webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* harmony export (immutable) */ __webpack_exports__["b"] = __decorate;
/* unused harmony export __param */
/* harmony export (immutable) */ __webpack_exports__["d"] = __metadata;
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports, __webpack_require__(3), __webpack_require__(8), __webpack_require__(26)) :
	typeof define === 'function' && define.amd ? define(['exports', 'vue', 'vue-class-component', 'reflect-metadata'], factory) :
	(factory((global.VuePropertyDecorator = {}),global.Vue,global.VueClassComponent));
}(this, (function (exports,vue,vueClassComponent) { 'use strict';

vue = vue && vue.hasOwnProperty('default') ? vue['default'] : vue;
var vueClassComponent__default = 'default' in vueClassComponent ? vueClassComponent['default'] : vueClassComponent;

/** vue-property-decorator verson 6.0.0 MIT LICENSE copyright 2017 kaorun343 */
'use strict';
/**
 * decorator of an inject
 * @param key key
 * @return PropertyDecorator
 */
function Inject(key) {
    return vueClassComponent.createDecorator(function (componentOptions, k) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[k] = key || k;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return vueClassComponent.createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) || null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/**
 * decorator of model
 * @param  event event name
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        if (!Array.isArray(options) && typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
        vueClassComponent.createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        if (!Array.isArray(options) && typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
        vueClassComponent.createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vueClassComponent.createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        componentOptions.watch[path] = { handler: handler, deep: deep, immediate: immediate };
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (original.apply(this, args) !== false)
                this.$emit.apply(this, [event || key].concat(args));
        };
    };
}

exports.Component = vueClassComponent__default;
exports.Vue = vue;
exports.Inject = Inject;
exports.Provide = Provide;
exports.Model = Model;
exports.Prop = Prop;
exports.Watch = Watch;
exports.Emit = Emit;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.16
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.16';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(22).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery v2.2.0 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="2.2.0",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isPlainObject:function(a){return"object"!==n.type(a)||a.nodeType||n.isWindow(a)?!1:a.constructor&&!k.call(a.constructor.prototype,"isPrototypeOf")?!1:!0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=d.createElement("script"),b.text=a,d.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:h.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(d=e.call(arguments,2),f=function(){return a.apply(b||this,d.concat(e.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=R.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return h.call(b,a)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&f.parentNode&&(this.length=1,this[0]=f),this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?void 0!==c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?h.call(n(a),this[0]):h.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||n.uniqueSort(e),D.test(a)&&e.reverse()),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.removeEventListener("DOMContentLoaded",J),a.removeEventListener("load",J),n.ready()}n.ready.promise=function(b){return I||(I=n.Deferred(),"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(n.ready):(d.addEventListener("DOMContentLoaded",J),a.addEventListener("load",J))),I.promise(b)},n.ready.promise();var K=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)K(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},L=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function M(){this.expando=n.expando+M.uid++}M.uid=1,M.prototype={register:function(a,b){var c=b||{};return a.nodeType?a[this.expando]=c:Object.defineProperty(a,this.expando,{value:c,writable:!0,configurable:!0}),a[this.expando]},cache:function(a){if(!L(a))return{};var b=a[this.expando];return b||(b={},L(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[b]=c;else for(d in b)e[d]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=a[this.expando];if(void 0!==f){if(void 0===b)this.register(a);else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in f?d=[b,e]:(d=e,d=d in f?[d]:d.match(G)||[])),c=d.length;while(c--)delete f[d[c]]}(void 0===b||n.isEmptyObject(f))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!n.isEmptyObject(b)}};var N=new M,O=new M,P=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Q=/[A-Z]/g;function R(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Q,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:P.test(c)?n.parseJSON(c):c}catch(e){}O.set(a,b,c);
}else c=void 0;return c}n.extend({hasData:function(a){return O.hasData(a)||N.hasData(a)},data:function(a,b,c){return O.access(a,b,c)},removeData:function(a,b){O.remove(a,b)},_data:function(a,b,c){return N.access(a,b,c)},_removeData:function(a,b){N.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=O.get(f),1===f.nodeType&&!N.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),R(f,d,e[d])));N.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){O.set(this,a)}):K(this,function(b){var c,d;if(f&&void 0===b){if(c=O.get(f,a)||O.get(f,a.replace(Q,"-$&").toLowerCase()),void 0!==c)return c;if(d=n.camelCase(a),c=O.get(f,d),void 0!==c)return c;if(c=R(f,d,void 0),void 0!==c)return c}else d=n.camelCase(a),this.each(function(){var c=O.get(this,d);O.set(this,d,b),a.indexOf("-")>-1&&void 0!==c&&O.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){O.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=N.get(a,b),c&&(!d||n.isArray(c)?d=N.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return N.get(a,c)||N.access(a,c,{empty:n.Callbacks("once memory").add(function(){N.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=N.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),U=["Top","Right","Bottom","Left"],V=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function W(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&T.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var X=/^(?:checkbox|radio)$/i,Y=/<([\w:-]+)/,Z=/^$|\/(?:java|ecma)script/i,$={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};$.optgroup=$.option,$.tbody=$.tfoot=$.colgroup=$.caption=$.thead,$.th=$.td;function _(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function aa(a,b){for(var c=0,d=a.length;d>c;c++)N.set(a[c],"globalEval",!b||N.get(b[c],"globalEval"))}var ba=/<|&#?\w+;/;function ca(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],o=0,p=a.length;p>o;o++)if(f=a[o],f||0===f)if("object"===n.type(f))n.merge(m,f.nodeType?[f]:f);else if(ba.test(f)){g=g||l.appendChild(b.createElement("div")),h=(Y.exec(f)||["",""])[1].toLowerCase(),i=$[h]||$._default,g.innerHTML=i[1]+n.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;n.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",o=0;while(f=m[o++])if(d&&n.inArray(f,d)>-1)e&&e.push(f);else if(j=n.contains(f.ownerDocument,f),g=_(l.appendChild(f),"script"),j&&aa(g),c){k=0;while(f=g[k++])Z.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),l.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var da=/^key/,ea=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,fa=/^([^.]*)(?:\.(.+)|)/;function ga(){return!0}function ha(){return!1}function ia(){try{return d.activeElement}catch(a){}}function ja(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ja(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ha;else if(!e)return this;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return"undefined"!=typeof n&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(G)||[""],j=b.length;while(j--)h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.hasData(a)&&N.get(a);if(r&&(i=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&N.remove(a,"handle events")}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(N.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())(!a.rnamespace||a.rnamespace.test(g.namespace))&&(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||d,e=c.documentElement,f=c.body,a.pageX=b.clientX+(e&&e.scrollLeft||f&&f.scrollLeft||0)-(e&&e.clientLeft||f&&f.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||f&&f.scrollTop||0)-(e&&e.clientTop||f&&f.clientTop||0)),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ea.test(f)?this.mouseHooks:da.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=d),3===a.target.nodeType&&(a.target=a.target.parentNode),h.filter?h.filter(a,g):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==ia()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===ia()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ga:ha):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:ha,isPropagationStopped:ha,isImmediatePropagationStopped:ha,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ga,a&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ga,a&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ga,a&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),n.fn.extend({on:function(a,b,c,d){return ja(this,a,b,c,d)},one:function(a,b,c,d){return ja(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=ha),this.each(function(){n.event.remove(this,a,c,b)})}});var ka=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,la=/<script|<style|<link/i,ma=/checked\s*(?:[^=]|=\s*.checked.)/i,na=/^true\/(.*)/,oa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function pa(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a:a}function qa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function ra(a){var b=na.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function sa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(N.hasData(a)&&(f=N.access(a),g=N.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}O.hasData(a)&&(h=O.access(a),i=n.extend({},h),O.set(b,i))}}function ta(a,b){var c=b.nodeName.toLowerCase();"input"===c&&X.test(a.type)?b.checked=a.checked:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}function ua(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&ma.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),ua(f,b,c,d)});if(o&&(e=ca(b,a[0].ownerDocument,!1,a,d),g=e.firstChild,1===e.childNodes.length&&(e=g),g||d)){for(h=n.map(_(e,"script"),qa),i=h.length;o>m;m++)j=e,m!==p&&(j=n.clone(j,!0,!0),i&&n.merge(h,_(j,"script"))),c.call(a[m],j,m);if(i)for(k=h[h.length-1].ownerDocument,n.map(h,ra),m=0;i>m;m++)j=h[m],Z.test(j.type||"")&&!N.access(j,"globalEval")&&n.contains(k,j)&&(j.src?n._evalUrl&&n._evalUrl(j.src):n.globalEval(j.textContent.replace(oa,"")))}return a}function va(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(_(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&aa(_(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(ka,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=_(h),f=_(a),d=0,e=f.length;e>d;d++)ta(f[d],g[d]);if(b)if(c)for(f=f||_(a),g=g||_(h),d=0,e=f.length;e>d;d++)sa(f[d],g[d]);else sa(a,h);return g=_(h,"script"),g.length>0&&aa(g,!i&&_(a,"script")),h},cleanData:function(a){for(var b,c,d,e=n.event.special,f=0;void 0!==(c=a[f]);f++)if(L(c)){if(b=c[N.expando]){if(b.events)for(d in b.events)e[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);c[N.expando]=void 0}c[O.expando]&&(c[O.expando]=void 0)}}}),n.fn.extend({domManip:ua,detach:function(a){return va(this,a,!0)},remove:function(a){return va(this,a)},text:function(a){return K(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&(this.textContent=a)})},null,a,arguments.length)},append:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.appendChild(a)}})},prepend:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(_(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return K(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!la.test(a)&&!$[(Y.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(_(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return ua(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(_(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),f=e.length-1,h=0;f>=h;h++)c=h===f?this:this.clone(!0),n(e[h])[b](c),g.apply(d,c.get());return this.pushStack(d)}});var wa,xa={HTML:"block",BODY:"block"};function ya(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function za(a){var b=d,c=xa[a];return c||(c=ya(a,b),"none"!==c&&c||(wa=(wa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=wa[0].contentDocument,b.write(),b.close(),c=ya(a,b),wa.detach()),xa[a]=c),c}var Aa=/^margin/,Ba=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ca=function(b){var c=b.ownerDocument.defaultView;return c.opener||(c=a),c.getComputedStyle(b)},Da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Ea=d.documentElement;!function(){var b,c,e,f,g=d.createElement("div"),h=d.createElement("div");if(h.style){h.style.backgroundClip="content-box",h.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===h.style.backgroundClip,g.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",g.appendChild(h);function i(){h.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",h.innerHTML="",Ea.appendChild(g);var d=a.getComputedStyle(h);b="1%"!==d.top,f="2px"===d.marginLeft,c="4px"===d.width,h.style.marginRight="50%",e="4px"===d.marginRight,Ea.removeChild(g)}n.extend(l,{pixelPosition:function(){return i(),b},boxSizingReliable:function(){return null==c&&i(),c},pixelMarginRight:function(){return null==c&&i(),e},reliableMarginLeft:function(){return null==c&&i(),f},reliableMarginRight:function(){var b,c=h.appendChild(d.createElement("div"));return c.style.cssText=h.style.cssText="-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",h.style.width="1px",Ea.appendChild(g),b=!parseFloat(a.getComputedStyle(c).marginRight),Ea.removeChild(g),h.removeChild(c),b}})}}();function Fa(a,b,c){var d,e,f,g,h=a.style;return c=c||Ca(a),c&&(g=c.getPropertyValue(b)||c[b],""!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),!l.pixelMarginRight()&&Ba.test(g)&&Aa.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function Ga(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Ha=/^(none|table(?!-c[ea]).+)/,Ia={position:"absolute",visibility:"hidden",display:"block"},Ja={letterSpacing:"0",fontWeight:"400"},Ka=["Webkit","O","Moz","ms"],La=d.createElement("div").style;function Ma(a){if(a in La)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ka.length;while(c--)if(a=Ka[c]+b,a in La)return a}function Na(a,b,c){var d=T.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Oa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+U[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+U[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+U[f]+"Width",!0,e))):(g+=n.css(a,"padding"+U[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+U[f]+"Width",!0,e)));return g}function Pa(b,c,e){var f=!0,g="width"===c?b.offsetWidth:b.offsetHeight,h=Ca(b),i="border-box"===n.css(b,"boxSizing",!1,h);if(d.msFullscreenElement&&a.top!==a&&b.getClientRects().length&&(g=Math.round(100*b.getBoundingClientRect()[c])),0>=g||null==g){if(g=Fa(b,c,h),(0>g||null==g)&&(g=b.style[c]),Ba.test(g))return g;f=i&&(l.boxSizingReliable()||g===b.style[c]),g=parseFloat(g)||0}return g+Oa(b,c,e||(i?"border":"content"),f,h)+"px"}function Qa(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=N.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&V(d)&&(f[g]=N.access(d,"olddisplay",za(d.nodeName)))):(e=V(d),"none"===c&&e||N.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Fa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=T.exec(c))&&e[1]&&(c=W(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Fa(a,b,d)),"normal"===e&&b in Ja&&(e=Ja[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Ha.test(n.css(a,"display"))&&0===a.offsetWidth?Da(a,Ia,function(){return Pa(a,b,d)}):Pa(a,b,d):void 0},set:function(a,c,d){var e,f=d&&Ca(a),g=d&&Oa(a,b,d,"border-box"===n.css(a,"boxSizing",!1,f),f);return g&&(e=T.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=n.css(a,b)),Na(a,c,g)}}}),n.cssHooks.marginLeft=Ga(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Fa(a,"marginLeft"))||a.getBoundingClientRect().left-Da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px":void 0}),n.cssHooks.marginRight=Ga(l.reliableMarginRight,function(a,b){return b?Da(a,{display:"inline-block"},Fa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+U[d]+b]=f[d]||f[d-2]||f[0];return e}},Aa.test(a)||(n.cssHooks[a+b].set=Na)}),n.fn.extend({css:function(a,b){return K(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ca(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Qa(this,!0)},hide:function(){return Qa(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){V(this)?n(this).show():n(this).hide()})}});function Ra(a,b,c,d,e){return new Ra.prototype.init(a,b,c,d,e)}n.Tween=Ra,Ra.prototype={constructor:Ra,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ra.propHooks[this.prop];return a&&a.get?a.get(this):Ra.propHooks._default.get(this)},run:function(a){var b,c=Ra.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ra.propHooks._default.set(this),this}},Ra.prototype.init.prototype=Ra.prototype,Ra.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},Ra.propHooks.scrollTop=Ra.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=Ra.prototype.init,n.fx.step={};var Sa,Ta,Ua=/^(?:toggle|show|hide)$/,Va=/queueHooks$/;function Wa(){return a.setTimeout(function(){Sa=void 0}),Sa=n.now()}function Xa(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=U[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ya(a,b,c){for(var d,e=(_a.tweeners[b]||[]).concat(_a.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Za(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&V(a),q=N.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?N.get(a,"olddisplay")||za(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Ua.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?za(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=N.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;N.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ya(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function $a(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function _a(a,b,c){var d,e,f=0,g=_a.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Sa||Wa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:Sa||Wa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for($a(k,j.opts.specialEasing);g>f;f++)if(d=_a.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,Ya,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(_a,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return W(c.elem,a,T.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],_a.tweeners[c]=_a.tweeners[c]||[],_a.tweeners[c].unshift(b)},prefilters:[Za],prefilter:function(a,b){b?_a.prefilters.unshift(a):_a.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(V).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=_a(this,n.extend({},a),f);(e||N.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=N.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Va.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=N.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Xa(b,!0),a,d,e)}}),n.each({slideDown:Xa("show"),slideUp:Xa("hide"),slideToggle:Xa("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Sa=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Sa=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ta||(Ta=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(Ta),Ta=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",l.checkOn=""!==a.value,l.optSelected=c.selected,b.disabled=!0,l.optDisabled=!c.disabled,a=d.createElement("input"),a.value="t",a.type="radio",l.radioValue="t"===a.value}();var ab,bb=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return K(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?ab:void 0)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)}}),ab={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=bb[b]||n.find.attr;bb[b]=function(a,b,d){var e,f;return d||(f=bb[b],bb[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,bb[b]=f),e}});var cb=/^(?:input|select|textarea|button)$/i,db=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return K(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b];
},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):cb.test(a.nodeName)||db.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var eb=/[\t\r\n\f]/g;function fb(a){return a.getAttribute&&a.getAttribute("class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,fb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,fb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,fb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(void 0===a||"boolean"===c)&&(b=fb(this),b&&N.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":N.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+fb(c)+" ").replace(eb," ").indexOf(b)>-1)return!0;return!1}});var gb=/\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(gb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){return n.trim(a.value)}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(n.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var hb=/^(?:focusinfocus|focusoutblur)$/;n.extend(n.event,{trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!hb.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),l=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},f||!o.trigger||o.trigger.apply(e,c)!==!1)){if(!f&&!o.noBubble&&!n.isWindow(e)){for(j=o.delegateType||q,hb.test(j+q)||(h=h.parentNode);h;h=h.parentNode)p.push(h),i=h;i===(e.ownerDocument||d)&&p.push(i.defaultView||i.parentWindow||a)}g=0;while((h=p[g++])&&!b.isPropagationStopped())b.type=g>1?j:o.bindType||q,m=(N.get(h,"events")||{})[b.type]&&N.get(h,"handle"),m&&m.apply(h,c),m=l&&h[l],m&&m.apply&&L(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=q,f||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!L(e)||l&&n.isFunction(e[q])&&!n.isWindow(e)&&(i=e[l],i&&(e[l]=null),n.event.triggered=q,e[q](),n.event.triggered=void 0,i&&(e[l]=i)),b.result}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b),d.isDefaultPrevented()&&c.preventDefault()}}),n.fn.extend({trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),l.focusin="onfocusin"in a,l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=N.access(d,b);e||d.addEventListener(a,c,!0),N.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=N.access(d,b)-1;e?N.access(d,b,e):(d.removeEventListener(a,c,!0),N.remove(d,b))}}});var ib=a.location,jb=n.now(),kb=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return(!c||c.getElementsByTagName("parsererror").length)&&n.error("Invalid XML: "+b),c};var lb=/#.*$/,mb=/([?&])_=[^&]*/,nb=/^(.*?):[ \t]*([^\r\n]*)$/gm,ob=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,pb=/^(?:GET|HEAD)$/,qb=/^\/\//,rb={},sb={},tb="*/".concat("*"),ub=d.createElement("a");ub.href=ib.href;function vb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function wb(a,b,c,d){var e={},f=a===sb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function xb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function yb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function zb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:ib.href,type:"GET",isLocal:ob.test(ib.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":tb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?xb(xb(a,n.ajaxSettings),b):xb(n.ajaxSettings,a)},ajaxPrefilter:vb(rb),ajaxTransport:vb(sb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m=n.ajaxSetup({},c),o=m.context||m,p=m.context&&(o.nodeType||o.jquery)?n(o):n.event,q=n.Deferred(),r=n.Callbacks("once memory"),s=m.statusCode||{},t={},u={},v=0,w="canceled",x={readyState:0,getResponseHeader:function(a){var b;if(2===v){if(!h){h={};while(b=nb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===v?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return v||(a=u[c]=u[c]||a,t[a]=b),this},overrideMimeType:function(a){return v||(m.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>v)for(b in a)s[b]=[s[b],a[b]];else x.always(a[x.status]);return this},abort:function(a){var b=a||w;return e&&e.abort(b),z(0,b),this}};if(q.promise(x).complete=r.add,x.success=x.done,x.error=x.fail,m.url=((b||m.url||ib.href)+"").replace(lb,"").replace(qb,ib.protocol+"//"),m.type=c.method||c.type||m.method||m.type,m.dataTypes=n.trim(m.dataType||"*").toLowerCase().match(G)||[""],null==m.crossDomain){j=d.createElement("a");try{j.href=m.url,j.href=j.href,m.crossDomain=ub.protocol+"//"+ub.host!=j.protocol+"//"+j.host}catch(y){m.crossDomain=!0}}if(m.data&&m.processData&&"string"!=typeof m.data&&(m.data=n.param(m.data,m.traditional)),wb(rb,m,c,x),2===v)return x;k=n.event&&m.global,k&&0===n.active++&&n.event.trigger("ajaxStart"),m.type=m.type.toUpperCase(),m.hasContent=!pb.test(m.type),f=m.url,m.hasContent||(m.data&&(f=m.url+=(kb.test(f)?"&":"?")+m.data,delete m.data),m.cache===!1&&(m.url=mb.test(f)?f.replace(mb,"$1_="+jb++):f+(kb.test(f)?"&":"?")+"_="+jb++)),m.ifModified&&(n.lastModified[f]&&x.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&x.setRequestHeader("If-None-Match",n.etag[f])),(m.data&&m.hasContent&&m.contentType!==!1||c.contentType)&&x.setRequestHeader("Content-Type",m.contentType),x.setRequestHeader("Accept",m.dataTypes[0]&&m.accepts[m.dataTypes[0]]?m.accepts[m.dataTypes[0]]+("*"!==m.dataTypes[0]?", "+tb+"; q=0.01":""):m.accepts["*"]);for(l in m.headers)x.setRequestHeader(l,m.headers[l]);if(m.beforeSend&&(m.beforeSend.call(o,x,m)===!1||2===v))return x.abort();w="abort";for(l in{success:1,error:1,complete:1})x[l](m[l]);if(e=wb(sb,m,c,x)){if(x.readyState=1,k&&p.trigger("ajaxSend",[x,m]),2===v)return x;m.async&&m.timeout>0&&(i=a.setTimeout(function(){x.abort("timeout")},m.timeout));try{v=1,e.send(t,z)}catch(y){if(!(2>v))throw y;z(-1,y)}}else z(-1,"No Transport");function z(b,c,d,h){var j,l,t,u,w,y=c;2!==v&&(v=2,i&&a.clearTimeout(i),e=void 0,g=h||"",x.readyState=b>0?4:0,j=b>=200&&300>b||304===b,d&&(u=yb(m,x,d)),u=zb(m,u,x,j),j?(m.ifModified&&(w=x.getResponseHeader("Last-Modified"),w&&(n.lastModified[f]=w),w=x.getResponseHeader("etag"),w&&(n.etag[f]=w)),204===b||"HEAD"===m.type?y="nocontent":304===b?y="notmodified":(y=u.state,l=u.data,t=u.error,j=!t)):(t=y,(b||!y)&&(y="error",0>b&&(b=0))),x.status=b,x.statusText=(c||y)+"",j?q.resolveWith(o,[l,y,x]):q.rejectWith(o,[x,y,t]),x.statusCode(s),s=void 0,k&&p.trigger(j?"ajaxSuccess":"ajaxError",[x,m,j?l:t]),r.fireWith(o,[x,y]),k&&(p.trigger("ajaxComplete",[x,m]),--n.active||n.event.trigger("ajaxStop")))}return x},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return!n.expr.filters.visible(a)},n.expr.filters.visible=function(a){return a.offsetWidth>0||a.offsetHeight>0||a.getClientRects().length>0};var Ab=/%20/g,Bb=/\[\]$/,Cb=/\r?\n/g,Db=/^(?:submit|button|image|reset|file)$/i,Eb=/^(?:input|select|textarea|keygen)/i;function Fb(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||Bb.test(a)?d(a,e):Fb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Fb(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Fb(c,a[c],b,e);return d.join("&").replace(Ab,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Eb.test(this.nodeName)&&!Db.test(a)&&(this.checked||!X.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(Cb,"\r\n")}}):{name:b.name,value:c.replace(Cb,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Gb={0:200,1223:204},Hb=n.ajaxSettings.xhr();l.cors=!!Hb&&"withCredentials"in Hb,l.ajax=Hb=!!Hb,n.ajaxTransport(function(b){var c,d;return l.cors||Hb&&!b.crossDomain?{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Gb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=n("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Ib=[],Jb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Ib.pop()||n.expando+"_"+jb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Jb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Jb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Jb,"$1"+e):b.jsonp!==!1&&(b.url+=(kb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Ib.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),l.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||(l.createHTMLDocument?d.implementation.createHTMLDocument(""):d);var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ca([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var Kb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Kb)return Kb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(g,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function Lb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(e=d.getBoundingClientRect(),c=Lb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0)-a.scrollTop(),d.left+=n.css(a[0],"borderLeftWidth",!0)-a.scrollLeft()),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ea})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;n.fn[a]=function(d){return K(this,function(a,d,e){var f=Lb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Ga(l.pixelPosition,function(a,c){return c?(c=Fa(a,b),Ba.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return K(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)},size:function(){return this.length}}),n.fn.andSelf=n.fn.addBack,"function"=="function"&&__webpack_require__(21)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return n}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));var Mb=a.jQuery,Nb=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Nb),b&&a.jQuery===n&&(a.jQuery=Mb),n},b||(a.jQuery=a.$=n),n});


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_header_head_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_navigation_nav_vue__ = __webpack_require__(30);




var App = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.navList = [
            {
                key: "installation",
                name: "Installation of Application",
                link: "Installation of Application"
            },
            {
                key: "navigation",
                name: "Define Navigation Tree",
                link: "Define Navigation Tree"
            },
            { key: "floorplan", name: "Build Floorplan", link: "Build Floorplan" },
            { key: "devices", name: "Add Devices", link: "Add Devices" },
            {
                key: "place",
                name: "Place Floormount Devices",
                link: "Place Floormount Devices"
            },
            { key: "discovery", name: "Auto Discovery", link: "Auto Discovery" },
            { key: "rack", name: "Rack Building", link: "Rack Building" },
            { key: "port", name: "Port Mapping", link: "Port Mapping" },
            { key: "device", name: "Device Settings", link: "Device Settings" },
            { key: "alarm", name: "Alarm Settings", link: "Alarm Settings" }
        ];
        return _this;
    }
    App = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: { Head: __WEBPACK_IMPORTED_MODULE_2_components_header_head_vue__["a" /* default */], Nav: __WEBPACK_IMPORTED_MODULE_3_components_navigation_nav_vue__["a" /* default */] }
        })
    ], App);
    return App;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (App);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
  * vue-class-component v6.2.0
  * (c) 2015-present Evan You
  * @license MIT
  */


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(__webpack_require__(3));

var hasProto = { __proto__: [] } instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return Vue.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== "object" && type !== "function");
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { return vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    if (false) {
        if (!(Component.prototype instanceof Vue) && Object.keys(plainData).length > 0) {
            warn('Component class must inherit Vue or its descendant class ' +
                'when class property is used.');
        }
    }
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured' // 2.5
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (typeof descriptor.value === 'function') {
            // methods
            (options.methods || (options.methods = {}))[key] = descriptor.value;
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof Vue
        ? superProto.constructor
        : Vue;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    return Extended;
}
var reservedPropertyNames = [
    // Unique id
    'cid',
    // Super Vue constructor
    'super',
    // Component options that will be used by the component
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    // Private assets
    'component',
    'directive',
    'filter'
];
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // `prototype` should not be overwritten
        if (key === 'prototype') {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value)
                && superDescriptor
                && superDescriptor.value === descriptor.value) {
                return;
            }
        }
        // Warn if the users manually declare reserved properties
        if (false) {
            warn("Static property name '" + key + "' declared on class '" + Original.name + "' " +
                'conflicts with reserved property name of Vue internal. ' +
                'It may cause unexpected behavior of the component. Consider renaming the property.');
        }
        Object.defineProperty(Extended, key, descriptor);
    });
}

function Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
(function (Component) {
    function registerHooks(keys) {
        $internalHooks.push.apply($internalHooks, keys);
    }
    Component.registerHooks = registerHooks;
})(Component || (Component = {}));
var Component$1 = Component;

exports.default = Component$1;
exports.createDecorator = createDecorator;
exports.mixins = mixins;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);


var Head = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Head, _super);
    function Head() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Head = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({})
    ], Head);
    return Head;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Head);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_item_vue__ = __webpack_require__(32);



var Nav = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Nav, _super);
    function Nav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.idx = 1;
        return _this;
    }
    Nav.prototype.beforeMount = function () {
        var hkey = this.$route.params.hkey;
    };
    Nav.prototype.onNavigation = function (idx) {
        this.idx = idx + 1;
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: null, type: Array }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], Nav.prototype, "items", void 0);
    Nav = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: { NavItem: __WEBPACK_IMPORTED_MODULE_2__nav_item_vue__["a" /* default */] }
        })
    ], Nav);
    return Nav;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Nav);


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);


var NavItem = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](NavItem, _super);
    function NavItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: null }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], NavItem.prototype, "item", void 0);
    NavItem = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({})
    ], NavItem);
    return NavItem;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (NavItem);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_class__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__collapse_collapse_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__video_video_vue__ = __webpack_require__(49);





var CommonStep = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CommonStep, _super);
    function CommonStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonStep.prototype.isArray = function (val) {
        return Array.isArray(val);
    };
    Object.defineProperty(CommonStep.prototype, "item", {
        get: function () {
            return this.nkey && this.steps ? this.steps[this.nkey] : {};
        },
        enumerable: true,
        configurable: true
    });
    CommonStep.prototype.setData = function (val) {
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: undefined, type: String }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], CommonStep.prototype, "nkey", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2_vuex_class__["a" /* Getter */],
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], CommonStep.prototype, "steps", void 0);
    CommonStep = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: { Collapse: __WEBPACK_IMPORTED_MODULE_3__collapse_collapse_vue__["a" /* default */], Video: __WEBPACK_IMPORTED_MODULE_4__video_video_vue__["a" /* default */] }
        })
    ], CommonStep);
    return CommonStep;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (CommonStep);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_image_preview_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_item_vue__ = __webpack_require__(45);




var Collapse = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Collapse, _super);
    function Collapse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itActive = -1;
        _this.itActiveList = [];
        return _this;
    }
    Collapse.prototype.onChildChanged = function (current, pre) {
        this.itActiveList = [];
    };
    Collapse.prototype.parseMessage = function (val) {
        return typeof val === "string"
            ? "<p>" + val + "</p>"
            : []
                .concat(val)
                .reduce(function (pre, current) { return pre + "<li>" + current + "</li>"; }, '<ol type="a" class="qs-text-info">') + "</ol>";
    };
    Collapse.prototype.isString = function (val) {
        return typeof val === "string";
    };
    Object.defineProperty(Collapse.prototype, "isActive", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Collapse.prototype.isArray = function (val) {
        return Array.isArray(val);
    };
    Collapse.prototype.isObject = function (val) {
        var type = typeof val;
        return val != null && (type === "object" || type === "function");
    };
    Collapse.prototype.toggle = function (idx) {
        var tmp = this.itActiveList.slice();
        this.itActive = idx === this.itActive ? -1 : idx;
        var ix = tmp.indexOf(idx);
        if (~ix) {
            tmp.splice(ix, 1);
        }
        else {
            tmp.push(idx);
        }
        this.itActiveList = tmp;
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: null, type: Array }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], Collapse.prototype, "items", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: null, type: String }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], Collapse.prototype, "hkey", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])("hkey"),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:paramtypes", [Object, Object]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:returntype", void 0)
    ], Collapse.prototype, "onChildChanged", null);
    Collapse = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            components: { ImagePreview: __WEBPACK_IMPORTED_MODULE_2__image_image_preview_vue__["a" /* default */], ComponentItem: __WEBPACK_IMPORTED_MODULE_3__component_item_vue__["a" /* default */] }
        })
    ], Collapse);
    return Collapse;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Collapse);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_preview_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d76ee2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_preview_vue__ = __webpack_require__(44);
function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d76ee2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);


var ImagePreview = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ImagePreview, _super);
    function ImagePreview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImagePreview.prototype.mounted = function () {
        $('.lightbox-portfolio').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            image: {
                verticalFit: true
            }
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: null, type: String }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], ImagePreview.prototype, "item", void 0);
    ImagePreview = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({})
    ], ImagePreview);
    return ImagePreview;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (ImagePreview);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_image_preview_vue__ = __webpack_require__(15);



var ComponentItem = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ComponentItem, _super);
    function ComponentItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.itActive = -1;
        _this.itActiveList = [];
        return _this;
    }
    ComponentItem.prototype.isString = function (val) {
        return typeof val === 'string';
    };
    Object.defineProperty(ComponentItem.prototype, "isActive", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    ComponentItem.prototype.isArray = function (val) {
        return Array.isArray(val);
    };
    ComponentItem.prototype.isObject = function (val) {
        var type = typeof val;
        return val != null && (type === 'object' || type === 'function');
    };
    ComponentItem.prototype.getStyleByType = function (item, isLi) {
        if (isLi === void 0) { isLi = false; }
        if (item == null || this.isString(item)) {
            return;
        }
        var style = {};
        var color = item.color, backgroundColor = item.backgroundColor, height = item.height;
        if (isLi === false) {
            if (color) {
                style = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, style, { color: color });
            }
            if (backgroundColor) {
                style = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, style, { 'background-color': backgroundColor });
            }
        }
        else {
            if (height) {
                style = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, style, { height: height });
            }
        }
        return style;
    };
    ComponentItem.prototype.getClassByType = function (item) {
        if (item == null || this.isString(item)) {
            return { 'lower-latin': true };
        }
        var type = item.type, color = item.color, backgroundColor = item.backgroundColor;
        var dClass = { none: true };
        switch (type) {
            case 'option':
                dClass = { option: true };
                break;
            case 'abc':
                dClass = { 'lower-latin': true };
                break;
            case '123)':
                dClass = { 'decimal-parenthesis': true };
                break;
            case 'dot':
                dClass = { dot: true };
                break;
            case 'p':
                dClass = { p: true };
                break;
            case 'span':
                dClass = { span: true };
                break;
            case 'image':
                dClass = { image: true };
                break;
            case 'br':
                dClass = {};
                break;
            default:
                break;
        }
        return dClass;
    };
    ComponentItem.prototype.toggle = function (idx) {
        this.itActive = idx === this.itActive ? -1 : idx;
        var ix = this.itActiveList.indexOf(idx);
        if (~ix) {
            this.itActiveList.splice(idx, 1);
        }
        else {
            this.itActiveList.push(idx);
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: null, type: [Array, String, Object] }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], ComponentItem.prototype, "item", void 0);
    ComponentItem = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({
            name: 'ComponentItem',
            components: { ImagePreview: __WEBPACK_IMPORTED_MODULE_2__image_image_preview_vue__["a" /* default */] }
        })
    ], ComponentItem);
    return ComponentItem;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (ComponentItem);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chimee_player__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chimee_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chimee_player__);



var Video = (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Video, _super);
    function Video() {
        var _this = _super.call(this) || this;
        _this.player = null;
        _this.classObject = { 'chimee-container': true };
        _this.ckey = 'chimee-container';
        if (_this.idx != null) {
            _this.ckey = "chimee-container-" + _this.idx;
            _this.classObject = (_a = {}, _a[_this.ckey] = true, _a);
            _this.upDateitem(_this.item);
        }
        return _this;
        var _a;
    }
    Video.prototype.upDateitem = function (val) {
        var _this = this;
        setTimeout(function () { return _this.initVideo(val); });
    };
    Video.prototype.upDateClass = function (val) {
        if (val == null) {
            return;
        }
        this.ckey = "chimee-container-" + val;
        this.classObject = (_a = {}, _a[this.ckey] = true, _a);
        var _a;
    };
    Video.prototype.initVideo = function (path) {
        if (path != null && path.length > 0) {
            if (this.player == null) {
                this.player = new __WEBPACK_IMPORTED_MODULE_2_chimee_player___default.a({
                    wrapper: "." + this.ckey,
                    src: path,
                    isLive: false,
                    box: 'native',
                    autoplay: false,
                    controls: true
                });
            }
            else {
                this.player.load(path);
            }
        }
    };
    Video.prototype.mounted = function () { };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: null, type: String }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], Video.prototype, "item", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: null, type: Number }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Object)
    ], Video.prototype, "idx", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])('item'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:paramtypes", [String]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:returntype", void 0)
    ], Video.prototype, "upDateitem", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])('idx'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:paramtypes", [Number]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:returntype", void 0)
    ], Video.prototype, "upDateClass", null);
    Video = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({}),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __metadata */]("design:paramtypes", [])
    ], Video);
    return Video;
}(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (Video);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'Voltar ao topo'
    },
    visibleOffset: {
      type: [String, Number],
      default: 600
    },
    right: {
      type: String,
      default: '30px'
    },
    bottom: {
      type: String,
      default: '40px'
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  /**
   * Catch window scroll event 
   * @return {void}
   */
  created: function created() {
    var _this = this;

    var catchScroll = function catchScroll() {
      _this.visible = window.pageYOffset > parseInt(_this.visibleOffset);
    };

    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };

    window.onscroll = catchScroll;
  },

  methods: {
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_backtotop__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_magnific_popup__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_magnific_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_magnific_popup__);






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
window['$'] = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window['jQuery'] = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_backtotop__["a" /* default */]);
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__app_vue__["a" /* default */] }
});


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(23);
// On some exotic environments, it's not clear which object `setimmeidate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(6)))

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e18949a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(35);
function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e18949a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof global === "object" ? global :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && Object({"NODE_ENV":"production"}) && Object({"NODE_ENV":"production"})["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));
//# sourceMappingURL=Reflect.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(4)))

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_head_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007965cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_head_vue__ = __webpack_require__(29);
function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_head_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007965cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_head_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-wrap",attrs:{"id":"header","data-plugin-options":"{\"stickyEnabled\": true, \"stickyEnableOnBoxed\": true, \"stickyEnableOnMobile\": true, \"stickyStartAt\": 0, \"stickySetTop\": \"0px\", \"stickyChangeLogo\": true}"}},[_c('div',{staticClass:"header-body"},[_c('div',{staticClass:"header-container container"},[_c('div',{staticClass:"header-row"},[_c('div',{staticClass:"header-column"},[_c('div',{staticClass:"header-logo"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"alt":"optimum path","height":"60","src":"static/img/opi.png"}})])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6abe1dfb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_vue__ = __webpack_require__(34);
function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6abe1dfb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_item_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c7f4a88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_item_vue__ = __webpack_require__(33);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c7f4a88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{name: _vm.item.link ,params:{ hkey:_vm.item.key}, props:true }}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.item.name))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-header"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ol',{staticClass:"list list-ordened"},[_vm._l((_vm.items),function(item,index){return [_c('router-link',{staticClass:"section-navigation-tab",attrs:{"tag":"li","to":{name: item.link ,params:{ hkey:item.key}, props:true }},on:{"click":function($event){_vm.onNavigation(index)}}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])]})],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('ul',{staticClass:"breadcrumb"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body",attrs:{"id":"app"}},[_c('Head'),_vm._v(" "),_c('main',{staticClass:"main",attrs:{"role":"main"}},[_c('Nav',{attrs:{"items":_vm.navList}}),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('back-to-top',{attrs:{"bottom":"0","right":"10px","visibleOffset":"500"}},[_c('button',{staticClass:"btn btn-info btn-to-top",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-chevron-up"})])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-copyright"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_vm._v("© Copyright 2018. All Rights Reserved.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('nav',{attrs:{"id":"sub-menu"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"http://www.eaton.com/us/en-us/company/policies-and-statements/privacy-cookies-and-data-protection.html","target":"_blank"}},[_vm._v("Privacy, cookies and data protection")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://www.eaton.com/us/en-us/company/policies-and-statements/terms-and-conditions.html","target":"_blank"}},[_vm._v("Terms and conditions")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__ = __webpack_require__(38);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    linkActiveClass: 'active',
    routes: [{
            path: '/',
            redirect: '/VPMsteps-1'
        }, {
            path: '/VPMsteps-1',
            name: 'Installation of Application',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'installation' }
        }, {
            path: '/VPMsteps-2',
            name: 'Define Navigation Tree',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'navigation' }
        }, {
            path: '/VPMsteps-3',
            name: 'Build Floorplan',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'floorplan' }
        }, {
            path: '/VPMsteps-4',
            name: 'Add Devices',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'devices' }
        }, {
            path: '/VPMsteps-5',
            name: 'Place Floormount Devices',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'place' }
        }, {
            path: '/VPMsteps-6',
            name: 'Auto Discovery',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'discovery' }
        }, {
            path: '/VPMsteps-7',
            name: 'Rack Building',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'rack' }
        }, {
            path: '/VPMsteps-8',
            name: 'Port Mapping',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'port' }
        }, {
            path: '/VPMsteps-9',
            name: 'Device Settings',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'device' }
        }, {
            path: '/VPMsteps-10',
            name: 'Alarm Settings',
            component: __WEBPACK_IMPORTED_MODULE_2_components_vpm_steps_common_step_vue__["a" /* default */],
            props: { nkey: 'alarm' }
        }]
}));


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_step_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b838d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_common_step_vue__ = __webpack_require__(53);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_step_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b838d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_common_step_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bindings__ = __webpack_require__(40);
/* unused harmony reexport State */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__bindings__["a"]; });
/* unused harmony reexport Action */
/* unused harmony reexport Mutation */
/* unused harmony reexport namespace */



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export State */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Getter; });
/* unused harmony export Action */
/* unused harmony export Mutation */
/* unused harmony export namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);


var State = createBindingHelper('computed', __WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */]);
var Getter = createBindingHelper('computed', __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */]);
var Action = createBindingHelper('methods', __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */]);
var Mutation = createBindingHelper('methods', __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */]);
function namespace(namespace, helper) {
    function namespacedHelper(a, b) {
        if (typeof b === 'string') {
            var key = b;
            var proto = a;
            return helper(key, { namespace: namespace })(proto, key);
        }
        var type = a;
        var options = merge(b || {}, { namespace: namespace });
        return helper(type, options);
    }
    return namespacedHelper;
}
function createBindingHelper(bindTo, mapFn) {
    function makeDecorator(map, namespace) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__["createDecorator"])(function (componentOptions, key) {
            if (!componentOptions[bindTo]) {
                componentOptions[bindTo] = {};
            }
            var mapObject = (_a = {}, _a[key] = map, _a);
            componentOptions[bindTo][key] = namespace !== undefined
                ? mapFn(namespace, mapObject)[key]
                : mapFn(mapObject)[key];
            var _a;
        });
    }
    function helper(a, b) {
        if (typeof b === 'string') {
            var key = b;
            var proto = a;
            return makeDecorator(key, undefined)(proto, key);
        }
        var namespace = extractNamespace(b);
        var type = a;
        return makeDecorator(type, namespace);
    }
    return helper;
}
function extractNamespace(options) {
    var n = options && options.namespace;
    if (typeof n !== 'string') {
        return undefined;
    }
    if (n[n.length - 1] !== '/') {
        return n + '/';
    }
    return n;
}
function merge(a, b) {
    var res = {};
    [a, b].forEach(function (obj) {
        Object.keys(obj).forEach(function (key) {
            res[key] = obj[key];
        });
    });
    return res;
}


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e405e99_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapse_vue__ = __webpack_require__(48);
function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e405e99_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 portfolio-item portfolio-list lightbox m-none",attrs:{"data-plugin-options":"{\"delegate\": \"a.lightbox-portfolio\", \"type\": \"image\", \"gallery\": {\"enabled\": true}}"}},[_c('span',{staticClass:"thumb-info thumb-info-lighten thumb-info-centered-icons"},[_c('span',{staticClass:"thumb-info-wrapper"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.item,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"thumb-info-action"},[_c('a',{staticClass:"lightbox-portfolio",attrs:{"href":_vm.item}},[_vm._m(0)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"thumb-info-action-icon thumb-info-action-icon-light"},[_c('i',{staticClass:"fa fa-search-plus"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_item_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d65721_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_item_vue__ = __webpack_require__(47);
function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64d65721_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item != null)?_c('span',[(_vm.isString(_vm.item))?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.item)}})]:(_vm.isArray(_vm.item))?[_c('ol',[_vm._l((_vm.item),function(itemCon){return [(itemCon != null)?_c('li',{class:_vm.getClassByType(itemCon),style:(_vm.getStyleByType(itemCon,true))},[_c('ComponentItem',{attrs:{"item":itemCon}})],1):_vm._e()]})],2)]:(_vm.isObject(_vm.item))?[(_vm.item.type)?[(_vm.item.type === 'abc' || _vm.item.type === 'dot' || _vm.item.type === '123)'  || _vm.item.type === 'option')?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.item.value)}})]:(_vm.item.type === 'br')?[_c('br')]:(_vm.item.type === 'p')?[_c('p',{style:(_vm.getStyleByType(_vm.item)),domProps:{"innerHTML":_vm._s(_vm.item.value)}})]:(_vm.item.type === 'option')?[_c('option',{domProps:{"innerHTML":_vm._s(_vm.item.value)}})]:(_vm.item.type === 'span')?[_c('span',{style:(_vm.getStyleByType(_vm.item)),domProps:{"innerHTML":_vm._s(_vm.item.value)}})]:(_vm.item.type === 'image')?[(_vm.item.value)?_c('ImagePreview',{attrs:{"item":_vm.item.value}}):_vm._e()]:_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),[_c('ComponentItem',{attrs:{"item":_vm.item.children}})]],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle toggle-primary",attrs:{"data-plugin-toggle":""}},[_vm._l((_vm.items),function(item,index){return [_c('section',{staticClass:"toggle",class:{ active: _vm.itActiveList.indexOf(index) > -1  }},[_c('label',{on:{"click":function($event){_vm.toggle(index)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('article',{staticClass:"toggle-content",style:({display: _vm.itActiveList.indexOf(index) > -1  ? 'block' :'none',color: '#000' })},[_c('ComponentItem',{attrs:{"item":item.content}}),_vm._v(" "),(item.image)?_c('ImagePreview',{attrs:{"item":item.image}}):_vm._e()],1)])],1)]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe9a75a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__ = __webpack_require__(52);
function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_video_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe9a75a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.ChimeePlayer=t()}(this,function(){"use strict";function __$styleInject(e,t){if("undefined"==typeof document)return t;e=e||"";var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");return n.type="text/css",r.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t}function unwrapExports(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e["default"]:e}function createCommonjsModule(e,t){return t={exports:{}},e(t,t.exports),t.exports}function PromiseCapability(e){var t,r;this.promise=new e(function(e,n){if(t!==undefined||r!==undefined)throw TypeError("Bad Promise constructor");t=e,r=n}),this.resolve=_aFunction(t),this.reject=_aFunction(r)}function defined$1(e){return void 0!==e}function isVoid(e){return e===undefined||null===e}function isArray$1(e){return Array.isArray(e)}function isFunction(e){return"function"==typeof e}function isObject$1(e){return Object(e)===e&&"[object Object]"===String(e)&&!isFunction(e)&&!isArray$1(e)}function isNumber(e){return"number"==typeof e}function isNumeric(e){return!isArray$1(e)&&e-_Number$parseFloat(e)+1>=0}function isInteger(e){return _Number$isInteger(e)}function isEmpty(e){return isArray$1(e)?0===e.length:isObject$1(e)?0===_Object$keys(e).length:!e}function isEvent(e){return e instanceof Event||(e&&e.originalEvent)instanceof Event}function isString(e){return"string"==typeof e||e instanceof String}function isBoolean(e){return"boolean"==typeof e}function isPromise(e){return!!e&&("object"===(void 0===e?"undefined":_typeof(e))||"function"==typeof e)&&"function"==typeof e.then}function isPrimitive(e){return isVoid(e)||isBoolean(e)||isString(e)||isNumber(e)}function isUrl(e){return isString(e)&&!!e.match(/^((https?|ftp|rtsp|mms):\/\/)(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}\.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+\.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.[a-z]{2,6}|localhost)(:[0-9]{1,4})?((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+\/?)$/i)}function isNode$2(e){return!!("object"===("undefined"==typeof Node?"undefined":_typeof(Node))?e instanceof Node:e&&"object"===(void 0===e?"undefined":_typeof(e))&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName)}function isElement(e){return!!("object"===("undefined"==typeof HTMLElement?"undefined":_typeof(HTMLElement))?e instanceof HTMLElement:e&&"object"===(void 0===e?"undefined":_typeof(e))&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName)}function isPosterityNode(e,t){if(!isNode$2(e)||!isNode$2(t))return!1;for(;t.parentNode;)if((t=t.parentNode)===e)return!0;return!1}function isHTMLString(e){return/<[^>]+?>/.test(e)}function isError(e){return e instanceof Error}function formatter(e,t){if(!isString(e))throw new TypeError("Log's method only acccept string as argument, but not "+e+" in "+(void 0===e?"undefined":_typeof(e)));return isString(t)?"["+(e=Log$1.FORCE_GLOBAL_TAG?Log$1.GLOBAL_TAG:e||Log$1.GLOBAL_TAG)+"] > "+t:"["+Log$1.GLOBAL_TAG+"] > "+e}function genTraversalHandler(e){function t(r,n,i){if(isArray$1(r)||isObject$1(r)){n=isPrimitive(n)?isObject$1(r)?{}:[]:n;for(var o in r)n[o]=t(r[o],n[o],o);return n}return e(r,n,i)}return t}function deepClone(e){if(isPrimitive(e))throw new TypeError("deepClone only accept non primitive type");return _deepAssign(e)}function deepAssign(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];if(t.length<2)throw new Error("deepAssign accept two and more argument");for(var n=t.length-1;n>-1;n--)if(isPrimitive(t[n]))throw new TypeError("deepAssign only accept non primitive type");var i=t.shift();return t.forEach(function(e){return _deepAssign(e,i)}),i}function camelize(e,t){return e.replace(/(^|[^a-zA-Z]+)([a-zA-Z])/g,function(e,r,n,i){return t||0!==i?n.toUpperCase():n.toLowerCase()})}function hypenate(e){return camelize(e).replace(/([A-Z])/g,function(e){return"-"+e.toLowerCase()})}function bind(e,t){return e.bind?e.bind(t):e.apply?function(){for(var r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];return e.apply(t,n)}:function(){for(var r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];return e.call.apply(e,[t].concat(_toConsumableArray(n)))}}function uuid(){return S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4()}function S4(){return(65536*(1+Math.random())|0).toString(16).substring(1)}function getDeepProperty(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{},n=r.throwError,i=n!==undefined&&n,o=r.backup;if(isString(t)&&(t=t.split(".")),!isArray$1(t))throw new TypeError("keys of getDeepProperty must be string or Array<string>");for(var a=[],s=e,u=0,c=t.length;u<c;u++){var l=t[u];if(isVoid(s)){if(i)throw new Error("obj"+(a.length>0?"."+a.join("."):" itself")+" is "+s);return o}s=s[l],a.push(l)}return s}function transObjectAttrIntoArray(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(e,t){return+e-+t};return _Object$keys(e).sort(t).reduce(function(t,r){return t.concat(e[r])},[])}function runRejectableQueue(e){for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];return new _Promise(function(t,n){!function i(o){if(o>=e.length)return void t();var a=isFunction(e[o])?e[o].apply(e,_toConsumableArray(r)):e[o];return!1===a?n("stop"):_Promise.resolve(a).then(function(){return i(o+1)})["catch"](function(e){return n(e||"stop")})}(0)})}function runStoppableQueue(e){for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];return function i(t){return t>=e.length||!1!==(isFunction(e[t])?e[t].apply(e,_toConsumableArray(r)):e[t])&&i(++t)}(0)}function strRepeat(e,t){var r=t;e=""+(e||"");var n=e.length;return t=(t||n)-n,((t>0?e.repeat?"0".repeat(t):new Array(t+1).join("0"):"")+e).slice(0,r)}function formatTime(e){var t=Math.floor(e/3600);e=Math.floor(e%3600);var r=strRepeat(Math.floor(e/60),2);e=Math.floor(e%60);var n=strRepeat(e,2);return t>=1?t+":"+r+":"+n:r+":"+n}function formatDate(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:new Date,t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"yyyy-MM-dd hh:mm:ss.i",r=e.getFullYear().toString(),n={M:e.getMonth()+1,d:e.getDate(),h:e.getHours(),m:e.getMinutes(),s:e.getSeconds(),i:e.getMilliseconds()};t=t.replace(/(y+)/gi,function(e,t){return r.substr(4-Math.min(4,t.length))});for(var i in n)!function(e){t=t.replace(new RegExp("("+e+"+)","g"),function(t,r){return(n[e]<10&&r.length>1?"0":"")+n[e]})}(i);return t}function getLocalStorage(e){try{return window.localStorage.getItem(e)}catch(r){try{var t=document.cookie.match(new RegExp("(^| )"+e+"=([^;]*)(;|$)"));return isArray$1(t)?unescape(t[2]):""}catch(r){return""}}}function setLocalStorage(e,t){try{window.localStorage.setItem(e,t)}catch(n){var r=new Date;r.setTime(r.getTime()+2592e7);try{document.cookie=e+"="+escape(t)+";expires="+r.toUTCString()+";path=/;"}catch(n){}}}function getEvtTypeCache(e,t){var r=e.__evt_id;r||(Object.defineProperty(e,"__evt_id",{writable:!0,enumerable:!1,configurable:!0}),r=e.__evt_id=++_evtListenerCache.count);var n=r+"_"+t,i=_evtListenerCache[n];return i||(i=_evtListenerCache[n]=[]),i}function emitEventCache(e,t,r){var n=_Object$create(null);n.type=t,n.target=e,r&&_Object$assign(n,isObject$1(r)?r:{data:r}),getEvtTypeCache(e,t).forEach(function(t){(t[1]||t[0]).apply(e,[n])})}function addEventCache(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=arguments[4];isFunction(n)&&!i&&(i=n,n=undefined);var o=[r,undefined,n];n&&!i&&(i=function(){removeEventCache(e,t,r,n);for(var i=arguments.length,o=Array(i),a=0;a<i;a++)o[a]=arguments[a];r.apply(e,o)}),i&&(o[1]=i),getEvtTypeCache(e,t).push(o)}function removeEventCache(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=getEvtTypeCache(e,t);if(r||n){var o=-1,a=void 0;return i.find(function(e,t){if((!r||e[0]===r)&&(!n||e[2]))return o=t,a=e[1],!0}),-1!==o&&i.splice(o,1),a}i.length=0}function getEvtTypeCache$1(e,t){var r=e.__evt_id;r||(Object.defineProperty(e,"__evt_id",{writable:!0,enumerable:!1,configurable:!0}),r=e.__evt_id=++_evtListenerCache$1.count);var n=r+"_"+t,i=_evtListenerCache$1[n];return i||(i=_evtListenerCache$1[n]=[]),i}function emitEventCache$1(e,t,r){var n=_Object$create(null);n.type=t,n.target=e,r&&_Object$assign(n,isObject$1(r)?r:{data:r}),getEvtTypeCache$1(e,t).forEach(function(t){(t[1]||t[0]).apply(e,[n])})}function addEventCache$1(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=arguments[4];isFunction(n)&&!i&&(i=n,n=undefined);var o=[r,undefined,n];n&&!i&&(i=function(){removeEventCache$1(e,t,r,n);for(var i=arguments.length,o=Array(i),a=0;a<i;a++)o[a]=arguments[a];r.apply(e,o)}),i&&(o[1]=i),getEvtTypeCache$1(e,t).push(o)}function removeEventCache$1(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=getEvtTypeCache$1(e,t);if(r||n){var o=-1,a=void 0;return i.find(function(e,t){if((!r||e[0]===r)&&(!n||e[2]))return o=t,a=e[1],!0}),-1!==o&&i.splice(o,1),a}i.length=0}function makeArray$1(e){return _Array$from(e)}function getAttr(e,t){return e.getAttribute(t)}function setAttr(e,t,r){r===undefined?e.removeAttribute(t):e.setAttribute(t,r)}function addClassName(e,t){if(t&&(t=t.trim())){var r=t.split(/\s+/);if(e.classList)r.forEach(function(t){return e.classList.add(t)});else{var n=" "+(e.className||"")+" ";r.forEach(function(e){-1===n.indexOf(" "+e+" ")&&(n+=" "+e)}),e.className=n.trim()}}}function removeClassName(e,t){if(t&&(t=t.trim())){var r=t.split(/\s+/);if(e.classList)r.forEach(function(t){return e.classList.remove(t)});else{var n=" "+e.className+" ";r.forEach(function(e){for(var t=" "+e+" ";-1!==n.indexOf(t);)n=n.replace(t," ")}),e.className=n.trim()}}}function hasClassName(e,t){return new RegExp("(?:^|\\s)"+t+"(?=\\s|$)").test(e.className)}function removeEvent(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=arguments.length>4&&arguments[4]!==undefined&&arguments[4];if(i!==undefined&&!isBoolean(i)&&supportsPassive&&(i={passive:!0}),n){var o=removeEventCache$1(e,t+"_once",r);o&&(r=o)}e.removeEventListener(t,r,i)}function addEvent(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=arguments.length>4&&arguments[4]!==undefined&&arguments[4];if(i!==undefined&&!isBoolean(i)&&supportsPassive&&(i={passive:!0}),n){var o=r;r=function(){return function(){for(var a=arguments.length,s=Array(a),u=0;u<a;u++)s[u]=arguments[u];o.apply(this,s),removeEvent(e,t,r,n,i)}}(),addEventCache$1(e,t+"_once",o,r)}e.addEventListener(t,r,i)}function addDelegate(e,t,r,n){var i=arguments.length>4&&arguments[4]!==undefined&&arguments[4];i!==undefined&&!isBoolean(i)&&supportsPassive&&(i={passive:!0});var o=function(r){var i=findParents(r.target||r.srcElement,e,!0),o=query(t,e,!0),a=void 0;o.find?a=o.find(function(e){return i.find(function(t){return e===t})}):o.forEach(function(e){return!a&&i.forEach(function(t){a||e!==t||(a=t)})}),a&&n.apply(a,arguments)};addEventCache$1(e,r+"_delegate_"+t,n,o),e.addEventListener(r,o,i)}function removeDelegate(e,t,r,n){var i=arguments.length>4&&arguments[4]!==undefined&&arguments[4];i!==undefined&&!isBoolean(i)&&supportsPassive&&(i={passive:!0});var o=removeEventCache$1(e,r+"_delegate_"+t,n);o&&e.removeEventListener(r,o,i)}function getStyle(e,t){return(e.currentStyle||document.defaultView.getComputedStyle(e,null))[t]||e.style[t]}function setStyle(e,t,r){if(isObject$1(t))for(var n in t)setStyle(e,n,t[n]);else e.style[t]=r}function query(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:document,r=arguments[2],n=t.querySelectorAll(e);return r?_Array$from(n):n}function removeEl(e){e.parentNode.removeChild(e)}function findParents(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null,r=arguments[2],n=arguments[3],i=[];for(r&&i.push(e);e&&e.parentNode!==t;)(e=e.parentNode)&&i.push(e);return n&&i.push(t),i}function $(e,t){return e.constructor===NodeWrap?e:new NodeWrap(e,t)}function isDescriptor(e){if(!e||!e.hasOwnProperty)return!1;for(var t=["value","initializer","get","set"],r=0,n=t.length;r<n;r++)if(e.hasOwnProperty(t[r]))return!0;return!1}function isAccessorDescriptor(e){return!!e&&(isFunction(e.get)||isFunction(e.set))&&isBoolean(e.configurable)&&isBoolean(e.enumerable)&&e.writable===undefined}function isDataDescriptor(e){return!!e&&e.hasOwnProperty("value")&&isBoolean(e.configurable)&&isBoolean(e.enumerable)&&isBoolean(e.writable)}function isInitializerDescriptor(e){return!!e&&isFunction(e.initializer)&&isBoolean(e.configurable)&&isBoolean(e.enumerable)&&isBoolean(e.writable)}function createDefaultSetter(e){return function(t){return _Object$defineProperty(this,e,{configurable:!0,writable:!0,enumerable:!0,value:t}),t}}function compressOneArgFnArray(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"You must pass me an array of function";if(!isArray$1(e)||e.length<1)throw new TypeError(t);if(1===e.length){if(!isFunction(e[0]))throw new TypeError(t);return e[0]}return e.reduce(function(e,r){if(!isFunction(r)||!isFunction(e))throw new TypeError(t);return function(t){return bind(r,this)(bind(e,this)(t))}})}function getOwnKeysFn(){var e=_Object$getOwnPropertyNames,t=_Object$getOwnPropertySymbols;return isFunction(t)?function(r){return _Array$from(e(r).concat(t(r)))}:e}function getOwnPropertyDescriptorsFn(){return isFunction(_Object$getOwnPropertyDescriptors)?_Object$getOwnPropertyDescriptors:function(e){return getOwnKeys(e).reduce(function(t,r){return t[r]=getOwnPropertyDescriptor$3(e,r),t},{})}}function compressMultipleDecorators(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];if(!t.length)throw new TypeError("You must pass in decorators in compressMultipleDecorators");return t.forEach(function(e){if(!isFunction(e))throw new TypeError('Decorators must be a function, but not "'+e+'" in '+(void 0===e?"undefined":_typeof(e)))}),1===t.length?t[0]:function(e,r,n){return t.reduce(function(t,n){return n(e,r,t)},n)}}function accessor(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},t=e.get,r=e.set,n=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},i=n.preGet,o=i!==undefined&&i,a=n.preSet,s=a===undefined||a;if(!(isFunction(t)||isFunction(r)||isArray$1(t)&&t.length>0||isArray$1(r)&&r.length>0))throw new TypeError("@accessor need a getter or setter. If you don't need to add setter/getter. You should remove @accessor");var u="@accessor only accept function or array of function as getter/setter";return t=isArray$1(t)?compressOneArgFnArray(t,u):t,r=isArray$1(r)?compressOneArgFnArray(r,u):r,function(e,n,i){var a=i||{},u=a.configurable,c=u===undefined||u,l=a.enumerable,f=l===undefined||l,d=isFunction(t),h=isFunction(r),p=function(e){return d?bind(t,this)(e):e},y=function(e){return h?bind(r,this)(e):e};if(isAccessorDescriptor(i)){var g=i.get,m=i.set,_=isFunction(g),v=isFunction(m);return{get:_||d?function(){var e=this,t=bind(p,this),r=function(){return _?bind(g,e)():undefined};return(o?[t,r]:[r,t]).reduce(function(e,t){return t(e)},undefined)}:undefined,set:v||h?function(e){var t=this,r=bind(y,this),n=function(e){return v?bind(m,t)(e):e};return(s?[r,n]:[n,r]).reduce(function(e,t){return t(e)},e)}:undefined,configurable:c,enumerable:f}}if(isInitializerDescriptor(i)){var b=i.initializer,$=void 0,w=!1;return{get:function(){var e=bind(p,this);return w?e($):($=bind(b,this)(),w=!0,e($))},set:function(e){var t=bind(y,this);return $=s?t(e):e,w=!0,s||t($),$},configurable:c,enumerable:f}}var E=i||{},S=E.value;return{get:function(){return bind(p,this)(S)},set:function(e){var t=bind(y,this);return S=s?t(e):e,s||t(S),S},configurable:c,enumerable:f}}}function before(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];if(0===t.length)throw new Error("@before accept at least one parameter. If you don't need to preprocess before your function, do not add @before decorators");if(t.length>2&&isDescriptor(t[2]))throw new Error("You may use @before straightly, @before return decorators, you should call it before you set it as decorator.");for(var n=t.length-1;n>-1;n--)if(!isFunction(t[n]))throw new TypeError("@before only accept function parameter");return function(e,r,n){var i=n||{},o=i.value,a=i.configurable,s=i.enumerable,u=i.writable;if(!isFunction(o))throw new TypeError('@before can only be used on function, please check the property "'+r+'" is a method or not.');return{value:function(){for(var e=this,r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];var a=t.reduce(function(t,r){var n=bind(r,e).apply(undefined,_toConsumableArray(t));return n===undefined?t:isArray$1(n)?n:[n]},n);return bind(o,this).apply(undefined,_toConsumableArray(a))},configurable:a,enumerable:s,writable:u}}}function initialize(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];if(0===t.length)throw new Error("@initialize accept at least one parameter. If you don't need to initialize your value, do not add @initialize.");if(t.length>2&&isDescriptor(t[2]))throw new Error("You may use @initialize straightly, @initialize return decorators, you need to call it");var n=compressOneArgFnArray(t,"@initialize only accept function parameter");return function(e,t,r){if(r===undefined)return{value:bind(n,e)(),configurable:!0,writable:!0,enumerable:!0};if(isAccessorDescriptor(r)){var i=!1,o=r.set;return accessor({get:function(e){return i?e:bind(n,this)(e)},set:o?function(e){return i=!0,e}:undefined})(e,t,r)}if(isInitializerDescriptor(r)){var a=r.initializer;return{initializer:function(){return bind(n,this)(bind(a,this)())},configurable:r.configurable,writable:r.writable,enumerable:r.enumerable}}return{value:bind(n,this)(r.value),writable:r.writable,configurable:r.configurable,enumerable:r.enumerable}}}function setAlias(e,t,r,n,i,o){var a=r.configurable,s=r.enumerable,u=o.force,c=o.omit,l=getOwnPropertyDescriptor$1$1(n,i);if(l!==undefined){if(c)return;if(!u)throw new Error('"'+t+'" is an existing property, if you want to override it, please set "force" true in @alias option.');if(!l.configurable)throw new Error('property "'+t+'" is unconfigurable.')}defineProperty$4(n,i,{get:function(){return e[t]},set:function(r){return e[t]=r,t},configurable:a,enumerable:s})}function alias(e,t,r){if(2===arguments.length?isString(e)&&(r=t,t=e,e=undefined):1===arguments.length&&(t=e,e=undefined),!isString(t))throw new TypeError("@alias need a string as a key to find the porperty to set alias on");var n="If you want to use @alias to set alias on other instance, you must pass in a legal instance";if(e!==undefined&&isPrimitive(e))throw new TypeError(n);var i=isObject$1(r)?r:{force:!1,omit:!1},o=i.force,a=i.omit;return function(r,i,s){function u(e,t,r){var i=isPrimitive(e)?t:e,o=r.split("."),a=o.slice(-1),s=_slicedToArray(a,1),u=s[0];if(i=getDeepProperty(i,o.slice(0,-1),{throwError:!0}),isPrimitive(i))throw new TypeError(n);return{target:i,name:u}}if(s=s||{value:undefined,configurable:!0,writable:!0,enumerable:!0},isInitializerDescriptor(s))return initialize(function(r){var n=u(e,this,t),c=n.target,l=n.name;return setAlias(this,i,s,c,l,{force:o,omit:a}),r})(r,i,s);if(isAccessorDescriptor(s)){var c=void 0,l=function(r){if(c)return r;var n=u(e,this,t),l=n.target,f=n.name;return setAlias(this,i,s,l,f,{force:o,omit:a}),c=!0,r};return accessor({get:l,set:l})(r,i,s)}var f=u(e,r,t),d=f.target,h=f.name;return setAlias(r,i,s,d,h,{force:o,omit:a}),s}}function classify(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},r=t.requirement,n=t.customArgs,i=n!==undefined&&n;return function(){for(var t=arguments.length,n=Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var a=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},s=a.exclude,u=s===undefined?[]:s,c=a.include,l=c===undefined?[]:c,f=a.construct,d=f!==undefined&&f,h=a.self,p=h!==undefined&&h;if(!isArray$1(u))throw new TypeError("options.exclude must be an array");if(!isArray$1(l))throw new TypeError("options.include must be an array");return function(t){var o=isFunction(t);if(!p&&!o)throw new TypeError("@"+e.name+"Class can only be used on class");if(p&&isPrimitive(t))throw new TypeError("@"+e.name+"Class must be used on non-primitive type value in 'self' mode");var a=p?t:t.prototype;if(isVoid(a))throw new Error("The prototype of the "+t.name+" is empty, please check it");var s=getOwnPropertyDescriptors(a);getOwnKeys(a).concat(l).forEach(function(t){var c=s[t];"constructor"===t&&!d||p&&o&&["name","length","prototype"].indexOf(t)>-1||u.indexOf(t)>-1||isFunction(r)&&!1===r(a,t,c,{self:p})||defineProperty$1$1(a,t,(i?e.apply(undefined,_toConsumableArray(n)):e)(a,t,c))})}}}function getBoundSuper(e,t){if(void 0===_WeakMap)throw new Error("Using @autobind on "+t.name+"() requires WeakMap support due to its use of super."+t.name+"()");mapStore||(mapStore=new _WeakMap),!1===mapStore.has(e)&&mapStore.set(e,new _WeakMap);var r=mapStore.get(e);return!1===r.has(t)&&r.set(t,bind(t,e)),r.get(t)}function autobind(e,t,r){if(1===arguments.length)return autobindClass()(e);var n=r||{},i=n.value,o=n.configurable;if(!isFunction(i))throw new TypeError('@autobind can only be used on functions, not "'+i+'" in '+(void 0===i?"undefined":_typeof(i))+' on property "'+t+'"');var a=e.constructor;return{configurable:o,enumerable:!1,get:function(){var r=this,n=function(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return i.call.apply(i,[r].concat(_toConsumableArray(t)))};return this===e?i:this.constructor!==a&&_Object$getPrototypeOf(this).constructor===a?i:this.constructor!==a&&t in this.constructor.prototype?getBoundSuper(this,i):(_Object$defineProperty(this,t,{configurable:!0,writable:!0,enumerable:!1,value:n}),n)},set:createDefaultSetter(t)}}function frozen(e,t,r){if(r===undefined)return{value:undefined,writable:!1,enumerable:!1,configurable:!1};if(r.enumerable=!1,r.configurable=!1,isAccessorDescriptor(r)){var n=r.get;if(r.set=undefined,!isFunction(n))return;return{get:function(){var e=bind(n,this)();return defineProperty$2$1(this,t,{value:e,writable:!1,configurable:!1,enumerable:!1}),e},set:undefined,configurable:!1,enumerable:!1}}return r.writable=!1,r}function waituntil(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},r=t.other;if(!isFunction(e)&&!isPromise(e)&&!isString(e))throw new TypeError("@waitUntil only accept Function, Promise or String");return function(t,n,i){var o=i||{},a=o.value,s=o.configurable;if(!isFunction(a))throw new TypeError("@waituntil can only be used on function, but not "+a+' on property "'+n+'"');var u=!1,c=[],l=isPromise(e)?function(){return e}:isFunction(e)?e:function(){var t=e.split("."),n=t.slice(-1),i=isPrimitive(r)?this:r;if(!u){var o=getDeepProperty(i,t.slice(0,-1));if(isVoid(o))return o;var a=getOwnPropertyDescriptor$2$1(o,n),s=function(e){if(!0===e)for(;c.length>0;)c[0](),c.shift();return e},l=isDescriptor(a)?accessor({set:s})(o,n,a):accessor({set:s})(o,n,{value:undefined,configurable:!0,enumerable:!0,writable:!0});defineProperty$3$1(o,n,l),u=!0}return getDeepProperty(i,t)};return{value:function(){for(var e=this,t=arguments.length,r=Array(t),n=0;n<t;n++)r[n]=arguments[n];var i=bind(a,this),o=bind(l,this).apply(undefined,r);return isPromise(o)?_Promise.resolve(o).then(function(){return bind(a,e).apply(undefined,r)}):!0===o?bind(a,this).apply(undefined,r):new _Promise(function(e){var t=function(){i.apply(undefined,r),e()};c.push(t)})},enumerable:!1,configurable:s,writable:!1}}}function nonenumerable(e,t,r){return r===undefined?{value:undefined,enumerable:!1,configurable:!0,writable:!0}:(r.enumerable=!1,r)}function applyDecorators(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{},n=r.self,i=n!==undefined&&n,o=r.omit,a=o!==undefined&&o,s=isFunction(t);if(s||isArray$1(t)){if(!isFunction(e))throw new TypeError("If you want to decorator class, you must pass it a legal class");if(s)t(e);else for(var u=0,c=t.length;u<c;u++){var l=t[u];if(!isFunction(l))throw new TypeError("If you want to decorate an class, you must pass it function or array of function");l(e)}return e}if(!i&&!isFunction(e))throw new TypeError("applyDecorators only accept class as first arguments. If you want to modify instance, you should set options.self true.");if(i&&isPrimitive(e))throw new TypeError("We can't apply docorators on a primitive value, even in self mode");if(!isObject$1(t))throw new TypeError("applyDecorators only accept object as second arguments");var f=i?e:e.prototype;if(isVoid(f))throw new Error("The class muse have a prototype, please take a check");for(var d in t){var h=t[d],p=isArray$1(h)?h:[h],y=void 0;try{y=compressMultipleDecorators.apply(undefined,_toConsumableArray(p))}catch(m){throw new Error("The decorators set on props must be Function or Array of Function")}var g=getOwnPropertyDescriptor$3$1(f,d);if(!g||g.configurable)defineProperty$6(f,d,y(f,d,g));else if(!a)throw new Error(d+" of "+f+" is unconfigurable")}return e}function deepProxy(e,t,r){var n,i=r.diff,o=r.operationPrefix,a={},s=!1,u=new Proxy(e,{get:function(e,r,n){var u=e[r];if(isArray$1(e)&&arrayChangeMethod.indexOf(r)>-1)return function(){s=!0,bind(u,n).apply(undefined,arguments),s=!1,t()};if(!0===a[r])return u;if(isObject$1(u)||isArray$1(u)){var c=a[r]||deepProxy(u,t,{diff:i,operationPrefix:o});return a[r]=c,c}return a[r]=!0,u},set:function(e,r,n){var u=e[r],c=isObject$1(n)||isArray$1(n)?deepProxy(n,t,{diff:i,operationPrefix:o}):n;return e[r]=c,a[r]=!0,!!(s||i&&u===c)||(t(),!0)},deleteProperty:function(e,r){return delete e[r],delete a[r],!!s||(t(),!0)}}),c=(n={},_defineProperty$1(n,o+"set",[initialize(function(e){return function(e,t){u[e]=t}}),nonenumerable]),_defineProperty$1(n,o+"del",[initialize(function(e){return function(e){delete u[e]}}),nonenumerable]),n);return applyDecorators(u,c,{self:!0}),u}function deepObserve(e,t,r){function n(e){var r=void 0;return e.reduce(function(e,n){return e[n]=[accessor({set:function(e){return r=this[n],e}}),accessor({get:function(e){return u[n]?e:((isObject$1(e)||isArray$1(e))&&deepObserve(e,t,{operationPrefix:a,diff:s}),u[n]=!0,e)},set:function(e){return(isObject$1(e)||isArray$1(e))&&deepObserve(e,t,{operationPrefix:a,diff:s}),u[n]=!0,c||s&&r===e||t(),e}},{preSet:!1})],e},{})}var i,o=this,a=r.operationPrefix,s=r.diff,u={},c=!1,l=n(getOwnKeys(e));if(applyDecorators(e,l,{self:!0,omit:!0}),isArray$1(e)){var f=arrayChangeMethod.reduce(function(r,i){return r[i]=[initialize(function(r){return r=isFunction(r)?r:Array.prototype[i],function(){var i=e.length;if(c=!0,bind(r,e).apply(undefined,arguments),c=!1,i<e.length){var o=new Array(e.length-i).fill(1).map(function(e,t){return(t+i).toString()}),a=n(o);applyDecorators(e,a,{self:!0,omit:!0})}t()}}),nonenumerable],r},{});applyDecorators(e,f,{self:!0})}var d=(i={},_defineProperty$1(i,a+"set",[initialize(function(t){return function(r,i){var a=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{},s=a.disable,u=a.isNewVal;if(u=u||-1===getOwnKeys(e).indexOf(r),isFunction(t)&&bind(t,o)(r,i,{disable:!0,isNewVal:u}),u){var c=n([r]);applyDecorators(e,c,{self:!0,omit:!0})}s||(e[r]=i)}}),nonenumerable]),_defineProperty$1(i,a+"del",[initialize(function(r){return function(n){isFunction(r)?bind(r,o)(n):delete e[n],t()}}),nonenumerable]),i);return applyDecorators(e,d,{self:!0}),e}function watch(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=isObject$1(t[t.length-1])?t[t.length-1]:{},i=n.deep,o=n.omit,a=n.other,s=n.operationPrefix,u=s===undefined?"__":s,c=n.diff,l=c===undefined||c,f=n.proxy;if("function"!=typeof Proxy&&(f=!1),!t.length)throw new TypeError("You must pass a function or a string to find the hanlder function.");if(a!==undefined&&isPrimitive(a))throw new TypeError("If you want us to trigger function on the other instance, you must pass in a legal instance");if(!isString(u))throw new TypeError("operationPrefix must be an string");return function(e,r,n){var s=t.reduce(function(r,n,i){if(!isString(n)&&!isFunction(n)){if(!i||i!==t.length-1)throw new TypeError("You can only pass function or string as handler");return r}return r.push(isString(n)?function(t,r){var i=a||e,s=getDeepProperty(i,n);if(isFunction(s))return bind(s,this)(t,r);if(!o)throw new Error("You pass in a function for us to trigger, please ensure the property to be a function or set omit flag true")}:n),r},[]),c=function(e,t){var r=this;s.forEach(function(n){return bind(n,r)(e,t)})},d=!1,h=void 0,p=void 0,y=void 0;return compressMultipleDecorators(accessor({set:function(e){var t=this;h=this[r],y=undefined;var n=function(){return bind(c,t)(p,h)};return i&&(isObject$1(e)||isArray$1(e))?f?deepProxy(e,n,{diff:l,operationPrefix:u}):deepObserve(e,n,{operationPrefix:u,diff:l}):e},get:function(e){var t=this;if(y)return y;if(!d){d=!0;var r=function(){return bind(c,t)(p,h)};if(i&&(isObject$1(e)||isArray$1(e))){if(f)return y=deepProxy(e,r,{diff:l,operationPrefix:u}),h=y,p=y,y;deepObserve(e,r,{operationPrefix:u,diff:l})}h=e,p=e}return e}},{preSet:!0}),accessor({set:function(e){return p=e,l&&h===e||bind(c,this)(p,h),h=e,e}},{preSet:!1}))(e,r,n)}}function runnable(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},r=t.other,n=t.backup;if(!isFunction(e)&&!isString(e))throw new TypeError("@runnable only accept Function or String");return function(t,i,o){var a=o||{},s=a.value,u=a.configurable;if(!isFunction(s))throw new TypeError("@runnable can only be used on method, but not "+s+' on property "'+i+'".');var c=isFunction(e)?e:function(){var t=e.split(".");return getDeepProperty(isPrimitive(r)?this:r,t)};return n=isFunction(n)?n:function(){},{value:function(){return!0===bind(c,this).apply(undefined,arguments)?bind(s,this).apply(undefined,arguments):bind(n,this).apply(undefined,arguments)},enumerable:!1,configurable:u,writable:!1}}}function nonconfigurable(e,t,r){return r===undefined?{value:undefined,enumerable:!0,configurable:!0,writable:!0}:(r.configurable=!0,r)}function string(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=isString(t[0])?t.shift():"";return t.unshift(function(e){return isString(e)?e:n}),initialize.apply(undefined,t)}function boolean(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=!!isBoolean(t[0])&&t.shift();return t.unshift(function(e){return isBoolean(e)?e:n}),initialize.apply(undefined,t)}function string$1(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=isString(t[0])?t.shift():"";return t.unshift(function(e){return isString(e)?e:n}),accessor({set:t,get:t})}function boolean$1(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=!!isBoolean(t[0])&&t.shift();return t.unshift(function(e){return isBoolean(e)?e:n}),accessor({set:t,get:t})}function number$1(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=isNumber(t[0])?t.shift():0;return t.unshift(function(e){return isNumber(e)?e:n}),accessor({set:t,get:t})}function setStyle$1(e,t,r){if(isObject$1(t))for(var n in t)setStyle$1(e,n,t[n]);else e.style[t]=r}function native(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(isObject$1(t)&&(r=t),isString(e)&&(t=e),isElement(e)||(e=document),!isString(t))throw new Error("You must pass in a string as name, but not "+(void 0===t?"undefined":_typeof(t))+".");for(var n=r,i=n.keyOnly,o=i!==undefined&&i,a=0;a<SYNONYMS.length;a++){t=t.replace(SYNONYMS[a][0],SYNONYMS[a][1]);for(var s=0;s<VENDOR_PREFIXES.length;s++){var u=0===s?t:VENDOR_PREFIXES[s]+t.charAt(0).toUpperCase()+t.substr(1);if(e[u]!==undefined)return o?u:e[u]}}return o?"":undefined}function dispatchEvent(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{},n=r.bubbles,i=n===undefined||n,o=r.cancelable,a=o===undefined||o,s=void 0;if(isFunction(Event)?s=new Event(t,{bubbles:i,cancelable:a}):document.createEvent?(s=document.createEvent("HTMLEvents"),
s.initEvent(t,!0,!0)):document.createEventObject&&(s=document.createEventObject(),s.eventType=t,s.eventName=t),!isObject$1(s)&&!isEvent(s))throw new Error("We can't create an object on this browser, please report to author");e.dispatchEvent?e.dispatchEvent(s):e.fireEvent?e.fireEvent("on"+s.eventType,s):e[t]?e[t]():e["on"+t]&&e["on"+t]()}function _applyDecoratedDescriptor$1$1(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function _applyDecoratedDescriptor$2(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function secondaryChecker(e){return!e.match(secondaryReg)}function eventBinderCheck(e,t){if(!isString(e))throw new TypeError("key parameter must be String");if(!isFunction(t))throw new TypeError("fn parameter must be Function")}function attrAndStyleCheck(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.length>2?["set"].concat(t):2===t.length?["video","container","wrapper","videoElement"].indexOf(t[0])>-1?["get"].concat(t):["set","container"].concat(t):["get","container"].concat(t)}function _initDefineProp$1(e,t,r,n){r&&_Object$defineProperty(e,t,{enumerable:r.enumerable,configurable:r.configurable,writable:r.writable,value:r.initializer?r.initializer.call(n):void 0})}function _applyDecoratedDescriptor$4(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function stringOrVoid(e){return isString(e)?e:undefined}function accessorVideoProperty(e){return accessor({get:function(t){return this.dispatcher.videoConfigReady&&this.inited?this.dom.videoElement[e]:t},set:function(t){return this.dispatcher.videoConfigReady?(this.dom.videoElement[e]=t,t):t}})}function accessorVideoAttribute(e){var t=isObject$1(e)?e:{set:e,get:e,isBoolean:!1},r=t.set,n=t.get,i=t.isBoolean;return accessor({get:function(e){return this.dispatcher.videoConfigReady&&this.inited?this.dom.videoElement[n]:e},set:function(e){if(!this.dispatcher.videoConfigReady)return e;var t=i?e?"":undefined:null===e?undefined:e;return this.dom.setAttr("video",r,t),e}})}function accessorCustomAttribute(e,t){return accessor({get:function(r){var n=this.dom.getAttr("video",e);return this.dispatcher.videoConfigReady&&this.inited?t?!!n:n:r},set:function(r){if(!this.dispatcher.videoConfigReady)return r;var n=t?r||undefined:null===r?undefined:r;return this.dom.setAttr("video",e,n),r}})}function accessorWidthAndHeight(e){return accessor({get:function(t){if(!this.dispatcher.videoConfigReady||!this.inited)return t;var r=this.dom.getAttr("video",e),n=this.dom.videoElement[e];return isNumeric(r)&&isNumber(n)?n:r||undefined},set:function(t){if(!this.dispatcher.videoConfigReady)return t;var r=void 0;return t===undefined||isNumber(t)?r=t:isString(t)&&!_Number$isNaN(parseFloat(t))&&(r=t),this.dom.setAttr("video",e,r),r}})}function _applyDecoratedDescriptor$3(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function _applyDecoratedDescriptor$5(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function targetCheck(e){if("video"===e&&(e="videoElement"),!isElement(this[e]))throw new TypeError('Your target "'+e+'" is not a legal HTMLElement');for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];return[e].concat(r)}function attrOperationCheck(e,t,r){if(!isString(t))throw new TypeError("to handle dom's attribute or style, your attr parameter must be string, but not "+t+" in "+(void 0===t?"undefined":_typeof(t)));if(!isString(e))throw new TypeError("to handle dom's attribute or style, your target parameter must be string, , but not "+e+" in "+(void 0===e?"undefined":_typeof(e)));return[e,t,r]}function _applyDecoratedDescriptor$1(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function convertNameIntoId(e){if(!isString(e))throw new Error("Plugin's name must be a string, but not \""+e+'" in '+(void 0===e?"undefined":_typeof(e)));return camelize(e)}function checkPluginConfig(e){if(isFunction(e)){if(!(e.prototype instanceof Plugin))throw new TypeError("Your are trying to install plugin "+e.name+", but it's not extends from Chimee.plugin.")}else{if(!isObject$1(e)||isEmpty(e))throw new TypeError("plugin's config must be an Object, but not \""+e+'" in '+(void 0===e?"undefined":_typeof(e)));var t=e.name;if(!isString(t)||t.length<1)throw new TypeError('plugin must have a legal namea, but not "'+t+'" in '+(void 0===t?"undefined":_typeof(t)))}}function _initDefineProp$2(e,t,r,n){r&&_Object$defineProperty(e,t,{enumerable:r.enumerable,configurable:r.configurable,writable:r.writable,value:r.initializer?r.initializer.call(n):void 0})}function _applyDecoratedDescriptor$6(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function _initDefineProp(e,t,r,n){r&&_Object$defineProperty(e,t,{enumerable:r.enumerable,configurable:r.configurable,writable:r.writable,value:r.initializer?r.initializer.call(n):void 0})}function _applyDecoratedDescriptor(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function __$styleInject$1(e,t){if("undefined"==typeof document)return t;e=e||"";var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");return n.type="text/css",r.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t}function unwrapExports$1(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e["default"]:e}function createCommonjsModule$1(e,t){return t={exports:{}},e(t,t.exports),t.exports}function bind$1(e,t){return e.bind?e.bind(t):e.apply?function(){for(var r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];return e.apply(t,n)}:function(){for(var r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];return e.call.apply(e,[t].concat(_toConsumableArray$1(n)))}}function _applyDecoratedDescriptor$2$1(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function _applyDecoratedDescriptor$1$2(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function _applyDecoratedDescriptor$2$2(e,t,r,n,i){var o={};return Object.keys(n).forEach(function(e){o[e]=n[e]}),o.enumerable=!!o.enumerable,o.configurable=!!o.configurable,("value"in o||o.initializer)&&(o.writable=!0),o=r.slice().reverse().reduce(function(r,n){return n(e,t,r)||r},o),i&&void 0!==o.initializer&&(o.value=o.initializer?o.initializer.call(i):void 0,o.initializer=undefined),void 0===o.initializer&&(Object.defineProperty(e,t,o),o=null),o}function hundleChildren(e){return e.$config.children?e.$config.children:e.isLive?{play:!0,progressTime:!1,progressBar:!1,volume:!0,screen:!0}:{play:!0,progressTime:!0,progressBar:!0,volume:!0,screen:!0}}function createChild(e){var t=e.config.children=hundleChildren(e),r={};return t?_Object$keys$1(t).forEach(function(n){switch(n){case"play":t.play&&(r.play=new Play(e,t.play));break;case"progressTime":t.progressTime&&(r.progressTime=new ProgressTime(e,t.progressTime));break;case"progressBar":r.progressBar=new ProgressBar(e,t.progressBar);break;case"volume":t.volume&&(r.volume=new Volume(e,t.volume));break;case"screen":t.screen&&(r.screen=new Screen(e,t.screen));break;case"clarity":t.clarity&&Array.isArray(t.clarity.list)&&(r.clarity=new Clarity(e,t.clarity));break;default:r[n]=new Component(e,t[n])}}):(r.play=new Play(e),r.progressTime=new ProgressTime(e),r.progressBar=new ProgressBar(e),r.volume=new Volume(e),r.screen=new Screen(e)),r}function __$styleInject$2(e,t){if("undefined"==typeof document)return t;e=e||"";var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");return n.type="text/css",r.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t}function popupFactory(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},t=e.tagName,r=t===undefined?"chimee-popup":t,n=e.className,i=e.name,o=i===undefined?"popup":i,a=e.html,s=e.title,u=s===undefined?"\u8fd9\u662f\u4e00\u4e2a\u4fe1\u606f\u6846":s,c=e.body,l=c===undefined?"\u8fd9\u91cc\u662f\u4fe1\u606f\u5185\u5bb9":c,f=e.offsetAttr,d=f===undefined?"left top":f,h=e.offset,p=h===undefined?"50% 50%":h,y=e.translate,g=y===undefined?"":y,m=e.width,_=e.height,v=e.level,b=e.init,w=e.inited,E=e.data,S=e.create,O=e.beforeCreate,T=e.destroy,A=e.events,x=e.computed,k=e.methods,D=k===undefined?{}:k,I=e.penetrate,P=I!==undefined&&I,M=e.operable,R=M===undefined||M,C=e.hide,j=C!==undefined&&C,L=e.opened,N=e.closed,F=e.autoFocus,B={html:a||"\n      <cm-pp-close>\xd7</cm-pp-close>\n      "+(!1!==u?"<cm-pp-head>"+u+"</cm-pp-head>":"")+"\n      "+(!1!==l?"<cm-pp-body>"+l+"</cm-pp-body>":"")+"\n    ",closeSelector:"._close"};return{name:o,el:r,className:n,beforeCreate:function(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},t=e.events,r=e.methods,n=arguments[1];isObject$1(n)&&(isObject$1(n.events)&&deepAssign(t,n.events),isObject$1(n.methods)&&deepAssign(r,n.methods)),O&&O.apply(this,arguments)},create:function(){var e=isObject$1(this.$config)?deepAssign(B,this.$config):B;(this.$domWrap=$(this.$dom).css("display","none")).html(e.html).delegate("cm-pp-close, "+e.closeSelector,"click",this.close),this.width(m).height(_).offset(p).translate(g),this._hide=j;for(var t=arguments.length,r=Array(t),n=0;n<t;n++)r[n]=arguments[n];S&&S.apply(this,r),!this._hide&&this.open()},destroy:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];T&&T.apply(this,t),this.$domWrap.undelegate(this.$config.closeSelector,"click",this.close).remove()},level:v,init:b,inited:w,data:E,events:A,computed:x,penetrate:P,operable:R,autoFocus:F,methods:deepAssign({open:function(){if(this.destroyed)return this;this.$domWrap.css("display","block"),this._hide=!1;for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return this.$emit("popupOpen",t,this),isFunction(L)&&L.apply(this,t),this},close:function(){if(this.destroyed)return this;this.$domWrap.css("display","none"),this._hide=!0;for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return this.$emit("popupClose",t,this),isFunction(N)&&N.apply(this,t),this},width:function(e){return e&&this.$domWrap.css("width",e),this},height:function(e){return e&&this.$domWrap.css("height",e),this},offset:function(e){var t=(""+(e||"")).split(" "),r={};if(t.length>2)return["top","right","bottom","left"].forEach(function(e,n){t[n]&&"auto"!==t[n]&&(r[e]=t[n])}),this.$domWrap.css(r),this;var n=_slicedToArray(t,2),i=n[0],o=n[1];if(""===i)return this;var a=o||i,s=d.split(" ");r[s[0]]=i,r[s[1]]=a,this.$domWrap.css(r);var u=[];return"50%"===i&&u.push("-50%"),"50%"===a&&u.push("-50%"),u.length>0&&this.translate(u.join(" ")),this},translate:function(e){var t=(""+(e||"")).split(" "),r=_slicedToArray(t,2),n=r[0],i=r[1];return""!==n&&(this.$domWrap.css("transform","translate("+n+", "+(i||n)+")"),"transform"in document.createElement("a").style||!window.console||!window.console.warn||console.warn("[chimee-plugin-popup] \u5f53\u524d\u73af\u5883\u4e0d\u652f\u6301CSS3\u7684transform\u7279\u6027\uff0cDom\u5143\u7d20\u65e0\u6cd5\u6b63\u5e38\u4f7f\u7528translate\u3002")),this}},D)}}function __$styleInject$4(e,t){if("undefined"==typeof document)return t;e=e||"";var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");return n.type="text/css",r.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t}function popupFactory$2(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},t=e.tagName,r=t===undefined?"chimee-popup":t,n=e.className,i=e.name,o=i===undefined?"popup":i,a=e.html,s=e.title,u=s===undefined?"\u8fd9\u662f\u4e00\u4e2a\u4fe1\u606f\u6846":s,c=e.body,l=c===undefined?"\u8fd9\u91cc\u662f\u4fe1\u606f\u5185\u5bb9":c,f=e.offsetAttr,d=f===undefined?"left top":f,h=e.offset,p=h===undefined?"50% 50%":h,y=e.translate,g=y===undefined?"":y,m=e.width,_=e.height,v=e.level,b=e.init,w=e.inited,E=e.data,S=e.create,O=e.beforeCreate,T=e.destroy,A=e.events,x=e.computed,k=e.methods,D=k===undefined?{}:k,I=e.penetrate,P=I!==undefined&&I,M=e.operable,R=M===undefined||M,C=e.hide,j=C!==undefined&&C,L=e.opened,N=e.closed,F=e.autoFocus,B={html:a||"\n      <cm-pp-close>\xd7</cm-pp-close>\n      "+(!1!==u?"<cm-pp-head>"+u+"</cm-pp-head>":"")+"\n      "+(!1!==l?"<cm-pp-body>"+l+"</cm-pp-body>":"")+"\n    ",closeSelector:"._close"};return{name:o,el:r,className:n,beforeCreate:function(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},t=e.events,r=e.methods,n=arguments[1];isObject$1(n)&&(isObject$1(n.events)&&deepAssign(t,n.events),isObject$1(n.methods)&&deepAssign(r,n.methods)),O&&O.apply(this,arguments)},create:function(){var e=isObject$1(this.$config)?deepAssign(B,this.$config):B;(this.$domWrap=$(this.$dom).css("display","none")).html(e.html).delegate("cm-pp-close, "+e.closeSelector,"click",this.close),this.width(m).height(_).offset(p).translate(g),this._hide=j;for(var t=arguments.length,r=Array(t),n=0;n<t;n++)r[n]=arguments[n];S&&S.apply(this,r),!this._hide&&this.open()},destroy:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];T&&T.apply(this,t),this.$domWrap.undelegate(this.$config.closeSelector,"click",this.close).remove()},level:v,init:b,inited:w,data:E,events:A,computed:x,penetrate:P,operable:R,autoFocus:F,methods:deepAssign({open:function(){if(this.destroyed)return this;this.$domWrap.css("display","block"),this._hide=!1;for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return this.$emit("popupOpen",t,this),isFunction(L)&&L.apply(this,t),this},close:function(){if(this.destroyed)return this;this.$domWrap.css("display","none"),this._hide=!0;for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return this.$emit("popupClose",t,this),isFunction(N)&&N.apply(this,t),this},width:function(e){return e&&this.$domWrap.css("width",e),this},height:function(e){return e&&this.$domWrap.css("height",e),this},offset:function(e){var t=(""+(e||"")).split(" "),r={};if(t.length>2)return["top","right","bottom","left"].forEach(function(e,n){t[n]&&"auto"!==t[n]&&(r[e]=t[n])}),this.$domWrap.css(r),this;var n=_slicedToArray(t,2),i=n[0],o=n[1];if(""===i)return this;var a=o||i,s=d.split(" ");r[s[0]]=i,r[s[1]]=a,this.$domWrap.css(r);var u=[];return"50%"===i&&u.push("-50%"),"50%"===a&&u.push("-50%"),u.length>0&&this.translate(u.join(" ")),this},translate:function(e){var t=(""+(e||"")).split(" "),r=_slicedToArray(t,2),n=r[0],i=r[1];return n&&this.$domWrap.css("transform","translate("+n+", "+(i||n)+")"),this}},D)}}function __$styleInject$3(e,t){if("undefined"==typeof document)return t;e=e||"";var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");return n.type="text/css",r.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t}function __$styleInject$6(e,t){if("undefined"==typeof document)return t;e=e||"";var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");return n.type="text/css",r.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t}function popupFactory$4(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},t=e.tagName,r=t===undefined?"chimee-popup":t,n=e.className,i=e.name,o=i===undefined?"popup":i,a=e.html,s=e.title,u=s===undefined?"\u8fd9\u662f\u4e00\u4e2a\u4fe1\u606f\u6846":s,c=e.body,l=c===undefined?"\u8fd9\u91cc\u662f\u4fe1\u606f\u5185\u5bb9":c,f=e.offsetAttr,d=f===undefined?"left top":f,h=e.offset,p=h===undefined?"50% 50%":h,y=e.translate,g=y===undefined?"":y,m=e.width,_=e.height,v=e.level,b=e.init,w=e.inited,E=e.data,S=e.create,O=e.beforeCreate,T=e.destroy,A=e.events,x=e.computed,k=e.methods,D=k===undefined?{}:k,I=e.penetrate,P=I!==undefined&&I,M=e.operable,R=M===undefined||M,C=e.hide,j=C!==undefined&&C,L=e.opened,N=e.closed,F=e.autoFocus,B={html:a||"\n      <cm-pp-close>\xd7</cm-pp-close>\n      "+(!1!==u?"<cm-pp-head>"+u+"</cm-pp-head>":"")+"\n      "+(!1!==l?"<cm-pp-body>"+l+"</cm-pp-body>":"")+"\n    ",closeSelector:"._close"};return{name:o,el:r,className:n,beforeCreate:function(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},t=e.events,r=e.methods,n=arguments[1];isObject$1(n)&&(isObject$1(n.events)&&deepAssign(t,n.events),isObject$1(n.methods)&&deepAssign(r,n.methods)),O&&O.apply(this,arguments)},create:function(){var e=isObject$1(this.$config)?deepAssign(B,this.$config):B;(this.$domWrap=$(this.$dom).css("display","none")).html(e.html).delegate("cm-pp-close, "+e.closeSelector,"click",this.close),this.width(m).height(_).offset(p).translate(g),this._hide=j;for(var t=arguments.length,r=Array(t),n=0;n<t;n++)r[n]=arguments[n];S&&S.apply(this,r),!this._hide&&this.open()},destroy:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];T&&T.apply(this,t),this.$domWrap.undelegate(this.$config.closeSelector,"click",this.close).remove()},level:v,init:b,inited:w,data:E,events:A,computed:x,penetrate:P,operable:R,autoFocus:F,methods:deepAssign({open:function(){if(this.destroyed)return this;this.$domWrap.css("display","block"),this._hide=!1;for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return this.$emit("popupOpen",t,this),isFunction(L)&&L.apply(this,t),this},close:function(){if(this.destroyed)return this;this.$domWrap.css("display","none"),this._hide=!0;for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return this.$emit("popupClose",t,this),isFunction(N)&&N.apply(this,t),this},width:function(e){return e&&this.$domWrap.css("width",e),this},height:function(e){return e&&this.$domWrap.css("height",e),this},offset:function(e){var t=(""+(e||"")).split(" "),r={};if(t.length>2)return["top","right","bottom","left"].forEach(function(e,n){t[n]&&"auto"!==t[n]&&(r[e]=t[n])}),this.$domWrap.css(r),this;var n=_slicedToArray(t,2),i=n[0],o=n[1];if(""===i)return this;var a=o||i,s=d.split(" ");r[s[0]]=i,r[s[1]]=a,this.$domWrap.css(r);var u=[];return"50%"===i&&u.push("-50%"),"50%"===a&&u.push("-50%"),u.length>0&&this.translate(u.join(" ")),this},translate:function(e){var t=(""+(e||"")).split(" "),r=_slicedToArray(t,2),n=r[0],i=r[1];return n&&this.$domWrap.css("transform","translate("+n+", "+(i||n)+")"),this}},D)}}function __$styleInject$5(e,t){if("undefined"==typeof document)return t;e=e||"";var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");return n.type="text/css",r.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t}function __$styleInject$7(e,t){if("undefined"==typeof document)return t;e=e||"";var r=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");return n.type="text/css",r.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e)),t}function asinh(e){return isFinite(e=+e)&&0!=e?e<0?-asinh(-e):Math.log(e+Math.sqrt(e*e+1)):e}function PromiseCapability$1(e){var t,r;this.promise=new e(function(e,n){if(t!==undefined||r!==undefined)throw TypeError("Bad Promise constructor");t=e,r=n}),this.resolve=_aFunction$3(t),this.reject=_aFunction$3(r)}function get$2(e,t){var r,n,i=arguments.length<3?e:arguments[2];return _anObject$3(e)===i?e[t]:(r=_objectGopd$3.f(e,t))?_has$3(r,"value")?r.value:r.get!==undefined?r.get.call(i):undefined:_isObject$3(n=_objectGpo$3(e))?get$2(n,t,i):void 0}function set(e,t,r){var n,i,o=arguments.length<4?e:arguments[3],a=_objectGopd$3.f(_anObject$3(e),t);if(!a){if(_isObject$3(i=_objectGpo$3(e)))return set(i,t,r,o);a=_propertyDesc$3(0)}return _has$3(a,"value")?!(!1===a.writable||!_isObject$3(o))&&(n=_objectGopd$3.f(o,t)||_propertyDesc$3(0),n.value=r,_objectDp$3.f(o,t,n),!0):a.set!==undefined&&(a.set.call(o,r),!0)}function flattenIntoArray(e,t,r,n,i,o,a,s){for(var u,c,l=i,f=0,d=!!a&&_ctx$3(a,s,3);f<n;){if(f in r){if(u=d?d(r[f],f,t):r[f],c=!1,_isObject$3(u)&&(c=u[IS_CONCAT_SPREADABLE],c=c!==undefined?!!c:_isArray$3(u)),c&&o>0)l=flattenIntoArray(e,t,u,_toLength$3(u.length),l,o-1)-1;else{if(l>=9007199254740991)throw TypeError();e[l]=u}l++}f++}return l}function define(e,t,r){e[t]||Object[DEFINE_PROPERTY](e,t,{writable:!0,configurable:!0,value:r})}var commonjsGlobal="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},_defined=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e},_toObject=function(e){return Object(_defined(e))},hasOwnProperty={}.hasOwnProperty,_has=function(e,t){return hasOwnProperty.call(e,t)},_global=createCommonjsModule(function(e){var t=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=t)}),SHARED="__core-js_shared__",store=_global[SHARED]||(_global[SHARED]={}),_shared=function(e){return store[e]||(store[e]={})},id=0,px=Math.random(),_uid=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++id+px).toString(36))},shared=_shared("keys"),_sharedKey=function(e){return shared[e]||(shared[e]=_uid(e))},IE_PROTO=_sharedKey("IE_PROTO"),ObjectProto=Object.prototype,_objectGpo=Object.getPrototypeOf||function(e){return e=_toObject(e),_has(e,IE_PROTO)?e[IE_PROTO]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?ObjectProto:null},_core=createCommonjsModule(function(e){var t=e.exports={version:"2.5.1"};"number"==typeof __e&&(__e=t)}),_core_1=_core.version,_aFunction=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e},_ctx=function(e,t,r){if(_aFunction(e),t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,i){return e.call(t,r,n,i)}}return function(){return e.apply(t,arguments)}},_isObject=function(e){return"object"==typeof e?null!==e:"function"==typeof e},_anObject=function(e){if(!_isObject(e))throw TypeError(e+" is not an object!");return e},_fails=function(e){try{return!!e()}catch(t){return!0}},_descriptors=!_fails(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),document$1=_global.document,is=_isObject(document$1)&&_isObject(document$1.createElement),_domCreate=function(e){return is?document$1.createElement(e):{}},_ie8DomDefine=!_descriptors&&!_fails(function(){return 7!=Object.defineProperty(_domCreate("div"),"a",{get:function(){return 7}}).a}),_toPrimitive=function(e,t){if(!_isObject(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!_isObject(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!_isObject(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!_isObject(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")},dP=Object.defineProperty,f=_descriptors?Object.defineProperty:function(e,t,r){if(_anObject(e),t=_toPrimitive(t,!0),_anObject(r),_ie8DomDefine)try{return dP(e,t,r)}catch(n){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(e[t]=r.value),e},_objectDp={f:f},_propertyDesc=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},_hide=_descriptors?function(e,t,r){return _objectDp.f(e,t,_propertyDesc(1,r))}:function(e,t,r){return e[t]=r,e},PROTOTYPE="prototype",$export=function(e,t,r){var n,i,o,a=e&$export.F,s=e&$export.G,u=e&$export.S,c=e&$export.P,l=e&$export.B,f=e&$export.W,d=s?_core:_core[t]||(_core[t]={}),h=d[PROTOTYPE],p=s?_global:u?_global[t]:(_global[t]||{})[PROTOTYPE];s&&(r=t);for(n in r)(i=!a&&p&&p[n]!==undefined)&&n in d||(o=i?p[n]:r[n],d[n]=s&&"function"!=typeof p[n]?r[n]:l&&i?_ctx(o,_global):f&&p[n]==o?function(e){var t=function(t,r,n){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,n)}return e.apply(this,arguments)};return t[PROTOTYPE]=e[PROTOTYPE],t}(o):c&&"function"==typeof o?_ctx(Function.call,o):o,c&&((d.virtual||(d.virtual={}))[n]=o,e&$export.R&&h&&!h[n]&&_hide(h,n,o)))};$export.F=1,$export.G=2,$export.S=4,$export.P=8,$export.B=16,$export.W=32,$export.U=64,$export.R=128;var _export=$export,_objectSap=function(e,t){var r=(_core.Object||{})[e]||Object[e],n={};n[e]=t(r),_export(_export.S+_export.F*_fails(function(){r(1)}),"Object",n)};_objectSap("getPrototypeOf",function(){return function(e){return _objectGpo(_toObject(e))}});var getPrototypeOf$1=_core.Object.getPrototypeOf,getPrototypeOf=createCommonjsModule(function(e){e.exports={"default":getPrototypeOf$1,__esModule:!0}}),_Object$getPrototypeOf=unwrapExports(getPrototypeOf),classCallCheck=createCommonjsModule(function(e,t){t.__esModule=!0,t["default"]=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}}),_classCallCheck=unwrapExports(classCallCheck),ceil=Math.ceil,floor=Math.floor,_toInteger=function(e){return isNaN(e=+e)?0:(e>0?floor:ceil)(e)},_stringAt=function(e){return function(t,r){var n,i,o=String(_defined(t)),a=_toInteger(r),s=o.length;return a<0||a>=s?e?"":undefined:(n=o.charCodeAt(a),n<55296||n>56319||a+1===s||(i=o.charCodeAt(a+1))<56320||i>57343?e?o.charAt(a):n:e?o.slice(a,a+2):i-56320+(n-55296<<10)+65536)}},_library=!0,_redefine=_hide,_iterators={},toString={}.toString,_cof=function(e){return toString.call(e).slice(8,-1)},_iobject=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==_cof(e)?e.split(""):Object(e)},_toIobject=function(e){return _iobject(_defined(e))},min=Math.min,_toLength=function(e){return e>0?min(_toInteger(e),9007199254740991):0},max=Math.max,min$1=Math.min,_toAbsoluteIndex=function(e,t){return e=_toInteger(e),e<0?max(e+t,0):min$1(e,t)},_arrayIncludes=function(e){return function(t,r,n){var i,o=_toIobject(t),a=_toLength(o.length),s=_toAbsoluteIndex(n,a);if(e&&r!=r){for(;a>s;)if((i=o[s++])!=i)return!0}else for(;a>s;s++)if((e||s in o)&&o[s]===r)return e||s||0;return!e&&-1}},arrayIndexOf=_arrayIncludes(!1),IE_PROTO$2=_sharedKey("IE_PROTO"),_objectKeysInternal=function(e,t){var r,n=_toIobject(e),i=0,o=[];for(r in n)r!=IE_PROTO$2&&_has(n,r)&&o.push(r);for(;t.length>i;)_has(n,r=t[i++])&&(~arrayIndexOf(o,r)||o.push(r));return o},_enumBugKeys="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),_objectKeys=Object.keys||function(e){return _objectKeysInternal(e,_enumBugKeys)},_objectDps=_descriptors?Object.defineProperties:function(e,t){_anObject(e);for(var r,n=_objectKeys(t),i=n.length,o=0;i>o;)_objectDp.f(e,r=n[o++],t[r]);return e},document$2=_global.document,_html=document$2&&document$2.documentElement,IE_PROTO$1=_sharedKey("IE_PROTO"),Empty=function(){},PROTOTYPE$1="prototype",createDict=function(){var e,t=_domCreate("iframe"),r=_enumBugKeys.length;for(t.style.display="none",_html.appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),createDict=e.F;r--;)delete createDict[PROTOTYPE$1][_enumBugKeys[r]];return createDict()},_objectCreate=Object.create||function(e,t){var r;return null!==e?(Empty[PROTOTYPE$1]=_anObject(e),r=new Empty,Empty[PROTOTYPE$1]=null,r[IE_PROTO$1]=e):r=createDict(),t===undefined?r:_objectDps(r,t)},_wks=createCommonjsModule(function(e){var t=_shared("wks"),r=_global.Symbol,n="function"==typeof r;(e.exports=function(e){return t[e]||(t[e]=n&&r[e]||(n?r:_uid)("Symbol."+e))}).store=t}),def=_objectDp.f,TAG=_wks("toStringTag"),_setToStringTag=function(e,t,r){e&&!_has(e=r?e:e.prototype,TAG)&&def(e,TAG,{configurable:!0,value:t})},IteratorPrototype={};_hide(IteratorPrototype,_wks("iterator"),function(){return this});var _iterCreate=function(e,t,r){e.prototype=_objectCreate(IteratorPrototype,{next:_propertyDesc(1,r)}),_setToStringTag(e,t+" Iterator")},ITERATOR=_wks("iterator"),BUGGY=!([].keys&&"next"in[].keys()),FF_ITERATOR="@@iterator",KEYS="keys",VALUES="values",returnThis=function(){return this},_iterDefine=function(e,t,r,n,i,o,a){_iterCreate(r,t,n);var s,u,c,l=function(e){if(!BUGGY&&e in p)return p[e];switch(e){case KEYS:case VALUES:return function(){return new r(this,e)}}return function(){return new r(this,e)}},f=t+" Iterator",d=i==VALUES,h=!1,p=e.prototype,y=p[ITERATOR]||p[FF_ITERATOR]||i&&p[i],g=y||l(i),m=i?d?l("entries"):g:undefined,_="Array"==t?p.entries||y:y;if(_&&(c=_objectGpo(_.call(new e)))!==Object.prototype&&c.next&&(_setToStringTag(c,f,!0),_library||_has(c,ITERATOR)||_hide(c,ITERATOR,returnThis)),d&&y&&y.name!==VALUES&&(h=!0,g=function(){return y.call(this)}),_library&&!a||!BUGGY&&!h&&p[ITERATOR]||_hide(p,ITERATOR,g),
_iterators[t]=g,_iterators[f]=returnThis,i)if(s={values:d?g:l(VALUES),keys:o?g:l(KEYS),entries:m},a)for(u in s)u in p||_redefine(p,u,s[u]);else _export(_export.P+_export.F*(BUGGY||h),t,s);return s},$at=_stringAt(!0);_iterDefine(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:undefined,done:!0}:(e=$at(t,r),this._i+=e.length,{value:e,done:!1})});var _iterStep=function(e,t){return{value:t,done:!!e}},es6_array_iterator=_iterDefine(Array,"Array",function(e,t){this._t=_toIobject(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,r=this._i++;return!e||r>=e.length?(this._t=undefined,_iterStep(1)):"keys"==t?_iterStep(0,r):"values"==t?_iterStep(0,e[r]):_iterStep(0,[r,e[r]])},"values");_iterators.Arguments=_iterators.Array;for(var TO_STRING_TAG=_wks("toStringTag"),DOMIterables="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),i=0;i<DOMIterables.length;i++){var NAME=DOMIterables[i],Collection=_global[NAME],proto=Collection&&Collection.prototype;proto&&!proto[TO_STRING_TAG]&&_hide(proto,TO_STRING_TAG,NAME),_iterators[NAME]=_iterators.Array}var f$1=_wks,_wksExt={f:f$1},iterator$2=_wksExt.f("iterator"),iterator=createCommonjsModule(function(e){e.exports={"default":iterator$2,__esModule:!0}});unwrapExports(iterator);var _meta=createCommonjsModule(function(e){var t=_uid("meta"),r=_objectDp.f,n=0,i=Object.isExtensible||function(){return!0},o=!_fails(function(){return i(Object.preventExtensions({}))}),a=function(e){r(e,t,{value:{i:"O"+ ++n,w:{}}})},s=function(e,r){if(!_isObject(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!_has(e,t)){if(!i(e))return"F";if(!r)return"E";a(e)}return e[t].i},u=function(e,r){if(!_has(e,t)){if(!i(e))return!0;if(!r)return!1;a(e)}return e[t].w},c=function(e){return o&&l.NEED&&i(e)&&!_has(e,t)&&a(e),e},l=e.exports={KEY:t,NEED:!1,fastKey:s,getWeak:u,onFreeze:c}}),_meta_1=_meta.KEY,_meta_2=_meta.NEED,_meta_3=_meta.fastKey,_meta_4=_meta.getWeak,_meta_5=_meta.onFreeze,defineProperty=_objectDp.f,_wksDefine=function(e){var t=_core.Symbol||(_core.Symbol=_library?{}:_global.Symbol||{});"_"==e.charAt(0)||e in t||defineProperty(t,e,{value:_wksExt.f(e)})},f$2=Object.getOwnPropertySymbols,_objectGops={f:f$2},f$3={}.propertyIsEnumerable,_objectPie={f:f$3},_enumKeys=function(e){var t=_objectKeys(e),r=_objectGops.f;if(r)for(var n,i=r(e),o=_objectPie.f,a=0;i.length>a;)o.call(e,n=i[a++])&&t.push(n);return t},_isArray=Array.isArray||function(e){return"Array"==_cof(e)},hiddenKeys=_enumBugKeys.concat("length","prototype"),f$5=Object.getOwnPropertyNames||function(e){return _objectKeysInternal(e,hiddenKeys)},_objectGopn={f:f$5},gOPN$1=_objectGopn.f,toString$1={}.toString,windowNames="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],getWindowNames=function(e){try{return gOPN$1(e)}catch(t){return windowNames.slice()}},f$4=function(e){return windowNames&&"[object Window]"==toString$1.call(e)?getWindowNames(e):gOPN$1(_toIobject(e))},_objectGopnExt={f:f$4},gOPD$1=Object.getOwnPropertyDescriptor,f$6=_descriptors?gOPD$1:function(e,t){if(e=_toIobject(e),t=_toPrimitive(t,!0),_ie8DomDefine)try{return gOPD$1(e,t)}catch(r){}if(_has(e,t))return _propertyDesc(!_objectPie.f.call(e,t),e[t])},_objectGopd={f:f$6},META=_meta.KEY,gOPD=_objectGopd.f,dP$1=_objectDp.f,gOPN=_objectGopnExt.f,$Symbol=_global.Symbol,$JSON=_global.JSON,_stringify=$JSON&&$JSON.stringify,PROTOTYPE$2="prototype",HIDDEN=_wks("_hidden"),TO_PRIMITIVE=_wks("toPrimitive"),isEnum={}.propertyIsEnumerable,SymbolRegistry=_shared("symbol-registry"),AllSymbols=_shared("symbols"),OPSymbols=_shared("op-symbols"),ObjectProto$1=Object[PROTOTYPE$2],USE_NATIVE="function"==typeof $Symbol,QObject=_global.QObject,setter=!QObject||!QObject[PROTOTYPE$2]||!QObject[PROTOTYPE$2].findChild,setSymbolDesc=_descriptors&&_fails(function(){return 7!=_objectCreate(dP$1({},"a",{get:function(){return dP$1(this,"a",{value:7}).a}})).a})?function(e,t,r){var n=gOPD(ObjectProto$1,t);n&&delete ObjectProto$1[t],dP$1(e,t,r),n&&e!==ObjectProto$1&&dP$1(ObjectProto$1,t,n)}:dP$1,wrap=function(e){var t=AllSymbols[e]=_objectCreate($Symbol[PROTOTYPE$2]);return t._k=e,t},isSymbol=USE_NATIVE&&"symbol"==typeof $Symbol.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof $Symbol},$defineProperty=function(e,t,r){return e===ObjectProto$1&&$defineProperty(OPSymbols,t,r),_anObject(e),t=_toPrimitive(t,!0),_anObject(r),_has(AllSymbols,t)?(r.enumerable?(_has(e,HIDDEN)&&e[HIDDEN][t]&&(e[HIDDEN][t]=!1),r=_objectCreate(r,{enumerable:_propertyDesc(0,!1)})):(_has(e,HIDDEN)||dP$1(e,HIDDEN,_propertyDesc(1,{})),e[HIDDEN][t]=!0),setSymbolDesc(e,t,r)):dP$1(e,t,r)},$defineProperties=function(e,t){_anObject(e);for(var r,n=_enumKeys(t=_toIobject(t)),i=0,o=n.length;o>i;)$defineProperty(e,r=n[i++],t[r]);return e},$create=function(e,t){return t===undefined?_objectCreate(e):$defineProperties(_objectCreate(e),t)},$propertyIsEnumerable=function(e){var t=isEnum.call(this,e=_toPrimitive(e,!0));return!(this===ObjectProto$1&&_has(AllSymbols,e)&&!_has(OPSymbols,e))&&(!(t||!_has(this,e)||!_has(AllSymbols,e)||_has(this,HIDDEN)&&this[HIDDEN][e])||t)},$getOwnPropertyDescriptor=function(e,t){if(e=_toIobject(e),t=_toPrimitive(t,!0),e!==ObjectProto$1||!_has(AllSymbols,t)||_has(OPSymbols,t)){var r=gOPD(e,t);return!r||!_has(AllSymbols,t)||_has(e,HIDDEN)&&e[HIDDEN][t]||(r.enumerable=!0),r}},$getOwnPropertyNames=function(e){for(var t,r=gOPN(_toIobject(e)),n=[],i=0;r.length>i;)_has(AllSymbols,t=r[i++])||t==HIDDEN||t==META||n.push(t);return n},$getOwnPropertySymbols=function(e){for(var t,r=e===ObjectProto$1,n=gOPN(r?OPSymbols:_toIobject(e)),i=[],o=0;n.length>o;)!_has(AllSymbols,t=n[o++])||r&&!_has(ObjectProto$1,t)||i.push(AllSymbols[t]);return i};USE_NATIVE||($Symbol=function(){if(this instanceof $Symbol)throw TypeError("Symbol is not a constructor!");var e=_uid(arguments.length>0?arguments[0]:undefined),t=function(r){this===ObjectProto$1&&t.call(OPSymbols,r),_has(this,HIDDEN)&&_has(this[HIDDEN],e)&&(this[HIDDEN][e]=!1),setSymbolDesc(this,e,_propertyDesc(1,r))};return _descriptors&&setter&&setSymbolDesc(ObjectProto$1,e,{configurable:!0,set:t}),wrap(e)},_redefine($Symbol[PROTOTYPE$2],"toString",function(){return this._k}),_objectGopd.f=$getOwnPropertyDescriptor,_objectDp.f=$defineProperty,_objectGopn.f=_objectGopnExt.f=$getOwnPropertyNames,_objectPie.f=$propertyIsEnumerable,_objectGops.f=$getOwnPropertySymbols,_descriptors&&!_library&&_redefine(ObjectProto$1,"propertyIsEnumerable",$propertyIsEnumerable,!0),_wksExt.f=function(e){return wrap(_wks(e))}),_export(_export.G+_export.W+_export.F*!USE_NATIVE,{Symbol:$Symbol});for(var es6Symbols="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),j=0;es6Symbols.length>j;)_wks(es6Symbols[j++]);for(var wellKnownSymbols=_objectKeys(_wks.store),k=0;wellKnownSymbols.length>k;)_wksDefine(wellKnownSymbols[k++]);_export(_export.S+_export.F*!USE_NATIVE,"Symbol",{"for":function(e){return _has(SymbolRegistry,e+="")?SymbolRegistry[e]:SymbolRegistry[e]=$Symbol(e)},keyFor:function(e){if(!isSymbol(e))throw TypeError(e+" is not a symbol!");for(var t in SymbolRegistry)if(SymbolRegistry[t]===e)return t},useSetter:function(){setter=!0},useSimple:function(){setter=!1}}),_export(_export.S+_export.F*!USE_NATIVE,"Object",{create:$create,defineProperty:$defineProperty,defineProperties:$defineProperties,getOwnPropertyDescriptor:$getOwnPropertyDescriptor,getOwnPropertyNames:$getOwnPropertyNames,getOwnPropertySymbols:$getOwnPropertySymbols}),$JSON&&_export(_export.S+_export.F*(!USE_NATIVE||_fails(function(){var e=$Symbol();return"[null]"!=_stringify([e])||"{}"!=_stringify({a:e})||"{}"!=_stringify(Object(e))})),"JSON",{stringify:function(e){if(e!==undefined&&!isSymbol(e)){for(var t,r,n=[e],i=1;arguments.length>i;)n.push(arguments[i++]);return t=n[1],"function"==typeof t&&(r=t),!r&&_isArray(t)||(t=function(e,t){if(r&&(t=r.call(this,e,t)),!isSymbol(t))return t}),n[1]=t,_stringify.apply($JSON,n)}}}),$Symbol[PROTOTYPE$2][TO_PRIMITIVE]||_hide($Symbol[PROTOTYPE$2],TO_PRIMITIVE,$Symbol[PROTOTYPE$2].valueOf),_setToStringTag($Symbol,"Symbol"),_setToStringTag(Math,"Math",!0),_setToStringTag(_global.JSON,"JSON",!0),_wksDefine("asyncIterator"),_wksDefine("observable");var symbol$2=_core.Symbol,symbol=createCommonjsModule(function(e){e.exports={"default":symbol$2,__esModule:!0}});unwrapExports(symbol);var _typeof_1=createCommonjsModule(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(iterator),i=r(symbol),o="function"==typeof i["default"]&&"symbol"==typeof n["default"]?function(e){return typeof e}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":typeof e};t["default"]="function"==typeof i["default"]&&"symbol"===o(n["default"])?function(e){return void 0===e?"undefined":o(e)}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":void 0===e?"undefined":o(e)}}),_typeof=unwrapExports(_typeof_1),possibleConstructorReturn=createCommonjsModule(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(_typeof_1);t["default"]=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==(void 0===t?"undefined":(0,r["default"])(t))&&"function"!=typeof t?e:t}}),_possibleConstructorReturn=unwrapExports(possibleConstructorReturn),check=function(e,t){if(_anObject(e),!_isObject(t)&&null!==t)throw TypeError(t+": can't set as prototype!")},_setProto={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=_ctx(Function.call,_objectGopd.f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(n){t=!0}return function(e,n){return check(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):undefined),check:check};_export(_export.S,"Object",{setPrototypeOf:_setProto.set});var setPrototypeOf$2=_core.Object.setPrototypeOf,setPrototypeOf=createCommonjsModule(function(e){e.exports={"default":setPrototypeOf$2,__esModule:!0}});unwrapExports(setPrototypeOf),_export(_export.S,"Object",{create:_objectCreate});var $Object=_core.Object,create$2=function(e,t){return $Object.create(e,t)},create$1=createCommonjsModule(function(e){e.exports={"default":create$2,__esModule:!0}}),_Object$create=unwrapExports(create$1),inherits=createCommonjsModule(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(setPrototypeOf),i=r(create$1),o=r(_typeof_1);t["default"]=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+(void 0===t?"undefined":(0,o["default"])(t)));e.prototype=(0,i["default"])(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(n["default"]?(0,n["default"])(e,t):e.__proto__=t)}}),_inherits=unwrapExports(inherits);_export(_export.S+_export.F*!_descriptors,"Object",{defineProperty:_objectDp.f});var $Object$1=_core.Object,defineProperty$2=function(e,t,r){return $Object$1.defineProperty(e,t,r)},defineProperty$1=createCommonjsModule(function(e){e.exports={"default":defineProperty$2,__esModule:!0}}),_Object$defineProperty=unwrapExports(defineProperty$1),$getOwnPropertyDescriptor$1=_objectGopd.f;_objectSap("getOwnPropertyDescriptor",function(){return function(e,t){return $getOwnPropertyDescriptor$1(_toIobject(e),t)}});var $Object$2=_core.Object,getOwnPropertyDescriptor$1=function(e,t){return $Object$2.getOwnPropertyDescriptor(e,t)},getOwnPropertyDescriptor=createCommonjsModule(function(e){e.exports={"default":getOwnPropertyDescriptor$1,__esModule:!0}}),_Object$getOwnPropertyDescriptor=unwrapExports(getOwnPropertyDescriptor),createClass=createCommonjsModule(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(defineProperty$1);t["default"]=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),(0,r["default"])(e,i.key,i)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()}),_createClass=unwrapExports(createClass),get=createCommonjsModule(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(getPrototypeOf),i=r(getOwnPropertyDescriptor);t["default"]=function o(e,t,r){null===e&&(e=Function.prototype);var a=(0,i["default"])(e,t);if(a===undefined){var s=(0,n["default"])(e);return null===s?undefined:o(s,t,r)}if("value"in a)return a.value;var u=a.get;return u===undefined?undefined:u.call(r)}}),_get=unwrapExports(get),TAG$1=_wks("toStringTag"),ARG="Arguments"==_cof(function(){return arguments}()),tryGet=function(e,t){try{return e[t]}catch(r){}},_classof=function(e){var t,r,n;return e===undefined?"Undefined":null===e?"Null":"string"==typeof(r=tryGet(t=Object(e),TAG$1))?r:ARG?_cof(t):"Object"==(n=_cof(t))&&"function"==typeof t.callee?"Arguments":n},ITERATOR$1=_wks("iterator"),core_isIterable=_core.isIterable=function(e){var t=Object(e);return t[ITERATOR$1]!==undefined||"@@iterator"in t||_iterators.hasOwnProperty(_classof(t))},isIterable$2=core_isIterable,isIterable=createCommonjsModule(function(e){e.exports={"default":isIterable$2,__esModule:!0}});unwrapExports(isIterable);var ITERATOR$2=_wks("iterator"),core_getIteratorMethod=_core.getIteratorMethod=function(e){if(e!=undefined)return e[ITERATOR$2]||e["@@iterator"]||_iterators[_classof(e)]},core_getIterator=_core.getIterator=function(e){var t=core_getIteratorMethod(e);if("function"!=typeof t)throw TypeError(e+" is not iterable!");return _anObject(t.call(e))},getIterator$2=core_getIterator,getIterator=createCommonjsModule(function(e){e.exports={"default":getIterator$2,__esModule:!0}});unwrapExports(getIterator);var slicedToArray=createCommonjsModule(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(isIterable),i=r(getIterator);t["default"]=function(){function e(e,t){var r=[],n=!0,o=!1,a=undefined;try{for(var s,u=(0,i["default"])(e);!(n=(s=u.next()).done)&&(r.push(s.value),!t||r.length!==t);n=!0);}catch(c){o=!0,a=c}finally{try{!n&&u["return"]&&u["return"]()}finally{if(o)throw a}}return r}return function(t,r){if(Array.isArray(t))return t;if((0,n["default"])(Object(t)))return e(t,r);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}()}),_slicedToArray=unwrapExports(slicedToArray),isEnum$1=_objectPie.f,_objectToArray=function(e){return function(t){for(var r,n=_toIobject(t),i=_objectKeys(n),o=i.length,a=0,s=[];o>a;)isEnum$1.call(n,r=i[a++])&&s.push(e?[r,n[r]]:n[r]);return s}},$entries=_objectToArray(!0);_export(_export.S,"Object",{entries:function(e){return $entries(e)}});var entries$1=_core.Object.entries,entries=createCommonjsModule(function(e){e.exports={"default":entries$1,__esModule:!0}}),_Object$entries=unwrapExports(entries),_iterCall=function(e,t,r,n){try{return n?t(_anObject(r)[0],r[1]):t(r)}catch(o){var i=e["return"];throw i!==undefined&&_anObject(i.call(e)),o}},ITERATOR$3=_wks("iterator"),ArrayProto=Array.prototype,_isArrayIter=function(e){return e!==undefined&&(_iterators.Array===e||ArrayProto[ITERATOR$3]===e)},_createProperty=function(e,t,r){t in e?_objectDp.f(e,t,_propertyDesc(0,r)):e[t]=r},ITERATOR$4=_wks("iterator"),SAFE_CLOSING=!1;try{var riter=[7][ITERATOR$4]();riter["return"]=function(){SAFE_CLOSING=!0}}catch(e){}var _iterDetect=function(e,t){if(!t&&!SAFE_CLOSING)return!1;var r=!1;try{var n=[7],i=n[ITERATOR$4]();i.next=function(){return{done:r=!0}},n[ITERATOR$4]=function(){return i},e(n)}catch(e){}return r};_export(_export.S+_export.F*!_iterDetect(function(e){}),"Array",{from:function(e){var t,r,n,i,o=_toObject(e),a="function"==typeof this?this:Array,s=arguments.length,u=s>1?arguments[1]:undefined,c=u!==undefined,l=0,f=core_getIteratorMethod(o);if(c&&(u=_ctx(u,s>2?arguments[2]:undefined,2)),f==undefined||a==Array&&_isArrayIter(f))for(t=_toLength(o.length),r=new a(t);t>l;l++)_createProperty(r,l,c?u(o[l],l):o[l]);else for(i=f.call(o),r=new a;!(n=i.next()).done;l++)_createProperty(r,l,c?_iterCall(i,u,[n.value,l],!0):n.value);return r.length=l,r}});var from$1=_core.Array.from,from=createCommonjsModule(function(e){e.exports={"default":from$1,__esModule:!0}}),_Array$from=unwrapExports(from),toConsumableArray=createCommonjsModule(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(from);t["default"]=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return(0,r["default"])(e)}}),_toConsumableArray=unwrapExports(toConsumableArray),$assign=Object.assign,_objectAssign=!$assign||_fails(function(){var e={},t={},r=Symbol(),n="abcdefghijklmnopqrst";return e[r]=7,n.split("").forEach(function(e){t[e]=e}),7!=$assign({},e)[r]||Object.keys($assign({},t)).join("")!=n})?function(e,t){for(var r=_toObject(e),n=arguments.length,i=1,o=_objectGops.f,a=_objectPie.f;n>i;)for(var s,u=_iobject(arguments[i++]),c=o?_objectKeys(u).concat(o(u)):_objectKeys(u),l=c.length,f=0;l>f;)a.call(u,s=c[f++])&&(r[s]=u[s]);return r}:$assign;_export(_export.S+_export.F,"Object",{assign:_objectAssign});var assign$1=_core.Object.assign,assign=createCommonjsModule(function(e){e.exports={"default":assign$1,__esModule:!0}}),_Object$assign=unwrapExports(assign),_anInstance=function(e,t,r,n){if(!(e instanceof t)||n!==undefined&&n in e)throw TypeError(r+": incorrect invocation!");return e},_forOf=createCommonjsModule(function(e){var t={},r={},n=e.exports=function(e,n,i,o,a){var s,u,c,l,f=a?function(){return e}:core_getIteratorMethod(e),d=_ctx(i,o,n?2:1),h=0;if("function"!=typeof f)throw TypeError(e+" is not iterable!");if(_isArrayIter(f)){for(s=_toLength(e.length);s>h;h++)if((l=n?d(_anObject(u=e[h])[0],u[1]):d(e[h]))===t||l===r)return l}else for(c=f.call(e);!(u=c.next()).done;)if((l=_iterCall(c,d,u.value,n))===t||l===r)return l};n.BREAK=t,n.RETURN=r}),SPECIES=_wks("species"),_speciesConstructor=function(e,t){var r,n=_anObject(e).constructor;return n===undefined||(r=_anObject(n)[SPECIES])==undefined?t:_aFunction(r)},_invoke=function(e,t,r){var n=r===undefined;switch(t.length){case 0:return n?e():e.call(r);case 1:return n?e(t[0]):e.call(r,t[0]);case 2:return n?e(t[0],t[1]):e.call(r,t[0],t[1]);case 3:return n?e(t[0],t[1],t[2]):e.call(r,t[0],t[1],t[2]);case 4:return n?e(t[0],t[1],t[2],t[3]):e.call(r,t[0],t[1],t[2],t[3])}return e.apply(r,t)},process$1=_global.process,setTask=_global.setImmediate,clearTask=_global.clearImmediate,MessageChannel=_global.MessageChannel,Dispatch=_global.Dispatch,counter=0,queue={},ONREADYSTATECHANGE="onreadystatechange",defer,channel,port,run=function(){var e=+this;if(queue.hasOwnProperty(e)){var t=queue[e];delete queue[e],t()}},listener=function(e){run.call(e.data)};setTask&&clearTask||(setTask=function(e){for(var t=[],r=1;arguments.length>r;)t.push(arguments[r++]);return queue[++counter]=function(){_invoke("function"==typeof e?e:Function(e),t)},defer(counter),counter},clearTask=function(e){delete queue[e]},"process"==_cof(process$1)?defer=function(e){process$1.nextTick(_ctx(run,e,1))}:Dispatch&&Dispatch.now?defer=function(e){Dispatch.now(_ctx(run,e,1))}:MessageChannel?(channel=new MessageChannel,port=channel.port2,channel.port1.onmessage=listener,defer=_ctx(port.postMessage,port,1)):_global.addEventListener&&"function"==typeof postMessage&&!_global.importScripts?(defer=function(e){_global.postMessage(e+"","*")},_global.addEventListener("message",listener,!1)):defer=ONREADYSTATECHANGE in _domCreate("script")?function(e){_html.appendChild(_domCreate("script"))[ONREADYSTATECHANGE]=function(){_html.removeChild(this),run.call(e)}}:function(e){setTimeout(_ctx(run,e,1),0)});var _task={set:setTask,clear:clearTask},macrotask=_task.set,Observer=_global.MutationObserver||_global.WebKitMutationObserver,process$2=_global.process,Promise$1=_global.Promise,isNode$1="process"==_cof(process$2),_microtask=function(){var t,r,n,i=function(){var i,o;for(isNode$1&&(i=process$2.domain)&&i.exit();t;){o=t.fn,t=t.next;try{o()}catch(e){throw t?n():r=undefined,e}}r=undefined,i&&i.enter()};if(isNode$1)n=function(){process$2.nextTick(i)};else if(Observer){var o=!0,a=document.createTextNode("");new Observer(i).observe(a,{characterData:!0}),n=function(){a.data=o=!o}}else if(Promise$1&&Promise$1.resolve){var s=Promise$1.resolve();n=function(){s.then(i)}}else n=function(){macrotask.call(_global,i)};return function(e){var i={fn:e,next:undefined};r&&(r.next=i),t||(t=i,n()),r=i}},f$7=function(e){return new PromiseCapability(e)},_newPromiseCapability={f:f$7},_perform=function(t){try{return{e:!1,v:t()}}catch(e){return{e:!0,v:e}}},_promiseResolve=function(e,t){if(_anObject(e),_isObject(t)&&t.constructor===e)return t;var r=_newPromiseCapability.f(e);return(0,r.resolve)(t),r.promise},_redefineAll=function(e,t,r){for(var n in t)r&&e[n]?e[n]=t[n]:_hide(e,n,t[n]);return e},SPECIES$1=_wks("species"),_setSpecies=function(e){var t="function"==typeof _core[e]?_core[e]:_global[e];_descriptors&&t&&!t[SPECIES$1]&&_objectDp.f(t,SPECIES$1,{configurable:!0,get:function(){return this}})},task=_task.set,microtask=_microtask(),PROMISE="Promise",TypeError$1=_global.TypeError,process=_global.process,$Promise=_global[PROMISE],isNode="process"==_classof(process),empty=function(){},Internal,newGenericPromiseCapability,OwnPromiseCapability,Wrapper,newPromiseCapability=newGenericPromiseCapability=_newPromiseCapability.f,USE_NATIVE$1=!!function(){try{var e=$Promise.resolve(1),t=(e.constructor={})[_wks("species")]=function(e){e(empty,empty)};return(isNode||"function"==typeof PromiseRejectionEvent)&&e.then(empty)instanceof t}catch(e){}}(),isThenable=function(e){var t;return!(!_isObject(e)||"function"!=typeof(t=e.then))&&t},notify=function(t,r){if(!t._n){t._n=!0;var n=t._c;microtask(function(){for(var i=t._v,o=1==t._s,a=0;n.length>a;)!function(r){var n,a,s=o?r.ok:r.fail,u=r.resolve,c=r.reject,l=r.domain;try{s?(o||(2==t._h&&onHandleUnhandled(t),t._h=1),!0===s?n=i:(l&&l.enter(),n=s(i),l&&l.exit()),n===r.promise?c(TypeError$1("Promise-chain cycle")):(a=isThenable(n))?a.call(n,u,c):u(n)):c(i)}catch(e){c(e)}}(n[a++]);t._c=[],t._n=!1,r&&!t._h&&onUnhandled(t)})}},onUnhandled=function(e){task.call(_global,function(){var t,r,n,i=e._v,o=isUnhandled(e);if(o&&(t=_perform(function(){isNode?process.emit("unhandledRejection",i,e):(r=_global.onunhandledrejection)?r({promise:e,reason:i}):(n=_global.console)&&n.error&&n.error("Unhandled promise rejection",i)}),e._h=isNode||isUnhandled(e)?2:1),e._a=undefined,o&&t.e)throw t.v})},isUnhandled=function(e){if(1==e._h)return!1;for(var t,r=e._a||e._c,n=0;r.length>n;)if(t=r[n++],t.fail||!isUnhandled(t.promise))return!1;return!0},onHandleUnhandled=function(e){task.call(_global,function(){var t;isNode?process.emit("rejectionHandled",e):(t=_global.onrejectionhandled)&&t({promise:e,reason:e._v})})},$reject=function(e){var t=this;t._d||(t._d=!0,t=t._w||t,t._v=e,t._s=2,t._a||(t._a=t._c.slice()),notify(t,!0))},$resolve=function(t){var r,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw TypeError$1("Promise can't be resolved itself");(r=isThenable(t))?microtask(function(){var i={_w:n,_d:!1};try{r.call(t,_ctx($resolve,i,1),_ctx($reject,i,1))}catch(e){$reject.call(i,e)}}):(n._v=t,n._s=1,notify(n,!1))}catch(e){$reject.call({_w:n,_d:!1},e)}}};USE_NATIVE$1||($Promise=function(e){_anInstance(this,$Promise,PROMISE,"_h"),_aFunction(e),Internal.call(this);try{e(_ctx($resolve,this,1),_ctx($reject,this,1))}catch(t){$reject.call(this,t)}},Internal=function(e){this._c=[],this._a=undefined,this._s=0,this._d=!1,this._v=undefined,this._h=0,this._n=!1},Internal.prototype=_redefineAll($Promise.prototype,{then:function(e,t){var r=newPromiseCapability(_speciesConstructor(this,$Promise));return r.ok="function"!=typeof e||e,r.fail="function"==typeof t&&t,r.domain=isNode?process.domain:undefined,this._c.push(r),this._a&&this._a.push(r),this._s&&notify(this,!1),r.promise},"catch":function(e){return this.then(undefined,e)}}),OwnPromiseCapability=function(){var e=new Internal;this.promise=e,this.resolve=_ctx($resolve,e,1),this.reject=_ctx($reject,e,1)},_newPromiseCapability.f=newPromiseCapability=function(e){return e===$Promise||e===Wrapper?new OwnPromiseCapability(e):newGenericPromiseCapability(e)}),_export(_export.G+_export.W+_export.F*!USE_NATIVE$1,{Promise:$Promise}),_setToStringTag($Promise,PROMISE),_setSpecies(PROMISE),Wrapper=_core[PROMISE],_export(_export.S+_export.F*!USE_NATIVE$1,PROMISE,{reject:function(e){var t=newPromiseCapability(this);return(0,t.reject)(e),t.promise}}),_export(_export.S+_export.F*(_library||!USE_NATIVE$1),PROMISE,{resolve:function(e){return _promiseResolve(_library&&this===Wrapper?$Promise:this,e)}}),_export(_export.S+_export.F*!(USE_NATIVE$1&&_iterDetect(function(e){$Promise.all(e)["catch"](empty)})),PROMISE,{all:function(e){var t=this,r=newPromiseCapability(t),n=r.resolve,i=r.reject,o=_perform(function(){var r=[],o=0,a=1;_forOf(e,!1,function(e){var s=o++,u=!1;r.push(undefined),a++,t.resolve(e).then(function(e){u||(u=!0,r[s]=e,--a||n(r))},i)}),--a||n(r)});return o.e&&i(o.v),r.promise},race:function(e){var t=this,r=newPromiseCapability(t),n=r.reject,i=_perform(function(){_forOf(e,!1,function(e){t.resolve(e).then(r.resolve,n)})});return i.e&&n(i.v),r.promise}}),_export(_export.P+_export.R,"Promise",{"finally":function(e){var t=_speciesConstructor(this,_core.Promise||_global.Promise),r="function"==typeof e;return this.then(r?function(r){return _promiseResolve(t,e()).then(function(){return r})}:e,r?function(r){return _promiseResolve(t,e()).then(function(){throw r})}:e)}}),_export(_export.S,"Promise",{"try":function(e){var t=_newPromiseCapability.f(this),r=_perform(e);return(r.e?t.reject:t.resolve)(r.v),t.promise}});var promise$1=_core.Promise,promise=createCommonjsModule(function(e){e.exports={"default":promise$1,__esModule:!0}}),_Promise=unwrapExports(promise);_objectSap("keys",function(){return function(e){return _objectKeys(_toObject(e))}});var keys$1=_core.Object.keys,keys=createCommonjsModule(function(e){e.exports={"default":keys$1,__esModule:!0}}),_Object$keys=unwrapExports(keys),floor$1=Math.floor,_isInteger=function(e){return!_isObject(e)&&isFinite(e)&&floor$1(e)===e};_export(_export.S,"Number",{isInteger:_isInteger});var isInteger$2=_core.Number.isInteger,isInteger$1=createCommonjsModule(function(e){e.exports={"default":isInteger$2,__esModule:!0}}),_Number$isInteger=unwrapExports(isInteger$1),_stringWs="\t\n\x0B\f\r \xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff",space="["+_stringWs+"]",non="\u200b\x85",ltrim=RegExp("^"+space+space+"*"),rtrim=RegExp(space+space+"*$"),exporter=function(e,t,r){var n={},i=_fails(function(){return!!_stringWs[e]()||non[e]()!=non}),o=n[e]=i?t(trim):_stringWs[e];r&&(n[r]=o),_export(_export.P+_export.F*i,"String",n)},trim=exporter.trim=function(e,t){return e=String(_defined(e)),1&t&&(e=e.replace(ltrim,"")),2&t&&(e=e.replace(rtrim,"")),e},_stringTrim=exporter,$parseFloat=_global.parseFloat,$trim=_stringTrim.trim,_parseFloat$3=1/$parseFloat(_stringWs+"-0")!=-Infinity?function(e){var t=$trim(String(e),3),r=$parseFloat(t);return 0===r&&"-"==t.charAt(0)?-0:r}:$parseFloat;_export(_export.S+_export.F*(Number.parseFloat!=_parseFloat$3),"Number",{parseFloat:_parseFloat$3});var _parseFloat$1=parseFloat,_parseFloat=createCommonjsModule(function(e){e.exports={"default":_parseFloat$1,__esModule:!0}}),_Number$parseFloat=unwrapExports(_parseFloat),Log$1=function(){function e(){_classCallCheck(this,e)}return _createClass(e,null,[{key:"error",value:function(t,r){e.ENABLE_ERROR&&(console.error||console.warn||console.log)(formatter(t,r))}},{key:"info",value:function(t,r){e.ENABLE_INFO&&(console.info||console.log)(formatter(t,r))}},{key:"warn",value:function(t,r){e.ENABLE_WARN&&(console.warn||console.log)(formatter(t,r))}},{key:"debug",value:function(t,r){e.ENABLE_DEBUG&&(console.debug||console.log)(formatter(t,r))}},{key:"verbose",value:function(t,r){e.ENABLE_VERBOSE&&console.log(formatter(t,r))}}]),e}();Log$1.GLOBAL_TAG="chimee",Log$1.FORCE_GLOBAL_TAG=!1,Log$1.ENABLE_ERROR=!0,Log$1.ENABLE_INFO=!0,Log$1.ENABLE_WARN=!0,Log$1.ENABLE_DEBUG=!0,Log$1.ENABLE_VERBOSE=!0;var uaParser=createCommonjsModule(function(e,t){!function(r,n){var i="model",o="name",a="type",s="vendor",u="version",c="mobile",l="tablet",f={extend:function(e,t){var r={};for(var n in e)t[n]&&t[n].length%2==0?r[n]=t[n].concat(e[n]):r[n]=e[n];return r},has:function(e,t){return"string"==typeof e&&-1!==t.toLowerCase().indexOf(e.toLowerCase())},lowerize:function(e){return e.toLowerCase()},major:function(e){return"string"==typeof e?e.replace(/[^\d\.]/g,"").split(".")[0]:n},trim:function(e){return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}},d={rgx:function(e,t){for(var r,i,o,a,s,u,c=0;c<t.length&&!s;){var l=t[c],f=t[c+1];for(r=i=0;r<l.length&&!s;)if(s=l[r++].exec(e))for(o=0;o<f.length;o++)u=s[++i],a=f[o],"object"==typeof a&&a.length>0?2==a.length?"function"==typeof a[1]?this[a[0]]=a[1].call(this,u):this[a[0]]=a[1]:3==a.length?"function"!=typeof a[1]||a[1].exec&&a[1].test?this[a[0]]=u?u.replace(a[1],a[2]):n:this[a[0]]=u?a[1].call(this,u,a[2]):n:4==a.length&&(this[a[0]]=u?a[3].call(this,u.replace(a[1],a[2])):n):this[a]=u||n;c+=2}},str:function(e,t){for(var r in t)if("object"==typeof t[r]&&t[r].length>0){for(var i=0;i<t[r].length;i++)if(f.has(t[r][i],e))return"?"===r?n:r}else if(f.has(t[r],e))return"?"===r?n:r;return e}},h={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}},p={
browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[o,u],[/(opios)[\/\s]+([\w\.]+)/i],[[o,"Opera Mini"],u],[/\s(opr)\/([\w\.]+)/i],[[o,"Opera"],u],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i],[o,u],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[o,"IE"],u],[/(edge)\/((\d+)?[\w\.]+)/i],[o,u],[/(yabrowser)\/([\w\.]+)/i],[[o,"Yandex"],u],[/(puffin)\/([\w\.]+)/i],[[o,"Puffin"],u],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[o,"UCBrowser"],u],[/(comodo_dragon)\/([\w\.]+)/i],[[o,/_/g," "],u],[/(micromessenger)\/([\w\.]+)/i],[[o,"WeChat"],u],[/(QQ)\/([\d\.]+)/i],[o,u],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[o,u],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[u,[o,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[u,[o,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[u,[o,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[o,/(.+)/,"$1 WebView"],u],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[o,/(.+(?:g|us))(.+)/,"$1 $2"],u],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[u,[o,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[o,u],[/(dolfin)\/([\w\.]+)/i],[[o,"Dolphin"],u],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[o,"Chrome"],u],[/(coast)\/([\w\.]+)/i],[[o,"Opera Coast"],u],[/fxios\/([\w\.-]+)/i],[u,[o,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[u,[o,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[u,o],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[o,"GSA"],u],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[o,[u,d.str,h.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[o,u],[/(navigator|netscape)\/([\w\.-]+)/i],[[o,"Netscape"],u],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[o,u]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[["architecture","amd64"]],[/(ia32(?=;))/i],[["architecture",f.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[["architecture","ia32"]],[/windows\s(ce|mobile);\sppc;/i],[["architecture","arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[["architecture",/ower/,"",f.lowerize]],[/(sun4\w)[;\)]/i],[["architecture","sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[["architecture",f.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[i,s,[a,l]],[/applecoremedia\/[\w\.]+ \((ipad)/],[i,[s,"Apple"],[a,l]],[/(apple\s{0,1}tv)/i],[[i,"Apple TV"],[s,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[s,i,[a,l]],[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],[i,[s,"Amazon"],[a,l]],[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],[[i,d.str,h.device.amazon.model],[s,"Amazon"],[a,c]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[i,s,[a,c]],[/\((ip[honed|\s\w*]+);/i],[i,[s,"Apple"],[a,c]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[s,i,[a,c]],[/\(bb10;\s(\w+)/i],[i,[s,"BlackBerry"],[a,c]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[i,[s,"Asus"],[a,l]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[s,"Sony"],[i,"Xperia Tablet"],[a,l]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[i,[s,"Sony"],[a,c]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[s,i,[a,"console"]],[/android.+;\s(shield)\sbuild/i],[i,[s,"Nvidia"],[a,"console"]],[/(playstation\s[34portablevi]+)/i],[i,[s,"Sony"],[a,"console"]],[/(sprint\s(\w+))/i],[[s,d.str,h.device.sprint.vendor],[i,d.str,h.device.sprint.model],[a,c]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[s,i,[a,l]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w+)*/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i],[s,[i,/_/g," "],[a,c]],[/(nexus\s9)/i],[i,[s,"HTC"],[a,l]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[i,[s,"Huawei"],[a,c]],[/(microsoft);\s(lumia[\s\w]+)/i],[s,i,[a,c]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[i,[s,"Microsoft"],[a,"console"]],[/(kin\.[onetw]{3})/i],[[i,/\./g," "],[s,"Microsoft"],[a,c]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w+)*/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[i,[s,"Motorola"],[a,c]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[i,[s,"Motorola"],[a,l]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[s,f.trim],[i,f.trim],[a,"smarttv"]],[/hbbtv.+maple;(\d+)/i],[[i,/^/,"SmartTV"],[s,"Samsung"],[a,"smarttv"]],[/\(dtv[\);].+(aquos)/i],[i,[s,"Sharp"],[a,"smarttv"]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[s,"Samsung"],i,[a,l]],[/smart-tv.+(samsung)/i],[s,[a,"smarttv"],i],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,/sec-((sgh\w+))/i],[[s,"Samsung"],i,[a,c]],[/sie-(\w+)*/i],[i,[s,"Siemens"],[a,c]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]+)*/i],[[s,"Nokia"],i,[a,c]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[i,[s,"Acer"],[a,l]],[/android.+([vl]k\-?\d{3})\s+build/i],[i,[s,"LG"],[a,l]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[s,"LG"],i,[a,l]],[/(lg) netcast\.tv/i],[s,i,[a,"smarttv"]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w+)*/i,/android.+lg(\-?[\d\w]+)\s+build/i],[i,[s,"LG"],[a,c]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[i,[s,"Lenovo"],[a,l]],[/linux;.+((jolla));/i],[s,i,[a,c]],[/((pebble))app\/[\d\.]+\s/i],[s,i,[a,"wearable"]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[s,i,[a,c]],[/crkey/i],[[i,"Chromecast"],[s,"Google"]],[/android.+;\s(glass)\s\d/i],[i,[s,"Google"],[a,"wearable"]],[/android.+;\s(pixel c)\s/i],[i,[s,"Google"],[a,l]],[/android.+;\s(pixel xl|pixel)\s/i],[i,[s,"Google"],[a,c]],[/android.+(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[i,/_/g," "],[s,"Xiaomi"],[a,c]],[/android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[i,/_/g," "],[s,"Xiaomi"],[a,l]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[i,[s,"Meizu"],[a,l]],[/android.+a000(1)\s+build/i],[i,[s,"OnePlus"],[a,c]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[i,[s,"RCA"],[a,l]],[/android.+[;\/]\s*(Venue[\d\s]*)\s+build/i],[i,[s,"Dell"],[a,l]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[i,[s,"Verizon"],[a,l]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[s,"Barnes & Noble"],i,[a,l]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[i,[s,"NuVision"],[a,l]],[/android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i],[[s,"ZTE"],i,[a,l]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[i,[s,"Swiss"],[a,c]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[i,[s,"Swiss"],[a,l]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[i,[s,"Zeki"],[a,l]],[/(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i],[[s,"Dragon Touch"],i,[a,l]],[/android.+[;\/]\s*(NS-?.+)\s+build/i],[i,[s,"Insignia"],[a,l]],[/android.+[;\/]\s*((NX|Next)-?.+)\s+build/i],[i,[s,"NextBook"],[a,l]],[/android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[s,"Voice"],i,[a,c]],[/android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i],[[s,"LvTel"],i,[a,c]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[i,[s,"Envizen"],[a,l]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i],[s,i,[a,l]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[i,[s,"MachSpeed"],[a,l]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[s,i,[a,l]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[i,[s,"Rotor"],[a,l]],[/android.+(KS(.+))\s+build/i],[i,[s,"Amazon"],[a,l]],[/android.+(Gigaset)[\s\-]+(Q.+)\s+build/i],[s,i,[a,l]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[a,f.lowerize],s,i],[/(android.+)[;\/].+build/i],[i,[s,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[u,[o,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[o,u],[/rv\:([\w\.]+).*(gecko)/i],[u,o]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[o,u],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[o,[u,d.str,h.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[o,"Windows"],[u,d.str,h.os.windows.version]],[/\((bb)(10);/i],[[o,"BlackBerry"],u],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[o,u],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[o,"Symbian"],u],[/\((series40);/i],[o],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[o,"Firefox OS"],u],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[o,u],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[o,"Chromium OS"],u],[/(sunos)\s?([\w\.]+\d)*/i],[[o,"Solaris"],u],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[o,u],[/(haiku)\s(\w+)/i],[o,u],[/cfnetwork\/.+darwin/i,/ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[u,/_/g,"."],[o,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[o,"Mac OS"],[u,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[o,u]]},y=function(e,t){if("object"==typeof e&&(t=e,e=n),!(this instanceof y))return new y(e,t).getResult();var i=e||(r&&r.navigator&&r.navigator.userAgent?r.navigator.userAgent:""),o=t?f.extend(p,t):p;return this.getBrowser=function(){var e={name:n,version:n};return d.rgx.call(e,i,o.browser),e.major=f.major(e.version),e},this.getCPU=function(){var e={architecture:n};return d.rgx.call(e,i,o.cpu),e},this.getDevice=function(){var e={vendor:n,model:n,type:n};return d.rgx.call(e,i,o.device),e},this.getEngine=function(){var e={name:n,version:n};return d.rgx.call(e,i,o.engine),e},this.getOS=function(){var e={name:n,version:n};return d.rgx.call(e,i,o.os),e},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}},this.getUA=function(){return i},this.setUA=function(e){return i=e,this},this};y.VERSION="0.7.17",y.BROWSER={NAME:o,MAJOR:"major",VERSION:u},y.CPU={ARCHITECTURE:"architecture"},y.DEVICE={MODEL:i,VENDOR:s,TYPE:a,CONSOLE:"console",MOBILE:c,SMARTTV:"smarttv",TABLET:l,WEARABLE:"wearable",EMBEDDED:"embedded"},y.ENGINE={NAME:o,VERSION:u},y.OS={NAME:o,VERSION:u},e.exports&&(t=e.exports=y),t.UAParser=y;var g=r&&(r.jQuery||r.Zepto);if(void 0!==g){var m=new y;g.ua=m.getResult(),g.ua.get=function(){return m.getUA()},g.ua.set=function(e){m.setUA(e);var t=m.getResult();for(var r in t)g.ua[r]=t[r]}}}("object"==typeof window?window:commonjsGlobal)}),uaParser_1=uaParser.UAParser,_deepAssign=genTraversalHandler(function(e){return e}),inBrowser="undefined"!=typeof window&&"[object Object]"!==Object.prototype.toString.call(window),raf=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame||function(e){return setTimeout(e,17)},caf=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.msCancelAnimationFrame||window.oCancelAnimationFrame||function(e){clearTimeout(e)},_evtListenerCache=_Object$create(null);_evtListenerCache.count=0;var CustEvent=function(){function e(t,r){var n=this;if(_classCallCheck(this,e),Object.defineProperty(this,"__target",{writable:!0,enumerable:!1,configurable:!0}),this.__target=this,t){if("object"!==(void 0===t?"undefined":_typeof(t)))throw new Error("CusEvent target are not object");this.__target=t,r&&["on","once","off","emit"].forEach(function(e){t[e]=n[e]})}}return _createClass(e,[{key:"on",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return addEventCache(this.__target,e,t,r),this}},{key:"once",value:function(e,t){return this.on(e,t,!0)}},{key:"off",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return removeEventCache(this.__target,e,t,r),this}},{key:"emit",value:function(e,t){return emitEventCache(this.__target,e,{data:t}),this}}]),e}(),_evtListenerCache$1=_Object$create(null);_evtListenerCache$1.count=0;var CustEvent$1=function(){function e(t,r){var n=this;if(_classCallCheck(this,e),Object.defineProperty(this,"__target",{writable:!0,enumerable:!1,configurable:!0}),this.__target=this,t){if("object"!==(void 0===t?"undefined":_typeof(t)))throw new Error("CusEvent target are not object");this.__target=t,r&&["on","once","off","emit"].forEach(function(e){t[e]=n[e]})}}return _createClass(e,[{key:"on",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return addEventCache$1(this.__target,e,t,r),this}},{key:"once",value:function(e,t){return this.on(e,t,!0)}},{key:"off",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return removeEventCache$1(this.__target,e,t,r),this}},{key:"emit",value:function(e,t){return emitEventCache$1(this.__target,e,{data:t}),this}}]),e}(),inBrowser$1="undefined"!=typeof window&&"[object Object]"!==Object.prototype.toString.call(window),_divEl=document.createElement("div"),_textAttrName="innerText";"textContent"in _divEl&&(_textAttrName="textContent");var _arrPrototype=Array.prototype,supportsPassive=!1;try{var opts=Object.defineProperty({},"passive",{get:function(){supportsPassive=!0}});window.addEventListener("test",null,opts)}catch(e){}var NodeWrap=function(){function e(t){var r=arguments.length>1&&arguments[1]!==undefined?arguments[1]:document;_classCallCheck(this,e);var n=this;n.selector=t;var i=void 0;t&&t.constructor===NodeList?i=makeArray$1(t):isArray$1(t)?i=t:isString(t)?0===t.indexOf("<")?(_divEl.innerHTML=t,i=query("*",_divEl,!0)):i=query(t,r,!0):i=[t],_Object$assign(n,i),n.length=i.length}return _createClass(e,[{key:"each",value:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return _arrPrototype.forEach.apply(this,t),this}},{key:"push",value:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return _arrPrototype.push.apply(this,t),this}},{key:"splice",value:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return $(_arrPrototype.splice.apply(this,t))}},{key:"find",value:function(e){var t=[];this.each(function(r){t=t.concat(query(e,r,!0))});var r=$(t);return r.parent=this,r.selector=e,r}},{key:"append",value:function(e){var t=$(e),r=this[0];return t.each(function(e){return r.appendChild(e)}),this}},{key:"appendTo",value:function(e){return $(e).append(this),this}},{key:"text",value:function(e){return 0===arguments.length?this[0][_textAttrName]:this.each(function(t){t[_textAttrName]=e})}},{key:"html",value:function(e){return 0===arguments.length?this[0].innerHTML:this.each(function(t){t.innerHTML=e})}},{key:"attr",value:function(e,t){return 1===arguments.length?getAttr(this[0],e):this.each(function(r){return setAttr(r,e,t)})}},{key:"data",value:function(e,t){return 0===arguments.length?this[0].dataset||{}:1===arguments.length?(this[0].dataset||{})[e]:this.each(function(r){(r.dataset||(r.dataset={}))[e]=t})}},{key:"css",value:function(e,t){return 1!==arguments.length||isObject$1(e)?this.each(function(r){return setStyle(r,e,t)}):getStyle(this[0],e)}},{key:"addClass",value:function(e){return this.each(function(t){return addClassName(t,e)})}},{key:"removeClass",value:function(e){return this.each(function(t){return removeClassName(t,e)})}},{key:"hasClass",value:function(e){return hasClassName(this[0],e)}},{key:"on",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2],n=arguments.length>3&&arguments[3]!==undefined&&arguments[3];return this.each(function(i){return addEvent(i,e,t,r,n)})}},{key:"off",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2],n=arguments.length>3&&arguments[3]!==undefined&&arguments[3];return this.each(function(i){return removeEvent(i,e,t,r,n)})}},{key:"delegate",value:function(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3];return this.each(function(i){return addDelegate(i,e,t,r,n)})}},{key:"undelegate",value:function(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3];return this.each(function(i){return removeDelegate(i,e,t,r,n)})}},{key:"remove",value:function(){return this.each(function(e){return removeEl(e)})}}]),e}(),defaultConfig={type:"vod",box:"native",lockInternalProperty:!1},Native=function(e){function t(e,r){_classCallCheck(this,t);var n=_possibleConstructorReturn(this,(t.__proto__||_Object$getPrototypeOf(t)).call(this));return n.video=e,n.box="native",n.config=defaultConfig,deepAssign(n.config,r),n.bindEvents(),n}return _inherits(t,e),_createClass(t,[{key:"internalPropertyHandle",value:function(){if(_Object$getOwnPropertyDescriptor){var e=this,t=_Object$getOwnPropertyDescriptor(HTMLMediaElement.prototype,"currentTime");Object.defineProperty(this.video,"currentTime",{get:function(){return t.get.call(e.video)},set:function(r){if(e.currentTimeLock)return t.set.call(e.video,r);throw new Error("can not set currentTime by youself")}})}}},{key:"bindEvents",value:function(){var e=this;this.video&&this.config.lockInternalProperty&&this.video.addEventListener("canplay",function(){e.internalPropertyHandle()})}},{key:"load",value:function(e){this.config.src=e||this.config.src,this.video.setAttribute("src",this.config.src)}},{key:"unload",value:function(){this.video.src="",this.video.removeAttribute("src")}},{key:"destroy",value:function(){this.video&&this.unload()}},{key:"play",value:function(){return this.video.play()}},{key:"pause",value:function(){return this.video.pause()}},{key:"refresh",value:function(){this.video.src=this.config.src}},{key:"attachMedia",value:function(){}},{key:"seek",value:function(e){this.currentTimeLock=!0,this.video.currentTime=e,this.currentTimeLock=!1}}]),t}(CustEvent),defaultConfig$1={isLive:!0,box:"native",lockInternalProperty:!1,reloadTime:1500},$const={kernelEvent:["mediaInfo","heartbeat","error"]},Kernel=function(e){function t(e,r){_classCallCheck(this,t);var n=_possibleConstructorReturn(this,(t.__proto__||_Object$getPrototypeOf(t)).call(this));return n.tag="kernel",n.config=deepAssign({},defaultConfig$1,r),n.video=e,n.videokernel=n.selectKernel(),n.bindEvents(n.videokernel,n.video),n}return _inherits(t,e),_createClass(t,[{key:"bindEvents",value:function(e,t){var r=this;e&&$const.kernelEvent.forEach(function(t){e.on(t,function(e){r.emit(t,e.data)})})}},{key:"selectKernel",value:function(){var e=this.config;isObject$1(e.preset)||(e.preset={});var t=e.box,r=e.src.toLowerCase();if(t||(t=-1!==r.indexOf(".flv")?"flv":-1!==r.indexOf(".m3u8")?"hls":-1!==r.indexOf(".mp4")?"mp4":"native"),"native"!==t&&"mp4"!==t&&!e.preset[t])return void Log$1.error(this.tag,"You want to play for "+t+", but you have not installed the kernel.");switch("mp4"===t&&(e.preset[t]&&e.preset[t].isSupport()||(Log$1.verbose(this.tag,"browser is not support mp4 decode, auto switch native player"),t="native")),t){case"native":return new Native(this.video,e);case"mp4":case"flv":case"hls":return new e.preset[t](this.video,e);default:return void Log$1.error(this.tag,"not mactch any player, please check your config")}}},{key:"attachMedia",value:function(){if(!this.videokernel)return Log$1.error(this.tag,"videokernel is not already, must init player");this.videokernel.attachMedia()}},{key:"load",value:function(e){if(this.config.src=e||this.config.src,!this.videokernel||!this.config.src)return Log$1.error(this.tag,"videokernel is not already, must init player");this.videokernel.load(this.config.src)}},{key:"destroy",value:function(){if(!this.videokernel)return Log$1.error(this.tag,"videokernel is not exit");this.videokernel.destroy()}},{key:"play",value:function(){if(!this.videokernel)return Log$1.error(this.tag,"videokernel is not already, must init player");this.videokernel.play()}},{key:"pause",value:function(){if(!this.videokernel||!this.config.src)return Log$1.error(this.tag,"videokernel is not already, must init player");this.videokernel.pause()}},{key:"seek",value:function(e){return isNumber(e)?this.videokernel?this.videokernel.seek(e):void Log$1.error(this.tag,"videokernel is not already, must init player"):void Log$1.error(this.tag,"seek params must be a number")}},{key:"refresh",value:function(){if(!this.videokernel)return Log$1.error(this.tag,"videokernel is not already, must init player");this.videokernel.refresh()}},{key:"currentTime",get:function(){return this.videokernel?this.video.currentTime:0}},{key:"duration",get:function(){return this.video.duration}},{key:"volume",get:function(){return this.video.volume},set:function(e){this.video.volume=e}},{key:"muted",get:function(){return this.video.muted},set:function(e){this.video.muted=e}},{key:"buffered",get:function(){return this.video.buffered}}]),t}(CustEvent),_validateCollection=function(e,t){if(!_isObject(e)||e._t!==t)throw TypeError("Incompatible receiver, "+t+" required!");return e},dP$2=_objectDp.f,fastKey=_meta.fastKey,SIZE=_descriptors?"_s":"size",getEntry=function(e,t){var r,n=fastKey(t);if("F"!==n)return e._i[n];for(r=e._f;r;r=r.n)if(r.k==t)return r},_collectionStrong={getConstructor:function(e,t,r,n){var i=e(function(e,o){_anInstance(e,i,t,"_i"),e._t=t,e._i=_objectCreate(null),e._f=undefined,e._l=undefined,e[SIZE]=0,o!=undefined&&_forOf(o,r,e[n],e)});return _redefineAll(i.prototype,{clear:function(){for(var e=_validateCollection(this,t),r=e._i,n=e._f;n;n=n.n)n.r=!0,n.p&&(n.p=n.p.n=undefined),delete r[n.i];e._f=e._l=undefined,e[SIZE]=0},"delete":function(e){var r=_validateCollection(this,t),n=getEntry(r,e);if(n){var i=n.n,o=n.p;delete r._i[n.i],n.r=!0,o&&(o.n=i),i&&(i.p=o),r._f==n&&(r._f=i),r._l==n&&(r._l=o),r[SIZE]--}return!!n},forEach:function(e){_validateCollection(this,t);for(var r,n=_ctx(e,arguments.length>1?arguments[1]:undefined,3);r=r?r.n:this._f;)for(n(r.v,r.k,this);r&&r.r;)r=r.p},has:function(e){return!!getEntry(_validateCollection(this,t),e)}}),_descriptors&&dP$2(i.prototype,"size",{get:function(){return _validateCollection(this,t)[SIZE]}}),i},def:function(e,t,r){var n,i,o=getEntry(e,t);return o?o.v=r:(e._l=o={i:i=fastKey(t,!0),k:t,v:r,p:n=e._l,n:undefined,r:!1},e._f||(e._f=o),n&&(n.n=o),e[SIZE]++,"F"!==i&&(e._i[i]=o)),e},getEntry:getEntry,setStrong:function(e,t,r){_iterDefine(e,t,function(e,r){this._t=_validateCollection(e,t),this._k=r,this._l=undefined},function(){for(var e=this,t=e._k,r=e._l;r&&r.r;)r=r.p;return e._t&&(e._l=r=r?r.n:e._t._f)?"keys"==t?_iterStep(0,r.k):"values"==t?_iterStep(0,r.v):_iterStep(0,[r.k,r.v]):(e._t=undefined,_iterStep(1))},r?"entries":"values",!r,!0),_setSpecies(t)}},SPECIES$2=_wks("species"),_arraySpeciesConstructor=function(e){var t;return _isArray(e)&&(t=e.constructor,"function"!=typeof t||t!==Array&&!_isArray(t.prototype)||(t=undefined),_isObject(t)&&null===(t=t[SPECIES$2])&&(t=undefined)),t===undefined?Array:t},_arraySpeciesCreate=function(e,t){return new(_arraySpeciesConstructor(e))(t)},_arrayMethods=function(e,t){var r=1==e,n=2==e,i=3==e,o=4==e,a=6==e,s=5==e||a,u=t||_arraySpeciesCreate;return function(t,c,l){for(var f,d,h=_toObject(t),p=_iobject(h),y=_ctx(c,l,3),g=_toLength(p.length),m=0,_=r?u(t,g):n?u(t,0):undefined;g>m;m++)if((s||m in p)&&(f=p[m],d=y(f,m,h),e))if(r)_[m]=d;else if(d)switch(e){case 3:return!0;case 5:return f;case 6:return m;case 2:_.push(f)}else if(o)return!1;return a?-1:i||o?o:_}},dP$3=_objectDp.f,each=_arrayMethods(0),_collection=function(e,t,r,n,i,o){var a=_global[e],s=a,u=i?"set":"add",c=s&&s.prototype,l={};return _descriptors&&"function"==typeof s&&(o||c.forEach&&!_fails(function(){(new s).entries().next()}))?(s=t(function(t,r){_anInstance(t,s,e,"_c"),t._c=new a,r!=undefined&&_forOf(r,i,t[u],t)}),each("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","),function(e){var t="add"==e||"set"==e;e in c&&(!o||"clear"!=e)&&_hide(s.prototype,e,function(r,n){if(_anInstance(this,s,e),!t&&o&&!_isObject(r))return"get"==e&&undefined;var i=this._c[e](0===r?0:r,n);return t?this:i})}),o||dP$3(s.prototype,"size",{get:function(){return this._c.size}})):(s=n.getConstructor(t,e,i,u),_redefineAll(s.prototype,r),_meta.NEED=!0),_setToStringTag(s,e),l[e]=s,_export(_export.G+_export.W+_export.F,l),o||n.setStrong(s,e,i),s},MAP="Map",es6_map=_collection(MAP,function(e){return function(){return e(this,arguments.length>0?arguments[0]:undefined)}},{get:function(e){var t=_collectionStrong.getEntry(_validateCollection(this,MAP),e);return t&&t.v},set:function(e,t){return _collectionStrong.def(_validateCollection(this,MAP),0===e?0:e,t)}},_collectionStrong,!0),_arrayFromIterable=function(e,t){var r=[];return _forOf(e,!1,r.push,r,t),r},_collectionToJson=function(e){return function(){if(_classof(this)!=e)throw TypeError(e+"#toJSON isn't generic");return _arrayFromIterable(this)}};_export(_export.P+_export.R,"Map",{toJSON:_collectionToJson("Map")});var _setCollectionOf=function(e){_export(_export.S,e,{of:function(){for(var e=arguments.length,t=Array(e);e--;)t[e]=arguments[e];return new this(t)}})};_setCollectionOf("Map");var _setCollectionFrom=function(e){_export(_export.S,e,{from:function(e){var t,r,n,i,o=arguments[1];return _aFunction(this),t=o!==undefined,t&&_aFunction(o),e==undefined?new this:(r=[],t?(n=0,i=_ctx(o,arguments[2],2),_forOf(e,!1,function(e){r.push(i(e,n++))})):_forOf(e,!1,r.push,r),new this(r))}})};_setCollectionFrom("Map");var map$1=_core.Map,map=createCommonjsModule(function(e){e.exports={"default":map$1,__esModule:!0}}),_Map=unwrapExports(map),Reflect$1=_global.Reflect,_ownKeys=Reflect$1&&Reflect$1.ownKeys||function(e){var t=_objectGopn.f(_anObject(e)),r=_objectGops.f;return r?t.concat(r(e)):t};_export(_export.S,"Object",{getOwnPropertyDescriptors:function(e){for(var t,r,n=_toIobject(e),i=_objectGopd.f,o=_ownKeys(n),a={},s=0;o.length>s;)(r=i(n,t=o[s++]))!==undefined&&_createProperty(a,t,r);return a}});var getOwnPropertyDescriptors$2=_core.Object.getOwnPropertyDescriptors,getOwnPropertyDescriptors$1=createCommonjsModule(function(e){e.exports={"default":getOwnPropertyDescriptors$2,__esModule:!0}}),_Object$getOwnPropertyDescriptors=unwrapExports(getOwnPropertyDescriptors$1),getOwnPropertySymbols$1=_core.Object.getOwnPropertySymbols,getOwnPropertySymbols=createCommonjsModule(function(e){e.exports={"default":getOwnPropertySymbols$1,__esModule:!0}}),_Object$getOwnPropertySymbols=unwrapExports(getOwnPropertySymbols);_objectSap("getOwnPropertyNames",function(){return _objectGopnExt.f});var $Object$3=_core.Object,getOwnPropertyNames$1=function(e){return $Object$3.getOwnPropertyNames(e)},getOwnPropertyNames=createCommonjsModule(function(e){e.exports={"default":getOwnPropertyNames$1,__esModule:!0}}),_Object$getOwnPropertyNames=unwrapExports(getOwnPropertyNames),getWeak=_meta.getWeak,arrayFind=_arrayMethods(5),arrayFindIndex=_arrayMethods(6),id$1=0,uncaughtFrozenStore=function(e){return e._l||(e._l=new UncaughtFrozenStore)},UncaughtFrozenStore=function(){this.a=[]},findUncaughtFrozen=function(e,t){return arrayFind(e.a,function(e){return e[0]===t})};UncaughtFrozenStore.prototype={get:function(e){var t=findUncaughtFrozen(this,e);if(t)return t[1]},has:function(e){return!!findUncaughtFrozen(this,e)},set:function(e,t){var r=findUncaughtFrozen(this,e);r?r[1]=t:this.a.push([e,t])},"delete":function(e){var t=arrayFindIndex(this.a,function(t){return t[0]===e});return~t&&this.a.splice(t,1),!!~t}};var _collectionWeak={getConstructor:function(e,t,r,n){var i=e(function(e,o){_anInstance(e,i,t,"_i"),e._t=t,e._i=id$1++,e._l=undefined,o!=undefined&&_forOf(o,r,e[n],e)});return _redefineAll(i.prototype,{"delete":function(e){if(!_isObject(e))return!1;var r=getWeak(e);return!0===r?uncaughtFrozenStore(_validateCollection(this,t))["delete"](e):r&&_has(r,this._i)&&delete r[this._i]},has:function(e){if(!_isObject(e))return!1;var r=getWeak(e);return!0===r?uncaughtFrozenStore(_validateCollection(this,t)).has(e):r&&_has(r,this._i)}}),i},def:function(e,t,r){var n=getWeak(_anObject(t),!0);return!0===n?uncaughtFrozenStore(e).set(t,r):n[e._i]=r,e},ufstore:uncaughtFrozenStore},es6_weakMap=createCommonjsModule(function(e){var t,r=_arrayMethods(0),n=_meta.getWeak,i=Object.isExtensible,o=_collectionWeak.ufstore,a={},s=function(e){return function(){return e(this,arguments.length>0?arguments[0]:undefined)}},u={get:function(e){if(_isObject(e)){var t=n(e);return!0===t?o(_validateCollection(this,"WeakMap")).get(e):t?t[this._i]:undefined}},set:function(e,t){return _collectionWeak.def(_validateCollection(this,"WeakMap"),e,t)}},c=e.exports=_collection("WeakMap",s,u,_collectionWeak,!0,!0);_fails(function(){return 7!=(new c).set((Object.freeze||Object)(a),7).get(a)})&&(t=_collectionWeak.getConstructor(s,"WeakMap"),_objectAssign(t.prototype,u),_meta.NEED=!0,r(["delete","has","get","set"],function(e){var r=c.prototype,n=r[e];_redefine(r,e,function(r,o){if(_isObject(r)&&!i(r)){this._f||(this._f=new t);var a=this._f[e](r,o);return"set"==e?this:a}return n.call(this,r,o)})}))});_setCollectionOf("WeakMap"),_setCollectionFrom("WeakMap");var weakMap$1=_core.WeakMap,weakMap=createCommonjsModule(function(e){e.exports={"default":weakMap$1,__esModule:!0}}),_WeakMap=unwrapExports(weakMap),defineProperty$5$1=createCommonjsModule(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(defineProperty$1);t["default"]=function(e,t,n){return t in e?(0,r["default"])(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}}),_defineProperty$1=unwrapExports(defineProperty$5$1),meta=_meta.onFreeze;_objectSap("preventExtensions",function(e){return function(t){return e&&_isObject(t)?e(meta(t)):t}});var preventExtensions$2=_core.Object.preventExtensions,preventExtensions$1=createCommonjsModule(function(e){e.exports={"default":preventExtensions$2,__esModule:!0}});unwrapExports(preventExtensions$1);var getOwnPropertyDescriptor$3=_Object$getOwnPropertyDescriptor,getOwnKeys=getOwnKeysFn(),getOwnPropertyDescriptors=getOwnPropertyDescriptorsFn(),getOwnPropertyDescriptor$1$1=_Object$getOwnPropertyDescriptor,defineProperty$4=_Object$defineProperty,defineProperty$1$1=_Object$defineProperty,autobindClass=classify(autobind,{requirement:function(e,t,r){return isDataDescriptor(r)&&isFunction(r.value)}}),mapStore=void 0,defineProperty$2$1=_Object$defineProperty,getOwnPropertyDescriptor$2$1=_Object$getOwnPropertyDescriptor,defineProperty$3$1=_Object$defineProperty,defineProperty$6=_Object$defineProperty,getOwnPropertyDescriptor$3$1=_Object$getOwnPropertyDescriptor,arrayChangeMethod=["push","pop","unshift","shift","splice","sort","reverse"],$JSON$1=_core.JSON||(_core.JSON={stringify:JSON.stringify}),stringify$1=function(e){
return $JSON$1.stringify.apply($JSON$1,arguments)},stringify=createCommonjsModule(function(e){e.exports={"default":stringify$1,__esModule:!0}}),_JSON$stringify=unwrapExports(stringify);_export(_export.S,"Number",{isNaN:function(e){return e!=e}});var isNan$1=_core.Number.isNaN,isNan=createCommonjsModule(function(e){e.exports={"default":isNan$1,__esModule:!0}}),_Number$isNaN=unwrapExports(isNan),VENDOR_PREFIXES=["","o","ms","moz","webkit","webkitCurrent"],SYNONYMS=[["",""],["exit","cancel"],["screen","Screen"]],DESKTOP_FULLSCREEN_STYLE={position:"fixed",zIndex:"2147483647",left:0,top:0,right:0,bottom:0,overflow:"hidden",width:"100%",height:"100%"},FULLSCREEN_CHANGE=["fullscreenchange","webkitfullscreenchange","mozfullscreenchange","MSFullscreenChange"],FULLSCREEN_ERROR=["fullscreenerror","webkitfullscreenerror","mozfullscreenerror","MSFullscreenError"],_dec$1$1,_dec2$1$1,_dec3$1$1,_dec4$1$1,_dec5$1$1,_class$1$1,_class2$1$1,fullscreenEnabled=native("fullscreenEnabled"),ESFullScreen=(_dec$1$1=autobindClass(),_dec2$1$1=alias("requestFullscreen"),_dec3$1$1=alias("exitFullscreen"),_dec4$1$1=alias("addEventListener"),_dec5$1$1=alias("removeEventListener"),_dec$1$1((_class2$1$1=function(){function e(){_classCallCheck(this,e),this._fullscreenElement=null,this.isNativelySupport=defined$1(native("fullscreenElement"))&&(!defined$1(fullscreenEnabled)||!0===fullscreenEnabled),this._openKey=native(document.body,"requestFullscreen",{keyOnly:!0}),this._exitKey=native("exitFullscreen",{keyOnly:!0})}return _createClass(e,[{key:"open",value:function(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},r=t.force,n=r!==undefined&&r,i=this.fullscreenElement;if(i&&i!==e){if(!n)return dispatchEvent(document,"fullscreenerror"),!1;this.exit()}return this.isNativelySupport?(e[this._openKey](),!0):(this._savedStyles=_Object$keys(DESKTOP_FULLSCREEN_STYLE).reduce(function(t,r){return t[r]=e.style[r],t},{}),setStyle$1(e,DESKTOP_FULLSCREEN_STYLE),document.body&&(this._bodyOverflow=document.body.style.overflow,document.body.style.overflow="hidden"),document.documentElement&&(this._htmlOverflow=document.documentElement.style.overflow,document.documentElement.style.overflow="hidden"),this._fullscreenElement=e,dispatchEvent(e,"fullscreenchange"),!0)}},{key:"exit",value:function(){if(!this.isFullscreen)return!1;if(this.isNativelySupport)return document[this._exitKey](),!0;var e=this._fullscreenElement;return setStyle$1(e,this._savedStyles),document.body&&(document.body.style.overflow=this._bodyOverflow),document.documentElement&&(document.documentElement.style.overflow=this._htmlOverflow),this._fullscreenElement=null,this._savedStyles={},dispatchEvent(e,"fullscreenchange"),!0}},{key:"on",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:document;this._handleEvent(r,"addEventListener",e,t)}},{key:"off",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:document;this._handleEvent(r,"removeEventListener",e,t)}},{key:"_handleEvent",value:function(e,t,r,n){("fullscreenchange"===r?FULLSCREEN_CHANGE:FULLSCREEN_ERROR).forEach(function(r){e[t](r,n)})}},{key:"fullscreenElement",get:function(){return["fullscreenElement","webkitFullscreenElement","mozFullScreenElement","msFullscreenElement"].reduce(function(e,t){return e||document[t]},null)||this._fullscreenElement}},{key:"isFullscreen",get:function(){return isElement(this.fullscreenElement)}}]),e}(),_applyDecoratedDescriptor$1$1(_class2$1$1.prototype,"open",[_dec2$1$1],_Object$getOwnPropertyDescriptor(_class2$1$1.prototype,"open"),_class2$1$1.prototype),_applyDecoratedDescriptor$1$1(_class2$1$1.prototype,"exit",[_dec3$1$1],_Object$getOwnPropertyDescriptor(_class2$1$1.prototype,"exit"),_class2$1$1.prototype),_applyDecoratedDescriptor$1$1(_class2$1$1.prototype,"on",[_dec4$1$1],_Object$getOwnPropertyDescriptor(_class2$1$1.prototype,"on"),_class2$1$1.prototype),_applyDecoratedDescriptor$1$1(_class2$1$1.prototype,"off",[_dec5$1$1],_Object$getOwnPropertyDescriptor(_class2$1$1.prototype,"off"),_class2$1$1.prototype),_class$1$1=_class2$1$1))||_class$1$1),index=new ESFullScreen,videoEvents=["abort","canplay","canplaythrough","durationchange","emptied","encrypted","ended","error","interruptbegin","interruptend","loadeddata","loadedmetadata","loadstart","mozaudioavailable","pause","play","playing","progress","ratechange","seeked","seeking","stalled","suspend","timeupdate","volumechange","waiting"],videoReadOnlyProperties=["buffered","currentSrc","duration","error","ended","networkState","paused","readyState","seekable","sinkId","controlsList","tabIndex","dataset","offsetHeight","offsetLeft","offsetParent","offsetTop","offsetWidth"],domEvents=["beforeinput","blur","click","compositionend","compositionstart","compositionupdate","dblclick","focus","focusin","focusout","input","keydown","keypress","keyup","mousedown","mouseenter","mouseleave","mousemove","mouseout","mouseover","mouseup","resize","scroll","select","wheel","mousewheel","fullscreenchange","contextmenu","touchstart","touchmove","touchend"],passiveEvents=["wheel","mousewheel","touchstart","touchmove"],selfProcessorEvents=["silentLoad","fullscreen"],kernelMethods=["play","pause","seek"],dispatcherMethods=["load"],kernelEvents=["mediaInfo","heartbeat","error"],domMethods=["focus","fullscreen","requestFullscreen","exitFullscreen"],videoMethods=["canPlayType","captureStream","setSinkId"],_dec$2,_dec2$1,_dec3$1,_dec4$1,_class$2,secondaryReg=/^(before|after|_)/,Bus=(_dec$2=runnable(secondaryChecker),_dec2$1=runnable(secondaryChecker,{backup:function(){return!1}}),_dec3$1=runnable(secondaryChecker),_dec4$1=runnable(secondaryChecker,{backup:function(){return!1}}),_class$2=function(){function e(t){_classCallCheck(this,e),this.events={},this.onceMap={},this.__dispatcher=t}return _createClass(e,[{key:"on",value:function(e,t,r){var n=this._getEventStage(t),i=n.stage,o=n.key;this._addEvent([o,i,e],r)}},{key:"off",value:function(e,t,r){var n=this._getEventStage(t),i=n.stage,o=n.key,a=[o,i,e];if(!this._removeEvent(a,r)){var s=this._getHandlerFromOnceMap(a,r);isFunction(s)&&this._removeEvent(a,s)&&this._removeFromOnceMap(a,r,s)}}},{key:"once",value:function(e,t,r){var n=this._getEventStage(t),i=n.stage,o=n.key,a=this,s=[o,i,e],u=function c(){bind(r,this).apply(undefined,arguments),a._removeEvent(s,c),a._removeFromOnceMap(s,r,c)};this._addEvent(s,u),this._addToOnceMap(s,r,u)}},{key:"emit",value:function(e){for(var t=this,r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];var o=this.events[e];if(isEmpty(o))return selfProcessorEvents.indexOf(e)>-1?_Promise.resolve():this._eventProcessor.apply(this,[e,{sync:!1}].concat(_toConsumableArray(n)));var a=this._getEventQueue(o.before,this.__dispatcher.order);return runRejectableQueue.apply(undefined,[a].concat(_toConsumableArray(n))).then(function(){if(!(selfProcessorEvents.indexOf(e)>-1))return t._eventProcessor.apply(t,[e,{sync:!1}].concat(_toConsumableArray(n)))})["catch"](function(e){return isError(e)&&t.__dispatcher.throwError(e),_Promise.reject(e)})}},{key:"emitSync",value:function(e){for(var t=this.events[e],r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];if(isEmpty(t))return selfProcessorEvents.indexOf(e)>-1||this._eventProcessor.apply(this,[e,{sync:!0}].concat(_toConsumableArray(n)));var o=this._getEventQueue(t.before,this.__dispatcher.order);return runStoppableQueue.apply(undefined,[o].concat(_toConsumableArray(n)))&&(selfProcessorEvents.indexOf(e)>-1||this._eventProcessor.apply(this,[e,{sync:!0}].concat(_toConsumableArray(n))))}},{key:"trigger",value:function(e){for(var t=this,r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];var o=this.events[e];if(isEmpty(o))return _Promise.resolve(!0);var a=this._getEventQueue(o.main,this.__dispatcher.order);return runRejectableQueue.apply(undefined,[a].concat(_toConsumableArray(n))).then(function(){var e=t._getEventQueue(o.after,t.__dispatcher.order);return runRejectableQueue.apply(undefined,[e].concat(_toConsumableArray(n)))}).then(function(){return t._runSideEffectEvent.apply(t,[e,t.__dispatcher.order].concat(_toConsumableArray(n)))})["catch"](function(r){return isError(r)&&t.__dispatcher.throwError(r),t._runSideEffectEvent.apply(t,[e,t.__dispatcher.order].concat(_toConsumableArray(n)))})}},{key:"triggerSync",value:function(e){var t=this.events[e];if(isEmpty(t))return!0;for(var r=this._getEventQueue(t.main,this.__dispatcher.order),n=this._getEventQueue(t.after,this.__dispatcher.order),i=arguments.length,o=Array(i>1?i-1:0),a=1;a<i;a++)o[a-1]=arguments[a];var s=runStoppableQueue.apply(undefined,[r].concat(_toConsumableArray(o)))&&runStoppableQueue.apply(undefined,[n].concat(_toConsumableArray(o)));return this._runSideEffectEvent.apply(this,[e,this.__dispatcher.order].concat(_toConsumableArray(o))),s}},{key:"destroy",value:function(){delete this.events,delete this.__dispatcher}},{key:"_addEvent",value:function(e,t){e=deepClone(e);var r=e.pop(),n=e.reduce(function(e,t){return e[t]=e[t]||{},e[t]},this.events);n[r]=n[r]||[],n[r].push(t)}},{key:"_removeEvent",value:function(e,t){e=deepClone(e);for(var r=e.pop(),n=this.events,i=0,o=e.length;i<o;i++){var a=n[e[i]];if(isEmpty(a))return;n=a}var s=n[r]||[],u=s.indexOf(t),c=u>-1;return c&&s.splice(u,1),s.length<1&&delete n[r],c}},{key:"_addToOnceMap",value:function(e,t,r){var n=e.join("-"),i=this.onceMap[n]=this.onceMap[n]||new _Map;i.has(t)||i.set(t,[]),i.get(t).push(r)}},{key:"_removeFromOnceMap",value:function(e,t,r){var n=e.join("-"),i=this.onceMap[n],o=i.get(t),a=o.indexOf(r);o.splice(a,1),isEmpty(o)&&i["delete"](t)}},{key:"_getHandlerFromOnceMap",value:function(e,t){var r=e.join("-"),n=this.onceMap[r];if(!isVoid(n)&&n.has(t)){return n.get(t)[0]}}},{key:"_getEventStage",value:function(e){var t=e.match(secondaryReg),r=t&&t[0]||"main";return t&&(e=camelize(e.replace(secondaryReg,""))),{stage:r,key:e}}},{key:"_getEventQueue",value:function(e,t){var r=this;return t=isArray$1(t)?t.concat(["_vm"]):["_vm"],isEmpty(e)?[]:t.reduce(function(t,n){return isEmpty(e[n])||!isArray$1(e[n])||!r.__dispatcher.plugins[n]&&"_vm"!==n?t:t.concat(e[n].map(function(e){return bind(e,r.__dispatcher.plugins[n]||r.__dispatcher.vm)}))},[])}},{key:"_eventProcessor",value:function(e,t){for(var r=t.sync,n=kernelMethods.indexOf(e)>-1,i=domMethods.indexOf(e)>-1,o=dispatcherMethods.indexOf(e)>-1,a=arguments.length,s=Array(a>2?a-2:0),u=2;u<a;u++)s[u-2]=arguments[u];if(n||i||o){if(o){var c;(c=this.__dispatcher)[e].apply(c,_toConsumableArray(s))}else{var l;(l=this.__dispatcher[n?"kernel":"dom"])[e].apply(l,_toConsumableArray(s))}if(videoEvents.indexOf(e)>-1||domEvents.indexOf(e)>-1)return!0}return this[r?"triggerSync":"trigger"].apply(this,[e].concat(_toConsumableArray(s)))}},{key:"_runSideEffectEvent",value:function(e,t){for(var r=arguments.length,n=Array(r>2?r-2:0),i=2;i<r;i++)n[i-2]=arguments[i];var o=this.events[e];return!isEmpty(o)&&(this._getEventQueue(o._,t).forEach(function(e){return e.apply(undefined,_toConsumableArray(n))}),!0)}}]),e}(),_applyDecoratedDescriptor$2(_class$2.prototype,"emit",[_dec$2],_Object$getOwnPropertyDescriptor(_class$2.prototype,"emit"),_class$2.prototype),_applyDecoratedDescriptor$2(_class$2.prototype,"emitSync",[_dec2$1],_Object$getOwnPropertyDescriptor(_class$2.prototype,"emitSync"),_class$2.prototype),_applyDecoratedDescriptor$2(_class$2.prototype,"trigger",[_dec3$1],_Object$getOwnPropertyDescriptor(_class$2.prototype,"trigger"),_class$2.prototype),_applyDecoratedDescriptor$2(_class$2.prototype,"triggerSync",[_dec4$1],_Object$getOwnPropertyDescriptor(_class$2.prototype,"triggerSync"),_class$2.prototype),_class$2),_dec$5,_dec2$3,_class$5,_descriptor$1,_descriptor2$1,_descriptor3$1,_descriptor4,_descriptor5,_descriptor6,_descriptor7,accessorMap={src:[string$1(),accessor({set:function(e){return this.dispatcher.readySync&&this.autoload&&e!==this.src&&(this.needToLoadSrc=!0),e}}),accessor({set:function(e){return this.needToLoadSrc&&(this.needToLoadSrc=!1,this.dispatcher.bus.emit("load",e)),e}},{preSet:!1})],autoload:boolean$1(),autoplay:[boolean$1(),accessorVideoProperty("autoplay")],controls:[boolean$1(),accessorVideoProperty("controls")],width:[accessorWidthAndHeight("width")],height:[accessorWidthAndHeight("height")],crossOrigin:[accessor({set:stringOrVoid}),accessorVideoAttribute({set:"crossorigin",get:"crossOrigin"})],loop:[boolean$1(),accessorVideoProperty("loop")],defaultMuted:[boolean$1(),accessorVideoAttribute({get:"defaultMuted",set:"muted",isBoolean:!0})],muted:[boolean$1(),accessorVideoProperty("muted")],preload:[accessor({set:stringOrVoid}),accessorVideoAttribute("preload")],poster:[string$1(),accessor({get:function(e){return this.dispatcher.videoConfigReady&&this.inited?this.dom.videoElement.poster:e},set:function(e){return this.dispatcher.videoConfigReady?(e.length&&this.dom.setAttr("video","poster",e),e):e}})],playsInline:[accessor({get:function(e){var t=this.dom.videoElement.playsInline;return this.dispatcher.videoConfigReady&&this.inited?t===undefined?e:t:e},set:function(e){if(!this.dispatcher.videoConfigReady)return e;this.dom.videoElement.playsInline=e;var t=e?"":undefined;return this.dom.setAttr("video","playsinline",t),this.dom.setAttr("video","webkit-playsinline",t),this.dom.setAttr("video","x5-video-player-type",e?"h5":undefined),e}}),boolean$1()],x5VideoPlayerFullscreen:[accessor({set:function(e){return!!e},get:function(e){return!!e}}),accessorCustomAttribute("x5-video-player-fullscreen",!0)],x5VideoOrientation:[accessor({set:stringOrVoid}),accessorCustomAttribute("x5-video-orientation")],xWebkitAirplay:[accessor({set:function(e){return!!e},get:function(e){return!!e}}),accessorCustomAttribute("x-webkit-airplay",!0)],playbackRate:[number$1(1),accessorVideoProperty("playbackRate")],defaultPlaybackRate:[accessorVideoProperty("defaultPlaybackRate"),number$1(1)],disableRemotePlayback:[boolean$1(),accessorVideoProperty("disableRemotePlayback")],volume:[number$1(1),accessorVideoProperty("volume")]},VideoConfig=(_dec$5=boolean(),_dec2$3=string(function(e){return e.toLocaleLowerCase()}),_class$5=function(){function e(t,r){_classCallCheck(this,e),_initDefineProp$1(this,"needToLoadSrc",_descriptor$1,this),_initDefineProp$1(this,"changeWatchable",_descriptor2$1,this),_initDefineProp$1(this,"inited",_descriptor3$1,this),this.src="",_initDefineProp$1(this,"isLive",_descriptor4,this),_initDefineProp$1(this,"box",_descriptor5,this),this.preset={},this.autoload=!0,this.autoplay=!1,this.controls=!1,this.width="100%",this.height="100%",this.crossOrigin=undefined,this.loop=!1,this.defaultMuted=!1,this.muted=!1,this.preload="auto",this.poster=undefined,this.playsInline=!1,this.x5VideoPlayerFullscreen=!1,this.x5VideoOrientation=undefined,this.xWebkitAirplay=!1,this.playbackRate=1,this.defaultPlaybackRate=1,this.disableRemotePlayback=!1,this.volume=1,_initDefineProp$1(this,"_kernelProperty",_descriptor6,this),_initDefineProp$1(this,"_realDomAttr",_descriptor7,this),applyDecorators(this,accessorMap,{self:!0}),Object.defineProperty(this,"dispatcher",{value:t,enumerable:!1,writable:!1,configurable:!1}),Object.defineProperty(this,"dom",{value:t.dom,enumerable:!1,writable:!1,configurable:!1}),deepAssign(this,r)}return _createClass(e,[{key:"init",value:function(){var e=this;this._realDomAttr.forEach(function(t){e[t]=e[t]}),this.inited=!0}}]),e}(),_descriptor$1=_applyDecoratedDescriptor$4(_class$5.prototype,"needToLoadSrc",[nonenumerable],{enumerable:!0,initializer:function(){return!1}}),_descriptor2$1=_applyDecoratedDescriptor$4(_class$5.prototype,"changeWatchable",[nonenumerable],{enumerable:!0,initializer:function(){return!0}}),_descriptor3$1=_applyDecoratedDescriptor$4(_class$5.prototype,"inited",[nonenumerable],{enumerable:!0,initializer:function(){return!1}}),_descriptor4=_applyDecoratedDescriptor$4(_class$5.prototype,"isLive",[_dec$5,nonconfigurable],{enumerable:!0,initializer:function(){return!1}}),_descriptor5=_applyDecoratedDescriptor$4(_class$5.prototype,"box",[_dec2$3,nonconfigurable],{enumerable:!0,initializer:function(){return""}}),_descriptor6=_applyDecoratedDescriptor$4(_class$5.prototype,"_kernelProperty",[frozen],{enumerable:!0,initializer:function(){return["isLive","box","preset","kernels"]}}),_descriptor7=_applyDecoratedDescriptor$4(_class$5.prototype,"_realDomAttr",[frozen],{enumerable:!0,initializer:function(){return["src","controls","width","height","crossOrigin","loop","muted","preload","poster","autoplay","playsInline","x5VideoPlayerFullscreen","x5VideoOrientation","xWebkitAirplay","playbackRate","defaultPlaybackRate","autoload","disableRemotePlayback","defaultMuted","volume"]}}),_class$5),_dec$4,_dec2$2,_dec3$2,_dec4$2,_dec5$1,_dec6,_dec7,_dec8,_dec9,_dec10,_dec11,_dec12,_dec13,_dec14,_dec15,_dec16,_dec17,_dec18,_dec19,_class$4,_class2$1,VideoWrapper=(_dec$4=autobindClass(),_dec2$2=alias("silentLoad"),_dec3$2=alias("fullScreen"),_dec4$2=alias("$fullScreen"),_dec5$1=alias("fullscreen"),_dec6=alias("emit"),_dec7=alias("emitSync"),_dec8=alias("on"),_dec9=alias("addEventListener"),_dec10=before(eventBinderCheck),_dec11=alias("off"),_dec12=alias("removeEventListener"),_dec13=before(eventBinderCheck),_dec14=alias("once"),_dec15=before(eventBinderCheck),_dec16=alias("css"),_dec17=before(attrAndStyleCheck),_dec18=alias("attr"),_dec19=before(attrAndStyleCheck),_dec$4((_class2$1=function(){function e(){_classCallCheck(this,e),this.__events={},this.__unwatchHandlers=[]}return _createClass(e,[{key:"__wrapAsVideo",value:function(e){var t=this;videoReadOnlyProperties.forEach(function(e){_Object$defineProperty(t,e,{get:function(){return this.__dispatcher.dom.videoElement[e]},set:undefined,configurable:!1,enumerable:!1})}),videoMethods.forEach(function(e){_Object$defineProperty(t,e,{get:function(){var t=this.__dispatcher.dom.videoElement;return bind(t[e],t)},set:undefined,configurable:!1,enumerable:!1})}),applyDecorators(this,e._realDomAttr.concat(e._kernelProperty).reduce(function(t,r){return t[r]=[accessor({get:function(){return e[r]},set:function(t){return e[r]=t,t}}),nonenumerable],t},{}),{self:!0}),kernelMethods.forEach(function(e){_Object$defineProperty(t,e,{value:function(){for(var t=this,r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];return new _Promise(function(r){var i;t.__dispatcher.bus.once(t.__id,"_"+e,r),(i=t.__dispatcher.bus)[/^(seek)$/.test(e)?"emitSync":"emit"].apply(i,[e].concat(_toConsumableArray(n)))})},configurable:!0,enumerable:!1,writable:!0})}),domMethods.forEach(function(e){"fullscreen"!==e&&_Object$defineProperty(t,e,{value:function(){var t;return(t=this.__dispatcher.dom)[e].apply(t,arguments)},configurable:!0,enumerable:!1,writable:!0})})}},{key:"$watch",value:function(e,t){var r=this,n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{},i=n.deep,o=n.diff,a=o===undefined||o,s=n.other,u=n.proxy,c=u!==undefined&&u;if(!isString(e)&&!isArray$1(e))throw new TypeError("$watch only accept string and Array<string> as key to find the target to spy on, but not "+e+", whose type is "+(void 0===e?"undefined":_typeof(e)));var l=!0,f=function(){!l||this instanceof VideoConfig&&!this.dispatcher.changeWatchable||bind(t,this).apply(undefined,arguments)},d=function g(){l=!1;var e=r.__unwatchHandlers.indexOf(g);e>-1&&r.__unwatchHandlers.splice(e,1)},h=isString(e)?e.split("."):e,p=h.pop(),y=this.__dispatcher.videoConfig;return applyDecorators(0===h.length&&!s&&y._realDomAttr.indexOf(p)>-1?y:["isFullscreen","fullscreenElement"].indexOf(p)>-1?this.__dispatcher.dom:getDeepProperty(s||this,h,{throwError:!0}),_defineProperty$1({},p,watch(f,{deep:i,diff:a,proxy:c})),{self:!0}),this.__unwatchHandlers.push(d),d}},{key:"$set",value:function(e,t,r){if(!isObject$1(e)&&!isArray$1(e))throw new TypeError("$set only support Array or Object, but not "+e+", whose type is "+(void 0===e?"undefined":_typeof(e)));if(!isFunction(e.__set))return void(e[t]=r);e.__set(t,r)}},{key:"$del",value:function(e,t){if(!isObject$1(e)&&!isArray$1(e))throw new TypeError("$del only support Array or Object, but not "+e+", whose type is "+(void 0===e?"undefined":_typeof(e)));if(!isFunction(e.__del))return void delete e[t];e.__del(t)}},{key:"load",value:function(){for(var e=this,t=arguments.length,r=Array(t),n=0;n<t;n++)r[n]=arguments[n];return new _Promise(function(t){var n;e.__dispatcher.bus.once(e.__id,"_load",t),(n=e.__dispatcher.bus).emit.apply(n,["load"].concat(r))})}},{key:"$silentLoad",value:function(){for(var e=this,t=arguments.length,r=Array(t),n=0;n<t;n++)r[n]=arguments[n];return this.__dispatcher.bus.emit("silentLoad").then(function(){var t;return(t=e.__dispatcher).silentLoad.apply(t,r)}).then(function(t){e.__dispatcher.bus.trigger("silentLoad",t)})}},{key:"$fullscreen",value:function(){var e=!(arguments.length>0&&arguments[0]!==undefined)||arguments[0],t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"container";if(!this.__dispatcher.bus.emitSync("fullscreen",e,t))return!1;var r=this.__dispatcher.dom.fullscreen(e,t);return this.__dispatcher.bus.triggerSync("fullscreen",e,t),r}},{key:"$emit",value:function(e){var t;if(!isString(e))throw new TypeError("emit key parameter must be String");for(var r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];(t=this.__dispatcher.bus).emit.apply(t,[e].concat(_toConsumableArray(n)))}},{key:"$emitSync",value:function(e){var t;if(!isString(e))throw new TypeError("emitSync key parameter must be String");for(var r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];return(t=this.__dispatcher.bus).emitSync.apply(t,[e].concat(_toConsumableArray(n)))}},{key:"$on",value:function(e,t){this.__dispatcher.bus.on(this.__id,e,t),this.__addEvents(e,t)}},{key:"$off",value:function(e,t){this.__dispatcher.bus.off(this.__id,e,t),this.__removeEvents(e,t)}},{key:"$once",value:function(e,t){var r=this,n=function i(){bind(t,this).apply(undefined,arguments),r.__removeEvents(e,i)};r.__addEvents(e,n),this.__dispatcher.bus.once(this.__id,e,n)}},{key:"$css",value:function(e){for(var t,r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];return(t=this.__dispatcher.dom)[e+"Style"].apply(t,n)}},{key:"$attr",value:function(e){for(var t,r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];if("set"===e&&/video/.test(n[0])){if(!this.__dispatcher.videoConfigReady)return n[2];if(this.__dispatcher.videoConfig._realDomAttr.indexOf(n[1])>-1){var o=n[1],a=n[2];return this.__dispatcher.videoConfig[o]=a,a}}return(t=this.__dispatcher.dom)[e+"Attr"].apply(t,n)}},{key:"__addEvents",value:function(e,t){this.__events[e]=this.__events[e]||[],this.__events[e].push(t)}},{key:"__removeEvents",value:function(e,t){if(!isEmpty(this.__events[e])){var r=this.__events[e].indexOf(t);r<0||(this.__events[e].splice(r,1),isEmpty(this.__events[e])&&delete this.__events[e])}}},{key:"__destroy",value:function(){var e=this;this.__unwatchHandlers.forEach(function(e){return e()}),_Object$keys(this.__events).forEach(function(t){isArray$1(e.__events[t])&&e.__events[t].forEach(function(r){return e.$off(t,r)})}),delete this.__events}},{key:"currentTime",get:function(){return this.__dispatcher.kernel.currentTime},set:function(e){this.__dispatcher.bus.emitSync("seek",e)}},{key:"$plugins",get:function(){return this.__dispatcher.plugins}},{key:"$pluginOrder",get:function(){return this.__dispatcher.order}},{key:"$wrapper",get:function(){return this.__dispatcher.dom.wrapper}},{key:"$container",get:function(){return this.__dispatcher.dom.container}},{key:"$video",get:function(){return this.__dispatcher.dom.videoElement}},{key:"isFullscreen",get:function(){return this.__dispatcher.dom.isFullscreen}},{key:"fullscreenElement",get:function(){return this.__dispatcher.dom.fullscreenElement}},{key:"container",get:function(){return this.__dispatcher.containerConfig},set:function(e){if(!isObject$1(e))throw new Error("The config of container must be Object, but not "+(void 0===e?"undefined":_typeof(e))+".");return deepAssign(this.__dispatcher.containerConfig,e),this.__dispatcher.container}}]),e}(),_applyDecoratedDescriptor$3(_class2$1.prototype,"$silentLoad",[_dec2$2],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$silentLoad"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$fullscreen",[_dec3$2,_dec4$2,_dec5$1],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$fullscreen"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$emit",[_dec6],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$emit"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$emitSync",[_dec7],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$emitSync"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$on",[_dec8,_dec9,_dec10],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$on"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$off",[_dec11,_dec12,_dec13],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$off"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$once",[_dec14,_dec15],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$once"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$css",[_dec16,_dec17],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$css"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$attr",[_dec18,_dec19],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$attr"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$plugins",[nonenumerable],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$plugins"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$pluginOrder",[nonenumerable],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$pluginOrder"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$wrapper",[nonenumerable],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$wrapper"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$container",[nonenumerable],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$container"),_class2$1.prototype),_applyDecoratedDescriptor$3(_class2$1.prototype,"$video",[nonenumerable],_Object$getOwnPropertyDescriptor(_class2$1.prototype,"$video"),_class2$1.prototype),_class$4=_class2$1))||_class$4),_dec$3,_class$3,Plugin=(_dec$3=autobindClass())(_class$3=function(e){function t(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},r=e.id,n=e.name,i=e.level,o=i===undefined?0:i,a=e.operable,s=a===undefined||a,u=e.beforeCreate,c=e.create,l=e.init,f=e.inited,d=e.destroy,h=e.events,p=h===undefined?{}:h,y=e.data,g=y===undefined?{}:y,m=e.computed,_=m===undefined?{}:m,v=e.methods,b=v===undefined?{}:v,$=e.el,w=e.penetrate,E=w!==undefined&&w,S=e.inner,O=S===undefined||S,T=e.autoFocus,A=e.className,x=arguments[1],k=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{name:n};_classCallCheck(this,t);var D=_possibleConstructorReturn(this,(t.__proto__||_Object$getPrototypeOf(t)).call(this));if(D.destroyed=!1,D.VERSION="0.6.2",D.__operable=!0,D.__level=0,isEmpty(x))throw new TypeError("lack of dispatcher");if(!isString(r))throw new TypeError("id of PluginConfig must be string");D.__id=r,D.__dispatcher=x,D.$videoConfig=D.__dispatcher.videoConfig,D.__wrapAsVideo(D.$videoConfig),D.beforeCreate=D.beforeCreate||u;try{isFunction(D.beforeCreate)&&D.beforeCreate({events:p,data:g,computed:_,methods:b},k)}catch(P){D.$throwError(P)}if(!isEmpty(b)&&isObject$1(b)&&_Object$keys(b).forEach(function(e){var t=b[e];if(!isFunction(t))throw new TypeError("plugins methods must be Function");_Object$defineProperty(D,e,{value:bind(t,D),writable:!0,enumerable:!1,configurable:!0})}),!isEmpty(p)&&isObject$1(p)&&_Object$keys(p).forEach(function(e){if(!isFunction(p[e]))throw new TypeError("plugins events hook must bind with Function");D.$on(e,p[e])}),!isEmpty(g)&&isObject$1(g)&&deepAssign(D,g),!isEmpty(_)&&isObject$1(_)){var I=_Object$keys(_).reduce(function(e,t){var r=_[t];return isFunction(r)?(e[t]=accessor({get:r}),e):isObject$1(r)&&(isFunction(r.get)||isFunction(r.set))?(e[t]=accessor(r),e):e},{});applyDecorators(D,I,{self:!0})}D.create=D.create||c,D.init=D.init||l,D.inited=D.inited||f,D.destroy=D.destroy||d,D.$dom=D.__dispatcher.dom.insertPlugin(D.__id,$,{penetrate:E,inner:O,autoFocus:T,className:A}),D.$inner=O,D.$autoFocus=T,D.$penetrate=E,applyDecorators(D,{$inner:frozen,$autoFocus:frozen,$penetrate:frozen},{self:!0}),D.$operable=isBoolean(k.operable)?k.operable:s,D.__level=isInteger(k.level)?k.level:o,D.$config=k;try{isFunction(D.create)&&D.create()}catch(P){D.$throwError(P)}return D}return _inherits(t,e),_createClass(t,[{key:"__init",value:function(e){try{isFunction(this.init)&&this.init(e)}catch(t){this.$throwError(t)}}},{key:"__inited",value:function(){var e=this,t=void 0;try{t=isFunction(this.inited)&&this.inited()}catch(r){this.$throwError(r)}return this.readySync=!isPromise(t),this.ready=this.readySync?_Promise.resolve():t.then(function(t){return e.readySync=!0,t})["catch"](function(t){return isError(t)?e.$throwError(t):_Promise.reject(t)}),this.readySync||this.ready}},{key:"$bumpToTop",value:function(){var e=this.__dispatcher._getTopLevel(this.$inner);this.$level=e+1}},{key:"$throwError",value:function(e){this.__dispatcher.throwError(e)}},{key:"$destroy",value:function(){isFunction(this.destroy)&&this.destroy(),_get(t.prototype.__proto__||_Object$getPrototypeOf(t.prototype),"__destroy",this).call(this),this.__dispatcher.dom.removePlugin(this.__id),delete this.__dispatcher,delete this.$dom,this.destroyed=!0}},{key:"$operable",set:function(e){isBoolean(e)&&(this.$dom.style.pointerEvents=e?"auto":"none",this.__operable=e)},get:function(){return this.__operable}},{key:"$level",set:function(e){isInteger(e)&&(this.__level=e,this.__dispatcher._sortZIndex())},get:function(){return this.__level}}]),t}(VideoWrapper))||_class$3,_dec$6,_dec2$4,_dec3$3,_dec4$3,_dec5$2,_dec6$1,_class$6,Dom=(_dec$6=waituntil("__dispatcher.videoConfigReady"),_dec2$4=before(attrOperationCheck,targetCheck),_dec3$3=before(attrOperationCheck,targetCheck),_dec4$3=before(attrOperationCheck,targetCheck),_dec5$2=before(attrOperationCheck,targetCheck),_dec6$1=before(targetCheck),_class$6=function(){function e(t,r){var n=this;if(_classCallCheck(this,e),this.plugins={},this.originHTML="",this.videoEventHandlerList=[],this.videoDomEventHandlerList=[],this.containerDomEventHandlerList=[],this.wrapperDomEventHandlerList=[],this.__domEventHandlerList={},this.__mouseInVideo=!1,this.__videoExtendedNodes=[],this.isFullscreen=!1,this.fullscreenElement=undefined,this.__dispatcher=r,!isElement(t)&&!isString(t))throw new TypeError("Wrapper can only be string or HTMLElement, but not "+(void 0===t?"undefined":_typeof(t)));var i=$(t);if(0===i.length)throw new TypeError("Can not get dom node accroding wrapper. Please check your wrapper");this.wrapper=i[0],this.originHTML=this.wrapper.innerHTML;var o=i.find("video")[0];o||(o=document.createElement("video")),this.installVideo(o),this._addDomEvents(this.container,this.containerDomEventHandlerList,function(e){return function(){for(var t,r=arguments.length,i=Array(r),o=0;o<r;o++)i[o]=arguments[o];return(t=n.__dispatcher.bus).triggerSync.apply(t,["c_"+e].concat(_toConsumableArray(i)))}}),this._addDomEvents(this.wrapper,this.wrapperDomEventHandlerList,function(e){return function(){for(var t,r=arguments.length,i=Array(r),o=0;o<r;o++)i[o]=arguments[o];return(t=n.__dispatcher.bus).triggerSync.apply(t,["w_"+e].concat(_toConsumableArray(i)))}}),this._fullscreenMonitor(),index.on("fullscreenchange",this._fullscreenMonitor)}return _createClass(e,[{key:"installVideo",value:function(e){var t=this;if(this.__videoExtendedNodes.push(e),setAttr(e,"tabindex",-1),this._autoFocusToVideo(e),isElement(this.container)){var r=this.container;0===r.childNodes.length?r.appendChild(e):r.insertBefore(e,r.childNodes[0])
}else e.parentElement&&isElement(e.parentElement)&&e.parentElement!==this.wrapper?this.container=e.parentElement:(this.container=document.createElement("container"),$(this.container).append(e));return this.container.parentElement!==this.wrapper&&$(this.wrapper).append(this.container),videoEvents.forEach(function(r){var n=function(){for(var e,n=arguments.length,i=Array(n),o=0;o<n;o++)i[o]=arguments[o];return(e=t.__dispatcher.bus).trigger.apply(e,[r].concat(_toConsumableArray(i)))};t.videoEventHandlerList.push(n),addEvent(e,r,n)}),this._addDomEvents(e,this.videoDomEventHandlerList,function(e){return t._getEventHandler(e,{penetrate:!0})}),this.videoElement=e,e}},{key:"removeVideo",value:function(){var e=this,t=this.videoElement;return this._autoFocusToVideo(this.videoElement,!1),videoEvents.forEach(function(t,r){removeEvent(e.videoElement,t,e.videoEventHandlerList[r])}),this.videoEventHandlerList=[],domEvents.forEach(function(t,r){removeEvent(e.videoElement,t,e.videoDomEventHandlerList[r])}),this.videoDomEventHandlerList=[],$(t).remove(),delete this.videoElement,t}},{key:"insertPlugin",value:function(e,t){var r=this,n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};if(!isString(e))throw new TypeError("insertPlugin id parameter must be string");if(isElement(this.plugins[e])&&this.removePlugin(e),isString(t))if(isHTMLString(t)){var i=document.createElement("div");i.innerHTML=t,t=i.children[0]}else t=document.createElement(hypenate(t));else isObject$1(t)&&(n=t);var o=n,a=o.inner,s=o.penetrate,u=o.autoFocus,c=n,l=c.className,f=t&&isElement(t)?t:document.createElement("div");isArray$1(l)&&(l=l.join(" ")),isString(l)&&addClassName(f,l),this.plugins[e]=f;var d=a?this.container:this.wrapper,h=a?this.videoElement:this.container;return(isBoolean(u)?u:a)&&this._autoFocusToVideo(f),s&&(this.__domEventHandlerList[e]=this.__domEventHandlerList[e]||[],this._addDomEvents(f,this.__domEventHandlerList[e],function(e){return r._getEventHandler(e,{penetrate:s})}),this.__videoExtendedNodes.push(f)),d.lastChild===h?(d.appendChild(f),f):(d.insertBefore(f,h.nextSibling),f)}},{key:"removePlugin",value:function(e){var t=this;if(isString(e)){var r=this.plugins[e];isElement(r)&&(r.parentNode&&r.parentNode.removeChild(r),this._autoFocusToVideo(r,!0)),isEmpty(this.__domEventHandlerList[e])||(domEvents.forEach(function(r,n){removeEvent(t.plugins[e],r,t.__domEventHandlerList[e][n])}),delete this.__domEventHandlerList[e]),delete this.plugins[e]}}},{key:"setPluginsZIndex",value:function(e){var t=this;e.forEach(function(e,r){return setStyle(e.match(/^(videoElement|container)$/)?t[e]:t.plugins[e],"z-index",++r)})}},{key:"setAttr",value:function(e,t,r){setAttr(this[e],t,r)}},{key:"getAttr",value:function(e,t){return getAttr(this[e],t)}},{key:"setStyle",value:function(e,t,r){setStyle(this[e],t,r)}},{key:"getStyle",value:function(e,t){return getStyle(this[e],t)}},{key:"requestFullscreen",value:function(e){return index.open(this[e])}},{key:"exitFullscreen",value:function(){return index.exit()}},{key:"fullscreen",value:function(){for(var e=!(arguments.length>0&&arguments[0]!==undefined)||arguments[0],t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"container",r=arguments.length,n=Array(r>2?r-2:0),i=2;i<r;i++)n[i-2]=arguments[i];return e?this.requestFullscreen.apply(this,[t].concat(_toConsumableArray(n))):this.exitFullscreen.apply(this,_toConsumableArray(n))}},{key:"focus",value:function(){this.videoElement.focus()}},{key:"destroy",value:function(){var e=this;this.removeVideo(),domEvents.forEach(function(t,r){removeEvent(e.container,t,e.containerDomEventHandlerList[r]),removeEvent(e.wrapper,t,e.wrapperDomEventHandlerList[r])}),index.off("fullscreenchange",this._fullscreenMonitor),this.wrapper.innerHTML=this.originHTML,delete this.wrapper,delete this.plugins}},{key:"_addDomEvents",value:function(e,t,r){domEvents.forEach(function(n){var i=r(n);if(t.push(i),passiveEvents.indexOf(n)>-1)return void addEvent(e,n,i,!1,{passive:!0});addEvent(e,n,i)})}},{key:"_autoFocusToVideo",value:function(e){var t=arguments.length>1&&arguments[1]!==undefined&&arguments[1];(t?removeEvent:addEvent)(e,"mouseup",this._focusToVideo,!1,!0),(t?removeEvent:addEvent)(e,"touchend",this._focusToVideo,!1,!0)}},{key:"_focusToVideo",value:function(){var e=window.scrollX,t=window.scrollY;isFunction(this.videoElement.focus)&&this.videoElement.focus(),window.scrollTo(e,t)}},{key:"_fullscreenMonitor",value:function(e){var t=index.fullscreenElement,r=this.isFullscreen;!t||!isPosterityNode(this.wrapper,t)&&t!==this.wrapper?(this.isFullscreen=!1,this.fullscreenElement=undefined):(this.isFullscreen=!0,this.fullscreenElement=this.wrapper===t?"wrapper":this.container===t?"container":this.videoElement===t?"video":t),isEvent(e)&&r!==this.isFullscreen&&this.__dispatcher.bus.triggerSync("fullscreenchange",e)}},{key:"_getEventHandler",value:function(e,t){var r=this;if(!t.penetrate||["mouseenter","mouseleave"].indexOf(e)<0)return function(){for(var t,n=arguments.length,i=Array(n),o=0;o<n;o++)i[o]=arguments[o];(t=r.__dispatcher.bus).triggerSync.apply(t,[e].concat(i))};var n=function(e){return r.__videoExtendedNodes.indexOf(e)>-1||r.__videoExtendedNodes.reduce(function(t,r){return t||isPosterityNode(r,e)},!1)};return function(){for(var e=arguments.length,t=Array(e),i=0;i<e;i++)t[i]=arguments[i];var o=t[0],a=o.toElement,s=o.currentTarget,u=o.relatedTarget,c=o.type,l=a||u;if(r.__mouseInVideo&&"mouseleave"===c&&!n(l)){var f;return r.__mouseInVideo=!1,(f=r.__dispatcher.bus).triggerSync.apply(f,["mouseleave"].concat(t))}if(!r.__mouseInVideo&&"mouseenter"===c&&n(s)){var d;return r.__mouseInVideo=!0,(d=r.__dispatcher.bus).triggerSync.apply(d,["mouseenter"].concat(t))}}}}]),e}(),_applyDecoratedDescriptor$5(_class$6.prototype,"setAttr",[_dec$6,_dec2$4],_Object$getOwnPropertyDescriptor(_class$6.prototype,"setAttr"),_class$6.prototype),_applyDecoratedDescriptor$5(_class$6.prototype,"getAttr",[_dec3$3],_Object$getOwnPropertyDescriptor(_class$6.prototype,"getAttr"),_class$6.prototype),_applyDecoratedDescriptor$5(_class$6.prototype,"setStyle",[_dec4$3],_Object$getOwnPropertyDescriptor(_class$6.prototype,"setStyle"),_class$6.prototype),_applyDecoratedDescriptor$5(_class$6.prototype,"getStyle",[_dec5$2],_Object$getOwnPropertyDescriptor(_class$6.prototype,"getStyle"),_class$6.prototype),_applyDecoratedDescriptor$5(_class$6.prototype,"requestFullscreen",[_dec6$1],_Object$getOwnPropertyDescriptor(_class$6.prototype,"requestFullscreen"),_class$6.prototype),_applyDecoratedDescriptor$5(_class$6.prototype,"_focusToVideo",[autobind],_Object$getOwnPropertyDescriptor(_class$6.prototype,"_focusToVideo"),_class$6.prototype),_applyDecoratedDescriptor$5(_class$6.prototype,"_fullscreenMonitor",[autobind],_Object$getOwnPropertyDescriptor(_class$6.prototype,"_fullscreenMonitor"),_class$6.prototype),_class$6),defaultContainerConfig={width:"100%",height:"100%",position:"relative",display:"block"},Vessel=function t(e,r,n){var i=this;_classCallCheck(this,t),this.__dispatcher=e,this.__target=r,["width","height","position","display"].forEach(function(e){_Object$defineProperty(i,e,{get:function(){return this.__dispatcher.dom.getStyle(this.__target,e)},set:function(t){if(isNumber(t)&&(t+="px"),!isString(t))throw new Error("The value of "+e+" in "+this.__target+"Config must be string, but not "+(void 0===t?"undefined":_typeof(t))+".");return this.__dispatcher.dom.setStyle(this.__target,e,t),t},configurable:!0,enumerable:!0})}),deepAssign(this,n)},_dec$1,_dec2,_dec3,_dec4,_dec5,_class$1,pluginConfigSet={},kernelsSet={},Dispatcher=(_dec$1=before(convertNameIntoId),_dec2=before(checkPluginConfig),_dec3=before(convertNameIntoId),_dec4=before(convertNameIntoId),_dec5=before(convertNameIntoId),_class$1=function(){function e(t,r){var n=this;if(_classCallCheck(this,e),this.plugins={},this.order=[],this.readySync=!1,this.zIndexMap={inner:[],outer:[]},this.changeWatchable=!0,this.kernelEventHandlerList=[],!isObject$1(t))throw new TypeError('UserConfig must be an Object, but not "'+t+'" in '+(void 0===t?"undefined":_typeof(t)));this.dom=new Dom(t.wrapper,this),this.bus=new Bus(this),this.vm=r,this.videoConfigReady=!1,this.videoConfig=new VideoConfig(this,t),isArray$1(t.plugins)&&!isArray$1(t.plugin)&&(t.plugin=t.plugins,delete t.plugins),this._initUserPlugin(t.plugin);var i=deepAssign({},defaultContainerConfig,t.container||{});this.order.forEach(function(e){return n.plugins[e].__init(n.videoConfig,i)}),this.videoConfigReady=!0,this.videoConfig.init(),this.containerConfig=new Vessel(this,"container",i),this.kernel=this._createKernel(this.dom.videoElement,this.videoConfig),this._bindKernelEvents(this.kernel);var o=[];this.order.forEach(function(e){var t=n.plugins[e].__inited();isPromise(t)&&o.push(t)}),this.readySync=0===o.length,this.ready=this.readySync?_Promise.resolve():_Promise.all(o).then(function(){n.readySync=!0,n.bus.trigger("ready"),n._autoloadVideoSrcAtFirst()}),this.readySync&&this._autoloadVideoSrcAtFirst()}return _createClass(e,[{key:"use",value:function(t){if(isString(t)&&(t={name:t,alias:undefined}),!isObject$1(t)||isObject$1(t)&&!isString(t.name))throw new TypeError("pluginConfig do not match requirement");isString(t.alias)||(t.alias=undefined);var r=t,n=r.name,i=r.alias;t.name=i||n,delete t.alias;var o=camelize(n),a=camelize(i||n),s=t,u=e.getPluginConfig(o);if(isEmpty(u))throw new TypeError("You have not installed plugin "+o);isObject$1(u)&&(u.id=a);var c=isFunction(u)?new u({id:a},this,s):new Plugin(u,this,s);return this.plugins[a]=c,_Object$defineProperty(this.vm,a,{value:c,configurable:!0,enumerable:!1,writable:!1}),this.order.push(a),this._sortZIndex(),this.videoConfigReady&&c.__inited(),c.ready}},{key:"unuse",value:function(e){var t=this.plugins[e];if(!isObject$1(t)||!isFunction(t.$destroy))return void delete this.plugins[e];t.$destroy();var r=this.order.indexOf(e);r>-1&&this.order.splice(r,1),delete this.plugins[e],delete this.vm[e]}},{key:"throwError",value:function(e){this.vm.__throwError(e)}},{key:"silentLoad",value:function(e){var t=this,r=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},n=r.duration,i=n===undefined?3:n,o=r.bias,a=o===undefined?0:o,s=r.repeatTimes,u=s===undefined?0:s,c=r.increment,l=c===undefined?0:c,f=r.isLive,d=f===undefined?this.videoConfig.isLive:f,h=r.box,p=h===undefined?this.videoConfig.box:h,y=r.kernels,g=y===undefined?this.videoConfig.kernels:y,m=r.preset,_=m===undefined?this.videoConfig.preset:m,v=r.immediate||d,b={isLive:d,box:p,src:e,kernels:g,preset:_};return runRejectableQueue(new Array(u+1).fill(1).map(function(e,n){return function(){return new _Promise(function(e,o){r.abort&&o({error:!0,message:"user abort the mission"});var s=document.createElement("video"),c=t.kernel.currentTime+i+l*n;s.muted=!0;var f=!1,h=void 0,p=void 0,y=void 0,g=void 0,m=function _(){var r=t.kernel.currentTime;if(a<=0&&r>=c||a>0&&(Math.abs(c-r)<=a&&f||r-c>a))return removeEvent(t.dom.videoElement,"timeupdate",_),removeEvent(s,"error",p,!0),f?o({error:!1,video:s,kernel:h}):(removeEvent(s,"canplay",y,!0),removeEvent(s,"loadedmetadata",g,!0),h.destroy(),e())};y=function(){if(f=!0,v)return removeEvent(t.dom.videoElement,"timeupdate",m),removeEvent(s,"error",p,!0),o({error:!1,video:s,kernel:h})},g=function(){d||h.seek(c)},p=function(r){removeEvent(s,"canplay",y,!0),removeEvent(s,"loadedmetadata",g,!0),removeEvent(t.dom.videoElement,"timeupdate",m),h.off("error",p);var i=void 0;if(r.target===h){var a=r.data.errmsg;Log$1.error("chimee's silent bump into a kernel error",a),i=new Error(a)}else i=isEmpty(s.error)?new Error("unknow video error"):new Error(s.error.message),Log$1.error("chimee's silentload",i.message);return h.destroy(),t._silentLoadTempKernel=undefined,n===u?o(i):e(i)},addEvent(s,"canplay",y,!0),addEvent(s,"loadedmetadata",g,!0),addEvent(s,"error",p,!0),h=t._createKernel(s,b),t._silentLoadTempKernel=h,h.on("error",p),addEvent(t.dom.videoElement,"timeupdate",m),h.load()})}})).then(function(){var t="The silentLoad for "+e+" timed out. Please set a longer duration or check your network";return _Promise.reject(new Error(t))})["catch"](function(e){if(isError(e))return _Promise.reject(e);if(e.error)return _Promise.reject(new Error(e.message));var n=e.video,i=e.kernel;return r.abort?(i.destroy(),_Promise.reject(new Error("user abort the mission"))):t.dom.videoElement.paused?(t.switchKernel({video:n,kernel:i,config:b}),_Promise.resolve()):new _Promise(function(e){addEvent(n,"play",function(){t.switchKernel({video:n,kernel:i,config:b}),e()},!0),n.play()})})}},{key:"load",value:function(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!isEmpty(t)){var r=this.videoConfig,n=t.isLive,i=n===undefined?r.isLive:n,o=t.box,a=o===undefined?r.box:o,s=t.preset,u=s===undefined?r.preset:s,c=t.kernels,l=c===undefined?r.kernels:c,f=document.createElement("video"),d={isLive:i,box:a,preset:u,src:e,kernels:l},h=this._createKernel(f,d);this.switchKernel({video:f,kernel:h,config:d})}var p=this.videoConfig.autoload;this._changeUnwatchable(this.videoConfig,"autoload",!1),this.videoConfig.src=e||this.videoConfig.src,this.kernel.load(this.videoConfig.src),this._changeUnwatchable(this.videoConfig,"autoload",p)}},{key:"switchKernel",value:function(e){var t=this,r=e.video,n=e.kernel,i=e.config,o=this.kernel,a=deepClone(this.videoConfig);this.dom.removeVideo(),this.dom.installVideo(r),this.videoConfig.changeWatchable=!1,this.videoConfig.autoload=!1,this.videoConfig.src=i.src,this.videoConfig._realDomAttr.forEach(function(e){"src"!==e&&(t.videoConfig[e]=a[e])}),this.videoConfig.changeWatchable=!0,this._bindKernelEvents(o,!0),this._bindKernelEvents(n),this.kernel=n,this._silentLoadTempKernel=undefined;var s=i.isLive,u=i.box,c=i.preset,l=i.kernels;_Object$assign(this.videoConfig,{isLive:s,box:u,preset:c,kernels:l}),o.destroy()}},{key:"destroy",value:function(){for(var e in this.plugins)this.unuse(e);this.bus.destroy(),delete this.bus,this.dom.destroy(),delete this.dom,this._bindKernelEvents(this.kernel,!0),this.kernel.destroy(),delete this.kernel,delete this.vm,delete this.plugins,delete this.order}},{key:"_initUserPlugin",value:function(){var e=this,t=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return isArray$1(t)||(t=[]),t.map(function(t){return e.use(t)})}},{key:"_sortZIndex",value:function(){var e=this,t=this.order.reduce(function(t,r){var n=e.plugins[r];if(isEmpty(n))return t;var i=t[n.$inner?"inner":"outer"],o=n.$level;return i[o]=i[o]||[],i[o].push(r),t},{inner:{},outer:{}}),r=t.inner,n=t.outer;r[0]=r[0]||[],r[0].unshift("videoElement"),n[0]=n[0]||[],n[0].unshift("container");var i=transObjectAttrIntoArray(r),o=transObjectAttrIntoArray(n);this.dom.setPluginsZIndex(i),this.dom.setPluginsZIndex(o),this.zIndexMap.inner=i,this.zIndexMap.outer=o}},{key:"_getTopLevel",value:function(e){var t=this.zIndexMap[e?"inner":"outer"],r=this.plugins[t[t.length-1]];return isEmpty(r)?0:r.$level}},{key:"_autoloadVideoSrcAtFirst",value:function(){if(this.videoConfig.autoload){if(!this.videoConfig.src)return void Log$1.warn("You have not set the src, so you better set autoload to be false. Accroding to https://github.com/Chimeejs/chimee/blob/master/doc/zh-cn/chimee-api.md#src.");this.bus.emit("load",this.videoConfig.src)}}},{key:"_changeUnwatchable",value:function(e,t,r){this.changeWatchable=!1,e[t]=r,this.changeWatchable=!0}},{key:"_createKernel",value:function(e,t){var r=t.kernels,n=t.preset,i=isArray$1(r)?r.reduce(function(e,t){return isFunction(kernelsSet[t])?(e[t]=kernelsSet[t],e):(Log$1.warn("You have not installed kernel for "+t+"."),e)},{}):isObject$1(r)?r:{};return t.preset=_Object$assign(i,n),new Kernel(e,t)}},{key:"_bindKernelEvents",value:function(e){var t=this,r=arguments.length>1&&arguments[1]!==undefined&&arguments[1];kernelEvents.forEach(function(n,i){if(!r){var o=function(){for(var e,r=arguments.length,i=Array(r),o=0;o<r;o++)i[o]=arguments[o];return(e=t.bus).triggerSync.apply(e,[n].concat(_toConsumableArray(i)))};return e.on(n,o),void t.kernelEventHandlerList.push(o)}var a=t.kernelEventHandlerList[i];e.off(n,a)}),r?(this.kernelEventHandlerList=[],e.off("error",this.throwError)):e.on("error",this.throwError)}}],[{key:"install",value:function(e){var t=e.name,r=camelize(t);isEmpty(pluginConfigSet[r]);var n=isFunction(e)?e:deepAssign({id:r},e);return pluginConfigSet[r]=n,r}},{key:"hasInstalled",value:function(e){return!isEmpty(pluginConfigSet[e])}},{key:"uninstall",value:function(e){delete pluginConfigSet[e]}},{key:"getPluginConfig",value:function(e){return pluginConfigSet[e]}},{key:"installKernel",value:function(e,t){(isObject$1(e)?_Object$entries(e):[[e,t]]).forEach(function(e){var t=_slicedToArray(e,2),r=t[0],n=t[1];if(!isFunction(n))throw new Error("The kernel you install on "+r+" must be a Function, but not "+(void 0===n?"undefined":_typeof(n)));isFunction(kernelsSet[r])&&Log$1.warn("You have alrady install a kenrle on "+r+", and now we will replace it"),kernelsSet[r]=n})}},{key:"uninstallKernel",value:function(e){delete kernelsSet[e]}},{key:"hasInstalledKernel",value:function(e){return isFunction(kernelsSet[e])}}]),e}(),_applyDecoratedDescriptor$1(_class$1.prototype,"unuse",[_dec$1],_Object$getOwnPropertyDescriptor(_class$1.prototype,"unuse"),_class$1.prototype),_applyDecoratedDescriptor$1(_class$1.prototype,"throwError",[autobind],_Object$getOwnPropertyDescriptor(_class$1.prototype,"throwError"),_class$1.prototype),_applyDecoratedDescriptor$1(_class$1,"install",[_dec2],_Object$getOwnPropertyDescriptor(_class$1,"install"),_class$1),_applyDecoratedDescriptor$1(_class$1,"hasInstalled",[_dec3],_Object$getOwnPropertyDescriptor(_class$1,"hasInstalled"),_class$1),_applyDecoratedDescriptor$1(_class$1,"uninstall",[_dec4],_Object$getOwnPropertyDescriptor(_class$1,"uninstall"),_class$1),_applyDecoratedDescriptor$1(_class$1,"getPluginConfig",[_dec5],_Object$getOwnPropertyDescriptor(_class$1,"getPluginConfig"),_class$1),_class$1),_class$7,_descriptor$2,GlobalConfig=(_class$7=function(){function e(){_classCallCheck(this,e),this.log={error:!0,info:!0,warn:!0,debug:!0,verbose:!0},_initDefineProp$2(this,"_silent",_descriptor$2,this),this.errorHandler=undefined;var t=_Object$keys(this.log).reduce(function(e,t){return e[t]=accessor({get:function(){return Log$1["ENABLE_"+t.toUpperCase()]},set:function(e){return Log$1["ENABLE_"+t.toUpperCase()]=e,!0===e&&(this.silent=!1),e}}),e},{});applyDecorators(this.log,t,{self:!0})}return _createClass(e,[{key:"silent",get:function(){return this._silent},set:function(e){var t=this;e=!!e,this._silent=e,_Object$keys(this.log).forEach(function(r){t.log[r]=!e})}}]),e}(),_descriptor$2=_applyDecoratedDescriptor$6(_class$7.prototype,"_silent",[nonenumerable],{enumerable:!0,initializer:function(){return!1}}),_class$7),_dec,_class,_class2,_descriptor,_descriptor2,_descriptor3,_init,_init2,_init3,_init4,_init5,_init6,_init7,_init8,_init9,_class3,_temp,Chimee=(_dec=autobindClass())((_temp=_class3=function(e){function t(e){_classCallCheck(this,t);var r=_possibleConstructorReturn(this,(t.__proto__||_Object$getPrototypeOf(t)).call(this));if(r.destroyed=!1,_initDefineProp(r,"__id",_descriptor,r),_initDefineProp(r,"version",_descriptor2,r),_initDefineProp(r,"config",_descriptor3,r),isString(e)||isElement(e))e={wrapper:e,controls:!0};else{if(!isObject$1(e))throw new Error("You must pass in an Object containing wrapper or string or element to new a Chimee");if(!e.wrapper)throw new Error("You must pass in an legal object")}return r.__dispatcher=new Dispatcher(e,r),r.ready=r.__dispatcher.ready,r.readySync=r.__dispatcher.readySync,r.__wrapAsVideo(r.__dispatcher.videoConfig),r}return _inherits(t,e),_createClass(t,[{key:"destroy",value:function(){_get(t.prototype.__proto__||_Object$getPrototypeOf(t.prototype),"__destroy",this).call(this),this.__dispatcher.destroy(),this.destroyed=!0}},{key:"use",value:function(e){this.__dispatcher.use(e)}},{key:"unuse",value:function(e){this.__dispatcher.unuse(e)}},{key:"__throwError",value:function(e){isString(e)&&(e=new Error(e));var r=this.config.errorHandler||t.config.errorHandler;if(isFunction(r))return r(e);if(!t.config.silent)throw e}}]),t}(VideoWrapper),_class3.plugin=Plugin,_class3.config=new GlobalConfig,_class3.install=Dispatcher.install,_class3.uninstall=Dispatcher.uninstall,_class3.hasInstalled=Dispatcher.hasInstalled,_class3.installKernel=Dispatcher.installKernel,_class3.uninstallKernel=Dispatcher.uninstallKernel,_class3.hasInstalledKernel=Dispatcher.hasInstalledKernel,_class3.getPluginConfig=Dispatcher.getPluginConfig,_class2=_temp,_descriptor=_applyDecoratedDescriptor(_class2.prototype,"__id",[frozen],{enumerable:!0,initializer:function(){return"_vm"}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,"version",[frozen],{enumerable:!0,initializer:function(){return"0.6.2"}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,"config",[frozen],{enumerable:!0,initializer:function(){return{errorHandler:undefined}}}),_applyDecoratedDescriptor(_class2,"plugin",[frozen],(_init=_Object$getOwnPropertyDescriptor(_class2,"plugin"),_init=_init?_init.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init}}),_class2),_applyDecoratedDescriptor(_class2,"config",[frozen],(_init2=_Object$getOwnPropertyDescriptor(_class2,"config"),_init2=_init2?_init2.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init2}}),_class2),_applyDecoratedDescriptor(_class2,"install",[frozen],(_init3=_Object$getOwnPropertyDescriptor(_class2,"install"),_init3=_init3?_init3.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init3}}),_class2),_applyDecoratedDescriptor(_class2,"uninstall",[frozen],(_init4=_Object$getOwnPropertyDescriptor(_class2,"uninstall"),_init4=_init4?_init4.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init4}}),_class2),_applyDecoratedDescriptor(_class2,"hasInstalled",[frozen],(_init5=_Object$getOwnPropertyDescriptor(_class2,"hasInstalled"),_init5=_init5?_init5.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init5}}),_class2),_applyDecoratedDescriptor(_class2,"installKernel",[frozen],(_init6=_Object$getOwnPropertyDescriptor(_class2,"installKernel"),_init6=_init6?_init6.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init6}}),_class2),_applyDecoratedDescriptor(_class2,"uninstallKernel",[frozen],(_init7=_Object$getOwnPropertyDescriptor(_class2,"uninstallKernel"),_init7=_init7?_init7.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init7}}),_class2),_applyDecoratedDescriptor(_class2,"hasInstalledKernel",[frozen],(_init8=_Object$getOwnPropertyDescriptor(_class2,"hasInstalledKernel"),_init8=_init8?_init8.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init8}}),_class2),_applyDecoratedDescriptor(_class2,"getPluginConfig",[frozen],(_init9=_Object$getOwnPropertyDescriptor(_class2,"getPluginConfig"),_init9=_init9?_init9.value:undefined,{enumerable:!0,configurable:!0,writable:!0,initializer:function(){return _init9}}),_class2),_class=_class2))||_class;__$styleInject$1('container{position:relative}container,video{display:block;width:100%;height:100%;background:#000;outline:none}video:focus{outline:none}.chimee-flex-component svg:hover g,.chimee-flex-component svg g{fill:#fff;stroke:#fff}chimee-clarity-list,chimee-control-state-pause,chimee-control-state-play,chimee-progressbar-tip,chimee-screen-full,chimee-screen-small,chimee-volume-state-high,chimee-volume-state-low,chimee-volume-state-mute{display:none}chimee-control.full chimee-screen-full,chimee-control.pause chimee-control-state-pause,chimee-control.play chimee-control-state-play,chimee-control.small chimee-screen-small,chimee-volume.high chimee-volume-state-high,chimee-volume.low chimee-volume-state-low,chimee-volume.mute chimee-volume-state-mute{display:inline-block;width:1.4em;height:100%}chimee-control{display:block;height:100%;line-height:2em;font-size:14px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;font-family:Roboto,Arial,Helvetica,sans-serif;-webkit-transition:visibility .5s ease;transition:visibility .5s ease}chimee-control,chimee-control-wrap{position:absolute;bottom:0;left:0;width:100%}chimee-control-wrap{height:2.2em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;background:rgba(0,0,0,.5);-webkit-transition:bottom .5s ease;transition:bottom .5s ease;pointer-events:auto}.chimee-flex-component{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;height:2em;cursor:pointer}.chimee-flex-component svg{vertical-align:middle;width:2em;height:1.5em}chimee-control-state.chimee-flex-component{-ms-flex-preferred-size:3em;flex-basis:3em;text-align:right;margin-right:1em}chimee-control-state .left,chimee-control-state .right{-webkit-transition:d .2s ease-in-out;transition:d .2s ease-in-out}chimee-progresstime.chimee-flex-component{color:#fff;font-weight:400;text-align:center;white-space:nowrap}chimee-progresstime-pass,chimee-progresstime-total{display:inline}chimee-progressbar.chimee-flex-component{position:relative;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}chimee-progressbar-wrap{display:inline-block;height:100%;position:absolute;left:1em;right:1em;top:0}chimee-progressbar.progressbar-layout-top{position:static}chimee-progressbar.progressbar-layout-top chimee-progressbar-wrap{top:-1.6em;height:1.6em;left:0;right:0}chimee-progressbar.progressbar-layout-top .chimee-progressbar-line{left:0;top:.8em}.chimee-progressbar-line{position:absolute;top:.9em;left:0;display:inline-block;height:3px}chimee-progressbar-bg{width:100%;background:#4c4c4c}chimee-progressbar-buffer{width:0;background:#6f6f6f}chimee-progressbar-all{background:#de698c}chimee-progressbar-ball{content:"";position:absolute;right:-.8em;top:-.3em;display:inline-block;width:.8em;height:.8em;border-radius:.8em;background:#fff;pointer-events:none}chimee-progressbar-tip{position:absolute;bottom:.5em;top:-1.5em;left:0;z-index:1;padding:0 .5em;height:1.5em;background:#fff;line-height:1.5em;border-radius:4px;color:#000;text-align:center}chimee-volume.chimee-flex-component{cursor:pointer;padding:0;-ms-flex-preferred-size:7em;flex-basis:7em;white-space:nowrap;margin-right:1em;position:relative}chimee-volume.chimee-flex-component.vertical{padding-right:1em;-ms-flex-preferred-size:2em;flex-basis:2em}chimee-volume-state{display:inline-block;width:2em;vertical-align:top}chimee-volume .line,chimee-volume .ring1,chimee-volume .ring2{stroke-dasharray:150;stroke-dashoffset:150;-webkit-transition:stroke-dashoffset .7s ease-in-out;transition:stroke-dashoffset .7s ease-in-out}chimee-volume.high .ring1,chimee-volume.high .ring2,chimee-volume.low .ring2,chimee-volume.mute .line,chimee-volume.mute .ring1,chimee-volume.mute .ring2{stroke-dashoffset:0}chimee-volume.vertical:hover chimee-volume-bar{display:inline-block}chimee-volume.vertical chimee-volume-bar{position:absolute;top:-7em;left:-.2em;width:2em;height:4em;padding-bottom:3em;display:none;vertical-align:middle}chimee-volume.vertical chimee-volume-bar:before{content:"";position:absolute;left:0;right:0;top:0;bottom:1em;background:#212121;border-radius:4px}chimee-volume.vertical chimee-volume-bar-wrap{display:inline-block;position:absolute;bottom:1em;left:0;top:1em;right:0;height:4em}chimee-volume.vertical chimee-volume-bar-all,chimee-volume.vertical chimee-volume-bar-bg{position:absolute;bottom:0;left:1em;display:inline-block;width:2px;border-radius:4px}chimee-volume.vertical chimee-volume-bar-bg{height:4em;background:#4c4c4c;opacity:.5}chimee-volume.vertical chimee-volume-bar-all{background:#de698c}chimee-volume.vertical chimee-volume-bar-all:after{content:"";position:absolute;right:-.34em;top:-.4em;display:inline-block;width:.8em;height:.8em;border-radius:.8em;background:#fff;pointer-events:none}chimee-volume.horizonal chimee-volume-bar{position:relative;height:1.2em;width:4em;display:inline-block;vertical-align:middle}chimee-volume.horizonal chimee-volume-bar-all,chimee-volume.horizonal chimee-volume-bar-bg{position:absolute;top:.4em;left:0;display:inline-block;height:2px}chimee-volume.horizonal chimee-volume-bar-bg{width:4em;background:#4c4c4c;opacity:.5}chimee-volume.horizonal chimee-volume-bar-all{background:#de698c}chimee-volume.horizonal chimee-volume-bar-all:after{content:"";position:absolute;right:-.4em;top:-.3em;display:inline-block;width:.8em;height:.8em;border-radius:.8em;background:#fff;pointer-events:none}chimee-screen.chimee-flex-component{-ms-flex-preferred-size:3em;flex-basis:3em;text-align:left}chimee-clarity.chimee-flex-component{position:relative;color:#fff;width:6em;height:1.75em;padding:0;padding-right:1em;padding-left:1em;text-align:center;vertical-align:middle;font-size:16px}chimee-clarity.chimee-flex-component:hover chimee-clarity-list{display:inline-block}chimee-clarity.chimee-flex-component svg{width:auto;height:auto}chimee-clarity-list{position:absolute;left:0;bottom:1em;width:100%;padding-bottom:1.5em;opacity:.8;-webkit-box-sizing:content-box;box-sizing:content-box;line-height:0}chimee-clarity-list ul{margin:0;padding:.5em 0;background:#292929;line-height:2em}chimee-clarity-list li{list-style-type:none}chimee-clarity-list li.active,chimee-clarity-list li:hover{color:#de698c}chimee-clarity-list-arrow{position:absolute;bottom:1.5em;width:100%}',undefined);var _defined$2=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e},_toObject$2=function(e){return Object(_defined$2(e))},hasOwnProperty$1={}.hasOwnProperty,_has$2=function(e,t){return hasOwnProperty$1.call(e,t)},toString$2={}.toString,_cof$2=function(e){return toString$2.call(e).slice(8,-1)},_iobject$2=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==_cof$2(e)?e.split(""):Object(e)},_toIobject$2=function(e){return _iobject$2(_defined$2(e))},ceil$1=Math.ceil,floor$2=Math.floor,_toInteger$2=function(e){return isNaN(e=+e)?0:(e>0?floor$2:ceil$1)(e)},min$2=Math.min,_toLength$2=function(e){return e>0?min$2(_toInteger$2(e),9007199254740991):0},max$1=Math.max,min$1$1=Math.min,_toAbsoluteIndex$2=function(e,t){return e=_toInteger$2(e),e<0?max$1(e+t,0):min$1$1(e,t)},_arrayIncludes$2=function(e){return function(t,r,n){var i,o=_toIobject$2(t),a=_toLength$2(o.length),s=_toAbsoluteIndex$2(n,a);if(e&&r!=r){for(;a>s;)if((i=o[s++])!=i)return!0}else for(;a>s;s++)if((e||s in o)&&o[s]===r)return e||s||0;return!e&&-1}},_global$2=createCommonjsModule$1(function(e){var t=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=t)}),SHARED$1="__core-js_shared__",store$1=_global$2[SHARED$1]||(_global$2[SHARED$1]={}),_shared$2=function(e){return store$1[e]||(store$1[e]={})},id$2=0,px$1=Math.random(),_uid$2=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++id$2+px$1).toString(36))},shared$2=_shared$2("keys"),_sharedKey$2=function(e){return shared$2[e]||(shared$2[e]=_uid$2(e))},arrayIndexOf$1=_arrayIncludes$2(!1),IE_PROTO$3=_sharedKey$2("IE_PROTO"),_objectKeysInternal$2=function(e,t){var r,n=_toIobject$2(e),i=0,o=[];for(r in n)r!=IE_PROTO$3&&_has$2(n,r)&&o.push(r);for(;t.length>i;)_has$2(n,r=t[i++])&&(~arrayIndexOf$1(o,r)||o.push(r));return o},_enumBugKeys$2="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),_objectKeys$2=Object.keys||function(e){return _objectKeysInternal$2(e,_enumBugKeys$2)},_core$2=createCommonjsModule$1(function(e){var t=e.exports={version:"2.5.1"};"number"==typeof __e&&(__e=t)}),_aFunction$2=function(e){
if("function"!=typeof e)throw TypeError(e+" is not a function!");return e},_ctx$2=function(e,t,r){if(_aFunction$2(e),t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,i){return e.call(t,r,n,i)}}return function(){return e.apply(t,arguments)}},_isObject$2=function(e){return"object"==typeof e?null!==e:"function"==typeof e},_anObject$2=function(e){if(!_isObject$2(e))throw TypeError(e+" is not an object!");return e},_fails$2=function(e){try{return!!e()}catch(e){return!0}},_descriptors$2=!_fails$2(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),document$1$1=_global$2.document,is$1=_isObject$2(document$1$1)&&_isObject$2(document$1$1.createElement),_domCreate$2=function(e){return is$1?document$1$1.createElement(e):{}},_ie8DomDefine$2=!_descriptors$2&&!_fails$2(function(){return 7!=Object.defineProperty(_domCreate$2("div"),"a",{get:function(){return 7}}).a}),_toPrimitive$2=function(e,t){if(!_isObject$2(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!_isObject$2(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!_isObject$2(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!_isObject$2(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")},dP$4=Object.defineProperty,f$8=_descriptors$2?Object.defineProperty:function(e,t,r){if(_anObject$2(e),t=_toPrimitive$2(t,!0),_anObject$2(r),_ie8DomDefine$2)try{return dP$4(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(e[t]=r.value),e},_objectDp$2={f:f$8},_propertyDesc$2=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},_hide$2=_descriptors$2?function(e,t,r){return _objectDp$2.f(e,t,_propertyDesc$2(1,r))}:function(e,t,r){return e[t]=r,e},PROTOTYPE$3="prototype",$export$2=function(e,t,r){var n,i,o,a=e&$export$2.F,s=e&$export$2.G,u=e&$export$2.S,c=e&$export$2.P,l=e&$export$2.B,f=e&$export$2.W,d=s?_core$2:_core$2[t]||(_core$2[t]={}),h=d[PROTOTYPE$3],p=s?_global$2:u?_global$2[t]:(_global$2[t]||{})[PROTOTYPE$3];s&&(r=t);for(n in r)(i=!a&&p&&p[n]!==undefined)&&n in d||(o=i?p[n]:r[n],d[n]=s&&"function"!=typeof p[n]?r[n]:l&&i?_ctx$2(o,_global$2):f&&p[n]==o?function(e){var t=function(t,r,n){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,n)}return e.apply(this,arguments)};return t[PROTOTYPE$3]=e[PROTOTYPE$3],t}(o):c&&"function"==typeof o?_ctx$2(Function.call,o):o,c&&((d.virtual||(d.virtual={}))[n]=o,e&$export$2.R&&h&&!h[n]&&_hide$2(h,n,o)))};$export$2.F=1,$export$2.G=2,$export$2.S=4,$export$2.P=8,$export$2.B=16,$export$2.W=32,$export$2.U=64,$export$2.R=128;var _export$2=$export$2,_objectSap$2=function(e,t){var r=(_core$2.Object||{})[e]||Object[e],n={};n[e]=t(r),_export$2(_export$2.S+_export$2.F*_fails$2(function(){r(1)}),"Object",n)};_objectSap$2("keys",function(){return function(e){return _objectKeys$2(_toObject$2(e))}});var keys$1$1=_core$2.Object.keys,keys$3=createCommonjsModule$1(function(e){e.exports={"default":keys$1$1,__esModule:!0}}),_Object$keys$1=unwrapExports$1(keys$3),IE_PROTO$1$1=_sharedKey$2("IE_PROTO"),ObjectProto$2=Object.prototype,_objectGpo$2=Object.getPrototypeOf||function(e){return e=_toObject$2(e),_has$2(e,IE_PROTO$1$1)?e[IE_PROTO$1$1]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?ObjectProto$2:null};_objectSap$2("getPrototypeOf",function(){return function(e){return _objectGpo$2(_toObject$2(e))}});var getPrototypeOf$1$1=_core$2.Object.getPrototypeOf,getPrototypeOf$4=createCommonjsModule$1(function(e){e.exports={"default":getPrototypeOf$1$1,__esModule:!0}}),_Object$getPrototypeOf$1=unwrapExports$1(getPrototypeOf$4),classCallCheck$1=createCommonjsModule$1(function(e,t){t.__esModule=!0,t["default"]=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}}),_classCallCheck$1=unwrapExports$1(classCallCheck$1);_export$2(_export$2.S+_export$2.F*!_descriptors$2,"Object",{defineProperty:_objectDp$2.f});var $Object$4=_core$2.Object,defineProperty$2$2=function(e,t,r){return $Object$4.defineProperty(e,t,r)},defineProperty$6$1=createCommonjsModule$1(function(e){e.exports={"default":defineProperty$2$2,__esModule:!0}});unwrapExports$1(defineProperty$6$1);var createClass$1=createCommonjsModule$1(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(defineProperty$6$1);t["default"]=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),(0,r["default"])(e,i.key,i)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()}),_createClass$1=unwrapExports$1(createClass$1),_stringAt$2=function(e){return function(t,r){var n,i,o=String(_defined$2(t)),a=_toInteger$2(r),s=o.length;return a<0||a>=s?e?"":undefined:(n=o.charCodeAt(a),n<55296||n>56319||a+1===s||(i=o.charCodeAt(a+1))<56320||i>57343?e?o.charAt(a):n:e?o.slice(a,a+2):i-56320+(n-55296<<10)+65536)}},_library$2=!0,_redefine$2=_hide$2,_iterators$2={},_objectDps$2=_descriptors$2?Object.defineProperties:function(e,t){_anObject$2(e);for(var r,n=_objectKeys$2(t),i=n.length,o=0;i>o;)_objectDp$2.f(e,r=n[o++],t[r]);return e},document$2$1=_global$2.document,_html$2=document$2$1&&document$2$1.documentElement,IE_PROTO$2$1=_sharedKey$2("IE_PROTO"),Empty$1=function(){},PROTOTYPE$1$1="prototype",createDict$1=function(){var e,t=_domCreate$2("iframe"),r=_enumBugKeys$2.length;for(t.style.display="none",_html$2.appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),createDict$1=e.F;r--;)delete createDict$1[PROTOTYPE$1$1][_enumBugKeys$2[r]];return createDict$1()},_objectCreate$2=Object.create||function(e,t){var r;return null!==e?(Empty$1[PROTOTYPE$1$1]=_anObject$2(e),r=new Empty$1,Empty$1[PROTOTYPE$1$1]=null,r[IE_PROTO$2$1]=e):r=createDict$1(),t===undefined?r:_objectDps$2(r,t)},_wks$2=createCommonjsModule$1(function(e){var t=_shared$2("wks"),r=_global$2.Symbol,n="function"==typeof r;(e.exports=function(e){return t[e]||(t[e]=n&&r[e]||(n?r:_uid$2)("Symbol."+e))}).store=t}),def$1=_objectDp$2.f,TAG$2=_wks$2("toStringTag"),_setToStringTag$2=function(e,t,r){e&&!_has$2(e=r?e:e.prototype,TAG$2)&&def$1(e,TAG$2,{configurable:!0,value:t})},IteratorPrototype$1={};_hide$2(IteratorPrototype$1,_wks$2("iterator"),function(){return this});var _iterCreate$2=function(e,t,r){e.prototype=_objectCreate$2(IteratorPrototype$1,{next:_propertyDesc$2(1,r)}),_setToStringTag$2(e,t+" Iterator")},ITERATOR$5=_wks$2("iterator"),BUGGY$1=!([].keys&&"next"in[].keys()),FF_ITERATOR$1="@@iterator",KEYS$1="keys",VALUES$1="values",returnThis$1=function(){return this},_iterDefine$2=function(e,t,r,n,i,o,a){_iterCreate$2(r,t,n);var s,u,c,l=function(e){if(!BUGGY$1&&e in p)return p[e];switch(e){case KEYS$1:case VALUES$1:return function(){return new r(this,e)}}return function(){return new r(this,e)}},f=t+" Iterator",d=i==VALUES$1,h=!1,p=e.prototype,y=p[ITERATOR$5]||p[FF_ITERATOR$1]||i&&p[i],g=y||l(i),m=i?d?l("entries"):g:undefined,_="Array"==t?p.entries||y:y;if(_&&(c=_objectGpo$2(_.call(new e)))!==Object.prototype&&c.next&&(_setToStringTag$2(c,f,!0),_library$2||_has$2(c,ITERATOR$5)||_hide$2(c,ITERATOR$5,returnThis$1)),d&&y&&y.name!==VALUES$1&&(h=!0,g=function(){return y.call(this)}),_library$2&&!a||!BUGGY$1&&!h&&p[ITERATOR$5]||_hide$2(p,ITERATOR$5,g),_iterators$2[t]=g,_iterators$2[f]=returnThis$1,i)if(s={values:d?g:l(VALUES$1),keys:o?g:l(KEYS$1),entries:m},a)for(u in s)u in p||_redefine$2(p,u,s[u]);else _export$2(_export$2.P+_export$2.F*(BUGGY$1||h),t,s);return s},$at$1=_stringAt$2(!0);_iterDefine$2(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:undefined,done:!0}:(e=$at$1(t,r),this._i+=e.length,{value:e,done:!1})});var _iterStep$2=function(e,t){return{value:t,done:!!e}},es6_array_iterator$2=_iterDefine$2(Array,"Array",function(e,t){this._t=_toIobject$2(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,r=this._i++;return!e||r>=e.length?(this._t=undefined,_iterStep$2(1)):"keys"==t?_iterStep$2(0,r):"values"==t?_iterStep$2(0,e[r]):_iterStep$2(0,[r,e[r]])},"values");_iterators$2.Arguments=_iterators$2.Array;for(var TO_STRING_TAG$1=_wks$2("toStringTag"),DOMIterables$1="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),i$1=0;i$1<DOMIterables$1.length;i$1++){var NAME$1=DOMIterables$1[i$1],Collection$1=_global$2[NAME$1],proto$1=Collection$1&&Collection$1.prototype;proto$1&&!proto$1[TO_STRING_TAG$1]&&_hide$2(proto$1,TO_STRING_TAG$1,NAME$1),_iterators$2[NAME$1]=_iterators$2.Array}var f$1$1=_wks$2,_wksExt$2={f:f$1$1},iterator$2$1=_wksExt$2.f("iterator"),iterator$4=createCommonjsModule$1(function(e){e.exports={"default":iterator$2$1,__esModule:!0}});unwrapExports$1(iterator$4);var _meta$2=createCommonjsModule$1(function(e){var t=_uid$2("meta"),r=_objectDp$2.f,n=0,i=Object.isExtensible||function(){return!0},o=!_fails$2(function(){return i(Object.preventExtensions({}))}),a=function(e){r(e,t,{value:{i:"O"+ ++n,w:{}}})},s=function(e,r){if(!_isObject$2(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!_has$2(e,t)){if(!i(e))return"F";if(!r)return"E";a(e)}return e[t].i},u=function(e,r){if(!_has$2(e,t)){if(!i(e))return!0;if(!r)return!1;a(e)}return e[t].w},c=function(e){return o&&l.NEED&&i(e)&&!_has$2(e,t)&&a(e),e},l=e.exports={KEY:t,NEED:!1,fastKey:s,getWeak:u,onFreeze:c}}),defineProperty$4$2=_objectDp$2.f,_wksDefine$2=function(e){var t=_core$2.Symbol||(_core$2.Symbol=_library$2?{}:_global$2.Symbol||{});"_"==e.charAt(0)||e in t||defineProperty$4$2(t,e,{value:_wksExt$2.f(e)})},f$2$1=Object.getOwnPropertySymbols,_objectGops$2={f:f$2$1},f$3$1={}.propertyIsEnumerable,_objectPie$2={f:f$3$1},_enumKeys$2=function(e){var t=_objectKeys$2(e),r=_objectGops$2.f;if(r)for(var n,i=r(e),o=_objectPie$2.f,a=0;i.length>a;)o.call(e,n=i[a++])&&t.push(n);return t},_isArray$2=Array.isArray||function(e){return"Array"==_cof$2(e)},hiddenKeys$1=_enumBugKeys$2.concat("length","prototype"),f$5$1=Object.getOwnPropertyNames||function(e){return _objectKeysInternal$2(e,hiddenKeys$1)},_objectGopn$2={f:f$5$1},gOPN$1$1=_objectGopn$2.f,toString$1$1={}.toString,windowNames$1="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],getWindowNames$1=function(e){try{return gOPN$1$1(e)}catch(e){return windowNames$1.slice()}},f$4$1=function(e){return windowNames$1&&"[object Window]"==toString$1$1.call(e)?getWindowNames$1(e):gOPN$1$1(_toIobject$2(e))},_objectGopnExt$2={f:f$4$1},gOPD$1$1=Object.getOwnPropertyDescriptor,f$6$1=_descriptors$2?gOPD$1$1:function(e,t){if(e=_toIobject$2(e),t=_toPrimitive$2(t,!0),_ie8DomDefine$2)try{return gOPD$1$1(e,t)}catch(e){}if(_has$2(e,t))return _propertyDesc$2(!_objectPie$2.f.call(e,t),e[t])},_objectGopd$2={f:f$6$1},META$1=_meta$2.KEY,gOPD$3=_objectGopd$2.f,dP$1$1=_objectDp$2.f,gOPN$3=_objectGopnExt$2.f,$Symbol$1=_global$2.Symbol,$JSON$2=_global$2.JSON,_stringify$1=$JSON$2&&$JSON$2.stringify,PROTOTYPE$2$1="prototype",HIDDEN$1=_wks$2("_hidden"),TO_PRIMITIVE$1=_wks$2("toPrimitive"),isEnum$2={}.propertyIsEnumerable,SymbolRegistry$1=_shared$2("symbol-registry"),AllSymbols$1=_shared$2("symbols"),OPSymbols$1=_shared$2("op-symbols"),ObjectProto$1$1=Object[PROTOTYPE$2$1],USE_NATIVE$2="function"==typeof $Symbol$1,QObject$1=_global$2.QObject,setter$1=!QObject$1||!QObject$1[PROTOTYPE$2$1]||!QObject$1[PROTOTYPE$2$1].findChild,setSymbolDesc$1=_descriptors$2&&_fails$2(function(){return 7!=_objectCreate$2(dP$1$1({},"a",{get:function(){return dP$1$1(this,"a",{value:7}).a}})).a})?function(e,t,r){var n=gOPD$3(ObjectProto$1$1,t);n&&delete ObjectProto$1$1[t],dP$1$1(e,t,r),n&&e!==ObjectProto$1$1&&dP$1$1(ObjectProto$1$1,t,n)}:dP$1$1,wrap$1=function(e){var t=AllSymbols$1[e]=_objectCreate$2($Symbol$1[PROTOTYPE$2$1]);return t._k=e,t},isSymbol$1=USE_NATIVE$2&&"symbol"==typeof $Symbol$1.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof $Symbol$1},$defineProperty$1=function(e,t,r){return e===ObjectProto$1$1&&$defineProperty$1(OPSymbols$1,t,r),_anObject$2(e),t=_toPrimitive$2(t,!0),_anObject$2(r),_has$2(AllSymbols$1,t)?(r.enumerable?(_has$2(e,HIDDEN$1)&&e[HIDDEN$1][t]&&(e[HIDDEN$1][t]=!1),r=_objectCreate$2(r,{enumerable:_propertyDesc$2(0,!1)})):(_has$2(e,HIDDEN$1)||dP$1$1(e,HIDDEN$1,_propertyDesc$2(1,{})),e[HIDDEN$1][t]=!0),setSymbolDesc$1(e,t,r)):dP$1$1(e,t,r)},$defineProperties$1=function(e,t){_anObject$2(e);for(var r,n=_enumKeys$2(t=_toIobject$2(t)),i=0,o=n.length;o>i;)$defineProperty$1(e,r=n[i++],t[r]);return e},$create$1=function(e,t){return t===undefined?_objectCreate$2(e):$defineProperties$1(_objectCreate$2(e),t)},$propertyIsEnumerable$1=function(e){var t=isEnum$2.call(this,e=_toPrimitive$2(e,!0));return!(this===ObjectProto$1$1&&_has$2(AllSymbols$1,e)&&!_has$2(OPSymbols$1,e))&&(!(t||!_has$2(this,e)||!_has$2(AllSymbols$1,e)||_has$2(this,HIDDEN$1)&&this[HIDDEN$1][e])||t)},$getOwnPropertyDescriptor$2=function(e,t){if(e=_toIobject$2(e),t=_toPrimitive$2(t,!0),e!==ObjectProto$1$1||!_has$2(AllSymbols$1,t)||_has$2(OPSymbols$1,t)){var r=gOPD$3(e,t);return!r||!_has$2(AllSymbols$1,t)||_has$2(e,HIDDEN$1)&&e[HIDDEN$1][t]||(r.enumerable=!0),r}},$getOwnPropertyNames$1=function(e){for(var t,r=gOPN$3(_toIobject$2(e)),n=[],i=0;r.length>i;)_has$2(AllSymbols$1,t=r[i++])||t==HIDDEN$1||t==META$1||n.push(t);return n},$getOwnPropertySymbols$1=function(e){for(var t,r=e===ObjectProto$1$1,n=gOPN$3(r?OPSymbols$1:_toIobject$2(e)),i=[],o=0;n.length>o;)!_has$2(AllSymbols$1,t=n[o++])||r&&!_has$2(ObjectProto$1$1,t)||i.push(AllSymbols$1[t]);return i};USE_NATIVE$2||($Symbol$1=function(){if(this instanceof $Symbol$1)throw TypeError("Symbol is not a constructor!");var e=_uid$2(arguments.length>0?arguments[0]:undefined),t=function(r){this===ObjectProto$1$1&&t.call(OPSymbols$1,r),_has$2(this,HIDDEN$1)&&_has$2(this[HIDDEN$1],e)&&(this[HIDDEN$1][e]=!1),setSymbolDesc$1(this,e,_propertyDesc$2(1,r))};return _descriptors$2&&setter$1&&setSymbolDesc$1(ObjectProto$1$1,e,{configurable:!0,set:t}),wrap$1(e)},_redefine$2($Symbol$1[PROTOTYPE$2$1],"toString",function(){return this._k}),_objectGopd$2.f=$getOwnPropertyDescriptor$2,_objectDp$2.f=$defineProperty$1,_objectGopn$2.f=_objectGopnExt$2.f=$getOwnPropertyNames$1,_objectPie$2.f=$propertyIsEnumerable$1,_objectGops$2.f=$getOwnPropertySymbols$1,_descriptors$2&&!_library$2&&_redefine$2(ObjectProto$1$1,"propertyIsEnumerable",$propertyIsEnumerable$1,!0),_wksExt$2.f=function(e){return wrap$1(_wks$2(e))}),_export$2(_export$2.G+_export$2.W+_export$2.F*!USE_NATIVE$2,{Symbol:$Symbol$1});for(var es6Symbols$1="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),j$1=0;es6Symbols$1.length>j$1;)_wks$2(es6Symbols$1[j$1++]);for(var wellKnownSymbols$1=_objectKeys$2(_wks$2.store),k$1=0;wellKnownSymbols$1.length>k$1;)_wksDefine$2(wellKnownSymbols$1[k$1++]);_export$2(_export$2.S+_export$2.F*!USE_NATIVE$2,"Symbol",{"for":function(e){return _has$2(SymbolRegistry$1,e+="")?SymbolRegistry$1[e]:SymbolRegistry$1[e]=$Symbol$1(e)},keyFor:function(e){if(!isSymbol$1(e))throw TypeError(e+" is not a symbol!");for(var t in SymbolRegistry$1)if(SymbolRegistry$1[t]===e)return t},useSetter:function(){setter$1=!0},useSimple:function(){setter$1=!1}}),_export$2(_export$2.S+_export$2.F*!USE_NATIVE$2,"Object",{create:$create$1,defineProperty:$defineProperty$1,defineProperties:$defineProperties$1,getOwnPropertyDescriptor:$getOwnPropertyDescriptor$2,getOwnPropertyNames:$getOwnPropertyNames$1,getOwnPropertySymbols:$getOwnPropertySymbols$1}),$JSON$2&&_export$2(_export$2.S+_export$2.F*(!USE_NATIVE$2||_fails$2(function(){var e=$Symbol$1();return"[null]"!=_stringify$1([e])||"{}"!=_stringify$1({a:e})||"{}"!=_stringify$1(Object(e))})),"JSON",{stringify:function(e){if(e!==undefined&&!isSymbol$1(e)){for(var t,r,n=[e],i=1;arguments.length>i;)n.push(arguments[i++]);return t=n[1],"function"==typeof t&&(r=t),!r&&_isArray$2(t)||(t=function(e,t){if(r&&(t=r.call(this,e,t)),!isSymbol$1(t))return t}),n[1]=t,_stringify$1.apply($JSON$2,n)}}}),$Symbol$1[PROTOTYPE$2$1][TO_PRIMITIVE$1]||_hide$2($Symbol$1[PROTOTYPE$2$1],TO_PRIMITIVE$1,$Symbol$1[PROTOTYPE$2$1].valueOf),_setToStringTag$2($Symbol$1,"Symbol"),_setToStringTag$2(Math,"Math",!0),_setToStringTag$2(_global$2.JSON,"JSON",!0),_wksDefine$2("asyncIterator"),_wksDefine$2("observable");var symbol$2$1=_core$2.Symbol,symbol$4=createCommonjsModule$1(function(e){e.exports={"default":symbol$2$1,__esModule:!0}});unwrapExports$1(symbol$4);var _typeof_1$1=createCommonjsModule$1(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(iterator$4),i=r(symbol$4),o="function"==typeof i["default"]&&"symbol"==typeof n["default"]?function(e){return typeof e}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":typeof e};t["default"]="function"==typeof i["default"]&&"symbol"===o(n["default"])?function(e){return void 0===e?"undefined":o(e)}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":void 0===e?"undefined":o(e)}});unwrapExports$1(_typeof_1$1);var possibleConstructorReturn$1=createCommonjsModule$1(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(_typeof_1$1);t["default"]=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==(void 0===t?"undefined":(0,r["default"])(t))&&"function"!=typeof t?e:t}}),_possibleConstructorReturn$1=unwrapExports$1(possibleConstructorReturn$1),$getOwnPropertyDescriptor$1$1=_objectGopd$2.f;_objectSap$2("getOwnPropertyDescriptor",function(){return function(e,t){return $getOwnPropertyDescriptor$1$1(_toIobject$2(e),t)}});var $Object$1$1=_core$2.Object,getOwnPropertyDescriptor$1$2=function(e,t){return $Object$1$1.getOwnPropertyDescriptor(e,t)},getOwnPropertyDescriptor$4=createCommonjsModule$1(function(e){e.exports={"default":getOwnPropertyDescriptor$1$2,__esModule:!0}}),_Object$getOwnPropertyDescriptor$1=unwrapExports$1(getOwnPropertyDescriptor$4),get$1=createCommonjsModule$1(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(getPrototypeOf$4),i=r(getOwnPropertyDescriptor$4);t["default"]=function o(e,t,r){null===e&&(e=Function.prototype);var a=(0,i["default"])(e,t);if(a===undefined){var s=(0,n["default"])(e);return null===s?undefined:o(s,t,r)}if("value"in a)return a.value;var u=a.get;return u===undefined?undefined:u.call(r)}}),_get$1=unwrapExports$1(get$1),check$1=function(e,t){if(_anObject$2(e),!_isObject$2(t)&&null!==t)throw TypeError(t+": can't set as prototype!")},_setProto$2={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=_ctx$2(Function.call,_objectGopd$2.f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(e){t=!0}return function(e,n){return check$1(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):undefined),check:check$1};_export$2(_export$2.S,"Object",{setPrototypeOf:_setProto$2.set});var setPrototypeOf$2$1=_core$2.Object.setPrototypeOf,setPrototypeOf$4=createCommonjsModule$1(function(e){e.exports={"default":setPrototypeOf$2$1,__esModule:!0}});unwrapExports$1(setPrototypeOf$4),_export$2(_export$2.S,"Object",{create:_objectCreate$2});var $Object$2$1=_core$2.Object,create$2$1=function(e,t){return $Object$2$1.create(e,t)},create$4=createCommonjsModule$1(function(e){e.exports={"default":create$2$1,__esModule:!0}});unwrapExports$1(create$4);var inherits$1=createCommonjsModule$1(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(setPrototypeOf$4),i=r(create$4),o=r(_typeof_1$1);t["default"]=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+(void 0===t?"undefined":(0,o["default"])(t)));e.prototype=(0,i["default"])(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(n["default"]?(0,n["default"])(e,t):e.__proto__=t)}}),_inherits$1=unwrapExports$1(inherits$1),_iterCall$2=function(t,r,n,i){try{return i?r(_anObject$2(n)[0],n[1]):r(n)}catch(e){var o=t["return"];throw o!==undefined&&_anObject$2(o.call(t)),e}},ITERATOR$1$1=_wks$2("iterator"),ArrayProto$1=Array.prototype,_isArrayIter$2=function(e){return e!==undefined&&(_iterators$2.Array===e||ArrayProto$1[ITERATOR$1$1]===e)},_createProperty$2=function(e,t,r){t in e?_objectDp$2.f(e,t,_propertyDesc$2(0,r)):e[t]=r},TAG$1$1=_wks$2("toStringTag"),ARG$1="Arguments"==_cof$2(function(){return arguments}()),tryGet$1=function(e,t){try{return e[t]}catch(e){}},_classof$2=function(e){var t,r,n;return e===undefined?"Undefined":null===e?"Null":"string"==typeof(r=tryGet$1(t=Object(e),TAG$1$1))?r:ARG$1?_cof$2(t):"Object"==(n=_cof$2(t))&&"function"==typeof t.callee?"Arguments":n},ITERATOR$2$1=_wks$2("iterator"),core_getIteratorMethod$2=_core$2.getIteratorMethod=function(e){if(e!=undefined)return e[ITERATOR$2$1]||e["@@iterator"]||_iterators$2[_classof$2(e)]},ITERATOR$3$1=_wks$2("iterator"),SAFE_CLOSING$1=!1;try{var riter$1=[7][ITERATOR$3$1]();riter$1["return"]=function(){SAFE_CLOSING$1=!0}}catch(e){}var _iterDetect$2=function(e,t){if(!t&&!SAFE_CLOSING$1)return!1;var r=!1;try{var n=[7],i=n[ITERATOR$3$1]();i.next=function(){return{done:r=!0}},n[ITERATOR$3$1]=function(){return i},e(n)}catch(e){}return r};_export$2(_export$2.S+_export$2.F*!_iterDetect$2(function(e){}),"Array",{from:function(e){var t,r,n,i,o=_toObject$2(e),a="function"==typeof this?this:Array,s=arguments.length,u=s>1?arguments[1]:undefined,c=u!==undefined,l=0,f=core_getIteratorMethod$2(o);if(c&&(u=_ctx$2(u,s>2?arguments[2]:undefined,2)),f==undefined||a==Array&&_isArrayIter$2(f))for(t=_toLength$2(o.length),r=new a(t);t>l;l++)_createProperty$2(r,l,c?u(o[l],l):o[l]);else for(i=f.call(o),r=new a;!(n=i.next()).done;l++)_createProperty$2(r,l,c?_iterCall$2(i,u,[n.value,l],!0):n.value);return r.length=l,r}});var from$1$1=_core$2.Array.from,from$4=createCommonjsModule$1(function(e){e.exports={"default":from$1$1,__esModule:!0}}),_Array$from$1=unwrapExports$1(from$4),toConsumableArray$1=createCommonjsModule$1(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(from$4);t["default"]=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return(0,r["default"])(e)}}),_toConsumableArray$1=unwrapExports$1(toConsumableArray$1),floor$1$1=Math.floor,_isInteger$2=function(e){return!_isObject$2(e)&&isFinite(e)&&floor$1$1(e)===e};_export$2(_export$2.S,"Number",{isInteger:_isInteger$2});var isInteger$2$1=_core$2.Number.isInteger,isInteger$1$1=createCommonjsModule$1(function(e){e.exports={"default":isInteger$2$1,__esModule:!0}});unwrapExports$1(isInteger$1$1);var _stringWs$2="\t\n\x0B\f\r \xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff",space$1="["+_stringWs$2+"]",non$1="\u200b\x85",ltrim$1=RegExp("^"+space$1+space$1+"*"),rtrim$1=RegExp(space$1+space$1+"*$"),exporter$1=function(e,t,r){var n={},i=_fails$2(function(){return!!_stringWs$2[e]()||non$1[e]()!=non$1}),o=n[e]=i?t(trim$1):_stringWs$2[e];r&&(n[r]=o),_export$2(_export$2.P+_export$2.F*i,"String",n)},trim$1=exporter$1.trim=function(e,t){return e=String(_defined$2(e)),1&t&&(e=e.replace(ltrim$1,"")),2&t&&(e=e.replace(rtrim$1,"")),e},_stringTrim$2=exporter$1,$parseFloat$2=_global$2.parseFloat,$trim$1=_stringTrim$2.trim,_parseFloat$3$1=1/$parseFloat$2(_stringWs$2+"-0")!=-Infinity?function(e){var t=$trim$1(String(e),3),r=$parseFloat$2(t);return 0===r&&"-"==t.charAt(0)?-0:r}:$parseFloat$2;_export$2(_export$2.S+_export$2.F*(Number.parseFloat!=_parseFloat$3$1),"Number",{parseFloat:_parseFloat$3$1});var _parseFloat$1$1=parseFloat,_parseFloat$5=createCommonjsModule$1(function(e){e.exports={"default":_parseFloat$1$1,__esModule:!0}});unwrapExports$1(_parseFloat$5);var Base=function(){function e(t){_classCallCheck$1(this,e),this.parent=t}return _createClass$1(e,[{key:"create",value:function(){this.createEl(),this.addAllEvent()}},{key:"destroy",value:function(){this.removeAllEvent()}},{key:"createEl",value:function(){this.$dom=document.createElement(this.option.tag),this.$dom.innerHTML=this.option.html,this.parent.$wrap.appendChild(this.$dom)}},{key:"addAllEvent",value:function(){var e=this;this.option.defaultEvent&&_Object$keys$1(this.option.defaultEvent).forEach(function(t){var r=e.option.defaultEvent[t];e[r]=bind$1(e[r],e),addEvent(e.$dom,t,e[r],!1,!1)}),this.option.event&&_Object$keys$1(this.option.event).forEach(function(t){var r="__"+t;e[r]=bind$1(e.option.event[t],e),addEvent(e.$dom,t,e[r],!1,!1)})}},{key:"removeAllEvent",value:function(){var e=this;this.option.defaultEvent&&_Object$keys$1(this.option.defaultEvent).forEach(function(t){var r=e.option.defaultEvent[t];e[r]=bind$1(e[r],e),removeEvent(e.$dom,t,e[r],!1,!1)}),this.option.event&&_Object$keys$1(this.option.event).forEach(function(t){var r="__"+t;e[r]=bind$1(e.option.event[t],e),removeEvent(e.$dom,t,e[r],!1,!1)})}}]),e}(),Component=function(e){function t(e,r){_classCallCheck$1(this,t);var n=_possibleConstructorReturn$1(this,(t.__proto__||_Object$getPrototypeOf$1(t)).call(this,e));return n.option=r,n.init(),n}return _inherits$1(t,e),_createClass$1(t,[{key:"init",value:function(){_get$1(t.prototype.__proto__||_Object$getPrototypeOf$1(t.prototype),"create",this).call(this),addClassName(this.$dom,"chimee-flex-component")}}]),t}(Base),defaultOption={tag:"chimee-control-state",html:"\n    <chimee-control-state-play></chimee-control-state-play>\n    <chimee-control-state-pause></chimee-control-state-pause>\n  ",animate:{icon:'\n      <svg viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        <g fill="#ffffff" stroke="#ffffff">\n          <path class="left"></path>\n          <path class="right"></path>\n        </g>\n      </svg>\n    ',path:{play:{left:"M0.921875,0.265625L0.921875,197.074852L95.7890625,149L96.2929688,49Z",right:"M90.3142151,45.9315226L90.3142151,151.774115L201.600944,99.9938782L201.600944,98.0237571Z"},pause:{left:"M0.921875,1.265625L0.921875,198.074852L79.3611677,198.074852L79.3611677,0.258923126Z",right:"M126.921875,1.265625L126.921875,198.074852L205.361168,198.074852L205.361168,0.258923126Z"}}},defaultEvent:{click:"click"}},Play=function(e){function t(e,r){_classCallCheck$1(this,t);var n=_possibleConstructorReturn$1(this,(t.__proto__||_Object$getPrototypeOf$1(t)).call(this,e));return n.option=deepAssign(defaultOption,isObject$1(r)?r:{}),n.animate=!1,n.init(),n}return _inherits$1(t,e),_createClass$1(t,[{key:"init",value:function(){_get$1(t.prototype.__proto__||_Object$getPrototypeOf$1(t.prototype),"create",this).call(this),this.$dom=$(this.$dom),this.$dom.addClass("chimee-flex-component"),this.option.icon&&this.option.icon.play&&this.option.icon.pause?(this.$play=this.$dom.find("chimee-control-state-play"),this.$pause=this.$dom.find("chimee-control-state-pause"),this.$play.html(this.option.icon.play),this.$pause.html(this.option.icon.pause)):this.option.bitmap||(this.animate=!0,this.option.animate.path=this.option.path?this.option.path:this.option.animate.path,this.$dom.html(this.option.animate.icon),this.$left=this.$dom.find(".left"),this.$right=this.$dom.find(".right")),this.changeState("pause")}},{key:"changeState",value:function(e){var t="play"===e?"pause":"play";this.state=e,addClassName(this.parent.$dom,t),removeClassName(this.parent.$dom,e),this.animate&&this.setPath(t)}},{key:"setPath",value:function(e){var t=this.option.animate.path;"play"===e?(this.$left.attr("d",t.play.left),this.$right.attr("d",t.play.right)):(this.$left.attr("d",t.pause.left),this.$right.attr("d",t.pause.right))}},{key:"click",value:function(e){var t="play"===this.state?"pause":"play";this.changeState(t),this.parent.$emit(t)}}]),t}(Base),_class$2$1,defaultOption$1={tag:"chimee-volume",html:"\n    <chimee-volume-state>\n      <chimee-volume-state-mute></chimee-volume-state-mute>\n      <chimee-volume-state-low></chimee-volume-state-low>\n      <chimee-volume-state-high></chimee-volume-state-high>\n    </chimee-volume-state>\n    <chimee-volume-bar>\n      <chimee-volume-bar-wrap>\n        <chimee-volume-bar-bg></chimee-volume-bar-bg>\n        <chimee-volume-bar-all>\n          <chimee-volume-bar-ball></chimee-volume-bar-ball>\n        </chimee-volume-bar-all>\n        <chimee-volume-bar-track></chimee-volume-bar-track>\n      </chimee-volume-bar-wrap>\n    </chimee-volume-bar>\n  ",animate:{icon:'\n      <svg viewBox="0 0 107 101" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        <g class="volume">\n          <polygon class="horn" points="0.403399942 30 27.3842118 30 56.8220589 2.84217094e-14 57.9139815 100 27.3842118 70 0.403399942 70"></polygon>\n          <path class="ring1" d="M63,5.00975239 C69.037659,4.78612057 75.9178585,8.40856146 83.6405984,15.877075 C95.2247083,27.0798454 100,34.7975125 100,50.9608558 C100,67.1241991 95.3628694,73.7907482 83.6405984,83.8306724 C75.8257511,90.5239552 68.9455516,94.0320644 63,94.355" fill-opacity="0" stroke-width="10"></path>\n          <path class="ring2" d="M65.2173913,29.4929195 C67.8779343,29.3931169 70.9097496,31.0097416 74.3128371,34.3427934 C79.4174684,39.3423712 81.5217391,42.7866154 81.5217391,50 C81.5217391,57.2133846 79.4783502,60.1885354 74.3128371,64.6691576 C70.8691617,67.656239 67.8373465,69.2218397 65.2173913,69.3659595" fill-opacity="0" stroke-width="10"></path>\n          <path class="line" d="M4.19119202,3.65220497 L102,96" stroke-width="10"></path>\n        </g>\n      </svg>\n    '},defaultEvent:{mousedown:"mousedown"}},getElementPath=function(e){var t=[];if(null===e)return t;for(t.push(e);null!==e.parentNode;)e=e.parentNode,t.push(e);return t},Volume=(_class$2$1=function(e){function t(e,r){_classCallCheck$1(this,t);var n=_possibleConstructorReturn$1(this,(t.__proto__||_Object$getPrototypeOf$1(t)).call(this,e));return n.parent.preVolume=0,n.option=deepAssign(defaultOption$1,isObject$1(r)?r:{}),n.init(),n}return _inherits$1(t,e),_createClass$1(t,[{key:"inited",value:function(){this.update()}},{key:"init",value:function(){_get$1(t.prototype.__proto__||_Object$getPrototypeOf$1(t.prototype),"create",this).call(this),this.$dom=$(this.$dom),this.$state=this.$dom.find("chimee-volume-state"),this.$bar=this.$dom.find("chimee-volume-bar"),this.$all=this.$dom.find("chimee-volume-bar-all"),this.$bg=this.$dom.find("chimee-volume-bar-bg"),this.layout="vertical"===this.option.layout?"vertical":"horizonal",this.option.icon&&this.option.icon.mute&&this.option.icon.low?(this.option.icon.high=this.option.icon.high||this.option.icon.low,this.$mute=this.$dom.find("chimee-volume-state-mute"),this.$low=this.$dom.find("chimee-volume-state-low"),this.$high=this.$dom.find("chimee-volume-state-high"),this.$mute.html(this.option.icon.mute),this.$low.html(this.option.icon.low),this.$high.html(this.option.icon.high)):this.option.bitmap||(this.animate=!0,this.$state.html(this.option.animate.icon)),this.$dom.addClass("chimee-flex-component "+this.layout),this.changeState()}},{key:"changeState",value:function(){0===this.parent.volume?this.state="mute":this.parent.volume>0&&this.parent.volume<=.5?this.state="low":this.parent.volume>.5&&this.parent.volume<=1&&(this.state="high"),
this.$dom.removeClass("mute low high"),this.$dom.addClass(this.state)}},{key:"click",value:function(e){var t=e.path||getElementPath(e.target);return-1!==t.indexOf(this.$state[0])?(this.stateClick(e),"state"):-1!==t.indexOf(this.$bar[0])?(this.barClick(e),"bar"):"padding"}},{key:"stateClick",value:function(){var e=this.parent.volume;this.parent.volume=0===e?this.parent.preVolume:0,this.parent.preVolume=e,this.changeState()}},{key:"barClick",value:function(e){var t="vertical"===this.layout?1-e.offsetY/this.$bg[0].offsetHeight:e.offsetX/this.$bg[0].offsetWidth;this.parent.volume=t<0?0:t>1?1:t,this.update()}},{key:"mousedown",value:function(e){"bar"===this.click(e)&&(this.startX="vertical"===this.layout?e.clientY:e.clientX,this.startVolume=this.parent.volume,addEvent(window,"mousemove",this.draging),addEvent(window,"mouseup",this.dragEnd),addEvent(window,"contextmenu",this.dragEnd))}},{key:"update",value:function(){this.changeState(),"vertical"===this.layout?this.$all.css("height",100*this.parent.volume+"%"):this.$all.css("width",100*this.parent.volume+"%")}},{key:"draging",value:function(e){this.endX="vertical"===this.layout?e.clientY:e.clientX;var t="vertical"===this.layout?(this.startX-this.endX)/this.$bg[0].offsetHeight:(this.endX-this.startX)/this.$bg[0].offsetWidth,r=+(this.startVolume+t).toFixed(2);this.parent.volume=r<0?0:r>1?1:r}},{key:"dragEnd",value:function(){this.startX=0,this.startVolume=0,removeEvent(window,"mousemove",this.draging),removeEvent(window,"mouseup",this.dragEnd),removeEvent(window,"contextmenu",this.dragEnd)}}]),t}(Base),_applyDecoratedDescriptor$2$1(_class$2$1.prototype,"draging",[autobind],_Object$getOwnPropertyDescriptor$1(_class$2$1.prototype,"draging"),_class$2$1.prototype),_applyDecoratedDescriptor$2$1(_class$2$1.prototype,"dragEnd",[autobind],_Object$getOwnPropertyDescriptor$1(_class$2$1.prototype,"dragEnd"),_class$2$1.prototype),_class$2$1),_class$1$2,defaultOption$2={tag:"chimee-progressbar",html:'\n    <chimee-progressbar-wrap>\n      <chimee-progressbar-bg class="chimee-progressbar-line"></chimee-progressbar-bg>\n      <chimee-progressbar-buffer class="chimee-progressbar-line"></chimee-progressbar-buffer>\n      <chimee-progressbar-all class="chimee-progressbar-line">\n        <chimee-progressbar-ball></chimee-progressbar-ball>\n      </chimee-progressbar-all>\n      <chimee-progressbar-tip></chimee-progressbar-tip>\n    </chimee-progressbar-wrap>\n  '},ProgressBar=(_class$1$2=function(e){function t(e,r){_classCallCheck$1(this,t);var n=_possibleConstructorReturn$1(this,(t.__proto__||_Object$getPrototypeOf$1(t)).call(this,e));return n.option=deepAssign(defaultOption$2,isObject$1(r)?r:{}),n.visiable=!1!==r,n.init(),n}return _inherits$1(t,e),_createClass$1(t,[{key:"init",value:function(){_get$1(t.prototype.__proto__||_Object$getPrototypeOf$1(t.prototype),"create",this).call(this),this.$dom=$(this.$dom),this.$wrap=this.$dom.find("chimee-progressbar-wrap"),this.$buffer=this.$dom.find("chimee-progressbar-buffer"),this.$all=this.$dom.find("chimee-progressbar-all"),this.$tip=this.$dom.find("chimee-progressbar-tip"),this.$track=this.$dom.find("chimee-progressbar-track"),this.$line=this.$dom.find(".chimee-progressbar-line"),this.$ball=this.$dom.find("chimee-progressbar-ball"),this.$dom.addClass("chimee-flex-component"),!this.visiable&&this.$dom.css("visibility","hidden"),"top"===this.option.layout&&(this.$dom.addClass("progressbar-layout-top"),this.$wrap.css({top:-this.$ball[0].offsetHeight+"px"}),setStyle(this.parent.$wrap,"paddingTop",this.$ball[0].offsetHeight+"px")),this.addWrapEvent()}},{key:"destroy",value:function(){this.removeWrapEvent(),this.watch_screen&&this.watch_screen(),_get$1(t.prototype.__proto__||_Object$getPrototypeOf$1(t.prototype),"destroy",this).call(this)}},{key:"addWrapEvent",value:function(){this.$wrap.on("mousedown",this.mousedown),this.$wrap.on("mousemove",this.tipShow),this.$wrap.on("mouseleave",this.tipEnd)}},{key:"removeWrapEvent",value:function(){this.$wrap.off("mousedown",this.mousedown),this.$wrap.off("mousemove",this.tipShow),this.$wrap.off("mouseleave",this.tipEnd)}},{key:"progress",value:function(){var e=0;try{e=this.parent.buffered.end(0)}catch(e){}var t=e/this.parent.duration*100+"%";this.$buffer.css("width",t)}},{key:"update",value:function(){var e=this._currentTime!==undefined?this._currentTime:this.parent.currentTime,t=e?e/this.parent.duration:0;this.$all.css("width","calc("+100*t+"% - "+this.$ball[0].offsetWidth/2+"px")}},{key:"mousedown",value:function(e){e.target!==this.$tip[0]&&(this._currentTime=e.offsetX/this.$wrap[0].offsetWidth*this.parent.duration,this.startX=e.clientX,this.startTime=this._currentTime,addEvent(window,"mousemove",this.draging),addEvent(window,"mouseup",this.dragEnd),addEvent(window,"contextmenu",this.dragEnd))}},{key:"draging",value:function(e){this.endX=e.clientX;var t=(this.endX-this.startX)/this.$wrap[0].offsetWidth*this.parent.duration,r=+(this.startTime+t).toFixed(2);this._currentTime=r<0?0:r>this.parent.duration?this.parent.duration:r,this.update()}},{key:"dragEnd",value:function(){this.startX=0,this.startTime=0,this.parent.currentTime=this._currentTime,this._currentTime=undefined,removeEvent(window,"mousemove",this.draging),removeEvent(window,"mouseup",this.dragEnd),removeEvent(window,"contextmenu",this.dragEnd)}},{key:"tipShow",value:function(e){if(e.target===this.$tip[0]||e.target===this.$ball[0])return void this.$tip.css("display","none");var t=e.offsetX/this.$wrap[0].offsetWidth*this.parent.duration;t=t<0?0:t>this.parent.duration?this.parent.duration:t;var r=formatTime(t),n=e.offsetX-this.$tip[0].offsetWidth/2,i=this.$wrap[0].offsetWidth-this.$tip[0].offsetWidth;n=n<0?0:n>i?i:n,this.$tip.text(r),this.$tip.css("display","inline-block"),this.$tip.css("left",n+"px")}},{key:"tipEnd",value:function(){this.$tip.css("display","none")}}]),t}(Base),_applyDecoratedDescriptor$1$2(_class$1$2.prototype,"mousedown",[autobind],_Object$getOwnPropertyDescriptor$1(_class$1$2.prototype,"mousedown"),_class$1$2.prototype),_applyDecoratedDescriptor$1$2(_class$1$2.prototype,"draging",[autobind],_Object$getOwnPropertyDescriptor$1(_class$1$2.prototype,"draging"),_class$1$2.prototype),_applyDecoratedDescriptor$1$2(_class$1$2.prototype,"dragEnd",[autobind],_Object$getOwnPropertyDescriptor$1(_class$1$2.prototype,"dragEnd"),_class$1$2.prototype),_applyDecoratedDescriptor$1$2(_class$1$2.prototype,"tipShow",[autobind],_Object$getOwnPropertyDescriptor$1(_class$1$2.prototype,"tipShow"),_class$1$2.prototype),_applyDecoratedDescriptor$1$2(_class$1$2.prototype,"tipEnd",[autobind],_Object$getOwnPropertyDescriptor$1(_class$1$2.prototype,"tipEnd"),_class$1$2.prototype),_class$1$2),defaultOption$3={tag:"chimee-progresstime",html:"\n    <chimee-progresstime-pass>00:00</chimee-progresstime-pass\n    ><chimee-progresstime-total\n      ><span>/</span\n      ><chimee-progresstime-total-value>00:00</chimee-progresstime-total-value>\n    </chimee-progresstime-total>\n  "},ProgressTime=function(e){function t(e,r){_classCallCheck$1(this,t);var n=_possibleConstructorReturn$1(this,(t.__proto__||_Object$getPrototypeOf$1(t)).call(this,e));return n.option=deepAssign(defaultOption$3,isObject$1(r)?r:{}),n.init(),n}return _inherits$1(t,e),_createClass$1(t,[{key:"init",value:function(){_get$1(t.prototype.__proto__||_Object$getPrototypeOf$1(t.prototype),"create",this).call(this),this.$dom=$(this.$dom),this.$total=this.$dom.find("chimee-progresstime-total-value"),this.$pass=this.$dom.find("chimee-progresstime-pass"),this.$dom.addClass("chimee-flex-component")}},{key:"updatePass",value:function(){this.$pass.text(formatTime(this.parent.currentTime))}},{key:"updateTotal",value:function(){this.$total.text(formatTime(this.parent.duration))}}]),t}(Base),_class$2$2,defaultOption$4={tag:"chimee-screen",html:'\n    <chimee-screen-full>\n      <svg viewBox="0 0 67 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n          \x3c!-- Generator: Sketch 43.1 (39012) - http://www.bohemiancoding.com/sketch --\x3e\n          <desc>Created with Sketch.</desc>\n          <defs></defs>\n          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n              <g id="screen-small" transform="translate(33.756308, 32.621867) rotate(45.000000) translate(-33.756308, -32.621867) translate(18.756308, -10.378133)" fill="#FFFFFF">\n                  <polygon id="Path" transform="translate(14.967695, 66.389245) rotate(180.000000) translate(-14.967695, -66.389245) " points="11.5190786 46.9431778 11.7210093 70.7913773 0.565180527 70.7913773 15.4674455 85.8353125 29.3702096 70.7913773 18.5573247 70.7702156 18.5573247 46.9431778"></polygon>\n                  <polygon id="Path" points="11.5190786 0.274130278 11.7210093 24.1223298 0.565180527 24.1223298 15.4674455 39.1662649 29.3702096 24.1223298 18.5573247 24.1011681 18.5573247 0.274130278"></polygon>\n              </g>\n          </g>\n      </svg>\n    </chimee-screen-full>\n    <chimee-screen-small>\n      <svg viewBox="0 0 61 62" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        \x3c!-- Generator: Sketch 43.1 (39012) - http://www.bohemiancoding.com/sketch --\x3e\n        <desc>Created with Sketch.</desc>\n        <defs></defs>\n        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n            <g id="Group" transform="translate(30.756308, 30.621867) rotate(45.000000) translate(-30.756308, -30.621867) translate(15.756308, -12.378133)" fill="#FFFFFF">\n                <polygon id="Path" points="11.5190786 46.9431778 11.7210093 70.7913773 0.565180527 70.7913773 15.4674455 85.8353125 29.3702096 70.7913773 18.5573247 70.7702156 18.5573247 46.9431778"></polygon>\n                <polygon id="Path" transform="translate(14.967695, 19.720198) rotate(180.000000) translate(-14.967695, -19.720198) " points="11.5190786 0.274130278 11.7210093 24.1223298 0.565180527 24.1223298 15.4674455 39.1662649 29.3702096 24.1223298 18.5573247 24.1011681 18.5573247 0.274130278"></polygon>\n            </g>\n        </g>\n      </svg>\n    </chimee-screen-small>\n  ',defaultEvent:{click:"click"}},Screen=(_class$2$2=function(e){function t(e,r){_classCallCheck$1(this,t);var n=_possibleConstructorReturn$1(this,(t.__proto__||_Object$getPrototypeOf$1(t)).call(this,e));return n.state="small",n.option=deepAssign(defaultOption$4,isObject$1(r)?r:{}),n.init(),n}return _inherits$1(t,e),_createClass$1(t,[{key:"init",value:function(){_get$1(t.prototype.__proto__||_Object$getPrototypeOf$1(t.prototype),"create",this).call(this),this.$dom=$(this.$dom),this.changeState(this.state),this.$dom.addClass("chimee-flex-component"),this.$full=this.$dom.find("chimee-screen-full"),this.$small=this.$dom.find("chimee-screen-small"),this.option.icon&&this.option.icon.full&&this.option.icon.small?(this.$full.html(this.option.icon.full),this.$small.html(this.option.icon.small)):this.option.bitmap&&(this.$full.html(""),this.$small.html(""))}},{key:"changeState",value:function(e){var t="small"===e?"full":"small";addClassName(this.parent.$dom,e),removeClassName(this.parent.$dom,t)}},{key:"click",value:function(){var e=!1;"small"===this.state?(this.state="full",e=!0):(this.state="small",e=!1),this.changeState(this.state),this.parent.$fullscreen(e,"container"),e?this.watch_screen=this.parent.$watch("isFullscreen",this.screenChange):this.watch_screen()}},{key:"screenChange",value:function(){this.parent.fullscreenElement&&(this.state="small",this.changeState("small"),this.parent.$fullscreen(!1,"container"))}}]),t}(Base),_applyDecoratedDescriptor$2$2(_class$2$2.prototype,"screenChange",[autobind],_Object$getOwnPropertyDescriptor$1(_class$2$2.prototype,"screenChange"),_class$2$2.prototype),_class$2$2),defaultOption$5={tag:"chimee-clarity",width:"2em",html:'\n    <chimee-clarity-text></chimee-clarity-text>\n    <chimee-clarity-list>\n      <ul></ul>\n      <div class="chimee-clarity-list-arrow">\n        <svg viewBox="0 0 115 6"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n          <g id="Group-3-Copy" fill="#57B0F6">\n            <polygon id="Path-2" points="0.0205224145 0.0374249581 0.0205224145 2.12677903 53.9230712 2.12677903 57.1127727 5.3468462 60.2283558 2.12677903 113.820935 2.12677903 113.820935 0.0374249581"></polygon>\n          </g>\n        </svg>\n      </div>\n    </chimee-clarity-list>\n  ',defaultEvent:{click:"click"},duration:10,increment:1},Clarity=function(e){function t(e,r){_classCallCheck$1(this,t);var n=_possibleConstructorReturn$1(this,(t.__proto__||_Object$getPrototypeOf$1(t)).call(this,e));return n.option=deepAssign(defaultOption$5,isObject$1(r)?r:{}),n.init(),n}return _inherits$1(t,e),_createClass$1(t,[{key:"init",value:function(){_get$1(t.prototype.__proto__||_Object$getPrototypeOf$1(t.prototype),"create",this).call(this),addClassName(this.$dom,"chimee-flex-component"),this.$text=$(this.$dom).find("chimee-clarity-text"),this.$list=$(this.$dom).find("chimee-clarity-list"),this.$listUl=this.$list.find("ul"),this.option.width&&setStyle(this.$dom,"width",this.option.width),this.initTextList()}},{key:"initTextList",value:function(){var e=this;this.option.list.forEach(function(t){var r=$(document.createElement("li"));r.attr("data-url",t.src),r.text(t.name),t.src===e.parent.$videoConfig.src&&(e.$text.text(t.name),r.addClass("active")),e.$listUl.append(r)})}},{key:"click",value:function(e){var t=this,r=e.target;if("LI"===r.tagName){var n=r.getAttribute("data-url")||"";this.switchClarity(n).then(function(){t.loadOption=undefined,_Array$from$1(r.parentElement.children).map(function(e){removeClassName(e,"active")}),addClassName(e.target,"active"),t.$text.text(e.target.textContent)})["catch"](function(e){console.warn(e)})}}},{key:"switchClarity",value:function(e){return this.loadOption&&(this.loadOption.abort=!0),this.loadOption={duration:this.option.duration,repeatTimes:3,immediate:!0,increment:this.option.increment},this.parent.$silentLoad(e,this.loadOption)}}]),t}(Base),majorColorStyle="\n  .chimee-flex-component svg *{\n    fill: majorColor;\n    stroke: majorColor;\n  }\n  chimee-progressbar-all{\n    background: majorColor;\n  }\n  chimee-volume.chimee-flex-component chimee-volume-bar-all{\n    background: majorColor;    \n  }\n  chimee-clarity-list li:hover,\n  chimee-clarity-list li.active {\n    color: majorColor;\n  }\n",hoverColorStyle="\n  .chimee-flex-component svg:hover *{\n    fill: hoverColor;\n    stroke: hoverColor;\n  }\n",defaultConfig$1$1={hideBarTime:2e3,barShowByMouse:"move"},chimeeControl={name:"chimeeControl",el:"chimee-control",data:{children:{},show:!1,disabled:!0},level:99,operable:!1,penetrate:!1,create:function(){},init:function(e){e.controls&&(this.show=!0,e.controls=!1);var t=this;applyDecorators(e,{controls:accessor({get:function(){return t.show},set:function(e){return t.show=Boolean(e),t._display(),!1}},{preSet:!0})},{self:!0}),this.config=isObject$1(this.$config)?deepAssign(defaultConfig$1$1,this.$config):defaultConfig$1$1,this.config.hideBarTime="move"===this.config.barShowByMouse?this.config.hideBarTime:0,this.$dom.innerHTML="<chimee-control-wrap></chimee-control-wrap>",this.$wrap=this.$dom.querySelector("chimee-control-wrap"),this.children=createChild(this),this._setStyle()},destroy:function(){window.clearTimeout(this.timeId)},inited:function(){for(var e in this.children)this.children[e].inited&&this.children[e].inited()},events:{loadstart:function(){this._disable(!0)},canplay:function(){this._disable(!1)},play:function(){this.children.play&&this.children.play.changeState("play"),"move"===this.config.barShowByMouse&&this._hideItself()},pause:function(){this.children.play&&this.children.play.changeState("pause"),this._showItself()},c_mouseenter:function(){"move"!==this.config.barShowByMouse&&this._showItself()},c_mousemove:function(){this._mousemove()},c_mouseleave:function(){"move"!==this.config.barShowByMouse&&this._hideItself()},durationchange:function(){this.children.progressTime&&this.children.progressTime.updateTotal()},timeupdate:function(){this._progressUpdate()},progress:function(){this.children.progressBar&&this.children.progressBar.progress()},volumechange:function(){this.children.volume&&this.children.volume.update()},keydown:function(e){if(!this.disabled)switch(e.stopPropagation(),e.keyCode){case 32:e.preventDefault(),this.children.play&&this.children.play.click(e);break;case 37:e.preventDefault();var t=this.currentTime-10;this.currentTime=t<0?0:t,this._mousemove();break;case 39:e.preventDefault();var r=this.currentTime+10;this.currentTime=r>this.duration?this.duration:r,this._mousemove();break;case 38:e.preventDefault();var n=this.volume+.1;this.volume=n>1?1:n,this._mousemove();break;case 40:e.preventDefault();var i=this.volume-.1;this.volume=i<0?0:i,this._mousemove()}},click:function(e){var t=this,r=new Date,n=this.clickTime;if(this.clickTime=r,r-n<300)return void clearTimeout(this.clickTimeId);this.clickTimeId=setTimeout(function(){!t.disabled&&t.children.play&&t.children.play.click(e)},300)},dblclick:function(e){!this.disabled&&this.children.screen&&this.children.screen.click()}},methods:{_progressUpdate:function(){this.children.progressBar&&this.children.progressBar.update(),this.children.progressTime&&this.children.progressTime.updatePass()},_hideItself:function(){var e=this;window.clearTimeout(this.timeId),this.timeId=setTimeout(function(){var t=e.$wrap.offsetHeight;t=e.children.progressBar?e.children.progressBar.$wrap[0].offsetTop-t:-t,setStyle(e.$wrap,{bottom:t+"px"}),setStyle(e.$dom,{visibility:"hidden"})},this.config.hideBarTime)},_showItself:function(){window.clearTimeout(this.timeId),setStyle(this.$wrap,{bottom:"0"}),setStyle(this.$dom,{visibility:"visible"})},_display:function(){var e=this.show?"block":"none";setStyle(this.$dom,{display:e})},_mousemove:function(e){this.paused||"enter"===this.config.barShowByMouse||(this._showItself(),this._hideItself())},_disable:function(e){this.show&&(this.disabled=e,setStyle(this.$wrap,"pointerEvents",e?"none":"auto"))},_setStyle:function(){var e="";e+=this.config.majorColor?majorColorStyle.replace(/majorColor/g,this.config.majorColor):"",e+=this.config.hoverColor?hoverColorStyle.replace(/hoverColor/g,this.config.hoverColor):"";var t=document.createElement("style");t.setAttribute("type","text/css"),t.innerHTML=e,document.head.appendChild(t)}}};__$styleInject$2("chimee-popup{position:absolute;color:#fff;background-color:rgba(88,88,88,.5);font-size:13px;font-family:sans-serif;border:1px solid hsla(0,0%,100%,.08);padding:3px}chimee-popup cm-pp-close{float:right;color:#fff;text-decoration:none;line-height:14px;text-shadow:0 0 1px #000;font-size:15px;padding:0 3px;cursor:pointer;opacity:.8}chimee-popup cm-pp-close:hover{opacity:1}chimee-popup cm-pp-body,chimee-popup cm-pp-head{display:block;padding:3px 3px 6px}chimee-popup cm-pp-head{font-weight:700;border-bottom:1px solid hsla(0,0%,100%,.18);padding:0 5px 4px;margin-bottom:5px}chimee-popup cm-pp-body{font-size:12px}",undefined),__$styleInject$4("chimee-popup{position:absolute;color:#fff;background-color:rgba(88,88,88,.5);font-size:13px;font-family:sans-serif;border:1px solid hsla(0,0%,100%,.08);padding:3px}chimee-popup cm-pp-close{float:right;color:#fff;text-decoration:none;line-height:14px;text-shadow:0 0 1px #000;font-size:15px;padding:0 3px;cursor:pointer;opacity:.8}chimee-popup cm-pp-close:hover{opacity:1}chimee-popup cm-pp-body,chimee-popup cm-pp-head{display:block;padding:3px 3px 6px}chimee-popup cm-pp-head{font-weight:700;border-bottom:1px solid hsla(0,0%,100%,.18);padding:0 5px 4px;margin-bottom:5px}chimee-popup cm-pp-body{font-size:12px}",undefined),__$styleInject$3("chimee-menu{position:absolute;color:#fff;background-color:rgba(37,37,37,.7);font-size:13px;font-family:sans-serif;border:1px solid hsla(0,0%,100%,.08);border-radius:2px;padding:2px;box-shadow:0 1px 4px rgba(0,0,0,.6)}chimee-menu ul{margin:0;padding:0;font-size:12px}chimee-menu li{cursor:pointer;padding:0 4px;line-height:24px;list-style:none;white-space:nowrap;margin:0;border:0;font-size:12px;font-weight:400}chimee-menu li:hover{background-color:hsla(0,0%,100%,.1)}chimee-menu li[disable]{opacity:.5;cursor:default}chimee-menu li a{color:#fff;text-decoration:none}chimee-menu li a:hover{color:#fff}",undefined);var logPopupOpenEvt="openLogPopup",contextmenuConf=popupFactory$2({tagName:"chimee-menu",name:"chimeeContextmenu",html:"<ul></ul>",offset:"0",hide:!0,data:{baseMenus:[{text:"\u67e5\u770b\u65e5\u5fd7",action:logPopupOpenEvt,hide:!0},{text:"Chimee {VERSION} &copy; 360",url:"http://chimee.org",disable:!0}]},create:function(){var e=this,t=this.$config,r=t.baseMenus,n=t.menus;isArray$1(r)&&(this.baseMenus=r),this.updatemenu(n),this.$domWrap.on("click",this.clickHandler),this.$plugins.chimeeLog&&this.switchLogMenu(!1),this._doc=new this.$domWrap.constructor(document),this._doc_click=function(t){return e.close()},this._doc.on("click",this._doc_click)},destroy:function(){this._doc.off("click",this._doc_click)},opened:function(){this.$bumpToTop()},events:{contextmenu:function(e){var t=e.offsetX,r=e.offsetY,n=this.$dom.parentElement;if(isFunction(n.getBoundingClientRect)){var i=n.getBoundingClientRect();t=e.pageX-i.left-(document.documentElement.scrollLeft||document.body.scrollLeft||0),r=e.pageY-i.top-(document.documentElement.scrollTop||document.body.scrollTop||0)}this.offset(t+"px "+r+"px").open(e),e.preventDefault()},logPluginDestroy:function(){this.switchLogMenu(!0)},logPluginCreate:function(){this.switchLogMenu(!1)}},methods:{switchLogMenu:function(e){var t=this.baseMenus.find(function(e){return e.action===logPopupOpenEvt});t&&(t.hide=e,this.$domWrap.find('[data-action="'+logPopupOpenEvt+'"]').css("display",e?"none":""))},updatemenu:function(e){var t=this,r=[];isArray$1(e)&&(r=r.concat(e));var n=r.concat(this.baseMenus).map(function(e){var r=e.hide,n=e.disable,i=e.action,o=e.className,a=e.text,s=e.url,u=n?"disable":"",c=i?'data-action="'+i+'"':"",l=o?'class="'+o+'"':"",f=r?'style="display:none"':"",d=a.replace(/\{([^)]*)\}/g,function(e,r){return t[r]});return s&&(d='<a href="'+s+'" target="_blank">'+d+"</a>"),"<li "+u+" "+c+" "+l+" "+f+">"+d+"</li>"}).join("");this.$domWrap.find("ul").html(n)},clickHandler:function(e){var t=e.target;if(!t.disable){var r=t.dataset.action;r&&(this.$emit(r),isFunction(this[r])&&this[r](e)),this.close()}e.stopPropagation()}}});__$styleInject$6("chimee-popup{position:absolute;color:#fff;background-color:rgba(88,88,88,.5);font-size:13px;font-family:sans-serif;border:1px solid hsla(0,0%,100%,.08);padding:3px}chimee-popup cm-pp-close{float:right;color:#fff;text-decoration:none;line-height:14px;text-shadow:0 0 1px #000;font-size:15px;padding:0 3px;cursor:pointer;opacity:.8}chimee-popup cm-pp-close:hover{opacity:1}chimee-popup cm-pp-body,chimee-popup cm-pp-head{display:block;padding:3px 3px 6px}chimee-popup cm-pp-head{font-weight:700;border-bottom:1px solid hsla(0,0%,100%,.18);padding:0 5px 4px;margin-bottom:5px}chimee-popup cm-pp-body{font-size:12px}",undefined),__$styleInject$5(".chimee-log{padding:2px;box-shadow:0 1px 4px rgba(0,0,0,.6)}.chimee-log label{margin-left:10px;font-weight:100;font-size:12px}.chimee-log label input{vertical-align:middle;display:inline;width:auto;padding:0;margin:0}.chimee-log vs-pp-body{padding:3px}.chimee-log textarea{display:block;width:100%;height:200px;margin:-3px;border:1px solid hsla(0,0%,100%,.5);background-color:hsla(0,0%,100%,.9)}",undefined);var pageLoadedTimestamp=(new Date).getTime().toString();setLocalStorage("_chimee_t",pageLoadedTimestamp);var supportLS=getLocalStorage("_chimee_t")===pageLoadedTimestamp,defaultEvents=function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];var n={};return t.forEach(function(e){n[e]=function(t){for(var r=this,n=arguments.length,i=Array(n>1?n-1:0),o=1;o<n;o++)i[o-1]=arguments[o];this.writeLog(t);var a=this.box,s=this.type,u=this.src,c=this._waiting_num,l=this.currentTime,f=this._is_seek,d=f!==undefined&&f,h=this._is_play,p=h!==undefined&&h,y=this.playingTimestamp,g=this.loadstartTimestamp,m=this.waitingTimestamp;switch(e){case"loadstart":this.sendLog(e,{box:a,type:s,src:u}),this._ls_timeout=setTimeout(function(){r.sendLog("timeout",{src:u})},this.timeoutDelay),this._total_waiting_time=0;break;case"seeking":this._is_seek=!0;break;case"play":this._is_play=!0;break;case"pause":this.sendLog(e,{src:u,currentTime:l});break;case"canplay":clearTimeout(this._ls_timeout);var _=this.canplayTimestamp;this.sendLog(e,{src:u,currentTime:l,waitingNum:c,waitingTime:_-(g||m||_)});break;case"playing":clearTimeout(this._ls_timeout);var v=y-(g||m||y);this._total_waiting_time+=v,this.sendLog(e,{src:u,waitingNum:c,currentTime:l,isSeek:d,isPlay:p,waitingTime:v}),this.loadstartTimestamp=0,this.waitingTimestamp=0,this._is_seek=!1,this._is_play=!1;break;case"ended":this.sendLog(e,{src:u,waitingNum:c,totalWaitingTime:this._total_waiting_time});break;case"waiting":this._waiting_num++,this.sendLog(e,{src:u,waitingNum:c,currentTime:l,isSeek:d,isPlay:p});break;case"error":this.sendLog(e,{src:u,args:i})}}}),n}("loadstart","abort","durationchange","loadedmetadata","loadeddata","progress","canplay","canplaythrough","pause","play","playing","emptied","ended","seeking","seeked","stalled","suspend","timeupdate","waiting","error"),index$1=popupFactory$4({name:"chimeeLog",className:"chimee-log",title:"\u65e5\u5fd7\u4fe1\u606f"+(supportLS?'<label><input type="checkbox">\u4e0b\u6b21\u81ea\u52a8\u6253\u5f00</label>':""),body:"<textarea>Chimee logs:</textarea>",offset:"0",width:"400px",hide:!0,autoFocus:!1,logPostUrl:undefined,beforeCreate:function(e,t){isUrl(t.logPostUrl)&&(this.logPostUrl=t.logPostUrl),t.timeoutDelay&&(this.timeoutDelay=t.timeoutDelay)},create:function(){this.logBase.ver=this.VERSION;var e=this.$domWrap;if(this.$txtEl=e.find("textarea"),supportLS){var t="1"===getLocalStorage("auto_on");e.find('input[type="checkbox"]').on("change",function(e){setLocalStorage("auto_on",+this.checked)})[0].checked=t,this._hide=!t}this.writeLog({type:"ready"}),this.$emitSync("logPluginCreate")},destroy:function(){clearTimeout(this._ls_timeout),this.$emitSync("logPluginDestroy"),this.sendLog("destroy")},inited:function(){},closed:function(){this.$txtEl.text("")},opened:function(){this.$bumpToTop()},methods:{writeLog:function(e){var t=e.type;if(this[t+"Timestamp"]=+new Date,!this._hide){var r=void 0,n="write_"+t+"_log";if(this[n]){for(var i=arguments.length,o=Array(i>1?i-1:0),a=1;a<i;a++)o[a-1]=arguments[a];r=this[n](t,o)}var s=this.$txtEl.text()+"\n["+formatDate(new Date(this[t+"Timestamp"]),"yyyy-MM-dd hh:mm:ss.i")+"] "+t+" "+(r!==undefined?_JSON$stringify(r):""),u=this.$txtEl.text(s)[0];u.scrollTop=u.scrollHeight}},write_loadstart_log:function(e){return{box:this.box,type:this.type,src:this.src}},write_durationchange_log:function(){return{duration:this.duration}},write_timeupdate_log:function(){return{currentTime:this.currentTime}},send_inited_log:function(){var e=this.box,t=this.type,r=this.src,n=this.controls,i=this.loop;return{pro:location.protocol,box:e,type:t,src:r,ctrs:n,loop:i}},sendLog:function(e,t){var r=this.logPostUrl;if(r){var n=deepAssign(t||{},this.logBase),i="send_"+e+"_log";this[i]&&deepAssign(n,this[i](e,n)),deepAssign(n,{evt:e,_t:+new Date,_r:Math.random()});var o=[];_Object$keys(n).forEach(function(e){return o.push(encodeURIComponent(e)+"="+encodeURIComponent(n[e]))});var a=new Image;a.onload=a.onerror=function(e){a=null},a.src=r+"?"+o.join("&")}}},events:deepAssign(defaultEvents,{openLogPopup:function(){this.open()}}),data:{timeoutDelay:3e4,pageLoadedTimestamp:pageLoadedTimestamp,_waiting_num:0,_total_waiting_time:0,logBase:{uid:function(e){return e||(e=uuid(),setLocalStorage("_chimee_uid",e)),e}(getLocalStorage("_chimee_uid")),ref:location.href}},computed:{type:function(){return this.$videoConfig.isLive?"live":"vod"}}})
;__$styleInject$7('chimee-center-state{position:absolute}@keyframes a{0%{opacity:1}to{transform:scale(2);opacity:0}}chimee-center-state-correct,chimee-center-state-error,chimee-center-state-loading,chimee-center-state-tip{display:none}chimee-center-state.correct chimee-center-state-correct,chimee-center-state.error chimee-center-state-error,chimee-center-state.loading chimee-center-state-loading,chimee-center-state.tip chimee-center-state-tip{display:inline-block}chimee-center-state-correct{width:104px;height:104px}chimee-center-state-tip{position:absolute;left:26px;bottom:26px;width:52px;height:52px;border-radius:26px;background:rgba(0,0,0,.5);animation:a .5s linear 1 normal forwards}chimee-center-state.play span{background-image:url("data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjQycHgiIGhlaWdodD0iNTFweCIgdmlld0JveD0iMCAwIDQyIDUxIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0My4xICgzOTAxMikgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwb2x5Z29uIGlkPSJUcmlhbmdsZSIgZmlsbD0iI0ZGRkZGRiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjEuMDAwMDAwLCAyNS41MDAwMDApIHJvdGF0ZSg5MC4wMDAwMDApIHRyYW5zbGF0ZSgtMjEuMDAwMDAwLCAtMjUuNTAwMDAwKSAiIHBvaW50cz0iMjEgNSA0NiA0NiAtNCA0NiI+PC9wb2x5Z29uPgogICAgPC9nPgo8L3N2Zz4=")}chimee-center-state.pause span{background-image:url("data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjUwcHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDUwIDUwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0My4xICgzOTAxMikgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNGRkZGRkYiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSI1MCI+PC9yZWN0PgogICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiNGRkZGRkYiIHg9IjMwIiB5PSIwIiB3aWR0aD0iMjAiIGhlaWdodD0iNTAiPjwvcmVjdD4KICAgIDwvZz4KPC9zdmc+")}chimee-center-state.back span{background-image:url("data:image/svg+xml;base64,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")}chimee-center-state.forward span{background-image:url("data:image/svg+xml;base64,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")}chimee-center-state.volume-high span{background-image:url("data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjEwN3B4IiBoZWlnaHQ9IjEwMXB4IiB2aWV3Qm94PSIwIDAgMTA3IDEwMSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDQuMSAoNDE0NTUpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iR3JvdXAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAwLjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiI+CiAgICAgICAgPHBvbHlnb24gaWQ9IlBhdGgiIGZpbGw9IiNmZmZmZmYiIHBvaW50cz0iMC40MDczMTY0NDYgMzAgMjcuNjUwMDc3OSAzMCA1Ny4zNzM3MjkzIDIuODQyMTcwOTRlLTE0IDU4LjQ3NjI1MzIgMTAwIDI3LjY1MDA3NzkgNzAgMC40MDczMTY0NDYgNzAiPjwvcG9seWdvbj4KICAgICAgICA8cGF0aCBkPSJNNjMuNjExNjUwNSw1LjAwOTc1MjM5IEM2OS43MDc5Mjc1LDQuNzg2MTIwNTcgNzYuNjU0OTI1MSw4LjQwODU2MTQ2IDg0LjQ1MjY0MzEsMTUuODc3MDc1IEM5Ni4xNDkyMjAxLDI3LjA3OTg0NTQgMTAwLjk3MDg3NCwzNC43OTc1MTI1IDEwMC45NzA4NzQsNTAuOTYwODU1OCBDMTAwLjk3MDg3NCw2Ny4xMjQxOTkxIDk2LjI4ODcyMjUsNzMuNzkwNzQ4MiA4NC40NTI2NDMxLDgzLjgzMDY3MjQgQzc2LjU2MTkyMzQsOTAuNTIzOTU1MiA2OS42MTQ5MjU5LDk0LjAzMjA2NDQgNjMuNjExNjUwNSw5NC4zNTUiIGlkPSLlpJbnjq8iIHN0cm9rZS13aWR0aD0iMTAiPjwvcGF0aD4KICAgICAgICA8cGF0aCBkPSJNNjUuODUwNTY5OSwyOS40OTI5MTk1IEM2OC41MzY5NDM0LDI5LjM5MzExNjkgNzEuNTk4MTkzOCwzMS4wMDk3NDE2IDc1LjAzNDMyMSwzNC4zNDI3OTM0IEM4MC4xODg1MTE4LDM5LjM0MjM3MTIgODIuMzEzMjEyMyw0Mi43ODY2MTU0IDgyLjMxMzIxMjMsNTAgQzgyLjMxMzIxMjMsNTcuMjEzMzg0NiA4MC4yNDk5ODQ3LDYwLjE4ODUzNTQgNzUuMDM0MzIxLDY0LjY2OTE1NzYgQzcxLjU1NzIxMTksNjcuNjU2MjM5IDY4LjQ5NTk2MTUsNjkuMjIxODM5NyA2NS44NTA1Njk5LDY5LjM2NTk1OTUiIGlkPSLlhoXnjq8iIHN0cm9rZS13aWR0aD0iMTAiPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+")}chimee-center-state.volume-low span{background-image:url("data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9Ijg5cHgiIGhlaWdodD0iMTAxcHgiIHZpZXdCb3g9IjAgMCA4OSAxMDEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ0LjEgKDQxNDU1KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMC4wMDAwMDApIiBzdHJva2U9IiNGRkZGRkYiPgogICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoIiBmaWxsPSIjZmZmZmZmIiBwb2ludHM9IjAuNDA3MzE2NDQ2IDMwIDI3LjY1MDA3NzkgMzAgNTcuMzczNzI5MyAyLjg0MjE3MDk0ZS0xNCA1OC40NzYyNTMyIDEwMCAyNy42NTAwNzc5IDcwIDAuNDA3MzE2NDQ2IDcwIj48L3BvbHlnb24+CiAgICAgICAgPHBhdGggZD0iTTY1Ljg1MDU2OTksMjkuNDkyOTE5NSBDNjguNTM2OTQzNCwyOS4zOTMxMTY5IDcxLjU5ODE5MzgsMzEuMDA5NzQxNiA3NS4wMzQzMjEsMzQuMzQyNzkzNCBDODAuMTg4NTExOCwzOS4zNDIzNzEyIDgyLjMxMzIxMjMsNDIuNzg2NjE1NCA4Mi4zMTMyMTIzLDUwIEM4Mi4zMTMyMTIzLDU3LjIxMzM4NDYgODAuMjQ5OTg0Nyw2MC4xODg1MzU0IDc1LjAzNDMyMSw2NC42NjkxNTc2IEM3MS41NTcyMTE5LDY3LjY1NjIzOSA2OC40OTU5NjE1LDY5LjIyMTgzOTcgNjUuODUwNTY5OSw2OS4zNjU5NTk1IiBpZD0i5YaF546vIiBzdHJva2Utd2lkdGg9IjEwIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg==")}chimee-center-state-tip span{display:inline-block;width:24px;height:24px;margin:14px;background-origin:content-box;background-size:auto 100%;background-repeat:no-repeat;background-position:50%;box-sizing:initial}chimee-center-state.play span{background-position:110% 50%}chimee-center-state-loading{width:52px;height:52px;padding:26px;background-image:url("data:image/svg+xml;base64,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");background-origin:content-box;background-size:auto 100%;background-repeat:no-repeat;background-position:50%}chimee-center-state-error{display:none;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:180px;font-size:16px;z-index:1;color:#ffcf00;text-shadow:0 0 3px red;font-weight:100}',undefined);var clss="correct tip play pause back forward volume-high volume-low",chimeeCenterState=popupFactory({name:"chimeeCenterState",tagName:"chimee-center-state",html:"\n    <chimee-center-state-correct>\n      <chimee-center-state-loading></chimee-center-state-loading>\n      <chimee-center-state-tip>\n        <span></span>\n      </chimee-center-state-tip>\n    </chimee-center-state-correct>\n    <chimee-center-state-error>\u52a0\u8f7d\u5931\u8d25\uff0c\u8bf7\u5237\u65b0\u91cd\u8bd5</chimee-center-state-error>\n  ",offset:"50%",hide:!1,create:function(){},inited:function(){this.src&&this.showLoading(!0)},penetrate:!0,operable:!1,destroy:function(){this.clearTimeout()},events:{pause:function(){this.showTip("pause"),this.showLoading(!1)},play:function(){this.showTip("play")},canplay:function(){this.playing()},playing:function(){this.playing()},loadstart:function(){this.waiting("loadstart")},waiting:function(){this.waiting()},timeupdate:function(){this.clearTimeout()},keydown:function(e){if(this.$videoConfig.plugin.some(function(e){return"chimeeControl"===(e.name||e)}))switch(e.stopPropagation(),e.keyCode){case 37:e.preventDefault(),!this.live&&this.showTip("back");break;case 39:e.preventDefault(),!this.live&&this.showTip("forward");break;case 38:e.preventDefault(),this.showTip("volume-high");break;case 40:e.preventDefault(),this.showTip("volume-low")}}},methods:{playing:function(){this.clearTimeout(),this.showLoading(!1),this.showError(!1)},waiting:function(e){var t=this;this.clearTimeout(),this._timeout=setTimeout(function(){return t.showError()},3e4),("loadstart"===e||!this.paused)&&this.showLoading()},clearTimeout:function(e){function t(){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}(function(){this._timeout&&(clearTimeout(this._timeout),this._timeout=null)}),showTip:function(e){var t=this;this.$domWrap.removeClass(clss).addClass("correct tip "+e),setTimeout(function(){t.$domWrap.removeClass("tip "+e)},500)},showLoading:function(e){!1===e?this.$domWrap.removeClass("loading"):this.$domWrap.addClass("correct loading")},showError:function(e){!1===e?this.$domWrap.removeClass("error"):(this.$domWrap[0].className="",this.$domWrap.addClass("error"))}}}),hls=createCommonjsModule(function(t,r){!function(e,r){t.exports=r()}(0,function(){return function(e){function t(n){if(r[n])return r[n].exports;var i=r[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e["default"]}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/dist/",t(t.s=8)}([function(e,t,r){function n(){}function i(e,t){return t="["+e+"] > "+t}function o(e){var t=self.console[e];return t?function(){for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];n[0]&&(n[0]=i(e,n[0])),t.apply(self.console,n)}:n}function a(e){for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];r.forEach(function(t){c[t]=e[t]?e[t].bind(e):o(t)})}r.d(t,"a",function(){return l}),r.d(t,"b",function(){return f});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u={trace:n,debug:n,log:n,warn:n,info:n,error:n},c=u,l=function(e){if(!0===e||"object"===(void 0===e?"undefined":s(e))){a(e,"debug","log","info","warn","error");try{c.log()}catch(e){c=u}}else c=u},f=c},function(e,t,r){t.a={MEDIA_ATTACHING:"hlsMediaAttaching",MEDIA_ATTACHED:"hlsMediaAttached",MEDIA_DETACHING:"hlsMediaDetaching",MEDIA_DETACHED:"hlsMediaDetached",BUFFER_RESET:"hlsBufferReset",BUFFER_CODECS:"hlsBufferCodecs",BUFFER_CREATED:"hlsBufferCreated",BUFFER_APPENDING:"hlsBufferAppending",BUFFER_APPENDED:"hlsBufferAppended",BUFFER_EOS:"hlsBufferEos",BUFFER_FLUSHING:"hlsBufferFlushing",BUFFER_FLUSHED:"hlsBufferFlushed",MANIFEST_LOADING:"hlsManifestLoading",MANIFEST_LOADED:"hlsManifestLoaded",MANIFEST_PARSED:"hlsManifestParsed",LEVEL_SWITCH:"hlsLevelSwitch",LEVEL_SWITCHING:"hlsLevelSwitching",LEVEL_SWITCHED:"hlsLevelSwitched",LEVEL_LOADING:"hlsLevelLoading",LEVEL_LOADED:"hlsLevelLoaded",LEVEL_UPDATED:"hlsLevelUpdated",LEVEL_PTS_UPDATED:"hlsLevelPtsUpdated",AUDIO_TRACKS_UPDATED:"hlsAudioTracksUpdated",AUDIO_TRACK_SWITCH:"hlsAudioTrackSwitch",AUDIO_TRACK_SWITCHING:"hlsAudioTrackSwitching",AUDIO_TRACK_SWITCHED:"hlsAudioTrackSwitched",AUDIO_TRACK_LOADING:"hlsAudioTrackLoading",AUDIO_TRACK_LOADED:"hlsAudioTrackLoaded",SUBTITLE_TRACKS_UPDATED:"hlsSubtitleTracksUpdated",SUBTITLE_TRACK_SWITCH:"hlsSubtitleTrackSwitch",SUBTITLE_TRACK_LOADING:"hlsSubtitleTrackLoading",SUBTITLE_TRACK_LOADED:"hlsSubtitleTrackLoaded",SUBTITLE_FRAG_PROCESSED:"hlsSubtitleFragProcessed",INIT_PTS_FOUND:"hlsInitPtsFound",FRAG_LOADING:"hlsFragLoading",FRAG_LOAD_PROGRESS:"hlsFragLoadProgress",FRAG_LOAD_EMERGENCY_ABORTED:"hlsFragLoadEmergencyAborted",FRAG_LOADED:"hlsFragLoaded",FRAG_DECRYPTED:"hlsFragDecrypted",FRAG_PARSING_INIT_SEGMENT:"hlsFragParsingInitSegment",FRAG_PARSING_USERDATA:"hlsFragParsingUserdata",FRAG_PARSING_METADATA:"hlsFragParsingMetadata",FRAG_PARSING_DATA:"hlsFragParsingData",FRAG_PARSED:"hlsFragParsed",FRAG_BUFFERED:"hlsFragBuffered",FRAG_CHANGED:"hlsFragChanged",FPS_DROP:"hlsFpsDrop",FPS_DROP_LEVEL_CAPPING:"hlsFpsDropLevelCapping",ERROR:"hlsError",DESTROYING:"hlsDestroying",KEY_LOADING:"hlsKeyLoading",KEY_LOADED:"hlsKeyLoaded",STREAM_STATE_TRANSITION:"hlsStreamStateTransition"}},function(e,t,r){r.d(t,"b",function(){return n}),r.d(t,"a",function(){return i});var n={NETWORK_ERROR:"networkError",MEDIA_ERROR:"mediaError",MUX_ERROR:"muxError",OTHER_ERROR:"otherError"},i={MANIFEST_LOAD_ERROR:"manifestLoadError",MANIFEST_LOAD_TIMEOUT:"manifestLoadTimeOut",MANIFEST_PARSING_ERROR:"manifestParsingError",MANIFEST_INCOMPATIBLE_CODECS_ERROR:"manifestIncompatibleCodecsError",LEVEL_LOAD_ERROR:"levelLoadError",LEVEL_LOAD_TIMEOUT:"levelLoadTimeOut",LEVEL_SWITCH_ERROR:"levelSwitchError",AUDIO_TRACK_LOAD_ERROR:"audioTrackLoadError",AUDIO_TRACK_LOAD_TIMEOUT:"audioTrackLoadTimeOut",FRAG_LOAD_ERROR:"fragLoadError",FRAG_LOOP_LOADING_ERROR:"fragLoopLoadingError",FRAG_LOAD_TIMEOUT:"fragLoadTimeOut",FRAG_DECRYPT_ERROR:"fragDecryptError",FRAG_PARSING_ERROR:"fragParsingError",REMUX_ALLOC_ERROR:"remuxAllocError",KEY_LOAD_ERROR:"keyLoadError",KEY_LOAD_TIMEOUT:"keyLoadTimeOut",BUFFER_ADD_CODEC_ERROR:"bufferAddCodecError",BUFFER_APPEND_ERROR:"bufferAppendError",BUFFER_APPENDING_ERROR:"bufferAppendingError",BUFFER_STALLED_ERROR:"bufferStalledError",BUFFER_FULL_ERROR:"bufferFullError",BUFFER_SEEK_OVER_HOLE:"bufferSeekOverHole",BUFFER_NUDGE_ON_STALL:"bufferNudgeOnStall",INTERNAL_EXCEPTION:"internalException"}},function(e,t,r){function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}r.d(t,"b",function(){return o});var i=function(){function e(){n(this,e)}return e.isHeader=function(e,t){return t+10<=e.length&&73===e[t]&&68===e[t+1]&&51===e[t+2]&&e[t+3]<255&&e[t+4]<255&&e[t+6]<128&&e[t+7]<128&&e[t+8]<128&&e[t+9]<128},e.isFooter=function(e,t){return t+10<=e.length&&51===e[t]&&68===e[t+1]&&73===e[t+2]&&e[t+3]<255&&e[t+4]<255&&e[t+6]<128&&e[t+7]<128&&e[t+8]<128&&e[t+9]<128},e.getID3Data=function(t,r){for(var n=r,i=0;e.isHeader(t,r);){i+=10;i+=e._readSize(t,r+6),e.isFooter(t,r+10)&&(i+=10),r+=i}return i>0?t.subarray(n,n+i):undefined},e._readSize=function(e,t){var r=0;return r=(127&e[t])<<21,r|=(127&e[t+1])<<14,r|=(127&e[t+2])<<7,r|=127&e[t+3]},e.getTimeStamp=function(t){for(var r=e.getID3Frames(t),n=0;n<r.length;n++){var i=r[n];if(e.isTimeStampFrame(i))return e._readTimeStamp(i)}return undefined},e.isTimeStampFrame=function(e){return e&&"PRIV"===e.key&&"com.apple.streaming.transportStreamTimestamp"===e.info},e._getFrameData=function(t){var r=String.fromCharCode(t[0],t[1],t[2],t[3]),n=e._readSize(t,4);return{type:r,size:n,data:t.subarray(10,10+n)}},e.getID3Frames=function(t){for(var r=0,n=[];e.isHeader(t,r);){var i=e._readSize(t,r+6);r+=10;for(var o=r+i;r+8<o;){var a=e._getFrameData(t.subarray(r)),s=e._decodeFrame(a);s&&n.push(s),r+=a.size+10}e.isFooter(t,r)&&(r+=10)}return n},e._decodeFrame=function(t){return"PRIV"===t.type?e._decodePrivFrame(t):"T"===t.type[0]?e._decodeTextFrame(t):"W"===t.type[0]?e._decodeURLFrame(t):undefined},e._readTimeStamp=function(e){if(8===e.data.byteLength){var t=new Uint8Array(e.data),r=1&t[3],n=(t[4]<<23)+(t[5]<<15)+(t[6]<<7)+t[7];return n/=45,r&&(n+=47721858.84),Math.round(n)}return undefined},e._decodePrivFrame=function(t){if(t.size<2)return undefined;var r=e._utf8ArrayToStr(t.data),n=new Uint8Array(t.data.subarray(r.length+1));return{key:t.type,info:r,data:n.buffer}},e._decodeTextFrame=function(t){if(t.size<2)return undefined;if("TXXX"===t.type){var r=1,n=e._utf8ArrayToStr(t.data.subarray(r));r+=n.length+1;var i=e._utf8ArrayToStr(t.data.subarray(r));return{key:t.type,info:n,data:i}}var o=e._utf8ArrayToStr(t.data.subarray(1));return{key:t.type,data:o}},e._decodeURLFrame=function(t){if("WXXX"===t.type){if(t.size<2)return undefined;var r=1,n=e._utf8ArrayToStr(t.data.subarray(r));r+=n.length+1;var i=e._utf8ArrayToStr(t.data.subarray(r));return{key:t.type,info:n,data:i}}var o=e._utf8ArrayToStr(t.data);return{key:t.type,data:o}},e._utf8ArrayToStr=function(e){for(var t=e.length,r=void 0,n=void 0,i=void 0,o="",a=0;a<t;)if(0!==(r=e[a++])&&3!==r)switch(r>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:o+=String.fromCharCode(r);break;case 12:case 13:n=e[a++],o+=String.fromCharCode((31&r)<<6|63&n);break;case 14:n=e[a++],i=e[a++],o+=String.fromCharCode((15&r)<<12|(63&n)<<6|(63&i)<<0)}return o},e}(),o=i._utf8ArrayToStr;t.a=i},function(e,t,r){function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var s=function(){function e(t,r){n(this,e),this.subtle=t,this.aesIV=r}return e.prototype.decrypt=function(e,t){return this.subtle.decrypt({name:"AES-CBC",iv:this.aesIV},t,e)},e}(),u=s,c=function(){function e(t,r){i(this,e),this.subtle=t,this.key=r}return e.prototype.expandKey=function(){return this.subtle.importKey("raw",this.key,{name:"AES-CBC"},!1,["encrypt","decrypt"])},e}(),l=c,f=function(){function e(){o(this,e),this.rcon=[0,1,2,4,8,16,32,64,128,27,54],this.subMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)],this.invSubMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)],this.sBox=new Uint32Array(256),this.invSBox=new Uint32Array(256),this.key=new Uint32Array(0),this.initTable()}return e.prototype.uint8ArrayToUint32Array_=function(e){for(var t=new DataView(e),r=new Uint32Array(4),n=0;n<4;n++)r[n]=t.getUint32(4*n);return r},e.prototype.initTable=function(){var e=this.sBox,t=this.invSBox,r=this.subMix,n=r[0],i=r[1],o=r[2],a=r[3],s=this.invSubMix,u=s[0],c=s[1],l=s[2],f=s[3],d=new Uint32Array(256),h=0,p=0,y=0;for(y=0;y<256;y++)d[y]=y<128?y<<1:y<<1^283;for(y=0;y<256;y++){var g=p^p<<1^p<<2^p<<3^p<<4;g=g>>>8^255&g^99,e[h]=g,t[g]=h;var m=d[h],_=d[m],v=d[_],b=257*d[g]^16843008*g;n[h]=b<<24|b>>>8,i[h]=b<<16|b>>>16,o[h]=b<<8|b>>>24,a[h]=b,b=16843009*v^65537*_^257*m^16843008*h,u[g]=b<<24|b>>>8,c[g]=b<<16|b>>>16,l[g]=b<<8|b>>>24,f[g]=b,h?(h=m^d[d[d[v^m]]],p^=d[d[p]]):h=p=1}},e.prototype.expandKey=function(e){for(var t=this.uint8ArrayToUint32Array_(e),r=!0,n=0;n<t.length&&r;)r=t[n]===this.key[n],n++;if(!r){this.key=t;var i=this.keySize=t.length;if(4!==i&&6!==i&&8!==i)throw new Error("Invalid aes key size="+i);var o=this.ksRows=4*(i+6+1),a=void 0,s=void 0,u=this.keySchedule=new Uint32Array(o),c=this.invKeySchedule=new Uint32Array(o),l=this.sBox,f=this.rcon,d=this.invSubMix,h=d[0],p=d[1],y=d[2],g=d[3],m=void 0,_=void 0;for(a=0;a<o;a++)a<i?m=u[a]=t[a]:(_=m,a%i==0?(_=_<<8|_>>>24,_=l[_>>>24]<<24|l[_>>>16&255]<<16|l[_>>>8&255]<<8|l[255&_],_^=f[a/i|0]<<24):i>6&&a%i==4&&(_=l[_>>>24]<<24|l[_>>>16&255]<<16|l[_>>>8&255]<<8|l[255&_]),u[a]=m=(u[a-i]^_)>>>0);for(s=0;s<o;s++)a=o-s,_=3&s?u[a]:u[a-4],c[s]=s<4||a<=4?_:h[l[_>>>24]]^p[l[_>>>16&255]]^y[l[_>>>8&255]]^g[l[255&_]],c[s]=c[s]>>>0}},e.prototype.networkToHostOrderSwap=function(e){return e<<24|(65280&e)<<8|(16711680&e)>>8|e>>>24},e.prototype.decrypt=function(e,t,r){for(var n,i,o=this.keySize+6,a=this.invKeySchedule,s=this.invSBox,u=this.invSubMix,c=u[0],l=u[1],f=u[2],d=u[3],h=this.uint8ArrayToUint32Array_(r),p=h[0],y=h[1],g=h[2],m=h[3],_=new Int32Array(e),v=new Int32Array(_.length),b=void 0,$=void 0,w=void 0,E=void 0,S=void 0,O=void 0,T=void 0,A=void 0,x=void 0,k=void 0,D=void 0,I=void 0,P=this.networkToHostOrderSwap;t<_.length;){for(x=P(_[t]),k=P(_[t+1]),D=P(_[t+2]),I=P(_[t+3]),S=x^a[0],O=I^a[1],T=D^a[2],A=k^a[3],n=4,i=1;i<o;i++)b=c[S>>>24]^l[O>>16&255]^f[T>>8&255]^d[255&A]^a[n],$=c[O>>>24]^l[T>>16&255]^f[A>>8&255]^d[255&S]^a[n+1],w=c[T>>>24]^l[A>>16&255]^f[S>>8&255]^d[255&O]^a[n+2],E=c[A>>>24]^l[S>>16&255]^f[O>>8&255]^d[255&T]^a[n+3],S=b,O=$,T=w,A=E,n+=4;b=s[S>>>24]<<24^s[O>>16&255]<<16^s[T>>8&255]<<8^s[255&A]^a[n],$=s[O>>>24]<<24^s[T>>16&255]<<16^s[A>>8&255]<<8^s[255&S]^a[n+1],w=s[T>>>24]<<24^s[A>>16&255]<<16^s[S>>8&255]<<8^s[255&O]^a[n+2],E=s[A>>>24]<<24^s[S>>16&255]<<16^s[O>>8&255]<<8^s[255&T]^a[n+3],n+=3,v[t]=P(b^p),v[t+1]=P(E^y),v[t+2]=P(w^g),v[t+3]=P($^m),p=x,y=k,g=D,m=I,t+=4}return v.buffer},e.prototype.destroy=function(){this.key=undefined,this.keySize=undefined,this.ksRows=undefined,this.sBox=undefined,this.invSBox=undefined,this.subMix=undefined,this.invSubMix=undefined,this.keySchedule=undefined,this.invKeySchedule=undefined,this.rcon=undefined},e}(),d=f,h=r(2),p=r(0),y=function(){function e(t,r){a(this,e),this.observer=t,this.config=r,this.logEnabled=!0;try{var n=crypto||self.crypto;this.subtle=n.subtle||n.webkitSubtle}catch(e){}this.disableWebCrypto=!this.subtle}return e.prototype.isSync=function(){return this.disableWebCrypto&&this.config.enableSoftwareAES},e.prototype.decrypt=function(e,t,r,n){var i=this;if(this.disableWebCrypto&&this.config.enableSoftwareAES){this.logEnabled&&(p.b.log("JS AES decrypt"),this.logEnabled=!1);var o=this.decryptor;o||(this.decryptor=o=new d),o.expandKey(t),n(o.decrypt(e,0,r))}else{this.logEnabled&&(p.b.log("WebCrypto AES decrypt"),this.logEnabled=!1);var a=this.subtle;this.key!==t&&(this.key=t,this.fastAesKey=new l(a,t)),this.fastAesKey.expandKey().then(function(o){new u(a,r).decrypt(e,o)["catch"](function(o){i.onWebCryptoError(o,e,t,r,n)}).then(function(e){n(e)})})["catch"](function(o){i.onWebCryptoError(o,e,t,r,n)})}},e.prototype.onWebCryptoError=function(e,t,r,n,i){this.config.enableSoftwareAES?(p.b.log("WebCrypto Error, disable WebCrypto API"),this.disableWebCrypto=!0,this.logEnabled=!0,this.decrypt(t,r,n,i)):(p.b.error("decrypting error : "+e.message),this.observer.trigger(Event.ERROR,{type:h.b.MEDIA_ERROR,details:h.a.FRAG_DECRYPT_ERROR,fatal:!0,reason:e.message}))},e.prototype.destroy=function(){var e=this.decryptor;e&&(e.destroy(),this.decryptor=undefined)},e}();t.a=y},function(e,t){function r(){this._events=this._events||{},this._maxListeners=this._maxListeners||undefined}function n(e){return"function"==typeof e}
function i(e){return"number"==typeof e}function o(e){return"object"==typeof e&&null!==e}function a(e){return void 0===e}e.exports=r,r.EventEmitter=r,r.prototype._events=undefined,r.prototype._maxListeners=undefined,r.defaultMaxListeners=10,r.prototype.setMaxListeners=function(e){if(!i(e)||e<0||isNaN(e))throw TypeError("n must be a positive number");return this._maxListeners=e,this},r.prototype.emit=function(e){var t,r,i,s,u,c;if(this._events||(this._events={}),"error"===e&&(!this._events.error||o(this._events.error)&&!this._events.error.length)){if((t=arguments[1])instanceof Error)throw t;var l=new Error('Uncaught, unspecified "error" event. ('+t+")");throw l.context=t,l}if(r=this._events[e],a(r))return!1;if(n(r))switch(arguments.length){case 1:r.call(this);break;case 2:r.call(this,arguments[1]);break;case 3:r.call(this,arguments[1],arguments[2]);break;default:s=Array.prototype.slice.call(arguments,1),r.apply(this,s)}else if(o(r))for(s=Array.prototype.slice.call(arguments,1),c=r.slice(),i=c.length,u=0;u<i;u++)c[u].apply(this,s);return!0},r.prototype.addListener=function(e,t){var i;if(!n(t))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",e,n(t.listener)?t.listener:t),this._events[e]?o(this._events[e])?this._events[e].push(t):this._events[e]=[this._events[e],t]:this._events[e]=t,o(this._events[e])&&!this._events[e].warned&&(i=a(this._maxListeners)?r.defaultMaxListeners:this._maxListeners)&&i>0&&this._events[e].length>i&&(this._events[e].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[e].length),"function"==typeof console.trace&&console.trace()),this},r.prototype.on=r.prototype.addListener,r.prototype.once=function(e,t){function r(){this.removeListener(e,r),i||(i=!0,t.apply(this,arguments))}if(!n(t))throw TypeError("listener must be a function");var i=!1;return r.listener=t,this.on(e,r),this},r.prototype.removeListener=function(e,t){var r,i,a,s;if(!n(t))throw TypeError("listener must be a function");if(!this._events||!this._events[e])return this;if(r=this._events[e],a=r.length,i=-1,r===t||n(r.listener)&&r.listener===t)delete this._events[e],this._events.removeListener&&this.emit("removeListener",e,t);else if(o(r)){for(s=a;s-- >0;)if(r[s]===t||r[s].listener&&r[s].listener===t){i=s;break}if(i<0)return this;1===r.length?(r.length=0,delete this._events[e]):r.splice(i,1),this._events.removeListener&&this.emit("removeListener",e,t)}return this},r.prototype.removeAllListeners=function(e){var t,r;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[e]&&delete this._events[e],this;if(0===arguments.length){for(t in this._events)"removeListener"!==t&&this.removeAllListeners(t);return this.removeAllListeners("removeListener"),this._events={},this}if(r=this._events[e],n(r))this.removeListener(e,r);else if(r)for(;r.length;)this.removeListener(e,r[r.length-1]);return delete this._events[e],this},r.prototype.listeners=function(e){return this._events&&this._events[e]?n(this._events[e])?[this._events[e]]:this._events[e].slice():[]},r.prototype.listenerCount=function(e){if(this._events){var t=this._events[e];if(n(t))return 1;if(t)return t.length}return 0},r.listenerCount=function(e,t){return e.listenerCount(t)}},function(e,t,r){!function(t){var r=/^((?:[^\/;?#]+:)?)(\/\/[^\/\;?#]*)?(.*?)??(;.*?)?(\?.*?)?(#.*?)?$/,n=/^([^\/;?#]*)(.*)$/,i=/(?:\/|^)\.(?=\/)/g,o=/(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g,a={buildAbsoluteURL:function(e,t,r){if(r=r||{},e=e.trim(),!(t=t.trim())){if(!r.alwaysNormalize)return e;var i=this.parseURL(e);if(!s)throw new Error("Error trying to parse base URL.");return i.path=a.normalizePath(i.path),a.buildURLFromParts(i)}var o=this.parseURL(t);if(!o)throw new Error("Error trying to parse relative URL.");if(o.scheme)return r.alwaysNormalize?(o.path=a.normalizePath(o.path),a.buildURLFromParts(o)):t;var s=this.parseURL(e);if(!s)throw new Error("Error trying to parse base URL.");if(!s.netLoc&&s.path&&"/"!==s.path[0]){var u=n.exec(s.path);s.netLoc=u[1],s.path=u[2]}s.netLoc&&!s.path&&(s.path="/");var c={scheme:s.scheme,netLoc:o.netLoc,path:null,params:o.params,query:o.query,fragment:o.fragment};if(!o.netLoc&&(c.netLoc=s.netLoc,"/"!==o.path[0]))if(o.path){var l=s.path,f=l.substring(0,l.lastIndexOf("/")+1)+o.path;c.path=a.normalizePath(f)}else c.path=s.path,o.params||(c.params=s.params,o.query||(c.query=s.query));return null===c.path&&(c.path=r.alwaysNormalize?a.normalizePath(o.path):o.path),a.buildURLFromParts(c)},parseURL:function(e){var t=r.exec(e);return t?{scheme:t[1]||"",netLoc:t[2]||"",path:t[3]||"",params:t[4]||"",query:t[5]||"",fragment:t[6]||""}:null},normalizePath:function(e){for(e=e.split("").reverse().join("").replace(i,"");e.length!==(e=e.replace(o,"")).length;);return e.split("").reverse().join("")},buildURLFromParts:function(e){return e.scheme+e.netLoc+e.path+e.params+e.query+e.fragment}};e.exports=a}()},function(e,t,r){function n(e,t,r,n){var i,o,a,s,u,c=navigator.userAgent.toLowerCase(),l=n,f=[96e3,88200,64e3,48e3,44100,32e3,24e3,22050,16e3,12e3,11025,8e3,7350];return i=1+((192&t[r+2])>>>6),(o=(60&t[r+2])>>>2)>f.length-1?void e.trigger(Event.ERROR,{type:O.b.MEDIA_ERROR,details:O.a.FRAG_PARSING_ERROR,fatal:!0,reason:"invalid ADTS sampling index:"+o}):(s=(1&t[r+2])<<2,s|=(192&t[r+3])>>>6,A.b.log("manifest codec:"+n+",ADTS data:type:"+i+",sampleingIndex:"+o+"["+f[o]+"Hz],channelConfig:"+s),/firefox/i.test(c)?o>=6?(i=5,u=new Array(4),a=o-3):(i=2,u=new Array(2),a=o):-1!==c.indexOf("android")?(i=2,u=new Array(2),a=o):(i=5,u=new Array(4),n&&(-1!==n.indexOf("mp4a.40.29")||-1!==n.indexOf("mp4a.40.5"))||!n&&o>=6?a=o-3:((n&&-1!==n.indexOf("mp4a.40.2")&&(o>=6&&1===s||/vivaldi/i.test(c))||!n&&1===s)&&(i=2,u=new Array(2)),a=o)),u[0]=i<<3,u[0]|=(14&o)>>1,u[1]|=(1&o)<<7,u[1]|=s<<3,5===i&&(u[1]|=(14&a)>>1,u[2]=(1&a)<<7,u[2]|=8,u[3]=0),{config:u,samplerate:f[o],channelCount:s,codec:"mp4a.40."+i,manifestCodec:l})}function i(e,t){return 255===e[t]&&240==(246&e[t+1])}function o(e,t){return 1&e[t+1]?7:9}function a(e,t){return(3&e[t+3])<<11|e[t+4]<<3|(224&e[t+5])>>>5}function s(e,t){return!!(t+1<e.length&&i(e,t))}function u(e,t){if(t+1<e.length&&i(e,t)){var r=o(e,t),n=r;t+5<e.length&&(n=a(e,t));var s=t+n;if(s===e.length||s+1<e.length&&i(e,s))return!0}return!1}function c(e,t,r,i,o){if(!e.samplerate){var a=n(t,r,i,o);e.config=a.config,e.samplerate=a.samplerate,e.channelCount=a.channelCount,e.codec=a.codec,e.manifestCodec=a.manifestCodec,A.b.log("parsed codec:"+e.codec+",rate:"+a.samplerate+",nb channel:"+a.channelCount)}}function l(e){return 9216e4/e}function f(e,t,r,n,i){var s,u,c,l=e.length;return s=o(e,t),u=a(e,t),u-=s,u>0&&t+s+u<=l?(c=r+n*i,{headerLength:s,frameLength:u,stamp:c}):undefined}function d(e,t,r,n,i){var o=l(e.samplerate),a=f(t,r,n,i,o);if(a){var s=a.stamp,u=a.headerLength,c=a.frameLength,d={unit:t.subarray(r+u,r+u+c),pts:s,dts:s};return e.samples.push(d),e.len+=c,{sample:d,length:c+u}}return undefined}function h(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function p(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function y(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function g(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function m(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function v(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function b(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function $(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function w(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function E(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var S=r(1),O=r(2),T=r(4),A=r(0),x=r(3),k=function(){function e(t,r,n){h(this,e),this.observer=t,this.config=n,this.remuxer=r}return e.prototype.resetInitSegment=function(e,t,r,n){this._audioTrack={container:"audio/adts",type:"audio",id:0,sequenceNumber:0,isAAC:!0,samples:[],len:0,manifestCodec:t,duration:n,inputTimeScale:9e4}},e.prototype.resetTimeStamp=function(){},e.probe=function(e){if(!e)return!1;for(var t=x.a.getID3Data(e,0)||[],r=t.length,n=e.length;r<n;r++)if(u(e,r))return A.b.log("ADTS sync word found !"),!0;return!1},e.prototype.append=function(e,t,r,n){for(var i=this._audioTrack,o=x.a.getID3Data(e,0)||[],a=x.a.getTimeStamp(o),u=a?90*a:9e4*t,l=0,f=u,h=e.length,p=o.length,y=[{pts:f,dts:f,data:o}];p<h-1;)if(s(e,p)&&p+5<h){c(i,this.observer,e,p,i.manifestCodec);var g=d(i,e,p,u,l);if(!g){A.b.log("Unable to parse AAC frame");break}p+=g.length,f=g.sample.pts,l++}else x.a.isHeader(e,p)?(o=x.a.getID3Data(e,p),y.push({pts:f,dts:f,data:o}),p+=o.length):p++;this.remuxer.remux(i,{samples:[]},{samples:y,inputTimeScale:9e4},{samples:[]},t,r,n)},e.prototype.destroy=function(){},e}(),D=k,I=Math.pow(2,32)-1,P=function(){function e(t,r){p(this,e),this.observer=t,this.remuxer=r}return e.prototype.resetTimeStamp=function(e){this.initPTS=e},e.prototype.resetInitSegment=function(t,r,n,i){if(t&&t.byteLength){var o=this.initData=e.parseInitSegment(t);null==r&&(r="mp4a.40.5"),null==n&&(n="avc1.42e01e");var a={};o.audio&&o.video?a.audiovideo={container:"video/mp4",codec:r+","+n,initSegment:i?t:null}:(o.audio&&(a.audio={container:"audio/mp4",codec:r,initSegment:i?t:null}),o.video&&(a.video={container:"video/mp4",codec:n,initSegment:i?t:null})),this.observer.trigger(S.a.FRAG_PARSING_INIT_SEGMENT,{tracks:a})}else r&&(this.audioCodec=r),n&&(this.videoCodec=n)},e.probe=function(t){return e.findBox({data:t,start:0,end:Math.min(t.length,16384)},["moof"]).length>0},e.bin2str=function(e){return String.fromCharCode.apply(null,e)},e.readUint32=function(e,t){e.data&&(t+=e.start,e=e.data);var r=e[t]<<24|e[t+1]<<16|e[t+2]<<8|e[t+3];return r<0?4294967296+r:r},e.writeUint32=function(e,t,r){e.data&&(t+=e.start,e=e.data),e[t]=r>>24,e[t+1]=r>>16&255,e[t+2]=r>>8&255,e[t+3]=255&r},e.findBox=function(t,r){var n,i,o,a,s,u,c,l=[];if(t.data?(u=t.start,a=t.end,t=t.data):(u=0,a=t.byteLength),!r.length)return null;for(n=u;n<a;)i=e.readUint32(t,n),o=e.bin2str(t.subarray(n+4,n+8)),c=i>1?n+i:a,o===r[0]&&(1===r.length?l.push({data:t,start:n+8,end:c}):(s=e.findBox({data:t,start:n+8,end:c},r.slice(1)),s.length&&(l=l.concat(s)))),n=c;return l},e.parseInitSegment=function(t){var r=[];return e.findBox(t,["moov","trak"]).forEach(function(t){var n=e.findBox(t,["tkhd"])[0];if(n){var i=n.data[n.start],o=0===i?12:20,a=e.readUint32(n,o),s=e.findBox(t,["mdia","mdhd"])[0];if(s){i=s.data[s.start],o=0===i?12:20;var u=e.readUint32(s,o),c=e.findBox(t,["mdia","hdlr"])[0];if(c){var l=e.bin2str(c.data.subarray(c.start+8,c.start+12)),f={soun:"audio",vide:"video"}[l];if(f){var d=e.findBox(t,["mdia","minf","stbl","stsd"]);if(d.length){d=d[0];var h=e.bin2str(d.data.subarray(d.start+12,d.start+16));A.b.log("MP4Demuxer:"+f+":"+h+" found")}r[a]={timescale:u,type:f},r[f]={timescale:u,id:a}}}}}}),r},e.getStartDTS=function(t,r){var n,i,o;return n=e.findBox(r,["moof","traf"]),i=[].concat.apply([],n.map(function(r){return e.findBox(r,["tfhd"]).map(function(n){var i,o;return i=e.readUint32(n,4),o=t[i].timescale||9e4,e.findBox(r,["tfdt"]).map(function(t){var r,n;return r=t.data[t.start],n=e.readUint32(t,4),1===r&&(n*=Math.pow(2,32),n+=e.readUint32(t,8)),n})[0]/o})})),o=Math.min.apply(null,i),isFinite(o)?o:0},e.offsetStartDTS=function(t,r,n){e.findBox(r,["moof","traf"]).map(function(r){return e.findBox(r,["tfhd"]).map(function(i){var o=e.readUint32(i,4),a=t[o].timescale||9e4;e.findBox(r,["tfdt"]).map(function(t){var r=t.data[t.start],i=e.readUint32(t,4);if(0===r)e.writeUint32(t,4,i-n*a);else{i*=Math.pow(2,32),i+=e.readUint32(t,8),i-=n*a,i=Math.max(i,0);var o=Math.floor(i/(I+1)),s=Math.floor(i%(I+1));e.writeUint32(t,4,o),e.writeUint32(t,8,s)}})})})},e.prototype.append=function(t,r,n,i){var o=this.initData;o||(this.resetInitSegment(t,this.audioCodec,this.videoCodec),o=this.initData);var a=void 0,s=this.initPTS;if(s===undefined){var u=e.getStartDTS(o,t);this.initPTS=s=u-r,this.observer.trigger(S.a.INIT_PTS_FOUND,{initPTS:s})}e.offsetStartDTS(o,t,s),a=e.getStartDTS(o,t),this.remuxer.remux(o.audio,o.video,null,null,a,n,i,t)},e.prototype.destroy=function(){},e}(),M=P,R={BitratesMap:[32,64,96,128,160,192,224,256,288,320,352,384,416,448,32,48,56,64,80,96,112,128,160,192,224,256,320,384,32,40,48,56,64,80,96,112,128,160,192,224,256,320,32,48,56,64,80,96,112,128,144,160,176,192,224,256,8,16,24,32,40,48,56,64,80,96,112,128,144,160],SamplingRateMap:[44100,48e3,32e3,22050,24e3,16e3,11025,12e3,8e3],appendFrame:function(e,t,r,n,i){if(r+24>t.length)return undefined;var o=this.parseHeader(t,r);if(o&&r+o.frameLength<=t.length){var a=10368e4/o.sampleRate,s=n+i*a,u={unit:t.subarray(r,r+o.frameLength),pts:s,dts:s};return e.config=[],e.channelCount=o.channelCount,e.samplerate=o.sampleRate,e.samples.push(u),e.len+=o.frameLength,{sample:u,length:o.frameLength}}return undefined},parseHeader:function(e,t){var r=e[t+1]>>3&3,n=e[t+1]>>1&3,i=e[t+2]>>4&15,o=e[t+2]>>2&3,a=!!(2&e[t+2]);if(1!==r&&0!==i&&15!==i&&3!==o){var s=3===r?3-n:3===n?3:4,u=1e3*R.BitratesMap[14*s+i-1],c=3===r?0:2===r?1:2,l=R.SamplingRateMap[3*c+o],f=a?1:0;return{sampleRate:l,channelCount:e[t+3]>>6==3?1:2,frameLength:3===n?(3===r?12:6)*u/l+f<<2:(3===r?144:72)*u/l+f|0}}return undefined},isHeaderPattern:function(e,t){return 255===e[t]&&224==(224&e[t+1])&&0!=(6&e[t+1])},isHeader:function(e,t){return!!(t+1<e.length&&this.isHeaderPattern(e,t))},probe:function(e,t){if(t+1<e.length&&this.isHeaderPattern(e,t)){var r=this.parseHeader(e,t),n=4;r&&r.frameLength&&(n=r.frameLength);var i=t+n;if(i===e.length||i+1<e.length&&this.isHeaderPattern(e,i))return!0}return!1}},C=R,j=function(){function e(t){y(this,e),this.data=t,this.bytesAvailable=t.byteLength,this.word=0,this.bitsAvailable=0}return e.prototype.loadWord=function(){var e=this.data,t=this.bytesAvailable,r=e.byteLength-t,n=new Uint8Array(4),i=Math.min(4,t);if(0===i)throw new Error("no bytes available");n.set(e.subarray(r,r+i)),this.word=new DataView(n.buffer).getUint32(0),this.bitsAvailable=8*i,this.bytesAvailable-=i},e.prototype.skipBits=function(e){var t;this.bitsAvailable>e?(this.word<<=e,this.bitsAvailable-=e):(e-=this.bitsAvailable,t=e>>3,e-=t>>3,this.bytesAvailable-=t,this.loadWord(),this.word<<=e,this.bitsAvailable-=e)},e.prototype.readBits=function(e){var t=Math.min(this.bitsAvailable,e),r=this.word>>>32-t;return e>32&&A.b.error("Cannot read more than 32 bits at a time"),this.bitsAvailable-=t,this.bitsAvailable>0?this.word<<=t:this.bytesAvailable>0&&this.loadWord(),t=e-t,t>0&&this.bitsAvailable?r<<t|this.readBits(t):r},e.prototype.skipLZ=function(){var e;for(e=0;e<this.bitsAvailable;++e)if(0!=(this.word&2147483648>>>e))return this.word<<=e,this.bitsAvailable-=e,e;return this.loadWord(),e+this.skipLZ()},e.prototype.skipUEG=function(){this.skipBits(1+this.skipLZ())},e.prototype.skipEG=function(){this.skipBits(1+this.skipLZ())},e.prototype.readUEG=function(){var e=this.skipLZ();return this.readBits(e+1)-1},e.prototype.readEG=function(){var e=this.readUEG();return 1&e?1+e>>>1:-1*(e>>>1)},e.prototype.readBoolean=function(){return 1===this.readBits(1)},e.prototype.readUByte=function(){return this.readBits(8)},e.prototype.readUShort=function(){return this.readBits(16)},e.prototype.readUInt=function(){return this.readBits(32)},e.prototype.skipScalingList=function(e){var t,r,n=8,i=8;for(t=0;t<e;t++)0!==i&&(r=this.readEG(),i=(n+r+256)%256),n=0===i?n:i},e.prototype.readSPS=function(){var e,t,r,n,i,o,a,s=0,u=0,c=0,l=0,f=this.readUByte.bind(this),d=this.readBits.bind(this),h=this.readUEG.bind(this),p=this.readBoolean.bind(this),y=this.skipBits.bind(this),g=this.skipEG.bind(this),m=this.skipUEG.bind(this),_=this.skipScalingList.bind(this);if(f(),e=f(),d(5),y(3),f(),m(),100===e||110===e||122===e||244===e||44===e||83===e||86===e||118===e||128===e){var v=h();if(3===v&&y(1),m(),m(),y(1),p())for(o=3!==v?8:12,a=0;a<o;a++)p()&&_(a<6?16:64)}m();var b=h();if(0===b)h();else if(1===b)for(y(1),g(),g(),t=h(),a=0;a<t;a++)g();m(),y(1),r=h(),n=h(),i=d(1),0===i&&y(1),y(1),p()&&(s=h(),u=h(),c=h(),l=h());var $=[1,1];if(p()&&p()){switch(f()){case 1:$=[1,1];break;case 2:$=[12,11];break;case 3:$=[10,11];break;case 4:$=[16,11];break;case 5:$=[40,33];break;case 6:$=[24,11];break;case 7:$=[20,11];break;case 8:$=[32,11];break;case 9:$=[80,33];break;case 10:$=[18,11];break;case 11:$=[15,11];break;case 12:$=[64,33];break;case 13:$=[160,99];break;case 14:$=[4,3];break;case 15:$=[3,2];break;case 16:$=[2,1];break;case 255:$=[f()<<8|f(),f()<<8|f()]}}return{width:Math.ceil(16*(r+1)-2*s-2*u),height:(2-i)*(n+1)*16-(i?2:4)*(c+l),pixelRatio:$}},e.prototype.readSliceType=function(){return this.readUByte(),this.readUEG(),this.readUEG()},e}(),L=j,N=function(){function e(t,r,n,i){g(this,e),this.decryptdata=n,this.discardEPB=i,this.decrypter=new T.a(t,r)}return e.prototype.decryptBuffer=function(e,t){this.decrypter.decrypt(e,this.decryptdata.key.buffer,this.decryptdata.iv.buffer,t)},e.prototype.decryptAacSample=function(e,t,r,n){var i=e[t].unit,o=i.subarray(16,i.length-i.length%16),a=o.buffer.slice(o.byteOffset,o.byteOffset+o.length),s=this;this.decryptBuffer(a,function(o){o=new Uint8Array(o),i.set(o,16),n||s.decryptAacSamples(e,t+1,r)})},e.prototype.decryptAacSamples=function(e,t,r){for(;;t++){if(t>=e.length)return void r();if(!(e[t].unit.length<32)){var n=this.decrypter.isSync();if(this.decryptAacSample(e,t,r,n),!n)return}}},e.prototype.getAvcEncryptedData=function(e){for(var t=16*Math.floor((e.length-48)/160)+16,r=new Int8Array(t),n=0,i=32;i<=e.length-16;i+=160,n+=16)r.set(e.subarray(i,i+16),n);return r},e.prototype.getAvcDecryptedUnit=function(e,t){t=new Uint8Array(t);for(var r=0,n=32;n<=e.length-16;n+=160,r+=16)e.set(t.subarray(r,r+16),n);return e},e.prototype.decryptAvcSample=function(e,t,r,n,i,o){var a=this.discardEPB(i.data),s=this.getAvcEncryptedData(a),u=this;this.decryptBuffer(s.buffer,function(s){i.data=u.getAvcDecryptedUnit(a,s),o||u.decryptAvcSamples(e,t,r+1,n)})},e.prototype.decryptAvcSamples=function(e,t,r,n){for(;;t++,r=0){if(t>=e.length)return void n();for(var i=e[t].units;!(r>=i.length);r++){var o=i[r];if(!(o.length<=48||1!==o.type&&5!==o.type)){var a=this.decrypter.isSync();if(this.decryptAvcSample(e,t,r,n,o,a),!a)return}}}},e}(),F=N,B={video:0,audio:1,id3:2,text:3},U=function(){function e(t,r,n,i){m(this,e),this.observer=t,this.config=n,this.typeSupported=i,this.remuxer=r,this.sampleAes=null}return e.prototype.setDecryptData=function(e){null!=e&&null!=e.key&&"SAMPLE-AES"===e.method?this.sampleAes=new F(this.observer,this.config,e,this.discardEPB):this.sampleAes=null},e.probe=function(t){var r=e._syncOffset(t);return!(r<0)&&(r&&A.b.warn("MPEG2-TS detected but first sync word found @ offset "+r+", junk ahead ?"),!0)},e._syncOffset=function(e){for(var t=Math.min(1e3,e.length-564),r=0;r<t;){if(71===e[r]&&71===e[r+188]&&71===e[r+376])return r;r++}return-1},e.createTrack=function(e,t){return{container:"video"===e||"audio"===e?"video/mp2t":undefined,type:e,id:B[e],pid:-1,inputTimeScale:9e4,sequenceNumber:0,samples:[],len:0,dropped:"video"===e?0:undefined,isAAC:"audio"===e||undefined,duration:"audio"===e?t:undefined}},e.prototype.resetInitSegment=function(t,r,n,i){this.pmtParsed=!1,this._pmtId=-1,this._avcTrack=e.createTrack("video",i),this._audioTrack=e.createTrack("audio",i),this._id3Track=e.createTrack("id3",i),this._txtTrack=e.createTrack("text",i),this.aacOverFlow=null,this.aacLastPTS=null,this.avcSample=null,this.audioCodec=r,this.videoCodec=n,this._duration=i},e.prototype.resetTimeStamp=function(){},e.prototype.append=function(t,r,n,i){var o,a,s,u,c,l=t.length,f=!1;this.contiguous=n;var d=this.pmtParsed,h=this._avcTrack,p=this._audioTrack,y=this._id3Track,g=h.pid,m=p.pid,_=y.pid,v=this._pmtId,b=h.pesData,$=p.pesData,w=y.pesData,E=this._parsePAT,T=this._parsePMT,x=this._parsePES,k=this._parseAVCPES.bind(this),D=this._parseAACPES.bind(this),I=this._parseMPEGPES.bind(this),P=this._parseID3PES.bind(this),M=e._syncOffset(t);for(l-=(l+M)%188,o=M;o<l;o+=188)if(71===t[o]){if(a=!!(64&t[o+1]),s=((31&t[o+1])<<8)+t[o+2],(48&t[o+3])>>4>1){if((u=o+5+t[o+4])===o+188)continue}else u=o+4;switch(s){case g:a&&(b&&(c=x(b))&&k(c,!1),b={data:[],size:0}),b&&(b.data.push(t.subarray(u,o+188)),b.size+=o+188-u);break;case m:a&&($&&(c=x($))&&(p.isAAC?D(c):I(c)),$={data:[],size:0}),$&&($.data.push(t.subarray(u,o+188)),$.size+=o+188-u);break;case _:a&&(w&&(c=x(w))&&P(c),w={data:[],size:0}),w&&(w.data.push(t.subarray(u,o+188)),w.size+=o+188-u);break;case 0:a&&(u+=t[u]+1),v=this._pmtId=E(t,u);break;case v:a&&(u+=t[u]+1);var R=T(t,u,!0===this.typeSupported.mpeg||!0===this.typeSupported.mp3,null!=this.sampleAes);g=R.avc,g>0&&(h.pid=g),m=R.audio,m>0&&(p.pid=m,p.isAAC=R.isAAC),_=R.id3,_>0&&(y.pid=_),f&&!d&&(A.b.log("reparse from beginning"),f=!1,o=M-188),d=this.pmtParsed=!0;break;case 17:case 8191:break;default:f=!0}}else this.observer.trigger(S.a.ERROR,{type:O.b.MEDIA_ERROR,details:O.a.FRAG_PARSING_ERROR,fatal:!1,reason:"TS packet did not start with 0x47"});b&&(c=x(b))?(k(c,!0),h.pesData=null):h.pesData=b,$&&(c=x($))?(p.isAAC?D(c):I(c),p.pesData=null):($&&$.size&&A.b.log("last AAC PES packet truncated,might overlap between fragments"),p.pesData=$),w&&(c=x(w))?(P(c),y.pesData=null):y.pesData=w,null==this.sampleAes?this.remuxer.remux(p,h,y,this._txtTrack,r,n,i):this.decryptAndRemux(p,h,y,this._txtTrack,r,n,i)},e.prototype.decryptAndRemux=function(e,t,r,n,i,o,a){if(e.samples&&e.isAAC){var s=this;this.sampleAes.decryptAacSamples(e.samples,0,function(){s.decryptAndRemuxAvc(e,t,r,n,i,o,a)})}else this.decryptAndRemuxAvc(e,t,r,n,i,o,a)},e.prototype.decryptAndRemuxAvc=function(e,t,r,n,i,o,a){if(t.samples){var s=this;this.sampleAes.decryptAvcSamples(t.samples,0,0,function(){s.remuxer.remux(e,t,r,n,i,o,a)})}else this.remuxer.remux(e,t,r,n,i,o,a)},e.prototype.destroy=function(){this._initPTS=this._initDTS=undefined,this._duration=0},e.prototype._parsePAT=function(e,t){return(31&e[t+10])<<8|e[t+11]},e.prototype._parsePMT=function(e,t,r,n){var i,o,a,s,u={audio:-1,avc:-1,id3:-1,isAAC:!0};for(i=(15&e[t+1])<<8|e[t+2],o=t+3+i-4,a=(15&e[t+10])<<8|e[t+11],t+=12+a;t<o;){switch(s=(31&e[t+1])<<8|e[t+2],e[t]){case 207:if(!n){A.b.log("unkown stream type:"+e[t]);break}case 15:-1===u.audio&&(u.audio=s);break;case 21:-1===u.id3&&(u.id3=s);break;case 219:if(!n){A.b.log("unkown stream type:"+e[t]);break}case 27:-1===u.avc&&(u.avc=s);break;case 3:case 4:r?-1===u.audio&&(u.audio=s,u.isAAC=!1):A.b.log("MPEG audio found, not supported in this browser for now");break;case 36:A.b.warn("HEVC stream type found, not supported for now");break;default:A.b.log("unkown stream type:"+e[t])}t+=5+((15&e[t+3])<<8|e[t+4])}return u},e.prototype._parsePES=function(e){var t,r,n,i,o,a,s,u,c=0,l=e.data;if(!e||0===e.size)return null;for(;l[0].length<19&&l.length>1;){var f=new Uint8Array(l[0].length+l[1].length);f.set(l[0]),f.set(l[1],l[0].length),l[0]=f,l.splice(1,1)}if(t=l[0],1===(t[0]<<16)+(t[1]<<8)+t[2]){if((n=(t[4]<<8)+t[5])&&n>e.size-6)return null;r=t[7],192&r&&(a=536870912*(14&t[9])+4194304*(255&t[10])+16384*(254&t[11])+128*(255&t[12])+(254&t[13])/2,a>4294967295&&(a-=8589934592),64&r?(s=536870912*(14&t[14])+4194304*(255&t[15])+16384*(254&t[16])+128*(255&t[17])+(254&t[18])/2,s>4294967295&&(s-=8589934592),a-s>54e5&&(A.b.warn(Math.round((a-s)/9e4)+"s delta between PTS and DTS, align them"),a=s)):s=a),i=t[8],u=i+9,e.size-=u,o=new Uint8Array(e.size);for(var d=0,h=l.length;d<h;d++){t=l[d];var p=t.byteLength;if(u){if(u>p){u-=p;continue}t=t.subarray(u),p-=u,u=0}o.set(t,c),c+=p}return n&&(n-=i+3),{data:o,pts:a,dts:s,len:n}}return null},e.prototype.pushAccesUnit=function(e,t){if(e.units.length&&e.frame){var r=t.samples,n=r.length;!this.config.forceKeyFrameOnDiscontinuity||!0===e.key||t.sps&&(n||this.contiguous)?(e.id=n,r.push(e)):t.dropped++}e.debug.length&&A.b.log(e.pts+"/"+e.dts+":"+e.debug)},e.prototype._parseAVCPES=function(e,t){var r,n,i,o=this,a=this._avcTrack,s=this._parseAVCNALu(e.data),u=this.avcSample,c=!1,l=this.pushAccesUnit.bind(this),f=function(e,t,r,n){return{key:e,pts:t,dts:r,units:[],debug:n}};e.data=null,u&&s.length&&!a.audFound&&(l(u,a),u=this.avcSample=f(!1,e.pts,e.dts,"")),s.forEach(function(t){switch(t.type){case 1:n=!0,u||(u=o.avcSample=f(!0,e.pts,e.dts,"")),u.frame=!0;var s=t.data;if(c&&s.length>4){var d=new L(s).readSliceType();2!==d&&4!==d&&7!==d&&9!==d||(u.key=!0)}break;case 5:n=!0,u||(u=o.avcSample=f(!0,e.pts,e.dts,"")),u.key=!0,u.frame=!0;break;case 6:n=!0,r=new L(o.discardEPB(t.data)),r.readUByte();for(var h=0,p=0,y=!1,g=0;!y&&r.bytesAvailable>1;){h=0;do{g=r.readUByte(),h+=g}while(255===g);p=0;do{g=r.readUByte(),p+=g}while(255===g);if(4===h&&0!==r.bytesAvailable){y=!0;if(181===r.readUByte()){if(49===r.readUShort()){if(1195456820===r.readUInt()){if(3===r.readUByte()){var m=r.readUByte(),_=r.readUByte(),v=31&m,b=[m,_];for(i=0;i<v;i++)b.push(r.readUByte()),b.push(r.readUByte()),b.push(r.readUByte());o._insertSampleInOrder(o._txtTrack.samples,{type:3,pts:e.pts,bytes:b})}}}}}else if(p<r.bytesAvailable)for(i=0;i<p;i++)r.readUByte()}break;case 7:if(n=!0,c=!0,!a.sps){r=new L(t.data);var $=r.readSPS();a.width=$.width,a.height=$.height,a.pixelRatio=$.pixelRatio,a.sps=[t.data],a.duration=o._duration;var w=t.data.subarray(1,4),E="avc1.";for(i=0;i<3;i++){var S=w[i].toString(16);S.length<2&&(S="0"+S),E+=S}a.codec=E}break;case 8:n=!0,a.pps||(a.pps=[t.data]);break;case 9:n=!1,a.audFound=!0,u&&l(u,a),u=o.avcSample=f(!1,e.pts,e.dts,"");break;case 12:n=!1;break;default:n=!1,u&&(u.debug+="unknown NAL "+t.type+" ")}if(u&&n){u.units.push(t)}}),t&&u&&(l(u,a),this.avcSample=null)},e.prototype._insertSampleInOrder=function(e,t){var r=e.length;if(r>0){if(t.pts>=e[r-1].pts)e.push(t);else for(var n=r-1;n>=0;n--)if(t.pts<e[n].pts){e.splice(n,0,t);break}}else e.push(t)},e.prototype._getLastNalUnit=function(){var e=this.avcSample,t=void 0;if(!e||0===e.units.length){var r=this._avcTrack,n=r.samples;e=n[n.length-1]}if(e){var i=e.units;t=i[i.length-1]}return t},e.prototype._parseAVCNALu=function(e){var t,r,n,i,o,a=0,s=e.byteLength,u=this._avcTrack,c=u.naluState||0,l=c,f=[],d=-1;for(-1===c&&(d=0,o=31&e[0],c=0,a=1);a<s;)if(t=e[a++],c)if(1!==c)if(t)if(1===t){if(d>=0)n={data:e.subarray(d,a-c-1),type:o},f.push(n);else{var h=this._getLastNalUnit();if(h&&(l&&a<=4-l&&h.state&&(h.data=h.data.subarray(0,h.data.byteLength-l)),(r=a-c-1)>0)){var p=new Uint8Array(h.data.byteLength+r);p.set(h.data,0),p.set(e.subarray(0,r),h.data.byteLength),h.data=p}}a<s?(i=31&e[a],d=a,o=i,c=0):c=-1}else c=0;else c=3;else c=t?0:2;else c=t?0:1;if(d>=0&&c>=0&&(n={data:e.subarray(d,s),type:o,state:c},f.push(n)),0===f.length){var y=this._getLastNalUnit();if(y){var g=new Uint8Array(y.data.byteLength+e.byteLength);g.set(y.data,0),g.set(e,y.data.byteLength),y.data=g}}return u.naluState=c,f},e.prototype.discardEPB=function(e){for(var t,r,n=e.byteLength,i=[],o=1;o<n-2;)0===e[o]&&0===e[o+1]&&3===e[o+2]?(i.push(o+2),o+=2):o++;if(0===i.length)return e;t=n-i.length,r=new Uint8Array(t);var a=0;for(o=0;o<t;a++,o++)a===i[0]&&(a++,i.shift()),r[o]=e[a];return r},e.prototype._parseAACPES=function(e){var t,r,n,i,o,a=this._audioTrack,u=e.data,f=e.pts,h=this.aacOverFlow,p=this.aacLastPTS;if(h){var y=new Uint8Array(h.byteLength+u.byteLength);y.set(h,0),y.set(u,h.byteLength),u=y}for(n=0,o=u.length;n<o-1&&!s(u,n);n++);if(n){var g,m;if(n<o-1?(g="AAC PES did not start with ADTS header,offset:"+n,m=!1):(g="no ADTS header found in AAC PES",m=!0),A.b.warn("parsing error:"+g),this.observer.trigger(S.a.ERROR,{type:O.b.MEDIA_ERROR,details:O.a.FRAG_PARSING_ERROR,fatal:m,reason:g}),m)return}if(c(a,this.observer,u,n,this.audioCodec),r=0,t=l(a.samplerate),h&&p){var _=p+t;Math.abs(_-f)>1&&(A.b.log("AAC: align PTS for overlapping frames by "+Math.round((_-f)/90)),f=_)}for(;n<o;)if(s(u,n)&&n+5<o){var v=d(a,u,n,f,r);if(!v)break;n+=v.length,i=v.sample.pts,r++}else n++;h=n<o?u.subarray(n,o):null,this.aacOverFlow=h,this.aacLastPTS=i},e.prototype._parseMPEGPES=function(e){for(var t=e.data,r=t.length,n=0,i=0,o=e.pts;i<r;)if(C.isHeader(t,i)){var a=C.appendFrame(this._audioTrack,t,i,o,n);if(!a)break;i+=a.length,n++}else i++},e.prototype._parseID3PES=function(e){this._id3Track.samples.push(e)},e}(),z=U,G=function(){function e(t,r,n){_(this,e),this.observer=t,this.config=n,this.remuxer=r}return e.prototype.resetInitSegment=function(e,t,r,n){this._audioTrack={container:"audio/mpeg",type:"audio",id:-1,sequenceNumber:0,isAAC:!1,samples:[],len:0,manifestCodec:t,duration:n,inputTimeScale:9e4}},e.prototype.resetTimeStamp=function(){},e.probe=function(e){var t,r,n=x.a.getID3Data(e,0);if(n&&x.a.getTimeStamp(n)!==undefined)for(t=n.length,r=Math.min(e.length-1,t+100);t<r;t++)if(C.probe(e,t))return A.b.log("MPEG Audio sync word found !"),!0;return!1},e.prototype.append=function(e,t,r,n){for(var i=x.a.getID3Data(e,0),o=90*x.a.getTimeStamp(i),a=i.length,s=e.length,u=0,c=0,l=this._audioTrack,f=[{pts:o,dts:o,data:i}];a<s;)if(C.isHeader(e,a)){var d=C.appendFrame(l,e,a,o,u);if(!d)break;a+=d.length,c=d.sample.pts,u++}else x.a.isHeader(e,a)?(i=x.a.getID3Data(e,a),f.push({pts:c,dts:c,data:i}),a+=i.length):a++;this.remuxer.remux(l,{samples:[]},{samples:f,inputTimeScale:9e4},{samples:[]},t,r,n)},e.prototype.destroy=function(){},e}(),W=G,H=function(){function e(){v(this,e)}return e.getSilentFrame=function(e,t){switch(e){case"mp4a.40.2":if(1===t)return new Uint8Array([0,200,0,128,35,128]);if(2===t)return new Uint8Array([33,0,73,144,2,25,0,35,128]);if(3===t)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,142]);if(4===t)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,128,44,128,8,2,56]);if(5===t)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,56]);if(6===t)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,0,178,0,32,8,224]);break;default:if(1===t)return new Uint8Array([1,64,34,128,163,78,230,128,186,8,0,0,0,28,6,241,193,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);if(2===t)return new Uint8Array([1,64,34,128,163,94,230,128,186,8,0,0,0,0,149,0,6,241,161,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);if(3===t)return new Uint8Array([1,64,34,128,163,94,230,128,186,8,0,0,0,0,149,0,6,241,161,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94])}return null},e}(),V=H,Y=Math.pow(2,32)-1,K=function(){function e(){b(this,e)}return e.init=function(){e.types={avc1:[],avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],".mp3":[],mvex:[],mvhd:[],pasp:[],sdtp:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[],smhd:[]};var t;for(t in e.types)e.types.hasOwnProperty(t)&&(e.types[t]=[t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2),t.charCodeAt(3)]);var r=new Uint8Array([0,0,0,0,0,0,0,0,118,105,100,101,0,0,0,0,0,0,0,0,0,0,0,0,86,105,100,101,111,72,97,110,100,108,101,114,0]),n=new Uint8Array([0,0,0,0,0,0,0,0,115,111,117,110,0,0,0,0,0,0,0,0,0,0,0,0,83,111,117,110,100,72,97,110,100,108,101,114,0]);e.HDLR_TYPES={video:r,audio:n};var i=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,12,117,114,108,32,0,0,0,1]),o=new Uint8Array([0,0,0,0,0,0,0,0]);e.STTS=e.STSC=e.STCO=o,e.STSZ=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0]),e.VMHD=new Uint8Array([0,0,0,1,0,0,0,0,0,0,0,0]),e.SMHD=new Uint8Array([0,0,0,0,0,0,0,0]),e.STSD=new Uint8Array([0,0,0,0,0,0,0,1])
;var a=new Uint8Array([105,115,111,109]),s=new Uint8Array([97,118,99,49]),u=new Uint8Array([0,0,0,1]);e.FTYP=e.box(e.types.ftyp,a,u,a,s),e.DINF=e.box(e.types.dinf,e.box(e.types.dref,i))},e.box=function(e){for(var t,r=Array.prototype.slice.call(arguments,1),n=8,i=r.length,o=i;i--;)n+=r[i].byteLength;for(t=new Uint8Array(n),t[0]=n>>24&255,t[1]=n>>16&255,t[2]=n>>8&255,t[3]=255&n,t.set(e,4),i=0,n=8;i<o;i++)t.set(r[i],n),n+=r[i].byteLength;return t},e.hdlr=function(t){return e.box(e.types.hdlr,e.HDLR_TYPES[t])},e.mdat=function(t){return e.box(e.types.mdat,t)},e.mdhd=function(t,r){r*=t;var n=Math.floor(r/(Y+1)),i=Math.floor(r%(Y+1));return e.box(e.types.mdhd,new Uint8Array([1,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,t>>24&255,t>>16&255,t>>8&255,255&t,n>>24,n>>16&255,n>>8&255,255&n,i>>24,i>>16&255,i>>8&255,255&i,85,196,0,0]))},e.mdia=function(t){return e.box(e.types.mdia,e.mdhd(t.timescale,t.duration),e.hdlr(t.type),e.minf(t))},e.mfhd=function(t){return e.box(e.types.mfhd,new Uint8Array([0,0,0,0,t>>24,t>>16&255,t>>8&255,255&t]))},e.minf=function(t){return"audio"===t.type?e.box(e.types.minf,e.box(e.types.smhd,e.SMHD),e.DINF,e.stbl(t)):e.box(e.types.minf,e.box(e.types.vmhd,e.VMHD),e.DINF,e.stbl(t))},e.moof=function(t,r,n){return e.box(e.types.moof,e.mfhd(t),e.traf(n,r))},e.moov=function(t){for(var r=t.length,n=[];r--;)n[r]=e.trak(t[r]);return e.box.apply(null,[e.types.moov,e.mvhd(t[0].timescale,t[0].duration)].concat(n).concat(e.mvex(t)))},e.mvex=function(t){for(var r=t.length,n=[];r--;)n[r]=e.trex(t[r]);return e.box.apply(null,[e.types.mvex].concat(n))},e.mvhd=function(t,r){r*=t;var n=Math.floor(r/(Y+1)),i=Math.floor(r%(Y+1)),o=new Uint8Array([1,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,t>>24&255,t>>16&255,t>>8&255,255&t,n>>24,n>>16&255,n>>8&255,255&n,i>>24,i>>16&255,i>>8&255,255&i,0,1,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255]);return e.box(e.types.mvhd,o)},e.sdtp=function(t){var r,n,i=t.samples||[],o=new Uint8Array(4+i.length);for(n=0;n<i.length;n++)r=i[n].flags,o[n+4]=r.dependsOn<<4|r.isDependedOn<<2|r.hasRedundancy;return e.box(e.types.sdtp,o)},e.stbl=function(t){return e.box(e.types.stbl,e.stsd(t),e.box(e.types.stts,e.STTS),e.box(e.types.stsc,e.STSC),e.box(e.types.stsz,e.STSZ),e.box(e.types.stco,e.STCO))},e.avc1=function(t){var r,n,i,o=[],a=[];for(r=0;r<t.sps.length;r++)n=t.sps[r],i=n.byteLength,o.push(i>>>8&255),o.push(255&i),o=o.concat(Array.prototype.slice.call(n));for(r=0;r<t.pps.length;r++)n=t.pps[r],i=n.byteLength,a.push(i>>>8&255),a.push(255&i),a=a.concat(Array.prototype.slice.call(n));var s=e.box(e.types.avcC,new Uint8Array([1,o[3],o[4],o[5],255,224|t.sps.length].concat(o).concat([t.pps.length]).concat(a))),u=t.width,c=t.height,l=t.pixelRatio[0],f=t.pixelRatio[1];return e.box(e.types.avc1,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,u>>8&255,255&u,c>>8&255,255&c,0,72,0,0,0,72,0,0,0,0,0,0,0,1,18,100,97,105,108,121,109,111,116,105,111,110,47,104,108,115,46,106,115,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,17,17]),s,e.box(e.types.btrt,new Uint8Array([0,28,156,128,0,45,198,192,0,45,198,192])),e.box(e.types.pasp,new Uint8Array([l>>24,l>>16&255,l>>8&255,255&l,f>>24,f>>16&255,f>>8&255,255&f])))},e.esds=function(e){var t=e.config.length;return new Uint8Array([0,0,0,0,3,23+t,0,1,0,4,15+t,64,21,0,0,0,0,0,0,0,0,0,0,0,5].concat([t]).concat(e.config).concat([6,1,2]))},e.mp4a=function(t){var r=t.samplerate;return e.box(e.types.mp4a,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,t.channelCount,0,16,0,0,0,0,r>>8&255,255&r,0,0]),e.box(e.types.esds,e.esds(t)))},e.mp3=function(t){var r=t.samplerate;return e.box(e.types[".mp3"],new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,t.channelCount,0,16,0,0,0,0,r>>8&255,255&r,0,0]))},e.stsd=function(t){return"audio"===t.type?t.isAAC||"mp3"!==t.codec?e.box(e.types.stsd,e.STSD,e.mp4a(t)):e.box(e.types.stsd,e.STSD,e.mp3(t)):e.box(e.types.stsd,e.STSD,e.avc1(t))},e.tkhd=function(t){var r=t.id,n=t.duration*t.timescale,i=t.width,o=t.height,a=Math.floor(n/(Y+1)),s=Math.floor(n%(Y+1));return e.box(e.types.tkhd,new Uint8Array([1,0,0,7,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,r>>24&255,r>>16&255,r>>8&255,255&r,0,0,0,0,a>>24,a>>16&255,a>>8&255,255&a,s>>24,s>>16&255,s>>8&255,255&s,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,i>>8&255,255&i,0,0,o>>8&255,255&o,0,0]))},e.traf=function(t,r){var n=e.sdtp(t),i=t.id,o=Math.floor(r/(Y+1)),a=Math.floor(r%(Y+1));return e.box(e.types.traf,e.box(e.types.tfhd,new Uint8Array([0,0,0,0,i>>24,i>>16&255,i>>8&255,255&i])),e.box(e.types.tfdt,new Uint8Array([1,0,0,0,o>>24,o>>16&255,o>>8&255,255&o,a>>24,a>>16&255,a>>8&255,255&a])),e.trun(t,n.length+16+20+8+16+8+8),n)},e.trak=function(t){return t.duration=t.duration||4294967295,e.box(e.types.trak,e.tkhd(t),e.mdia(t))},e.trex=function(t){var r=t.id;return e.box(e.types.trex,new Uint8Array([0,0,0,0,r>>24,r>>16&255,r>>8&255,255&r,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,1]))},e.trun=function(t,r){var n,i,o,a,s,u,c=t.samples||[],l=c.length,f=12+16*l,d=new Uint8Array(f);for(r+=8+f,d.set([0,0,15,1,l>>>24&255,l>>>16&255,l>>>8&255,255&l,r>>>24&255,r>>>16&255,r>>>8&255,255&r],0),n=0;n<l;n++)i=c[n],o=i.duration,a=i.size,s=i.flags,u=i.cts,d.set([o>>>24&255,o>>>16&255,o>>>8&255,255&o,a>>>24&255,a>>>16&255,a>>>8&255,255&a,s.isLeading<<2|s.dependsOn,s.isDependedOn<<6|s.hasRedundancy<<4|s.paddingValue<<1|s.isNonSync,61440&s.degradPrio,15&s.degradPrio,u>>>24&255,u>>>16&255,u>>>8&255,255&u],12+16*n);return e.box(e.types.trun,d)},e.initSegment=function(t){e.types||e.init();var r,n=e.moov(t);return r=new Uint8Array(e.FTYP.byteLength+n.byteLength),r.set(e.FTYP),r.set(n,e.FTYP.byteLength),r},e}(),Z=K,J=function(){function e(t,r,n,i){$(this,e),this.observer=t,this.config=r,this.typeSupported=n;var o=navigator.userAgent;this.isSafari=i&&i.indexOf("Apple")>-1&&o&&!o.match("CriOS"),this.ISGenerated=!1}return e.prototype.destroy=function(){},e.prototype.resetTimeStamp=function(e){this._initPTS=this._initDTS=e},e.prototype.resetInitSegment=function(){this.ISGenerated=!1},e.prototype.remux=function(e,t,r,n,i,o,a){if(this.ISGenerated||this.generateIS(e,t,i),this.ISGenerated){var s=e.samples.length,u=t.samples.length,c=i,l=i;if(s&&u){var f=(e.samples[0].dts-t.samples[0].dts)/t.inputTimeScale;c+=Math.max(0,f),l+=Math.max(0,-f)}if(s){e.timescale||(A.b.warn("regenerate InitSegment as audio detected"),this.generateIS(e,t,i));var d=this.remuxAudio(e,c,o,a);if(u){var h=void 0;d&&(h=d.endPTS-d.startPTS),t.timescale||(A.b.warn("regenerate InitSegment as video detected"),this.generateIS(e,t,i)),this.remuxVideo(t,l,o,h,a)}}else{var p=void 0;u&&(p=this.remuxVideo(t,l,o,a)),p&&e.codec&&this.remuxEmptyAudio(e,c,o,p)}}r.samples.length&&this.remuxID3(r,i),n.samples.length&&this.remuxText(n,i),this.observer.trigger(S.a.FRAG_PARSED)},e.prototype.generateIS=function(e,t,r){var n,i,o=this.observer,a=e.samples,s=t.samples,u=this.typeSupported,c="audio/mp4",l={},f={tracks:l},d=this._initPTS===undefined;if(d&&(n=i=Infinity),e.config&&a.length&&(e.timescale=e.samplerate,A.b.log("audio sampling rate : "+e.samplerate),e.isAAC||(u.mpeg?(c="audio/mpeg",e.codec=""):u.mp3&&(e.codec="mp3")),l.audio={container:c,codec:e.codec,initSegment:!e.isAAC&&u.mpeg?new Uint8Array:Z.initSegment([e]),metadata:{channelCount:e.channelCount}},d&&(n=i=a[0].pts-e.inputTimeScale*r)),t.sps&&t.pps&&s.length){var h=t.inputTimeScale;t.timescale=h,l.video={container:"video/mp4",codec:t.codec,initSegment:Z.initSegment([t]),metadata:{width:t.width,height:t.height}},d&&(n=Math.min(n,s[0].pts-h*r),i=Math.min(i,s[0].dts-h*r),this.observer.trigger(S.a.INIT_PTS_FOUND,{initPTS:n}))}Object.keys(l).length?(o.trigger(S.a.FRAG_PARSING_INIT_SEGMENT,f),this.ISGenerated=!0,d&&(this._initPTS=n,this._initDTS=i)):o.trigger(S.a.ERROR,{type:O.b.MEDIA_ERROR,details:O.a.FRAG_PARSING_ERROR,fatal:!1,reason:"no audio/video samples found"})},e.prototype.remuxVideo=function(e,t,r,n,i){var o,a,s,u,c,l,f,d=8,h=e.timescale,p=e.samples,y=[],g=p.length,m=this._PTSNormalize,_=this._initDTS,v=this.nextAvcDts,b=this.isSafari;b&&(r|=p.length&&v&&(i&&Math.abs(t-v/h)<.1||Math.abs(p[0].pts-v-_)<h/5)),r||(v=t*h),p.forEach(function(e){e.pts=m(e.pts-_,v),e.dts=m(e.dts-_,v)}),p.sort(function(e,t){var r=e.dts-t.dts,n=e.pts-t.pts;return r||(n||e.id-t.id)});var $=p.reduce(function(e,t){return Math.max(Math.min(e,t.pts-t.dts),-18e3)},0);if($<0){A.b.warn("PTS < DTS detected in video samples, shifting DTS by "+Math.round($/90)+" ms to overcome this issue");for(var w=0;w<p.length;w++)p[w].dts+=$}var E=p[0];c=Math.max(E.dts,0),u=Math.max(E.pts,0);var T=Math.round((c-v)/90);r&&T&&(T>1?A.b.log("AVC:"+T+" ms hole between fragments detected,filling it"):T<-1&&A.b.log("AVC:"+-T+" ms overlapping between fragments detected"),c=v,p[0].dts=c,u=Math.max(u-T,v),p[0].pts=u,A.b.log("Video/PTS/DTS adjusted: "+Math.round(u/90)+"/"+Math.round(c/90)+",delta:"+T+" ms")),E=p[p.length-1],f=Math.max(E.dts,0),l=Math.max(E.pts,0,f),b&&(o=Math.round((f-c)/(p.length-1)));for(var x=0,k=0,D=0;D<g;D++){for(var I=p[D],P=I.units,M=P.length,R=0,C=0;C<M;C++)R+=P[C].data.length;k+=R,x+=M,I.length=R,I.dts=b?c+D*o:Math.max(I.dts,c),I.pts=Math.max(I.pts,I.dts)}var j=k+4*x+8;try{a=new Uint8Array(j)}catch(ie){return void this.observer.trigger(S.a.ERROR,{type:O.b.MUX_ERROR,details:O.a.REMUX_ALLOC_ERROR,fatal:!1,bytes:j,reason:"fail allocating video mdat "+j})}var L=new DataView(a.buffer);L.setUint32(0,j),a.set(Z.types.mdat,4);for(var N=0;N<g;N++){for(var F=p[N],B=F.units,U=0,z=void 0,G=0,W=B.length;G<W;G++){var H=B[G],V=H.data,Y=H.data.byteLength;L.setUint32(d,Y),d+=4,a.set(V,d),d+=Y,U+=4+Y}if(b)z=Math.max(0,o*Math.round((F.pts-F.dts)/o));else{if(N<g-1)o=p[N+1].dts-F.dts;else{var K=this.config,J=F.dts-p[N>0?N-1:N].dts;if(K.stretchShortVideoTrack){var Q=K.maxBufferHole,X=K.maxSeekHole,q=Math.floor(Math.min(Q,X)*h),ee=(n?u+n*h:this.nextAudioPts)-F.pts;ee>q?(o=ee-J,o<0&&(o=J),A.b.log("It is approximately "+ee/90+" ms to the next segment; using duration "+o/90+" ms for the last video frame.")):o=J}else o=J}z=Math.round(F.pts-F.dts)}y.push({size:U,duration:o,cts:z,flags:{isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:F.key?2:1,isNonSync:F.key?0:1}})}this.nextAvcDts=f+o;var te=e.dropped;if(e.len=0,e.nbNalu=0,e.dropped=0,y.length&&navigator.userAgent.toLowerCase().indexOf("chrome")>-1){var re=y[0].flags;re.dependsOn=2,re.isNonSync=0}e.samples=y,s=Z.moof(e.sequenceNumber++,c,e),e.samples=[];var ne={data1:s,data2:a,startPTS:u/h,endPTS:(l+o)/h,startDTS:c/h,endDTS:this.nextAvcDts/h,type:"video",nb:y.length,dropped:te};return this.observer.trigger(S.a.FRAG_PARSING_DATA,ne),ne},e.prototype.remuxAudio=function(e,t,r,n){var i,o,a,s,u,c,l,f=e.inputTimeScale,d=e.timescale,h=f/d,p=e.isAAC?1024:1152,y=p*h,g=this._PTSNormalize,m=this._initDTS,_=!e.isAAC&&this.typeSupported.mpeg,v=e.samples,b=[],$=this.nextAudioPts;if(r|=v.length&&$&&(n&&Math.abs(t-$/f)<.1||Math.abs(v[0].pts-$-m)<20*y),r||($=t*f),v.forEach(function(e){e.pts=e.dts=g(e.pts-m,$)}),v.sort(function(e,t){return e.pts-t.pts}),n&&e.isAAC)for(var w=this.config.maxAudioFramesDrift,E=0,T=$;E<v.length;){var x,k=v[E],D=k.pts;x=D-T;var I=Math.abs(1e3*x/f);if(x<=-w*y)A.b.warn("Dropping 1 audio frame @ "+(T/f).toFixed(3)+"s due to "+Math.round(I)+" ms overlap."),v.splice(E,1),e.len-=k.unit.length;else if(x>=w*y&&I<1e4&&T){var P=Math.round(x/y);A.b.warn("Injecting "+P+" audio frame @ "+(T/f).toFixed(3)+"s due to "+Math.round(1e3*x/f)+" ms gap.");for(var M=0;M<P;M++){var R=Math.max(T,0);a=V.getSilentFrame(e.manifestCodec||e.codec,e.channelCount),a||(A.b.log("Unable to get silent frame for given audio codec; duplicating last frame instead."),a=k.unit.subarray()),v.splice(E,0,{unit:a,pts:R,dts:R}),e.len+=a.length,T+=y,E++}k.pts=k.dts=T,T+=y,E++}else k.pts=k.dts=T,T+=y,E++}for(var C=0,j=v.length;C<j;C++){var L=v[C],N=L.unit,F=L.pts;if(l!==undefined)o.duration=Math.round((F-l)/h);else{var B=Math.round(1e3*(F-$)/f),U=0;if(r&&e.isAAC&&B){if(B>0&&B<1e4)U=Math.round((F-$)/y),A.b.log(B+" ms hole between AAC samples detected,filling it"),U>0&&(a=V.getSilentFrame(e.manifestCodec||e.codec,e.channelCount),a||(a=N.subarray()),e.len+=U*a.length);else if(B<-12){A.b.log("drop overlapping AAC sample, expected/parsed/delta:"+($/f).toFixed(3)+"s/"+(F/f).toFixed(3)+"s/"+-B+"ms"),e.len-=N.byteLength;continue}F=$}if(c=Math.max(0,F),!(e.len>0))return;var z=_?e.len:e.len+8;i=_?0:8;try{s=new Uint8Array(z)}catch(X){return void this.observer.trigger(S.a.ERROR,{type:O.b.MUX_ERROR,details:O.a.REMUX_ALLOC_ERROR,fatal:!1,bytes:z,reason:"fail allocating audio mdat "+z})}if(!_){new DataView(s.buffer).setUint32(0,z),s.set(Z.types.mdat,4)}for(var G=0;G<U;G++)a=V.getSilentFrame(e.manifestCodec||e.codec,e.channelCount),a||(A.b.log("Unable to get silent frame for given audio codec; duplicating this frame instead."),a=N.subarray()),s.set(a,i),i+=a.byteLength,o={size:a.byteLength,cts:0,duration:1024,flags:{isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:1}},b.push(o)}s.set(N,i);var W=N.byteLength;i+=W,o={size:W,cts:0,duration:0,flags:{isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:1}},b.push(o),l=F}var H=0,Y=b.length;if(Y>=2&&(H=b[Y-2].duration,o.duration=H),Y){this.nextAudioPts=$=l+h*H,e.len=0,e.samples=b,u=_?new Uint8Array:Z.moof(e.sequenceNumber++,c/h,e),e.samples=[];var K=c/f,J=$/f,Q={data1:u,data2:s,startPTS:K,endPTS:J,startDTS:K,endDTS:J,type:"audio",nb:Y};return this.observer.trigger(S.a.FRAG_PARSING_DATA,Q),Q}return null},e.prototype.remuxEmptyAudio=function(e,t,r,n){var i=e.inputTimeScale,o=e.samplerate?e.samplerate:i,a=i/o,s=this.nextAudioPts,u=(s!==undefined?s:n.startDTS*i)+this._initDTS,c=n.endDTS*i+this._initDTS,l=1024*a,f=Math.ceil((c-u)/l),d=V.getSilentFrame(e.manifestCodec||e.codec,e.channelCount);if(A.b.warn("remux empty Audio"),!d)return void A.b.trace("Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!");for(var h=[],p=0;p<f;p++){var y=u+p*l;h.push({unit:d,pts:y,dts:y}),e.len+=d.length}e.samples=h,this.remuxAudio(e,t,r)},e.prototype.remuxID3=function(e,t){var r,n=e.samples.length,i=e.inputTimeScale,o=this._initPTS,a=this._initDTS;if(n){for(var s=0;s<n;s++)r=e.samples[s],r.pts=(r.pts-o)/i,r.dts=(r.dts-a)/i;this.observer.trigger(S.a.FRAG_PARSING_METADATA,{samples:e.samples})}e.samples=[],t=t},e.prototype.remuxText=function(e,t){e.samples.sort(function(e,t){return e.pts-t.pts});var r,n=e.samples.length,i=e.inputTimeScale,o=this._initPTS;if(n){for(var a=0;a<n;a++)r=e.samples[a],r.pts=(r.pts-o)/i;this.observer.trigger(S.a.FRAG_PARSING_USERDATA,{samples:e.samples})}e.samples=[],t=t},e.prototype._PTSNormalize=function(e,t){var r;if(t===undefined)return e;for(r=t<e?-8589934592:8589934592;Math.abs(e-t)>4294967296;)e+=r;return e},e}(),Q=J,X=function(){function e(t){w(this,e),this.observer=t}return e.prototype.destroy=function(){},e.prototype.resetTimeStamp=function(){},e.prototype.resetInitSegment=function(){},e.prototype.remux=function(e,t,r,n,i,o,a,s){var u=this.observer,c="";e&&(c+="audio"),t&&(c+="video"),u.trigger(S.a.FRAG_PARSING_DATA,{data1:s,startPTS:i,startDTS:i,type:c,nb:1,dropped:0}),u.trigger(S.a.FRAG_PARSED)},e}(),q=X,ee=function(){function e(t,r,n,i){E(this,e),this.observer=t,this.typeSupported=r,this.config=n,this.vendor=i}return e.prototype.destroy=function(){var e=this.demuxer;e&&e.destroy()},e.prototype.push=function(e,t,r,n,i,o,a,s,u,c,l,f){if(e.byteLength>0&&null!=t&&null!=t.key&&"AES-128"===t.method){var d=this.decrypter;null==d&&(d=this.decrypter=new T.a(this.observer,this.config));var h,p=this;try{h=performance.now()}catch(y){h=Date.now()}d.decrypt(e,t.key.buffer,t.iv.buffer,function(e){var d;try{d=performance.now()}catch(y){d=Date.now()}p.observer.trigger(S.a.FRAG_DECRYPTED,{stats:{tstart:h,tdecrypt:d}}),p.pushDecrypted(new Uint8Array(e),t,new Uint8Array(r),n,i,o,a,s,u,c,l,f)})}else this.pushDecrypted(new Uint8Array(e),t,new Uint8Array(r),n,i,o,a,s,u,c,l,f)},e.prototype.pushDecrypted=function(e,t,r,n,i,o,a,s,u,c,l,f){var d=this.demuxer;if(!d||a&&!this.probe(e)){for(var h=this.observer,p=this.typeSupported,y=this.config,g=[{demux:z,remux:Q},{demux:D,remux:Q},{demux:W,remux:Q},{demux:M,remux:q}],m=0,_=g.length;m<_;m++){var v=g[m],b=v.demux.probe;if(b(e)){var $=this.remuxer=new v.remux(h,y,p,this.vendor);d=new v.demux(h,$,y,p),this.probe=b;break}}if(!d)return void h.trigger(S.a.ERROR,{type:O.b.MEDIA_ERROR,details:O.a.FRAG_PARSING_ERROR,fatal:!0,reason:"no demux matching with content found"});this.demuxer=d}var w=this.remuxer;(a||s)&&(d.resetInitSegment(r,n,i,c),w.resetInitSegment()),a&&(d.resetTimeStamp(f),w.resetTimeStamp(f)),"function"==typeof d.setDecryptData&&d.setDecryptData(t),d.append(e,o,u,l)},e}();t.a=ee},function(t,r,n){function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){var r=Ue[t];return!!r&&!0===r[e.slice(0,4)]}function s(e,t){return MediaSource.isTypeSupported((t||"video")+'/mp4;codecs="'+e+'"')}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function c(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function f(e,t){if(!e)return null;for(var r=null,n=0;n<e.length;n++){var i=e[n];i.id===t&&(r=i)}return r}function d(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function h(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function p(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function y(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function g(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function m(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function _(){if("undefined"!=typeof window)return window.MediaSource||window.WebKitMediaSource}function v(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function b(e,t,r){var n=e[t],i=e[r],o=i.startPTS;isNaN(o)?i.start=r>t?n.start+n.duration:Math.max(n.start-i.duration,0):r>t?(n.duration=o-n.start,n.duration<0&&Me.b.warn("negative duration computed for frag "+n.sn+",level "+n.level+", there should be some duration drift between playlist and fragment!")):(i.duration=n.start-o,i.duration<0&&Me.b.warn("negative duration computed for frag "+i.sn+",level "+i.level+", there should be some duration drift between playlist and fragment!"))}function $(e,t,r,n,i,o){var a=r;if(!isNaN(t.startPTS)){var s=Math.abs(t.startPTS-r);isNaN(t.deltaPTS)?t.deltaPTS=s:t.deltaPTS=Math.max(s,t.deltaPTS),a=Math.max(r,t.startPTS),r=Math.min(r,t.startPTS),n=Math.max(n,t.endPTS),i=Math.min(i,t.startDTS),o=Math.max(o,t.endDTS)}var u=r-t.start;t.start=t.startPTS=r,t.maxStartPTS=a,t.endPTS=n,t.startDTS=i,t.endDTS=o,t.duration=n-r;var c=t.sn;if(!e||c<e.startSN||c>e.endSN)return 0;var l,f,d;for(l=c-e.startSN,f=e.fragments,f[l]=t,d=l;d>0;d--)b(f,d,d-1);for(d=l;d<f.length-1;d++)b(f,d,d+1);return e.PTSKnown=!0,u}function w(e,t){var r,n=Math.max(e.startSN,t.startSN)-t.startSN,i=Math.min(e.endSN,t.endSN)-t.startSN,o=t.startSN-e.startSN,a=e.fragments,s=t.fragments,u=0;if(i<n)return void(t.PTSKnown=!1);for(var c=n;c<=i;c++){var l=a[o+c],f=s[c];f&&l&&(u=l.cc-f.cc,isNaN(l.startPTS)||(f.start=f.startPTS=l.startPTS,f.endPTS=l.endPTS,f.duration=l.duration,f.backtracked=l.backtracked,f.dropped=l.dropped,r=f))}if(u)for(Me.b.log("discontinuity sliding from playlist, take drift into account"),c=0;c<s.length;c++)s[c].cc+=u;if(r)$(t,r,r.startPTS,r.endPTS,r.startDTS,r.endDTS);else if(o>=0&&o<a.length){var d=a[o].start;for(c=0;c<s.length;c++)s[c].start+=d}t.PTSKnown=e.PTSKnown}function E(e,t){for(var r=null,n=0;n<e.length;n+=1){var i=e[n];if(i&&i.cc===t){r=i;break}}return r}function S(e,t){return rt.search(e,function(e){return e.cc<t?1:e.cc>t?-1:0})}function O(e,t,r){var n=!1;return t&&t.details&&r&&(r.endCC>r.startCC||e&&e.cc<r.startCC)&&(n=!0),n}function T(e,t){var r=e.fragments,n=t.fragments;if(!n.length||!r.length)return void Me.b.log("No fragments to align");var i=E(r,n[0].cc);return!i||i&&!i.startPTS?void Me.b.log("No frag in previous level to align on"):i}function A(e,t){t.fragments.forEach(function(t){if(t){var r=t.start+e;t.start=t.startPTS=r,t.endPTS=r+t.duration}}),t.PTSKnown=!0}function x(e,t,r){if(O(e,t,r)){var n=T(t.details,r);n&&(Me.b.log("Adjusting PTS using last level due to CC increase within current level"),A(n.start,r))}if(!1===r.PTSKnown&&t&&t.details){var i=t.details.programDateTime,o=r.programDateTime,a=(o-i)/1e3+t.details.fragments[0].start;isNaN(a)||(Me.b.log("adjusting PTS using programDateTime delta, sliding:"+a.toFixed(3)),A(a,r))}}function k(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function D(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function I(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function P(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function M(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function R(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function C(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function j(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function L(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function N(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function F(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function B(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function U(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function z(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function G(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function W(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function H(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function V(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function Y(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function K(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function Z(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function J(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function Q(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function X(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function q(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ee(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function te(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function re(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ne(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function ie(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function oe(){this.window=window,this.state="INITIAL",this.buffer="",this.decoder=new Jt,this.regionList=[]}function ae(e){function t(e,t,r,n){return 3600*(0|e)+60*(0|t)+(0|r)+(0|n)/1e3}var r=e.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);return r?r[3]?t(r[1],r[2],r[3].replace(":",""),r[4]):r[1]>59?t(r[1],r[2],0,r[4]):t(0,r[1],r[2],r[4]):null}function se(){this.values=Object.create(null)}function ue(e,t,r,n){var i=n?e.split(n):[e];for(var o in i)if("string"==typeof i[o]){var a=i[o].split(r);if(2===a.length){var s=a[0],u=a[1];t(s,u)}}}function ce(e,t,r){function n(){var t=ae(e);if(null===t)throw new Error("Malformed timestamp: "+o);return e=e.replace(/^[^\sa-zA-Z-]+/,""),t}function i(){e=e.replace(/^\s+/,"")}var o=e;if(i(),t.startTime=n(),i(),"--\x3e"!==e.substr(0,3))throw new Error("Malformed time stamp (time stamps must be separated by '--\x3e'): "+o);e=e.substr(3),i(),t.endTime=n(),i(),function(e,t){var n=new se;ue(e,function(e,t){switch(e){case"region":for(var i=r.length-1;i>=0;i--)if(r[i].id===t){n.set(e,r[i].region);break}break;case"vertical":n.alt(e,t,["rl","lr"]);break;case"line":var o=t.split(","),a=o[0];n.integer(e,a),n.percent(e,a)&&n.set("snapToLines",!1),n.alt(e,a,["auto"]),2===o.length&&n.alt("lineAlign",o[1],["start",Xt,"end"]);break;case"position":o=t.split(","),n.percent(e,o[0]),2===o.length&&n.alt("positionAlign",o[1],["start",Xt,"end","line-left","line-right","auto"]);break;case"size":n.percent(e,t);break;case"align":n.alt(e,t,["start",Xt,"end","left","right"])}},/:/,/\s/),t.region=n.get("region",null),t.vertical=n.get("vertical","");var i=n.get("line","auto");"auto"===i&&-1===Qt.line&&(i=-1),t.line=i,t.lineAlign=n.get("lineAlign","start"),t.snapToLines=n.get("snapToLines",!0),t.size=n.get("size",100),t.align=n.get("align",Xt);var o=n.get("position","auto");"auto"===o&&50===Qt.position&&(o="start"===t.align||"left"===t.align?0:"end"===t.align||"right"===t.align?100:50),t.position=o}(e,t)}function le(e){return e.replace(/<br(?: \/)?>/gi,"\n")}function fe(e,t,r,n){for(var i,o,a,s,u,c=window.VTTCue||window.TextTrackCue,l=0;l<n.rows.length;l++)if(i=n.rows[l],a=!0,s=0,u="",!i.isEmpty()){for(var f=0;f<i.chars.length;f++)i.chars[f].uchar.match(/\s/)&&a?s++:(u+=i.chars[f].uchar,a=!1);i.cueStartTime=t,t===r&&(r+=1e-4),o=new c(t,r,le(u.trim())),s>=16?s--:s++,navigator.userAgent.match(/Firefox\//)?o.line=l+1:o.line=l>7?l-2:l+1,o.align="left",o.position=Math.max(0,Math.min(100,s/32*100+(navigator.userAgent.match(/Firefox\//)?50:0))),e.addCue(o)}}function de(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function he(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function pe(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ye(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function ge(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function me(e){if(e&&e.cues)for(;e.cues.length>0;)e.removeCue(e.cues[0])}function _e(e,t){return e&&e.label===t.name&&!(e.textTrack1||e.textTrack2)}function ve(e,t,r,n){return Math.min(t,n)-Math.max(e,r)}function be(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function $e(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function we(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function Ee(e){for(var t=[],r=0;r<e.length;r++)"subtitles"===e[r].kind&&t.push(e[r]);return t}function Se(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function Oe(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function Te(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function Ae(e,t){
if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(r,"__esModule",{value:!0});var xe={};n.d(xe,"newCue",function(){return fe});var ke=n(6),De=n.n(ke),Ie=n(1),Pe=n(2),Me=n(0),Re="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},Ce=function(){function e(t){i(this,e),this.hls=t,this.onEvent=this.onEvent.bind(this);for(var r=arguments.length,n=Array(r>1?r-1:0),o=1;o<r;o++)n[o-1]=arguments[o];this.handledEvents=n,this.useGenericHandler=!0,this.registerListeners()}return e.prototype.destroy=function(){this.unregisterListeners()},e.prototype.isEventHandler=function(){return"object"===Re(this.handledEvents)&&this.handledEvents.length&&"function"==typeof this.onEvent},e.prototype.registerListeners=function(){this.isEventHandler()&&this.handledEvents.forEach(function(e){if("hlsEventGeneric"===e)throw new Error("Forbidden event name: "+e);this.hls.on(e,this.onEvent)},this)},e.prototype.unregisterListeners=function(){this.isEventHandler()&&this.handledEvents.forEach(function(e){this.hls.off(e,this.onEvent)},this)},e.prototype.onEvent=function(e,t){this.onEventGeneric(e,t)},e.prototype.onEventGeneric=function(e,t){var r=function(e,t){var r="on"+e.replace("hls","");if("function"!=typeof this[r])throw new Error("Event "+e+" has no generic handler in this "+this.constructor.name+" class (tried "+r+")");return this[r].bind(this,t)};try{r.call(this,e,t).call()}catch(n){Me.b.error("internal error happened while processing "+e+":"+n.message),this.hls.trigger(Ie.a.ERROR,{type:Pe.b.OTHER_ERROR,details:Pe.a.INTERNAL_EXCEPTION,fatal:!1,event:e,err:n})}},e}(),je=Ce,Le=/^(\d+)x(\d+)$/,Ne=/\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g,Fe=function(){function e(t){o(this,e),"string"==typeof t&&(t=e.parseAttrList(t));for(var r in t)t.hasOwnProperty(r)&&(this[r]=t[r])}return e.prototype.decimalInteger=function(e){var t=parseInt(this[e],10);return t>Number.MAX_SAFE_INTEGER?Infinity:t},e.prototype.hexadecimalInteger=function(e){if(this[e]){var t=(this[e]||"0x").slice(2);t=(1&t.length?"0":"")+t;for(var r=new Uint8Array(t.length/2),n=0;n<t.length/2;n++)r[n]=parseInt(t.slice(2*n,2*n+2),16);return r}return null},e.prototype.hexadecimalIntegerAsNumber=function(e){var t=parseInt(this[e],16);return t>Number.MAX_SAFE_INTEGER?Infinity:t},e.prototype.decimalFloatingPoint=function(e){return parseFloat(this[e])},e.prototype.enumeratedString=function(e){return this[e]},e.prototype.decimalResolution=function(e){var t=Le.exec(this[e]);return null===t?undefined:{width:parseInt(t[1],10),height:parseInt(t[2],10)}},e.parseAttrList=function(e){var t,r={};for(Ne.lastIndex=0;null!==(t=Ne.exec(e));){var n=t[2];0===n.indexOf('"')&&n.lastIndexOf('"')===n.length-1&&(n=n.slice(1,-1)),r[t[1]]=n}return r},e}(),Be=Fe,Ue={audio:{a3ds:!0,"ac-3":!0,"ac-4":!0,alac:!0,alaw:!0,dra1:!0,"dts+":!0,"dts-":!0,dtsc:!0,dtse:!0,dtsh:!0,"ec-3":!0,enca:!0,g719:!0,g726:!0,m4ae:!0,mha1:!0,mha2:!0,mhm1:!0,mhm2:!0,mlpa:!0,mp4a:!0,"raw ":!0,Opus:!0,samr:!0,sawb:!0,sawp:!0,sevc:!0,sqcp:!0,ssmv:!0,twos:!0,ulaw:!0},video:{avc1:!0,avc2:!0,avc3:!0,avc4:!0,avcp:!0,drac:!0,dvav:!0,dvhe:!0,encv:!0,hev1:!0,hvc1:!0,mjp2:!0,mp4v:!0,mvc1:!0,mvc2:!0,mvc3:!0,mvc4:!0,resv:!0,rv60:!0,s263:!0,svc1:!0,svc2:!0,"vc-1":!0,vp08:!0,vp09:!0}},ze=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),Ge=/#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g,We=/#EXT-X-MEDIA:(.*)/g,He=new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,/|(?!#)(\S+)/.source,/|#EXT-X-BYTERANGE:*(.+)/.source,/|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,/|#.*/.source].join(""),"g"),Ve=/(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/,Ye=function(){function e(){l(this,e),this.method=null,this.key=null,this.iv=null,this._uri=null}return ze(e,[{key:"uri",get:function(){return!this._uri&&this.reluri&&(this._uri=De.a.buildAbsoluteURL(this.baseuri,this.reluri,{alwaysNormalize:!0})),this._uri}}]),e}(),Ke=function(){function e(){l(this,e),this._url=null,this._byteRange=null,this._decryptdata=null,this.tagList=[]}return e.prototype.createInitializationVector=function(e){for(var t=new Uint8Array(16),r=12;r<16;r++)t[r]=e>>8*(15-r)&255;return t},e.prototype.fragmentDecryptdataFromLevelkey=function(e,t){var r=e;return e&&e.method&&e.uri&&!e.iv&&(r=new Ye,r.method=e.method,r.baseuri=e.baseuri,r.reluri=e.reluri,r.iv=this.createInitializationVector(t)),r},e.prototype.cloneObj=function(e){return JSON.parse(JSON.stringify(e))},ze(e,[{key:"url",get:function(){return!this._url&&this.relurl&&(this._url=De.a.buildAbsoluteURL(this.baseurl,this.relurl,{alwaysNormalize:!0})),this._url},set:function(e){this._url=e}},{key:"programDateTime",get:function(){return!this._programDateTime&&this.rawProgramDateTime&&(this._programDateTime=new Date(Date.parse(this.rawProgramDateTime))),this._programDateTime}},{key:"byteRange",get:function(){if(!this._byteRange){var e=this._byteRange=[];if(this.rawByteRange){var t=this.rawByteRange.split("@",2);if(1===t.length){var r=this.lastByteRangeEndOffset;e[0]=r||0}else e[0]=parseInt(t[1]);e[1]=parseInt(t[0])+e[0]}}return this._byteRange}},{key:"byteRangeStartOffset",get:function(){return this.byteRange[0]}},{key:"byteRangeEndOffset",get:function(){return this.byteRange[1]}},{key:"decryptdata",get:function(){return this._decryptdata||(this._decryptdata=this.fragmentDecryptdataFromLevelkey(this.levelkey,this.sn)),this._decryptdata}}]),e}(),Ze=function(e){function t(r){l(this,t);var n=u(this,e.call(this,r,Ie.a.MANIFEST_LOADING,Ie.a.LEVEL_LOADING,Ie.a.AUDIO_TRACK_LOADING,Ie.a.SUBTITLE_TRACK_LOADING));return n.loaders={},n}return c(t,e),t.prototype.destroy=function(){for(var e in this.loaders){var t=this.loaders[e];t&&t.destroy()}this.loaders={},je.prototype.destroy.call(this)},t.prototype.onManifestLoading=function(e){this.load(e.url,{type:"manifest"})},t.prototype.onLevelLoading=function(e){this.load(e.url,{type:"level",level:e.level,id:e.id})},t.prototype.onAudioTrackLoading=function(e){this.load(e.url,{type:"audioTrack",id:e.id})},t.prototype.onSubtitleTrackLoading=function(e){this.load(e.url,{type:"subtitleTrack",id:e.id})},t.prototype.load=function(e,t){var r=this.loaders[t.type];if(r){var n=r.context;if(n&&n.url===e)return void Me.b.trace("playlist request ongoing");Me.b.warn("abort previous loader for type:"+t.type),r.abort()}var i=this.hls.config,o=void 0,a=void 0,s=void 0,u=void 0;"manifest"===t.type?(o=i.manifestLoadingMaxRetry,a=i.manifestLoadingTimeOut,s=i.manifestLoadingRetryDelay,u=i.manifestLoadingMaxRetryTimeout):(o=i.levelLoadingMaxRetry,a=i.levelLoadingTimeOut,s=i.levelLoadingRetryDelay,u=i.levelLoadingMaxRetryTimeout,Me.b.log("loading playlist for "+t.type+" "+(t.level||t.id))),r=this.loaders[t.type]=t.loader="undefined"!=typeof i.pLoader?new i.pLoader(i):new i.loader(i),t.url=e,t.responseType="";var c=void 0,l=void 0;c={timeout:a,maxRetry:o,retryDelay:s,maxRetryDelay:u},l={onSuccess:this.loadsuccess.bind(this),onError:this.loaderror.bind(this),onTimeout:this.loadtimeout.bind(this)},r.load(t,c,l)},t.prototype.resolve=function(e,t){return De.a.buildAbsoluteURL(t,e,{alwaysNormalize:!0})},t.prototype.parseMasterPlaylist=function(e,t){var r=[],n=void 0;for(Ge.lastIndex=0;null!=(n=Ge.exec(e));){var i={},o=i.attrs=new Be(n[1]);i.url=this.resolve(n[2],t);var s=o.decimalResolution("RESOLUTION");s&&(i.width=s.width,i.height=s.height),i.bitrate=o.decimalInteger("AVERAGE-BANDWIDTH")||o.decimalInteger("BANDWIDTH"),i.name=o.NAME,function(e,t){["video","audio"].forEach(function(r){var n=e.filter(function(e){return a(e,r)});if(n.length){var i=n.filter(function(e){return 0===e.lastIndexOf("avc1",0)||0===e.lastIndexOf("mp4a",0)});t[r+"Codec"]=i.length>0?i[0]:n[0],e=e.filter(function(e){return-1===n.indexOf(e)})}}),t.unknownCodecs=e}([].concat((o.CODECS||"").split(/[ ,]+/)),i),i.videoCodec&&-1!==i.videoCodec.indexOf("avc1")&&(i.videoCodec=this.avc1toavcoti(i.videoCodec)),r.push(i)}return r},t.prototype.parseMasterPlaylistMedia=function(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[],i=void 0,o=[],a=0;for(We.lastIndex=0;null!==(i=We.exec(e));){var s={},u=new Be(i[1]);if(u.TYPE===r){if(s.groupId=u["GROUP-ID"],s.name=u.NAME,s.type=r,s["default"]="YES"===u.DEFAULT,s.autoselect="YES"===u.AUTOSELECT,s.forced="YES"===u.FORCED,u.URI&&(s.url=this.resolve(u.URI,t)),s.lang=u.LANGUAGE,s.name||(s.name=s.lang),n.length){var c=f(n,s.groupId);s.audioCodec=c?c.codec:n[0].codec}s.id=a++,o.push(s)}}return o},t.prototype.avc1toavcoti=function(e){var t,r=e.split(".");return r.length>2?(t=r.shift()+".",t+=parseInt(r.shift()).toString(16),t+=("000"+parseInt(r.shift()).toString(16)).substr(-4)):t=e,t},t.prototype.parseLevelPlaylist=function(e,t,r,n){var i,o,a=0,s=0,u={type:null,version:null,url:t,fragments:[],live:!0,startSN:0},c=new Ye,l=0,f=null,d=new Ke;for(He.lastIndex=0;null!==(i=He.exec(e));){var h=i[1];if(h){d.duration=parseFloat(h);var p=(" "+i[2]).slice(1);d.title=p||null,d.tagList.push(p?["INF",h,p]:["INF",h])}else if(i[3]){if(!isNaN(d.duration)){var y=a++;d.type=n,d.start=s,d.levelkey=c,d.sn=y,d.level=r,d.cc=l,d.baseurl=t,d.relurl=(" "+i[3]).slice(1),u.fragments.push(d),f=d,s+=d.duration,d=new Ke}}else if(i[4]){if(d.rawByteRange=(" "+i[4]).slice(1),f){var g=f.byteRangeEndOffset;g&&(d.lastByteRangeEndOffset=g)}}else if(i[5])d.rawProgramDateTime=(" "+i[5]).slice(1),d.tagList.push(["PROGRAM-DATE-TIME",d.rawProgramDateTime]),u.programDateTime===undefined&&(u.programDateTime=new Date(new Date(Date.parse(i[5]))-1e3*s));else{for(i=i[0].match(Ve),o=1;o<i.length&&i[o]===undefined;o++);var m=(" "+i[o+1]).slice(1),_=(" "+i[o+2]).slice(1);switch(i[o]){case"#":d.tagList.push(_?[m,_]:[m]);break;case"PLAYLIST-TYPE":u.type=m.toUpperCase();break;case"MEDIA-SEQUENCE":a=u.startSN=parseInt(m);break;case"TARGETDURATION":u.targetduration=parseFloat(m);break;case"VERSION":u.version=parseInt(m);break;case"EXTM3U":break;case"ENDLIST":u.live=!1;break;case"DIS":l++,d.tagList.push(["DIS"]);break;case"DISCONTINUITY-SEQ":l=parseInt(m);break;case"KEY":var v=m,b=new Be(v),$=b.enumeratedString("METHOD"),w=b.URI,E=b.hexadecimalInteger("IV");$&&(c=new Ye,w&&["AES-128","SAMPLE-AES"].indexOf($)>=0&&(c.method=$,c.baseuri=t,c.reluri=w,c.key=null,c.iv=E));break;case"START":var S=m,O=new Be(S),T=O.decimalFloatingPoint("TIME-OFFSET");isNaN(T)||(u.startTimeOffset=T);break;case"MAP":var A=new Be(m);d.relurl=A.URI,d.rawByteRange=A.BYTERANGE,d.baseurl=t,d.level=r,d.type=n,d.sn="initSegment",u.initSegment=d,d=new Ke;break;default:Me.b.warn("line parsed but not handled: "+i)}}}return d=f,d&&!d.relurl&&(u.fragments.pop(),s-=d.duration),u.totalduration=s,u.averagetargetduration=s/u.fragments.length,u.endSN=a-1,u.startCC=u.fragments[0]?u.fragments[0].cc:0,u.endCC=l,u},t.prototype.loadsuccess=function(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null,i=e.data,o=e.url,a=r.type,s=r.id,u=r.level,c=this.hls;if(this.loaders[a]=undefined,o!==undefined&&0!==o.indexOf("data:")||(o=r.url),t.tload=performance.now(),0===i.indexOf("#EXTM3U"))if(i.indexOf("#EXTINF:")>0){var l="audioTrack"!==a&&"subtitleTrack"!==a,f=isNaN(u)?isNaN(s)?0:s:u,d=this.parseLevelPlaylist(i,o,f,"audioTrack"===a?"audio":"subtitleTrack"===a?"subtitle":"main");d.tload=t.tload,"manifest"===a&&c.trigger(Ie.a.MANIFEST_LOADED,{levels:[{url:o,details:d}],audioTracks:[],url:o,stats:t,networkDetails:n}),t.tparsed=performance.now(),d.targetduration?l?c.trigger(Ie.a.LEVEL_LOADED,{details:d,level:u||0,id:s||0,stats:t,networkDetails:n}):"audioTrack"===a?c.trigger(Ie.a.AUDIO_TRACK_LOADED,{details:d,id:s,stats:t,networkDetails:n}):"subtitleTrack"===a&&c.trigger(Ie.a.SUBTITLE_TRACK_LOADED,{details:d,id:s,stats:t,networkDetails:n}):c.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:Pe.a.MANIFEST_PARSING_ERROR,fatal:!0,url:o,reason:"invalid targetduration",networkDetails:n})}else{var h=this.parseMasterPlaylist(i,o);if(h.length){var p=h.map(function(e){return{id:e.attrs.AUDIO,codec:e.audioCodec}}),y=this.parseMasterPlaylistMedia(i,o,"AUDIO",p),g=this.parseMasterPlaylistMedia(i,o,"SUBTITLES");if(y.length){var m=!1;y.forEach(function(e){e.url||(m=!0)}),!1===m&&h[0].audioCodec&&!h[0].attrs.AUDIO&&(Me.b.log("audio codec signaled in quality level, but no embedded audio track signaled, create one"),y.unshift({type:"main",name:"main"}))}c.trigger(Ie.a.MANIFEST_LOADED,{levels:h,audioTracks:y,subtitles:g,url:o,stats:t,networkDetails:n})}else c.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:Pe.a.MANIFEST_PARSING_ERROR,fatal:!0,url:o,reason:"no level found in manifest",networkDetails:n})}else c.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:Pe.a.MANIFEST_PARSING_ERROR,fatal:!0,url:o,reason:"no EXTM3U delimiter",networkDetails:n})},t.prototype.loaderror=function(e,t){var r,n,i=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null,o=t.loader;switch(t.type){case"manifest":r=Pe.a.MANIFEST_LOAD_ERROR,n=!0;break;case"level":r=Pe.a.LEVEL_LOAD_ERROR,n=!1;break;case"audioTrack":r=Pe.a.AUDIO_TRACK_LOAD_ERROR,n=!1}o&&(o.abort(),this.loaders[t.type]=undefined),this.hls.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:r,fatal:n,url:o.url,loader:o,response:e,context:t,networkDetails:i})},t.prototype.loadtimeout=function(e,t){var r,n,i=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null,o=t.loader;switch(t.type){case"manifest":r=Pe.a.MANIFEST_LOAD_TIMEOUT,n=!0;break;case"level":r=Pe.a.LEVEL_LOAD_TIMEOUT,n=!1;break;case"audioTrack":r=Pe.a.AUDIO_TRACK_LOAD_TIMEOUT,n=!1}o&&(o.abort(),this.loaders[t.type]=undefined),this.hls.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:r,fatal:n,url:o.url,loader:o,context:t,networkDetails:i})},t}(je),Je=Ze,Qe=function(e){function t(r){d(this,t);var n=h(this,e.call(this,r,Ie.a.FRAG_LOADING));return n.loaders={},n}return p(t,e),t.prototype.destroy=function(){var e=this.loaders;for(var t in e){var r=e[t];r&&r.destroy()}this.loaders={},je.prototype.destroy.call(this)},t.prototype.onFragLoading=function(e){var t=e.frag,r=t.type,n=this.loaders[r],i=this.hls.config;t.loaded=0,n&&(Me.b.warn("abort previous fragment loader for type:"+r),n.abort()),n=this.loaders[r]=t.loader="undefined"!=typeof i.fLoader?new i.fLoader(i):new i.loader(i);var o=void 0,a=void 0,s=void 0;o={url:t.url,frag:t,responseType:"arraybuffer",progressData:!1};var u=t.byteRangeStartOffset,c=t.byteRangeEndOffset;isNaN(u)||isNaN(c)||(o.rangeStart=u,o.rangeEnd=c),a={timeout:i.fragLoadingTimeOut,maxRetry:0,retryDelay:0,maxRetryDelay:i.fragLoadingMaxRetryTimeout},s={onSuccess:this.loadsuccess.bind(this),onError:this.loaderror.bind(this),onTimeout:this.loadtimeout.bind(this),onProgress:this.loadprogress.bind(this)},n.load(o,a,s)},t.prototype.loadsuccess=function(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null,i=e.data,o=r.frag;o.loader=undefined,this.loaders[o.type]=undefined,this.hls.trigger(Ie.a.FRAG_LOADED,{payload:i,frag:o,stats:t,networkDetails:n})},t.prototype.loaderror=function(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null,n=t.loader;n&&n.abort(),this.loaders[t.type]=undefined,this.hls.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:Pe.a.FRAG_LOAD_ERROR,fatal:!1,frag:t.frag,response:e,networkDetails:r})},t.prototype.loadtimeout=function(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null,n=t.loader;n&&n.abort(),this.loaders[t.type]=undefined,this.hls.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:Pe.a.FRAG_LOAD_TIMEOUT,fatal:!1,frag:t.frag,networkDetails:r})},t.prototype.loadprogress=function(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null,i=t.frag;i.loaded=e.loaded,this.hls.trigger(Ie.a.FRAG_LOAD_PROGRESS,{frag:i,stats:e,networkDetails:n})},t}(je),Xe=Qe,qe=function(e){function t(r){y(this,t);var n=g(this,e.call(this,r,Ie.a.KEY_LOADING));return n.loaders={},n.decryptkey=null,n.decrypturl=null,n}return m(t,e),t.prototype.destroy=function(){for(var e in this.loaders){var t=this.loaders[e];t&&t.destroy()}this.loaders={},je.prototype.destroy.call(this)},t.prototype.onKeyLoading=function(e){var t=e.frag,r=t.type,n=this.loaders[r],i=t.decryptdata,o=i.uri;if(o!==this.decrypturl||null===this.decryptkey){var a=this.hls.config;n&&(Me.b.warn("abort previous key loader for type:"+r),n.abort()),t.loader=this.loaders[r]=new a.loader(a),this.decrypturl=o,this.decryptkey=null;var s=void 0,u=void 0,c=void 0;s={url:o,frag:t,responseType:"arraybuffer"},u={timeout:a.fragLoadingTimeOut,maxRetry:a.fragLoadingMaxRetry,retryDelay:a.fragLoadingRetryDelay,maxRetryDelay:a.fragLoadingMaxRetryTimeout},c={onSuccess:this.loadsuccess.bind(this),onError:this.loaderror.bind(this),onTimeout:this.loadtimeout.bind(this)},t.loader.load(s,u,c)}else this.decryptkey&&(i.key=this.decryptkey,this.hls.trigger(Ie.a.KEY_LOADED,{frag:t}))},t.prototype.loadsuccess=function(e,t,r){var n=r.frag;this.decryptkey=n.decryptdata.key=new Uint8Array(e.data),n.loader=undefined,this.loaders[n.type]=undefined,this.hls.trigger(Ie.a.KEY_LOADED,{frag:n})},t.prototype.loaderror=function(e,t){var r=t.frag,n=r.loader;n&&n.abort(),this.loaders[t.type]=undefined,this.hls.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:Pe.a.KEY_LOAD_ERROR,fatal:!1,frag:r,response:e})},t.prototype.loadtimeout=function(e,t){var r=t.frag,n=r.loader;n&&n.abort(),this.loaders[t.type]=undefined,this.hls.trigger(Ie.a.ERROR,{type:Pe.b.NETWORK_ERROR,details:Pe.a.KEY_LOAD_TIMEOUT,fatal:!1,frag:r})},t}(je),et=qe,tt={search:function(e,t){for(var r=0,n=e.length-1,i=null,o=null;r<=n;){i=(r+n)/2|0,o=e[i];var a=t(o);if(a>0)r=i+1;else{if(!(a<0))return o;n=i-1}}return null}},rt=tt,nt={isBuffered:function(e,t){if(e)for(var r=e.buffered,n=0;n<r.length;n++)if(t>=r.start(n)&&t<=r.end(n))return!0;return!1},bufferInfo:function(e,t,r){if(e){var n,i=e.buffered,o=[];for(n=0;n<i.length;n++)o.push({start:i.start(n),end:i.end(n)});return this.bufferedInfo(o,t,r)}return{len:0,start:t,end:t,nextStart:undefined}},bufferedInfo:function(e,t,r){var n,i,o,a,s,u=[];for(e.sort(function(e,t){var r=e.start-t.start;return r||t.end-e.end}),s=0;s<e.length;s++){var c=u.length;if(c){var l=u[c-1].end;e[s].start-l<r?e[s].end>l&&(u[c-1].end=e[s].end):u.push(e[s])}else u.push(e[s])}for(s=0,n=0,i=o=t;s<u.length;s++){var f=u[s].start,d=u[s].end;if(t+r>=f&&t<d)i=f,o=d,n=o-t;else if(t+r<f){a=f;break}}return{len:n,start:i,end:o,nextStart:a}}},it=nt,ot=n(7),at=n(5),st=n.n(at),ut=n(9),ct=n.n(ut),lt=_(),ft=function(){function e(t,r){v(this,e),this.hls=t,this.id=r;var n=this.observer=new st.a,i=t.config;n.trigger=function(e){for(var t=arguments.length,r=Array(t>1?t-1:0),i=1;i<t;i++)r[i-1]=arguments[i];n.emit.apply(n,[e,e].concat(r))},n.off=function(e){for(var t=arguments.length,r=Array(t>1?t-1:0),i=1;i<t;i++)r[i-1]=arguments[i];n.removeListener.apply(n,[e].concat(r))};var o=function(e,r){r=r||{},r.frag=this.frag,r.id=this.id,t.trigger(e,r)}.bind(this);n.on(Ie.a.FRAG_DECRYPTED,o),n.on(Ie.a.FRAG_PARSING_INIT_SEGMENT,o),n.on(Ie.a.FRAG_PARSING_DATA,o),n.on(Ie.a.FRAG_PARSED,o),n.on(Ie.a.ERROR,o),n.on(Ie.a.FRAG_PARSING_METADATA,o),n.on(Ie.a.FRAG_PARSING_USERDATA,o),n.on(Ie.a.INIT_PTS_FOUND,o);var a={mp4:lt.isTypeSupported("video/mp4"),mpeg:lt.isTypeSupported("audio/mpeg"),mp3:lt.isTypeSupported('audio/mp4; codecs="mp3"')},s=navigator.vendor;if(i.enableWorker&&"undefined"!=typeof Worker){Me.b.log("demuxing in webworker");var u=void 0;try{u=this.w=ct()(10),this.onwmsg=this.onWorkerMessage.bind(this),u.addEventListener("message",this.onwmsg),u.onerror=function(e){t.trigger(Ie.a.ERROR,{type:Pe.b.OTHER_ERROR,details:Pe.a.INTERNAL_EXCEPTION,fatal:!0,event:"demuxerWorker",err:{message:e.message+" ("+e.filename+":"+e.lineno+")"}})},u.postMessage({cmd:"init",typeSupported:a,vendor:s,id:r,config:JSON.stringify(i)})}catch(c){Me.b.error("error while initializing DemuxerWorker, fallback on DemuxerInline"),u&&URL.revokeObjectURL(u.objectURL),this.demuxer=new ot.a(n,a,i,s),this.w=undefined}}else this.demuxer=new ot.a(n,a,i,s)}return e.prototype.destroy=function(){var e=this.w;if(e)e.removeEventListener("message",this.onwmsg),e.terminate(),this.w=null;else{var t=this.demuxer;t&&(t.destroy(),this.demuxer=null)}var r=this.observer;r&&(r.removeAllListeners(),this.observer=null)},e.prototype.push=function(e,t,r,n,i,o,a,s){var u=this.w,c=isNaN(i.startDTS)?i.start:i.startDTS,l=i.decryptdata,f=this.frag,d=!(f&&i.cc===f.cc),h=!(f&&i.level===f.level),p=f&&i.sn===f.sn+1,y=!h&&p;if(d&&Me.b.log(this.id+":discontinuity detected"),h&&Me.b.log(this.id+":switch detected"),this.frag=i,u)u.postMessage({cmd:"demux",data:e,decryptdata:l,initSegment:t,audioCodec:r,videoCodec:n,timeOffset:c,discontinuity:d,trackSwitch:h,contiguous:y,duration:o,accurateTimeOffset:a,defaultInitPTS:s},e instanceof ArrayBuffer?[e]:[]);else{var g=this.demuxer;g&&g.push(e,l,t,r,n,c,d,h,y,o,a,s)}},e.prototype.onWorkerMessage=function(e){var t=e.data,r=this.hls;switch(t.event){case"init":URL.revokeObjectURL(this.w.objectURL);break;case Ie.a.FRAG_PARSING_DATA:t.data.data1=new Uint8Array(t.data1),t.data2&&(t.data.data2=new Uint8Array(t.data2));default:t.data=t.data||{},t.data.frag=this.frag,t.data.id=this.id,r.trigger(t.event,t.data)}},e}(),dt=ft,ht={toString:function(e){for(var t="",r=e.length,n=0;n<r;n++)t+="["+e.start(n).toFixed(3)+","+e.end(n).toFixed(3)+"]";return t}},pt=ht,yt=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),gt={STOPPED:"STOPPED",IDLE:"IDLE",KEY_LOADING:"KEY_LOADING",FRAG_LOADING:"FRAG_LOADING",FRAG_LOADING_WAITING_RETRY:"FRAG_LOADING_WAITING_RETRY",WAITING_LEVEL:"WAITING_LEVEL",PARSING:"PARSING",PARSED:"PARSED",BUFFER_FLUSHING:"BUFFER_FLUSHING",ENDED:"ENDED",ERROR:"ERROR"},mt=function(e){function t(r){k(this,t);var n=D(this,e.call(this,r,Ie.a.MEDIA_ATTACHED,Ie.a.MEDIA_DETACHING,Ie.a.MANIFEST_LOADING,Ie.a.MANIFEST_PARSED,Ie.a.LEVEL_LOADED,Ie.a.KEY_LOADED,Ie.a.FRAG_LOADED,Ie.a.FRAG_LOAD_EMERGENCY_ABORTED,Ie.a.FRAG_PARSING_INIT_SEGMENT,Ie.a.FRAG_PARSING_DATA,Ie.a.FRAG_PARSED,Ie.a.ERROR,Ie.a.AUDIO_TRACK_SWITCHING,Ie.a.AUDIO_TRACK_SWITCHED,Ie.a.BUFFER_CREATED,Ie.a.BUFFER_APPENDED,Ie.a.BUFFER_FLUSHED));return n.config=r.config,n.audioCodecSwap=!1,n.ticks=0,n._state=gt.STOPPED,n.ontick=n.tick.bind(n),n}return I(t,e),t.prototype.destroy=function(){this.stopLoad(),this.timer&&(clearInterval(this.timer),this.timer=null),je.prototype.destroy.call(this),this.state=gt.STOPPED},t.prototype.startLoad=function(e){if(this.levels){var t=this.lastCurrentTime,r=this.hls;if(this.stopLoad(),this.timer||(this.timer=setInterval(this.ontick,100)),this.level=-1,this.fragLoadError=0,!this.startFragRequested){var n=r.startLevel;-1===n&&(n=0,this.bitrateTest=!0),this.level=r.nextLoadLevel=n,this.loadedmetadata=!1}t>0&&-1===e&&(Me.b.log("override startPosition with lastCurrentTime @"+t.toFixed(3)),e=t),this.state=gt.IDLE,this.nextLoadPosition=this.startPosition=this.lastCurrentTime=e,this.tick()}else this.forceStartLoad=!0,this.state=gt.STOPPED},t.prototype.stopLoad=function(){var e=this.fragCurrent;e&&(e.loader&&e.loader.abort(),this.fragCurrent=null),this.fragPrevious=null,this.demuxer&&(this.demuxer.destroy(),this.demuxer=null),this.state=gt.STOPPED,this.forceStartLoad=!1},t.prototype.tick=function(){1===++this.ticks&&(this.doTick(),this.ticks>1&&setTimeout(this.tick,1),this.ticks=0)},t.prototype.doTick=function(){switch(this.state){case gt.ERROR:break;case gt.BUFFER_FLUSHING:this.fragLoadError=0;break;case gt.IDLE:this._doTickIdle();break;case gt.WAITING_LEVEL:var e=this.levels[this.level];e&&e.details&&(this.state=gt.IDLE);break;case gt.FRAG_LOADING_WAITING_RETRY:var t=performance.now(),r=this.retryDate;(!r||t>=r||this.media&&this.media.seeking)&&(Me.b.log("mediaController: retryDate reached, switch back to IDLE state"),this.state=gt.IDLE);break;case gt.ERROR:case gt.STOPPED:case gt.FRAG_LOADING:case gt.PARSING:case gt.PARSED:case gt.ENDED:}this._checkBuffer(),this._checkFragmentChanged()},t.prototype._doTickIdle=function(){var e=this.hls,t=e.config,r=this.media;if(this.levelLastLoaded!==undefined&&(r||!this.startFragRequested&&t.startFragPrefetch)){var n=void 0;n=this.loadedmetadata?r.currentTime:this.nextLoadPosition;var i=e.nextLoadLevel,o=this.levels[i];if(o){var a=o.bitrate,s=void 0;s=a?Math.max(8*t.maxBufferSize/a,t.maxBufferLength):t.maxBufferLength,s=Math.min(s,t.maxMaxBufferLength);var u=it.bufferInfo(this.mediaBuffer?this.mediaBuffer:r,n,t.maxBufferHole),c=u.len;if(!(c>=s)){Me.b.trace("buffer length of "+c.toFixed(3)+" is below max of "+s.toFixed(3)+". checking for more payload ..."),this.level=e.nextLoadLevel=i;var l=o.details;if(void 0===l||l.live&&this.levelLastLoaded!==i)return void(this.state=gt.WAITING_LEVEL);var f=this.fragPrevious;if(!l.live&&f&&!f.backtracked&&f.sn===l.endSN&&!u.nextStart){if(Math.min(r.duration,f.start+f.duration)-Math.max(u.end,f.start)<=Math.max(.2,f.duration)){var d={};return this.altAudio&&(d.type="video"),this.hls.trigger(Ie.a.BUFFER_EOS,d),void(this.state=gt.ENDED)}}this._fetchPayloadOrEos(n,u,l)}}}},t.prototype._fetchPayloadOrEos=function(e,t,r){var n=this.fragPrevious,i=this.level,o=r.fragments,a=o.length;if(0!==a){var s=o[0].start,u=o[a-1].start+o[a-1].duration,c=t.end,l=void 0;if(r.initSegment&&!r.initSegment.data)l=r.initSegment;else if(r.live){var f=this.config.initialLiveManifestSize;if(a<f)return void Me.b.warn("Can not start playback of a level, reason: not enough fragments "+a+" < "+f);if(null===(l=this._ensureFragmentAtLivePoint(r,c,s,u,n,o,a)))return}else c<s&&(l=o[0]);l||(l=this._findFragment(s,n,a,o,c,u,r)),l&&this._loadFragmentOrKey(l,i,r,e,c)}},t.prototype._ensureFragmentAtLivePoint=function(e,t,r,n,i,o,a){var s=this.hls.config,u=this.media,c=void 0,l=s.liveMaxLatencyDuration!==undefined?s.liveMaxLatencyDuration:s.liveMaxLatencyDurationCount*e.targetduration;if(t<Math.max(r-s.maxFragLookUpTolerance,n-l)){var f=this.liveSyncPosition=this.computeLivePosition(r,e);Me.b.log("buffer end: "+t.toFixed(3)+" is located too far from the end of live sliding playlist, reset currentTime to : "+f.toFixed(3)),t=f,u&&u.readyState&&u.duration>f&&(u.currentTime=f),this.nextLoadPosition=f}if(e.PTSKnown&&t>n&&u&&u.readyState)return null;if(this.startFragRequested&&!e.PTSKnown){if(i){var d=i.sn+1;if(d>=e.startSN&&d<=e.endSN){var h=o[d-e.startSN];i.cc===h.cc&&(c=h,Me.b.log("live playlist, switching playlist, load frag with next SN: "+c.sn))}c||(c=rt.search(o,function(e){return i.cc-e.cc}))&&Me.b.log("live playlist, switching playlist, load frag with same CC: "+c.sn)}c||(c=o[Math.min(a-1,Math.round(a/2))],Me.b.log("live playlist, switching playlist, unknown, load middle frag : "+c.sn))}return c},t.prototype._findFragment=function(e,t,r,n,i,o,a){var s=this.hls.config,u=void 0,c=void 0,l=s.maxFragLookUpTolerance,f=t?n[t.sn-n[0].sn+1]:undefined,d=function(e){var t=Math.min(l,e.duration+(e.deltaPTS?e.deltaPTS:0));return e.start+e.duration-t<=i?1:e.start-t>i&&e.start?-1:0};if(i<o?(i>o-l&&(l=0),c=f&&!d(f)?f:rt.search(n,d)):c=n[r-1],c){u=c;var h=u.sn-a.startSN,p=t&&u.level===t.level,y=n[h-1],g=n[h+1];if(t&&u.sn===t.sn)if(p&&!u.backtracked)if(u.sn<a.endSN){var m=t.deltaPTS;m&&m>s.maxBufferHole&&t.dropped&&h?(u=y,Me.b.warn("SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this"),t.loadCounter--):(u=g,Me.b.log("SN just loaded, load next one: "+u.sn))}else u=null;else u.backtracked&&(g&&g.backtracked?(Me.b.warn("Already backtracked from fragment "+g.sn+", will not backtrack to fragment "+u.sn+". Loading fragment "+g.sn),u=g):(Me.b.warn("Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe"),u.dropped=0,y?(y.loadCounter&&y.loadCounter--,u=y,u.backtracked=!0):h&&(u=null)))}return u},t.prototype._loadFragmentOrKey=function(e,t,r,n,i){var o=this.hls,a=o.config;if(!e.decryptdata||null==e.decryptdata.uri||null!=e.decryptdata.key){if(Me.b.log("Loading "+e.sn+" of ["+r.startSN+" ,"+r.endSN+"],level "+t+", currentTime:"+n.toFixed(3)+",bufferEnd:"+i.toFixed(3)),this.fragLoadIdx!==undefined?this.fragLoadIdx++:this.fragLoadIdx=0,e.loadCounter){e.loadCounter++;var s=a.fragLoadingLoopThreshold;if(e.loadCounter>s&&Math.abs(this.fragLoadIdx-e.loadIdx)<s)return void o.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.FRAG_LOOP_LOADING_ERROR,fatal:!1,frag:e})}else e.loadCounter=1;return e.loadIdx=this.fragLoadIdx,e.autoLevel=o.autoLevelEnabled,e.bitrateTest=this.bitrateTest,this.fragCurrent=e,this.startFragRequested=!0,isNaN(e.sn)||e.bitrateTest||(this.nextLoadPosition=e.start+e.duration),o.trigger(Ie.a.FRAG_LOADING,{frag:e}),this.demuxer||(this.demuxer=new dt(o,"main")),void(this.state=gt.FRAG_LOADING)}Me.b.log("Loading key for "+e.sn+" of ["+r.startSN+" ,"+r.endSN+"],level "+t),this.state=gt.KEY_LOADING,o.trigger(Ie.a.KEY_LOADING,{frag:e})},t.prototype.getBufferedFrag=function(e){return rt.search(this._bufferedFrags,function(t){return e<t.startPTS?-1:e>t.endPTS?1:0})},t.prototype.followingBufferedFrag=function(e){return e?this.getBufferedFrag(e.endPTS+.5):null},t.prototype._checkFragmentChanged=function(){var e,t,r=this.media;if(r&&r.readyState&&!1===r.seeking&&(t=r.currentTime,t>r.playbackRate*this.lastCurrentTime&&(this.lastCurrentTime=t),it.isBuffered(r,t)?e=this.getBufferedFrag(t):it.isBuffered(r,t+.1)&&(e=this.getBufferedFrag(t+.1)),e)){var n=e;if(n!==this.fragPlaying){this.hls.trigger(Ie.a.FRAG_CHANGED,{frag:n});var i=n.level;this.fragPlaying&&this.fragPlaying.level===i||this.hls.trigger(Ie.a.LEVEL_SWITCHED,{level:i}),this.fragPlaying=n}}},t.prototype.immediateLevelSwitch=function(){if(Me.b.log("immediateLevelSwitch"),!this.immediateSwitch){this.immediateSwitch=!0;var e=this.media,t=void 0;e?(t=e.paused,e.pause()):t=!0,this.previouslyPaused=t}var r=this.fragCurrent;r&&r.loader&&r.loader.abort(),this.fragCurrent=null,this.fragLoadIdx!==undefined&&(this.fragLoadIdx+=2*this.config.fragLoadingLoopThreshold),this.flushMainBuffer(0,Number.POSITIVE_INFINITY)},t.prototype.immediateLevelSwitchEnd=function(){var e=this.media;e&&e.buffered.length&&(this.immediateSwitch=!1,it.isBuffered(e,e.currentTime)&&(e.currentTime-=1e-4),this.previouslyPaused||e.play())},t.prototype.nextLevelSwitch=function(){var e=this.media;if(e&&e.readyState){var t=void 0,r=void 0,n=void 0;if(this.fragLoadIdx!==undefined&&(this.fragLoadIdx+=2*this.config.fragLoadingLoopThreshold),r=this.getBufferedFrag(e.currentTime),r&&r.startPTS>1&&this.flushMainBuffer(0,r.startPTS-1),e.paused)t=0;else{var i=this.hls.nextLoadLevel,o=this.levels[i],a=this.fragLastKbps;t=a&&this.fragCurrent?this.fragCurrent.duration*o.bitrate/(1e3*a)+1:0}if((n=this.getBufferedFrag(e.currentTime+t))&&(n=this.followingBufferedFrag(n))){var s=this.fragCurrent;s&&s.loader&&s.loader.abort(),this.fragCurrent=null,this.flushMainBuffer(n.maxStartPTS,Number.POSITIVE_INFINITY)}}},t.prototype.flushMainBuffer=function(e,t){this.state=gt.BUFFER_FLUSHING;var r={startOffset:e,endOffset:t};this.altAudio&&(r.type="video"),this.hls.trigger(Ie.a.BUFFER_FLUSHING,r)},t.prototype.onMediaAttached=function(e){var t=this.media=this.mediaBuffer=e.media;this.onvseeking=this.onMediaSeeking.bind(this),this.onvseeked=this.onMediaSeeked.bind(this),this.onvended=this.onMediaEnded.bind(this),t.addEventListener("seeking",this.onvseeking),t.addEventListener("seeked",this.onvseeked),t.addEventListener("ended",this.onvended);var r=this.config
;this.levels&&r.autoStartLoad&&this.hls.startLoad(r.startPosition)},t.prototype.onMediaDetaching=function(){var e=this.media;e&&e.ended&&(Me.b.log("MSE detaching and video ended, reset startPosition"),this.startPosition=this.lastCurrentTime=0);var t=this.levels;t&&t.forEach(function(e){e.details&&e.details.fragments.forEach(function(e){e.loadCounter=undefined,e.backtracked=undefined})}),e&&(e.removeEventListener("seeking",this.onvseeking),e.removeEventListener("seeked",this.onvseeked),e.removeEventListener("ended",this.onvended),this.onvseeking=this.onvseeked=this.onvended=null),this.media=this.mediaBuffer=null,this.loadedmetadata=!1,this.stopLoad()},t.prototype.onMediaSeeking=function(){var e=this.media,t=e?e.currentTime:undefined,r=this.config;isNaN(t)||Me.b.log("media seeking to "+t.toFixed(3));var n=this.mediaBuffer?this.mediaBuffer:e,i=it.bufferInfo(n,t,this.config.maxBufferHole);if(this.state===gt.FRAG_LOADING){var o=this.fragCurrent;if(0===i.len&&o){var a=r.maxFragLookUpTolerance,s=o.start-a,u=o.start+o.duration+a;t<s||t>u?(o.loader&&(Me.b.log("seeking outside of buffer while fragment load in progress, cancel fragment load"),o.loader.abort()),this.fragCurrent=null,this.fragPrevious=null,this.state=gt.IDLE):Me.b.log("seeking outside of buffer but within currently loaded fragment range")}}else this.state===gt.ENDED&&(0===i.len&&(this.fragPrevious=0),this.state=gt.IDLE);e&&(this.lastCurrentTime=t),this.state!==gt.FRAG_LOADING&&this.fragLoadIdx!==undefined&&(this.fragLoadIdx+=2*r.fragLoadingLoopThreshold),this.loadedmetadata||(this.nextLoadPosition=this.startPosition=t),this.tick()},t.prototype.onMediaSeeked=function(){var e=this.media,t=e?e.currentTime:undefined;isNaN(t)||Me.b.log("media seeked to "+t.toFixed(3)),this.tick()},t.prototype.onMediaEnded=function(){Me.b.log("media ended"),this.startPosition=this.lastCurrentTime=0},t.prototype.onManifestLoading=function(){Me.b.log("trigger BUFFER_RESET"),this.hls.trigger(Ie.a.BUFFER_RESET),this._bufferedFrags=[],this.stalled=!1,this.startPosition=this.lastCurrentTime=0},t.prototype.onManifestParsed=function(e){var t,r=!1,n=!1;e.levels.forEach(function(e){(t=e.audioCodec)&&(-1!==t.indexOf("mp4a.40.2")&&(r=!0),-1!==t.indexOf("mp4a.40.5")&&(n=!0))}),this.audioCodecSwitch=r&&n,this.audioCodecSwitch&&Me.b.log("both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"),this.levels=e.levels,this.startFragRequested=!1;var i=this.config;(i.autoStartLoad||this.forceStartLoad)&&this.hls.startLoad(i.startPosition)},t.prototype.onLevelLoaded=function(e){var t=e.details,r=e.level,n=this.levels[this.levelLastLoaded],i=this.levels[r],o=t.totalduration,a=0;if(Me.b.log("level "+r+" loaded ["+t.startSN+","+t.endSN+"],duration:"+o),t.live){var s=i.details;s&&t.fragments.length>0?(w(s,t),a=t.fragments[0].start,this.liveSyncPosition=this.computeLivePosition(a,s),t.PTSKnown&&!isNaN(a)?Me.b.log("live playlist sliding:"+a.toFixed(3)):(Me.b.log("live playlist - outdated PTS, unknown sliding"),x(this.fragPrevious,n,t))):(Me.b.log("live playlist - first load, unknown sliding"),t.PTSKnown=!1,x(this.fragPrevious,n,t))}else t.PTSKnown=!1;if(i.details=t,this.levelLastLoaded=r,this.hls.trigger(Ie.a.LEVEL_UPDATED,{details:t,level:r}),!1===this.startFragRequested){if(-1===this.startPosition||-1===this.lastCurrentTime){var u=t.startTimeOffset;isNaN(u)?t.live?(this.startPosition=this.computeLivePosition(a,t),Me.b.log("configure startPosition to "+this.startPosition)):this.startPosition=0:(u<0&&(Me.b.log("negative start time offset "+u+", count from end of last fragment"),u=a+o+u),Me.b.log("start time offset found in playlist, adjust startPosition to "+u),this.startPosition=u),this.lastCurrentTime=this.startPosition}this.nextLoadPosition=this.startPosition}this.state===gt.WAITING_LEVEL&&(this.state=gt.IDLE),this.tick()},t.prototype.onKeyLoaded=function(){this.state===gt.KEY_LOADING&&(this.state=gt.IDLE,this.tick())},t.prototype.onFragLoaded=function(e){var t=this.fragCurrent,r=e.frag;if(this.state===gt.FRAG_LOADING&&t&&"main"===r.type&&r.level===t.level&&r.sn===t.sn){var n=e.stats,i=this.levels[t.level],o=i.details;if(Me.b.log("Loaded  "+t.sn+" of ["+o.startSN+" ,"+o.endSN+"],level "+t.level),this.bitrateTest=!1,this.stats=n,!0===r.bitrateTest&&this.hls.nextLoadLevel)this.state=gt.IDLE,this.startFragRequested=!1,n.tparsed=n.tbuffered=performance.now(),this.hls.trigger(Ie.a.FRAG_BUFFERED,{stats:n,frag:t,id:"main"}),this.tick();else if("initSegment"===r.sn)this.state=gt.IDLE,n.tparsed=n.tbuffered=performance.now(),o.initSegment.data=e.payload,this.hls.trigger(Ie.a.FRAG_BUFFERED,{stats:n,frag:t,id:"main"}),this.tick();else{this.state=gt.PARSING;var a=o.totalduration,s=t.level,u=t.sn,c=this.config.defaultAudioCodec||i.audioCodec;this.audioCodecSwap&&(Me.b.log("swapping playlist audio codec"),c===undefined&&(c=this.lastAudioCodec),c&&(c=-1!==c.indexOf("mp4a.40.5")?"mp4a.40.2":"mp4a.40.5")),this.pendingBuffering=!0,this.appended=!1,Me.b.log("Parsing "+u+" of ["+o.startSN+" ,"+o.endSN+"],level "+s+", cc "+t.cc);var l=this.demuxer;l||(l=this.demuxer=new dt(this.hls,"main"));var f=this.media,d=f&&f.seeking,h=!d&&(o.PTSKnown||!o.live),p=o.initSegment?o.initSegment.data:[];l.push(e.payload,p,c,i.videoCodec,t,a,h,undefined)}}this.fragLoadError=0},t.prototype.onFragParsingInitSegment=function(e){var t=this.fragCurrent,r=e.frag;if(t&&"main"===e.id&&r.sn===t.sn&&r.level===t.level&&this.state===gt.PARSING){var n,i,o=e.tracks;if(o.audio&&this.altAudio&&delete o.audio,i=o.audio){var a=this.levels[this.level].audioCodec,s=navigator.userAgent.toLowerCase();a&&this.audioCodecSwap&&(Me.b.log("swapping playlist audio codec"),a=-1!==a.indexOf("mp4a.40.5")?"mp4a.40.2":"mp4a.40.5"),this.audioCodecSwitch&&1!==i.metadata.channelCount&&-1===s.indexOf("firefox")&&(a="mp4a.40.5"),-1!==s.indexOf("android")&&"audio/mpeg"!==i.container&&(a="mp4a.40.2",Me.b.log("Android: force audio codec to "+a)),i.levelCodec=a,i.id=e.id}i=o.video,i&&(i.levelCodec=this.levels[this.level].videoCodec,i.id=e.id),this.hls.trigger(Ie.a.BUFFER_CODECS,o);for(n in o){i=o[n],Me.b.log("main track:"+n+",container:"+i.container+",codecs[level/parsed]=["+i.levelCodec+"/"+i.codec+"]");var u=i.initSegment;u&&(this.appended=!0,this.pendingBuffering=!0,this.hls.trigger(Ie.a.BUFFER_APPENDING,{type:n,data:u,parent:"main",content:"initSegment"}))}this.tick()}},t.prototype.onFragParsingData=function(e){var t=this,r=this.fragCurrent,n=e.frag;if(r&&"main"===e.id&&n.sn===r.sn&&n.level===r.level&&("audio"!==e.type||!this.altAudio)&&this.state===gt.PARSING){var i=this.levels[this.level],o=r;if(isNaN(e.endPTS)&&(e.endPTS=e.startPTS+r.duration,e.endDTS=e.startDTS+r.duration),Me.b.log("Parsed "+e.type+",PTS:["+e.startPTS.toFixed(3)+","+e.endPTS.toFixed(3)+"],DTS:["+e.startDTS.toFixed(3)+"/"+e.endDTS.toFixed(3)+"],nb:"+e.nb+",dropped:"+(e.dropped||0)),"video"===e.type)if(o.dropped=e.dropped,o.dropped)if(o.backtracked)Me.b.warn("Already backtracked on this fragment, appending with the gap");else{var a=i.details;if(!a||o.sn!==a.startSN)return Me.b.warn("missing video frame(s), backtracking fragment"),o.backtracked=!0,this.nextLoadPosition=e.startPTS,this.state=gt.IDLE,this.fragPrevious=o,void this.tick();Me.b.warn("missing video frame(s) on first frag, appending with gap")}else o.backtracked=!1;var s=$(i.details,o,e.startPTS,e.endPTS,e.startDTS,e.endDTS),u=this.hls;u.trigger(Ie.a.LEVEL_PTS_UPDATED,{details:i.details,level:this.level,drift:s,type:e.type,start:e.startPTS,end:e.endPTS}),[e.data1,e.data2].forEach(function(r){r&&r.length&&t.state===gt.PARSING&&(t.appended=!0,t.pendingBuffering=!0,u.trigger(Ie.a.BUFFER_APPENDING,{type:e.type,data:r,parent:"main",content:"data"}))}),this.tick()}},t.prototype.onFragParsed=function(e){var t=this.fragCurrent,r=e.frag;t&&"main"===e.id&&r.sn===t.sn&&r.level===t.level&&this.state===gt.PARSING&&(this.stats.tparsed=performance.now(),this.state=gt.PARSED,this._checkAppendedParsed())},t.prototype.onAudioTrackSwitching=function(e){var t=!!e.url,r=e.id;if(!t){if(this.mediaBuffer!==this.media){Me.b.log("switching on main audio, use media.buffered to schedule main fragment loading"),this.mediaBuffer=this.media;var n=this.fragCurrent;n.loader&&(Me.b.log("switching to main audio track, cancel main fragment load"),n.loader.abort()),this.fragCurrent=null,this.fragPrevious=null,this.demuxer&&(this.demuxer.destroy(),this.demuxer=null),this.state=gt.IDLE}var i=this.hls;i.trigger(Ie.a.BUFFER_FLUSHING,{startOffset:0,endOffset:Number.POSITIVE_INFINITY,type:"audio"}),i.trigger(Ie.a.AUDIO_TRACK_SWITCHED,{id:r}),this.altAudio=!1}},t.prototype.onAudioTrackSwitched=function(e){var t=e.id,r=!!this.hls.audioTracks[t].url;if(r){var n=this.videoBuffer;n&&this.mediaBuffer!==n&&(Me.b.log("switching on alternate audio, use video.buffered to schedule main fragment loading"),this.mediaBuffer=n)}this.altAudio=r,this.tick()},t.prototype.onBufferCreated=function(e){var t=e.tracks,r=void 0,n=void 0,i=!1;for(var o in t){var a=t[o];"main"===a.id?(n=o,r=a,"video"===o&&(this.videoBuffer=t[o].buffer)):i=!0}i&&r?(Me.b.log("alternate track found, use "+n+".buffered to schedule main fragment loading"),this.mediaBuffer=r.buffer):this.mediaBuffer=this.media},t.prototype.onBufferAppended=function(e){if("main"===e.parent){var t=this.state;t!==gt.PARSING&&t!==gt.PARSED||(this.pendingBuffering=e.pending>0,this._checkAppendedParsed())}},t.prototype._checkAppendedParsed=function(){if(!(this.state!==gt.PARSED||this.appended&&this.pendingBuffering)){var e=this.fragCurrent;if(e){var t=this.mediaBuffer?this.mediaBuffer:this.media;Me.b.log("main buffered : "+pt.toString(t.buffered));var r=this._bufferedFrags.filter(function(e){return it.isBuffered(t,(e.startPTS+e.endPTS)/2)});r.push(e),this._bufferedFrags=r.sort(function(e,t){return e.startPTS-t.startPTS}),this.fragPrevious=e;var n=this.stats;n.tbuffered=performance.now(),this.fragLastKbps=Math.round(8*n.total/(n.tbuffered-n.tfirst)),this.hls.trigger(Ie.a.FRAG_BUFFERED,{stats:n,frag:e,id:"main"}),this.state=gt.IDLE}this.tick()}},t.prototype.onError=function(e){var t=e.frag||this.fragCurrent;if(!t||"main"===t.type){var r=!!this.media&&it.isBuffered(this.media,this.media.currentTime)&&it.isBuffered(this.media,this.media.currentTime+.5);switch(e.details){case Pe.a.FRAG_LOAD_ERROR:case Pe.a.FRAG_LOAD_TIMEOUT:case Pe.a.KEY_LOAD_ERROR:case Pe.a.KEY_LOAD_TIMEOUT:if(!e.fatal)if(this.fragLoadError+1<=this.config.fragLoadingMaxRetry){var n=Math.min(Math.pow(2,this.fragLoadError)*this.config.fragLoadingRetryDelay,this.config.fragLoadingMaxRetryTimeout);t.loadCounter=0,Me.b.warn("mediaController: frag loading failed, retry in "+n+" ms"),this.retryDate=performance.now()+n,this.loadedmetadata||(this.startFragRequested=!1,this.nextLoadPosition=this.startPosition),this.fragLoadError++,this.state=gt.FRAG_LOADING_WAITING_RETRY}else Me.b.error("mediaController: "+e.details+" reaches max retry, redispatch as fatal ..."),e.fatal=!0,this.state=gt.ERROR;break;case Pe.a.FRAG_LOOP_LOADING_ERROR:e.fatal||(r?(this._reduceMaxBufferLength(t.duration),this.state=gt.IDLE):t.autoLevel&&0!==t.level||(e.fatal=!0,this.state=gt.ERROR));break;case Pe.a.LEVEL_LOAD_ERROR:case Pe.a.LEVEL_LOAD_TIMEOUT:this.state!==gt.ERROR&&(e.fatal?(this.state=gt.ERROR,Me.b.warn("streamController: "+e.details+",switch to "+this.state+" state ...")):e.levelRetry||this.state!==gt.WAITING_LEVEL||(this.state=gt.IDLE));break;case Pe.a.BUFFER_FULL_ERROR:"main"!==e.parent||this.state!==gt.PARSING&&this.state!==gt.PARSED||(r?(this._reduceMaxBufferLength(this.config.maxBufferLength),this.state=gt.IDLE):(Me.b.warn("buffer full error also media.currentTime is not buffered, flush everything"),this.fragCurrent=null,this.flushMainBuffer(0,Number.POSITIVE_INFINITY)))}}},t.prototype._reduceMaxBufferLength=function(e){var t=this.config;t.maxMaxBufferLength>=e&&(t.maxMaxBufferLength/=2,Me.b.warn("main:reduce max buffer length to "+t.maxMaxBufferLength+"s"),this.fragLoadIdx!==undefined&&(this.fragLoadIdx+=2*t.fragLoadingLoopThreshold))},t.prototype._checkBuffer=function(){var e=this.media,t=this.config;if(e&&e.readyState){var r=e.currentTime,n=this.mediaBuffer?this.mediaBuffer:e,i=n.buffered;if(!this.loadedmetadata&&i.length){this.loadedmetadata=!0;var o=e.seeking?r:this.startPosition,a=it.isBuffered(n,o),s=i.start(0),u=!a&&Math.abs(o-s)<t.maxSeekHole;(r!==o||u)&&(Me.b.log("target start position:"+o),u&&(o=s,Me.b.log("target start position not buffered, seek to buffered.start(0) "+o)),Me.b.log("adjust currentTime from "+r+" to "+o),e.currentTime=o)}else if(this.immediateSwitch)this.immediateLevelSwitchEnd();else{var c=it.bufferInfo(e,r,0),l=!(e.paused||e.ended||0===e.buffered.length),f=r!==this.lastCurrentTime;if(f)this.stallReported&&(Me.b.warn("playback not stuck anymore @"+r+", after "+Math.round(performance.now()-this.stalled)+"ms"),this.stallReported=!1),this.stalled=undefined,this.nudgeRetry=0;else if(l){var d=performance.now(),h=this.hls;if(this.stalled){var p=d-this.stalled,y=c.len,g=this.nudgeRetry||0;if(y<=.5&&p>1e3*t.lowBufferWatchdogPeriod){this.stallReported||(this.stallReported=!0,Me.b.warn("playback stalling in low buffer @"+r),h.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.BUFFER_STALLED_ERROR,fatal:!1,buffer:y}));var m=c.nextStart,_=m-r;if(m&&_<t.maxSeekHole&&_>0){this.nudgeRetry=++g;var v=g*t.nudgeOffset;Me.b.log("adjust currentTime from "+e.currentTime+" to next buffered @ "+m+" + nudge "+v),e.currentTime=m+v,this.stalled=undefined,h.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.BUFFER_SEEK_OVER_HOLE,fatal:!1,hole:m+v-r})}}else if(y>.5&&p>1e3*t.highBufferWatchdogPeriod)if(this.stallReported||(this.stallReported=!0,Me.b.warn("playback stalling in high buffer @"+r),h.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.BUFFER_STALLED_ERROR,fatal:!1,buffer:y})),this.stalled=undefined,this.nudgeRetry=++g,g<t.nudgeMaxRetry){var b=e.currentTime,$=b+g*t.nudgeOffset;Me.b.log("adjust currentTime from "+b+" to "+$),e.currentTime=$,h.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.BUFFER_NUDGE_ON_STALL,fatal:!1})}else Me.b.error("still stuck in high buffer @"+r+" after "+t.nudgeMaxRetry+", raise fatal error"),h.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.BUFFER_STALLED_ERROR,fatal:!0})}else this.stalled=d,this.stallReported=!1}}}},t.prototype.onFragLoadEmergencyAborted=function(){this.state=gt.IDLE,this.loadedmetadata||(this.startFragRequested=!1,this.nextLoadPosition=this.startPosition),this.tick()},t.prototype.onBufferFlushed=function(){var e=this.mediaBuffer?this.mediaBuffer:this.media;this._bufferedFrags=this._bufferedFrags.filter(function(t){return it.isBuffered(e,(t.startPTS+t.endPTS)/2)}),this.fragLoadIdx!==undefined&&(this.fragLoadIdx+=2*this.config.fragLoadingLoopThreshold),this.state=gt.IDLE,this.fragPrevious=null},t.prototype.swapAudioCodec=function(){this.audioCodecSwap=!this.audioCodecSwap},t.prototype.computeLivePosition=function(e,t){var r=this.config.liveSyncDuration!==undefined?this.config.liveSyncDuration:this.config.liveSyncDurationCount*t.targetduration;return e+Math.max(0,t.totalduration-r)},yt(t,[{key:"state",set:function(e){if(this.state!==e){var t=this.state;this._state=e,Me.b.log("main stream:"+t+"->"+e),this.hls.trigger(Ie.a.STREAM_STATE_TRANSITION,{previousState:t,nextState:e})}},get:function(){return this._state}},{key:"currentLevel",get:function(){var e=this.media;if(e){var t=this.getBufferedFrag(e.currentTime);if(t)return t.level}return-1}},{key:"nextBufferedFrag",get:function(){var e=this.media;return e?this.followingBufferedFrag(this.getBufferedFrag(e.currentTime)):null}},{key:"nextLevel",get:function(){var e=this.nextBufferedFrag;return e?e.level:-1}},{key:"liveSyncPosition",get:function(){return this._liveSyncPosition},set:function(e){this._liveSyncPosition=e}}]),t}(je),_t=mt,vt=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),bt=function(e){function t(r){P(this,t);var n=M(this,e.call(this,r,Ie.a.MANIFEST_LOADED,Ie.a.LEVEL_LOADED,Ie.a.FRAG_LOADED,Ie.a.ERROR));return n._manualLevel=-1,n.timer=null,n}return R(t,e),t.prototype.destroy=function(){this.cleanTimer(),this._manualLevel=-1},t.prototype.cleanTimer=function(){null!==this.timer&&(clearTimeout(this.timer),this.timer=null)},t.prototype.startLoad=function(){var e=this._levels;this.canload=!0,this.levelRetryCount=0,e&&e.forEach(function(e){e.loadError=0;var t=e.details;t&&t.live&&(e.details=undefined)}),this.timer&&this.tick()},t.prototype.stopLoad=function(){this.canload=!1},t.prototype.onManifestLoaded=function(e){var t=[],r=void 0,n={},i=null,o=!1,a=!1,u=/chrome|firefox/.test(navigator.userAgent.toLowerCase()),c=[];if(e.levels.forEach(function(e){e.loadError=0,e.fragmentError=!1,o=o||!!e.videoCodec,a=a||!!e.audioCodec||!(!e.attrs||!e.attrs.AUDIO),!0===u&&e.audioCodec&&-1!==e.audioCodec.indexOf("mp4a.40.34")&&(e.audioCodec=undefined),i=n[e.bitrate],i===undefined?(e.url=[e.url],e.urlId=0,n[e.bitrate]=e,t.push(e)):i.url.push(e.url)}),!0===o&&!0===a&&(t=t.filter(function(e){return!!e.videoCodec})),t=t.filter(function(e){var t=e.audioCodec,r=e.videoCodec;return(!t||s(t))&&(!r||s(r))}),e.audioTracks&&(c=e.audioTracks.filter(function(e){return!e.audioCodec||s(e.audioCodec,"audio")})),t.length){r=t[0].bitrate,t.sort(function(e,t){return e.bitrate-t.bitrate}),this._levels=t;for(var l=0;l<t.length;l++)if(t[l].bitrate===r){this._firstLevel=l,Me.b.log("manifest loaded,"+t.length+" level(s) found, first bitrate:"+r);break}this.hls.trigger(Ie.a.MANIFEST_PARSED,{levels:t,audioTracks:c,firstLevel:this._firstLevel,stats:e.stats,audio:a,video:o,altAudio:c.length>0})}else this.hls.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.MANIFEST_INCOMPATIBLE_CODECS_ERROR,fatal:!0,url:this.hls.url,reason:"no level with compatible codecs found in manifest"})},t.prototype.setLevelInternal=function(e){var t=this._levels,r=this.hls;if(e>=0&&e<t.length){if(this.cleanTimer(),this._level!==e){Me.b.log("switching to level "+e),this._level=e;var n=t[e];n.level=e,r.trigger(Ie.a.LEVEL_SWITCH,n),r.trigger(Ie.a.LEVEL_SWITCHING,n)}var i=t[e],o=i.details;if(!o||!0===o.live){var a=i.urlId;r.trigger(Ie.a.LEVEL_LOADING,{url:i.url[a],level:e,id:a})}}else r.trigger(Ie.a.ERROR,{type:Pe.b.OTHER_ERROR,details:Pe.a.LEVEL_SWITCH_ERROR,level:e,fatal:!1,reason:"invalid level idx"})},t.prototype.onError=function(e){var t=this;if(!0===e.fatal)return void(e.type===Pe.b.NETWORK_ERROR&&this.cleanTimer());var r=e.details,n=!1,i=!1,o=void 0,a=void 0,s=this.hls.config;switch(r){case Pe.a.FRAG_LOAD_ERROR:case Pe.a.FRAG_LOAD_TIMEOUT:case Pe.a.FRAG_LOOP_LOADING_ERROR:case Pe.a.KEY_LOAD_ERROR:case Pe.a.KEY_LOAD_TIMEOUT:o=e.frag.level,i=!0;break;case Pe.a.LEVEL_LOAD_ERROR:case Pe.a.LEVEL_LOAD_TIMEOUT:o=e.context.level,n=!0;break;case Pe.a.REMUX_ALLOC_ERROR:o=e.level}if(o!==undefined)if(a=this._levels[o],a.loadError++,a.fragmentError=i,!0===i){var u=a.url.length;u>1&&a.loadError<u?(a.urlId=(a.urlId+1)%u,a.details=undefined,Me.b.warn("level controller,"+r+" for level "+o+": switching to redundant stream id "+a.urlId)):-1===this._manualLevel&&0!==o?(Me.b.warn("level controller,"+r+": switch-down for next fragment"),this.hls.nextAutoLevel=o-1):(Me.b.warn("level controller, "+r+": reload a fragment"),this._level=undefined)}else if(!0===n)if(this.levelRetryCount+1<=s.levelLoadingMaxRetry){var c=Math.min(Math.pow(2,this.levelRetryCount)*s.levelLoadingRetryDelay,s.levelLoadingMaxRetryTimeout);this.timer=setTimeout(function(){return t.tick()},c),e.levelRetry=!0,this.levelRetryCount++,Me.b.warn("level controller,"+r+", retry in "+c+" ms, current retry count is "+this.levelRetryCount)}else Me.b.error("cannot recover "+r+" error"),this._level=undefined,this.cleanTimer(),e.fatal=!0},t.prototype.onFragLoaded=function(e){var t=e.frag;if(t!==undefined&&"main"===t.type){var r=this._levels[t.level];r!==undefined&&(r.fragmentError=!1,r.loadError=0,this.levelRetryCount=0)}},t.prototype.onLevelLoaded=function(e){var t=this,r=e.level;if(r===this._level){var n=this._levels[r];!1===n.fragmentError&&(n.loadError=0,this.levelRetryCount=0);var i=e.details;if(i.live){var o=1e3*(i.averagetargetduration?i.averagetargetduration:i.targetduration),a=n.details;a&&i.endSN===a.endSN&&(o/=2,Me.b.log("same live playlist, reload twice faster")),o-=performance.now()-e.stats.trequest,o=Math.max(1e3,Math.round(o)),Me.b.log("live playlist, reload in "+o+" ms"),this.timer=setTimeout(function(){return t.tick()},o)}else this.cleanTimer()}},t.prototype.tick=function(){var e=this._level;if(e!==undefined&&this.canload){var t=this._levels[e];if(t&&t.url){var r=t.urlId;this.hls.trigger(Ie.a.LEVEL_LOADING,{url:t.url[r],level:e,id:r})}}},vt(t,[{key:"levels",get:function(){return this._levels}},{key:"level",get:function(){return this._level},set:function(e){var t=this._levels;t&&(e=Math.min(e,t.length-1),this._level===e&&t[e].details!==undefined||this.setLevelInternal(e))}},{key:"manualLevel",get:function(){return this._manualLevel},set:function(e){this._manualLevel=e,this._startLevel===undefined&&(this._startLevel=e),-1!==e&&(this.level=e)}},{key:"firstLevel",get:function(){return this._firstLevel},set:function(e){this._firstLevel=e}},{key:"startLevel",get:function(){if(this._startLevel===undefined){var e=this.hls.config.startLevel;return e!==undefined?e:this._firstLevel}return this._startLevel},set:function(e){this._startLevel=e}},{key:"nextLoadLevel",get:function(){return-1!==this._manualLevel?this._manualLevel:this.hls.nextAutoLevel},set:function(e){this.level=e,-1===this._manualLevel&&(this.hls.nextAutoLevel=e)}}]),t}(je),$t=bt,wt=n(3),Et=function(e){function t(r){C(this,t);var n=j(this,e.call(this,r,Ie.a.MEDIA_ATTACHED,Ie.a.MEDIA_DETACHING,Ie.a.FRAG_PARSING_METADATA));return n.id3Track=undefined,n.media=undefined,n}return L(t,e),t.prototype.destroy=function(){je.prototype.destroy.call(this)},t.prototype.onMediaAttached=function(e){this.media=e.media,this.media},t.prototype.onMediaDetaching=function(){this.media=undefined},t.prototype.onFragParsingMetadata=function(e){var t=e.frag,r=e.samples;this.id3Track||(this.id3Track=this.media.addTextTrack("metadata","id3"),this.id3Track.mode="hidden");for(var n=window.WebKitDataCue||window.VTTCue||window.TextTrackCue,i=0;i<r.length;i++){var o=wt.a.getID3Frames(r[i].data);if(o){var a=r[i].pts,s=i<r.length-1?r[i+1].pts:t.endPTS;a===s&&(s+=1e-4);for(var u=0;u<o.length;u++){var c=o[u];if(!wt.a.isTimeStampFrame(c)){var l=new n(a,s,"");l.value=c,this.id3Track.addCue(l)}}}}},t}(je),St=Et,Ot=function(){function e(t){N(this,e),this.alpha_=t?Math.exp(Math.log(.5)/t):0,this.estimate_=0,this.totalWeight_=0}return e.prototype.sample=function(e,t){var r=Math.pow(this.alpha_,e);this.estimate_=t*(1-r)+r*this.estimate_,this.totalWeight_+=e},e.prototype.getTotalWeight=function(){return this.totalWeight_},e.prototype.getEstimate=function(){if(this.alpha_){var e=1-Math.pow(this.alpha_,this.totalWeight_);return this.estimate_/e}return this.estimate_},e}(),Tt=Ot,At=function(){function e(t,r,n,i){F(this,e),this.hls=t,this.defaultEstimate_=i,this.minWeight_=.001,this.minDelayMs_=50,this.slow_=new Tt(r),this.fast_=new Tt(n)}return e.prototype.sample=function(e,t){e=Math.max(e,this.minDelayMs_);var r=8e3*t/e,n=e/1e3;this.fast_.sample(n,r),this.slow_.sample(n,r)},e.prototype.canEstimate=function(){var e=this.fast_;return e&&e.getTotalWeight()>=this.minWeight_},e.prototype.getEstimate=function(){return this.canEstimate()?Math.min(this.fast_.getEstimate(),this.slow_.getEstimate()):this.defaultEstimate_},e.prototype.destroy=function(){},e}(),xt=At,kt=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),Dt=function(e){function t(r){B(this,t);var n=U(this,e.call(this,r,Ie.a.FRAG_LOADING,Ie.a.FRAG_LOADED,Ie.a.FRAG_BUFFERED,Ie.a.ERROR));return n.lastLoadedFragLevel=0,n._nextAutoLevel=-1,n.hls=r,n.timer=null,n._bwEstimator=null,n.onCheck=n._abandonRulesCheck.bind(n),n}return z(t,e),t.prototype.destroy=function(){this.clearTimer(),je.prototype.destroy.call(this)},t.prototype.onFragLoading=function(e){var t=e.frag;if("main"===t.type){if(this.timer||(this.timer=setInterval(this.onCheck,100)),!this._bwEstimator){var r=this.hls,n=e.frag.level,i=r.levels[n].details.live,o=r.config,a=void 0,s=void 0;i?(a=o.abrEwmaFastLive,s=o.abrEwmaSlowLive):(a=o.abrEwmaFastVoD,s=o.abrEwmaSlowVoD),this._bwEstimator=new xt(r,s,a,o.abrEwmaDefaultEstimate)}this.fragCurrent=t}},t.prototype._abandonRulesCheck=function(){var e=this.hls,t=e.media,r=this.fragCurrent,n=r.loader,i=e.minAutoLevel;if(!n||n.stats&&n.stats.aborted)return Me.b.warn("frag loader destroy or aborted, disarm abandonRules"),void this.clearTimer();var o=n.stats;if(t&&o&&(!t.paused&&0!==t.playbackRate||!t.readyState)&&r.autoLevel&&r.level){var a=performance.now()-o.trequest,s=Math.abs(t.playbackRate);if(a>500*r.duration/s){var u=e.levels,c=Math.max(1,o.bw?o.bw/8:1e3*o.loaded/a),l=u[r.level],f=l.realBitrate?Math.max(l.realBitrate,l.bitrate):l.bitrate,d=o.total?o.total:Math.max(o.loaded,Math.round(r.duration*f/8)),h=t.currentTime,p=(d-o.loaded)/c,y=(it.bufferInfo(t,h,e.config.maxBufferHole).end-h)/s;if(y<2*r.duration/s&&p>y){var g=void 0,m=void 0;for(m=r.level-1;m>i;m--){var _=u[m].realBitrate?Math.max(u[m].realBitrate,u[m].bitrate):u[m].bitrate;if((g=r.duration*_/(6.4*c))<y)break}g<p&&(Me.b.warn("loading too slow, abort fragment loading and switch to level "+m+":fragLoadedDelay["+m+"]<fragLoadedDelay["+(r.level-1)+"];bufferStarvationDelay:"+g.toFixed(1)+"<"+p.toFixed(1)+":"+y.toFixed(1)),e.nextLoadLevel=m,this._bwEstimator.sample(a,o.loaded),n.abort(),this.clearTimer(),e.trigger(Ie.a.FRAG_LOAD_EMERGENCY_ABORTED,{frag:r,stats:o}))}}}},t.prototype.onFragLoaded=function(e){var t=e.frag;if("main"===t.type&&!isNaN(t.sn)){if(this.clearTimer(),this.lastLoadedFragLevel=t.level,this._nextAutoLevel=-1,this.hls.config.abrMaxWithRealBitrate){var r=this.hls.levels[t.level],n=(r.loaded?r.loaded.bytes:0)+e.stats.loaded,i=(r.loaded?r.loaded.duration:0)+e.frag.duration;r.loaded={bytes:n,duration:i},r.realBitrate=Math.round(8*n/i)}if(e.frag.bitrateTest){var o=e.stats;o.tparsed=o.tbuffered=o.tload,this.onFragBuffered(e)}}},t.prototype.onFragBuffered=function(e){var t=e.stats,r=e.frag;if(!(!0===t.aborted||1!==r.loadCounter||"main"!==r.type||isNaN(r.sn)||r.bitrateTest&&t.tload!==t.tbuffered)){var n=t.tparsed-t.trequest;Me.b.log("latency/loading/parsing/append/kbps:"+Math.round(t.tfirst-t.trequest)+"/"+Math.round(t.tload-t.tfirst)+"/"+Math.round(t.tparsed-t.tload)+"/"+Math.round(t.tbuffered-t.tparsed)+"/"+Math.round(8*t.loaded/(t.tbuffered-t.trequest))),this._bwEstimator.sample(n,t.loaded),t.bwEstimate=this._bwEstimator.getEstimate(),r.bitrateTest?this.bitrateTestDelay=n/1e3:this.bitrateTestDelay=0}},t.prototype.onError=function(e){switch(e.details){case Pe.a.FRAG_LOAD_ERROR:case Pe.a.FRAG_LOAD_TIMEOUT:this.clearTimer()}},t.prototype.clearTimer=function(){clearInterval(this.timer),this.timer=null},t.prototype._findBestLevel=function(e,t,r,n,i,o,a,s,u){for(var c=i;c>=n;c--){var l=u[c],f=l.details,d=f?f.totalduration/f.fragments.length:t,h=!!f&&f.live,p=void 0;p=c<=e?a*r:s*r;var y=u[c].realBitrate?Math.max(u[c].realBitrate,u[c].bitrate):u[c].bitrate,g=y*d/p;if(Me.b.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: "+c+"/"+Math.round(p)+"/"+y+"/"+d+"/"+o+"/"+g),p>y&&(!g||h&&!this.bitrateTestDelay||g<o))return c}return-1},kt(t,[{key:"nextAutoLevel",get:function(){var e=this._nextAutoLevel,t=this._bwEstimator;if(!(-1===e||t&&t.canEstimate()))return e;var r=this._nextABRAutoLevel;return-1!==e&&(r=Math.min(e,r)),r},set:function(e){this._nextAutoLevel=e}},{key:"_nextABRAutoLevel",get:function(){var e=this.hls,t=e.maxAutoLevel,r=e.levels,n=e.config,i=e.minAutoLevel,o=e.media,a=this.lastLoadedFragLevel,s=this.fragCurrent?this.fragCurrent.duration:0,u=o?o.currentTime:0,c=o&&0!==o.playbackRate?Math.abs(o.playbackRate):1,l=this._bwEstimator?this._bwEstimator.getEstimate():n.abrEwmaDefaultEstimate,f=(it.bufferInfo(o,u,n.maxBufferHole).end-u)/c,d=this._findBestLevel(a,s,l,i,t,f,n.abrBandWidthFactor,n.abrBandWidthUpFactor,r);if(d>=0)return d;Me.b.trace("rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering");var h=s?Math.min(s,n.maxStarvationDelay):n.maxStarvationDelay,p=n.abrBandWidthFactor,y=n.abrBandWidthUpFactor;if(0===f){var g=this.bitrateTestDelay;if(g){h=(s?Math.min(s,n.maxLoadingDelay):n.maxLoadingDelay)-g,Me.b.trace("bitrate test took "+Math.round(1e3*g)+"ms, set first fragment max fetchDuration to "+Math.round(1e3*h)+" ms"),p=y=1}}return d=this._findBestLevel(a,s,l,i,t,f+h,p,y,r),Math.max(d,0)}}]),t}(je),It=Dt,Pt=_(),Mt=function(e){function t(r){G(this,t);var n=W(this,e.call(this,r,Ie.a.MEDIA_ATTACHING,Ie.a.MEDIA_DETACHING,Ie.a.MANIFEST_PARSED,Ie.a.BUFFER_RESET,Ie.a.BUFFER_APPENDING,Ie.a.BUFFER_CODECS,Ie.a.BUFFER_EOS,Ie.a.BUFFER_FLUSHING,Ie.a.LEVEL_PTS_UPDATED,Ie.a.LEVEL_UPDATED));return n._msDuration=null,n._levelDuration=null,n.onsbue=n.onSBUpdateEnd.bind(n),n.onsbe=n.onSBUpdateError.bind(n),n.pendingTracks={},n.tracks={},n}return H(t,e),t.prototype.destroy=function(){je.prototype.destroy.call(this)},t.prototype.onLevelPtsUpdated=function(e){var t=e.type,r=this.tracks.audio;if("audio"===t&&r&&"audio/mpeg"===r.container){var n=this.sourceBuffer.audio;if(Math.abs(n.timestampOffset-e.start)>.1){var i=n.updating;try{n.abort()}catch(o){i=!0,Me.b.warn("can not abort audio buffer: "+o)}i?this.audioTimestampOffset=e.start:(Me.b.warn("change mpeg audio timestamp offset from "+n.timestampOffset+" to "+e.start),n.timestampOffset=e.start)}}},t.prototype.onManifestParsed=function(e){var t=e.audio,r=e.video||e.levels.length&&e.audio,n=0;e.altAudio&&(t||r)&&(n=(t?1:0)+(r?1:0),Me.b.log(n+" sourceBuffer(s) expected")),this.sourceBufferNb=n},t.prototype.onMediaAttaching=function(e){var t=this.media=e.media;if(t){var r=this.mediaSource=new Pt;this.onmso=this.onMediaSourceOpen.bind(this),this.onmse=this.onMediaSourceEnded.bind(this),this.onmsc=this.onMediaSourceClose.bind(this),r.addEventListener("sourceopen",this.onmso),r.addEventListener("sourceended",this.onmse),r.addEventListener("sourceclose",this.onmsc),t.src=URL.createObjectURL(r)}},t.prototype.onMediaDetaching=function(){Me.b.log("media source detaching");var e=this.mediaSource;if(e){if("open"===e.readyState)try{e.endOfStream()}catch(t){Me.b.warn("onMediaDetaching:"+t.message+" while calling endOfStream")}e.removeEventListener("sourceopen",this.onmso),e.removeEventListener("sourceended",this.onmse),e.removeEventListener("sourceclose",this.onmsc),this.media&&(URL.revokeObjectURL(this.media.src),this.media.removeAttribute("src"),this.media.load()),this.mediaSource=null,this.media=null,this.pendingTracks={},this.tracks={},this.sourceBuffer={},this.flushRange=[],this.segments=[],this.appended=0}this.onmso=this.onmse=this.onmsc=null,this.hls.trigger(Ie.a.MEDIA_DETACHED)},t.prototype.onMediaSourceOpen=function(){Me.b.log("media source opened"),this.hls.trigger(Ie.a.MEDIA_ATTACHED,{media:this.media});var e=this.mediaSource;e&&e.removeEventListener("sourceopen",this.onmso),this.checkPendingTracks()},t.prototype.checkPendingTracks=function(){var e=this.pendingTracks,t=Object.keys(e).length;t&&(this.sourceBufferNb<=t||0===this.sourceBufferNb)&&(this.createSourceBuffers(e),this.pendingTracks={},this.doAppending())},t.prototype.onMediaSourceClose=function(){Me.b.log("media source closed")},t.prototype.onMediaSourceEnded=function(){Me.b.log("media source ended")},t.prototype.onSBUpdateEnd=function(){if(this.audioTimestampOffset){var e=this.sourceBuffer.audio;Me.b.warn("change mpeg audio timestamp offset from "+e.timestampOffset+" to "+this.audioTimestampOffset),e.timestampOffset=this.audioTimestampOffset,delete this.audioTimestampOffset}
this._needsFlush&&this.doFlush(),this._needsEos&&this.checkEos(),this.appending=!1;var t=this.parent,r=this.segments.reduce(function(e,r){return r.parent===t?e+1:e},0);this.hls.trigger(Ie.a.BUFFER_APPENDED,{parent:t,pending:r}),this._needsFlush||this.doAppending(),this.updateMediaElementDuration()},t.prototype.onSBUpdateError=function(e){Me.b.error("sourceBuffer error:",e),this.hls.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.BUFFER_APPENDING_ERROR,fatal:!1})},t.prototype.onBufferReset=function(){var e=this.sourceBuffer;for(var t in e){var r=e[t];try{this.mediaSource.removeSourceBuffer(r),r.removeEventListener("updateend",this.onsbue),r.removeEventListener("error",this.onsbe)}catch(n){}}this.sourceBuffer={},this.flushRange=[],this.segments=[],this.appended=0},t.prototype.onBufferCodecs=function(e){if(0===Object.keys(this.sourceBuffer).length){for(var t in e)this.pendingTracks[t]=e[t];var r=this.mediaSource;r&&"open"===r.readyState&&this.checkPendingTracks()}},t.prototype.createSourceBuffers=function(e){var t=this.sourceBuffer,r=this.mediaSource;for(var n in e)if(!t[n]){var i=e[n],o=i.levelCodec||i.codec,a=i.container+";codecs="+o;Me.b.log("creating sourceBuffer("+a+")");try{var s=t[n]=r.addSourceBuffer(a);s.addEventListener("updateend",this.onsbue),s.addEventListener("error",this.onsbe),this.tracks[n]={codec:o,container:i.container},i.buffer=s}catch(u){Me.b.error("error while trying to add sourceBuffer:"+u.message),this.hls.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.BUFFER_ADD_CODEC_ERROR,fatal:!1,err:u,mimeType:a})}}this.hls.trigger(Ie.a.BUFFER_CREATED,{tracks:e})},t.prototype.onBufferAppending=function(e){this._needsFlush||(this.segments?this.segments.push(e):this.segments=[e],this.doAppending())},t.prototype.onBufferAppendFail=function(e){Me.b.error("sourceBuffer error:",e.event),this.hls.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.BUFFER_APPENDING_ERROR,fatal:!1})},t.prototype.onBufferEos=function(e){var t=this.sourceBuffer,r=e.type;for(var n in t)r&&n!==r||t[n].ended||(t[n].ended=!0,Me.b.log(n+" sourceBuffer now EOS"));this.checkEos()},t.prototype.checkEos=function(){var e=this.sourceBuffer,t=this.mediaSource;if(!t||"open"!==t.readyState)return void(this._needsEos=!1);for(var r in e){var n=e[r];if(!n.ended)return;if(n.updating)return void(this._needsEos=!0)}Me.b.log("all media data available, signal endOfStream() to MediaSource and stop loading fragment");try{t.endOfStream()}catch(e){Me.b.warn("exception while calling mediaSource.endOfStream()")}this._needsEos=!1},t.prototype.onBufferFlushing=function(e){this.flushRange.push({start:e.startOffset,end:e.endOffset,type:e.type}),this.flushBufferCounter=0,this.doFlush()},t.prototype.onLevelUpdated=function(e){var t=e.details;0!==t.fragments.length&&(this._levelDuration=t.totalduration+t.fragments[0].start,this.updateMediaElementDuration())},t.prototype.updateMediaElementDuration=function(){var e=this.media,t=this.mediaSource,r=this.sourceBuffer,n=this._levelDuration;if(null!==n&&e&&t&&r&&0!==e.readyState&&"open"===t.readyState){for(var i in r)if(r[i].updating)return;null===this._msDuration&&(this._msDuration=t.duration);var o=e.duration;(n>this._msDuration&&n>o||o===Infinity||isNaN(o))&&(Me.b.log("Updating mediasource duration to "+n.toFixed(3)),this._msDuration=t.duration=n)}},t.prototype.doFlush=function(){for(;this.flushRange.length;){var e=this.flushRange[0];if(!this.flushBuffer(e.start,e.end,e.type))return void(this._needsFlush=!0);this.flushRange.shift(),this.flushBufferCounter=0}if(0===this.flushRange.length){this._needsFlush=!1;var t=0,r=this.sourceBuffer;try{for(var n in r)t+=r[n].buffered.length}catch(i){Me.b.error("error while accessing sourceBuffer.buffered")}this.appended=t,this.hls.trigger(Ie.a.BUFFER_FLUSHED)}},t.prototype.doAppending=function(){var e=this.hls,t=this.sourceBuffer,r=this.segments;if(Object.keys(t).length){if(this.media.error)return this.segments=[],void Me.b.error("trying to append although a media error occured, flush segment and abort");if(this.appending)return;if(r&&r.length){var n=r.shift();try{var i=n.type,o=t[i];o?o.updating?r.unshift(n):(o.ended=!1,this.parent=n.parent,o.appendBuffer(n.data),this.appendError=0,this.appended++,this.appending=!0):this.onSBUpdateEnd()}catch(s){Me.b.error("error while trying to append buffer:"+s.message),r.unshift(n);var a={type:Pe.b.MEDIA_ERROR,parent:n.parent};if(22===s.code)return this.segments=[],a.details=Pe.a.BUFFER_FULL_ERROR,a.fatal=!1,void e.trigger(Ie.a.ERROR,a);if(this.appendError?this.appendError++:this.appendError=1,a.details=Pe.a.BUFFER_APPEND_ERROR,this.appendError>e.config.appendErrorMaxRetry)return Me.b.log("fail "+e.config.appendErrorMaxRetry+" times to append segment in sourceBuffer"),r=[],a.fatal=!0,void e.trigger(Ie.a.ERROR,a);a.fatal=!1,e.trigger(Ie.a.ERROR,a)}}}},t.prototype.flushBuffer=function(e,t,r){var n,i,o,a,s,u,c=this.sourceBuffer;if(Object.keys(c).length){if(Me.b.log("flushBuffer,pos/start/end: "+this.media.currentTime.toFixed(3)+"/"+e+"/"+t),this.flushBufferCounter<this.appended){for(var l in c)if(!r||l===r){if(n=c[l],n.ended=!1,n.updating)return Me.b.warn("cannot flush, sb updating in progress"),!1;try{for(i=0;i<n.buffered.length;i++)if(o=n.buffered.start(i),a=n.buffered.end(i),-1!==navigator.userAgent.toLowerCase().indexOf("firefox")&&t===Number.POSITIVE_INFINITY?(s=e,u=t):(s=Math.max(o,e),u=Math.min(a,t)),Math.min(u,a)-s>.5)return this.flushBufferCounter++,Me.b.log("flush "+l+" ["+s+","+u+"], of ["+o+","+a+"], pos:"+this.media.currentTime),n.remove(s,u),!1}catch(e){Me.b.warn("exception while accessing sourcebuffer, it might have been removed from MediaSource")}}}else Me.b.warn("abort flushing too many retries");Me.b.log("buffer flushed")}return!0},t}(je),Rt=Mt,Ct=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),jt=function(e){function t(r){return V(this,t),Y(this,e.call(this,r,Ie.a.FPS_DROP_LEVEL_CAPPING,Ie.a.MEDIA_ATTACHING,Ie.a.MANIFEST_PARSED))}return K(t,e),t.prototype.destroy=function(){this.hls.config.capLevelToPlayerSize&&(this.media=this.restrictedLevels=null,this.autoLevelCapping=Number.POSITIVE_INFINITY,this.timer&&(this.timer=clearInterval(this.timer)))},t.prototype.onFpsDropLevelCapping=function(e){t.isLevelAllowed(e.droppedLevel,this.restrictedLevels)&&this.restrictedLevels.push(e.droppedLevel)},t.prototype.onMediaAttaching=function(e){this.media=e.media instanceof HTMLVideoElement?e.media:null},t.prototype.onManifestParsed=function(e){var t=this.hls;this.restrictedLevels=[],t.config.capLevelToPlayerSize&&(this.autoLevelCapping=Number.POSITIVE_INFINITY,this.levels=e.levels,t.firstLevel=this.getMaxLevel(e.firstLevel),clearInterval(this.timer),this.timer=setInterval(this.detectPlayerSize.bind(this),1e3),this.detectPlayerSize())},t.prototype.detectPlayerSize=function(){if(this.media){var e=this.levels?this.levels.length:0;if(e){var t=this.hls;t.autoLevelCapping=this.getMaxLevel(e-1),t.autoLevelCapping>this.autoLevelCapping&&t.streamController.nextLevelSwitch(),this.autoLevelCapping=t.autoLevelCapping}}},t.prototype.getMaxLevel=function(e){var r=this;if(!this.levels)return-1;var n=this.levels.filter(function(n,i){return t.isLevelAllowed(i,r.restrictedLevels)&&i<=e});return t.getMaxLevelByMediaSize(n,this.mediaWidth,this.mediaHeight)},t.isLevelAllowed=function(e){return-1===(arguments.length>1&&arguments[1]!==undefined?arguments[1]:[]).indexOf(e)},t.getMaxLevelByMediaSize=function(e,t,r){if(!e||e&&!e.length)return-1;for(var n=e.length-1,i=0;i<e.length;i+=1){var o=e[i];if((o.width>=t||o.height>=r)&&function(e,t){return!t||(e.width!==t.width||e.height!==t.height)}(o,e[i+1])){n=i;break}}return n},Ct(t,[{key:"mediaWidth",get:function(){var e=void 0,r=this.media;return r&&(e=r.width||r.clientWidth||r.offsetWidth,e*=t.contentScaleFactor),e}},{key:"mediaHeight",get:function(){var e=void 0,r=this.media;return r&&(e=r.height||r.clientHeight||r.offsetHeight,e*=t.contentScaleFactor),e}}],[{key:"contentScaleFactor",get:function(){var e=1;try{e=window.devicePixelRatio}catch(e){}return e}}]),t}(je),Lt=jt,Nt=function(e){function t(r){return Z(this,t),J(this,e.call(this,r,Ie.a.MEDIA_ATTACHING))}return Q(t,e),t.prototype.destroy=function(){this.timer&&clearInterval(this.timer),this.isVideoPlaybackQualityAvailable=!1},t.prototype.onMediaAttaching=function(e){var t=this.hls.config;if(t.capLevelOnFPSDrop){"function"==typeof(this.video=e.media instanceof HTMLVideoElement?e.media:null).getVideoPlaybackQuality&&(this.isVideoPlaybackQualityAvailable=!0),clearInterval(this.timer),this.timer=setInterval(this.checkFPSInterval.bind(this),t.fpsDroppedMonitoringPeriod)}},t.prototype.checkFPS=function(e,t,r){var n=performance.now();if(t){if(this.lastTime){var i=n-this.lastTime,o=r-this.lastDroppedFrames,a=t-this.lastDecodedFrames,s=1e3*o/i,u=this.hls;if(u.trigger(Ie.a.FPS_DROP,{currentDropped:o,currentDecoded:a,totalDroppedFrames:r}),s>0&&o>u.config.fpsDroppedMonitoringThreshold*a){var c=u.currentLevel;Me.b.warn("drop FPS ratio greater than max allowed value for currentLevel: "+c),c>0&&(-1===u.autoLevelCapping||u.autoLevelCapping>=c)&&(c-=1,u.trigger(Ie.a.FPS_DROP_LEVEL_CAPPING,{level:c,droppedLevel:u.currentLevel}),u.autoLevelCapping=c,u.streamController.nextLevelSwitch())}}this.lastTime=n,this.lastDroppedFrames=r,this.lastDecodedFrames=t}},t.prototype.checkFPSInterval=function(){var e=this.video;if(e)if(this.isVideoPlaybackQualityAvailable){var t=e.getVideoPlaybackQuality();this.checkFPS(e,t.totalVideoFrames,t.droppedVideoFrames)}else this.checkFPS(e,e.webkitDecodedFrameCount,e.webkitDroppedFrameCount)},t}(je),Ft=Nt,Bt=function(){function t(e){X(this,t),e&&e.xhrSetup&&(this.xhrSetup=e.xhrSetup)}return t.prototype.destroy=function(){this.abort(),this.loader=null},t.prototype.abort=function(){var e=this.loader;e&&4!==e.readyState&&(this.stats.aborted=!0,e.abort()),window.clearTimeout(this.requestTimeout),this.requestTimeout=null,window.clearTimeout(this.retryTimeout),this.retryTimeout=null},t.prototype.load=function(e,t,r){this.context=e,this.config=t,this.callbacks=r,this.stats={trequest:performance.now(),retry:0},this.retryDelay=t.retryDelay,this.loadInternal()},t.prototype.loadInternal=function(){var t,r=this.context;t=this.loader=new XMLHttpRequest;var n=this.stats;n.tfirst=0,n.loaded=0;var i=this.xhrSetup;try{if(i)try{i(t,r.url)}catch(e){t.open("GET",r.url,!0),i(t,r.url)}t.readyState||t.open("GET",r.url,!0)}catch(e){return void this.callbacks.onError({code:t.status,text:e.message},r,t)}r.rangeEnd&&t.setRequestHeader("Range","bytes="+r.rangeStart+"-"+(r.rangeEnd-1)),t.onreadystatechange=this.readystatechange.bind(this),t.onprogress=this.loadprogress.bind(this),t.responseType=r.responseType,this.requestTimeout=window.setTimeout(this.loadtimeout.bind(this),this.config.timeout),t.send()},t.prototype.readystatechange=function(e){var t=e.currentTarget,r=t.readyState,n=this.stats,i=this.context,o=this.config;if(!n.aborted&&r>=2)if(window.clearTimeout(this.requestTimeout),0===n.tfirst&&(n.tfirst=Math.max(performance.now(),n.trequest)),4===r){var a=t.status;if(a>=200&&a<300){n.tload=Math.max(n.tfirst,performance.now());var s=void 0,u=void 0;"arraybuffer"===i.responseType?(s=t.response,u=s.byteLength):(s=t.responseText,u=s.length),n.loaded=n.total=u;var c={url:t.responseURL,data:s};this.callbacks.onSuccess(c,n,i,t)}else n.retry>=o.maxRetry||a>=400&&a<499?(Me.b.error(a+" while loading "+i.url),this.callbacks.onError({code:a,text:t.statusText},i,t)):(Me.b.warn(a+" while loading "+i.url+", retrying in "+this.retryDelay+"..."),this.destroy(),this.retryTimeout=window.setTimeout(this.loadInternal.bind(this),this.retryDelay),this.retryDelay=Math.min(2*this.retryDelay,o.maxRetryDelay),n.retry++)}else this.requestTimeout=window.setTimeout(this.loadtimeout.bind(this),o.timeout)},t.prototype.loadtimeout=function(){Me.b.warn("timeout while loading "+this.context.url),this.callbacks.onTimeout(this.stats,this.context,null)},t.prototype.loadprogress=function(e){var t=e.currentTarget,r=this.stats;r.loaded=e.loaded,e.lengthComputable&&(r.total=e.total);var n=this.callbacks.onProgress;n&&n(r,this.context,null,t)},t}(),Ut=Bt,zt=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),Gt=function(e){function t(r){q(this,t);var n=ee(this,e.call(this,r,Ie.a.MANIFEST_LOADING,Ie.a.MANIFEST_PARSED,Ie.a.AUDIO_TRACK_LOADED,Ie.a.ERROR));return n.ticks=0,n.ontick=n.tick.bind(n),n}return te(t,e),t.prototype.destroy=function(){this.cleanTimer(),je.prototype.destroy.call(this)},t.prototype.cleanTimer=function(){this.timer&&(clearTimeout(this.timer),this.timer=null)},t.prototype.tick=function(){1===++this.ticks&&(this.doTick(),this.ticks>1&&setTimeout(this.tick,1),this.ticks=0)},t.prototype.doTick=function(){this.updateTrack(this.trackId)},t.prototype.onError=function(e){e.fatal&&e.type===Pe.b.NETWORK_ERROR&&this.cleanTimer()},t.prototype.onManifestLoading=function(){this.tracks=[],this.trackId=-1},t.prototype.onManifestParsed=function(e){var t=this,r=e.audioTracks||[],n=!1;this.tracks=r,this.hls.trigger(Ie.a.AUDIO_TRACKS_UPDATED,{audioTracks:r});var i=0;r.forEach(function(e){if(e["default"]&&!n)return t.audioTrack=i,void(n=!0);i++}),!1===n&&r.length&&(Me.b.log("no default audio track defined, use first audio track as default"),this.audioTrack=0)},t.prototype.onAudioTrackLoaded=function(e){e.id<this.tracks.length&&(Me.b.log("audioTrack "+e.id+" loaded"),this.tracks[e.id].details=e.details,e.details.live&&!this.timer&&(this.timer=setInterval(this.ontick,1e3*e.details.targetduration)),!e.details.live&&this.timer&&this.cleanTimer())},t.prototype.setAudioTrackInternal=function(e){if(e>=0&&e<this.tracks.length){this.cleanTimer(),this.trackId=e,Me.b.log("switching to audioTrack "+e);var t=this.tracks[e],r=this.hls,n=t.type,i=t.url,o={id:e,type:n,url:i};r.trigger(Ie.a.AUDIO_TRACK_SWITCH,o),r.trigger(Ie.a.AUDIO_TRACK_SWITCHING,o);var a=t.details;!i||a!==undefined&&!0!==a.live||(Me.b.log("(re)loading playlist for audioTrack "+e),r.trigger(Ie.a.AUDIO_TRACK_LOADING,{url:i,id:e}))}},t.prototype.updateTrack=function(e){if(e>=0&&e<this.tracks.length){this.cleanTimer(),this.trackId=e,Me.b.log("updating audioTrack "+e);var t=this.tracks[e],r=t.url,n=t.details;!r||n!==undefined&&!0!==n.live||(Me.b.log("(re)loading playlist for audioTrack "+e),this.hls.trigger(Ie.a.AUDIO_TRACK_LOADING,{url:r,id:e}))}},zt(t,[{key:"audioTracks",get:function(){return this.tracks}},{key:"audioTrack",get:function(){return this.trackId},set:function(e){this.trackId===e&&this.tracks[e].details!==undefined||this.setAudioTrackInternal(e)}}]),t}(je),Wt=Gt,Ht=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),Vt={STOPPED:"STOPPED",STARTING:"STARTING",IDLE:"IDLE",PAUSED:"PAUSED",KEY_LOADING:"KEY_LOADING",FRAG_LOADING:"FRAG_LOADING",FRAG_LOADING_WAITING_RETRY:"FRAG_LOADING_WAITING_RETRY",WAITING_TRACK:"WAITING_TRACK",PARSING:"PARSING",PARSED:"PARSED",BUFFER_FLUSHING:"BUFFER_FLUSHING",ENDED:"ENDED",ERROR:"ERROR",WAITING_INIT_PTS:"WAITING_INIT_PTS"},Yt=function(e){function t(r){re(this,t);var n=ne(this,e.call(this,r,Ie.a.MEDIA_ATTACHED,Ie.a.MEDIA_DETACHING,Ie.a.AUDIO_TRACKS_UPDATED,Ie.a.AUDIO_TRACK_SWITCHING,Ie.a.AUDIO_TRACK_LOADED,Ie.a.KEY_LOADED,Ie.a.FRAG_LOADED,Ie.a.FRAG_PARSING_INIT_SEGMENT,Ie.a.FRAG_PARSING_DATA,Ie.a.FRAG_PARSED,Ie.a.ERROR,Ie.a.BUFFER_CREATED,Ie.a.BUFFER_APPENDED,Ie.a.BUFFER_FLUSHED,Ie.a.INIT_PTS_FOUND));return n.config=r.config,n.audioCodecSwap=!1,n.ticks=0,n._state=Vt.STOPPED,n.ontick=n.tick.bind(n),n.initPTS=[],n.waitingFragment=null,n.videoTrackCC=null,n}return ie(t,e),t.prototype.destroy=function(){this.stopLoad(),this.timer&&(clearInterval(this.timer),this.timer=null),je.prototype.destroy.call(this),this.state=Vt.STOPPED},t.prototype.onInitPtsFound=function(e){var t=e.id,r=e.frag.cc,n=e.initPTS;"main"===t&&(this.initPTS[r]=n,this.videoTrackCC=r,Me.b.log("InitPTS for cc:"+r+" found from video track:"+n),this.state===Vt.WAITING_INIT_PTS&&this.tick())},t.prototype.startLoad=function(e){if(this.tracks){var t=this.lastCurrentTime;this.stopLoad(),this.timer||(this.timer=setInterval(this.ontick,100)),this.fragLoadError=0,t>0&&-1===e?(Me.b.log("audio:override startPosition with lastCurrentTime @"+t.toFixed(3)),this.state=Vt.IDLE):(this.lastCurrentTime=this.startPosition?this.startPosition:e,this.state=Vt.STARTING),this.nextLoadPosition=this.startPosition=this.lastCurrentTime,this.tick()}else this.startPosition=e,this.state=Vt.STOPPED},t.prototype.stopLoad=function(){var e=this.fragCurrent;e&&(e.loader&&e.loader.abort(),this.fragCurrent=null),this.fragPrevious=null,this.demuxer&&(this.demuxer.destroy(),this.demuxer=null),this.state=Vt.STOPPED},t.prototype.tick=function(){1===++this.ticks&&(this.doTick(),this.ticks>1&&setTimeout(this.tick,1),this.ticks=0)},t.prototype.doTick=function(){var e,t,r,n=this.hls,i=n.config;switch(this.state){case Vt.ERROR:case Vt.PAUSED:case Vt.BUFFER_FLUSHING:break;case Vt.STARTING:this.state=Vt.WAITING_TRACK,this.loadedmetadata=!1;break;case Vt.IDLE:var o=this.tracks;if(!o)break;if(!this.media&&(this.startFragRequested||!i.startFragPrefetch))break;if(this.loadedmetadata)e=this.media.currentTime;else if((e=this.nextLoadPosition)===undefined)break;var a=this.mediaBuffer?this.mediaBuffer:this.media,s=this.videoBuffer?this.videoBuffer:this.media,u=it.bufferInfo(a,e,i.maxBufferHole),c=it.bufferInfo(s,e,i.maxBufferHole),l=u.len,f=u.end,d=this.fragPrevious,h=Math.max(i.maxBufferLength,c.len),p=this.audioSwitch,y=this.trackId;if((l<h||p)&&y<o.length){if(void 0===(r=o[y].details)){this.state=Vt.WAITING_TRACK;break}if(!p&&!r.live&&d&&d.sn===r.endSN&&(!this.media.seeking||this.media.duration-f<d.duration/2)){this.hls.trigger(Ie.a.BUFFER_EOS,{type:"audio"}),this.state=Vt.ENDED;break}var g=r.fragments,m=g.length,_=g[0].start,v=g[m-1].start+g[m-1].duration,b=void 0;if(p)if(r.live&&!r.PTSKnown)Me.b.log("switching audiotrack, live stream, unknown PTS,load first fragment"),f=0;else if(f=e,r.PTSKnown&&e<_){if(!(u.end>_||u.nextStart))return;Me.b.log("alt audio track ahead of main track, seek to start of alt audio track"),this.media.currentTime=_+.05}if(r.initSegment&&!r.initSegment.data)b=r.initSegment;else if(f<=_){if(b=g[0],null!==this.videoTrackCC&&b.cc!==this.videoTrackCC&&(b=S(g,this.videoTrackCC)),r.live&&b.loadIdx&&b.loadIdx===this.fragLoadIdx){var $=u.nextStart?u.nextStart:_;return Me.b.log("no alt audio available @currentTime:"+this.media.currentTime+", seeking @"+($+.05)),void(this.media.currentTime=$+.05)}}else{var w=void 0,E=i.maxFragLookUpTolerance,O=d?g[d.sn-g[0].sn+1]:undefined,T=function(e){var t=Math.min(E,e.duration);return e.start+e.duration-t<=f?1:e.start-t>f&&e.start?-1:0};f<v?(f>v-E&&(E=0),w=O&&!T(O)?O:rt.search(g,T)):w=g[m-1],w&&(b=w,_=w.start,d&&b.level===d.level&&b.sn===d.sn&&(b.sn<r.endSN?(b=g[b.sn+1-r.startSN],Me.b.log("SN just loaded, load next one: "+b.sn)):b=null))}if(b)if(b.decryptdata&&null!=b.decryptdata.uri&&null==b.decryptdata.key)Me.b.log("Loading key for "+b.sn+" of ["+r.startSN+" ,"+r.endSN+"],track "+y),this.state=Vt.KEY_LOADING,n.trigger(Ie.a.KEY_LOADING,{frag:b});else{if(Me.b.log("Loading "+b.sn+", cc: "+b.cc+" of ["+r.startSN+" ,"+r.endSN+"],track "+y+", currentTime:"+e+",bufferEnd:"+f.toFixed(3)),this.fragLoadIdx!==undefined?this.fragLoadIdx++:this.fragLoadIdx=0,b.loadCounter){b.loadCounter++;var A=i.fragLoadingLoopThreshold;if(b.loadCounter>A&&Math.abs(this.fragLoadIdx-b.loadIdx)<A)return void n.trigger(Ie.a.ERROR,{type:Pe.b.MEDIA_ERROR,details:Pe.a.FRAG_LOOP_LOADING_ERROR,fatal:!1,frag:b})}else b.loadCounter=1;b.loadIdx=this.fragLoadIdx,this.fragCurrent=b,this.startFragRequested=!0,isNaN(b.sn)||(this.nextLoadPosition=b.start+b.duration),n.trigger(Ie.a.FRAG_LOADING,{frag:b}),this.state=Vt.FRAG_LOADING}}break;case Vt.WAITING_TRACK:t=this.tracks[this.trackId],t&&t.details&&(this.state=Vt.IDLE);break;case Vt.FRAG_LOADING_WAITING_RETRY:var x=performance.now(),k=this.retryDate;a=this.media;var D=a&&a.seeking;(!k||x>=k||D)&&(Me.b.log("audioStreamController: retryDate reached, switch back to IDLE state"),this.state=Vt.IDLE);break;case Vt.WAITING_INIT_PTS:var I=this.videoTrackCC;if(this.initPTS[I]===undefined)break;var P=this.waitingFragment;if(P){var M=P.frag.cc;I!==M?(t=this.tracks[this.trackId],t.details&&t.details.live&&(Me.b.warn("Waiting fragment CC ("+M+") does not match video track CC ("+I+")"),this.waitingFragment=null,this.state=Vt.IDLE)):(this.state=Vt.FRAG_LOADING,this.onFragLoaded(this.waitingFragment),this.waitingFragment=null)}else this.state=Vt.IDLE;break;case Vt.STOPPED:case Vt.FRAG_LOADING:case Vt.PARSING:case Vt.PARSED:case Vt.ENDED:}},t.prototype.onMediaAttached=function(e){var t=this.media=this.mediaBuffer=e.media;this.onvseeking=this.onMediaSeeking.bind(this),this.onvended=this.onMediaEnded.bind(this),t.addEventListener("seeking",this.onvseeking),t.addEventListener("ended",this.onvended);var r=this.config;this.tracks&&r.autoStartLoad&&this.startLoad(r.startPosition)},t.prototype.onMediaDetaching=function(){var e=this.media;e&&e.ended&&(Me.b.log("MSE detaching and video ended, reset startPosition"),this.startPosition=this.lastCurrentTime=0);var t=this.tracks;t&&t.forEach(function(e){e.details&&e.details.fragments.forEach(function(e){e.loadCounter=undefined})}),e&&(e.removeEventListener("seeking",this.onvseeking),e.removeEventListener("ended",this.onvended),this.onvseeking=this.onvseeked=this.onvended=null),this.media=this.mediaBuffer=this.videoBuffer=null,this.loadedmetadata=!1,this.stopLoad()},t.prototype.onMediaSeeking=function(){this.state===Vt.ENDED&&(this.state=Vt.IDLE),this.media&&(this.lastCurrentTime=this.media.currentTime),this.fragLoadIdx!==undefined&&(this.fragLoadIdx+=2*this.config.fragLoadingLoopThreshold),this.tick()},t.prototype.onMediaEnded=function(){this.startPosition=this.lastCurrentTime=0},t.prototype.onAudioTracksUpdated=function(e){Me.b.log("audio tracks updated"),this.tracks=e.audioTracks},t.prototype.onAudioTrackSwitching=function(e){var t=!!e.url;this.trackId=e.id,this.fragCurrent=null,this.state=Vt.PAUSED,this.waitingFragment=null,t?this.timer||(this.timer=setInterval(this.ontick,100)):this.demuxer&&(this.demuxer.destroy(),this.demuxer=null),t&&(this.audioSwitch=!0,this.state=Vt.IDLE,this.fragLoadIdx!==undefined&&(this.fragLoadIdx+=2*this.config.fragLoadingLoopThreshold)),this.tick()},t.prototype.onAudioTrackLoaded=function(e){var t=e.details,r=e.id,n=this.tracks[r],i=t.totalduration,o=0;if(Me.b.log("track "+r+" loaded ["+t.startSN+","+t.endSN+"],duration:"+i),t.live){var a=n.details;a&&t.fragments.length>0?(w(a,t),o=t.fragments[0].start,t.PTSKnown?Me.b.log("live audio playlist sliding:"+o.toFixed(3)):Me.b.log("live audio playlist - outdated PTS, unknown sliding")):(t.PTSKnown=!1,Me.b.log("live audio playlist - first load, unknown sliding"))}else t.PTSKnown=!1;if(n.details=t,!this.startFragRequested){if(-1===this.startPosition){var s=t.startTimeOffset;isNaN(s)?this.startPosition=0:(Me.b.log("start time offset found in playlist, adjust startPosition to "+s),this.startPosition=s)}this.nextLoadPosition=this.startPosition}this.state===Vt.WAITING_TRACK&&(this.state=Vt.IDLE),this.tick()},t.prototype.onKeyLoaded=function(){this.state===Vt.KEY_LOADING&&(this.state=Vt.IDLE,this.tick())},t.prototype.onFragLoaded=function(e){var t=this.fragCurrent,r=e.frag;if(this.state===Vt.FRAG_LOADING&&t&&"audio"===r.type&&r.level===t.level&&r.sn===t.sn){var n=this.tracks[this.trackId],i=n.details,o=i.totalduration,a=t.level,s=t.sn,u=t.cc,c=this.config.defaultAudioCodec||n.audioCodec||"mp4a.40.2",l=this.stats=e.stats;if("initSegment"===s)this.state=Vt.IDLE,l.tparsed=l.tbuffered=performance.now(),i.initSegment.data=e.payload,this.hls.trigger(Ie.a.FRAG_BUFFERED,{stats:l,frag:t,id:"audio"}),this.tick();else{this.state=Vt.PARSING,this.appended=!1,this.demuxer||(this.demuxer=new dt(this.hls,"audio"));var f=this.initPTS[u],d=i.initSegment?i.initSegment.data:[];if(i.initSegment||f!==undefined){this.pendingBuffering=!0,Me.b.log("Demuxing "+s+" of ["+i.startSN+" ,"+i.endSN+"],track "+a);this.demuxer.push(e.payload,d,c,null,t,o,!1,f)}else Me.b.log("unknown video PTS for continuity counter "+u+", waiting for video PTS before demuxing audio frag "+s+" of ["+i.startSN+" ,"+i.endSN+"],track "+a),this.waitingFragment=e,this.state=Vt.WAITING_INIT_PTS}}this.fragLoadError=0},t.prototype.onFragParsingInitSegment=function(e){var t=this.fragCurrent,r=e.frag;if(t&&"audio"===e.id&&r.sn===t.sn&&r.level===t.level&&this.state===Vt.PARSING){var n=e.tracks,i=void 0;if(n.video&&delete n.video,i=n.audio){i.levelCodec=i.codec,i.id=e.id,this.hls.trigger(Ie.a.BUFFER_CODECS,n),Me.b.log("audio track:audio,container:"+i.container+",codecs[level/parsed]=["+i.levelCodec+"/"+i.codec+"]");var o=i.initSegment;if(o){var a={type:"audio",data:o,parent:"audio",content:"initSegment"};this.audioSwitch?this.pendingData=[a]:(this.appended=!0,this.pendingBuffering=!0,this.hls.trigger(Ie.a.BUFFER_APPENDING,a))}this.tick()}}},t.prototype.onFragParsingData=function(e){var t=this,r=this.fragCurrent,n=e.frag;if(r&&"audio"===e.id&&"audio"===e.type&&n.sn===r.sn&&n.level===r.level&&this.state===Vt.PARSING){var i=this.trackId,o=this.tracks[i],a=this.hls;isNaN(e.endPTS)&&(e.endPTS=e.startPTS+r.duration,e.endDTS=e.startDTS+r.duration),Me.b.log("parsed "+e.type+",PTS:["+e.startPTS.toFixed(3)+","+e.endPTS.toFixed(3)+"],DTS:["+e.startDTS.toFixed(3)+"/"+e.endDTS.toFixed(3)+"],nb:"+e.nb),$(o.details,r,e.startPTS,e.endPTS);var s=this.audioSwitch,u=this.media,c=!1;if(s&&u)if(u.readyState){var l=u.currentTime;Me.b.log("switching audio track : currentTime:"+l),l>=e.startPTS&&(Me.b.log("switching audio track : flushing all audio"),this.state=Vt.BUFFER_FLUSHING,a.trigger(Ie.a.BUFFER_FLUSHING,{startOffset:0,endOffset:Number.POSITIVE_INFINITY,type:"audio"}),c=!0,this.audioSwitch=!1,a.trigger(Ie.a.AUDIO_TRACK_SWITCHED,{id:i}))}else this.audioSwitch=!1,a.trigger(Ie.a.AUDIO_TRACK_SWITCHED,{id:i});var f=this.pendingData;this.audioSwitch||([e.data1,e.data2].forEach(function(t){t&&t.length&&f.push({type:e.type,data:t,parent:"audio",content:"data"})}),!c&&f.length&&(f.forEach(function(e){t.state===Vt.PARSING&&(t.pendingBuffering=!0,t.hls.trigger(Ie.a.BUFFER_APPENDING,e))}),this.pendingData=[],this.appended=!0)),this.tick()}},t.prototype.onFragParsed=function(e){var t=this.fragCurrent,r=e.frag;t&&"audio"===e.id&&r.sn===t.sn&&r.level===t.level&&this.state===Vt.PARSING&&(this.stats.tparsed=performance.now(),this.state=Vt.PARSED,this._checkAppendedParsed())},t.prototype.onBufferCreated=function(e){var t=e.tracks.audio;t&&(this.mediaBuffer=t.buffer,this.loadedmetadata=!0),e.tracks.video&&(this.videoBuffer=e.tracks.video.buffer)},t.prototype.onBufferAppended=function(e){if("audio"===e.parent){var t=this.state;t!==Vt.PARSING&&t!==Vt.PARSED||(this.pendingBuffering=e.pending>0,this._checkAppendedParsed())}},t.prototype._checkAppendedParsed=function(){if(!(this.state!==Vt.PARSED||this.appended&&this.pendingBuffering)){var e=this.fragCurrent,t=this.stats,r=this.hls;if(e){this.fragPrevious=e,t.tbuffered=performance.now(),r.trigger(Ie.a.FRAG_BUFFERED,{stats:t,frag:e,id:"audio"});var n=this.mediaBuffer?this.mediaBuffer:this.media;Me.b.log("audio buffered : "+pt.toString(n.buffered)),this.audioSwitch&&this.appended&&(this.audioSwitch=!1,r.trigger(Ie.a.AUDIO_TRACK_SWITCHED,{id:this.trackId})),this.state=Vt.IDLE}this.tick()}},t.prototype.onError=function(e){var t=e.frag;if(!t||"audio"===t.type)switch(e.details){case Pe.a.FRAG_LOAD_ERROR:case Pe.a.FRAG_LOAD_TIMEOUT:if(!e.fatal){var r=this.fragLoadError;r?r++:r=1;var n=this.config;if(r<=n.fragLoadingMaxRetry){this.fragLoadError=r,t.loadCounter=0;var i=Math.min(Math.pow(2,r-1)*n.fragLoadingRetryDelay,n.fragLoadingMaxRetryTimeout);Me.b.warn("audioStreamController: frag loading failed, retry in "+i+" ms"),this.retryDate=performance.now()+i,this.state=Vt.FRAG_LOADING_WAITING_RETRY}else Me.b.error("audioStreamController: "+e.details+" reaches max retry, redispatch as fatal ..."),e.fatal=!0,this.state=Vt.ERROR}break;case Pe.a.FRAG_LOOP_LOADING_ERROR:case Pe.a.AUDIO_TRACK_LOAD_ERROR:case Pe.a.AUDIO_TRACK_LOAD_TIMEOUT:case Pe.a.KEY_LOAD_ERROR:case Pe.a.KEY_LOAD_TIMEOUT:this.state!==Vt.ERROR&&(this.state=e.fatal?Vt.ERROR:Vt.IDLE,Me.b.warn("audioStreamController: "+e.details+" while loading frag,switch to "+this.state+" state ..."));break;case Pe.a.BUFFER_FULL_ERROR:if("audio"===e.parent&&(this.state===Vt.PARSING||this.state===Vt.PARSED)){var o=this.mediaBuffer,a=this.media.currentTime;if(o&&it.isBuffered(o,a)&&it.isBuffered(o,a+.5)){var s=this.config;s.maxMaxBufferLength>=s.maxBufferLength&&(s.maxMaxBufferLength/=2,Me.b.warn("audio:reduce max buffer length to "+s.maxMaxBufferLength+"s"),this.fragLoadIdx+=2*s.fragLoadingLoopThreshold),this.state=Vt.IDLE}else Me.b.warn("buffer full error also media.currentTime is not buffered, flush audio buffer"),this.fragCurrent=null,this.state=Vt.BUFFER_FLUSHING,this.hls.trigger(Ie.a.BUFFER_FLUSHING,{startOffset:0,endOffset:Number.POSITIVE_INFINITY,type:"audio"})}}},t.prototype.onBufferFlushed=function(){var e=this,t=this.pendingData;t&&t.length?(Me.b.log("appending pending audio data on Buffer Flushed"),t.forEach(function(t){e.hls.trigger(Ie.a.BUFFER_APPENDING,t)}),this.appended=!0,this.pendingData=[],this.state=Vt.PARSED):(this.state=Vt.IDLE,this.fragPrevious=null,this.tick())},Ht(t,[{key:"state",set:function(e){if(this.state!==e){var t=this.state;this._state=e,Me.b.log("audio stream:"+t+"->"+e)}},get:function(){return this._state}}]),t}(je),Kt=Yt,Zt=function(){function e(e){return"string"==typeof e&&(!!o[e.toLowerCase()]&&e.toLowerCase())}function t(e){return"string"==typeof e&&(!!a[e.toLowerCase()]&&e.toLowerCase())}function r(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)e[n]=r[n]}return e}function n(n,o,a){var s=this,u=function(){if("undefined"!=typeof navigator)return/MSIE\s8\.0/.test(navigator.userAgent)}(),c={};u?s=document.createElement("custom"):c.enumerable=!0,s.hasBeenReset=!1;var l="",f=!1,d=n,h=o,p=a,y=null,g="",m=!0,_="auto",v="start",b=50,$="middle",w=50,E="middle";if(Object.defineProperty(s,"id",r({},c,{get:function(){return l},set:function(e){l=""+e}})),Object.defineProperty(s,"pauseOnExit",r({},c,{get:function(){return f},set:function(e){f=!!e}})),Object.defineProperty(s,"startTime",r({},c,{get:function(){return d},set:function(e){if("number"!=typeof e)throw new TypeError("Start time must be set to a number.");d=e,this.hasBeenReset=!0}})),Object.defineProperty(s,"endTime",r({},c,{get:function(){return h},set:function(e){if("number"!=typeof e)throw new TypeError("End time must be set to a number.");h=e,this.hasBeenReset=!0}})),Object.defineProperty(s,"text",r({},c,{get:function(){return p},set:function(e){p=""+e,this.hasBeenReset=!0}})),Object.defineProperty(s,"region",r({},c,{get:function(){return y},set:function(e){y=e,this.hasBeenReset=!0}})),Object.defineProperty(s,"vertical",r({},c,{get:function(){return g},set:function(t){var r=e(t);if(!1===r)throw new SyntaxError("An invalid or illegal string was specified.");g=r,this.hasBeenReset=!0}})),Object.defineProperty(s,"snapToLines",r({},c,{get:function(){return m},set:function(e){m=!!e,this.hasBeenReset=!0}})),Object.defineProperty(s,"line",r({},c,{get:function(){return _},set:function(e){if("number"!=typeof e&&e!==i)throw new SyntaxError("An invalid number or illegal string was specified.");_=e,this.hasBeenReset=!0}})),Object.defineProperty(s,"lineAlign",r({},c,{get:function(){return v},set:function(e){var r=t(e)
;if(!r)throw new SyntaxError("An invalid or illegal string was specified.");v=r,this.hasBeenReset=!0}})),Object.defineProperty(s,"position",r({},c,{get:function(){return b},set:function(e){if(e<0||e>100)throw new Error("Position must be between 0 and 100.");b=e,this.hasBeenReset=!0}})),Object.defineProperty(s,"positionAlign",r({},c,{get:function(){return $},set:function(e){var r=t(e);if(!r)throw new SyntaxError("An invalid or illegal string was specified.");$=r,this.hasBeenReset=!0}})),Object.defineProperty(s,"size",r({},c,{get:function(){return w},set:function(e){if(e<0||e>100)throw new Error("Size must be between 0 and 100.");w=e,this.hasBeenReset=!0}})),Object.defineProperty(s,"align",r({},c,{get:function(){return E},set:function(e){var r=t(e);if(!r)throw new SyntaxError("An invalid or illegal string was specified.");E=r,this.hasBeenReset=!0}})),s.displayState=undefined,u)return s}if("undefined"!=typeof window&&window.VTTCue)return window.VTTCue;var i="auto",o={"":!0,lr:!0,rl:!0},a={start:!0,middle:!0,end:!0,left:!0,right:!0};return n.prototype.getCueAsHTML=function(){return window.WebVTT.convertCueToDOMTree(window,this.text)},n}(),Jt=function(){return{decode:function(e){if(!e)return"";if("string"!=typeof e)throw new Error("Error - expected string data.");return decodeURIComponent(encodeURIComponent(e))}}};se.prototype={set:function(e,t){this.get(e)||""===t||(this.values[e]=t)},get:function(e,t,r){return r?this.has(e)?this.values[e]:t[r]:this.has(e)?this.values[e]:t},has:function(e){return e in this.values},alt:function(e,t,r){for(var n=0;n<r.length;++n)if(t===r[n]){this.set(e,t);break}},integer:function(e,t){/^-?\d+$/.test(t)&&this.set(e,parseInt(t,10))},percent:function(e,t){return!!(t.match(/^([\d]{1,3})(\.[\d]*)?%$/)&&(t=parseFloat(t))>=0&&t<=100)&&(this.set(e,t),!0)}};var Qt=new Zt(0,0,0),Xt="middle"===Qt.align?"middle":"center";oe.prototype={parse:function(e){function t(){var e=r.buffer,t=0;for(e=le(e);t<e.length&&"\r"!==e[t]&&"\n"!==e[t];)++t;var n=e.substr(0,t);return"\r"===e[t]&&++t,"\n"===e[t]&&++t,r.buffer=e.substr(t),n}var r=this;e&&(r.buffer+=r.decoder.decode(e,{stream:!0}));try{var n;if("INITIAL"===r.state){if(!/\r\n|\n/.test(r.buffer))return this;n=t();var i=n.match(/^(\xef\xbb\xbf)?WEBVTT([ \t].*)?$/);if(!i||!i[0])throw new Error("Malformed WebVTT signature.");r.state="HEADER"}for(var o=!1;r.buffer;){if(!/\r\n|\n/.test(r.buffer))return this;switch(o?o=!1:n=t(),r.state){case"HEADER":/:/.test(n)?function(e){ue(e,function(e,t){switch(e){case"Region":console.log("parse region",t)}},/:/)}(n):n||(r.state="ID");continue;case"NOTE":n||(r.state="ID");continue;case"ID":if(/^NOTE($|[ \t])/.test(n)){r.state="NOTE";break}if(!n)continue;if(r.cue=new Zt(0,0,""),r.state="CUE",-1===n.indexOf("--\x3e")){r.cue.id=n;continue}case"CUE":try{ce(n,r.cue,r.regionList)}catch(e){r.cue=null,r.state="BADCUE";continue}r.state="CUETEXT";continue;case"CUETEXT":var a=-1!==n.indexOf("--\x3e");if(!n||a&&(o=!0)){r.oncue&&r.oncue(r.cue),r.cue=null,r.state="ID";continue}r.cue.text&&(r.cue.text+="\n"),r.cue.text+=n;continue;case"BADCUE":n||(r.state="ID");continue}}}catch(e){"CUETEXT"===r.state&&r.cue&&r.oncue&&r.oncue(r.cue),r.cue=null,r.state="INITIAL"===r.state?"BADWEBVTT":"BADCUE"}return this},flush:function(){var t=this;try{if(t.buffer+=t.decoder.decode(),(t.cue||"HEADER"===t.state)&&(t.buffer+="\n\n",t.parse()),"INITIAL"===t.state)throw new Error("Malformed WebVTT signature.")}catch(e){throw e}return t.onflush&&t.onflush(),this}};var qt=oe,er={42:225,92:233,94:237,95:243,96:250,123:231,124:247,125:209,126:241,127:9608,128:174,129:176,130:189,131:191,132:8482,133:162,134:163,135:9834,136:224,137:32,138:232,139:226,140:234,141:238,142:244,143:251,144:193,145:201,146:211,147:218,148:220,149:252,150:8216,151:161,152:42,153:8217,154:9473,155:169,156:8480,157:8226,158:8220,159:8221,160:192,161:194,162:199,163:200,164:202,165:203,166:235,167:206,168:207,169:239,170:212,171:217,172:249,173:219,174:171,175:187,176:195,177:227,178:205,179:204,180:236,181:210,182:242,183:213,184:245,185:123,186:125,187:92,188:94,189:95,190:124,191:8764,192:196,193:228,194:214,195:246,196:223,197:165,198:164,199:9475,200:197,201:229,202:216,203:248,204:9487,205:9491,206:9495,207:9499},tr=function(e){var t=e;return er.hasOwnProperty(e)&&(t=er[e]),String.fromCharCode(t)},rr=15,nr=100,ir={17:1,18:3,21:5,22:7,23:9,16:11,19:12,20:14},or={17:2,18:4,21:6,22:8,23:10,19:13,20:15},ar={25:1,26:3,29:5,30:7,31:9,24:11,27:12,28:14},sr={25:2,26:4,29:6,30:8,31:10,27:13,28:15},ur=["white","green","blue","cyan","red","yellow","magenta","black","transparent"],cr={verboseFilter:{DATA:3,DEBUG:3,INFO:2,WARNING:2,TEXT:1,ERROR:0},time:null,verboseLevel:0,setTime:function(e){this.time=e},log:function(e,t){var r=this.verboseFilter[e];this.verboseLevel>=r&&console.log(this.time+" ["+e+"] "+t)}},lr=function(e){for(var t=[],r=0;r<e.length;r++)t.push(e[r].toString(16));return t},fr=function(){function e(t,r,n,i,o){de(this,e),this.foreground=t||"white",this.underline=r||!1,this.italics=n||!1,this.background=i||"black",this.flash=o||!1}return e.prototype.reset=function(){this.foreground="white",this.underline=!1,this.italics=!1,this.background="black",this.flash=!1},e.prototype.setStyles=function(e){for(var t=["foreground","underline","italics","background","flash"],r=0;r<t.length;r++){var n=t[r];e.hasOwnProperty(n)&&(this[n]=e[n])}},e.prototype.isDefault=function(){return"white"===this.foreground&&!this.underline&&!this.italics&&"black"===this.background&&!this.flash},e.prototype.equals=function(e){return this.foreground===e.foreground&&this.underline===e.underline&&this.italics===e.italics&&this.background===e.background&&this.flash===e.flash},e.prototype.copy=function(e){this.foreground=e.foreground,this.underline=e.underline,this.italics=e.italics,this.background=e.background,this.flash=e.flash},e.prototype.toString=function(){return"color="+this.foreground+", underline="+this.underline+", italics="+this.italics+", background="+this.background+", flash="+this.flash},e}(),dr=function(){function e(t,r,n,i,o,a){de(this,e),this.uchar=t||" ",this.penState=new fr(r,n,i,o,a)}return e.prototype.reset=function(){this.uchar=" ",this.penState.reset()},e.prototype.setChar=function(e,t){this.uchar=e,this.penState.copy(t)},e.prototype.setPenState=function(e){this.penState.copy(e)},e.prototype.equals=function(e){return this.uchar===e.uchar&&this.penState.equals(e.penState)},e.prototype.copy=function(e){this.uchar=e.uchar,this.penState.copy(e.penState)},e.prototype.isEmpty=function(){return" "===this.uchar&&this.penState.isDefault()},e}(),hr=function(){function e(){de(this,e),this.chars=[];for(var t=0;t<nr;t++)this.chars.push(new dr);this.pos=0,this.currPenState=new fr}return e.prototype.equals=function(e){for(var t=!0,r=0;r<nr;r++)if(!this.chars[r].equals(e.chars[r])){t=!1;break}return t},e.prototype.copy=function(e){for(var t=0;t<nr;t++)this.chars[t].copy(e.chars[t])},e.prototype.isEmpty=function(){for(var e=!0,t=0;t<nr;t++)if(!this.chars[t].isEmpty()){e=!1;break}return e},e.prototype.setCursor=function(e){this.pos!==e&&(this.pos=e),this.pos<0?(cr.log("ERROR","Negative cursor position "+this.pos),this.pos=0):this.pos>nr&&(cr.log("ERROR","Too large cursor position "+this.pos),this.pos=nr)},e.prototype.moveCursor=function(e){var t=this.pos+e;if(e>1)for(var r=this.pos+1;r<t+1;r++)this.chars[r].setPenState(this.currPenState);this.setCursor(t)},e.prototype.backSpace=function(){this.moveCursor(-1),this.chars[this.pos].setChar(" ",this.currPenState)},e.prototype.insertChar=function(e){e>=144&&this.backSpace();var t=tr(e);if(this.pos>=nr)return void cr.log("ERROR","Cannot insert "+e.toString(16)+" ("+t+") at position "+this.pos+". Skipping it!");this.chars[this.pos].setChar(t,this.currPenState),this.moveCursor(1)},e.prototype.clearFromPos=function(e){var t;for(t=e;t<nr;t++)this.chars[t].reset()},e.prototype.clear=function(){this.clearFromPos(0),this.pos=0,this.currPenState.reset()},e.prototype.clearToEndOfRow=function(){this.clearFromPos(this.pos)},e.prototype.getTextString=function(){for(var e=[],t=!0,r=0;r<nr;r++){var n=this.chars[r].uchar;" "!==n&&(t=!1),e.push(n)}return t?"":e.join("")},e.prototype.setPenStyles=function(e){this.currPenState.setStyles(e),this.chars[this.pos].setPenState(this.currPenState)},e}(),pr=function(){function e(){de(this,e),this.rows=[];for(var t=0;t<rr;t++)this.rows.push(new hr);this.currRow=rr-1,this.nrRollUpRows=null,this.reset()}return e.prototype.reset=function(){for(var e=0;e<rr;e++)this.rows[e].clear();this.currRow=rr-1},e.prototype.equals=function(e){for(var t=!0,r=0;r<rr;r++)if(!this.rows[r].equals(e.rows[r])){t=!1;break}return t},e.prototype.copy=function(e){for(var t=0;t<rr;t++)this.rows[t].copy(e.rows[t])},e.prototype.isEmpty=function(){for(var e=!0,t=0;t<rr;t++)if(!this.rows[t].isEmpty()){e=!1;break}return e},e.prototype.backSpace=function(){this.rows[this.currRow].backSpace()},e.prototype.clearToEndOfRow=function(){this.rows[this.currRow].clearToEndOfRow()},e.prototype.insertChar=function(e){this.rows[this.currRow].insertChar(e)},e.prototype.setPen=function(e){this.rows[this.currRow].setPenStyles(e)},e.prototype.moveCursor=function(e){this.rows[this.currRow].moveCursor(e)},e.prototype.setCursor=function(e){cr.log("INFO","setCursor: "+e),this.rows[this.currRow].setCursor(e)},e.prototype.setPAC=function(e){cr.log("INFO","pacData = "+JSON.stringify(e));var t=e.row-1;if(this.nrRollUpRows&&t<this.nrRollUpRows-1&&(t=this.nrRollUpRows-1),this.nrRollUpRows&&this.currRow!==t){for(var r=0;r<rr;r++)this.rows[r].clear();var n=this.currRow+1-this.nrRollUpRows,i=this.lastOutputScreen;if(i){var o=i.rows[n].cueStartTime;if(o&&o<cr.time)for(var a=0;a<this.nrRollUpRows;a++)this.rows[t-this.nrRollUpRows+a+1].copy(i.rows[n+a])}}this.currRow=t;var s=this.rows[this.currRow];if(null!==e.indent){var u=e.indent,c=Math.max(u-1,0);s.setCursor(e.indent),e.color=s.chars[c].penState.foreground}var l={foreground:e.color,underline:e.underline,italics:e.italics,background:"black",flash:!1};this.setPen(l)},e.prototype.setBkgData=function(e){cr.log("INFO","bkgData = "+JSON.stringify(e)),this.backSpace(),this.setPen(e),this.insertChar(32)},e.prototype.setRollUpRows=function(e){this.nrRollUpRows=e},e.prototype.rollUp=function(){if(null===this.nrRollUpRows)return void cr.log("DEBUG","roll_up but nrRollUpRows not set yet");cr.log("TEXT",this.getDisplayText());var e=this.currRow+1-this.nrRollUpRows,t=this.rows.splice(e,1)[0];t.clear(),this.rows.splice(this.currRow,0,t),cr.log("INFO","Rolling up")},e.prototype.getDisplayText=function(e){e=e||!1;for(var t=[],r="",n=-1,i=0;i<rr;i++){var o=this.rows[i].getTextString();o&&(n=i+1,e?t.push("Row "+n+": '"+o+"'"):t.push(o.trim()))}return t.length>0&&(r=e?"["+t.join(" | ")+"]":t.join("\n")),r},e.prototype.getTextAndFormat=function(){return this.rows},e}(),yr=function(){function e(t,r){de(this,e),this.chNr=t,this.outputFilter=r,this.mode=null,this.verbose=0,this.displayedMemory=new pr,this.nonDisplayedMemory=new pr,this.lastOutputScreen=new pr,this.currRollUpRow=this.displayedMemory.rows[rr-1],this.writeScreen=this.displayedMemory,this.mode=null,this.cueStartTime=null}return e.prototype.reset=function(){this.mode=null,this.displayedMemory.reset(),this.nonDisplayedMemory.reset(),this.lastOutputScreen.reset(),this.currRollUpRow=this.displayedMemory.rows[rr-1],this.writeScreen=this.displayedMemory,this.mode=null,this.cueStartTime=null,this.lastCueEndTime=null},e.prototype.getHandler=function(){return this.outputFilter},e.prototype.setHandler=function(e){this.outputFilter=e},e.prototype.setPAC=function(e){this.writeScreen.setPAC(e)},e.prototype.setBkgData=function(e){this.writeScreen.setBkgData(e)},e.prototype.setMode=function(e){e!==this.mode&&(this.mode=e,cr.log("INFO","MODE="+e),"MODE_POP-ON"===this.mode?this.writeScreen=this.nonDisplayedMemory:(this.writeScreen=this.displayedMemory,this.writeScreen.reset()),"MODE_ROLL-UP"!==this.mode&&(this.displayedMemory.nrRollUpRows=null,this.nonDisplayedMemory.nrRollUpRows=null),this.mode=e)},e.prototype.insertChars=function(e){for(var t=0;t<e.length;t++)this.writeScreen.insertChar(e[t]);var r=this.writeScreen===this.displayedMemory?"DISP":"NON_DISP";cr.log("INFO",r+": "+this.writeScreen.getDisplayText(!0)),"MODE_PAINT-ON"!==this.mode&&"MODE_ROLL-UP"!==this.mode||(cr.log("TEXT","DISPLAYED: "+this.displayedMemory.getDisplayText(!0)),this.outputDataUpdate())},e.prototype.ccRCL=function(){cr.log("INFO","RCL - Resume Caption Loading"),this.setMode("MODE_POP-ON")},e.prototype.ccBS=function(){cr.log("INFO","BS - BackSpace"),"MODE_TEXT"!==this.mode&&(this.writeScreen.backSpace(),this.writeScreen===this.displayedMemory&&this.outputDataUpdate())},e.prototype.ccAOF=function(){},e.prototype.ccAON=function(){},e.prototype.ccDER=function(){cr.log("INFO","DER- Delete to End of Row"),this.writeScreen.clearToEndOfRow(),this.outputDataUpdate()},e.prototype.ccRU=function(e){cr.log("INFO","RU("+e+") - Roll Up"),this.writeScreen=this.displayedMemory,this.setMode("MODE_ROLL-UP"),this.writeScreen.setRollUpRows(e)},e.prototype.ccFON=function(){cr.log("INFO","FON - Flash On"),this.writeScreen.setPen({flash:!0})},e.prototype.ccRDC=function(){cr.log("INFO","RDC - Resume Direct Captioning"),this.setMode("MODE_PAINT-ON")},e.prototype.ccTR=function(){cr.log("INFO","TR"),this.setMode("MODE_TEXT")},e.prototype.ccRTD=function(){cr.log("INFO","RTD"),this.setMode("MODE_TEXT")},e.prototype.ccEDM=function(){cr.log("INFO","EDM - Erase Displayed Memory"),this.displayedMemory.reset(),this.outputDataUpdate(!0)},e.prototype.ccCR=function(){cr.log("CR - Carriage Return"),this.writeScreen.rollUp(),this.outputDataUpdate(!0)},e.prototype.ccENM=function(){cr.log("INFO","ENM - Erase Non-displayed Memory"),this.nonDisplayedMemory.reset()},e.prototype.ccEOC=function(){if(cr.log("INFO","EOC - End Of Caption"),"MODE_POP-ON"===this.mode){var e=this.displayedMemory;this.displayedMemory=this.nonDisplayedMemory,this.nonDisplayedMemory=e,this.writeScreen=this.nonDisplayedMemory,cr.log("TEXT","DISP: "+this.displayedMemory.getDisplayText())}this.outputDataUpdate(!0)},e.prototype.ccTO=function(e){cr.log("INFO","TO("+e+") - Tab Offset"),this.writeScreen.moveCursor(e)},e.prototype.ccMIDROW=function(e){var t={flash:!1};if(t.underline=e%2==1,t.italics=e>=46,t.italics)t.foreground="white";else{var r=Math.floor(e/2)-16,n=["white","green","blue","cyan","red","yellow","magenta"];t.foreground=n[r]}cr.log("INFO","MIDROW: "+JSON.stringify(t)),this.writeScreen.setPen(t)},e.prototype.outputDataUpdate=function(){var e=arguments.length>0&&arguments[0]!==undefined&&arguments[0],t=cr.time;null!==t&&this.outputFilter&&(null!==this.cueStartTime||this.displayedMemory.isEmpty()?this.displayedMemory.equals(this.lastOutputScreen)||(this.outputFilter.newCue&&(this.outputFilter.newCue(this.cueStartTime,t,this.lastOutputScreen),!0===e&&this.outputFilter.dispatchCue&&this.outputFilter.dispatchCue()),this.cueStartTime=this.displayedMemory.isEmpty()?null:t):this.cueStartTime=t,this.lastOutputScreen.copy(this.displayedMemory))},e.prototype.cueSplitAtTime=function(e){this.outputFilter&&(this.displayedMemory.isEmpty()||(this.outputFilter.newCue&&this.outputFilter.newCue(this.cueStartTime,e,this.displayedMemory),this.cueStartTime=e))},e}(),gr=function(){function e(t,r,n){de(this,e),this.field=t||1,this.outputs=[r,n],this.channels=[new yr(1,r),new yr(2,n)],this.currChNr=-1,this.lastCmdA=null,this.lastCmdB=null,this.bufferedData=[],this.startTime=null,this.lastTime=null,this.dataCounters={padding:0,"char":0,cmd:0,other:0}}return e.prototype.getHandler=function(e){return this.channels[e].getHandler()},e.prototype.setHandler=function(e,t){this.channels[e].setHandler(t)},e.prototype.addData=function(e,t){var r,n,i,o=!1;this.lastTime=e,cr.setTime(e);for(var a=0;a<t.length;a+=2)if(n=127&t[a],i=127&t[a+1],0!==n||0!==i){if(cr.log("DATA","["+lr([t[a],t[a+1]])+"] -> ("+lr([n,i])+")"),r=this.parseCmd(n,i),r||(r=this.parseMidrow(n,i)),r||(r=this.parsePAC(n,i)),r||(r=this.parseBackgroundAttributes(n,i)),!r&&(o=this.parseChars(n,i)))if(this.currChNr&&this.currChNr>=0){var s=this.channels[this.currChNr-1];s.insertChars(o)}else cr.log("WARNING","No channel found yet. TEXT-MODE?");r?this.dataCounters.cmd+=2:o?this.dataCounters["char"]+=2:(this.dataCounters.other+=2,cr.log("WARNING","Couldn't parse cleaned data "+lr([n,i])+" orig: "+lr([t[a],t[a+1]])))}else this.dataCounters.padding+=2},e.prototype.parseCmd=function(e,t){var r=null,n=(20===e||28===e)&&32<=t&&t<=47,i=(23===e||31===e)&&33<=t&&t<=35;if(!n&&!i)return!1;if(e===this.lastCmdA&&t===this.lastCmdB)return this.lastCmdA=null,this.lastCmdB=null,cr.log("DEBUG","Repeated command ("+lr([e,t])+") is dropped"),!0;r=20===e||23===e?1:2;var o=this.channels[r-1];return 20===e||28===e?32===t?o.ccRCL():33===t?o.ccBS():34===t?o.ccAOF():35===t?o.ccAON():36===t?o.ccDER():37===t?o.ccRU(2):38===t?o.ccRU(3):39===t?o.ccRU(4):40===t?o.ccFON():41===t?o.ccRDC():42===t?o.ccTR():43===t?o.ccRTD():44===t?o.ccEDM():45===t?o.ccCR():46===t?o.ccENM():47===t&&o.ccEOC():o.ccTO(t-32),this.lastCmdA=e,this.lastCmdB=t,this.currChNr=r,!0},e.prototype.parseMidrow=function(e,t){var r=null;if((17===e||25===e)&&32<=t&&t<=47){if((r=17===e?1:2)!==this.currChNr)return cr.log("ERROR","Mismatch channel in midrow parsing"),!1;return this.channels[r-1].ccMIDROW(t),cr.log("DEBUG","MIDROW ("+lr([e,t])+")"),!0}return!1},e.prototype.parsePAC=function(e,t){var r=null,n=null,i=(17<=e&&e<=23||25<=e&&e<=31)&&64<=t&&t<=127,o=(16===e||24===e)&&64<=t&&t<=95;if(!i&&!o)return!1;if(e===this.lastCmdA&&t===this.lastCmdB)return this.lastCmdA=null,this.lastCmdB=null,!0;r=e<=23?1:2,n=64<=t&&t<=95?1===r?ir[e]:ar[e]:1===r?or[e]:sr[e];var a=this.interpretPAC(n,t);return this.channels[r-1].setPAC(a),this.lastCmdA=e,this.lastCmdB=t,this.currChNr=r,!0},e.prototype.interpretPAC=function(e,t){var r=t,n={color:null,italics:!1,indent:null,underline:!1,row:e};return r=t>95?t-96:t-64,n.underline=1==(1&r),r<=13?n.color=["white","green","blue","cyan","red","yellow","magenta","white"][Math.floor(r/2)]:r<=15?(n.italics=!0,n.color="white"):n.indent=4*Math.floor((r-16)/2),n},e.prototype.parseChars=function(e,t){var r=null,n=null,i=null;if(e>=25?(r=2,i=e-8):(r=1,i=e),17<=i&&i<=19){var o=t;o=17===i?t+80:18===i?t+112:t+144,cr.log("INFO","Special char '"+tr(o)+"' in channel "+r),n=[o]}else 32<=e&&e<=127&&(n=0===t?[e]:[e,t]);if(n){var a=lr(n);cr.log("DEBUG","Char codes =  "+a.join(",")),this.lastCmdA=null,this.lastCmdB=null}return n},e.prototype.parseBackgroundAttributes=function(e,t){var r,n,i,o,a=(16===e||24===e)&&32<=t&&t<=47,s=(23===e||31===e)&&45<=t&&t<=47;return!(!a&&!s)&&(r={},16===e||24===e?(n=Math.floor((t-32)/2),r.background=ur[n],t%2==1&&(r.background=r.background+"_semi")):45===t?r.background="transparent":(r.foreground="black",47===t&&(r.underline=!0)),i=e<24?1:2,o=this.channels[i-1],o.setBkgData(r),this.lastCmdA=null,this.lastCmdB=null,!0)},e.prototype.reset=function(){for(var e=0;e<this.channels.length;e++)this.channels[e]&&this.channels[e].reset();this.lastCmdA=null,this.lastCmdB=null},e.prototype.cueSplitAtTime=function(e){for(var t=0;t<this.channels.length;t++)this.channels[t]&&this.channels[t].cueSplitAtTime(e)},e}(),mr=gr,_r=function(){function e(t,r){he(this,e),this.timelineController=t,this.track=r,this.startTime=null,this.endTime=null,this.screen=null}return e.prototype.dispatchCue=function(){null!==this.startTime&&(this.timelineController.addCues("textTrack"+this.track,this.startTime,this.endTime,this.screen),this.startTime=null)},e.prototype.newCue=function(e,t,r){(null===this.startTime||this.startTime>e)&&(this.startTime=e),this.endTime=t,this.screen=r,this.timelineController.createCaptionsTrack(this.track)},e}(),vr=_r,br=function(e,t,r){return e.substr(r||0,t.length)===t},$r=function(e){var t=parseInt(e.substr(-3)),r=parseInt(e.substr(-6,2)),n=parseInt(e.substr(-9,2)),i=e.length>9?parseInt(e.substr(0,e.indexOf(":"))):0;return isNaN(t)||isNaN(r)||isNaN(n)||isNaN(i)?-1:(t+=1e3*r,t+=6e4*n,t+=36e5*i)},wr=function(e){for(var t=5381,r=e.length;r;)t=33*t^e.charCodeAt(--r);return(t>>>0).toString()},Er=function(e,t,r){var n=e[t],i=e[n.prevCC];if(!i||!i["new"]&&n["new"])return e.ccOffset=e.presentationOffset=n.start,void(n["new"]=!1);for(;i&&i["new"];)e.ccOffset+=n.start-i.start,n["new"]=!1,n=i,i=e[n.prevCC];e.presentationOffset=r},Sr={parse:function(e,t,r,n,i,o){var a=/\r\n|\n\r|\n|\r/g,s=Object(wt.b)(new Uint8Array(e)).trim().replace(a,"\n").split("\n"),u="00:00.000",c=0,l=0,f=0,d=[],h=void 0,p=!0,y=new qt;y.oncue=function(e){var t=r[n],i=r.ccOffset;t&&t["new"]&&(l!==undefined?i=r.ccOffset=t.start:Er(r,n,f)),f&&(i=f+r.ccOffset-r.presentationOffset),e.startTime+=i-l,e.endTime+=i-l,e.id=wr(e.startTime.toString())+wr(e.endTime.toString())+wr(e.text),e.text=decodeURIComponent(encodeURIComponent(e.text)),e.endTime>0&&d.push(e)},y.onparsingerror=function(e){h=e},y.onflush=function(){if(h&&o)return void o(h);i(d)},s.forEach(function(e){if(p){if(br(e,"X-TIMESTAMP-MAP=")){p=!1,e.substr(16).split(",").forEach(function(e){br(e,"LOCAL:")?u=e.substr(6):br(e,"MPEGTS:")&&(c=parseInt(e.substr(7)))});try{t=t<0?t+8589934592:t,c-=t,l=$r(u)/1e3,f=c/9e4,-1===l&&(h=new Error("Malformed X-TIMESTAMP-MAP: "+e))}catch(e){h=new Error("Malformed X-TIMESTAMP-MAP: "+e)}return}""===e&&(p=!1)}y.parse(e+"\n")}),y.flush()}},Or=Sr,Tr=function(e){function t(r){pe(this,t);var n=ye(this,e.call(this,r,Ie.a.MEDIA_ATTACHING,Ie.a.MEDIA_DETACHING,Ie.a.FRAG_PARSING_USERDATA,Ie.a.FRAG_DECRYPTED,Ie.a.MANIFEST_LOADING,Ie.a.MANIFEST_LOADED,Ie.a.FRAG_LOADED,Ie.a.LEVEL_SWITCHING,Ie.a.INIT_PTS_FOUND));if(n.hls=r,n.config=r.config,n.enabled=!0,n.Cues=r.config.cueHandler,n.textTracks=[],n.tracks=[],n.unparsedVttFrags=[],n.initPTS=undefined,n.cueRanges=[],n.config.enableCEA708Captions){var i=new vr(n,1),o=new vr(n,2);n.cea608Parser=new mr(0,i,o)}return n}return ge(t,e),t.prototype.addCues=function(e,t,r,n){for(var i=this.cueRanges,o=!1,a=i.length;a--;){var s=i[a],u=ve(s[0],s[1],t,r);if(u>=0&&(s[0]=Math.min(s[0],t),s[1]=Math.max(s[1],r),o=!0,u/(r-t)>.5))return}o||i.push([t,r]),this.Cues.newCue(this[e],t,r,n)},t.prototype.onInitPtsFound=function(e){var t=this;"undefined"==typeof this.initPTS&&(this.initPTS=e.initPTS),this.unparsedVttFrags.length&&(this.unparsedVttFrags.forEach(function(e){t.onFragLoaded(e)}),this.unparsedVttFrags=[])},t.prototype.getExistingTrack=function(e){var t=this.media;if(t)for(var r=0;r<t.textTracks.length;r++){var n=t.textTracks[r],i="textTrack"+e;if(!0===n[i])return n}return null},t.prototype.sendAddTrackEvent=function(e,t){var r=null;try{r=new window.Event("addtrack")}catch(n){r=document.createEvent("Event"),r.initEvent("addtrack",!1,!1)}r.track=e,t.dispatchEvent(r)},t.prototype.createCaptionsTrack=function(e){var t="textTrack"+e;if(!this[t]){var r=this.getExistingTrack(e);if(r)this[t]=r,me(this[t]),this.sendAddTrackEvent(this[t],this.media);else{var n=this.createTextTrack("captions",this.config["captionsTextTrack"+e+"Label"],this.config.captionsTextTrack1LanguageCode);n&&(n[t]=!0,this[t]=n)}}},t.prototype.createTextTrack=function(e,t,r){var n=this.media;if(n)return n.addTextTrack(e,t,r)},t.prototype.destroy=function(){je.prototype.destroy.call(this)},t.prototype.onMediaAttaching=function(e){this.media=e.media,this._cleanTracks()},t.prototype.onMediaDetaching=function(){me(this.textTrack1),me(this.textTrack2)},t.prototype.onManifestLoading=function(){this.lastSn=-1,this.prevCC=-1,this.vttCCs={ccOffset:0,presentationOffset:0},this._cleanTracks()},t.prototype._cleanTracks=function(){var e=this.media;if(e){var t=e.textTracks;if(t)for(var r=0;r<t.length;r++)me(t[r])}},t.prototype.onManifestLoaded=function(e){var t=this;if(this.textTracks=[],this.unparsedVttFrags=this.unparsedVttFrags||[],this.initPTS=undefined,this.cueRanges=[],this.config.enableWebVTT){this.tracks=e.subtitles||[];var r=this.media?this.media.textTracks:[];this.tracks.forEach(function(e,n){var i=void 0;if(n<r.length){var o=r[n];_e(o,e)&&(i=o)}i||(i=t.createTextTrack("subtitles",e.name,e.lang)),i.mode=e["default"]?"showing":"hidden",t.textTracks.push(i)})}},t.prototype.onLevelSwitching=function(){this.enabled="NONE"!==this.hls.currentLevel.closedCaptions},t.prototype.onFragLoaded=function(e){var t=e.frag,r=e.payload;if("main"===t.type){var n=t.sn;if(n!==this.lastSn+1){var i=this.cea608Parser;i&&i.reset()}this.lastSn=n}else if("subtitle"===t.type)if(r.byteLength){if("undefined"==typeof this.initPTS)return void this.unparsedVttFrags.push(e);var o=t.decryptdata;null!=o&&null!=o.key&&"AES-128"===o.method||this._parseVTTs(t,r)}else this.hls.trigger(Ie.a.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:t})},t.prototype._parseVTTs=function(e,t){var r=this.vttCCs;r[e.cc]||(r[e.cc]={start:e.start,prevCC:this.prevCC,"new":!0},this.prevCC=e.cc);var n=this.textTracks,i=this.hls;Or.parse(t,this.initPTS,r,e.cc,function(t){var r=n[e.trackId];t.forEach(function(e){if(!r.cues.getCueById(e.id))try{r.addCue(e)}catch(n){var t=new window.TextTrackCue(e.startTime,e.endTime,e.text);t.id=e.id,r.addCue(t)}}),i.trigger(Ie.a.SUBTITLE_FRAG_PROCESSED,{success:!0,frag:e})},function(t){Me.b.log("Failed to parse VTT cue: "+t),i.trigger(Ie.a.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:e})})},t.prototype.onFragDecrypted=function(e){var t=e.payload,r=e.frag;if("subtitle"===r.type){if("undefined"==typeof this.initPTS)return void this.unparsedVttFrags.push(e);this._parseVTTs(r,t)}},t.prototype.onFragParsingUserdata=function(e){if(this.enabled&&this.config.enableCEA708Captions)for(var t=0;t<e.samples.length;t++){var r=this.extractCea608Data(e.samples[t].bytes);this.cea608Parser.addData(e.samples[t].pts,r)}},t.prototype.extractCea608Data=function(e){for(var t,r,n,i,o,a=31&e[0],s=2,u=[],c=0;c<a;c++)t=e[s++],r=127&e[s++],n=127&e[s++],i=0!=(4&t),o=3&t,0===r&&0===n||i&&0===o&&(u.push(r),u.push(n));return u},t}(je),Ar=Tr,xr=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),kr=function(e){function t(r){be(this,t);var n=$e(this,e.call(this,r,Ie.a.MEDIA_ATTACHED,Ie.a.MEDIA_DETACHING,Ie.a.MANIFEST_LOADING,Ie.a.MANIFEST_LOADED,Ie.a.SUBTITLE_TRACK_LOADED));return n.tracks=[],n.trackId=-1,n.media=undefined,n.subtitleDisplay=!1,n}return we(t,e),t.prototype._onTextTracksChanged=function(){if(this.media){for(var e=-1,t=Ee(this.media.textTracks),r=0;r<t.length;r++)"showing"===t[r].mode&&(e=r);this.subtitleTrack=e}},t.prototype.destroy=function(){je.prototype.destroy.call(this)},t.prototype.onMediaAttached=function(e){var t=this;this.media=e.media,this.media&&(this.queuedDefaultTrack!==undefined&&(this.subtitleTrack=this.queuedDefaultTrack,delete this.queuedDefaultTrack),this.trackChangeListener=this._onTextTracksChanged.bind(this),this.useTextTrackPolling=!(this.media.textTracks&&"onchange"in this.media.textTracks),this.useTextTrackPolling?this.subtitlePollingInterval=setInterval(function(){t.trackChangeListener()},500):this.media.textTracks.addEventListener("change",this.trackChangeListener))},t.prototype.onMediaDetaching=function(){this.media&&(this.useTextTrackPolling?clearInterval(this.subtitlePollingInterval):this.media.textTracks.removeEventListener("change",this.trackChangeListener),this.media=undefined)},t.prototype.onManifestLoading=function(){this.tracks=[],this.trackId=-1},t.prototype.onManifestLoaded=function(e){var t=this,r=e.subtitles||[];this.tracks=r,this.trackId=-1,this.hls.trigger(Ie.a.SUBTITLE_TRACKS_UPDATED,{subtitleTracks:r}),r.forEach(function(e){e["default"]&&(t.media?t.subtitleTrack=e.id:t.queuedDefaultTrack=e.id)})},t.prototype.onTick=function(){var e=this.trackId,t=this.tracks[e];if(t){var r=t.details;r!==undefined&&!0!==r.live||(Me.b.log("(re)loading playlist for subtitle track "+e),this.hls.trigger(Ie.a.SUBTITLE_TRACK_LOADING,{url:t.url,id:e}))}},t.prototype.onSubtitleTrackLoaded=function(e){var t=this;e.id<this.tracks.length&&(Me.b.log("subtitle track "+e.id+" loaded"),this.tracks[e.id].details=e.details,e.details.live&&!this.timer&&(this.timer=setInterval(function(){t.onTick()},1e3*e.details.targetduration,this)),!e.details.live&&this.timer&&(clearInterval(this.timer),this.timer=null))},t.prototype.setSubtitleTrackInternal=function(e){if(!(e<-1||e>=this.tracks.length)){this.timer&&(clearInterval(this.timer),this.timer=null);var t=Ee(this.media.textTracks);if(-1!==this.trackId&&this.subtitleDisplay&&(t[this.trackId].mode="hidden"),this.trackId=e,Me.b.log("switching to subtitle track "+e),this.hls.trigger(Ie.a.SUBTITLE_TRACK_SWITCH,{id:e}),-1!==e){var r=this.tracks[e];this.subtitleDisplay&&(t[e].mode="showing");var n=r.details;n!==undefined&&!0!==n.live||(Me.b.log("(re)loading playlist for subtitle track "+e),this.hls.trigger(Ie.a.SUBTITLE_TRACK_LOADING,{url:r.url,id:e}))}}},xr(t,[{key:"subtitleTracks",get:function(){return this.tracks}},{key:"subtitleTrack",get:function(){return this.trackId},set:function(e){this.trackId!==e&&this.setSubtitleTrackInternal(e)}}]),t}(je),Dr=kr,Ir=n(4),Pr={STOPPED:"STOPPED",IDLE:"IDLE",KEY_LOADING:"KEY_LOADING",FRAG_LOADING:"FRAG_LOADING"},Mr=function(e){function t(r){Se(this,t);var n=Oe(this,e.call(this,r,Ie.a.MEDIA_ATTACHED,Ie.a.ERROR,Ie.a.KEY_LOADED,Ie.a.FRAG_LOADED,Ie.a.SUBTITLE_TRACKS_UPDATED,Ie.a.SUBTITLE_TRACK_SWITCH,Ie.a.SUBTITLE_TRACK_LOADED,Ie.a.SUBTITLE_FRAG_PROCESSED));return n.config=r.config,n.vttFragSNsProcessed={},n.vttFragQueues=undefined,n.currentlyProcessing=null,n.state=Pr.STOPPED,n.currentTrackId=-1,n.ticks=0,n.decrypter=new Ir.a(r.observer,r.config),n}return Te(t,e),t.prototype.destroy=function(){je.prototype.destroy.call(this),this.state=Pr.STOPPED},t.prototype.clearVttFragQueues=function(){var e=this;this.vttFragQueues={},this.tracks.forEach(function(t){e.vttFragQueues[t.id]=[]})},t.prototype.nextFrag=function(){if(null===this.currentlyProcessing&&this.currentTrackId>-1&&this.vttFragQueues[this.currentTrackId].length){var e=this.currentlyProcessing=this.vttFragQueues[this.currentTrackId].shift();this.fragCurrent=e,this.hls.trigger(Ie.a.FRAG_LOADING,{frag:e}),this.state=Pr.FRAG_LOADING}},t.prototype.onSubtitleFragProcessed=function(e){e.success&&this.vttFragSNsProcessed[e.frag.trackId].push(e.frag.sn),this.currentlyProcessing=null,this.state=Pr.IDLE,this.nextFrag()},t.prototype.onMediaAttached=function(){this.state=Pr.IDLE},t.prototype.onError=function(e){var t=e.frag;t&&"subtitle"!==t.type||this.currentlyProcessing&&(this.currentlyProcessing=null,this.nextFrag())},t.prototype.tick=function(){var e=this;1===++this.ticks&&(this.doTick(),this.ticks>1&&setTimeout(function(){e.tick()},1),this.ticks=0)},t.prototype.doTick=function(){var e=this;switch(this.state){case Pr.IDLE:var t=this.tracks,r=this.currentTrackId,n=this.vttFragSNsProcessed[r],i=this.vttFragQueues[r],o=this.currentlyProcessing?this.currentlyProcessing.sn:-1,a=function(e){return n.indexOf(e.sn)>-1},s=function(e){return i.some(function(t){return t.sn===e.sn})};if(!t)break;var u;if(r<t.length&&(u=t[r].details),void 0===u)break;u.fragments.forEach(function(t){a(t)||t.sn===o||s(t)||(t.decryptdata&&null!=t.decryptdata.uri&&null==t.decryptdata.key?(Me.b.log("Loading key for "+t.sn),e.state=Pr.KEY_LOADING,e.hls.trigger(Ie.a.KEY_LOADING,{frag:t})):(t.trackId=r,i.push(t),e.nextFrag()))})}},t.prototype.onSubtitleTracksUpdated=function(e){var t=this;Me.b.log("subtitle tracks updated"),this.tracks=e.subtitleTracks,this.clearVttFragQueues(),this.vttFragSNsProcessed={},this.tracks.forEach(function(e){t.vttFragSNsProcessed[e.id]=[]})},t.prototype.onSubtitleTrackSwitch=function(e){this.currentTrackId=e.id,this.clearVttFragQueues()},t.prototype.onSubtitleTrackLoaded=function(){this.tick()},t.prototype.onKeyLoaded=function(){this.state===Pr.KEY_LOADING&&(this.state=Pr.IDLE,this.tick())},t.prototype.onFragLoaded=function(e){var t=this.fragCurrent,r=e.frag.decryptdata,n=e.frag,i=this.hls;if(this.state===Pr.FRAG_LOADING&&t&&"subtitle"===e.frag.type&&t.sn===e.frag.sn&&e.payload.byteLength>0&&null!=r&&null!=r.key&&"AES-128"===r.method){
var o;try{o=performance.now()}catch(a){o=Date.now()}this.decrypter.decrypt(e.payload,r.key.buffer,r.iv.buffer,function(e){var t;try{t=performance.now()}catch(a){t=Date.now()}i.trigger(Ie.a.FRAG_DECRYPTED,{frag:n,payload:e,stats:{tstart:o,tdecrypt:t}})})}},t}(je),Rr=Mr,Cr={autoStartLoad:!0,startPosition:-1,defaultAudioCodec:undefined,debug:!1,capLevelOnFPSDrop:!1,capLevelToPlayerSize:!1,initialLiveManifestSize:1,maxBufferLength:30,maxBufferSize:6e7,maxBufferHole:.5,maxSeekHole:2,lowBufferWatchdogPeriod:.5,highBufferWatchdogPeriod:3,nudgeOffset:.1,nudgeMaxRetry:3,maxFragLookUpTolerance:.25,liveSyncDurationCount:3,liveMaxLatencyDurationCount:Infinity,liveSyncDuration:undefined,liveMaxLatencyDuration:undefined,maxMaxBufferLength:600,enableWorker:!0,enableSoftwareAES:!0,manifestLoadingTimeOut:1e4,manifestLoadingMaxRetry:1,manifestLoadingRetryDelay:1e3,manifestLoadingMaxRetryTimeout:64e3,startLevel:undefined,levelLoadingTimeOut:1e4,levelLoadingMaxRetry:4,levelLoadingRetryDelay:1e3,levelLoadingMaxRetryTimeout:64e3,fragLoadingTimeOut:2e4,fragLoadingMaxRetry:6,fragLoadingRetryDelay:1e3,fragLoadingMaxRetryTimeout:64e3,fragLoadingLoopThreshold:3,startFragPrefetch:!1,fpsDroppedMonitoringPeriod:5e3,fpsDroppedMonitoringThreshold:.2,appendErrorMaxRetry:3,loader:Ut,fLoader:undefined,pLoader:undefined,xhrSetup:undefined,fetchSetup:undefined,abrController:It,bufferController:Rt,capLevelController:Lt,fpsController:Ft,stretchShortVideoTrack:!1,maxAudioFramesDrift:1,forceKeyFrameOnDiscontinuity:!0,abrEwmaFastLive:3,abrEwmaSlowLive:9,abrEwmaFastVoD:3,abrEwmaSlowVoD:9,abrEwmaDefaultEstimate:5e5,abrBandWidthFactor:.95,abrBandWidthUpFactor:.7,abrMaxWithRealBitrate:!1,maxStarvationDelay:4,maxLoadingDelay:4,minAutoBitrate:0};Cr.subtitleStreamController=Rr,Cr.subtitleTrackController=Dr,Cr.timelineController=Ar,Cr.cueHandler=xe,Cr.enableCEA708Captions=!0,Cr.enableWebVTT=!0,Cr.captionsTextTrack1Label="English",Cr.captionsTextTrack1LanguageCode="en",Cr.captionsTextTrack2Label="Spanish",Cr.captionsTextTrack2LanguageCode="es",Cr.audioStreamController=Kt,Cr.audioTrackController=Wt;var jr=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),Lr=function(){function e(){var t=this,r=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};Ae(this,e);var n=e.DefaultConfig;if((r.liveSyncDurationCount||r.liveMaxLatencyDurationCount)&&(r.liveSyncDuration||r.liveMaxLatencyDuration))throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");for(var i in n)i in r||(r[i]=n[i]);if(r.liveMaxLatencyDurationCount!==undefined&&r.liveMaxLatencyDurationCount<=r.liveSyncDurationCount)throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');if(r.liveMaxLatencyDuration!==undefined&&(r.liveMaxLatencyDuration<=r.liveSyncDuration||r.liveSyncDuration===undefined))throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');Object(Me.a)(r.debug),this.config=r,this._autoLevelCapping=-1;var o=this.observer=new st.a;o.trigger=function(e){for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];o.emit.apply(o,[e,e].concat(r))},o.off=function(e){for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];o.removeListener.apply(o,[e].concat(r))},this.on=o.on.bind(o),this.off=o.off.bind(o),this.trigger=o.trigger.bind(o);var a=this.abrController=new r.abrController(this),s=new r.bufferController(this),u=new r.capLevelController(this),c=new r.fpsController(this),l=new Je(this),f=new Xe(this),d=new et(this),h=new St(this),p=this.levelController=new $t(this),y=this.streamController=new _t(this),g=[p,y],m=r.audioStreamController;m&&g.push(new m(this)),this.networkControllers=g;var _=[l,f,d,a,s,u,c,h];if(m=r.audioTrackController){var v=new m(this);this.audioTrackController=v,_.push(v)}if(m=r.subtitleTrackController){var b=new m(this);this.subtitleTrackController=b,_.push(b)}[r.subtitleStreamController,r.timelineController].forEach(function(e){e&&_.push(new e(t))}),this.coreComponents=_}return e.isSupported=function(){var e=_(),t=window.SourceBuffer||window.WebKitSourceBuffer,r=e&&"function"==typeof e.isTypeSupported&&e.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'),n=!t||t.prototype&&"function"==typeof t.prototype.appendBuffer&&"function"==typeof t.prototype.remove;return r&&n},jr(e,null,[{key:"version",get:function(){return"0.8.7"}},{key:"Events",get:function(){return Ie.a}},{key:"ErrorTypes",get:function(){return Pe.b}},{key:"ErrorDetails",get:function(){return Pe.a}},{key:"DefaultConfig",get:function(){return e.defaultConfig?e.defaultConfig:Cr},set:function(t){e.defaultConfig=t}}]),e.prototype.destroy=function(){Me.b.log("destroy"),this.trigger(Ie.a.DESTROYING),this.detachMedia(),this.coreComponents.concat(this.networkControllers).forEach(function(e){e.destroy()}),this.url=null,this.observer.removeAllListeners(),this._autoLevelCapping=-1},e.prototype.attachMedia=function(e){Me.b.log("attachMedia"),this.media=e,this.trigger(Ie.a.MEDIA_ATTACHING,{media:e})},e.prototype.detachMedia=function(){Me.b.log("detachMedia"),this.trigger(Ie.a.MEDIA_DETACHING),this.media=null},e.prototype.loadSource=function(e){e=De.a.buildAbsoluteURL(window.location.href,e,{alwaysNormalize:!0}),Me.b.log("loadSource:"+e),this.url=e,this.trigger(Ie.a.MANIFEST_LOADING,{url:e})},e.prototype.startLoad=function(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:-1;Me.b.log("startLoad("+e+")"),this.networkControllers.forEach(function(t){t.startLoad(e)})},e.prototype.stopLoad=function(){Me.b.log("stopLoad"),this.networkControllers.forEach(function(e){e.stopLoad()})},e.prototype.swapAudioCodec=function(){Me.b.log("swapAudioCodec"),this.streamController.swapAudioCodec()},e.prototype.recoverMediaError=function(){Me.b.log("recoverMediaError");var e=this.media;this.detachMedia(),this.attachMedia(e)},jr(e,[{key:"levels",get:function(){return this.levelController.levels}},{key:"currentLevel",get:function(){return this.streamController.currentLevel},set:function(e){Me.b.log("set currentLevel:"+e),this.loadLevel=e,this.streamController.immediateLevelSwitch()}},{key:"nextLevel",get:function(){return this.streamController.nextLevel},set:function(e){Me.b.log("set nextLevel:"+e),this.levelController.manualLevel=e,this.streamController.nextLevelSwitch()}},{key:"loadLevel",get:function(){return this.levelController.level},set:function(e){Me.b.log("set loadLevel:"+e),this.levelController.manualLevel=e}},{key:"nextLoadLevel",get:function(){return this.levelController.nextLoadLevel},set:function(e){this.levelController.nextLoadLevel=e}},{key:"firstLevel",get:function(){return Math.max(this.levelController.firstLevel,this.minAutoLevel)},set:function(e){Me.b.log("set firstLevel:"+e),this.levelController.firstLevel=e}},{key:"startLevel",get:function(){return this.levelController.startLevel},set:function(e){Me.b.log("set startLevel:"+e);var t=this;-1!==e&&(e=Math.max(e,t.minAutoLevel)),t.levelController.startLevel=e}},{key:"autoLevelCapping",get:function(){return this._autoLevelCapping},set:function(e){Me.b.log("set autoLevelCapping:"+e),this._autoLevelCapping=e}},{key:"autoLevelEnabled",get:function(){return-1===this.levelController.manualLevel}},{key:"manualLevel",get:function(){return this.levelController.manualLevel}},{key:"minAutoLevel",get:function(){for(var e=this,t=e.levels,r=e.config.minAutoBitrate,n=t?t.length:0,i=0;i<n;i++){if((t[i].realBitrate?Math.max(t[i].realBitrate,t[i].bitrate):t[i].bitrate)>r)return i}return 0}},{key:"maxAutoLevel",get:function(){var e=this,t=e.levels,r=e.autoLevelCapping;return-1===r&&t&&t.length?t.length-1:r}},{key:"nextAutoLevel",get:function(){var e=this;return Math.min(Math.max(e.abrController.nextAutoLevel,e.minAutoLevel),e.maxAutoLevel)},set:function(e){var t=this;t.abrController.nextAutoLevel=Math.max(t.minAutoLevel,e)}},{key:"audioTracks",get:function(){var e=this.audioTrackController;return e?e.audioTracks:[]}},{key:"audioTrack",get:function(){var e=this.audioTrackController;return e?e.audioTrack:-1},set:function(e){var t=this.audioTrackController;t&&(t.audioTrack=e)}},{key:"liveSyncPosition",get:function(){return this.streamController.liveSyncPosition}},{key:"subtitleTracks",get:function(){var e=this.subtitleTrackController;return e?e.subtitleTracks:[]}},{key:"subtitleTrack",get:function(){var e=this.subtitleTrackController;return e?e.subtitleTrack:-1},set:function(e){var t=this.subtitleTrackController;t&&(t.subtitleTrack=e)}},{key:"subtitleDisplay",get:function(){var e=this.subtitleTrackController;return!!e&&e.subtitleDisplay},set:function(e){var t=this.subtitleTrackController;t&&(t.subtitleDisplay=e)}}]),e}();r["default"]=Lr},function(e,t,r){function n(e){function t(n){if(r[n])return r[n].exports;var i=r[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var r={};t.m=e,t.c=r,t.i=function(e){return e},t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e["default"]}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t.oe=function(e){throw console.error(e),e};var n=t(t.s=ENTRY_MODULE);return n["default"]||n}function i(e){return(e+"").replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}function o(e){var t=[],r=e.toString(),n=r.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);if(!n)return t;for(var o,a=n[1],s=new RegExp("(\\\\n|\\W)"+i(a)+"\\((/\\*.*?\\*/)?s?.*?([\\.|\\-|\\w|/|@]+).*?\\)","g");o=s.exec(r);)t.push(o[3]);return t}function a(e,t){for(var r=[t],n=[],i={};r.length;){var a=r.pop();if(!i[a]&&e[a]){i[a]=!0,n.push(a);var s=o(e[a]);r=r.concat(s)}}return n}e.exports=function(e,t){t=t||{};var i=r.m,o=t.all?Object.keys(i):a(i,e),s="("+n.toString().replace("ENTRY_MODULE",JSON.stringify(e))+")({"+o.map(function(e){return JSON.stringify(e)+": "+i[e].toString()}).join(",")+"})(self);",u=new window.Blob([s],{type:"text/javascript"});if(t.bare)return u;var c=window.URL||window.webkitURL||window.mozURL||window.msURL,l=c.createObjectURL(u),f=new window.Worker(l);return f.objectURL=l,f}},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0});var n=r(7),i=r(1),o=r(0),a=r(5),s=r.n(a),u=function(e){var t=new s.a;t.trigger=function(e){for(var r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];t.emit.apply(t,[e,e].concat(n))},t.off=function(e){for(var r=arguments.length,n=Array(r>1?r-1:0),i=1;i<r;i++)n[i-1]=arguments[i];t.removeListener.apply(t,[e].concat(n))};var r=function(t,r){e.postMessage({event:t,data:r})};e.addEventListener("message",function(i){var a=i.data;switch(a.cmd){case"init":var s=JSON.parse(a.config);e.demuxer=new n.a(t,a.typeSupported,s,a.vendor);try{Object(o.a)(!0===s.debug)}catch(u){console.warn("demuxerWorker: unable to enable logs")}r("init",null);break;case"demux":e.demuxer.push(a.data,a.decryptdata,a.initSegment,a.audioCodec,a.videoCodec,a.timeOffset,a.discontinuity,a.trackSwitch,a.contiguous,a.duration,a.accurateTimeOffset,a.defaultInitPTS)}}),t.on(i.a.FRAG_DECRYPTED,r),t.on(i.a.FRAG_PARSING_INIT_SEGMENT,r),t.on(i.a.FRAG_PARSED,r),t.on(i.a.ERROR,r),t.on(i.a.FRAG_PARSING_METADATA,r),t.on(i.a.FRAG_PARSING_USERDATA,r),t.on(i.a.INIT_PTS_FOUND,r),t.on(i.a.FRAG_PARSING_DATA,function(t,r){var n=[],i={event:t,data:r};r.data1&&(i.data1=r.data1.buffer,n.push(r.data1.buffer),delete r.data1),r.data2&&(i.data2=r.data2.buffer,n.push(r.data2.buffer),delete r.data2),e.postMessage(i,n)})};t["default"]=u}])["default"]})}),HlsCore=unwrapExports(hls),defaultConfig$2={type:"vod",autoPlay:!1,box:"hls",lockInternalProperty:!1,debug:!0,enableWorker:!0},Hls=function(e){function t(e,r){_classCallCheck(this,t);var n=_possibleConstructorReturn(this,(t.__proto__||_Object$getPrototypeOf(t)).call(this));return n.tag="HLS-player",n.video=e,n.box="hls",n.config=deepAssign({},defaultConfig$2,r),n.hls=new HlsCore,n.bindEvents(n.hls),n.attachMedia(),n}return _inherits(t,e),_createClass(t,null,[{key:"isSupport",value:function(){return HlsCore.isSupported()}},{key:"version",get:function(){return"1.0.6"}}]),_createClass(t,[{key:"internalPropertyHandle",value:function(){if(_Object$getOwnPropertyDescriptor){var e=this,t=_Object$getOwnPropertyDescriptor(HTMLMediaElement.prototype,"currentTime");Object.defineProperty(this.video,"currentTime",{get:function(){return t.get.call(e.video)},set:function(r){if(e.currentTimeLock)return t.set.call(e.video,r);throw new Error("can not set currentTime by youself")}})}}},{key:"bindEvents",value:function(e){var t=this;e&&(e.on(HlsCore.Events.ERROR,function(e,t){}),e.on(HlsCore.Events.LEVEL,function(e,t){})),this.video&&this.config.lockInternalProperty&&this.video.addEventListener("canplay",function(){t.internalPropertyHandle()})}},{key:"load",value:function(){this.hls.loadSource(this.config.src)}},{key:"attachMedia",value:function(){this.hls.attachMedia(this.video)}},{key:"play",value:function(){return this.video.play()}},{key:"destroy",value:function(){return this.hls.destroy()}},{key:"seek",value:function(e){this.currentTimeLock=!0,this._seek(e),this.currentTimeLock=!1}},{key:"_seek",value:function(e){this.video.currentTime=e}},{key:"pause",value:function(){return this.video.pause()}},{key:"refresh",value:function(){this.hls.stopLoad(),this.hls.loadSource(this.config.src)}}]),t}(CustEvent),lib=createCommonjsModule(function(module,exports){!function(e,t){module.exports=t()}(0,function(){return function(e){function t(n){if(r[n])return r[n].exports;var i=r[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e["default"]}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=6)}([function(e,t,r){!function(e,r){!function(e){function t(e){return e&&e.__esModule?e["default"]:e}function r(e,t){return t={exports:{}},e(t,t.exports),t.exports}function n(e){return Array.isArray(e)}function i(e){return"function"==typeof e}function o(e){return Object(e)===e&&"[object Object]"===String(e)&&!i(e)&&!n(e)}function a(e,t){var r=e.__evt_id;r||(Object.defineProperty(e,"__evt_id",{writable:!0,enumerable:!1,configurable:!0}),r=e.__evt_id=++pr.count);var n=r+"_"+t,i=pr[n];return i||(i=pr[n]=[]),i}function s(e,t,r){var n=Qt(null);n.type=t,n.target=e,r&&Yt(n,o(r)?r:{data:r}),a(e,t).forEach(function(t){(t[1]||t[0]).apply(e,[n])})}function u(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],o=arguments[4];i(n)&&!o&&(o=n,n=undefined);var s=[r,undefined,n];n&&!o&&(o=function(){c(e,t,r,n);for(var i=arguments.length,o=Array(i),a=0;a<i;a++)o[a]=arguments[a];r.apply(e,o)}),o&&(s[1]=o),a(e,t).push(s)}function c(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=a(e,t);if(r||n){var o=-1,s=void 0;return i.find(function(e,t){if((!r||e[0]===r)&&(!n||e[2]))return o=t,s=e[1],!0}),-1!==o&&i.splice(o,1),s}i.length=0}var l=Math.ceil,f=Math.floor,d=function(e){return isNaN(e=+e)?0:(e>0?f:l)(e)},h=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e},p=r(function(e){var t=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=t)}),y=r(function(e){var t=e.exports={version:"2.4.0"};"number"==typeof __e&&(__e=t)}),g=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e},m=function(e,t,r){if(g(e),t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,i){return e.call(t,r,n,i)}}return function(){return e.apply(t,arguments)}},_=function(e){return"object"==typeof e?null!==e:"function"==typeof e},v=function(e){if(!_(e))throw TypeError(e+" is not an object!");return e},b=function(e){try{return!!e()}catch(e){return!0}},$=!b(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),w=p.document,E=_(w)&&_(w.createElement),S=function(e){return E?w.createElement(e):{}},O=!$&&!b(function(){return 7!=Object.defineProperty(S("div"),"a",{get:function(){return 7}}).a}),T=function(e,t){if(!_(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!_(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!_(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!_(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")},A=Object.defineProperty,x=$?Object.defineProperty:function(e,t,r){if(v(e),t=T(t,!0),v(r),O)try{return A(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(e[t]=r.value),e},k={f:x},D=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},I=$?function(e,t,r){return k.f(e,t,D(1,r))}:function(e,t,r){return e[t]=r,e},P=function(e,t,r){var n,i,o,a=e&P.F,s=e&P.G,u=e&P.S,c=e&P.P,l=e&P.B,f=e&P.W,d=s?y:y[t]||(y[t]={}),h=d.prototype,g=s?p:u?p[t]:(p[t]||{}).prototype;s&&(r=t);for(n in r)(i=!a&&g&&g[n]!==undefined)&&n in d||(o=i?g[n]:r[n],d[n]=s&&"function"!=typeof g[n]?r[n]:l&&i?m(o,p):f&&g[n]==o?function(e){var t=function(t,r,n){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,n)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(o):c&&"function"==typeof o?m(Function.call,o):o,c&&((d.virtual||(d.virtual={}))[n]=o,e&P.R&&h&&!h[n]&&I(h,n,o)))};P.F=1,P.G=2,P.S=4,P.P=8,P.B=16,P.W=32,P.U=64,P.R=128;var M=P,R=I,C={}.hasOwnProperty,j=function(e,t){return C.call(e,t)},L={}.toString,N=function(e){return L.call(e).slice(8,-1)},F=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==N(e)?e.split(""):Object(e)},B=function(e){return F(h(e))},U=Math.min,z=function(e){return e>0?U(d(e),9007199254740991):0},G=Math.max,W=Math.min,H=function(e,t){return e=d(e),e<0?G(e+t,0):W(e,t)},V=p["__core-js_shared__"]||(p["__core-js_shared__"]={}),Y=function(e){return V[e]||(V[e]={})},K=0,Z=Math.random(),J=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++K+Z).toString(36))},Q=Y("keys"),X=function(e){return Q[e]||(Q[e]=J(e))},q=function(e){return function(t,r,n){var i,o=B(t),a=z(o.length),s=H(n,a);if(e&&r!=r){for(;a>s;)if((i=o[s++])!=i)return!0}else for(;a>s;s++)if((e||s in o)&&o[s]===r)return e||s||0;return!e&&-1}}(!1),ee=X("IE_PROTO"),te=function(e,t){var r,n=B(e),i=0,o=[];for(r in n)r!=ee&&j(n,r)&&o.push(r);for(;t.length>i;)j(n,r=t[i++])&&(~q(o,r)||o.push(r));return o},re="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),ne=Object.keys||function(e){return te(e,re)},ie=$?Object.defineProperties:function(e,t){v(e);for(var r,n=ne(t),i=n.length,o=0;i>o;)k.f(e,r=n[o++],t[r]);return e},oe=p.document&&document.documentElement,ae=X("IE_PROTO"),se=function(){},ue=function(){var e,t=S("iframe"),r=re.length;for(t.style.display="none",oe.appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),ue=e.F;r--;)delete ue.prototype[re[r]];return ue()},ce=Object.create||function(e,t){var r;return null!==e?(se.prototype=v(e),r=new se,se.prototype=null,r[ae]=e):r=ue(),t===undefined?r:ie(r,t)},le=r(function(e){var t=Y("wks"),r=p.Symbol,n="function"==typeof r;(e.exports=function(e){return t[e]||(t[e]=n&&r[e]||(n?r:J)("Symbol."+e))}).store=t}),fe=k.f,de=le("toStringTag"),he=function(e,t,r){e&&!j(e=r?e:e.prototype,de)&&fe(e,de,{configurable:!0,value:t})},pe={};I(pe,le("iterator"),function(){return this});var ye=function(e,t,r){e.prototype=ce(pe,{next:D(1,r)}),he(e,t+" Iterator")},ge=function(e){return Object(h(e))},me=X("IE_PROTO"),_e=Object.prototype,ve=Object.getPrototypeOf||function(e){return e=ge(e),j(e,me)?e[me]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?_e:null},be=le("iterator"),$e=!([].keys&&"next"in[].keys()),we=function(e,t,r,n,i,o,a){ye(r,t,n);var s,u,c,l=function(e){if(!$e&&e in p)return p[e];switch(e){case"keys":case"values":return function(){return new r(this,e)}}return function(){return new r(this,e)}},f=t+" Iterator",d="values"==i,h=!1,p=e.prototype,y=p[be]||p["@@iterator"]||i&&p[i],g=y||l(i),m=i?d?l("entries"):g:undefined,_="Array"==t?p.entries||y:y;if(_&&(c=ve(_.call(new e)))!==Object.prototype&&he(c,f,!0),d&&y&&"values"!==y.name&&(h=!0,g=function(){return y.call(this)}),a&&($e||h||!p[be])&&I(p,be,g),i)if(s={values:d?g:l("values"),keys:o?g:l("keys"),entries:m},a)for(u in s)u in p||R(p,u,s[u]);else M(M.P+M.F*($e||h),t,s);return s},Ee=function(e){return function(t,r){var n,i,o=String(h(t)),a=d(r),s=o.length;return a<0||a>=s?e?"":undefined:(n=o.charCodeAt(a),n<55296||n>56319||a+1===s||(i=o.charCodeAt(a+1))<56320||i>57343?e?o.charAt(a):n:e?o.slice(a,a+2):i-56320+(n-55296<<10)+65536)}}(!0);we(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:undefined,done:!0}:(e=Ee(t,r),this._i+=e.length,{value:e,done:!1})});for(var Se=function(e,t){return{value:t,done:!!e}},Oe=(we(Array,"Array",function(e,t){this._t=B(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,r=this._i++;return!e||r>=e.length?(this._t=undefined,Se(1)):"keys"==t?Se(0,r):"values"==t?Se(0,e[r]):Se(0,[r,e[r]])},"values"),le("toStringTag")),Te=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],Ae=0;Ae<5;Ae++){var xe=Te[Ae],ke=p[xe],De=ke&&ke.prototype;De&&!De[Oe]&&I(De,Oe,xe)}var Ie=le,Pe={f:Ie},Me=Pe.f("iterator"),Re=r(function(e){e.exports={"default":Me,__esModule:!0}}),Ce=r(function(e){var t=J("meta"),r=k.f,n=0,i=Object.isExtensible||function(){return!0},o=!b(function(){return i(Object.preventExtensions({}))}),a=function(e){r(e,t,{value:{i:"O"+ ++n,w:{}}})},s=function(e,r){if(!_(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!j(e,t)){if(!i(e))return"F";if(!r)return"E";a(e)}return e[t].i},u=function(e,r){if(!j(e,t)){if(!i(e))return!0;if(!r)return!1;a(e)}return e[t].w},c=function(e){return o&&l.NEED&&i(e)&&!j(e,t)&&a(e),e},l=e.exports={KEY:t,NEED:!1,fastKey:s,getWeak:u,onFreeze:c}}),je=k.f,Le=function(e){var t=y.Symbol||(y.Symbol={});"_"==e.charAt(0)||e in t||je(t,e,{value:Pe.f(e)})},Ne=function(e,t){for(var r,n=B(e),i=ne(n),o=i.length,a=0;o>a;)if(n[r=i[a++]]===t)return r},Fe=Object.getOwnPropertySymbols,Be={f:Fe},Ue={}.propertyIsEnumerable,ze={f:Ue},Ge=function(e){var t=ne(e),r=Be.f;if(r)for(var n,i=r(e),o=ze.f,a=0;i.length>a;)o.call(e,n=i[a++])&&t.push(n);return t},We=Array.isArray||function(e){return"Array"==N(e)},He=re.concat("length","prototype"),Ve=Object.getOwnPropertyNames||function(e){return te(e,He)},Ye={f:Ve},Ke=Ye.f,Ze={}.toString,Je="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],Qe=function(e){try{return Ke(e)}catch(e){return Je.slice()}},Xe=function(e){return Je&&"[object Window]"==Ze.call(e)?Qe(e):Ke(B(e))},qe={f:Xe},et=Object.getOwnPropertyDescriptor,tt=$?et:function(e,t){if(e=B(e),t=T(t,!0),O)try{return et(e,t)}catch(e){}if(j(e,t))return D(!ze.f.call(e,t),e[t])},rt={f:tt},nt=Ce.KEY,it=rt.f,ot=k.f,at=qe.f,st=p.Symbol,ut=p.JSON,ct=ut&&ut.stringify,lt=le("_hidden"),ft=le("toPrimitive"),dt={}.propertyIsEnumerable,ht=Y("symbol-registry"),pt=Y("symbols"),yt=Y("op-symbols"),gt=Object.prototype,mt="function"==typeof st,_t=p.QObject,vt=!_t||!_t.prototype||!_t.prototype.findChild,bt=$&&b(function(){return 7!=ce(ot({},"a",{get:function(){return ot(this,"a",{value:7}).a}})).a})?function(e,t,r){var n=it(gt,t);n&&delete gt[t],ot(e,t,r),n&&e!==gt&&ot(gt,t,n)}:ot,$t=function(e){var t=pt[e]=ce(st.prototype);return t._k=e,t},wt=mt&&"symbol"==typeof st.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof st},Et=function(e,t,r){return e===gt&&Et(yt,t,r),v(e),t=T(t,!0),v(r),j(pt,t)?(r.enumerable?(j(e,lt)&&e[lt][t]&&(e[lt][t]=!1),r=ce(r,{enumerable:D(0,!1)})):(j(e,lt)||ot(e,lt,D(1,{})),e[lt][t]=!0),bt(e,t,r)):ot(e,t,r)},St=function(e,t){v(e);for(var r,n=Ge(t=B(t)),i=0,o=n.length;o>i;)Et(e,r=n[i++],t[r]);return e},Ot=function(e,t){return t===undefined?ce(e):St(ce(e),t)},Tt=function(e){var t=dt.call(this,e=T(e,!0));return!(this===gt&&j(pt,e)&&!j(yt,e))&&(!(t||!j(this,e)||!j(pt,e)||j(this,lt)&&this[lt][e])||t)},At=function(e,t){if(e=B(e),t=T(t,!0),e!==gt||!j(pt,t)||j(yt,t)){var r=it(e,t);return!r||!j(pt,t)||j(e,lt)&&e[lt][t]||(r.enumerable=!0),r}},xt=function(e){for(var t,r=at(B(e)),n=[],i=0;r.length>i;)j(pt,t=r[i++])||t==lt||t==nt||n.push(t);return n},kt=function(e){for(var t,r=e===gt,n=at(r?yt:B(e)),i=[],o=0;n.length>o;)!j(pt,t=n[o++])||r&&!j(gt,t)||i.push(pt[t]);return i};mt||(st=function(){if(this instanceof st)throw TypeError("Symbol is not a constructor!");var e=J(arguments.length>0?arguments[0]:undefined),t=function(r){this===gt&&t.call(yt,r),j(this,lt)&&j(this[lt],e)&&(this[lt][e]=!1),bt(this,e,D(1,r))};return $&&vt&&bt(gt,e,{configurable:!0,set:t}),$t(e)},R(st.prototype,"toString",function(){return this._k}),rt.f=At,k.f=Et,Ye.f=qe.f=xt,ze.f=Tt,Be.f=kt,Pe.f=function(e){return $t(le(e))}),M(M.G+M.W+M.F*!mt,{Symbol:st});for(var Dt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),It=0;Dt.length>It;)le(Dt[It++]);for(var Dt=ne(le.store),It=0;Dt.length>It;)Le(Dt[It++]);M(M.S+M.F*!mt,"Symbol",{"for":function(e){return j(ht,e+="")?ht[e]:ht[e]=st(e)},keyFor:function(e){if(wt(e))return Ne(ht,e);throw TypeError(e+" is not a symbol!")},useSetter:function(){vt=!0},useSimple:function(){vt=!1}}),M(M.S+M.F*!mt,"Object",{create:Ot,defineProperty:Et,defineProperties:St,getOwnPropertyDescriptor:At,getOwnPropertyNames:xt,getOwnPropertySymbols:kt}),ut&&M(M.S+M.F*(!mt||b(function(){var e=st();return"[null]"!=ct([e])||"{}"!=ct({a:e})||"{}"!=ct(Object(e))})),"JSON",{stringify:function(e){if(e!==undefined&&!wt(e)){for(var t,r,n=[e],i=1;arguments.length>i;)n.push(arguments[i++]);return t=n[1],"function"==typeof t&&(r=t),!r&&We(t)||(t=function(e,t){if(r&&(t=r.call(this,e,t)),!wt(t))return t}),n[1]=t,ct.apply(ut,n)}}}),st.prototype[ft]||I(st.prototype,ft,st.prototype.valueOf),he(st,"Symbol"),he(Math,"Math",!0),he(p.JSON,"JSON",!0),Le("asyncIterator"),Le("observable");var Pt=y.Symbol,Mt=r(function(e){e.exports={"default":Pt,__esModule:!0}}),Rt=r(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(Re),i=r(Mt),o="function"==typeof i["default"]&&"symbol"==typeof n["default"]?function(e){return typeof e}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":typeof e};t["default"]="function"==typeof i["default"]&&"symbol"===o(n["default"])?function(e){return void 0===e?"undefined":o(e)}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":void 0===e?"undefined":o(e)}}),Ct=t(Rt),jt=r(function(e,t){t.__esModule=!0,t["default"]=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}}),Lt=t(jt);M(M.S+M.F*!$,"Object",{defineProperty:k.f});var Nt=y.Object,Ft=function(e,t,r){return Nt.defineProperty(e,t,r)},Bt=r(function(e){e.exports={"default":Ft,__esModule:!0}}),Ut=r(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(Bt);t["default"]=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),(0,r["default"])(e,i.key,i)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()}),zt=t(Ut),Gt=Object.assign,Wt=!Gt||b(function(){var e={},t={},r=Symbol(),n="abcdefghijklmnopqrst";return e[r]=7,n.split("").forEach(function(e){t[e]=e}),7!=Gt({},e)[r]||Object.keys(Gt({},t)).join("")!=n})?function(e,t){for(var r=ge(e),n=arguments.length,i=1,o=Be.f,a=ze.f;n>i;)for(var s,u=F(arguments[i++]),c=o?ne(u).concat(o(u)):ne(u),l=c.length,f=0;l>f;)a.call(u,s=c[f++])&&(r[s]=u[s]);return r}:Gt;M(M.S+M.F,"Object",{assign:Wt});var Ht=y.Object.assign,Vt=r(function(e){e.exports={"default":Ht,__esModule:!0}}),Yt=t(Vt);M(M.S,"Object",{create:ce});var Kt=y.Object,Zt=function(e,t){return Kt.create(e,t)},Jt=r(function(e){e.exports={"default":Zt,__esModule:!0}}),Qt=t(Jt);!function(e,t){var r=(y.Object||{})[e]||Object[e],n={};n[e]=t(r),M(M.S+M.F*b(function(){r(1)}),"Object",n)}("keys",function(){return function(e){return ne(ge(e))}});var Xt=y.Object.keys,qt=(r(function(e){e.exports={"default":Xt,__esModule:!0}}),Math.floor),er=function(e){return!_(e)&&isFinite(e)&&qt(e)===e};M(M.S,"Number",{isInteger:er});var tr=y.Number.isInteger,rr=(r(function(e){e.exports={"default":tr,__esModule:!0}}),"\t\n\x0B\f\r \xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff"),nr="["+rr+"]",ir="\u200b\x85",or=RegExp("^"+nr+nr+"*"),ar=RegExp(nr+nr+"*$"),sr=function(e,t,r){var n={},i=b(function(){return!!rr[e]()||ir[e]()!=ir}),o=n[e]=i?t(ur):rr[e];r&&(n[r]=o),M(M.P+M.F*i,"String",n)},ur=sr.trim=function(e,t){return e=String(h(e)),1&t&&(e=e.replace(or,"")),2&t&&(e=e.replace(ar,"")),e},cr=sr,lr=p.parseFloat,fr=cr.trim,dr=1/lr(rr+"-0")!=-Infinity?function(e){var t=fr(String(e),3),r=lr(t);return 0===r&&"-"==t.charAt(0)?-0:r}:lr;M(M.S+M.F*(Number.parseFloat!=dr),"Number",{parseFloat:dr});var hr=parseFloat,pr=(r(function(e){e.exports={"default":hr,__esModule:!0}}),Qt(null));pr.count=0;var yr=function(){function e(t,r){var n=this;if(Lt(this,e),Object.defineProperty(this,"__target",{writable:!0,enumerable:!1,configurable:!0}),this.__target=this,t){if("object"!==(void 0===t?"undefined":Ct(t)))throw new Error("CusEvent target are not object");this.__target=t,r&&["on","once","off","emit"].forEach(function(e){t[e]=n[e]})}}return zt(e,[{key:"on",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return u(this.__target,e,t,r),this}},{key:"once",value:function(e,t){return this.on(e,t,!0)}},{key:"off",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return c(this.__target,e,t,r),this}},{key:"emit",value:function(e,t){return s(this.__target,e,{data:t}),this}}]),e}();e.emitEventCache=s,e.addEventCache=u,e.removeEventCache=c,e.CustEvent=yr,Object.defineProperty(e,"__esModule",{value:!0})}(t)}()},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0});t.ERRORNO={NET_ERROR:100,CODEC_ERROR:101,CANNOT_SEEK:102,ENDOFSTREAM_ERROR:103,MEDIASOURCE_ERROR:104,SOURCEBUFFER_ERROR:105,SBABORT_ERROR:106,APPENDBUFFER_ERROR:107}},function(e,t,r){!function(t,r){e.exports=function(){function e(e){return e&&e.__esModule?e["default"]:e}function t(e,t){return t={exports:{}},e(t,t.exports),t.exports}function r(e){return"string"==typeof e||e instanceof String}function n(e,t){if(!r(e))throw new TypeError("Log's method only acccept string as argument, but not "+e+" in "+(void 0===e?"undefined":Ft(e)));return r(t)?"["+(e=rr.FORCE_GLOBAL_TAG?rr.GLOBAL_TAG:e||rr.GLOBAL_TAG)+"] > "+t:"["+rr.GLOBAL_TAG+"] > "+e}var i=t(function(e,t){t.__esModule=!0,t["default"]=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}}),o=e(i),a=t(function(e){var t=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=t)}),s=t(function(e){var t=e.exports={version:"2.5.0"};"number"==typeof __e&&(__e=t)}),u=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e
},c=function(e,t,r){if(u(e),t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,i){return e.call(t,r,n,i)}}return function(){return e.apply(t,arguments)}},l=function(e){return"object"==typeof e?null!==e:"function"==typeof e},f=function(e){if(!l(e))throw TypeError(e+" is not an object!");return e},d=function(e){try{return!!e()}catch(e){return!0}},h=!d(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),p=a.document,y=l(p)&&l(p.createElement),g=function(e){return y?p.createElement(e):{}},m=!h&&!d(function(){return 7!=Object.defineProperty(g("div"),"a",{get:function(){return 7}}).a}),_=function(e,t){if(!l(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!l(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!l(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!l(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")},v=Object.defineProperty,b=h?Object.defineProperty:function(e,t,r){if(f(e),t=_(t,!0),f(r),m)try{return v(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(e[t]=r.value),e},$={f:b},w=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},E=h?function(e,t,r){return $.f(e,t,w(1,r))}:function(e,t,r){return e[t]=r,e},S=function(e,t,r){var n,i,o,u=e&S.F,l=e&S.G,f=e&S.S,d=e&S.P,h=e&S.B,p=e&S.W,y=l?s:s[t]||(s[t]={}),g=y.prototype,m=l?a:f?a[t]:(a[t]||{}).prototype;l&&(r=t);for(n in r)(i=!u&&m&&m[n]!==undefined)&&n in y||(o=i?m[n]:r[n],y[n]=l&&"function"!=typeof m[n]?r[n]:h&&i?c(o,a):p&&m[n]==o?function(e){var t=function(t,r,n){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,n)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(o):d&&"function"==typeof o?c(Function.call,o):o,d&&((y.virtual||(y.virtual={}))[n]=o,e&S.R&&g&&!g[n]&&E(g,n,o)))};S.F=1,S.G=2,S.S=4,S.P=8,S.B=16,S.W=32,S.U=64,S.R=128;var O=S;O(O.S+O.F*!h,"Object",{defineProperty:$.f});var T=s.Object,A=function(e,t,r){return T.defineProperty(e,t,r)},x=t(function(e){e.exports={"default":A,__esModule:!0}}),k=t(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(x);t["default"]=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),(0,r["default"])(e,i.key,i)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()}),D=e(k),I=Math.ceil,P=Math.floor,M=function(e){return isNaN(e=+e)?0:(e>0?P:I)(e)},R=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e},C=E,j={}.hasOwnProperty,L=function(e,t){return j.call(e,t)},N={}.toString,F=function(e){return N.call(e).slice(8,-1)},B=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==F(e)?e.split(""):Object(e)},U=function(e){return B(R(e))},z=Math.min,G=function(e){return e>0?z(M(e),9007199254740991):0},W=Math.max,H=Math.min,V=function(e,t){return e=M(e),e<0?W(e+t,0):H(e,t)},Y=a["__core-js_shared__"]||(a["__core-js_shared__"]={}),K=function(e){return Y[e]||(Y[e]={})},Z=0,J=Math.random(),Q=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++Z+J).toString(36))},X=K("keys"),q=function(e){return X[e]||(X[e]=Q(e))},ee=function(e){return function(t,r,n){var i,o=U(t),a=G(o.length),s=V(n,a);if(e&&r!=r){for(;a>s;)if((i=o[s++])!=i)return!0}else for(;a>s;s++)if((e||s in o)&&o[s]===r)return e||s||0;return!e&&-1}}(!1),te=q("IE_PROTO"),re=function(e,t){var r,n=U(e),i=0,o=[];for(r in n)r!=te&&L(n,r)&&o.push(r);for(;t.length>i;)L(n,r=t[i++])&&(~ee(o,r)||o.push(r));return o},ne="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),ie=Object.keys||function(e){return re(e,ne)},oe=h?Object.defineProperties:function(e,t){f(e);for(var r,n=ie(t),i=n.length,o=0;i>o;)$.f(e,r=n[o++],t[r]);return e},ae=a.document,se=ae&&ae.documentElement,ue=q("IE_PROTO"),ce=function(){},le=function(){var e,t=g("iframe"),r=ne.length;for(t.style.display="none",se.appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),le=e.F;r--;)delete le.prototype[ne[r]];return le()},fe=Object.create||function(e,t){var r;return null!==e?(ce.prototype=f(e),r=new ce,ce.prototype=null,r[ue]=e):r=le(),t===undefined?r:oe(r,t)},de=t(function(e){var t=K("wks"),r=a.Symbol,n="function"==typeof r;(e.exports=function(e){return t[e]||(t[e]=n&&r[e]||(n?r:Q)("Symbol."+e))}).store=t}),he=$.f,pe=de("toStringTag"),ye=function(e,t,r){e&&!L(e=r?e:e.prototype,pe)&&he(e,pe,{configurable:!0,value:t})},ge={};E(ge,de("iterator"),function(){return this});var me=function(e,t,r){e.prototype=fe(ge,{next:w(1,r)}),ye(e,t+" Iterator")},_e=function(e){return Object(R(e))},ve=q("IE_PROTO"),be=Object.prototype,$e=Object.getPrototypeOf||function(e){return e=_e(e),L(e,ve)?e[ve]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?be:null},we=de("iterator"),Ee=!([].keys&&"next"in[].keys()),Se=function(e,t,r,n,i,o,a){me(r,t,n);var s,u,c,l=function(e){if(!Ee&&e in p)return p[e];switch(e){case"keys":case"values":return function(){return new r(this,e)}}return function(){return new r(this,e)}},f=t+" Iterator",d="values"==i,h=!1,p=e.prototype,y=p[we]||p["@@iterator"]||i&&p[i],g=y||l(i),m=i?d?l("entries"):g:undefined,_="Array"==t?p.entries||y:y;if(_&&(c=$e(_.call(new e)))!==Object.prototype&&c.next&&ye(c,f,!0),d&&y&&"values"!==y.name&&(h=!0,g=function(){return y.call(this)}),a&&(Ee||h||!p[we])&&E(p,we,g),i)if(s={values:d?g:l("values"),keys:o?g:l("keys"),entries:m},a)for(u in s)u in p||C(p,u,s[u]);else O(O.P+O.F*(Ee||h),t,s);return s},Oe=function(e){return function(t,r){var n,i,o=String(R(t)),a=M(r),s=o.length;return a<0||a>=s?e?"":undefined:(n=o.charCodeAt(a),n<55296||n>56319||a+1===s||(i=o.charCodeAt(a+1))<56320||i>57343?e?o.charAt(a):n:e?o.slice(a,a+2):i-56320+(n-55296<<10)+65536)}}(!0);Se(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:undefined,done:!0}:(e=Oe(t,r),this._i+=e.length,{value:e,done:!1})});for(var Te=function(e,t){return{value:t,done:!!e}},Ae=(Se(Array,"Array",function(e,t){this._t=U(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,r=this._i++;return!e||r>=e.length?(this._t=undefined,Te(1)):"keys"==t?Te(0,r):"values"==t?Te(0,e[r]):Te(0,[r,e[r]])},"values"),de("toStringTag")),xe="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),ke=0;ke<xe.length;ke++){var De=xe[ke],Ie=a[De],Pe=Ie&&Ie.prototype;Pe&&!Pe[Ae]&&E(Pe,Ae,De)}var Me=de,Re={f:Me},Ce=Re.f("iterator"),je=t(function(e){e.exports={"default":Ce,__esModule:!0}}),Le=t(function(e){var t=Q("meta"),r=$.f,n=0,i=Object.isExtensible||function(){return!0},o=!d(function(){return i(Object.preventExtensions({}))}),a=function(e){r(e,t,{value:{i:"O"+ ++n,w:{}}})},s=function(e,r){if(!l(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!L(e,t)){if(!i(e))return"F";if(!r)return"E";a(e)}return e[t].i},u=function(e,r){if(!L(e,t)){if(!i(e))return!0;if(!r)return!1;a(e)}return e[t].w},c=function(e){return o&&f.NEED&&i(e)&&!L(e,t)&&a(e),e},f=e.exports={KEY:t,NEED:!1,fastKey:s,getWeak:u,onFreeze:c}}),Ne=$.f,Fe=function(e){var t=s.Symbol||(s.Symbol={});"_"==e.charAt(0)||e in t||Ne(t,e,{value:Re.f(e)})},Be=function(e,t){for(var r,n=U(e),i=ie(n),o=i.length,a=0;o>a;)if(n[r=i[a++]]===t)return r},Ue=Object.getOwnPropertySymbols,ze={f:Ue},Ge={}.propertyIsEnumerable,We={f:Ge},He=function(e){var t=ie(e),r=ze.f;if(r)for(var n,i=r(e),o=We.f,a=0;i.length>a;)o.call(e,n=i[a++])&&t.push(n);return t},Ve=Array.isArray||function(e){return"Array"==F(e)},Ye=ne.concat("length","prototype"),Ke=Object.getOwnPropertyNames||function(e){return re(e,Ye)},Ze={f:Ke},Je=Ze.f,Qe={}.toString,Xe="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],qe=function(e){try{return Je(e)}catch(e){return Xe.slice()}},et=function(e){return Xe&&"[object Window]"==Qe.call(e)?qe(e):Je(U(e))},tt={f:et},rt=Object.getOwnPropertyDescriptor,nt=h?rt:function(e,t){if(e=U(e),t=_(t,!0),m)try{return rt(e,t)}catch(e){}if(L(e,t))return w(!We.f.call(e,t),e[t])},it={f:nt},ot=Le.KEY,at=it.f,st=$.f,ut=tt.f,ct=a.Symbol,lt=a.JSON,ft=lt&&lt.stringify,dt=de("_hidden"),ht=de("toPrimitive"),pt={}.propertyIsEnumerable,yt=K("symbol-registry"),gt=K("symbols"),mt=K("op-symbols"),_t=Object.prototype,vt="function"==typeof ct,bt=a.QObject,$t=!bt||!bt.prototype||!bt.prototype.findChild,wt=h&&d(function(){return 7!=fe(st({},"a",{get:function(){return st(this,"a",{value:7}).a}})).a})?function(e,t,r){var n=at(_t,t);n&&delete _t[t],st(e,t,r),n&&e!==_t&&st(_t,t,n)}:st,Et=function(e){var t=gt[e]=fe(ct.prototype);return t._k=e,t},St=vt&&"symbol"==typeof ct.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof ct},Ot=function(e,t,r){return e===_t&&Ot(mt,t,r),f(e),t=_(t,!0),f(r),L(gt,t)?(r.enumerable?(L(e,dt)&&e[dt][t]&&(e[dt][t]=!1),r=fe(r,{enumerable:w(0,!1)})):(L(e,dt)||st(e,dt,w(1,{})),e[dt][t]=!0),wt(e,t,r)):st(e,t,r)},Tt=function(e,t){f(e);for(var r,n=He(t=U(t)),i=0,o=n.length;o>i;)Ot(e,r=n[i++],t[r]);return e},At=function(e,t){return t===undefined?fe(e):Tt(fe(e),t)},xt=function(e){var t=pt.call(this,e=_(e,!0));return!(this===_t&&L(gt,e)&&!L(mt,e))&&(!(t||!L(this,e)||!L(gt,e)||L(this,dt)&&this[dt][e])||t)},kt=function(e,t){if(e=U(e),t=_(t,!0),e!==_t||!L(gt,t)||L(mt,t)){var r=at(e,t);return!r||!L(gt,t)||L(e,dt)&&e[dt][t]||(r.enumerable=!0),r}},Dt=function(e){for(var t,r=ut(U(e)),n=[],i=0;r.length>i;)L(gt,t=r[i++])||t==dt||t==ot||n.push(t);return n},It=function(e){for(var t,r=e===_t,n=ut(r?mt:U(e)),i=[],o=0;n.length>o;)!L(gt,t=n[o++])||r&&!L(_t,t)||i.push(gt[t]);return i};vt||(ct=function(){if(this instanceof ct)throw TypeError("Symbol is not a constructor!");var e=Q(arguments.length>0?arguments[0]:undefined),t=function(r){this===_t&&t.call(mt,r),L(this,dt)&&L(this[dt],e)&&(this[dt][e]=!1),wt(this,e,w(1,r))};return h&&$t&&wt(_t,e,{configurable:!0,set:t}),Et(e)},C(ct.prototype,"toString",function(){return this._k}),it.f=kt,$.f=Ot,Ze.f=tt.f=Dt,We.f=xt,ze.f=It,Re.f=function(e){return Et(de(e))}),O(O.G+O.W+O.F*!vt,{Symbol:ct});for(var Pt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),Mt=0;Pt.length>Mt;)de(Pt[Mt++]);for(var Rt=ie(de.store),Ct=0;Rt.length>Ct;)Fe(Rt[Ct++]);O(O.S+O.F*!vt,"Symbol",{"for":function(e){return L(yt,e+="")?yt[e]:yt[e]=ct(e)},keyFor:function(e){if(St(e))return Be(yt,e);throw TypeError(e+" is not a symbol!")},useSetter:function(){$t=!0},useSimple:function(){$t=!1}}),O(O.S+O.F*!vt,"Object",{create:At,defineProperty:Ot,defineProperties:Tt,getOwnPropertyDescriptor:kt,getOwnPropertyNames:Dt,getOwnPropertySymbols:It}),lt&&O(O.S+O.F*(!vt||d(function(){var e=ct();return"[null]"!=ft([e])||"{}"!=ft({a:e})||"{}"!=ft(Object(e))})),"JSON",{stringify:function(e){if(e!==undefined&&!St(e)){for(var t,r,n=[e],i=1;arguments.length>i;)n.push(arguments[i++]);return t=n[1],"function"==typeof t&&(r=t),!r&&Ve(t)||(t=function(e,t){if(r&&(t=r.call(this,e,t)),!St(t))return t}),n[1]=t,ft.apply(lt,n)}}}),ct.prototype[ht]||E(ct.prototype,ht,ct.prototype.valueOf),ye(ct,"Symbol"),ye(Math,"Math",!0),ye(a.JSON,"JSON",!0),Fe("asyncIterator"),Fe("observable");var jt=s.Symbol,Lt=t(function(e){e.exports={"default":jt,__esModule:!0}}),Nt=t(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(je),i=r(Lt),o="function"==typeof i["default"]&&"symbol"==typeof n["default"]?function(e){return typeof e}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":typeof e};t["default"]="function"==typeof i["default"]&&"symbol"===o(n["default"])?function(e){return void 0===e?"undefined":o(e)}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":void 0===e?"undefined":o(e)}}),Ft=e(Nt);!function(e,t){var r=(s.Object||{})[e]||Object[e],n={};n[e]=t(r),O(O.S+O.F*d(function(){r(1)}),"Object",n)}("keys",function(){return function(e){return ie(_e(e))}});var Bt=s.Object.keys,Ut=(t(function(e){e.exports={"default":Bt,__esModule:!0}}),Math.floor),zt=function(e){return!l(e)&&isFinite(e)&&Ut(e)===e};O(O.S,"Number",{isInteger:zt});var Gt=s.Number.isInteger,Wt=(t(function(e){e.exports={"default":Gt,__esModule:!0}}),"\t\n\x0B\f\r \xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff"),Ht="["+Wt+"]",Vt="\u200b\x85",Yt=RegExp("^"+Ht+Ht+"*"),Kt=RegExp(Ht+Ht+"*$"),Zt=function(e,t,r){var n={},i=d(function(){return!!Wt[e]()||Vt[e]()!=Vt}),o=n[e]=i?t(Jt):Wt[e];r&&(n[r]=o),O(O.P+O.F*i,"String",n)},Jt=Zt.trim=function(e,t){return e=String(R(e)),1&t&&(e=e.replace(Yt,"")),2&t&&(e=e.replace(Kt,"")),e},Qt=Zt,Xt=a.parseFloat,qt=Qt.trim,er=1/Xt(Wt+"-0")!=-Infinity?function(e){var t=qt(String(e),3),r=Xt(t);return 0===r&&"-"==t.charAt(0)?-0:r}:Xt;O(O.S+O.F*(Number.parseFloat!=er),"Number",{parseFloat:er});var tr=parseFloat,rr=(t(function(e){e.exports={"default":tr,__esModule:!0}}),function(){function e(){o(this,e)}return D(e,null,[{key:"error",value:function(t,r){e.ENABLE_ERROR&&(console.error||console.warn||console.log)(n(t,r))}},{key:"info",value:function(t,r){e.ENABLE_INFO&&(console.info||console.log)(n(t,r))}},{key:"warn",value:function(t,r){e.ENABLE_WARN&&(console.warn||console.log)(n(t,r))}},{key:"debug",value:function(t,r){e.ENABLE_DEBUG&&(console.debug||console.log)(n(t,r))}},{key:"verbose",value:function(t,r){e.ENABLE_VERBOSE&&console.log(n(t,r))}}]),e}());return rr.GLOBAL_TAG="chimee",rr.FORCE_GLOBAL_TAG=!1,rr.ENABLE_ERROR=!0,rr.ENABLE_INFO=!0,rr.ENABLE_WARN=!0,rr.ENABLE_DEBUG=!0,rr.ENABLE_VERBOSE=!0,rr}()}()},function(e,t,r){function n(e){return e&&e.__esModule?e:{"default":e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(10),c=n(u),l=r(12),f=n(l),d=r(13),h=n(d),p=r(14),y=n(p),g=r(0),m=function(e){function t(e){i(this,t);var r=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return r.loader=null,r.config={},r.config=e||{},r.bufferSize=3145728,r.cacheBuffer=new ArrayBuffer(r.bufferSize),r.cacheRemain=0,r.stashByteStart=0,r.enableStash=!0,r.stashSize=r.config.stashSize||393216,r.resumeFrom=0,r.currentRange={},r.totalReceive=0,r.seekPonit=undefined,r.timer=null,r.heartBeatInterval=null,r.preTotalReceive=0,r.seekLock=!1,r.webSocketURLReg=/wss?:\/\/(.+?)\//,r.selectLoader(),r.bindEvent(),r}return a(t,e),s(t,[{key:"selectLoader",value:function(){var e=this.config,t=this.config.src;this.webSocketURLReg.test(t)?this.loader=new h["default"](t,e,this.queryHandle):c["default"].isSupport()?this.loader=new c["default"](t,e,this.queryHandle):y["default"].isSupport()?this.loader=new y["default"](t,e,this.queryHandle):f["default"].isSupport()&&(this.loader=new f["default"](t,e,this.queryHandle)),this.loader.arrivalDataCallback=this.onLoaderChunkArrival.bind(this)}},{key:"bindEvent",value:function(){var e=this;this.loader.on("end",function(){var t=e.cacheBuffer.slice(0,e.cacheRemain);e.arrivalDataCallback(t,e.stashByteStart),e.emit("end")}),this.loader.on("error",function(t){e.emit("error",t.data)})}},{key:"onLoaderChunkArrival",value:function(e,t,r){if((!this.seekLock||r!==undefined)&&(r!==undefined&&(this.seekPonit=r,this.seekLock=!1),this.arrivalDataCallback))if(this.totalReceive+=e.byteLength,0===this.cacheRemain&&0===this.stashByteStart&&(this.stashByteStart=t),this.cacheRemain+e.byteLength<=this.stashSize){var n=new Uint8Array(this.cacheBuffer,0,this.stashSize);n.set(new Uint8Array(e),this.cacheRemain),this.cacheRemain+=e.byteLength}else{var i=new Uint8Array(this.cacheBuffer,0,this.bufferSize);if(this.cacheRemain>0){var o=this.cacheBuffer.slice(0,this.cacheRemain),a=0;if(this.seekPonit!==undefined?(a=this.arrivalDataCallback(o,this.stashByteStart,this.seekPonit),this.seekPonit=undefined):a=this.arrivalDataCallback(o,this.stashByteStart),a<o.byteLength){if(a>0){var s=new Uint8Array(o,a);i.set(s,0),this.cacheRemain=s.byteLength,this.stashByteStart+=a}}else this.cacheRemain=0,this.stashByteStart+=a;this.cacheRemain+e.byteLength>this.bufferSize&&(this.expandBuffer(this.cacheRemain+e.byteLength),i=new Uint8Array(this.cacheBuffer,0,this.bufferSize)),i.set(new Uint8Array(e),this.cacheRemain),this.cacheRemain+=e.byteLength}else{var u=0;if(this.seekPonit!==undefined?(u=this.arrivalDataCallback(e,t,this.seekPonit),this.seekPonit=undefined):u=this.arrivalDataCallback(e,t),u<e.byteLength){var c=e.byteLength-u;c>this.bufferSize&&(this.expandBuffer(c),i=new Uint8Array(this.cacheBuffer,0,this.bufferSize)),i.set(new Uint8Array(e,u),0),this.cacheRemain+=c,this.stashByteStart=t+u}}}}},{key:"initCacheBuffer",value:function(){this.cacheRemain=0,this.cacheBuffer=new ArrayBuffer(this.bufferSize)}},{key:"expandBuffer",value:function(e){var t=this.bufferSize;t<e&&(t=e),this.cacheBuffer=new ArrayBuffer(t),this.bufferSize=t}},{key:"pause",value:function(){this.loader.pause()}},{key:"open",value:function(e,t){this.loader.open({from:e||0,to:-1},t),this.heartbeat()}},{key:"heartbeat",value:function(){var e=this;window.clearInterval(this.heartBeatInterval),this.heartBeatInterval=setInterval(function(){e.emit("heartbeat",{speed:e.totalReceive-e.preTotalReceive,totalReceive:e.totalReceive}),e.preTotalReceive=e.totalReceive},1e3)}},{key:"resume",value:function(){this.paused=!1;var e=this.totalReceive;this.open(e)}},{key:"seek",value:function(e,t,r){this.seekLock=!0,this.totalReceive=e,this.preTotalReceive=e,this.initCacheBuffer(),this.cacheRemain=0,this.stashByteStart=0,this.open(e,r)}},{key:"destroy",value:function(){this.pause(),window.clearInterval(this.heartBeatInterval),this.heartBeatInterval=null}}]),t}(g.CustEvent);t["default"]=m},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){var t={},r=void 0;return r=-1!==e.to?"bytes="+e.from.toString()+"-"+e.to.toString():"bytes="+e.from.toString()+"-",t.Range=r,{headers:t}}},function(t,r,n){function i(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e["default"]:e}function o(e,t){return t={exports:{}},e(t,t.exports),t.exports}function a(e){for(var t=[],r=e,n=0,i=e.length;n<i;)if(r[n]<128)t.push(String.fromCharCode(r[n])),++n;else{if(r[n]<192);else if(r[n]<224){if(s(r,n,1)){var o=(31&r[n])<<6|63&r[n+1];if(o>=128){t.push(String.fromCharCode(65535&o)),n+=2;continue}}}else if(r[n]<240){if(s(r,n,2)){var a=(15&r[n])<<12|(63&r[n+1])<<6|63&r[n+2];if(a>=2048&&55296!=(63488&a)){t.push(String.fromCharCode(65535&a)),n+=3;continue}}}else if(r[n]<248&&s(r,n,3)){var u=(7&r[n])<<18|(63&r[n+1])<<12|(63&r[n+2])<<6|63&r[n+3];if(u>65536&&u<1114112){u-=65536,t.push(String.fromCharCode(u>>>10|55296)),t.push(String.fromCharCode(1023&u|56320)),n+=4;continue}}t.push(String.fromCharCode(65533)),++n}return t.join("")}function s(e,t,r){var n=e;if(t+r<n.length){for(;r--;)if(128!=(192&n[++t]))return!1;return!0}return!1}Object.defineProperty(r,"__esModule",{value:!0});var u=n(0),c=(n.n(u),function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e}),l=function(e){return Object(c(e))},f={}.hasOwnProperty,d=function(e,t){return f.call(e,t)},h=o(function(e){var t=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=t)}),p=h["__core-js_shared__"]||(h["__core-js_shared__"]={}),y=function(e){return p[e]||(p[e]={})},g=0,m=Math.random(),_=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++g+m).toString(36))},b=y("keys"),$=function(e){return b[e]||(b[e]=_(e))},w=$("IE_PROTO"),E=Object.prototype,S=Object.getPrototypeOf||function(e){return e=l(e),d(e,w)?e[w]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?E:null},O=o(function(e){var t=e.exports={version:"2.4.0"};"number"==typeof __e&&(__e=t)}),T=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e},A=function(e,t,r){if(T(e),t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,i){return e.call(t,r,n,i)}}return function(){return e.apply(t,arguments)}},x=function(e){return"object"==typeof e?null!==e:"function"==typeof e},k=function(e){if(!x(e))throw TypeError(e+" is not an object!");return e},D=function(e){try{return!!e()}catch(e){return!0}},I=!D(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),P=h.document,M=x(P)&&x(P.createElement),R=function(e){return M?P.createElement(e):{}},C=!I&&!D(function(){return 7!=Object.defineProperty(R("div"),"a",{get:function(){return 7}}).a}),j=function(e,t){if(!x(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!x(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!x(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!x(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")},L=Object.defineProperty,N=I?Object.defineProperty:function(e,t,r){if(k(e),t=j(t,!0),k(r),C)try{return L(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(e[t]=r.value),e},F={f:N},B=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},U=I?function(e,t,r){return F.f(e,t,B(1,r))}:function(e,t,r){return e[t]=r,e},z=function(e,t,r){var n,i,o,a=e&z.F,s=e&z.G,u=e&z.S,c=e&z.P,l=e&z.B,f=e&z.W,d=s?O:O[t]||(O[t]={}),p=d.prototype,y=s?h:u?h[t]:(h[t]||{}).prototype;s&&(r=t);for(n in r)(i=!a&&y&&y[n]!==undefined)&&n in d||(o=i?y[n]:r[n],d[n]=s&&"function"!=typeof y[n]?r[n]:l&&i?A(o,h):f&&y[n]==o?function(e){var t=function(t,r,n){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,n)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(o):c&&"function"==typeof o?A(Function.call,o):o,c&&((d.virtual||(d.virtual={}))[n]=o,e&z.R&&p&&!p[n]&&U(p,n,o)))};z.F=1,z.G=2,z.S=4,z.P=8,z.B=16,z.W=32,z.U=64,z.R=128;var G=z;!function(e,t){var r=(O.Object||{})[e]||Object[e],n={};n[e]=t(r),G(G.S+G.F*D(function(){r(1)}),"Object",n)}("getPrototypeOf",function(){return function(e){return S(l(e))}});var W=O.Object.getPrototypeOf,H=o(function(e){e.exports={"default":W,__esModule:!0}}),V=i(H),Y=Math.ceil,K=Math.floor,Z=function(e){return isNaN(e=+e)?0:(e>0?K:Y)(e)},J=U,Q={}.toString,X=function(e){return Q.call(e).slice(8,-1)},q=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==X(e)?e.split(""):Object(e)},ee=function(e){return q(c(e))},te=Math.min,re=function(e){return e>0?te(Z(e),9007199254740991):0},ne=Math.max,ie=Math.min,oe=function(e,t){return e=Z(e),e<0?ne(e+t,0):ie(e,t)},ae=function(e){return function(t,r,n){var i,o=ee(t),a=re(o.length),s=oe(n,a);if(e&&r!=r){for(;a>s;)if((i=o[s++])!=i)return!0}else for(;a>s;s++)if((e||s in o)&&o[s]===r)return e||s||0;return!e&&-1}}(!1),se=$("IE_PROTO"),ue=function(e,t){var r,n=ee(e),i=0,o=[];for(r in n)r!=se&&d(n,r)&&o.push(r);for(;t.length>i;)d(n,r=t[i++])&&(~ae(o,r)||o.push(r));return o},ce="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),le=Object.keys||function(e){return ue(e,ce)},fe=I?Object.defineProperties:function(e,t){k(e);for(var r,n=le(t),i=n.length,o=0;i>o;)F.f(e,r=n[o++],t[r]);return e},de=h.document&&document.documentElement,he=$("IE_PROTO"),pe=function(){},ye=function(){var e,t=R("iframe"),r=ce.length;for(t.style.display="none",de.appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),ye=e.F;r--;)delete ye.prototype[ce[r]];return ye()},ge=Object.create||function(e,t){var r;return null!==e?(pe.prototype=k(e),r=new pe,pe.prototype=null,r[he]=e):r=ye(),t===undefined?r:fe(r,t)},me=o(function(e){var t=y("wks"),r=h.Symbol,n="function"==typeof r;(e.exports=function(e){return t[e]||(t[e]=n&&r[e]||(n?r:_)("Symbol."+e))}).store=t}),_e=F.f,ve=me("toStringTag"),be=function(e,t,r){e&&!d(e=r?e:e.prototype,ve)&&_e(e,ve,{configurable:!0,value:t})},$e={};U($e,me("iterator"),function(){return this});var we=function(e,t,r){e.prototype=ge($e,{next:B(1,r)}),be(e,t+" Iterator")},Ee=me("iterator"),Se=!([].keys&&"next"in[].keys()),Oe=function(e,t,r,n,i,o,a){we(r,t,n);var s,u,c,l=function(e){if(!Se&&e in p)return p[e];switch(e){case"keys":case"values":return function(){return new r(this,e)}}return function(){return new r(this,e)}},f=t+" Iterator",d="values"==i,h=!1,p=e.prototype,y=p[Ee]||p["@@iterator"]||i&&p[i],g=y||l(i),m=i?d?l("entries"):g:undefined,_="Array"==t?p.entries||y:y;if(_&&(c=S(_.call(new e)))!==Object.prototype&&be(c,f,!0),d&&y&&"values"!==y.name&&(h=!0,g=function(){return y.call(this)}),a&&(Se||h||!p[Ee])&&U(p,Ee,g),i)if(s={values:d?g:l("values"),keys:o?g:l("keys"),entries:m},a)for(u in s)u in p||J(p,u,s[u]);else G(G.P+G.F*(Se||h),t,s);return s},Te=function(e){return function(t,r){var n,i,o=String(c(t)),a=Z(r),s=o.length;return a<0||a>=s?e?"":undefined:(n=o.charCodeAt(a),n<55296||n>56319||a+1===s||(i=o.charCodeAt(a+1))<56320||i>57343?e?o.charAt(a):n:e?o.slice(a,a+2):i-56320+(n-55296<<10)+65536)}}(!0);Oe(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:undefined,done:!0}:(e=Te(t,r),this._i+=e.length,{value:e,done:!1})});for(var Ae=function(e,t){return{value:t,done:!!e}},xe=(Oe(Array,"Array",function(e,t){this._t=ee(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,r=this._i++;return!e||r>=e.length?(this._t=undefined,Ae(1)):"keys"==t?Ae(0,r):"values"==t?Ae(0,e[r]):Ae(0,[r,e[r]])},"values"),me("toStringTag")),ke=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],De=0;De<5;De++){var Ie=ke[De],Pe=h[Ie],Me=Pe&&Pe.prototype;Me&&!Me[xe]&&U(Me,xe,Ie)}var Re=me,Ce={f:Re},je=Ce.f("iterator"),Le=o(function(e){e.exports={"default":je,__esModule:!0}});i(Le);var Ne=o(function(e){var t=_("meta"),r=F.f,n=0,i=Object.isExtensible||function(){return!0},o=!D(function(){return i(Object.preventExtensions({}))}),a=function(e){r(e,t,{value:{i:"O"+ ++n,w:{}}})},s=function(e,r){if(!x(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!d(e,t)){if(!i(e))return"F";if(!r)return"E";a(e)}return e[t].i},u=function(e,r){if(!d(e,t)){if(!i(e))return!0;if(!r)return!1;a(e)}return e[t].w},c=function(e){return o&&l.NEED&&i(e)&&!d(e,t)&&a(e),e},l=e.exports={KEY:t,NEED:!1,fastKey:s,getWeak:u,onFreeze:c}}),Fe=F.f,Be=function(e){var t=O.Symbol||(O.Symbol={});"_"==e.charAt(0)||e in t||Fe(t,e,{value:Ce.f(e)})},Ue=function(e,t){for(var r,n=ee(e),i=le(n),o=i.length,a=0;o>a;)if(n[r=i[a++]]===t)return r},ze=Object.getOwnPropertySymbols,Ge={f:ze},We={}.propertyIsEnumerable,He={f:We},Ve=function(e){var t=le(e),r=Ge.f;if(r)for(var n,i=r(e),o=He.f,a=0;i.length>a;)o.call(e,n=i[a++])&&t.push(n);return t},Ye=Array.isArray||function(e){return"Array"==X(e)},Ke=ce.concat("length","prototype"),Ze=Object.getOwnPropertyNames||function(e){return ue(e,Ke)},Je={f:Ze},Qe=Je.f,Xe={}.toString,qe="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],et=function(e){try{return Qe(e)}catch(e){return qe.slice()}},tt=function(e){return qe&&"[object Window]"==Xe.call(e)?et(e):Qe(ee(e))},rt={f:tt},nt=Object.getOwnPropertyDescriptor,it=I?nt:function(e,t){if(e=ee(e),t=j(t,!0),C)try{return nt(e,t)}catch(e){}if(d(e,t))return B(!He.f.call(e,t),e[t])},ot={f:it},at=Ne.KEY,st=ot.f,ut=F.f,ct=rt.f,lt=h.Symbol,ft=h.JSON,dt=ft&&ft.stringify,ht=me("_hidden"),pt=me("toPrimitive"),yt={}.propertyIsEnumerable,gt=y("symbol-registry"),mt=y("symbols"),_t=y("op-symbols"),vt=Object.prototype,bt="function"==typeof lt,$t=h.QObject,wt=!$t||!$t.prototype||!$t.prototype.findChild,Et=I&&D(function(){return 7!=ge(ut({},"a",{get:function(){return ut(this,"a",{value:7}).a}})).a})?function(e,t,r){var n=st(vt,t);n&&delete vt[t],ut(e,t,r),n&&e!==vt&&ut(vt,t,n)}:ut,St=function(e){var t=mt[e]=ge(lt.prototype);return t._k=e,t},Ot=bt&&"symbol"==typeof lt.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof lt},Tt=function(e,t,r){return e===vt&&Tt(_t,t,r),k(e),t=j(t,!0),k(r),d(mt,t)?(r.enumerable?(d(e,ht)&&e[ht][t]&&(e[ht][t]=!1),r=ge(r,{enumerable:B(0,!1)})):(d(e,ht)||ut(e,ht,B(1,{})),e[ht][t]=!0),Et(e,t,r)):ut(e,t,r)},At=function(e,t){k(e);for(var r,n=Ve(t=ee(t)),i=0,o=n.length;o>i;)Tt(e,r=n[i++],t[r]);return e},xt=function(e,t){return t===undefined?ge(e):At(ge(e),t)},kt=function(e){var t=yt.call(this,e=j(e,!0));return!(this===vt&&d(mt,e)&&!d(_t,e))&&(!(t||!d(this,e)||!d(mt,e)||d(this,ht)&&this[ht][e])||t)},Dt=function(e,t){if(e=ee(e),t=j(t,!0),e!==vt||!d(mt,t)||d(_t,t)){var r=st(e,t);return!r||!d(mt,t)||d(e,ht)&&e[ht][t]||(r.enumerable=!0),r}},It=function(e){for(var t,r=ct(ee(e)),n=[],i=0;r.length>i;)d(mt,t=r[i++])||t==ht||t==at||n.push(t);return n},Pt=function(e){for(var t,r=e===vt,n=ct(r?_t:ee(e)),i=[],o=0;n.length>o;)!d(mt,t=n[o++])||r&&!d(vt,t)||i.push(mt[t]);return i};bt||(lt=function(){if(this instanceof lt)throw TypeError("Symbol is not a constructor!");var e=_(arguments.length>0?arguments[0]:undefined),t=function(r){this===vt&&t.call(_t,r),d(this,ht)&&d(this[ht],e)&&(this[ht][e]=!1),Et(this,e,B(1,r))};return I&&wt&&Et(vt,e,{configurable:!0,set:t}),St(e)},J(lt.prototype,"toString",function(){return this._k}),ot.f=Dt,F.f=Tt,Je.f=rt.f=It,He.f=kt,Ge.f=Pt,Ce.f=function(e){return St(me(e))}),G(G.G+G.W+G.F*!bt,{Symbol:lt});for(var Mt="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),Rt=0;Mt.length>Rt;)me(Mt[Rt++]);for(var Mt=le(me.store),Rt=0;Mt.length>Rt;)Be(Mt[Rt++]);G(G.S+G.F*!bt,"Symbol",{"for":function(e){return d(gt,e+="")?gt[e]:gt[e]=lt(e)},keyFor:function(e){if(Ot(e))return Ue(gt,e);throw TypeError(e+" is not a symbol!")},useSetter:function(){wt=!0},useSimple:function(){wt=!1}}),G(G.S+G.F*!bt,"Object",{create:xt,defineProperty:Tt,defineProperties:At,getOwnPropertyDescriptor:Dt,getOwnPropertyNames:It,getOwnPropertySymbols:Pt}),ft&&G(G.S+G.F*(!bt||D(function(){var e=lt();return"[null]"!=dt([e])||"{}"!=dt({a:e})||"{}"!=dt(Object(e))})),"JSON",{stringify:function(e){if(e!==undefined&&!Ot(e)){for(var t,r,n=[e],i=1;arguments.length>i;)n.push(arguments[i++]);return t=n[1],"function"==typeof t&&(r=t),!r&&Ye(t)||(t=function(e,t){if(r&&(t=r.call(this,e,t)),!Ot(t))return t}),n[1]=t,dt.apply(ft,n)}}}),lt.prototype[pt]||U(lt.prototype,pt,lt.prototype.valueOf),be(lt,"Symbol"),be(Math,"Math",!0),
be(h.JSON,"JSON",!0),Be("asyncIterator"),Be("observable");var Ct=O.Symbol,jt=o(function(e){e.exports={"default":Ct,__esModule:!0}});i(jt);var Lt=o(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(Le),i=r(jt),o="function"==typeof i["default"]&&"symbol"==typeof n["default"]?function(e){return typeof e}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":typeof e};t["default"]="function"==typeof i["default"]&&"symbol"===o(n["default"])?function(e){return void 0===e?"undefined":o(e)}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":void 0===e?"undefined":o(e)}}),Nt=i(Lt),Ft=o(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(Lt);t["default"]=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==(void 0===t?"undefined":(0,r["default"])(t))&&"function"!=typeof t?e:t}}),Bt=i(Ft),Ut=function(e,t){if(k(e),!x(t)&&null!==t)throw TypeError(t+": can't set as prototype!")},zt={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=A(Function.call,ot.f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(e){t=!0}return function(e,n){return Ut(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):undefined),check:Ut};G(G.S,"Object",{setPrototypeOf:zt.set});var Gt=O.Object.setPrototypeOf,Wt=o(function(e){e.exports={"default":Gt,__esModule:!0}});i(Wt),G(G.S,"Object",{create:ge});var Ht=O.Object,Vt=function(e,t){return Ht.create(e,t)},Yt=o(function(e){e.exports={"default":Vt,__esModule:!0}});i(Yt);var Kt=o(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(Wt),i=r(Yt),o=r(Lt);t["default"]=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+(void 0===t?"undefined":(0,o["default"])(t)));e.prototype=(0,i["default"])(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(n["default"]?(0,n["default"])(e,t):e.__proto__=t)}}),Zt=i(Kt),Jt=Object.assign,Qt=!Jt||D(function(){var e={},t={},r=Symbol(),n="abcdefghijklmnopqrst";return e[r]=7,n.split("").forEach(function(e){t[e]=e}),7!=Jt({},e)[r]||Object.keys(Jt({},t)).join("")!=n})?function(e,t){for(var r=l(e),n=arguments.length,i=1,o=Ge.f,a=He.f;n>i;)for(var s,u=q(arguments[i++]),c=o?le(u).concat(o(u)):le(u),f=c.length,d=0;f>d;)a.call(u,s=c[d++])&&(r[s]=u[s]);return r}:Jt;G(G.S+G.F,"Object",{assign:Qt});var Xt=O.Object.assign,qt=o(function(e){e.exports={"default":Xt,__esModule:!0}}),er=i(qt),tr=o(function(e,t){t.__esModule=!0,t["default"]=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}}),rr=i(tr);G(G.S+G.F*!I,"Object",{defineProperty:F.f});var nr=O.Object,ir=function(e,t,r){return nr.defineProperty(e,t,r)},or=o(function(e){e.exports={"default":ir,__esModule:!0}});i(or);var ar=o(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(or);t["default"]=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),(0,r["default"])(e,i.key,i)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()}),sr=i(ar),ur=function(){function e(){rr(this,e),this.tagType=-1,this.dataSize=-1,this.Timestamp=-1,this.StreamID=-1,this.body=-1,this.time=-1,this.arr=[],this.size=-1}return sr(e,[{key:"getTime",value:function(){this.arr=[];for(var e=0;e<this.Timestamp.length;e++)this.arr.push(1==this.Timestamp[e].toString(16).length?"0"+this.Timestamp[e].toString(16):this.Timestamp[e].toString(16));this.arr.pop();var t=this.arr.join("");return this.time=parseInt(t,16),parseInt(t,16)}}]),e}(),cr=function(){function e(t){rr(this,e),this.TAG=this.constructor.name,this._buffer=t,this._buffer_index=0,this._total_bytes=t.byteLength,this._total_bits=8*t.byteLength,this._current_word=0,this._current_word_bits_left=0}return sr(e,[{key:"destroy",value:function(){this._buffer=null}},{key:"_fillCurrentWord",value:function(){var e=this._total_bytes-this._buffer_index;if(e<=0)throw new IllegalStateException("ExpGolomb: _fillCurrentWord() but no bytes available");var t=Math.min(4,e),r=new Uint8Array(4);r.set(this._buffer.subarray(this._buffer_index,this._buffer_index+t)),this._current_word=new DataView(r.buffer).getUint32(0,!1),this._buffer_index+=t,this._current_word_bits_left=8*t}},{key:"readBits",value:function(e){if(e>32)throw new InvalidArgumentException("ExpGolomb: readBits() bits exceeded max 32bits!");if(e<=this._current_word_bits_left){var t=this._current_word>>>32-e;return this._current_word<<=e,this._current_word_bits_left-=e,t}var r=this._current_word_bits_left?this._current_word:0;r>>>=32-this._current_word_bits_left;var n=e-this._current_word_bits_left;this._fillCurrentWord();var i=Math.min(n,this._current_word_bits_left),o=this._current_word>>>32-i;return this._current_word<<=i,this._current_word_bits_left-=i,r=r<<i|o}},{key:"readBool",value:function(){return 1===this.readBits(1)}},{key:"readByte",value:function(){return this.readBits(8)}},{key:"_skipLeadingZero",value:function(){var e=void 0;for(e=0;e<this._current_word_bits_left;e++)if(0!=(this._current_word&2147483648>>>e))return this._current_word<<=e,this._current_word_bits_left-=e,e;return this._fillCurrentWord(),e+this._skipLeadingZero()}},{key:"readUEG",value:function(){var e=this._skipLeadingZero();return this.readBits(e+1)-1}},{key:"readSEG",value:function(){var e=this.readUEG();return 1&e?e+1>>>1:-1*(e>>>1)}}]),e}(),lr=function(){function e(){rr(this,e)}return sr(e,null,[{key:"_ebsp2rbsp",value:function(e){for(var t=e,r=t.byteLength,n=new Uint8Array(r),i=0,o=0;o<r;o++)o>=2&&3===t[o]&&0===t[o-1]&&0===t[o-2]||(n[i]=t[o],i++);return new Uint8Array(n.buffer,0,i)}},{key:"parseSPS",value:function(t){var r=e._ebsp2rbsp(t),n=new cr(r);n.readByte();var i=n.readByte();n.readByte();var o=n.readByte();n.readUEG();var a=e.getProfileString(i),s=e.getLevelString(o),u=1,c=420,l=[0,420,422,444],f=8;if((100===i||110===i||122===i||244===i||44===i||83===i||86===i||118===i||128===i||138===i||144===i)&&(u=n.readUEG(),3===u&&n.readBits(1),u<=3&&(c=l[u]),f=n.readUEG()+8,n.readUEG(),n.readBits(1),n.readBool()))for(var d=3!==u?8:12,h=0;h<d;h++)n.readBool()&&(h<6?e._skipScalingList(n,16):e._skipScalingList(n,64));n.readUEG();var p=n.readUEG();if(0===p)n.readUEG();else if(1===p){n.readBits(1),n.readSEG(),n.readSEG();for(var y=n.readUEG(),g=0;g<y;g++)n.readSEG()}n.readUEG(),n.readBits(1);var m=n.readUEG(),_=n.readUEG(),v=n.readBits(1);0===v&&n.readBits(1),n.readBits(1);var b=0,$=0,w=0,E=0;n.readBool()&&(b=n.readUEG(),$=n.readUEG(),w=n.readUEG(),E=n.readUEG());var S=1,O=1,T=0,A=!0,x=0,k=0;if(n.readBool()){if(n.readBool()){var D=n.readByte(),I=[1,12,10,16,40,24,20,32,80,18,15,64,160,4,3,2],P=[1,11,11,11,33,11,11,11,33,11,11,33,99,3,2,1];D>0&&D<16?(S=I[D-1],O=P[D-1]):255===D&&(S=n.readByte()<<8|n.readByte(),O=n.readByte()<<8|n.readByte())}if(n.readBool()&&n.readBool(),n.readBool()&&(n.readBits(4),n.readBool()&&n.readBits(24)),n.readBool()&&(n.readUEG(),n.readUEG()),n.readBool()){var M=n.readBits(32),R=n.readBits(32);A=n.readBool(),x=R,k=2*M,T=x/k}}var C=1;1===S&&1===O||(C=S/O);var j=0,L=0;if(0===u)j=1,L=2-v;else{var N=3===u?1:2,F=1===u?2:1;j=N,L=F*(2-v)}var B=16*(m+1),U=16*(_+1)*(2-v);B-=(b+$)*j,U-=(w+E)*L;var z=Math.ceil(B*C);return n.destroy(),n=null,{profile_string:a,level_string:s,bit_depth:f,chroma_format:c,chroma_format_string:e.getChromaFormatString(c),frame_rate:{fixed:A,fps:T,fps_den:k,fps_num:x},sar_ratio:{width:S,height:O},codec_size:{width:B,height:U},present_size:{width:z,height:U}}}},{key:"_skipScalingList",value:function(e,t){for(var r=8,n=8,i=0,o=0;o<t;o++)0!==n&&(i=e.readSEG(),n=(r+i+256)%256),r=0===n?r:n}},{key:"getProfileString",value:function(e){switch(e){case 66:return"Baseline";case 77:return"Main";case 88:return"Extended";case 100:return"High";case 110:return"High10";case 122:return"High422";case 244:return"High444";default:return"Unknown"}}},{key:"getLevelString",value:function(e){return(e/10).toFixed(1)}},{key:"getChromaFormatString",value:function(e){switch(e){case 420:return"4:2:0";case 422:return"4:2:2";case 444:return"4:4:4";default:return"Unknown"}}}]),e}(),fr=null,dr=function(){function e(){rr(this,e)}return sr(e,null,[{key:"parseObject",value:function(t,r,n){var i=e.parseString(t,r,n),o=e.parseScript(t,r+i.size),a=o.objectEnd;return{data:{name:i.data,value:o.data},size:o.size,objectEnd:a}}},{key:"parseVariable",value:function(t,r,n){return e.parseObject(t,r,n)}},{key:"parseLongString",value:function(e,t,r){var n=new DataView(e,t),i=n.getUint32(0,!fr),o=void 0;return o=i>0?a(new Uint8Array(e,t+4,i)):"",{data:o,size:4+i}}},{key:"parseDate",value:function(e,t,r){var n=new DataView(e,t),i=n.getFloat64(0,!fr);return i+=60*n.getInt16(8,!fr)*1e3,{data:new Date(i),size:10}}},{key:"parseString",value:function(e,t,r){var n=new DataView(e,t),i=n.getUint16(0,!fr),o=void 0;return o=i>0?a(new Uint8Array(e,t+2,i)):"",{data:o,size:2+i}}},{key:"parseMetadata",value:function(t){fr=function(){var e=new ArrayBuffer(2);return new DataView(e).setInt16(0,256,!0),256===new Int16Array(e)[0]}();var r=e.parseScript(t,0),n=e.parseScript(t,r.size,t.length-r.size),i={};return i[r.data]=n.data,i}},{key:"parseScript",value:function(t,r,n){var i=r,o=new Uint8Array(t),a=o.buffer,s=new DataView(a,0,n),u=null,c=s.getUint8(i);switch(i+=1,c){case 0:u=s.getFloat64(i,!fr),i+=8;break;case 1:u=!!s.getUint8(i),i+=1;break;case 2:var l=e.parseString(a,i);u=l.data,i+=l.size;break;case 3:u={};var f=0;for(9==(16777215&s.getUint32(n-4,!fr))&&(f=3);i<n-4;){var d=e.parseObject(a,i,n-r-f);if(d.objectEnd)break;u[d.data.name]=d.data.value,i=d.size}if(i<=n-3){9===(16777215&v.getUint32(i-1,!fr))&&(i+=3)}break;case 8:for(u={},i+=4,s.getUint32(n-4,!fr);i<n-8;){var h=e.parseVariable(a,i);if(h.objectEnd)break;u[h.data.name]=h.data.value,i=h.size}if(i<=n-3){9===(16777215&s.getUint32(i-1,!fr))&&(i+=3)}break;case 9:u=undefined,i=1;break;case 10:u=[];var p=s.getUint32(i,!fr);i+=4;for(var y=0;y<p;y++){var g=e.parseScript(a,i);u.push(g.data),i=g.size}break;case 11:var m=e.parseDate(a,i+1,n-1);u=m.data,i+=m.size;break;case 12:var _=e.parseString(a,i+1,n-1);u=_.data,i+=_.size;break;default:i=n,console.log("AMF","Unsupported AMF value type "+c)}return{data:u,size:i}}}]),e}(),hr=function(){function e(){rr(this,e),this.mimeType=null,this.duration=null,this.hasAudio=null,this.hasVideo=null,this.audioCodec=null,this.videoCodec=null,this.audioDataRate=null,this.videoDataRate=null,this.audioSampleRate=null,this.audioChannelCount=null,this.width=null,this.height=null,this.fps=null,this.profile=null,this.level=null,this.chromaFormat=null,this.sarNum=null,this.sarDen=null,this.metadata=null,this.segments=null,this.segmentCount=null,this.hasKeyframesIndex=null,this.keyframesIndex=null}return sr(e,[{key:"isComplete",value:function(){var e=!1===this.hasAudio||!0===this.hasAudio&&null!=this.audioCodec&&null!=this.audioSampleRate&&null!=this.audioChannelCount,t=!1===this.hasVideo||!0===this.hasVideo&&null!=this.videoCodec&&null!=this.width&&null!=this.height&&null!=this.fps&&null!=this.profile&&null!=this.level&&null!=this.chromaFormat&&null!=this.sarNum&&null!=this.sarDen;return null!=this.mimeType&&null!=this.duration&&null!=this.metadata&&null!=this.hasKeyframesIndex&&e&&t}},{key:"isSeekable",value:function(){return!0===this.hasKeyframesIndex}}]),e}(),pr=function Tr(e){rr(this,Tr),this.type=e},yr=function(){function e(){rr(this,e),this.TAG=this.constructor.name,this._config={},this._onError=null,this._onMediaInfo=null,this._onTrackMetadata=null,this._onDataAvailable=null,this._dataOffset=0,this._firstParse=!0,this._dispatch=!1,this._hasAudio=!1,this._hasVideo=!1,this._audioInitialMetadataDispatched=!1,this._videoInitialMetadataDispatched=!1,this._mediaInfo=new hr,this._mediaInfo.hasAudio=this._hasAudio,this._mediaInfo.hasVideo=this._hasVideo,this._metadata=null,this._audioMetadata=null,this._videoMetadata=null,this._naluLengthSize=4,this._timestampBase=0,this._timescale=1e3,this._duration=0,this._durationOverrided=!1,this._referenceFrameRate={fixed:!0,fps:23.976,fps_num:23976,fps_den:1e3},this._videoTrack={type:"video",id:1,sequenceNumber:0,addcoefficient:2,samples:[],length:0},this._audioTrack={type:"audio",id:2,sequenceNumber:0,addcoefficient:2,samples:[],length:0},this._littleEndian=function(){var e=new ArrayBuffer(2);return new DataView(e).setInt16(0,256,!0),256===new Int16Array(e)[0]}()}return sr(e,[{key:"onMediaInfo",value:function(e){this._onMediaInfo=e}},{key:"parseMetadata",value:function(e){var t=dr.parseMetadata(e);this._parseScriptData(t)}},{key:"_parseScriptData",value:function(e){var t=e;if(t.hasOwnProperty("onMetaData")){this._metadata=t;var r=this._metadata.onMetaData;if("boolean"==typeof r.hasAudio&&(this._hasAudio=r.hasAudio,this._mediaInfo.hasAudio=this._hasAudio),"boolean"==typeof r.hasVideo&&(this._hasVideo=r.hasVideo,this._mediaInfo.hasVideo=this._hasVideo),"number"==typeof r.audiodatarate&&(this._mediaInfo.audioDataRate=r.audiodatarate),"number"==typeof r.videodatarate&&(this._mediaInfo.videoDataRate=r.videodatarate),"number"==typeof r.width&&(this._mediaInfo.width=r.width),"number"==typeof r.height&&(this._mediaInfo.height=r.height),"number"==typeof r.duration){if(!this._durationOverrided){var n=Math.floor(r.duration*this._timescale);this._duration=n,this._mediaInfo.duration=n}}else this._mediaInfo.duration=0;if("number"==typeof r.framerate){var i=Math.floor(1e3*r.framerate);if(i>0){var o=i/1e3;this._referenceFrameRate.fixed=!0,this._referenceFrameRate.fps=o,this._referenceFrameRate.fps_num=i,this._referenceFrameRate.fps_den=1e3,this._mediaInfo.fps=o}}if("object"===Nt(r.keyframes)){this._mediaInfo.hasKeyframesIndex=!0;var a=r.keyframes;a.times=r.times,a.filepositions=r.filepositions,this._mediaInfo.keyframesIndex=this._parseKeyframesIndex(a),r.keyframes=null}else this._mediaInfo.hasKeyframesIndex=!1;return this._dispatch=!1,this._mediaInfo.metadata=r,console.log(this.TAG,"Parsed onMetaData"),this._mediaInfo}}},{key:"_parseKeyframesIndex",value:function(e){for(var t=[],r=[],n=1;n<e.times.length;n++){var i=this._timestampBase+Math.floor(1e3*e.times[n]);t.push(i),r.push(e.filepositions[n])}return{times:t,filepositions:r}}},{key:"moofTag",value:function(e){for(var t=0;t<e.length;t++)this._dispatch=!0,this.parseChunks(e[t]);this._isInitialMetadataDispatched()&&this._dispatch&&(this._audioTrack.length||this._videoTrack.length)&&this._onDataAvailable(this._audioTrack,this._videoTrack)}},{key:"parseChunks",value:function(e){switch(e.tagType){case 8:this._parseAudioData(e.body.buffer,0,e.body.length,e.getTime());break;case 9:this._parseVideoData(e.body.buffer,0,e.body.length,e.getTime(),0);break;case 18:this.parseMetadata(e.body)}}},{key:"_parseVideoData",value:function(e,t,r,n,i){if(n==this._timestampBase&&0!=this._timestampBase)throw new pr(n,this._timestampBase,"\u592d\u5bff\u5566\u8fd9\u4e2a\u89c6\u9891\u4e0d\u662f\u4ece0\u5f00\u59cb");if(r<=1)return void console.log(this.TAG,"Flv: Invalid video packet, missing VideoData payload!");var o=new Uint8Array(e,t,r)[0],a=(240&o)>>>4,s=15&o;if(7!==s)return void(this._onError&&this._onError("Flv: Unsupported codec in video frame: "+s));this._parseAVCVideoPacket(e,t+1,r-1,n,i,a)}},{key:"_parseAVCVideoPacket",value:function(e,t,r,n,i,o){if(r<4)return void console.log(this.TAG,"Flv: Invalid AVC packet, missing AVCPacketType or/and CompositionTime");var a=this._littleEndian,s=new DataView(e,t,r),u=s.getUint8(0),c=16777215&s.getUint32(0,!a);if(0===u)this._parseAVCDecoderConfigurationRecord(e,t+4,r-4);else if(1===u)this._parseAVCVideoData(e,t+4,r-4,n,i,o,c);else if(2!==u)return void this._onError("Flv: Invalid video packet type "+u)}},{key:"_parseAVCDecoderConfigurationRecord",value:function(e,t,r){if(r<7)return void console.log(this.TAG,"Flv: Invalid AVCDecoderConfigurationRecord, lack of data!");var n=this._videoMetadata,i=this._videoTrack,o=this._littleEndian,a=new DataView(e,t,r);n?"undefined"!=typeof n.avcc&&console.log(this.TAG,"Found another AVCDecoderConfigurationRecord!"):(n=this._videoMetadata={},n.type="video",n.id=i.id,n.timescale=this._timescale,n.duration=this._duration);var s=a.getUint8(0),u=a.getUint8(1);a.getUint8(2),a.getUint8(3);if(1!==s||0===u)return void this._onError(DemuxErrors.FORMAT_ERROR,"Flv: Invalid AVCDecoderConfigurationRecord");if(this._naluLengthSize=1+(3&a.getUint8(4)),3!==this._naluLengthSize&&4!==this._naluLengthSize)return void this._onError(DemuxErrors.FORMAT_ERROR,"Flv: Strange NaluLengthSizeMinusOne: "+(this._naluLengthSize-1));var c=31&a.getUint8(5);if(0===c||c>1)return void this._onError(DemuxErrors.FORMAT_ERROR,"Flv: Invalid H264 SPS count: "+c);for(var l=6,f=0;f<c;f++){var d=a.getUint16(l,!o);if(l+=2,0!==d){var h=new Uint8Array(e,t+l,d);l+=d;var p=lr.parseSPS(h);n.codecWidth=p.codec_size.width,n.codecHeight=p.codec_size.height,n.presentWidth=p.present_size.width,n.presentHeight=p.present_size.height,n.config=p,n.profile=p.profile_string,n.level=p.level_string,n.bitDepth=p.bit_depth,n.chromaFormat=p.chroma_format,n.sarRatio=p.sar_ratio,n.frameRate=p.frame_rate,!1!==p.frame_rate.fixed&&0!==p.frame_rate.fps_num&&0!==p.frame_rate.fps_den||(n.frameRate=this._referenceFrameRate);var y=n.frameRate.fps_den,g=n.frameRate.fps_num;n.refSampleDuration=Math.floor(n.timescale*(y/g));for(var m=h.subarray(1,4),_="avc1.",v=0;v<3;v++){var b=m[v].toString(16);b.length<2&&(b="0"+b),_+=b}n.codec=_;var $=this._mediaInfo;$.width=n.codecWidth,$.height=n.codecHeight,$.fps=n.frameRate.fps,$.profile=n.profile,$.level=n.level,$.chromaFormat=p.chroma_format_string,$.sarNum=n.sarRatio.width,$.sarDen=n.sarRatio.height,$.videoCodec=_,$.meta=n,$.hasAudio?null!=$.audioCodec&&($.mimeType='video/x-flv; codecs="'+$.videoCodec+","+$.audioCodec+'"'):$.mimeType='video/x-flv; codecs="'+$.videoCodec+'"',$.isComplete()&&this._onMediaInfo($)}}var w=a.getUint8(l);if(0===w||w>1)return void this._onError(DemuxErrors.FORMAT_ERROR,"Flv: Invalid H264 PPS count: "+w);l++;for(var E=0;E<w;E++){var S=a.getUint16(l,!o);l+=2,0!==S&&(l+=S)}n.avcc=new Uint8Array(r),n.avcc.set(new Uint8Array(e,t,r),0),console.log(this.TAG,"Parsed AVCDecoderConfigurationRecord"),this._isInitialMetadataDispatched()?this._dispatch&&(this._audioTrack.length||this._videoTrack.length)&&this._onDataAvailable(this._audioTrack,this._videoTrack):this._videoInitialMetadataDispatched=!0,this._dispatch=!1,this._onTrackMetadata("video",n)}},{key:"timestampBase",value:function(e){this._timestampBase=e}},{key:"_parseAVCVideoData",value:function(e,t,r,n,i,o,a){for(var s=this._littleEndian,u=new DataView(e,t,r),c=[],l=0,f=0,d=this._naluLengthSize,h=this._timestampBase+n,p=1===o;f<r;){if(f+4>=r){console.log(this.TAG,"Malformed Nalu near timestamp "+h+", offset = "+f+", dataSize = "+r);break}var y=u.getUint32(f,!s);if(3===d&&(y>>>=8),y>r-d)return void console.log(this.TAG,"Malformed Nalus near timestamp "+h+", NaluSize > DataSize!");var g=31&u.getUint8(f+d);5===g&&(p=!0);var m=new Uint8Array(e,t+f,d+y),_={type:g,data:m};c.push(_),l+=m.byteLength,f+=d+y}if(c.length){var v=this._videoTrack,b={units:c,length:l,isKeyframe:p,dts:h,cts:a,pts:h+a};p&&(b.fileposition=i),v.samples.push(b),v.length+=l}}},{key:"_parseAudioData",value:function(e,t,r,n){if(n==this._timestampBase&&0!=this._timestampBase&&console.log(n,this._timestampBase,"\u592d\u5bff\u5566\u8fd9\u4e2a\u89c6\u9891\u4e0d\u662f\u4ece0\u5f00\u59cb"),r<=1)return void console.log(this.TAG,"Flv: Invalid audio packet, missing SoundData payload!");var i=this._audioMetadata,o=this._audioTrack;if(!i||!i.codec){i=this._audioMetadata={},i.type="audio",i.id=o.id,i.timescale=this._timescale,i.duration=this._duration;var a=new DataView(e,t,r),s=a.getUint8(0),u=s>>>4;if(10!==u)return void this._onError(DemuxErrors.CODEC_UNSUPPORTED,"Flv: Unsupported audio codec idx: "+u);var c=0,l=(12&s)>>>2,f=[5500,11025,22050,44100,48e3];if(!(l<f.length))return void this._onError(DemuxErrors.FORMAT_ERROR,"Flv: Invalid audio sample rate idx: "+l);c=f[l];var d=1&s;i.audioSampleRate=c,i.channelCount=0===d?1:2,i.refSampleDuration=Math.floor(1024/i.audioSampleRate*i.timescale),i.codec="mp4a.40.5"}var h=this._parseAACAudioData(e,t+1,r-1);if(h!=undefined){if(0===h.packetType){i.config&&console.log(this.TAG,"Found another AudioSpecificConfig!");var p=h.data;i.audioSampleRate=p.samplingRate,i.channelCount=p.channelCount,i.codec=p.codec,i.config=p.config,i.refSampleDuration=Math.floor(1024/i.audioSampleRate*i.timescale),console.log(this.TAG,"Parsed AudioSpecificConfig"),this._isInitialMetadataDispatched()?this._dispatch&&(this._audioTrack.length||this._videoTrack.length)&&this._onDataAvailable(this._audioTrack,this._videoTrack):this._audioInitialMetadataDispatched=!0,this._dispatch=!1,this._onTrackMetadata("audio",i);var y=this._mediaInfo;return y.audioCodec="mp4a.40."+p.originalAudioObjectType,y.audioSampleRate=i.audioSampleRate,y.audioChannelCount=i.channelCount,y.hasVideo?null!=y.videoCodec&&(y.mimeType='video/x-flv; codecs="'+y.videoCodec+","+y.audioCodec+'"'):y.mimeType='video/x-flv; codecs="'+y.audioCodec+'"',void(y.isComplete()&&this._onMediaInfo(y))}if(1===h.packetType){var g=this._timestampBase+n,m={unit:h.data,dts:g,pts:g};o.samples.push(m),o.length+=h.data.length}else console.log(this.TAG,"Flv: Unsupported AAC data type "+h.packetType)}}},{key:"_parseAACAudioData",value:function(e,t,r){if(r<=1)return void console.log(this.TAG,"Flv: Invalid AAC packet, missing AACPacketType or/and Data!");var n={},i=new Uint8Array(e,t,r);return n.packetType=i[0],0===i[0]?n.data=this._parseAACAudioSpecificConfig(e,t+1,r-1):n.data=i.subarray(1),n}},{key:"_parseAACAudioSpecificConfig",value:function(e,t,r){var n=new Uint8Array(e,t,r),i=null,o=[96e3,88200,64e3,48e3,44100,32e3,24e3,22050,16e3,12e3,11025,8e3,7350],a=0,s=0,u=0,c=null;if(a=s=n[0]>>>3,(u=(7&n[0])<<1|n[1]>>>7)<0||u>=o.length)return void this._onError(DemuxErrors.FORMAT_ERROR,"Flv: AAC invalid sampling frequency index!");var l=o[u],f=(120&n[1])>>>3;if(f<0||f>=8)return void this._onError(DemuxErrors.FORMAT_ERROR,"Flv: AAC invalid channel configuration");5===a&&(c=(7&n[1])<<1|n[2]>>>7);var d=self.navigator.userAgent.toLowerCase();return-1!==d.indexOf("firefox")?u>=6?(a=5,i=new Array(4),c=u-3):(a=2,i=new Array(2),c=u):-1!==d.indexOf("android")?(a=2,i=new Array(2),c=u):(a=5,c=u,i=new Array(4),u>=6?c=u-3:1===f&&(a=2,i=new Array(2),c=u)),i[0]=a<<3,i[0]|=(15&u)>>>1,i[1]=(15&u)<<7,i[1]|=(15&f)<<3,5===a&&(i[1]|=(15&c)>>>1,i[2]=(1&c)<<7,i[2]|=8,i[3]=0),{config:i,samplingRate:l,channelCount:f,codec:"mp4a.40."+a,originalAudioObjectType:s}}},{key:"_isInitialMetadataDispatched",value:function(){return this._hasAudio&&this._hasVideo?this._audioInitialMetadataDispatched&&this._videoInitialMetadataDispatched:this._hasAudio&&!this._hasVideo?this._audioInitialMetadataDispatched:!this._hasAudio&&this._hasVideo?this._videoInitialMetadataDispatched:void 0}},{key:"hasAudio",set:function(e){this._mediaInfo.hasAudio=this._hasAudio=e}},{key:"hasVideo",set:function(e){this._mediaInfo.hasVideo=this._hasVideo=e}}]),e}(),gr=function(){function e(){rr(this,e),this.tempUint8=new Uint8Array,this.arrTag=[],this.index=0,this.tempArr=[],this.stop=!1,this.offset=0,this.frist=!0,this._hasAudio=!1,this._hasVideo=!1}return sr(e,[{key:"setFlv",value:function(e){return this.stop=!1,this.arrTag=[],this.index=0,this.tempUint8=e,this.tempUint8.length>13&&70==this.tempUint8[0]&&76==this.tempUint8[1]&&86==this.tempUint8[2]?(this.probe(this.tempUint8.buffer),this.read(9),this.read(4),this.parse(),this.frist=!1,this.offset):this.frist?this.offset:this.parse()}},{key:"probe",value:function(e){var t=new Uint8Array(e),r={match:!1};if(70!==t[0]||76!==t[1]||86!==t[2]||1!==t[3])return r;var n=(4&t[4])>>>2!=0,i=0!=(1&t[4]);return n||i?(this._hasAudio=yr._hasAudio=n,this._hasVideo=yr._hasVideo=i,{match:!0,hasAudioTrack:n,hasVideoTrack:i}):r}},{key:"parse",value:function(){for(;this.index<this.tempUint8.length&&!this.stop;){this.offset=this.index;var e=new ur;if(this.tempUint8.length-this.index>=11){if(e.tagType=this.read(1)[0],e.dataSize=this.read(3),e.Timestamp=this.read(4),e.StreamID=this.read(3),18!=e.tagType&&8!=e.tagType&&9!=e.tagType)throw new pr("wrong tagType"+e.tagType);this.tempUint8.length-this.index>=this.getBodySum(e.dataSize)+4?(e.body=this.read(this.getBodySum(e.dataSize)),9==e.tagType&&this._hasVideo&&this.arrTag.push(e),8==e.tagType&&this._hasAudio&&this.arrTag.push(e),18==e.tagType&&0==this.arrTag.length&&this.arrTag.push(e),e.size=this.read(4),this.offset=this.index):this.stop=!0}else this.stop=!0}return this.offset}},{key:"read",value:function(e){var t=this.tempUint8.slice(this.index,this.index+e);return this.index+=e,t}},{key:"getBodySum",value:function(e){var t="";return t+=1==e[0].toString(16).length?"0"+e[0].toString(16):e[0].toString(16),t+=1==e[1].toString(16).length?"0"+e[1].toString(16):e[1].toString(16),t+=1==e[2].toString(16).length?"0"+e[2].toString(16):e[2].toString(16),parseInt(t,16)}}]),e}(),mr=function(){function e(){rr(this,e)}return sr(e,null,[{key:"init",value:function(){e.types={avc1:[],avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],mvex:[],mvhd:[],sdtp:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[],smhd:[]};for(var t in e.types)e.types.hasOwnProperty(t)&&(e.types[t]=[t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2),t.charCodeAt(3)]);var r=e.constants={};r.FTYP=new Uint8Array([105,115,111,109,0,0,0,1,105,115,111,109,97,118,99,49]),r.STSD_PREFIX=new Uint8Array([0,0,0,0,0,0,0,1]),r.STTS=new Uint8Array([0,0,0,0,0,0,0,0]),r.STSC=r.STCO=r.STTS,r.STSZ=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0]),r.HDLR_VIDEO=new Uint8Array([0,0,0,0,0,0,0,0,118,105,100,101,0,0,0,0,0,0,0,0,0,0,0,0,86,105,100,101,111,72,97,110,100,108,101,114,0]),r.HDLR_AUDIO=new Uint8Array([0,0,0,0,0,0,0,0,115,111,117,110,0,0,0,0,0,0,0,0,0,0,0,0,83,111,117,110,100,72,97,110,100,108,101,114,0]),r.DREF=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,12,117,114,108,32,0,0,0,1]),r.SMHD=new Uint8Array([0,0,0,0,0,0,0,0]),r.VMHD=new Uint8Array([0,0,0,1,0,0,0,0,0,0,0,0])}},{key:"box",value:function(e){for(var t=8,r=null,n=Array.prototype.slice.call(arguments,1),i=n.length,o=0;o<i;o++)t+=n[o].byteLength;r=new Uint8Array(t),r[0]=t>>>24&255,r[1]=t>>>16&255,r[2]=t>>>8&255,r[3]=255&t,r.set(e,4);for(var a=8,s=0;s<i;s++)r.set(n[s],a),a+=n[s].byteLength;return r}},{key:"generateInitSegment",value:function(t){t.constructor!=Array&&(t=[t]);var r=e.box(e.types.ftyp,e.constants.FTYP),n=e.moov(t),i=new Uint8Array(r.byteLength+n.byteLength);return i.set(r,0),i.set(n,r.byteLength),i}},{key:"moov",value:function(t){var r=e.mvhd(t[0].timescale,t[0].duration),n=e.trak(t[0]),i=void 0;t.length>1&&(i=e.trak(t[1]));var o=e.mvex(t);return t.length>1?e.box(e.types.moov,r,n,i,o):e.box(e.types.moov,r,n,o)}},{key:"mvhd",value:function(t,r){return e.box(e.types.mvhd,new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,t>>>24&255,t>>>16&255,t>>>8&255,255&t,r>>>24&255,r>>>16&255,r>>>8&255,255&r,0,1,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255]))}},{key:"trak",value:function(t){return e.box(e.types.trak,e.tkhd(t),e.mdia(t))}},{key:"tkhd",value:function(t){var r=t.id,n=t.duration,i=t.presentWidth,o=t.presentHeight;return e.box(e.types.tkhd,new Uint8Array([0,0,0,7,0,0,0,0,0,0,0,0,r>>>24&255,r>>>16&255,r>>>8&255,255&r,0,0,0,0,n>>>24&255,n>>>16&255,n>>>8&255,255&n,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,i>>>8&255,255&i,0,0,o>>>8&255,255&o,0,0]))}},{key:"mdia",value:function(t){return e.box(e.types.mdia,e.mdhd(t),e.hdlr(t),e.minf(t))}},{key:"mdhd",value:function(t){var r=t.timescale,n=t.duration;return e.box(e.types.mdhd,new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,r>>>24&255,r>>>16&255,r>>>8&255,255&r,n>>>24&255,n>>>16&255,n>>>8&255,255&n,85,196,0,0]))}},{key:"hdlr",value:function(t){var r=null;return r="audio"===t.type?e.constants.HDLR_AUDIO:e.constants.HDLR_VIDEO,e.box(e.types.hdlr,r)}},{key:"minf",value:function(t){var r=null;return r="audio"===t.type?e.box(e.types.smhd,e.constants.SMHD):e.box(e.types.vmhd,e.constants.VMHD),e.box(e.types.minf,r,e.dinf(),e.stbl(t))}},{key:"dinf",value:function(){return e.box(e.types.dinf,e.box(e.types.dref,e.constants.DREF))}},{key:"stbl",value:function(t){return e.box(e.types.stbl,e.stsd(t),e.box(e.types.stts,e.constants.STTS),e.box(e.types.stsc,e.constants.STSC),e.box(e.types.stsz,e.constants.STSZ),e.box(e.types.stco,e.constants.STCO))}},{key:"stsd",value:function(t){return"audio"===t.type?e.box(e.types.stsd,e.constants.STSD_PREFIX,e.mp4a(t)):e.box(e.types.stsd,e.constants.STSD_PREFIX,e.avc1(t))}},{key:"mp4a",value:function(t){var r=t.channelCount,n=t.audioSampleRate,i=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,r,0,16,0,0,0,0,n>>>8&255,255&n,0,0]);return e.box(e.types.mp4a,i,e.esds(t))}},{key:"esds",value:function(t){var r=t.config,n=r.length,i=new Uint8Array([0,0,0,0,3,23+n,0,1,0,4,15+n,64,21,0,0,0,0,0,0,0,0,0,0,0,5].concat([n]).concat(r).concat([6,1,2]));return e.box(e.types.esds,i)}},{key:"avc1",value:function(t){var r=t.avcc,n=t.codecWidth,i=t.codecHeight,o=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,n>>>8&255,255&n,i>>>8&255,255&i,0,72,0,0,0,72,0,0,0,0,0,0,0,1,4,103,49,49,49,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,255,255]);return e.box(e.types.avc1,o,e.box(e.types.avcC,r))}},{key:"mvex",value:function(t){return t.length>1?e.box(e.types.mvex,e.trex(t[0]),e.trex(t[1])):e.box(e.types.mvex,e.trex(t[0]))}},{key:"trex",value:function(t){var r=t.id,n=new Uint8Array([0,0,0,0,r>>>24&255,r>>>16&255,r>>>8&255,255&r,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,1]);return e.box(e.types.trex,n)}},{key:"moof",value:function(t,r){return e.box(e.types.moof,e.mfhd(t.sequenceNumber),e.traf(t,r))}},{key:"mfhd",value:function(t){var r=new Uint8Array([0,0,0,0,t>>>24&255,t>>>16&255,t>>>8&255,255&t]);return e.box(e.types.mfhd,r)}},{key:"traf",value:function(t,r){var n=t.id,i=e.box(e.types.tfhd,new Uint8Array([0,0,0,0,n>>>24&255,n>>>16&255,n>>>8&255,255&n])),o=e.box(e.types.tfdt,new Uint8Array([0,0,0,0,r>>>24&255,r>>>16&255,r>>>8&255,255&r])),a=e.sdtp(t),s=e.trun(t,a.byteLength+16+16+8+16+8+8);return e.box(e.types.traf,i,o,s,a)}},{key:"sdtp",value:function(t){for(var r=t.samples||[],n=r.length,i=new Uint8Array(4+n),o=0;o<n;o++){var a=r[o].flags;i[o+4]=a.isLeading<<6|a.dependsOn<<4|a.isDependedOn<<2|a.hasRedundancy}return e.box(e.types.sdtp,i)}},{key:"trun",value:function(t,r){var n=t.samples||[],i=n.length,o=12+16*i,a=new Uint8Array(o);r+=8+o,a.set([0,0,15,1,i>>>24&255,i>>>16&255,i>>>8&255,255&i,r>>>24&255,r>>>16&255,r>>>8&255,255&r],0);for(var s=0;s<i;s++){var u=n[s].duration,c=n[s].size,l=n[s].flags,f=n[s].cts;a.set([u>>>24&255,u>>>16&255,u>>>8&255,255&u,c>>>24&255,c>>>16&255,c>>>8&255,255&c,l.isLeading<<2|l.dependsOn,l.isDependedOn<<6|l.hasRedundancy<<4|l.isNonSync,0,0,f>>>24&255,f>>>16&255,f>>>8&255,255&f],12+16*s)}return e.box(e.types.trun,a)}},{key:"mdat",value:function(t){return e.box(e.types.mdat,t)}}]),e}(),_r=function(){function e(){rr(this,e)}return sr(e,null,[{key:"getSilentFrame",value:function(e){return 1===e?new Uint8Array([0,200,0,128,35,128]):2===e?new Uint8Array([33,0,73,144,2,25,0,35,128]):3===e?new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,142]):4===e?new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,128,44,128,8,2,56]):5===e?new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,56]):6===e?new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,0,178,0,32,8,224]):null}}]),e}(),vr={};!function(){
var e=self.navigator.userAgent.toLowerCase(),t=/(edge)\/([\w.]+)/.exec(e)||/(opr)[\/]([\w.]+)/.exec(e)||/(chrome)[ \/]([\w.]+)/.exec(e)||/(iemobile)[\/]([\w.]+)/.exec(e)||/(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(e)||/(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(e)||/(webkit)[ \/]([\w.]+)/.exec(e)||/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(e)||/(msie) ([\w.]+)/.exec(e)||e.indexOf("trident")>=0&&/(rv)(?::| )([\w.]+)/.exec(e)||e.indexOf("compatible")<0&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(e)||[],r=/(ipad)/.exec(e)||/(ipod)/.exec(e)||/(windows phone)/.exec(e)||/(iphone)/.exec(e)||/(kindle)/.exec(e)||/(android)/.exec(e)||/(windows)/.exec(e)||/(mac)/.exec(e)||/(linux)/.exec(e)||/(cros)/.exec(e)||[],n={browser:t[5]||t[3]||t[1]||"",version:t[2]||t[4]||"0",majorVersion:t[4]||t[2]||"0",platform:r[0]||""},i={};if(n.browser){i[n.browser]=!0;var o=n.majorVersion.split(".");i.version={major:parseInt(n.majorVersion,10),string:n.version},o.length>1&&(i.version.minor=parseInt(o[1],10)),o.length>2&&(i.version.build=parseInt(o[2],10))}n.platform&&(i[n.platform]=!0),(i.chrome||i.opr||i.safari)&&(i.webkit=!0),(i.rv||i.iemobile)&&(i.rv&&delete i.rv,n.browser="msie",i.msie=!0),i.edge&&(delete i.edge,n.browser="msedge",i.msedge=!0),i.opr&&(n.browser="opera",i.opera=!0),i.safari&&i.android&&(n.browser="android",i.android=!0),i.name=n.browser,i.platform=n.platform;for(var a in vr)vr.hasOwnProperty(a)&&delete vr[a];er(vr,i)}();var br=function Ar(e,t,r,n,i){rr(this,Ar),this.dts=e,this.pts=t,this.duration=r,this.originalDts=n,this.isSyncPoint=i,this.fileposition=null},$r=function(){function e(){rr(this,e),this.beginDts=0,this.endDts=0,this.beginPts=0,this.endPts=0,this.originalBeginDts=0,this.originalEndDts=0,this.syncPoints=[],this.firstSample=null,this.lastSample=null}return sr(e,[{key:"appendSyncPoint",value:function(e){e.isSyncPoint=!0,this.syncPoints.push(e)}}]),e}(),wr=(function(){function e(){rr(this,e),this._list=[]}sr(e,[{key:"clear",value:function(){this._list=[]}},{key:"appendArray",value:function(e){var t=this._list;0!==e.length&&(t.length>0&&e[0].originalDts<t[t.length-1].originalDts&&this.clear(),Array.prototype.push.apply(t,e))}},{key:"getLastSyncPointBeforeDts",value:function(e){if(0==this._list.length)return null;var t=this._list,r=0,n=t.length-1,i=0,o=0,a=n;for(e<t[0].dts&&(r=0,o=a+1);o<=a;){if((i=o+Math.floor((a-o)/2))===n||e>=t[i].dts&&e<t[i+1].dts){r=i;break}t[i].dts<e?o=i+1:a=i-1}return this._list[r]}}])}(),function(){function e(t){rr(this,e),this._type=t,this._list=[],this._lastAppendLocation=-1}return sr(e,[{key:"isEmpty",value:function(){return 0===this._list.length}},{key:"clear",value:function(){this._list=[],this._lastAppendLocation=-1}},{key:"_searchNearestSegmentBefore",value:function(e){var t=this._list;if(0===t.length)return-2;var r=t.length-1,n=0,i=0,o=r,a=0;if(e<t[0].originalBeginDts)return a=-1;for(;i<=o;){if((n=i+Math.floor((o-i)/2))===r||e>t[n].lastSample.originalDts&&e<t[n+1].originalBeginDts){a=n;break}t[n].originalBeginDts<e?i=n+1:o=n-1}return a}},{key:"_searchNearestSegmentAfter",value:function(e){return this._searchNearestSegmentBefore(e)+1}},{key:"append",value:function(e){var t=this._list,r=e,n=this._lastAppendLocation,i=0;-1!==n&&n<t.length&&r.originalBeginDts>=t[n].lastSample.originalDts&&(n===t.length-1||n<t.length-1&&r.originalBeginDts<t[n+1].originalBeginDts)?i=n+1:t.length>0&&(i=this._searchNearestSegmentBefore(r.originalBeginDts)+1),this._lastAppendLocation=i,this._list.splice(i,0,r)}},{key:"getLastSegmentBefore",value:function(e){var t=this._searchNearestSegmentBefore(e);return t>=0?this._list[t]:null}},{key:"getLastSampleBefore",value:function(e){var t=this.getLastSegmentBefore(e);return null!=t?t.lastSample:null}},{key:"getLastSyncPointBefore",value:function(e){for(var t=this._searchNearestSegmentBefore(e),r=this._list[t].syncPoints;0===r.length&&t>0;)t--,r=this._list[t].syncPoints;return r.length>0?r[r.length-1]:null}},{key:"type",get:function(){return this._type}},{key:"length",get:function(){return this._list.length}}]),e}()),Er=function(){function e(t){rr(this,e),this.TAG="MP4Remuxer",this._config=t,this._isLive=!0===t.isLive,this._dtsBase=-1,this._dtsBaseInited=!1,this._audioDtsBase=Infinity,this._videoDtsBase=Infinity,this._audioNextDts=undefined,this._videoNextDts=undefined,this._audioMeta=null,this._videoMeta=null,this._audioSegmentInfoList=new wr("audio"),this._videoSegmentInfoList=new wr("video"),this._onInitSegment=null,this._onMediaSegment=null,this._forceFirstIDR=!(!vr.chrome||!(vr.version.major<50||50===vr.version.major&&vr.version.build<2661)),this._fillSilentAfterSeek=vr.msedge||vr.msie,this._mp3UseMpegAudio=!vr.firefox}return sr(e,[{key:"destroy",value:function(){this._dtsBase=-1,this._dtsBaseInited=!1,this._audioMeta=null,this._videoMeta=null,this._audioSegmentInfoList.clear(),this._audioSegmentInfoList=null,this._videoSegmentInfoList.clear(),this._videoSegmentInfoList=null,this._onInitSegment=null,this._onMediaSegment=null}},{key:"bindDataSource",value:function(e){return e.onDataAvailable=this.remux.bind(this),e.onTrackMetadata=this._onTrackMetadataReceived.bind(this),this}},{key:"insertDiscontinuity",value:function(){this._audioNextDts=this._videoNextDts=undefined}},{key:"seek",value:function(e){this._videoSegmentInfoList.clear(),this._audioSegmentInfoList.clear()}},{key:"remux",value:function(e,t){if(!this._onMediaSegment)throw new IllegalStateException("MP4Remuxer: onMediaSegment callback must be specificed!");this._dtsBaseInited||this._calculateDtsBase(e,t),this._remuxVideo(t),this._remuxAudio(e)}},{key:"_onTrackMetadataReceived",value:function(e,t){var r=null,n="mp4",i=t.codec;if("audio"===e)this._audioMeta=t,"mp3"===t.codec&&this._mp3UseMpegAudio?(n="mpeg",i="",r=new Uint8Array):r=mr.generateInitSegment(t);else{if("video"!==e)return;this._videoMeta=t,r=mr.generateInitSegment(t)}if(!this._onInitSegment)throw new IllegalStateException("MP4Remuxer: onInitSegment callback must be specified!");this._onInitSegment(e,{type:e,data:r.buffer,codec:i,container:e+"/"+n,mediaDuration:t.duration})}},{key:"_calculateDtsBase",value:function(e,t){this._dtsBaseInited||(e.samples&&e.samples.length&&(this._audioDtsBase=e.samples[0].dts),t.samples&&t.samples.length&&(this._videoDtsBase=t.samples[0].dts),this._dtsBase=Math.min(this._audioDtsBase,this._videoDtsBase),this._dtsBaseInited=!0)}},{key:"_remuxAudio",value:function(e){if(null!=this._audioMeta){var t=e,r=t.samples,n=undefined,i=-1,o=-1,a=this._audioMeta.refSampleDuration,s="mp3"===this._audioMeta.codec&&this._mp3UseMpegAudio,u=this._dtsBaseInited&&this._audioNextDts===undefined,c=!1;if(r&&0!==r.length){var l=0,f=null,d=0;s?(l=0,d=t.length):(l=8,d=8+t.length);var h=r[0].dts-this._dtsBase;if(this._audioNextDts)n=h-this._audioNextDts;else if(this._audioSegmentInfoList.isEmpty())n=0,this._fillSilentAfterSeek&&!this._videoSegmentInfoList.isEmpty()&&"mp3"!==this._audioMeta.originalCodec&&(c=!0);else{var p=this._audioSegmentInfoList.getLastSampleBefore(h);if(null!=p){var y=h-(p.originalDts+p.duration);y<=3&&(y=0);var g=p.dts+p.duration+y;n=h-g}else n=0}if(c){var m=h-n,_=this._videoSegmentInfoList.getLastSegmentBefore(h);if(null!=_&&_.beginDts<m){var v=_r.getSilentFrame(this._audioMeta.originalCodec,this._audioMeta.channelCount);if(v){var b=_.beginDts,$=m-_.beginDts;Log.v(this.TAG,"InsertPrefixSilentAudio: dts: "+b+", duration: "+$),r.unshift({unit:v,dts:b,pts:b}),d+=v.byteLength}}else c=!1}for(var w=[],E=0;E<r.length;E++){var S=r[E],O=S.unit,T=S.dts-this._dtsBase,A=T-n;-1===i&&(i=A);var x=0;if(E!==r.length-1){x=r[E+1].dts-this._dtsBase-n-A}else x=w.length>=1?w[w.length-1].duration:Math.floor(a);var k=!1,D=null;if(x>1.5*a&&"mp3"!==this._audioMeta.codec){k=!0;var I=Math.abs(x-a),P=Math.ceil(I/a),M=A+a,R=_r.getSilentFrame(this._audioMeta.originalCodec,this._audioMeta.channelCount);null==R&&(R=O),D=[];for(var C=0;C<P;C++){var j=Math.round(M);if(D.length>0){var L=D[D.length-1];L.duration=j-L.dts}var N={dts:j,pts:j,cts:0,unit:R,size:R.byteLength,duration:0,originalDts:T,flags:{isLeading:0,dependsOn:1,isDependedOn:0,hasRedundancy:0}};D.push(N),d+=O.byteLength,M+=a}var F=D[D.length-1];F.duration=A+x-F.dts,x=Math.round(a)}w.push({dts:A,pts:A,cts:0,unit:S.unit,size:S.unit.byteLength,duration:x,originalDts:T,flags:{isLeading:0,dependsOn:1,isDependedOn:0,hasRedundancy:0}}),k&&w.push.apply(w,D)}s?f=new Uint8Array(d):(f=new Uint8Array(d),f[0]=d>>>24&255,f[1]=d>>>16&255,f[2]=d>>>8&255,f[3]=255&d,f.set(mr.types.mdat,4));for(var B=0;B<w.length;B++){var U=w[B].unit;f.set(U,l),l+=U.byteLength}var z=w[w.length-1];o=z.dts+z.duration,this._audioNextDts=o;var G=new $r;G.beginDts=i,G.endDts=o,G.beginPts=i,G.endPts=o,G.originalBeginDts=w[0].originalDts,G.originalEndDts=z.originalDts+z.duration,G.firstSample=new br(w[0].dts,w[0].pts,w[0].duration,w[0].originalDts,!1),G.lastSample=new br(z.dts,z.pts,z.duration,z.originalDts,!1),this._isLive||this._audioSegmentInfoList.append(G),t.samples=w,t.sequenceNumber++;var W=null;W=s?new Uint8Array:mr.moof(t,i),t.samples=[],t.length=0;var H={type:"audio",data:this._mergeBoxes(W,f).buffer,sampleCount:w.length,info:G};s&&u&&(H.timestampOffset=i),this._onMediaSegment("audio",H)}}}},{key:"_remuxVideo",value:function(e){if(null!=this._videoMeta){var t=e,r=t.samples,n=undefined,i=-1,o=-1,a=-1,s=-1;if(r&&0!==r.length){var u=8,c=8+e.length,l=new Uint8Array(c);l[0]=c>>>24&255,l[1]=c>>>16&255,l[2]=c>>>8&255,l[3]=255&c,l.set(mr.types.mdat,4);var f=r[0].dts-this._dtsBase;if(this._videoNextDts)n=f-this._videoNextDts;else if(this._videoSegmentInfoList.isEmpty())n=0;else{var d=this._videoSegmentInfoList.getLastSampleBefore(f);if(null!=d){var h=f-(d.originalDts+d.duration);h<=3&&(h=0);var p=d.dts+d.duration+h;n=f-p}else n=0}for(var y=new $r,g=[],m=0;m<r.length;m++){var _=r[m],v=_.dts-this._dtsBase,b=_.isKeyframe,$=v-n,w=_.cts,E=$+w;-1===i&&(i=$,a=E);var S=0;if(m!==r.length-1){S=r[m+1].dts-this._dtsBase-n-$}else S=g.length>=1?g[g.length-1].duration:Math.floor(this._videoMeta.refSampleDuration);if(b){var O=new br($,E,S,_.dts,!0);O.fileposition=_.fileposition,y.appendSyncPoint(O)}g.push({dts:$,pts:E,cts:w,units:_.units,size:_.length,isKeyframe:b,duration:S,originalDts:v,flags:{isLeading:0,dependsOn:b?2:1,isDependedOn:b?1:0,hasRedundancy:0,isNonSync:b?0:1}})}for(var T=0;T<g.length;T++)for(var A=g[T].units;A.length;){var x=A.shift(),k=x.data;l.set(k,u),u+=k.byteLength}var D=g[g.length-1];if(o=D.dts+D.duration,s=D.pts+D.duration,this._videoNextDts=o,y.beginDts=i,y.endDts=o,y.beginPts=a,y.endPts=s,y.originalBeginDts=g[0].originalDts,y.originalEndDts=D.originalDts+D.duration,y.firstSample=new br(g[0].dts,g[0].pts,g[0].duration,g[0].originalDts,g[0].isKeyframe),y.lastSample=new br(D.dts,D.pts,D.duration,D.originalDts,D.isKeyframe),this._isLive||this._videoSegmentInfoList.append(y),t.samples=g,t.sequenceNumber++,this._forceFirstIDR){var I=g[0].flags;I.dependsOn=2,I.isNonSync=0}var P=mr.moof(t,i);t.samples=[],t.length=0,this._onMediaSegment("video",{type:"video",data:this._mergeBoxes(P,l).buffer,sampleCount:g.length,info:y})}}}},{key:"_mergeBoxes",value:function(e,t){var r=new Uint8Array(e.byteLength+t.byteLength);return r.set(e,0),r.set(t,e.byteLength),r}},{key:"onInitSegment",get:function(){return this._onInitSegment},set:function(e){this._onInitSegment=e}},{key:"onMediaSegment",get:function(){return this._onMediaSegment},set:function(e){this._onMediaSegment=e}}]),e}(),Sr=function(){function t(e){rr(this,t),mr.init(),this._config={_isLive:!1},this._config=er(this._config,e),this.onInitSegment=null,this.onMediaSegment=null,this.onMediaInfo=null,this.seekCallBack=null,this.loadmetadata=!1,this.ftyp_moov=null,this._tagdemux=new yr,this._flvparse=new gr,this.ftyp_moov_v=null,this.ftyp_moov_a=null,this.metaSuccRun=!1,this.metas=[],this.parseChunk=null,this.hasVideo=!1,this.hasAudio=!1,this._error=null,this._pendingResolveSeekPoint=-1,this._tempBaseTime=0,this.setflvBase=this.setflvBasefrist,this._tagdemux._onTrackMetadata=this.Metadata.bind(this),this._tagdemux._onMediaInfo=this.metaSucc.bind(this),this._tagdemux._onDataAvailable=this.onDataAvailable.bind(this),this._tagdemux._onError=this.error.bind(this),this.m4mof=new Er(this._config),this.m4mof.onMediaSegment=this.onMdiaSegment.bind(this)}return sr(t,[{key:"seek",value:function(e){this.setflvBase=this.setflvBasefrist,e!=undefined&&0!=e||(e=0,this._pendingResolveSeekPoint=-1),this._tempBaseTime!=e&&(this._tempBaseTime=e,this._tagdemux._timestampBase=e,this.m4mof.seek(e),this.m4mof.insertDiscontinuity(),this._pendingResolveSeekPoint=e)}},{key:"setflvBasefrist",value:function(e,t){var r=0;try{r=this._flvparse.setFlv(new Uint8Array(e))}catch(n){this.error(n)}if(0==this._flvparse.arrTag.length)return r;if(this._flvparse.arrTag.length>0){this._tagdemux.hasAudio=this.hasAudio=this._flvparse._hasAudio,this._tagdemux.hasVideo=this.hasVideo=this._flvparse._hasVideo,0!=this._tempBaseTime&&this._tempBaseTime==this._flvparse.arrTag[0].getTime()&&(this._tagdemux._timestampBase=0);try{this._tagdemux.moofTag(this._flvparse.arrTag)}catch(n){this.error(n)}this.setflvBase=this.setflvBaseUsually}return r}},{key:"setflvBaseUsually",value:function(e,t){var r=0;try{r=this._flvparse.setFlv(new Uint8Array(e))}catch(n){this.error(n)}if(this._flvparse.arrTag.length>0)try{this._tagdemux.moofTag(this._flvparse.arrTag)}catch(n){this.error(n)}return r}},{key:"onMdiaSegment",value:function(e,t){if(this.onMediaSegment&&this.onMediaSegment(e,new Uint8Array(t.data)),-1!=this._pendingResolveSeekPoint&&"video"==e){var r=this._pendingResolveSeekPoint;this._pendingResolveSeekPoint=-1,this.seekCallBack&&this.seekCallBack(r)}}},{key:"Metadata",value:function(e,t){switch(e){case"video":if(this.metas.push(["video",t]),this.m4mof._videoMeta=t,this.hasVideo&&!this.hasAudio)return void this.metaSucc();break;case"audio":if(this.metas.push(["audio",t]),this.m4mof._audioMeta=t,!this.hasVideo&&this.hasAudio)return void this.metaSucc()}this.hasVideo&&this.hasAudio&&this.metas.length>1&&this.metaSucc()}},{key:"metaSucc",value:function(e){var t=this;if(this.onMediaInfo&&e&&this.onMediaInfo(e||this._tagdemux._mediaInfo,{hasAudio:this.hasAudio,hasVideo:this.hasVideo}),0==this.metas.length)return void(this.metaSuccRun=!0);e||(this.metas.length>1?this.metas.map(function(e){"video"==e[0]?t.ftyp_moov_v=mr.generateInitSegment([e[1]]):t.ftyp_moov_a=mr.generateInitSegment([e[1]])}):this.ftyp_moov=mr.generateInitSegment([this.metas[0][1]]),this.onInitSegment&&0==this.loadmetadata&&(this.ftyp_moov?this.onInitSegment(this.ftyp_moov):this.onInitSegment(this.ftyp_moov_v,this.ftyp_moov_a),this.loadmetadata=!0))}},{key:"onDataAvailable",value:function(t,r){try{this.m4mof.remux(t,r)}catch(e){this.error(e)}}},{key:"setflv",value:function(e,t){return this.setflvBase(e,t)}},{key:"setflvloc",value:function(e){gr.setFlv(new Uint8Array(e));if(gr.arrTag.length>0)return gr.arrTag}},{key:"error",value:function(e){this._error&&this._error(e)}}]),t}(),Or=function(e){function t(e){rr(this,t);var r=Bt(this,(t.__proto__||V(t)).call(this));return r.f2m=new Sr(e),r.f2m._error=r.error.bind(r),r._onInitSegment=null,r._onMediaSegment=null,r._onMediaInfo=null,r._seekCallBack=null,r}return Zt(t,e),sr(t,[{key:"error",value:function(e){this.emit("error",e.type)}},{key:"seek",value:function(e){this.f2m.seek(e)}},{key:"setflv",value:function(e){return this.f2m.setflv(e,0)}},{key:"setflvloc",value:function(e){return this.f2m.setflvloc(e)}},{key:"onInitSegment",set:function(e){this._onInitSegment=e,this.f2m.onInitSegment=e}},{key:"onMediaSegment",set:function(e){this._onMediaSegment=e,this.f2m.onMediaSegment=e}},{key:"onMediaInfo",set:function(e){this._onMediaInfo=e,this.f2m.onMediaInfo=e}},{key:"seekCallBack",set:function(e){this._seekCallBack=e,this.f2m.seekCallBack=e}}]),t}(u.CustEvent);r["default"]=Or},function(e,t,r){e.exports=r(7)},function(e,t,r){function n(e){return e&&e.__esModule?e:{"default":e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(8),c=n(u),l=r(9),f=n(l),d=r(17),h=n(d),p=r(18),y=function(e){function t(e,r){i(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.tag="flv-player",n.video=e,n.box="flv",n.timer=null,n.seekTimer=null,n.config=(0,p.deepAssign)({},h["default"],r),n.requestSetTime=!1,n.throttle=null,n.bindEvents(),n.attachMedia(),n}return a(t,e),s(t,null,[{key:"isSupport",value:function(){var e=new p.UAParser,t=e.getBrowser();return!("Safari"===t.name&&parseInt(t.major)<10)&&!(!window.MediaSource||!window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.640020,mp4a.40.2"'))}},{key:"version",get:function(){return"1.4.5"}}]),s(t,[{key:"internalPropertyHandle",value:function(){if(Object.getOwnPropertyDescriptor){var e=this,t=Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype,"currentTime");Object.defineProperty(this.video,"currentTime",{get:function(){return t.get.call(e.video)},set:function(r){if(e.currentTimeLock)return t.set.call(e.video,r);throw new Error("can not set currentTime by youself")}})}}},{key:"bindEvents",value:function(){var e=this;this.video&&this.video.addEventListener("canplay",function(){e.config.isLive&&e.video.play(),e.config.lockInternalProperty&&e.internalPropertyHandle()})}},{key:"attachMedia",value:function(){var e=this;this.mediaSource=new c["default"](this.video,this.config),this.mediaSource.on("error",function(t){e.emit("error",t.data),e.transmuxer&&e.transmuxer.pause()}),this.mediaSource.on("bufferFull",function(){e.pauseTransmuxer()}),this.mediaSource.on("updateend",function(){e.onmseUpdateEnd()})}},{key:"load",value:function(e){e&&(this.config.src=e),this.transmuxer=new f["default"](this.mediaSource,this.config,this.globalEvent),this.transmuxerEvent(this.transmuxer),this.transmuxer.loadSource()}},{key:"transmuxerEvent",value:function(e){var t=this,r=this.mediaSource;e.on("mediaSegment",function(e){r.emit("mediaSegment",e.data)}),e.on("mediaSegmentInit",function(e){r.emit("mediaSegmentInit",e.data)}),e.on("error",function(n){t.emit("error",n.data),e.pause(),r.pause()}),e.on("end",function(e){r.endOfStream()}),e.on("heartbeat",function(e){t.emit("heartbeat",e.data)}),e.on("mediaInfo",function(e){t.mediaInfo||(t.mediaInfo=e,t.emit("mediaInfo",e.data),r.init(e.data),t.video.src=URL.createObjectURL(r.mediaSource),t.video.addEventListener("seeking",t._throttle.call(t)))})}},{key:"_throttle",value:function(){return this.throttle=(0,p.throttle)(this._seek.bind(this),200,{leading:!1}),this.throttle}},{key:"isTimeinBuffered",value:function(e){for(var t=this.video.buffered,r=0;r<t.length;r++){var n=t.start(r),i=t.end(r);if(e>=n&&e<i)return!0}return!1}},{key:"getCurrentBufferEnd",value:function(){for(var e=this.video.buffered,t=this.video.currentTime,r=0;r<e.length;r++){var n=e.start(r),i=e.end(r);if(n<=t&&t<i)return i}}},{key:"_seek",value:function(e){var t=this;this.currentTimeLock=!0;var r=(0,p.isNumber)(e)&&!isNaN(e)?e:this.video.currentTime;if(this.requestSetTime)return this.requestSetTime=!1,void(this.currentTimeLock=!1);if(this.isTimeinBuffered(r)){if(this.config.alwaysSeekKeyframe){var n=this.transmuxer.getNearestKeyframe(Math.floor(1e3*r));n&&(this.requestSetTime=!0,this.video.currentTime=n.keyframetime/1e3)}}else{p.Log.verbose(this.tag,"do seek"),this.transmuxer.pause();var i=this.transmuxer.getNearestKeyframe(Math.floor(1e3*r));r=i.keyframetime/1e3,this.seekTimer=setTimeout(function(){t.mediaSource.seek(r),t.transmuxer.seek(i)},100),this.requestSetTime=!0,this.video.currentTime=r,window.clearInterval(this.timer),this.timer=null}return this.currentTimeLock=!1,r}},{key:"onmseUpdateEnd",value:function(){if(!this.config.isLive){this.getCurrentBufferEnd()>=this.video.currentTime+this.config.lazyLoadMaxDuration&&null===this.timer&&(p.Log.verbose(this.tag,"Maximum buffering duration exceeded, suspend transmuxing task"),this.pauseTransmuxer())}}},{key:"heartbeat",value:function(){for(var e=this.video.currentTime,t=this.video.buffered,r=!1,n=0;n<t.length;n++){var i=t.start(n),o=t.end(n);if(e>=i&&e<o){e>=o-this.config.lazyLoadRecoverDuration&&(r=!0);break}}r&&(window.clearInterval(this.timer),this.timer=null,p.Log.verbose(this.tag,"Continue loading from paused position"),this.transmuxer.resume(),this.mediaSource.resume())}},{key:"pauseTransmuxer",value:function(){this.transmuxer.pause(),this.mediaSource.pause(),this.timer||(this.timer=setInterval(this.heartbeat.bind(this),1e3))}},{key:"resume",value:function(){this._seek(0)}},{key:"destroy",value:function(){window.clearInterval(this.timer),window.clearInterval(this.seekTimer),this.video.removeEventListener("seeking",this.throttle),this.video&&(URL.revokeObjectURL(this.video.src),this.video.src="",this.video.removeAttribute("src"),this.transmuxer&&(this.transmuxer.pause(),this.transmuxer.destroy(),this.transmuxer=null),this.mediaSource&&(this.mediaSource.destroy(),this.mediaSource=null))}},{key:"seek",value:function(e){return this._seek(e)}},{key:"play",value:function(){return this.video.play()}},{key:"pause",value:function(){return this.video.pause()}},{key:"refresh",value:function(){this.transmuxer&&this.mediaSource?this._seek(0):p.Log.verbose(this.tag,"transmuxer & mediaSource not ready")}}]),t}(p.CustEvent);t["default"]=y},function(t,r,n){function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(r,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=n(0),c=n(2),l=function(e){return e&&e.__esModule?e:{"default":e}}(c),f=n(1),d=function(t){function r(e,t){i(this,r);var n=o(this,(r.__proto__||Object.getPrototypeOf(r)).call(this));return n.video=e,n.config=t,n.tag="mse-controller",n.e={onSourceOpen:n.onSourceOpen.bind(n),onSourceEnded:n.onSourceEnded.bind(n),onSourceClose:n.onSourceClose.bind(n),onSourceBufferError:n.onSourceBufferError.bind(n)},n.hasVideo=!0,n.hasAudio=!0,n.removeRangesList={video:[],audio:[]},n.removeBucketing=!1,n.timer={video:null,audio:null},n.queue={video:[],audio:[]},n.sourceBuffer={video:null,audio:null},n.mimeCodec={video:null,audio:null},n.sourceBufferEvent(),n.complete=!1,n}return a(r,t),s(r,[{key:"init",value:function(e){if(this.mediaSource)return l["default"].Error(this.tag,"MediaSource has been attached to an HTMLMediaElement!"),void this.emit("error",{errno:f.ERRORNO.MEDIASOURCE_ERROR,errmsg:"MediaSource has been attached to an HTMLMediaElement!"});e.hasAudio?this.mimeCodec.audio='audio/mp4; codecs="'+e.audioCodec+'"':this.hasAudio=!1,e.hasVideo?this.mimeCodec.video='video/mp4; codecs="'+e.videoCodec+'"':this.hasVideo=!1;var t=this.mediaSource=new window.MediaSource;t.addEventListener("sourceopen",this.e.onSourceOpen),t.addEventListener("sourceended",this.e.onSourceEnded),t.addEventListener("sourceclose",this.e.onSourceClose)}},{key:"onSourceOpen",value:function(){l["default"].verbose(this.tag,"MediaSource onSourceOpen"),this.mediaSource.removeEventListener("sourceopen",this.e.onSourceOpen),this.hasAudio&&this.addSourceBuffer("audio"),this.hasVideo&&this.addSourceBuffer("video"),this.hasQueueList()&&this.doUpdate(),this.emit("source_open")}},{key:"addSourceBuffer",value:function(e){var t=this;this.sourceBuffer[e]=this.mediaSource.addSourceBuffer(this.mimeCodec[e]),l["default"].verbose(this.tag,"add sourcebuffer "+e);var r=this.sourceBuffer[e];r.addEventListener("error",this.e.onSourceBufferError),r.addEventListener("abort",function(){return l["default"].verbose(t.tag,"sourceBuffer: abort")}),r.addEventListener("updateend",function(){t.sourceBuffer&&(t.hasRemoveList()?(t.removeRangesList.video.length&&t.cleanRangesList("video"),t.removeRangesList.audio.length&&t.cleanRangesList("audio")):t.hasQueueList()?t.doUpdate():t.complete&&!t.sourceBuffer[e].updating&&t.endOfStream(),t.emit("updateend"))})}},{key:"hasRemoveList",value:function(){return this.removeRangesList.video.length||this.removeRangesList.audio.length}},{key:"hasQueueList",value:function(){return this.queue.video.length||this.queue.audio.length}},{key:"doUpdate",value:function(){for(var e in this.queue)if(this.queue[e].length>0&&!this.sourceBuffer[e].updating){var t=this.queue[e].shift();this.appendBuffer(t,e)}}},{key:"sourceBufferEvent",value:function(){var e=this;this.on("mediaSegment",function(t){var r=t.data,n=r.type;e.needCleanupSourceBuffer(n)&&e.doCleanupSourceBuffer(n),!e.sourceBuffer[n]||e.sourceBuffer[n].updating||e.queue[n].length>0?e.queue[n].push(r.data):e.appendBuffer(r.data,n)}),this.on("mediaSegmentInit",function(t){var r=t.data,n=r.type;e.queue[n].push(r.data)})}},{key:"needCleanupSourceBuffer",value:function(e){var t=this.video.currentTime,r=this.video.buffered;return r.length>=1&&t-r.start(0)>=this.config.autoCleanupMaxBackwardDuration}},{key:"doCleanupSourceBuffer",value:function(e){l["default"].verbose(this.tag,"docleanBuffer");for(var t=this.video.currentTime,r=this.sourceBuffer[e],n=r.buffered,i=!1,o=0;o<n.length;o++){var a=n.start(o),s=n.end(o);if(a<=t&&t<s+3&&t-a>=this.config.autoCleanupMaxBackwardDuration){i=!0;var u=t-this.config.autoCleanupMinBackwardDuration;this.removeRangesList[e].push({start:a,end:u})}}i&&!this.sourceBuffer[e].updating&&this.cleanRangesList(e)}},{key:"cleanRangesList",value:function(e){if(!this.sourceBuffer[e].updating)for(var t=this.sourceBuffer[e];this.removeRangesList[e].length&&!t.updating;){var r=this.removeRangesList[e].shift();t.remove(r.start,r.end)}}},{key:"appendBuffer",value:function(t,r){if(this.sourceBuffer[r])try{this.sourceBuffer[r].appendBuffer(t.buffer)}catch(e){this.queue[r].unshift(t),22===e.code?(l["default"].verbose(this.tag,"MediaSource bufferFull"),this.emit("bufferFull")):this.emit("error",{errno:f.ERRORNO.APPENDBUFFER_ERROR,errmsg:e})}}},{key:"onSourceEnded",value:function(){l["default"].verbose(this.tag,"MediaSource onSourceEnded")}},{key:"onSourceClose",value:function(){l["default"].verbose(this.tag,"MediaSource onSourceClose"),this.mediaSource&&null!==this.e&&(this.mediaSource.removeEventListener("sourceopen",this.e.onSourceOpen),this.mediaSource.removeEventListener("sourceended",this.e.onSourceEnded),this.mediaSource.removeEventListener("sourceclose",this.e.onSourceClose))}},{key:"onSourceBufferError",value:function(e){this.emit("error",{errnono:f.ERRORNO.SOURCEBUFFER_ERROR,errmsg:e}),l["default"].error(this.tag,"SourceBuffer Error: "+e)}},{key:"seek",value:function(){for(var t in this.sourceBuffer){var r=this.sourceBuffer[t];if(r){if("open"===this.mediaSource.readyState)try{r.abort()}catch(e){this.emit("error",{errno:f.ERRORNO.SBABORT_ERROR,errmsg:e}),l["default"].error(this.tag,e.message)}this.queue[t]=[];for(var n=0;n<r.buffered.length;n++){var i=r.buffered.start(n),o=r.buffered.end(n);this.removeRangesList[t].push({start:i,end:o})}r.updating||this.cleanRangesList(t)}}}},{key:"resume",value:function(){this.doUpdate()}},{key:"pause",value:function(){}},{key:"endOfStream",value:function(){if(this.mediaSource){var e=this.mediaSource;this.complete=!0;var t=this.sourceBuffer;if(t.video&&t.video.updating||t.audio&&t.audio.updating)return;if("open"===e.readyState)try{e.endOfStream(),this.complete=!1}catch(r){l["default"].verbose(this.tag,r),this.emit("error",{errno:f.ERRORNO.ENDOFSTREAM_ERROR,errmsg:r})}}}},{key:"destroy",value:function(){if(this.mediaSource){var e=this.mediaSource;this.queue={video:[],audio:[]},this.sourceBuffer={video:null,audio:null},this.mimeCodec={video:null,audio:null};var t=this.sourceBuffer;this.complete=!1,this.endOfStream(),t&&("closed"!==e.readyState&&(e.removeSourceBuffer(t),t.removeEventListener("error",this.e.onSourceBufferError),t.removeEventListener("updateend",this.e.onSourceBufferUpdateEnd)),this.sourceBuffer=null),e.removeEventListener("sourceopen",this.e.onSourceOpen),e.removeEventListener("sourceended",this.e.onSourceEnded),e.removeEventListener("sourceclose",this.e.onSourceClose),this.mediaSource=null}}}]),r}(u.CustEvent);r["default"]=d},function(e,t,r){function n(e){return e&&e.__esModule?e:{"default":e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(3),c=n(u),l=r(0),f=r(15),d=n(f),h=r(5),p=n(h),y=r(1),g=function(e){function t(e,r,n){i(this,t);var a=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return a.config=r||{},a.tag="transmuxer",a.loader=null,a.CPU=null,a.keyframePoint=!1,a.w=null,a.config.webWorker&&(a.w=(0,d["default"])(16),a.w.addEventListener("message",function(e){a.parseCallback.call(a,e.data)}),a.w.postMessage({cmd:"init",data:r})),a.lock=0,a}return a(t,e),s(t,[{key:"loadSource",value:function(){this.config.webWorker?this.w.postMessage({cmd:"loadSource"}):(this.loader=new c["default"](this.config),this.loader.arrivalDataCallback=this.arrivalDataCallback.bind(this),this.loader.open(),this.loaderBindEvent(this.loader))}},{key:"loaderBindEvent",value:function(e){var t=this;e.on("end",function(){t.emit("end")}),e.on("error",function(e){t.emit("error",e.data)}),e.on("heartbeat",function(e){t.emit("heartbeat",e.data)})}},{key:"arrivalDataCallback",value:function(e,t,r){var n=this;return this.CPU||(this.CPU=new p["default"],this.CPU.onInitSegment=this.onRemuxerInitSegmentArrival.bind(this),this.CPU.onMediaSegment=this.onRemuxerMediaSegmentArrival.bind(this),this.CPU.onMediaInfo=this.onMediaInfo.bind(this),this.CPU.on("error",function(e){n.emit("error",{errno:y.ERRORNO.CODEC_ERROR,errmsg:e.data})})),r!==undefined&&this.CPU.seek(r),this.CPU.setflv(e)}},{key:"parseCallback",value:function(e){switch(e.cmd){case"mediaSegmentInit":this.emit("mediaSegmentInit",e.source);break;case"mediaSegment":this.emit("mediaSegment",e.source);break;case"mediainfo":this.mediaInfo=e.source,this.emit("mediaInfo",e.source);break;case"error":this.emit("error",e.source)}}},{key:"onMediaInfo",value:function(e){this.mediaInfo=e,this.emit("mediaInfo",e)}},{key:"onRemuxerInitSegmentArrival",value:function(e,t){
this.emit("mediaSegmentInit",{type:"video",data:e}),t&&this.emit("mediaSegmentInit",{type:"audio",data:t})}},{key:"onRemuxerMediaSegmentArrival",value:function(e,t){this.emit("mediaSegment",{type:e,data:t})}},{key:"getMediaInfo",value:function(){return this.mediaInfo}},{key:"pause",value:function(){this.config.webWorker?this.w.postMessage({cmd:"pause"}):this.loader.pause()}},{key:"resume",value:function(){this.config.webWorker?this.w.postMessage({cmd:"resume"}):this.loader.resume()}},{key:"isSeekable",value:function(){return this.mediaInfo.hasKeyframesIndex}},{key:"seek",value:function(e){if(!this.isSeekable())return this.emit("error",{errno:y.ERRORNO.CANNOT_SEEK,errmsg:"\u8fd9\u4e2aflv\u89c6\u9891\u4e0d\u652f\u6301seek"}),!1;this.config.webWorker?this.w.postMessage({cmd:"seek",keyframe:e}):this.loader.seek(e.keyframePoint,!1,e.keyframetime)}},{key:"destroy",value:function(){this.config.webWorker?this.w.postMessage({cmd:"destroy"}):(this.loader.destroy(),this.loader=null,this.CPU=null)}},{key:"getNearestKeyframe",value:function(e){if(this.mediaInfo&&this.mediaInfo.keyframesIndex){var t=this.mediaInfo.keyframesIndex.times,r=this.mediaInfo.keyframesIndex.filepositions;return function n(e,i){var o=e.length,a=Math.floor(o/2);if(1===o){var s=t.indexOf(e[0]);return{keyframetime:e[0],keyframePoint:r[s]}}if(e[a]>i)return n(e.slice(0,a),i);if(e[a]<i)return n(e.slice(a),i);var u=t.indexOf(e[0]);return{keyframetime:e[0],keyframePoint:r[u]}}(t,e)}return 0}}]),t}(l.CustEvent);t["default"]=g},function(e,t,r){function n(e){return e&&e.__esModule?e:{"default":e}}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(11),c=n(u),l=r(0),f=r(2),d=n(f),h=r(1),p=function(e){function t(e,r){i(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.tag="fetch",n.fetching=!1,n.config=r,n.range={from:0,to:524288},n.src=e,n.totalRange=null,n.block=524288,n.reader=null,n.requestAbort=!1,n.arrivalDataCallback=null,n.bytesStart=0,n.heartbeat=null,n}return a(t,e),s(t,null,[{key:"isSupport",value:function(){return!(!self.fetch||!self.ReadableStream)}}]),s(t,[{key:"open",value:function(e,t){var r=this;this.requestAbort=!1;var n=new Headers,i=e||{from:0,to:-1};if(!this.config.isLive){this.range.from=i.from,this.range.to=i.to;var o=(0,c["default"])(i,this.config);if("string"==typeof o)this.src=this.config.src+o;else for(var a in o)n.append(a,o[a])}t&&(this.bytesStart=0),this.bytesStart=e.from;var s={method:"GET",headers:n,mode:"cors",cache:"default",referrerPolicy:"no-referrer-when-downgrade"};fetch(this.src,s).then(function(e){if(e.ok){var n=e.body.getReader();return r.pump(n,t)}})["catch"](function(e){r.emit("error",{errno:h.ERRORNO.NET_ERROR,errmsg:e})})}},{key:"pause",value:function(){this.requestAbort=!0}},{key:"pump",value:function(e,t){var r=this;return e.read().then(function(n){if(!n.done){if(!0===r.requestAbort)return r.requestAbort=!1,e.cancel();var i=n.value.buffer;return r.arrivalDataCallback&&(r.arrivalDataCallback(i,r.bytesStart,t),r.bytesStart+=i.byteLength),r.pump(e)}r.emit("end"),d["default"].verbose(r.tag,"load end")})["catch"](function(e){r.emit("error",{errno:h.ERRORNO.NET_ERROR,errmsg:e.message})})}}]),t}(l.CustEvent);t["default"]=p},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e,t){if("range"===t.seekType){var r={},n=void 0;return n=-1!==e.to?"bytes="+e.from.toString()+"-"+e.to.toString():"bytes="+e.from.toString()+"-",r.Range=n,r}return-1!==e.to?"?start="+e.from.toString()+"&end="+e.to.toString():"?start="+e.from.toString()}},function(e,t,r){function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),s=r(4),u=function(e){return e&&e.__esModule?e:{"default":e}}(s),c=r(0),l=r(1),f=function(e){function t(e,r){n(this,t);var o=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return o.tag="RangeLoader",o.xhr=null,o.src=e,o.totalLength=null,o.chunkSizeKB=524288,o.range={},o.bytesStart=0,o.needSeek=!1,o.keyframePoint=null,o}return o(t,e),a(t,null,[{key:"isSupport",value:function(){try{var e=new XMLHttpRequest;return e.open("GET","https://example.com",!0),e.responseType="arraybuffer","arraybuffer"===e.responseType}catch(e){return!1}}}]),a(t,[{key:"open",value:function(e,t){var r=this.xhr=new XMLHttpRequest;r.open("GET",this.src,!0),r.responseType="arraybuffer",r.onreadystatechange=this.onReadyStateChange.bind(this),r.onprogress=this.onProgress.bind(this),r.onload=this.onLoad.bind(this),r.onerror=this.onXhrError.bind(this);var n=e||{from:0,to:-1};this.range.from=n.from,-1===n.to&&(n.to=n.from+this.chunkSizeKB),t&&(this.bytesStart=e.from,this.needSeek=!0,this.keyframePoint=t),this.range.to=n.to;var i=(0,u["default"])(n).headers;for(var o in i)r.setRequestHeader(o,i[o]);r.send()}},{key:"pause",value:function(){this.abort()}},{key:"abort",value:function(){this.xhr&&(this.xhr.onreadystatechange=null,this.xhr.onprogress=null,this.xhr.onload=null,this.xhr.onerror=null,this.xhr.abort(),this.xhr=null)}},{key:"destroy",value:function(){this.xhr&&(this.abort(),this.xhr.onreadystatechange=null,this.xhr.onprogress=null,this.xhr.onload=null,this.xhr.onerror=null,this.xhr=null),this.totalLength=null,this.bytesStart=null,this.range={}}},{key:"onReadyStateChange",value:function(e){var t=this.xhr;if(2===t.readyState&&t.status<200&&t.status>299){var r={from:this.range.from,to:this.range.to,url:this.src,msg:"http Error: http code "+t.status};this.emit("error",{errno:l.ERRORNO.NET_ERROR,errmsg:r})}}},{key:"onProgress",value:function(e){this.totalLength||(this.totalLength=e.total,this.abort(),this.open())}},{key:"onLoad",value:function(e){if(this.totalLength&&this.arrivalDataCallback){var t=e.target.response;this.needSeek?(this.needSeek=!1,this.arrivalDataCallback(t,this.bytesStart,this.keyframePoint)):this.arrivalDataCallback(t,this.bytesStart),this.bytesStart+=t.byteLength,this.open({from:this.bytesStart,to:-1})}}},{key:"onXhrError",value:function(e){var t={from:this.range.from,to:this.range.to,url:this.src,msg:e.constructor.name+" "+e.type};this.emit("error",{errno:l.ERRORNO.NET_ERROR,errmsg:t})}}]),t}(c.CustEvent);t["default"]=f},function(t,r,n){function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(r,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=n(0),c=n(1),l=function(t){function r(e,t){i(this,r);var n=o(this,(r.__proto__||Object.getPrototypeOf(r)).call(this));return n.tag="WebSocket",n.src=e,n._ws=null,n._requestAbort=!1,n._receivedLength=0,n}return a(r,t),s(r,null,[{key:"isSupported",value:function(){try{return"undefined"!=typeof window.WebSocket}catch(e){return!1}}}]),s(r,[{key:"destroy",value:function(){this._ws&&this.abort()}},{key:"open",value:function(t,r){try{var n=this._ws=new self.WebSocket(this.src);n.binaryType="arraybuffer",n.onopen=this.onWebSocketOpen.bind(this),n.onclose=this.onWebSocketClose.bind(this),n.onmessage=this.onWebSocketMessage.bind(this),n.onerror=this.onWebSocketError.bind(this)}catch(e){var i={code:e.code,msg:e.message};this.emit("error",{errno:c.ERRORNO.NET_ERROR,errmsg:i})}}},{key:"abort",value:function(){var e=this._ws;!e||0!==e.readyState&&1!==e.readyState||(this._requestAbort=!0,e.close()),this._ws=null}},{key:"onWebSocketClose",value:function(e){if(!0===this._requestAbort)return void(this._requestAbort=!1);this.emit("end")}},{key:"onWebSocketMessage",value:function(e){var t=this;if(e.data instanceof ArrayBuffer)this.dispatchArrayBuffer(e.data);else if(e.data instanceof Blob){var r=new FileReader;r.onload=function(){t.dispatchArrayBuffer(r.result)},r.readAsArrayBuffer(e.data)}else{var n={code:-1,msg:"Unsupported WebSocket message type: "+e.data.constructor.name};this.emit("error",{errno:c.ERRORNO.NET_ERROR,errmsg:n})}}},{key:"dispatchArrayBuffer",value:function(e){var t=e,r=this.receivedLength;this.receivedLength+=t.byteLength,this.arrivalDataCallback&&this.arrivalDataCallback(t,r,this.receivedLength)}},{key:"onWebSocketError",value:function(e){var t={code:e.code,msg:e.message};this.emit("error",{errno:c.ERRORNO.NET_ERROR,errmsg:t})}}]),r}(u.CustEvent);r["default"]=l},function(e,t,r){function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),s=r(4),u=function(e){return e&&e.__esModule?e:{"default":e}}(s),c=r(0),l=r(1),f=function(e){function t(e,r){n(this,t);var o=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return o.tag="mozChunkLoader",o.xhr=null,o.src=e,o.config=r,o.totalLength=null,o.chunkSizeKB=393216,o.range={},o.bytesStart=0,o.keyframePoint=null,o}return o(t,e),a(t,null,[{key:"isSupport",value:function(){try{var e=new XMLHttpRequest;return e.open("GET","https://example.com",!0),e.responseType="moz-chunked-arraybuffer","moz-chunked-arraybuffer"===e.responseType}catch(e){return!1}}}]),a(t,[{key:"open",value:function(e,t){var r=this.xhr=new XMLHttpRequest;if(r.open("GET",this.src,!0),r.responseType="moz-chunked-arraybuffer",r.onreadystatechange=this.onReadyStateChange.bind(this),r.onprogress=this.onProgress.bind(this),r.onload=this.onLoadEnd.bind(this),r.onerror=this.onXhrError.bind(this),!this.config.isLive){var n=e||{from:0,to:-1};this.range.from=n.from,this.range.to=n.to,t&&(this.needSeek=!0,this.keyframePoint=t);var i=(0,u["default"])(n).headers;for(var o in i)r.setRequestHeader(o,i[o])}r.send()}},{key:"pause",value:function(){this.abort()}},{key:"abort",value:function(){this.xhr&&(this.xhr.onreadystatechange=null,this.xhr.onprogress=null,this.xhr.onload=null,this.xhr.onerror=null,this.xhr.abort(),this.xhr=null)}},{key:"destroy",value:function(){this.xhr&&(this.abort(),this.xhr.onreadystatechange=null,this.xhr.onprogress=null,this.xhr.onload=null,this.xhr.onerror=null,this.xhr=null),this.totalLength=null,this.bytesStart=null,this.range={}}},{key:"onReadyStateChange",value:function(e){var t=this.xhr;if(2===t.readyState&&t.status<200&&t.status>299){var r={from:this.range.from,to:this.range.to,url:this.src,msg:"http Error: http code "+t.status};this.emit("error",{errno:l.ERRORNO.NET_ERROR,errmsg:r})}}},{key:"onProgress",value:function(e){this.totalLength||(this.totalLength=e.total,null!==e.total&&0!==e.total&&(this.totalLength=e.total));var t=e.target.response;this.needSeek?(this.needSeek=!1,this.arrivalDataCallback(t,this.bytesStart,this.keyframePoint)):this.arrivalDataCallback(t,this.bytesStart),this.bytesStart+=t.byteLength}},{key:"onLoadEnd",value:function(e){this.emit(this.tag,"video load end")}},{key:"onXhrError",value:function(e){var t={from:this.range.from,to:this.range.to,url:this.src,msg:e.constructor.name+" "+e.type};this.emit("error",{errno:l.ERRORNO.NET_ERROR,errmsg:t})}}]),t}(c.CustEvent);t["default"]=f},function(e,t,r){function n(e){function t(n){if(r[n])return r[n].exports;var i=r[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var r={};t.m=e,t.c=r,t.i=function(e){return e},t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e["default"]}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t.oe=function(e){throw console.error(e),e};var n=t(t.s=ENTRY_MODULE);return n["default"]||n}function i(e){return(e+"").replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}function o(e,t,n){var o={};o[n]=[];var a=t.toString(),s=a.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);if(!s)return o;for(var l,f=s[1],d=new RegExp("(\\\\n|\\W)"+i(f)+c,"g");l=d.exec(a);)"dll-reference"!==l[3]&&o[n].push(l[3]);for(d=new RegExp("\\("+i(f)+'\\("(dll-reference\\s('+u+'))"\\)\\)'+c,"g");l=d.exec(a);)e[l[2]]||(o[n].push(l[1]),e[l[2]]=r(l[1]).m),o[l[2]]=o[l[2]]||[],o[l[2]].push(l[4]);return o}function a(e){return Object.keys(e).reduce(function(t,r){return t||e[r].length>0},!1)}function s(e,t){for(var r={main:[t]},n={main:[]},i={main:{}};a(r);)for(var s=Object.keys(r),u=0;u<s.length;u++){var c=s[u],l=r[c],f=l.pop();if(i[c]=i[c]||{},!i[c][f]&&e[c][f]){i[c][f]=!0,n[c]=n[c]||[],n[c].push(f);for(var d=o(e,e[c][f],c),h=Object.keys(d),p=0;p<h.length;p++)r[h[p]]=r[h[p]]||[],r[h[p]]=r[h[p]].concat(d[h[p]])}}return n}var u="[\\.|\\-|\\+|\\w|/|@]+",c="\\((/\\*.*?\\*/)?s?.*?("+u+").*?\\)";e.exports=function(e,t){t=t||{};var i={main:r.m},o=t.all?{main:Object.keys(i)}:s(i,e),a="";Object.keys(o).filter(function(e){return"main"!==e}).forEach(function(e){for(var t=0;o[e][t];)t++;o[e].push(t),i[e][t]="(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })",a=a+"var "+e+" = ("+n.toString().replace("ENTRY_MODULE",JSON.stringify(t))+")({"+o[e].map(function(t){return JSON.stringify(t)+": "+i[e][t].toString()}).join(",")+"});\n"}),a=a+"("+n.toString().replace("ENTRY_MODULE",JSON.stringify(e))+")({"+o.main.map(function(e){return JSON.stringify(e)+": "+i.main[e].toString()}).join(",")+"})(self);";var u=new window.Blob([a],{type:"text/javascript"});if(t.bare)return u;var c=window.URL||window.webkitURL||window.mozURL||window.msURL,l=c.createObjectURL(u),f=new window.Worker(l);return f.objectURL=l,f}},function(e,t,r){function n(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){function t(){f=new o["default"],f.onInitSegment=r,f.onMediaSegment=n,f.onError=i,f.onMediaInfo=a,f.on("error",function(e){self.postMessage({cmd:"error",source:e.data})})}function r(e,t){self.postMessage({cmd:"mediaSegmentInit",source:{type:"video",data:e}}),t&&self.postMessage({cmd:"mediaSegmentInit",source:{type:"audio",data:t}})}function n(e,t){self.postMessage({cmd:"mediaSegment",source:{type:e,data:t}})}function i(e){self.postMessage({cmd:"error",source:e})}function a(e){self.postMessage({cmd:"mediainfo",source:e})}function u(e){d.pause(),d=new s["default"](h),d.arrivalDataCallback=l,d.seek(e.keyframePoint,!1,e.keyframetime)}function c(){d.destroy(),d=null,f=null}function l(e,r,n){return f||t(),n&&f.seek(n),f.setflv(e)}var f=null,d=null,h={};e.addEventListener("message",function(e){switch(e.data.cmd){case"init":h=e.data.data;break;case"loadSource":d=new s["default"](h),d.arrivalDataCallback=l,d.open();break;case"pause":d.pause();break;case"seek":u(e.data.keyframe);break;case"resume":d.resume();break;case"destroy":c()}})};var i=r(5),o=n(i),a=r(3),s=n(a)},function(e,t,r){Object.defineProperty(t,"__esModule",{value:!0}),t["default"]={isLive:!1,box:"flv",seekInKeyframe:!0,alwaysSeekKeyframe:!0,lazyLoadMaxDuration:120,lazyLoadRecoverDuration:30,lockInternalProperty:!1,debug:!0,webWorker:!1,autoCleanupSourceBuffer:!0,autoCleanupMaxBackwardDuration:30,autoCleanupMinBackwardDuration:30,stashSize:393216,seekType:"range"}},function(t,r,n){(function(t){!function(t,n){!function(r){function n(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e["default"]:e}function i(e,t){return t={exports:{}},e(t,t.exports),t.exports}function o(e){return void 0!==e}function a(e){return e===undefined||null===e}function s(e){return Array.isArray(e)}function u(e){return"function"==typeof e}function c(e){return Object(e)===e&&"[object Object]"===String(e)&&!u(e)&&!s(e)}function l(e){return"number"==typeof e}function f(e){return!s(e)&&e-Yn(e)+1>=0}function d(e){return Dn(e)}function h(e){return s(e)?0===e.length:c(e)?0===On(e).length:!e}function p(e){return e instanceof Event||(e&&e.originalEvent)instanceof Event}function y(e){return e instanceof Blob}function g(e){return y(e)&&_(e.name)}function m(e){return"[object Date]"===Object.prototype.toString.call(e)}function _(e){return"string"==typeof e||e instanceof String}function v(e){return"boolean"==typeof e}function b(e){return!!e&&("object"===(void 0===e?"undefined":wn(e))||"function"==typeof e)&&"function"==typeof e.then}function $(e){return a(e)||v(e)||_(e)||l(e)}function w(e){return _(e)&&!!e.match(/^((https?|ftp|rtsp|mms):\/\/)(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?(([0-9]{1,3}\.){3}[0-9]{1,3}|([0-9a-z_!~*'()-]+\.)*([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.[a-z]{2,6}|localhost)(:[0-9]{1,4})?((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+\/?)$/i)}function E(e){return!!("object"===("undefined"==typeof Node?"undefined":wn(Node))?e instanceof Node:e&&"object"===(void 0===e?"undefined":wn(e))&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName)}function S(e){return!!("object"===("undefined"==typeof HTMLElement?"undefined":wn(HTMLElement))?e instanceof HTMLElement:e&&"object"===(void 0===e?"undefined":wn(e))&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName)}function O(e,t){return!(!E(e)||!E(t))&&t.parentNode===e}function T(e,t){if(!E(e)||!E(t))return!1;for(;t.parentNode;)if((t=t.parentNode)===e)return!0;return!1}function A(e){return/<[^>]+?>/.test(e)}function x(e){return e instanceof Error}function k(e){return e instanceof RegExp}function D(e){function t(r,n,i){if(s(r)||c(r)){n=$(n)?c(r)?{}:[]:n;for(var o in r)n[o]=t(r[o],n[o],o);return n}return e(r,n,i)}return t}function I(e){if($(e))throw new TypeError("deepClone only accept non primitive type");return Kn(e)}function P(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];if(t.length<2)throw new Error("deepAssign accept two and more argument");for(var n=t.length-1;n>-1;n--)if($(t[n]))throw new TypeError("deepAssign only accept non primitive type");var i=t.shift();return t.forEach(function(e){return Kn(e,i)}),i}function M(e,t){return e.replace(/(^|[^a-zA-Z]+)([a-zA-Z])/g,function(e,r,n,i){return t||0!==i?n.toUpperCase():n.toLowerCase()})}function R(e){return M(e).replace(/([A-Z])/g,function(e){return"-"+e.toLowerCase()})}function C(e,t){return e.bind?e.bind(t):e.apply?function(){for(var r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];return e.apply(t,n)}:function(){for(var r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];return e.call.apply(e,[t].concat(ur(n)))}}function j(){return L()+L()+"-"+L()+"-"+L()+"-"+L()+"-"+L()+L()+L()}function L(){return(65536*(1+Math.random())|0).toString(16).substring(1)}function N(e){for(var t="";t.length<e;)t+=L();return t.slice(0,e)}function F(e,t){var r=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{},n=r.throwError,i=n!==undefined&&n,o=r.backup;if(_(t)&&(t=t.split(".")),!s(t))throw new TypeError("keys of getDeepProperty must be string or Array<string>");for(var u=[],c=e,l=0,f=t.length;l<f;l++){var d=t[l];if(a(c)){if(i)throw new Error("obj"+(u.length>0?"."+u.join("."):" itself")+" is "+c);return o}c=c[d],u.push(d)}return c}function B(e){var t,r;this.promise=new e(function(e,n){if(t!==undefined||r!==undefined)throw TypeError("Bad Promise constructor");t=e,r=n}),this.resolve=Me(t),this.reject=Me(r)}function U(e){return ar(e)}function z(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(e,t){return+e-+t};return On(e).sort(t).reduce(function(t,r){return t.concat(e[r])},[])}function G(e){for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];return new zi(function(t,n){!function i(o){if(o>=e.length)return void t();var a=u(e[o])?e[o].apply(e,ur(r)):e[o];return!1===a?n("stop"):zi.resolve(a).then(function(){return i(o+1)})["catch"](function(e){return n(e||"stop")})}(0)})}function W(e){for(var t=arguments.length,r=Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];return function i(t){return t>=e.length||!1!==(u(e[t])?e[t].apply(e,ur(r)):e[t])&&i(++t)}(0)}function H(e,t,r){var n=e;if(t+r<n.length){for(;r--;)if(128!=(192&n[++t]))return!1;return!0}return!1}function V(e){for(var t=[],r=e,n=0,i=e.length;n<i;)if(r[n]<128)t.push(String.fromCharCode(r[n])),++n;else{if(r[n]<192);else if(r[n]<224){if(H(r,n,1)){var o=(31&r[n])<<6|63&r[n+1];if(o>=128){t.push(String.fromCharCode(65535&o)),n+=2;continue}}}else if(r[n]<240){if(H(r,n,2)){var a=(15&r[n])<<12|(63&r[n+1])<<6|63&r[n+2];if(a>=2048&&55296!=(63488&a)){t.push(String.fromCharCode(65535&a)),n+=3;continue}}}else if(r[n]<248&&H(r,n,3)){var s=(7&r[n])<<18|(63&r[n+1])<<12|(63&r[n+2])<<6|63&r[n+3];if(s>65536&&s<1114112){s-=65536,t.push(String.fromCharCode(s>>>10|55296)),t.push(String.fromCharCode(1023&s|56320)),n+=4;continue}}t.push(String.fromCharCode(65533)),++n}return t.join("")}function Y(e,t,r){var n=void 0,i=void 0,o=void 0,a=void 0,s=void 0,u=function c(){var u=new Date-a;u<t&&u>=0?n=setTimeout(c,t-u):(n=null,r||(s=e.apply(o,i),n||(o=i=null)))};return function(){o=this,i=arguments,a=new Date;var c=r&&!n;return n||(n=setTimeout(u,t)),c&&(s=e.apply(o,i),o=i=null),s}}function K(e,t,r,n){var i=void 0,o=void 0,a=void 0,s=null,u=0;r||(r={});var c=function(){u=!1===r.leading?0:new Date-0,s=null,a=e.apply(i,o),s||(i=o=null)};return t=t||0,function(){var l=new Date;u||!1!==r.leading||(u=l);var f=t-(l-u);return i=n||this,o=arguments,f<=0||f>t?(s&&(clearTimeout(s),s=null),u=l,a=e.apply(i,o),s||(i=o=null)):s||!1===r.trailing||(s=setTimeout(c,f)),a}}function Z(e,t){var r=t;e=""+(e||"");var n=e.length;return t=(t||n)-n,((t>0?e.repeat?"0".repeat(t):new Array(t+1).join("0"):"")+e).slice(0,r)}function J(e){var t=Math.floor(e/3600);e=Math.floor(e%3600);var r=Z(Math.floor(e/60),2);e=Math.floor(e%60);var n=Z(e,2);return t>=1?t+":"+r+":"+n:r+":"+n}function Q(e){var t=document,r=t.querySelector("style");if(!r){r=t.createElement("style");var n=t.querySelector("head");n&&n.appendChild(r)}return r.appendChild(t.createTextNode(e)),r}function X(){var e=arguments.length>0&&arguments[0]!==undefined?arguments[0]:new Date,t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"yyyy-MM-dd hh:mm:ss.i",r=e.getFullYear().toString(),n={M:e.getMonth()+1,d:e.getDate(),h:e.getHours(),m:e.getMinutes(),s:e.getSeconds(),i:e.getMilliseconds()};t=t.replace(/(y+)/gi,function(e,t){return r.substr(4-Math.min(4,t.length))});for(var i in n)!function(e){t=t.replace(new RegExp("("+e+"+)","g"),function(t,r){return(n[e]<10&&r.length>1?"0":"")+n[e]})}(i);return t}function q(e){try{return window.localStorage.getItem(e)}catch(e){try{var t=document.cookie.match(new RegExp("(^| )"+e+"=([^;]*)(;|$)"));return s(t)?unescape(t[2]):""}catch(e){return""}}}function ee(e,t){try{window.localStorage.setItem(e,t)}catch(e){var r=new Date;r.setTime(r.getTime()+2592e7);try{document.cookie=e+"="+escape(t)+";expires="+r.toUTCString()+";path=/;"}catch(e){}}}function te(e,t){var r=e.__evt_id;r||(Object.defineProperty(e,"__evt_id",{writable:!0,enumerable:!1,configurable:!0}),r=e.__evt_id=++uo.count);var n=r+"_"+t,i=uo[n];return i||(i=uo[n]=[]),i}function re(e,t,r){var n=so(null);n.type=t,n.target=e,r&&no(n,c(r)?r:{data:r}),te(e,t).forEach(function(t){(t[1]||t[0]).apply(e,[n])})}function ne(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=arguments[4];u(n)&&!i&&(i=n,n=undefined);var o=[r,undefined,n];n&&!i&&(i=function(){ie(e,t,r,n);for(var i=arguments.length,o=Array(i),a=0;a<i;a++)o[a]=arguments[a];r.apply(e,o)}),i&&(o[1]=i),te(e,t).push(o)}function ie(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=te(e,t);if(r||n){var o=-1,a=void 0;return i.find(function(e,t){if((!r||e[0]===r)&&(!n||e[2]))return o=t,a=e[1],!0}),-1!==o&&i.splice(o,1),a}i.length=0}function oe(e,t){var r=e.__evt_id;r||(Object.defineProperty(e,"__evt_id",{writable:!0,enumerable:!1,configurable:!0}),r=e.__evt_id=++lo.count);var n=r+"_"+t,i=lo[n];return i||(i=lo[n]=[]),i}function ae(e,t,r){var n=so(null);n.type=t,n.target=e,r&&no(n,c(r)?r:{data:r}),oe(e,t).forEach(function(t){(t[1]||t[0]).apply(e,[n])})}function se(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=arguments[4];u(n)&&!i&&(i=n,n=undefined);var o=[r,undefined,n];n&&!i&&(i=function(){ue(e,t,r,n);for(var i=arguments.length,o=Array(i),a=0;a<i;a++)o[a]=arguments[a];r.apply(e,o)}),i&&(o[1]=i),oe(e,t).push(o)}function ue(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=oe(e,t);if(r||n){var o=-1,a=void 0;return i.find(function(e,t){if((!r||e[0]===r)&&(!n||e[2]))return o=t,a=e[1],!0}),-1!==o&&i.splice(o,1),a}i.length=0}function ce(e){return ar(e)}function le(e,t){return e.getAttribute(t)}function fe(e,t,r){r===undefined?e.removeAttribute(t):e.setAttribute(t,r)}function de(e,t){if(t&&(t=t.trim())){var r=t.split(/\s+/);if(e.classList)r.forEach(function(t){return e.classList.add(t)});else{var n=" "+(e.className||"")+" ";r.forEach(function(e){-1===n.indexOf(" "+e+" ")&&(n+=" "+e)}),e.className=n.trim()}}}function he(e,t){if(t&&(t=t.trim())){var r=t.split(/\s+/);if(e.classList)r.forEach(function(t){return e.classList.remove(t)});else{var n=" "+e.className+" ";r.forEach(function(e){for(var t=" "+e+" ";-1!==n.indexOf(t);)n=n.replace(t," ")}),e.className=n.trim()}}}function pe(e,t){return new RegExp("(?:^|\\s)"+t+"(?=\\s|$)").test(e.className)}function ye(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:go;if(n){var o=ue(e,t+"_once",r);o&&(r=o)}e.removeEventListener(t,r,i)}function ge(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined&&arguments[3],i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:go;if(n){var o=r;r=function(){return function(){for(var a=arguments.length,s=Array(a),u=0;u<a;u++)s[u]=arguments[u];o.apply(this,s),ye(e,t,r,n,i)}}(),se(e,t+"_once",o,r)}e.addEventListener(t,r,i)}function me(e,t,r,n){var i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:go,o=function(r){var i=Ee(r.target||r.srcElement,e,!0),o=$e(t,e,!0),a=void 0;o.find?a=o.find(function(e){return i.find(function(t){return e===t})}):o.forEach(function(e){return!a&&i.forEach(function(t){a||e!==t||(a=t)})}),a&&n.apply(a,arguments)};se(e,r+"_delegate_"+t,n,o),e.addEventListener(r,o,i)}function _e(e,t,r,n){var i=arguments.length>4&&arguments[4]!==undefined?arguments[4]:go,o=ue(e,r+"_delegate_"+t,n);o&&e.removeEventListener(r,o,i)}function ve(e,t){return(e.currentStyle||document.defaultView.getComputedStyle(e,null))[t]||e.style[t]}function be(e,t,r){if(c(t))for(var n in t)be(e,n,t[n]);else e.style[t]=r}function $e(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:document,r=arguments[2],n=t.querySelectorAll(e);return r?ar(n):n}function we(e){e.parentNode.removeChild(e)}function Ee(e){var t=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null,r=arguments[2],n=arguments[3],i=[];for(r&&i.push(e);e&&e.parentNode!==t;)(e=e.parentNode)&&i.push(e);return n&&i.push(t),i}function Se(e,t){return e.constructor===mo?e:new mo(e,t)}function Oe(e,t){if(!_(e))throw new TypeError("Log's method only acccept string as argument, but not "+e+" in "+(void 0===e?"undefined":wn(e)));return _(t)?"["+(e=_o.FORCE_GLOBAL_TAG?_o.GLOBAL_TAG:e||_o.GLOBAL_TAG)+"] > "+t:"["+_o.GLOBAL_TAG+"] > "+e}var Te="undefined"!=typeof window?window:void 0!==t?t:"undefined"!=typeof self?self:{},Ae=Math.ceil,xe=Math.floor,ke=function(e){return isNaN(e=+e)?0:(e>0?xe:Ae)(e)},De=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e},Ie=i(function(e){var t=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=t)}),Pe=i(function(e){var t=e.exports={version:"2.5.1"};"number"==typeof __e&&(__e=t)}),Me=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e},Re=function(e,t,r){if(Me(e),t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,i){return e.call(t,r,n,i)}}return function(){return e.apply(t,arguments)}},Ce=function(e){return"object"==typeof e?null!==e:"function"==typeof e},je=function(e){if(!Ce(e))throw TypeError(e+" is not an object!");return e},Le=function(e){try{return!!e()}catch(e){return!0}},Ne=!Le(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),Fe=Ie.document,Be=Ce(Fe)&&Ce(Fe.createElement),Ue=function(e){return Be?Fe.createElement(e):{}},ze=!Ne&&!Le(function(){return 7!=Object.defineProperty(Ue("div"),"a",{get:function(){return 7}}).a}),Ge=function(e,t){if(!Ce(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!Ce(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!Ce(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!Ce(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")},We=Object.defineProperty,He=Ne?Object.defineProperty:function(e,t,r){if(je(e),t=Ge(t,!0),je(r),ze)try{return We(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(e[t]=r.value),e},Ve={f:He},Ye=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},Ke=Ne?function(e,t,r){return Ve.f(e,t,Ye(1,r))}:function(e,t,r){return e[t]=r,e},Ze=function(e,t,r){var n,i,o,a=e&Ze.F,s=e&Ze.G,u=e&Ze.S,c=e&Ze.P,l=e&Ze.B,f=e&Ze.W,d=s?Pe:Pe[t]||(Pe[t]={}),h=d.prototype,p=s?Ie:u?Ie[t]:(Ie[t]||{}).prototype;s&&(r=t);for(n in r)(i=!a&&p&&p[n]!==undefined)&&n in d||(o=i?p[n]:r[n],d[n]=s&&"function"!=typeof p[n]?r[n]:l&&i?Re(o,Ie):f&&p[n]==o?function(e){
var t=function(t,r,n){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,n)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(o):c&&"function"==typeof o?Re(Function.call,o):o,c&&((d.virtual||(d.virtual={}))[n]=o,e&Ze.R&&h&&!h[n]&&Ke(h,n,o)))};Ze.F=1,Ze.G=2,Ze.S=4,Ze.P=8,Ze.B=16,Ze.W=32,Ze.U=64,Ze.R=128;var Je=Ze,Qe=Ke,Xe={}.hasOwnProperty,qe=function(e,t){return Xe.call(e,t)},et={},tt={}.toString,rt=function(e){return tt.call(e).slice(8,-1)},nt=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==rt(e)?e.split(""):Object(e)},it=function(e){return nt(De(e))},ot=Math.min,at=function(e){return e>0?ot(ke(e),9007199254740991):0},st=Math.max,ut=Math.min,ct=function(e,t){return e=ke(e),e<0?st(e+t,0):ut(e,t)},lt=Ie["__core-js_shared__"]||(Ie["__core-js_shared__"]={}),ft=function(e){return lt[e]||(lt[e]={})},dt=0,ht=Math.random(),pt=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++dt+ht).toString(36))},yt=ft("keys"),gt=function(e){return yt[e]||(yt[e]=pt(e))},mt=function(e){return function(t,r,n){var i,o=it(t),a=at(o.length),s=ct(n,a);if(e&&r!=r){for(;a>s;)if((i=o[s++])!=i)return!0}else for(;a>s;s++)if((e||s in o)&&o[s]===r)return e||s||0;return!e&&-1}}(!1),_t=gt("IE_PROTO"),vt=function(e,t){var r,n=it(e),i=0,o=[];for(r in n)r!=_t&&qe(n,r)&&o.push(r);for(;t.length>i;)qe(n,r=t[i++])&&(~mt(o,r)||o.push(r));return o},bt="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),$t=Object.keys||function(e){return vt(e,bt)},wt=Ne?Object.defineProperties:function(e,t){je(e);for(var r,n=$t(t),i=n.length,o=0;i>o;)Ve.f(e,r=n[o++],t[r]);return e},Et=Ie.document,St=Et&&Et.documentElement,Ot=gt("IE_PROTO"),Tt=function(){},At=function(){var e,t=Ue("iframe"),r=bt.length;for(t.style.display="none",St.appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),At=e.F;r--;)delete At.prototype[bt[r]];return At()},xt=Object.create||function(e,t){var r;return null!==e?(Tt.prototype=je(e),r=new Tt,Tt.prototype=null,r[Ot]=e):r=At(),t===undefined?r:wt(r,t)},kt=i(function(e){var t=ft("wks"),r=Ie.Symbol,n="function"==typeof r;(e.exports=function(e){return t[e]||(t[e]=n&&r[e]||(n?r:pt)("Symbol."+e))}).store=t}),Dt=Ve.f,It=kt("toStringTag"),Pt=function(e,t,r){e&&!qe(e=r?e:e.prototype,It)&&Dt(e,It,{configurable:!0,value:t})},Mt={};Ke(Mt,kt("iterator"),function(){return this});var Rt=function(e,t,r){e.prototype=xt(Mt,{next:Ye(1,r)}),Pt(e,t+" Iterator")},Ct=function(e){return Object(De(e))},jt=gt("IE_PROTO"),Lt=Object.prototype,Nt=Object.getPrototypeOf||function(e){return e=Ct(e),qe(e,jt)?e[jt]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?Lt:null},Ft=kt("iterator"),Bt=!([].keys&&"next"in[].keys()),Ut=function(){return this},zt=function(e,t,r,n,i,o,a){Rt(r,t,n);var s,u,c,l=function(e){if(!Bt&&e in p)return p[e];switch(e){case"keys":case"values":return function(){return new r(this,e)}}return function(){return new r(this,e)}},f=t+" Iterator",d="values"==i,h=!1,p=e.prototype,y=p[Ft]||p["@@iterator"]||i&&p[i],g=y||l(i),m=i?d?l("entries"):g:undefined,_="Array"==t?p.entries||y:y;if(_&&(c=Nt(_.call(new e)))!==Object.prototype&&c.next&&Pt(c,f,!0),d&&y&&"values"!==y.name&&(h=!0,g=function(){return y.call(this)}),a&&(Bt||h||!p[Ft])&&Ke(p,Ft,g),et[t]=g,et[f]=Ut,i)if(s={values:d?g:l("values"),keys:o?g:l("keys"),entries:m},a)for(u in s)u in p||Qe(p,u,s[u]);else Je(Je.P+Je.F*(Bt||h),t,s);return s},Gt=function(e){return function(t,r){var n,i,o=String(De(t)),a=ke(r),s=o.length;return a<0||a>=s?e?"":undefined:(n=o.charCodeAt(a),n<55296||n>56319||a+1===s||(i=o.charCodeAt(a+1))<56320||i>57343?e?o.charAt(a):n:e?o.slice(a,a+2):i-56320+(n-55296<<10)+65536)}}(!0);zt(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:undefined,done:!0}:(e=Gt(t,r),this._i+=e.length,{value:e,done:!1})});var Wt=function(t,r,n,i){try{return i?r(je(n)[0],n[1]):r(n)}catch(e){var o=t["return"];throw o!==undefined&&je(o.call(t)),e}},Ht=kt("iterator"),Vt=Array.prototype,Yt=function(e){return e!==undefined&&(et.Array===e||Vt[Ht]===e)},Kt=function(e,t,r){t in e?Ve.f(e,t,Ye(0,r)):e[t]=r},Zt=kt("toStringTag"),Jt="Arguments"==rt(function(){return arguments}()),Qt=function(e,t){try{return e[t]}catch(e){}},Xt=function(e){var t,r,n;return e===undefined?"Undefined":null===e?"Null":"string"==typeof(r=Qt(t=Object(e),Zt))?r:Jt?rt(t):"Object"==(n=rt(t))&&"function"==typeof t.callee?"Arguments":n},qt=kt("iterator"),er=Pe.getIteratorMethod=function(e){if(e!=undefined)return e[qt]||e["@@iterator"]||et[Xt(e)]},tr=kt("iterator"),rr=!1;try{[7][tr]()["return"]=function(){rr=!0}}catch(e){}var nr=function(e,t){if(!t&&!rr)return!1;var r=!1;try{var n=[7],i=n[tr]();i.next=function(){return{done:r=!0}},n[tr]=function(){return i},e(n)}catch(e){}return r};Je(Je.S+Je.F*!nr(function(e){}),"Array",{from:function(e){var t,r,n,i,o=Ct(e),a="function"==typeof this?this:Array,s=arguments.length,u=s>1?arguments[1]:undefined,c=u!==undefined,l=0,f=er(o);if(c&&(u=Re(u,s>2?arguments[2]:undefined,2)),f==undefined||a==Array&&Yt(f))for(t=at(o.length),r=new a(t);t>l;l++)Kt(r,l,c?u(o[l],l):o[l]);else for(i=f.call(o),r=new a;!(n=i.next()).done;l++)Kt(r,l,c?Wt(i,u,[n.value,l],!0):n.value);return r.length=l,r}});var ir=Pe.Array.from,or=i(function(e){e.exports={"default":ir,__esModule:!0}}),ar=n(or),sr=i(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(or);t["default"]=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return(0,r["default"])(e)}}),ur=n(sr),cr=function(e,t){return{value:t,done:!!e}};zt(Array,"Array",function(e,t){this._t=it(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,r=this._i++;return!e||r>=e.length?(this._t=undefined,cr(1)):"keys"==t?cr(0,r):"values"==t?cr(0,e[r]):cr(0,[r,e[r]])},"values");et.Arguments=et.Array;for(var lr=kt("toStringTag"),fr="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),dr=0;dr<fr.length;dr++){var hr=fr[dr],pr=Ie[hr],yr=pr&&pr.prototype;yr&&!yr[lr]&&Ke(yr,lr,hr),et[hr]=et.Array}var gr=kt,mr={f:gr},_r=mr.f("iterator"),vr=i(function(e){e.exports={"default":_r,__esModule:!0}});n(vr);var br=i(function(e){var t=pt("meta"),r=Ve.f,n=0,i=Object.isExtensible||function(){return!0},o=!Le(function(){return i(Object.preventExtensions({}))}),a=function(e){r(e,t,{value:{i:"O"+ ++n,w:{}}})},s=function(e,r){if(!Ce(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!qe(e,t)){if(!i(e))return"F";if(!r)return"E";a(e)}return e[t].i},u=function(e,r){if(!qe(e,t)){if(!i(e))return!0;if(!r)return!1;a(e)}return e[t].w},c=function(e){return o&&l.NEED&&i(e)&&!qe(e,t)&&a(e),e},l=e.exports={KEY:t,NEED:!1,fastKey:s,getWeak:u,onFreeze:c}}),$r=Ve.f,wr=function(e){var t=Pe.Symbol||(Pe.Symbol={});"_"==e.charAt(0)||e in t||$r(t,e,{value:mr.f(e)})},Er=Object.getOwnPropertySymbols,Sr={f:Er},Or={}.propertyIsEnumerable,Tr={f:Or},Ar=function(e){var t=$t(e),r=Sr.f;if(r)for(var n,i=r(e),o=Tr.f,a=0;i.length>a;)o.call(e,n=i[a++])&&t.push(n);return t},xr=Array.isArray||function(e){return"Array"==rt(e)},kr=bt.concat("length","prototype"),Dr=Object.getOwnPropertyNames||function(e){return vt(e,kr)},Ir={f:Dr},Pr=Ir.f,Mr={}.toString,Rr="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],Cr=function(e){try{return Pr(e)}catch(e){return Rr.slice()}},jr=function(e){return Rr&&"[object Window]"==Mr.call(e)?Cr(e):Pr(it(e))},Lr={f:jr},Nr=Object.getOwnPropertyDescriptor,Fr=Ne?Nr:function(e,t){if(e=it(e),t=Ge(t,!0),ze)try{return Nr(e,t)}catch(e){}if(qe(e,t))return Ye(!Tr.f.call(e,t),e[t])},Br={f:Fr},Ur=br.KEY,zr=Br.f,Gr=Ve.f,Wr=Lr.f,Hr=Ie.Symbol,Vr=Ie.JSON,Yr=Vr&&Vr.stringify,Kr=kt("_hidden"),Zr=kt("toPrimitive"),Jr={}.propertyIsEnumerable,Qr=ft("symbol-registry"),Xr=ft("symbols"),qr=ft("op-symbols"),en=Object.prototype,tn="function"==typeof Hr,rn=Ie.QObject,nn=!rn||!rn.prototype||!rn.prototype.findChild,on=Ne&&Le(function(){return 7!=xt(Gr({},"a",{get:function(){return Gr(this,"a",{value:7}).a}})).a})?function(e,t,r){var n=zr(en,t);n&&delete en[t],Gr(e,t,r),n&&e!==en&&Gr(en,t,n)}:Gr,an=function(e){var t=Xr[e]=xt(Hr.prototype);return t._k=e,t},sn=tn&&"symbol"==typeof Hr.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof Hr},un=function(e,t,r){return e===en&&un(qr,t,r),je(e),t=Ge(t,!0),je(r),qe(Xr,t)?(r.enumerable?(qe(e,Kr)&&e[Kr][t]&&(e[Kr][t]=!1),r=xt(r,{enumerable:Ye(0,!1)})):(qe(e,Kr)||Gr(e,Kr,Ye(1,{})),e[Kr][t]=!0),on(e,t,r)):Gr(e,t,r)},cn=function(e,t){je(e);for(var r,n=Ar(t=it(t)),i=0,o=n.length;o>i;)un(e,r=n[i++],t[r]);return e},ln=function(e,t){return t===undefined?xt(e):cn(xt(e),t)},fn=function(e){var t=Jr.call(this,e=Ge(e,!0));return!(this===en&&qe(Xr,e)&&!qe(qr,e))&&(!(t||!qe(this,e)||!qe(Xr,e)||qe(this,Kr)&&this[Kr][e])||t)},dn=function(e,t){if(e=it(e),t=Ge(t,!0),e!==en||!qe(Xr,t)||qe(qr,t)){var r=zr(e,t);return!r||!qe(Xr,t)||qe(e,Kr)&&e[Kr][t]||(r.enumerable=!0),r}},hn=function(e){for(var t,r=Wr(it(e)),n=[],i=0;r.length>i;)qe(Xr,t=r[i++])||t==Kr||t==Ur||n.push(t);return n},pn=function(e){for(var t,r=e===en,n=Wr(r?qr:it(e)),i=[],o=0;n.length>o;)!qe(Xr,t=n[o++])||r&&!qe(en,t)||i.push(Xr[t]);return i};tn||(Hr=function(){if(this instanceof Hr)throw TypeError("Symbol is not a constructor!");var e=pt(arguments.length>0?arguments[0]:undefined),t=function(r){this===en&&t.call(qr,r),qe(this,Kr)&&qe(this[Kr],e)&&(this[Kr][e]=!1),on(this,e,Ye(1,r))};return Ne&&nn&&on(en,e,{configurable:!0,set:t}),an(e)},Qe(Hr.prototype,"toString",function(){return this._k}),Br.f=dn,Ve.f=un,Ir.f=Lr.f=hn,Tr.f=fn,Sr.f=pn,mr.f=function(e){return an(kt(e))}),Je(Je.G+Je.W+Je.F*!tn,{Symbol:Hr});for(var yn="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),gn=0;yn.length>gn;)kt(yn[gn++]);for(var mn=$t(kt.store),_n=0;mn.length>_n;)wr(mn[_n++]);Je(Je.S+Je.F*!tn,"Symbol",{"for":function(e){return qe(Qr,e+="")?Qr[e]:Qr[e]=Hr(e)},keyFor:function(e){if(!sn(e))throw TypeError(e+" is not a symbol!");for(var t in Qr)if(Qr[t]===e)return t},useSetter:function(){nn=!0},useSimple:function(){nn=!1}}),Je(Je.S+Je.F*!tn,"Object",{create:ln,defineProperty:un,defineProperties:cn,getOwnPropertyDescriptor:dn,getOwnPropertyNames:hn,getOwnPropertySymbols:pn}),Vr&&Je(Je.S+Je.F*(!tn||Le(function(){var e=Hr();return"[null]"!=Yr([e])||"{}"!=Yr({a:e})||"{}"!=Yr(Object(e))})),"JSON",{stringify:function(e){if(e!==undefined&&!sn(e)){for(var t,r,n=[e],i=1;arguments.length>i;)n.push(arguments[i++]);return t=n[1],"function"==typeof t&&(r=t),!r&&xr(t)||(t=function(e,t){if(r&&(t=r.call(this,e,t)),!sn(t))return t}),n[1]=t,Yr.apply(Vr,n)}}}),Hr.prototype[Zr]||Ke(Hr.prototype,Zr,Hr.prototype.valueOf),Pt(Hr,"Symbol"),Pt(Math,"Math",!0),Pt(Ie.JSON,"JSON",!0),wr("asyncIterator"),wr("observable");var vn=Pe.Symbol,bn=i(function(e){e.exports={"default":vn,__esModule:!0}});n(bn);var $n=i(function(e,t){function r(e){return e&&e.__esModule?e:{"default":e}}t.__esModule=!0;var n=r(vr),i=r(bn),o="function"==typeof i["default"]&&"symbol"==typeof n["default"]?function(e){return typeof e}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":typeof e};t["default"]="function"==typeof i["default"]&&"symbol"===o(n["default"])?function(e){return void 0===e?"undefined":o(e)}:function(e){return e&&"function"==typeof i["default"]&&e.constructor===i["default"]&&e!==i["default"].prototype?"symbol":void 0===e?"undefined":o(e)}}),wn=n($n);!function(e,t){var r=(Pe.Object||{})[e]||Object[e],n={};n[e]=t(r),Je(Je.S+Je.F*Le(function(){r(1)}),"Object",n)}("keys",function(){return function(e){return $t(Ct(e))}});var En=Pe.Object.keys,Sn=i(function(e){e.exports={"default":En,__esModule:!0}}),On=n(Sn),Tn=Math.floor,An=function(e){return!Ce(e)&&isFinite(e)&&Tn(e)===e};Je(Je.S,"Number",{isInteger:An});var xn=Pe.Number.isInteger,kn=i(function(e){e.exports={"default":xn,__esModule:!0}}),Dn=n(kn),In="\t\n\x0B\f\r \xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff",Pn="["+In+"]",Mn="\u200b\x85",Rn=RegExp("^"+Pn+Pn+"*"),Cn=RegExp(Pn+Pn+"*$"),jn=function(e,t,r){var n={},i=Le(function(){return!!In[e]()||Mn[e]()!=Mn}),o=n[e]=i?t(Ln):In[e];r&&(n[r]=o),Je(Je.P+Je.F*i,"String",n)},Ln=jn.trim=function(e,t){return e=String(De(e)),1&t&&(e=e.replace(Rn,"")),2&t&&(e=e.replace(Cn,"")),e},Nn=jn,Fn=Ie.parseFloat,Bn=Nn.trim,Un=1/Fn(In+"-0")!=-Infinity?function(e){var t=Bn(String(e),3),r=Fn(t);return 0===r&&"-"==t.charAt(0)?-0:r}:Fn;Je(Je.S+Je.F*(Number.parseFloat!=Un),"Number",{parseFloat:Un});var zn,Gn,Wn,Hn=parseFloat,Vn=i(function(e){e.exports={"default":Hn,__esModule:!0}}),Yn=n(Vn),Kn=D(function(e){return e}),Zn=function(e,t,r,n){if(!(e instanceof t)||n!==undefined&&n in e)throw TypeError(r+": incorrect invocation!");return e},Jn=i(function(e){var t={},r={},n=e.exports=function(e,n,i,o,a){var s,u,c,l,f=a?function(){return e}:er(e),d=Re(i,o,n?2:1),h=0;if("function"!=typeof f)throw TypeError(e+" is not iterable!");if(Yt(f)){for(s=at(e.length);s>h;h++)if((l=n?d(je(u=e[h])[0],u[1]):d(e[h]))===t||l===r)return l}else for(c=f.call(e);!(u=c.next()).done;)if((l=Wt(c,d,u.value,n))===t||l===r)return l};n.BREAK=t,n.RETURN=r}),Qn=kt("species"),Xn=function(e,t){var r,n=je(e).constructor;return n===undefined||(r=je(n)[Qn])==undefined?t:Me(r)},qn=function(e,t,r){var n=r===undefined;switch(t.length){case 0:return n?e():e.call(r);case 1:return n?e(t[0]):e.call(r,t[0]);case 2:return n?e(t[0],t[1]):e.call(r,t[0],t[1]);case 3:return n?e(t[0],t[1],t[2]):e.call(r,t[0],t[1],t[2]);case 4:return n?e(t[0],t[1],t[2],t[3]):e.call(r,t[0],t[1],t[2],t[3])}return e.apply(r,t)},ei=Ie.process,ti=Ie.setImmediate,ri=Ie.clearImmediate,ni=Ie.MessageChannel,ii=Ie.Dispatch,oi=0,ai={},si=function(){var e=+this;if(ai.hasOwnProperty(e)){var t=ai[e];delete ai[e],t()}},ui=function(e){si.call(e.data)};ti&&ri||(ti=function(e){for(var t=[],r=1;arguments.length>r;)t.push(arguments[r++]);return ai[++oi]=function(){qn("function"==typeof e?e:Function(e),t)},zn(oi),oi},ri=function(e){delete ai[e]},"process"==rt(ei)?zn=function(e){ei.nextTick(Re(si,e,1))}:ii&&ii.now?zn=function(e){ii.now(Re(si,e,1))}:ni?(Gn=new ni,Wn=Gn.port2,Gn.port1.onmessage=ui,zn=Re(Wn.postMessage,Wn,1)):Ie.addEventListener&&"function"==typeof postMessage&&!Ie.importScripts?(zn=function(e){Ie.postMessage(e+"","*")},Ie.addEventListener("message",ui,!1)):zn="onreadystatechange"in Ue("script")?function(e){St.appendChild(Ue("script")).onreadystatechange=function(){St.removeChild(this),si.call(e)}}:function(e){setTimeout(Re(si,e,1),0)});var ci,li,fi,di,hi={set:ti,clear:ri},pi=hi.set,yi=Ie.MutationObserver||Ie.WebKitMutationObserver,gi=Ie.process,mi=Ie.Promise,_i="process"==rt(gi),vi=function(e){return new B(e)},bi={f:vi},$i=function(t){try{return{e:!1,v:t()}}catch(e){return{e:!0,v:e}}},wi=function(e,t){if(je(e),Ce(t)&&t.constructor===e)return t;var r=bi.f(e);return(0,r.resolve)(t),r.promise},Ei=kt("species"),Si=hi.set,Oi=function(){var t,r,n,i=function(){var i,o;for(_i&&(i=gi.domain)&&i.exit();t;){o=t.fn,t=t.next;try{o()}catch(e){throw t?n():r=undefined,e}}r=undefined,i&&i.enter()};if(_i)n=function(){gi.nextTick(i)};else if(yi){var o=!0,a=document.createTextNode("");new yi(i).observe(a,{characterData:!0}),n=function(){a.data=o=!o}}else if(mi&&mi.resolve){var s=mi.resolve();n=function(){s.then(i)}}else n=function(){pi.call(Ie,i)};return function(e){var i={fn:e,next:undefined};r&&(r.next=i),t||(t=i,n()),r=i}}(),Ti=Ie.TypeError,Ai=Ie.process,xi=Ie.Promise,ki="process"==Xt(Ai),Di=function(){},Ii=li=bi.f,Pi=!!function(){try{var e=xi.resolve(1),t=(e.constructor={})[kt("species")]=function(e){e(Di,Di)};return(ki||"function"==typeof PromiseRejectionEvent)&&e.then(Di)instanceof t}catch(e){}}(),Mi=function(e){var t;return!(!Ce(e)||"function"!=typeof(t=e.then))&&t},Ri=function(t,r){if(!t._n){t._n=!0;var n=t._c;Oi(function(){for(var i=t._v,o=1==t._s,a=0;n.length>a;)!function(r){var n,a,s=o?r.ok:r.fail,u=r.resolve,c=r.reject,l=r.domain;try{s?(o||(2==t._h&&Li(t),t._h=1),!0===s?n=i:(l&&l.enter(),n=s(i),l&&l.exit()),n===r.promise?c(Ti("Promise-chain cycle")):(a=Mi(n))?a.call(n,u,c):u(n)):c(i)}catch(e){c(e)}}(n[a++]);t._c=[],t._n=!1,r&&!t._h&&Ci(t)})}},Ci=function(e){Si.call(Ie,function(){var t,r,n,i=e._v,o=ji(e);if(o&&(t=$i(function(){ki?Ai.emit("unhandledRejection",i,e):(r=Ie.onunhandledrejection)?r({promise:e,reason:i}):(n=Ie.console)&&n.error&&n.error("Unhandled promise rejection",i)}),e._h=ki||ji(e)?2:1),e._a=undefined,o&&t.e)throw t.v})},ji=function(e){if(1==e._h)return!1;for(var t,r=e._a||e._c,n=0;r.length>n;)if(t=r[n++],t.fail||!ji(t.promise))return!1;return!0},Li=function(e){Si.call(Ie,function(){var t;ki?Ai.emit("rejectionHandled",e):(t=Ie.onrejectionhandled)&&t({promise:e,reason:e._v})})},Ni=function(e){var t=this;t._d||(t._d=!0,t=t._w||t,t._v=e,t._s=2,t._a||(t._a=t._c.slice()),Ri(t,!0))},Fi=function(t){var r,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw Ti("Promise can't be resolved itself");(r=Mi(t))?Oi(function(){var i={_w:n,_d:!1};try{r.call(t,Re(Fi,i,1),Re(Ni,i,1))}catch(e){Ni.call(i,e)}}):(n._v=t,n._s=1,Ri(n,!1))}catch(e){Ni.call({_w:n,_d:!1},e)}}};Pi||(xi=function(e){Zn(this,xi,"Promise","_h"),Me(e),ci.call(this);try{e(Re(Fi,this,1),Re(Ni,this,1))}catch(t){Ni.call(this,t)}},ci=function(e){this._c=[],this._a=undefined,this._s=0,this._d=!1,this._v=undefined,this._h=0,this._n=!1},ci.prototype=function(e,t,r){for(var n in t)r&&e[n]?e[n]=t[n]:Ke(e,n,t[n]);return e}(xi.prototype,{then:function(e,t){var r=Ii(Xn(this,xi));return r.ok="function"!=typeof e||e,r.fail="function"==typeof t&&t,r.domain=ki?Ai.domain:undefined,this._c.push(r),this._a&&this._a.push(r),this._s&&Ri(this,!1),r.promise},"catch":function(e){return this.then(undefined,e)}}),fi=function(){var e=new ci;this.promise=e,this.resolve=Re(Fi,e,1),this.reject=Re(Ni,e,1)},bi.f=Ii=function(e){return e===xi||e===di?new fi(e):li(e)}),Je(Je.G+Je.W+Je.F*!Pi,{Promise:xi}),Pt(xi,"Promise"),function(e){var t="function"==typeof Pe[e]?Pe[e]:Ie[e];Ne&&t&&!t[Ei]&&Ve.f(t,Ei,{configurable:!0,get:function(){return this}})}("Promise"),di=Pe.Promise,Je(Je.S+Je.F*!Pi,"Promise",{reject:function(e){var t=Ii(this);return(0,t.reject)(e),t.promise}}),Je(Je.S+!0*Je.F,"Promise",{resolve:function(e){return wi(this===di?xi:this,e)}}),Je(Je.S+Je.F*!(Pi&&nr(function(e){xi.all(e)["catch"](Di)})),"Promise",{all:function(e){var t=this,r=Ii(t),n=r.resolve,i=r.reject,o=$i(function(){var r=[],o=0,a=1;Jn(e,!1,function(e){var s=o++,u=!1;r.push(undefined),a++,t.resolve(e).then(function(e){u||(u=!0,r[s]=e,--a||n(r))},i)}),--a||n(r)});return o.e&&i(o.v),r.promise},race:function(e){var t=this,r=Ii(t),n=r.reject,i=$i(function(){Jn(e,!1,function(e){t.resolve(e).then(r.resolve,n)})});return i.e&&n(i.v),r.promise}}),Je(Je.P+Je.R,"Promise",{"finally":function(e){var t=Xn(this,Pe.Promise||Ie.Promise),r="function"==typeof e;return this.then(r?function(r){return wi(t,e()).then(function(){return r})}:e,r?function(r){return wi(t,e()).then(function(){throw r})}:e)}}),Je(Je.S,"Promise",{"try":function(e){var t=bi.f(this),r=$i(e);return(r.e?t.reject:t.resolve)(r.v),t.promise}});var Bi=Pe.Promise,Ui=i(function(e){e.exports={"default":Bi,__esModule:!0}}),zi=n(Ui),Gi="undefined"!=typeof window&&"[object Object]"!==Object.prototype.toString.call(window),Wi=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame||function(e){return setTimeout(e,17)},Hi=window.cancelAnimationFrame||window.mozCancelAnimationFrame||window.webkitCancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.msCancelAnimationFrame||window.oCancelAnimationFrame||function(e){clearTimeout(e)},Vi=i(function(e,t){t.__esModule=!0,t["default"]=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}}),Yi=n(Vi);Je(Je.S+Je.F*!Ne,"Object",{defineProperty:Ve.f});var Ki=Pe.Object,Zi=function(e,t,r){return Ki.defineProperty(e,t,r)},Ji=i(function(e){e.exports={"default":Zi,__esModule:!0}});n(Ji);var Qi=i(function(e,t){t.__esModule=!0;var r=function(e){return e&&e.__esModule?e:{"default":e}}(Ji);t["default"]=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),(0,r["default"])(e,i.key,i)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()}),Xi=n(Qi),qi=Object.assign,eo=!qi||Le(function(){var e={},t={},r=Symbol(),n="abcdefghijklmnopqrst";return e[r]=7,n.split("").forEach(function(e){t[e]=e}),7!=qi({},e)[r]||Object.keys(qi({},t)).join("")!=n})?function(e,t){for(var r=Ct(e),n=arguments.length,i=1,o=Sr.f,a=Tr.f;n>i;)for(var s,u=nt(arguments[i++]),c=o?$t(u).concat(o(u)):$t(u),l=c.length,f=0;l>f;)a.call(u,s=c[f++])&&(r[s]=u[s]);return r}:qi;Je(Je.S+Je.F,"Object",{assign:eo});var to=Pe.Object.assign,ro=i(function(e){e.exports={"default":to,__esModule:!0}}),no=n(ro);Je(Je.S,"Object",{create:xt});var io=Pe.Object,oo=function(e,t){return io.create(e,t)},ao=i(function(e){e.exports={"default":oo,__esModule:!0}}),so=n(ao),uo=so(null);uo.count=0;var co=function(){function e(t,r){var n=this;if(Yi(this,e),Object.defineProperty(this,"__target",{writable:!0,enumerable:!1,configurable:!0}),this.__target=this,t){if("object"!==(void 0===t?"undefined":wn(t)))throw new Error("CusEvent target are not object");this.__target=t,r&&["on","once","off","emit"].forEach(function(e){t[e]=n[e]})}}return Xi(e,[{key:"on",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return ne(this.__target,e,t,r),this}},{key:"once",value:function(e,t){return this.on(e,t,!0)}},{key:"off",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return ie(this.__target,e,t,r),this}},{key:"emit",value:function(e,t){return re(this.__target,e,{data:t}),this}}]),e}(),lo=so(null);lo.count=0;var fo=(function(){function e(t,r){var n=this;if(Yi(this,e),Object.defineProperty(this,"__target",{writable:!0,enumerable:!1,configurable:!0}),this.__target=this,t){if("object"!==(void 0===t?"undefined":wn(t)))throw new Error("CusEvent target are not object");this.__target=t,r&&["on","once","off","emit"].forEach(function(e){t[e]=n[e]})}}Xi(e,[{key:"on",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return se(this.__target,e,t,r),this}},{key:"once",value:function(e,t){return this.on(e,t,!0)}},{key:"off",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2];return ue(this.__target,e,t,r),this}},{key:"emit",value:function(e,t){return ae(this.__target,e,{data:t}),this}}])}(),"undefined"!=typeof window&&Object.prototype.toString.call(window),document.createElement("div")),ho="innerText";"textContent"in fo&&(ho="textContent");var po=Array.prototype;r.supportsPassive=!1;try{var yo=Object.defineProperty({},"passive",{get:function(){r.supportsPassive=!0}});window.addEventListener("test",null,yo)}catch(e){}var go=!!r.supportsPassive&&{passive:!0},mo=function(){function e(t){var r=arguments.length>1&&arguments[1]!==undefined?arguments[1]:document;Yi(this,e);var n=this;n.selector=t;var i=void 0;t&&t.constructor===NodeList?i=ce(t):s(t)?i=t:_(t)?0===t.indexOf("<")?(fo.innerHTML=t,i=$e("*",fo,!0)):i=$e(t,r,!0):i=[t],no(n,i),n.length=i.length}return Xi(e,[{key:"each",value:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return po.forEach.apply(this,t),this}},{key:"push",value:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return po.push.apply(this,t),this}},{key:"splice",value:function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return Se(po.splice.apply(this,t))}},{key:"find",value:function(e){var t=[];this.each(function(r){t=t.concat($e(e,r,!0))});var r=Se(t);return r.parent=this,r.selector=e,r}},{key:"append",value:function(e){var t=Se(e),r=this[0];return t.each(function(e){return r.appendChild(e)}),this}},{key:"appendTo",value:function(e){return Se(e).append(this),this}},{key:"text",value:function(e){return 0===arguments.length?this[0][ho]:this.each(function(t){t[ho]=e})}},{key:"html",value:function(e){return 0===arguments.length?this[0].innerHTML:this.each(function(t){t.innerHTML=e})}},{key:"attr",value:function(e,t){return 1===arguments.length?le(this[0],e):this.each(function(r){return fe(r,e,t)})}},{key:"data",value:function(e,t){return 0===arguments.length?this[0].dataset||{}:1===arguments.length?(this[0].dataset||{})[e]:this.each(function(r){(r.dataset||(r.dataset={}))[e]=t})}},{key:"css",value:function(e,t){return 1!==arguments.length||c(e)?this.each(function(r){return be(r,e,t)}):ve(this[0],e)}},{key:"addClass",value:function(e){return this.each(function(t){return de(t,e)})}},{key:"removeClass",value:function(e){return this.each(function(t){return he(t,e)})}},{key:"hasClass",value:function(e){return pe(this[0],e)}},{key:"on",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2],n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:go;return this.each(function(i){return ge(i,e,t,r,n)})}},{key:"off",value:function(e,t){var r=arguments.length>2&&arguments[2]!==undefined&&arguments[2],n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:go;return this.each(function(i){return ye(i,e,t,r,n)})}},{key:"delegate",value:function(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:go;return this.each(function(i){return me(i,e,t,r,n)})}},{key:"undelegate",value:function(e,t,r){var n=arguments.length>3&&arguments[3]!==undefined?arguments[3]:go;return this.each(function(i){return _e(i,e,t,r,n)})}},{key:"remove",value:function(){return this.each(function(e){return we(e)})}}]),e}(),_o=function(){function e(){Yi(this,e)}return Xi(e,null,[{key:"error",value:function(t,r){e.ENABLE_ERROR&&(console.error||console.warn||console.log)(Oe(t,r))}},{key:"info",value:function(t,r){e.ENABLE_INFO&&(console.info||console.log)(Oe(t,r))}},{key:"warn",value:function(t,r){e.ENABLE_WARN&&(console.warn||console.log)(Oe(t,r))}},{key:"debug",value:function(t,r){e.ENABLE_DEBUG&&(console.debug||console.log)(Oe(t,r))}},{key:"verbose",value:function(t,r){e.ENABLE_VERBOSE&&console.log(Oe(t,r))}}]),e}();_o.GLOBAL_TAG="chimee",_o.FORCE_GLOBAL_TAG=!1,_o.ENABLE_ERROR=!0,_o.ENABLE_INFO=!0,_o.ENABLE_WARN=!0,_o.ENABLE_DEBUG=!0,_o.ENABLE_VERBOSE=!0;var vo=i(function(e,t){!function(r,n){var i="model",o="name",a="type",s="vendor",u="version",c="mobile",l="tablet",f={extend:function(e,t){var r={};for(var n in e)t[n]&&t[n].length%2==0?r[n]=t[n].concat(e[n]):r[n]=e[n];return r},has:function(e,t){return"string"==typeof e&&-1!==t.toLowerCase().indexOf(e.toLowerCase())},lowerize:function(e){return e.toLowerCase()},major:function(e){return"string"==typeof e?e.replace(/[^\d\.]/g,"").split(".")[0]:n},trim:function(e){return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}},d={rgx:function(e,t){for(var r,i,o,a,s,u,c=0;c<t.length&&!s;){var l=t[c],f=t[c+1];for(r=i=0;r<l.length&&!s;)if(s=l[r++].exec(e))for(o=0;o<f.length;o++)u=s[++i],a=f[o],"object"==typeof a&&a.length>0?2==a.length?"function"==typeof a[1]?this[a[0]]=a[1].call(this,u):this[a[0]]=a[1]:3==a.length?"function"!=typeof a[1]||a[1].exec&&a[1].test?this[a[0]]=u?u.replace(a[1],a[2]):n:this[a[0]]=u?a[1].call(this,u,a[2]):n:4==a.length&&(this[a[0]]=u?a[3].call(this,u.replace(a[1],a[2])):n):this[a]=u||n;c+=2}},str:function(e,t){for(var r in t)if("object"==typeof t[r]&&t[r].length>0){for(var i=0;i<t[r].length;i++)if(f.has(t[r][i],e))return"?"===r?n:r}else if(f.has(t[r],e))return"?"===r?n:r;return e}},h={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}},p={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[o,u],[/(opios)[\/\s]+([\w\.]+)/i],[[o,"Opera Mini"],u],[/\s(opr)\/([\w\.]+)/i],[[o,"Opera"],u],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i],[o,u],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[o,"IE"],u],[/(edge)\/((\d+)?[\w\.]+)/i],[o,u],[/(yabrowser)\/([\w\.]+)/i],[[o,"Yandex"],u],[/(puffin)\/([\w\.]+)/i],[[o,"Puffin"],u],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[o,"UCBrowser"],u],[/(comodo_dragon)\/([\w\.]+)/i],[[o,/_/g," "],u],[/(micromessenger)\/([\w\.]+)/i],[[o,"WeChat"],u],[/(QQ)\/([\d\.]+)/i],[o,u],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[o,u],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[u,[o,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[u,[o,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[u,[o,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[o,/(.+)/,"$1 WebView"],u],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[o,/(.+(?:g|us))(.+)/,"$1 $2"],u],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[u,[o,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[o,u],[/(dolfin)\/([\w\.]+)/i],[[o,"Dolphin"],u],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[o,"Chrome"],u],[/(coast)\/([\w\.]+)/i],[[o,"Opera Coast"],u],[/fxios\/([\w\.-]+)/i],[u,[o,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[u,[o,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[u,o],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[o,"GSA"],u],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[o,[u,d.str,h.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[o,u],[/(navigator|netscape)\/([\w\.-]+)/i],[[o,"Netscape"],u],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[o,u]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[["architecture","amd64"]],[/(ia32(?=;))/i],[["architecture",f.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[["architecture","ia32"]],[/windows\s(ce|mobile);\sppc;/i],[["architecture","arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[["architecture",/ower/,"",f.lowerize]],[/(sun4\w)[;\)]/i],[["architecture","sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[["architecture",f.lowerize]]],
device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[i,s,[a,l]],[/applecoremedia\/[\w\.]+ \((ipad)/],[i,[s,"Apple"],[a,l]],[/(apple\s{0,1}tv)/i],[[i,"Apple TV"],[s,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[s,i,[a,l]],[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],[i,[s,"Amazon"],[a,l]],[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],[[i,d.str,h.device.amazon.model],[s,"Amazon"],[a,c]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[i,s,[a,c]],[/\((ip[honed|\s\w*]+);/i],[i,[s,"Apple"],[a,c]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[s,i,[a,c]],[/\(bb10;\s(\w+)/i],[i,[s,"BlackBerry"],[a,c]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[i,[s,"Asus"],[a,l]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[s,"Sony"],[i,"Xperia Tablet"],[a,l]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[i,[s,"Sony"],[a,c]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[s,i,[a,"console"]],[/android.+;\s(shield)\sbuild/i],[i,[s,"Nvidia"],[a,"console"]],[/(playstation\s[34portablevi]+)/i],[i,[s,"Sony"],[a,"console"]],[/(sprint\s(\w+))/i],[[s,d.str,h.device.sprint.vendor],[i,d.str,h.device.sprint.model],[a,c]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[s,i,[a,l]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w+)*/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i],[s,[i,/_/g," "],[a,c]],[/(nexus\s9)/i],[i,[s,"HTC"],[a,l]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[i,[s,"Huawei"],[a,c]],[/(microsoft);\s(lumia[\s\w]+)/i],[s,i,[a,c]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[i,[s,"Microsoft"],[a,"console"]],[/(kin\.[onetw]{3})/i],[[i,/\./g," "],[s,"Microsoft"],[a,c]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w+)*/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[i,[s,"Motorola"],[a,c]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[i,[s,"Motorola"],[a,l]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[s,f.trim],[i,f.trim],[a,"smarttv"]],[/hbbtv.+maple;(\d+)/i],[[i,/^/,"SmartTV"],[s,"Samsung"],[a,"smarttv"]],[/\(dtv[\);].+(aquos)/i],[i,[s,"Sharp"],[a,"smarttv"]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[s,"Samsung"],i,[a,l]],[/smart-tv.+(samsung)/i],[s,[a,"smarttv"],i],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,/sec-((sgh\w+))/i],[[s,"Samsung"],i,[a,c]],[/sie-(\w+)*/i],[i,[s,"Siemens"],[a,c]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]+)*/i],[[s,"Nokia"],i,[a,c]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[i,[s,"Acer"],[a,l]],[/android.+([vl]k\-?\d{3})\s+build/i],[i,[s,"LG"],[a,l]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[s,"LG"],i,[a,l]],[/(lg) netcast\.tv/i],[s,i,[a,"smarttv"]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w+)*/i,/android.+lg(\-?[\d\w]+)\s+build/i],[i,[s,"LG"],[a,c]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[i,[s,"Lenovo"],[a,l]],[/linux;.+((jolla));/i],[s,i,[a,c]],[/((pebble))app\/[\d\.]+\s/i],[s,i,[a,"wearable"]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[s,i,[a,c]],[/crkey/i],[[i,"Chromecast"],[s,"Google"]],[/android.+;\s(glass)\s\d/i],[i,[s,"Google"],[a,"wearable"]],[/android.+;\s(pixel c)\s/i],[i,[s,"Google"],[a,l]],[/android.+;\s(pixel xl|pixel)\s/i],[i,[s,"Google"],[a,c]],[/android.+(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[i,/_/g," "],[s,"Xiaomi"],[a,c]],[/android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[i,/_/g," "],[s,"Xiaomi"],[a,l]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[i,[s,"Meizu"],[a,l]],[/android.+a000(1)\s+build/i],[i,[s,"OnePlus"],[a,c]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[i,[s,"RCA"],[a,l]],[/android.+[;\/]\s*(Venue[\d\s]*)\s+build/i],[i,[s,"Dell"],[a,l]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[i,[s,"Verizon"],[a,l]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[s,"Barnes & Noble"],i,[a,l]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[i,[s,"NuVision"],[a,l]],[/android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i],[[s,"ZTE"],i,[a,l]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[i,[s,"Swiss"],[a,c]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[i,[s,"Swiss"],[a,l]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[i,[s,"Zeki"],[a,l]],[/(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i],[[s,"Dragon Touch"],i,[a,l]],[/android.+[;\/]\s*(NS-?.+)\s+build/i],[i,[s,"Insignia"],[a,l]],[/android.+[;\/]\s*((NX|Next)-?.+)\s+build/i],[i,[s,"NextBook"],[a,l]],[/android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[s,"Voice"],i,[a,c]],[/android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i],[[s,"LvTel"],i,[a,c]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[i,[s,"Envizen"],[a,l]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i],[s,i,[a,l]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[i,[s,"MachSpeed"],[a,l]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[s,i,[a,l]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[i,[s,"Rotor"],[a,l]],[/android.+(KS(.+))\s+build/i],[i,[s,"Amazon"],[a,l]],[/android.+(Gigaset)[\s\-]+(Q.+)\s+build/i],[s,i,[a,l]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[a,f.lowerize],s,i],[/(android.+)[;\/].+build/i],[i,[s,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[u,[o,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[o,u],[/rv\:([\w\.]+).*(gecko)/i],[u,o]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[o,u],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[o,[u,d.str,h.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[o,"Windows"],[u,d.str,h.os.windows.version]],[/\((bb)(10);/i],[[o,"BlackBerry"],u],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[o,u],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[o,"Symbian"],u],[/\((series40);/i],[o],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[o,"Firefox OS"],u],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[o,u],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[o,"Chromium OS"],u],[/(sunos)\s?([\w\.]+\d)*/i],[[o,"Solaris"],u],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[o,u],[/(haiku)\s(\w+)/i],[o,u],[/cfnetwork\/.+darwin/i,/ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[u,/_/g,"."],[o,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[o,"Mac OS"],[u,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[o,u]]},y=function(e,t){if("object"==typeof e&&(t=e,e=n),!(this instanceof y))return new y(e,t).getResult();var i=e||(r&&r.navigator&&r.navigator.userAgent?r.navigator.userAgent:""),o=t?f.extend(p,t):p;return this.getBrowser=function(){var e={name:n,version:n};return d.rgx.call(e,i,o.browser),e.major=f.major(e.version),e},this.getCPU=function(){var e={architecture:n};return d.rgx.call(e,i,o.cpu),e},this.getDevice=function(){var e={vendor:n,model:n,type:n};return d.rgx.call(e,i,o.device),e},this.getEngine=function(){var e={name:n,version:n};return d.rgx.call(e,i,o.engine),e},this.getOS=function(){var e={name:n,version:n};return d.rgx.call(e,i,o.os),e},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}},this.getUA=function(){return i},this.setUA=function(e){return i=e,this},this};y.VERSION="0.7.17",y.BROWSER={NAME:o,MAJOR:"major",VERSION:u},y.CPU={ARCHITECTURE:"architecture"},y.DEVICE={MODEL:i,VENDOR:s,TYPE:a,CONSOLE:"console",MOBILE:c,SMARTTV:"smarttv",TABLET:l,WEARABLE:"wearable",EMBEDDED:"embedded"},y.ENGINE={NAME:o,VERSION:u},y.OS={NAME:o,VERSION:u},e.exports&&(t=e.exports=y),t.UAParser=y;var g=r&&(r.jQuery||r.Zepto);if(void 0!==g){var m=new y;g.ua=m.getResult(),g.ua.get=function(){return m.getUA()},g.ua.set=function(e){m.setUA(e);var t=m.getResult();for(var r in t)g.ua[r]=t[r]}}}("object"==typeof window?window:Te)});r.Log=_o,r.UAParser=vo,r.genTraversalHandler=D,r.deepClone=I,r.deepAssign=P,r.camelize=M,r.hypenate=R,r.bind=C,r.uuid=j,r.S4=L,r.rand=N,r.getDeepProperty=F,r.defined=o,r.isVoid=a,r.isArray=s,r.isFunction=u,r.isObject=c,r.isNumber=l,r.isNumeric=f,r.isInteger=d,r.isEmpty=h,r.isEvent=p,r.isBlob=y,r.isFile=g,r.isDate=m,r.isString=_,r.isBoolean=v,r.isPromise=b,r.isPrimitive=$,r.isUrl=w,r.isNode=E,r.isElement=S,r.isChildNode=O,r.isPosterityNode=T,r.isHTMLString=A,r.isError=x,r.isRegExp=k,r.inBrowser=Gi,r.makeArray=U,r.transObjectAttrIntoArray=z,r.runRejectableQueue=G,r.runStoppableQueue=W,r.decodeUTF8=V,r.debounce=Y,r.throttle=K,r.raf=Wi,r.caf=Hi,r.strRepeat=Z,r.formatTime=J,r.appendCSS=Q,r.formatDate=X,r.getLocalStorage=q,r.setLocalStorage=ee,r.emitEventCache=re,r.addEventCache=ne,r.removeEventCache=ie,r.CustEvent=co,r.getAttr=le,r.setAttr=fe,r.addClassName=de,r.removeClassName=he,r.hasClassName=pe,r.removeEvent=ye,r.addEvent=ge,r.addDelegate=me,r.removeDelegate=_e,r.getStyle=ve,r.setStyle=be,r.query=$e,r.removeEl=we,r.findParents=Ee,r.$=Se,r.NodeWrap=mo,Object.defineProperty(r,"__esModule",{value:!0})}(r)}()}).call(r,n(19))},function(module,exports){var g;g=function(){return this}();try{g=g||Function("return this")()||eval("this")}catch(e){"object"==typeof window&&(g=window)}module.exports=g}])["default"]})}),chimeeKernelFlv=unwrapExports(lib);__$styleInject(".chimee-container container{position:relative;display:block;width:100%;height:100%}.chimee-container video{display:block;width:100%;height:100%;background:#000;outline:0}.chimee-container video:focus{outline:0}.chimee-container chimee-center-state-loading{box-sizing:initial}",undefined);var _global$3=createCommonjsModule(function(e){var t=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=t)}),hasOwnProperty$2={}.hasOwnProperty,_has$3=function(e,t){return hasOwnProperty$2.call(e,t)},_fails$3=function(e){try{return!!e()}catch(e){return!0}},_descriptors$3=!_fails$3(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),_core$3=createCommonjsModule(function(e){var t=e.exports={version:"2.5.1"};"number"==typeof __e&&(__e=t)}),_core_1$1=_core$3.version,_isObject$3=function(e){return"object"==typeof e?null!==e:"function"==typeof e},_anObject$3=function(e){if(!_isObject$3(e))throw TypeError(e+" is not an object!");return e},document$3=_global$3.document,is$2=_isObject$3(document$3)&&_isObject$3(document$3.createElement),_domCreate$3=function(e){return is$2?document$3.createElement(e):{}},_ie8DomDefine$3=!_descriptors$3&&!_fails$3(function(){return 7!=Object.defineProperty(_domCreate$3("div"),"a",{get:function(){return 7}}).a}),_toPrimitive$3=function(e,t){if(!_isObject$3(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!_isObject$3(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!_isObject$3(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!_isObject$3(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")},dP$6=Object.defineProperty,f$9=_descriptors$3?Object.defineProperty:function(e,t,r){if(_anObject$3(e),t=_toPrimitive$3(t,!0),_anObject$3(r),_ie8DomDefine$3)try{return dP$6(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(e[t]=r.value),e},_objectDp$3={f:f$9},_propertyDesc$3=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},_hide$3=_descriptors$3?function(e,t,r){return _objectDp$3.f(e,t,_propertyDesc$3(1,r))}:function(e,t,r){return e[t]=r,e},id$3=0,px$2=Math.random(),_uid$3=function(e){return"Symbol(".concat(e===undefined?"":e,")_",(++id$3+px$2).toString(36))},_redefine$3=createCommonjsModule(function(e){var t=_uid$3("src"),r=Function.toString,n=(""+r).split("toString");_core$3.inspectSource=function(e){return r.call(e)},(e.exports=function(e,r,i,o){var a="function"==typeof i;a&&(_has$3(i,"name")||_hide$3(i,"name",r)),e[r]!==i&&(a&&(_has$3(i,t)||_hide$3(i,t,e[r]?""+e[r]:n.join(String(r)))),e===_global$3?e[r]=i:o?e[r]?e[r]=i:_hide$3(e,r,i):(delete e[r],_hide$3(e,r,i)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[t]||r.call(this)})}),_aFunction$3=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e},_ctx$3=function(e,t,r){if(_aFunction$3(e),t===undefined)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,i){return e.call(t,r,n,i)}}return function(){return e.apply(t,arguments)}},PROTOTYPE$5="prototype",$export$3=function(e,t,r){var n,i,o,a,s=e&$export$3.F,u=e&$export$3.G,c=e&$export$3.S,l=e&$export$3.P,f=e&$export$3.B,d=u?_global$3:c?_global$3[t]||(_global$3[t]={}):(_global$3[t]||{})[PROTOTYPE$5],h=u?_core$3:_core$3[t]||(_core$3[t]={}),p=h[PROTOTYPE$5]||(h[PROTOTYPE$5]={});u&&(r=t);for(n in r)i=!s&&d&&d[n]!==undefined,o=(i?d:r)[n],a=f&&i?_ctx$3(o,_global$3):l&&"function"==typeof o?_ctx$3(Function.call,o):o,d&&_redefine$3(d,n,o,e&$export$3.U),h[n]!=o&&_hide$3(h,n,a),l&&p[n]!=o&&(p[n]=o)};_global$3.core=_core$3,$export$3.F=1,$export$3.G=2,$export$3.S=4,$export$3.P=8,$export$3.B=16,$export$3.W=32,$export$3.U=64,$export$3.R=128;var _export$3=$export$3,_meta$3=createCommonjsModule(function(e){var t=_uid$3("meta"),r=_objectDp$3.f,n=0,i=Object.isExtensible||function(){return!0},o=!_fails$3(function(){return i(Object.preventExtensions({}))}),a=function(e){r(e,t,{value:{i:"O"+ ++n,w:{}}})},s=function(e,r){if(!_isObject$3(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!_has$3(e,t)){if(!i(e))return"F";if(!r)return"E";a(e)}return e[t].i},u=function(e,r){if(!_has$3(e,t)){if(!i(e))return!0;if(!r)return!1;a(e)}return e[t].w},c=function(e){return o&&l.NEED&&i(e)&&!_has$3(e,t)&&a(e),e},l=e.exports={KEY:t,NEED:!1,fastKey:s,getWeak:u,onFreeze:c}}),_meta_1$1=_meta$3.KEY,_meta_2$1=_meta$3.NEED,_meta_3$1=_meta$3.fastKey,_meta_4$1=_meta$3.getWeak,_meta_5$1=_meta$3.onFreeze,SHARED$2="__core-js_shared__",store$2=_global$3[SHARED$2]||(_global$3[SHARED$2]={}),_shared$3=function(e){return store$2[e]||(store$2[e]={})},_wks$3=createCommonjsModule(function(e){var t=_shared$3("wks"),r=_global$3.Symbol,n="function"==typeof r;(e.exports=function(e){return t[e]||(t[e]=n&&r[e]||(n?r:_uid$3)("Symbol."+e))}).store=t}),def$2=_objectDp$3.f,TAG$3=_wks$3("toStringTag"),_setToStringTag$3=function(e,t,r){e&&!_has$3(e=r?e:e.prototype,TAG$3)&&def$2(e,TAG$3,{configurable:!0,value:t})},f$10=_wks$3,_wksExt$3={f:f$10},_library$3=!1,defineProperty$7=_objectDp$3.f,_wksDefine$3=function(e){var t=_core$3.Symbol||(_core$3.Symbol=_library$3?{}:_global$3.Symbol||{});"_"==e.charAt(0)||e in t||defineProperty$7(t,e,{value:_wksExt$3.f(e)})},toString$3={}.toString,_cof$3=function(e){return toString$3.call(e).slice(8,-1)},_iobject$3=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==_cof$3(e)?e.split(""):Object(e)},_defined$3=function(e){if(e==undefined)throw TypeError("Can't call method on  "+e);return e},_toIobject$3=function(e){return _iobject$3(_defined$3(e))},ceil$2=Math.ceil,floor$3=Math.floor,_toInteger$3=function(e){return isNaN(e=+e)?0:(e>0?floor$3:ceil$2)(e)},min$3=Math.min,_toLength$3=function(e){return e>0?min$3(_toInteger$3(e),9007199254740991):0},max$2=Math.max,min$4=Math.min,_toAbsoluteIndex$3=function(e,t){return e=_toInteger$3(e),e<0?max$2(e+t,0):min$4(e,t)},_arrayIncludes$3=function(e){return function(t,r,n){var i,o=_toIobject$3(t),a=_toLength$3(o.length),s=_toAbsoluteIndex$3(n,a);if(e&&r!=r){for(;a>s;)if((i=o[s++])!=i)return!0}else for(;a>s;s++)if((e||s in o)&&o[s]===r)return e||s||0;return!e&&-1}},shared$3=_shared$3("keys"),_sharedKey$3=function(e){return shared$3[e]||(shared$3[e]=_uid$3(e))},arrayIndexOf$2=_arrayIncludes$3(!1),IE_PROTO$4=_sharedKey$3("IE_PROTO"),_objectKeysInternal$3=function(e,t){var r,n=_toIobject$3(e),i=0,o=[];for(r in n)r!=IE_PROTO$4&&_has$3(n,r)&&o.push(r);for(;t.length>i;)_has$3(n,r=t[i++])&&(~arrayIndexOf$2(o,r)||o.push(r));return o},_enumBugKeys$3="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),_objectKeys$3=Object.keys||function(e){return _objectKeysInternal$3(e,_enumBugKeys$3)},f$11=Object.getOwnPropertySymbols,_objectGops$3={f:f$11},f$12={}.propertyIsEnumerable,_objectPie$3={f:f$12},_enumKeys$3=function(e){var t=_objectKeys$3(e),r=_objectGops$3.f;if(r)for(var n,i=r(e),o=_objectPie$3.f,a=0;i.length>a;)o.call(e,n=i[a++])&&t.push(n);return t},_isArray$3=Array.isArray||function(e){return"Array"==_cof$3(e)},_objectDps$3=_descriptors$3?Object.defineProperties:function(e,t){_anObject$3(e);for(var r,n=_objectKeys$3(t),i=n.length,o=0;i>o;)_objectDp$3.f(e,r=n[o++],t[r]);return e},document$4=_global$3.document,_html$3=document$4&&document$4.documentElement,IE_PROTO$5=_sharedKey$3("IE_PROTO"),Empty$2=function(){},PROTOTYPE$6="prototype",createDict$2=function(){var e,t=_domCreate$3("iframe"),r=_enumBugKeys$3.length;for(t.style.display="none",_html$3.appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),createDict$2=e.F;r--;)delete createDict$2[PROTOTYPE$6][_enumBugKeys$3[r]];return createDict$2()},_objectCreate$3=Object.create||function(e,t){var r;return null!==e?(Empty$2[PROTOTYPE$6]=_anObject$3(e),r=new Empty$2,Empty$2[PROTOTYPE$6]=null,r[IE_PROTO$5]=e):r=createDict$2(),t===undefined?r:_objectDps$3(r,t)},hiddenKeys$2=_enumBugKeys$3.concat("length","prototype"),f$14=Object.getOwnPropertyNames||function(e){return _objectKeysInternal$3(e,hiddenKeys$2)},_objectGopn$3={f:f$14},gOPN$5=_objectGopn$3.f,toString$4={}.toString,windowNames$2="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],getWindowNames$2=function(e){try{return gOPN$5(e)}catch(e){return windowNames$2.slice()}},f$13=function(e){return windowNames$2&&"[object Window]"==toString$4.call(e)?getWindowNames$2(e):gOPN$5(_toIobject$3(e))},_objectGopnExt$3={f:f$13},gOPD$5=Object.getOwnPropertyDescriptor,f$15=_descriptors$3?gOPD$5:function(e,t){if(e=_toIobject$3(e),t=_toPrimitive$3(t,!0),_ie8DomDefine$3)try{return gOPD$5(e,t)}catch(e){}if(_has$3(e,t))return _propertyDesc$3(!_objectPie$3.f.call(e,t),e[t])},_objectGopd$3={f:f$15},META$2=_meta$3.KEY,gOPD$4=_objectGopd$3.f,dP$5=_objectDp$3.f,gOPN$4=_objectGopnExt$3.f,$Symbol$2=_global$3.Symbol,$JSON$3=_global$3.JSON,_stringify$2=$JSON$3&&$JSON$3.stringify,PROTOTYPE$4="prototype",HIDDEN$2=_wks$3("_hidden"),TO_PRIMITIVE$2=_wks$3("toPrimitive"),isEnum$3={}.propertyIsEnumerable,SymbolRegistry$2=_shared$3("symbol-registry"),AllSymbols$2=_shared$3("symbols"),OPSymbols$2=_shared$3("op-symbols"),ObjectProto$3=Object[PROTOTYPE$4],USE_NATIVE$3="function"==typeof $Symbol$2,QObject$2=_global$3.QObject,setter$2=!QObject$2||!QObject$2[PROTOTYPE$4]||!QObject$2[PROTOTYPE$4].findChild,setSymbolDesc$2=_descriptors$3&&_fails$3(function(){return 7!=_objectCreate$3(dP$5({},"a",{get:function(){return dP$5(this,"a",{value:7}).a}})).a})?function(e,t,r){var n=gOPD$4(ObjectProto$3,t);n&&delete ObjectProto$3[t],dP$5(e,t,r),n&&e!==ObjectProto$3&&dP$5(ObjectProto$3,t,n)}:dP$5,wrap$2=function(e){var t=AllSymbols$2[e]=_objectCreate$3($Symbol$2[PROTOTYPE$4]);return t._k=e,t},isSymbol$2=USE_NATIVE$3&&"symbol"==typeof $Symbol$2.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof $Symbol$2},$defineProperty$1$1=function(e,t,r){return e===ObjectProto$3&&$defineProperty$1$1(OPSymbols$2,t,r),_anObject$3(e),t=_toPrimitive$3(t,!0),_anObject$3(r),_has$3(AllSymbols$2,t)?(r.enumerable?(_has$3(e,HIDDEN$2)&&e[HIDDEN$2][t]&&(e[HIDDEN$2][t]=!1),r=_objectCreate$3(r,{enumerable:_propertyDesc$3(0,!1)})):(_has$3(e,HIDDEN$2)||dP$5(e,HIDDEN$2,_propertyDesc$3(1,{})),e[HIDDEN$2][t]=!0),setSymbolDesc$2(e,t,r)):dP$5(e,t,r)},$defineProperties$2=function(e,t){_anObject$3(e);for(var r,n=_enumKeys$3(t=_toIobject$3(t)),i=0,o=n.length;o>i;)$defineProperty$1$1(e,r=n[i++],t[r]);return e},$create$2=function(e,t){return t===undefined?_objectCreate$3(e):$defineProperties$2(_objectCreate$3(e),t)},$propertyIsEnumerable$2=function(e){var t=isEnum$3.call(this,e=_toPrimitive$3(e,!0));return!(this===ObjectProto$3&&_has$3(AllSymbols$2,e)&&!_has$3(OPSymbols$2,e))&&(!(t||!_has$3(this,e)||!_has$3(AllSymbols$2,e)||_has$3(this,HIDDEN$2)&&this[HIDDEN$2][e])||t)},$getOwnPropertyDescriptor$3=function(e,t){if(e=_toIobject$3(e),t=_toPrimitive$3(t,!0),e!==ObjectProto$3||!_has$3(AllSymbols$2,t)||_has$3(OPSymbols$2,t)){var r=gOPD$4(e,t);return!r||!_has$3(AllSymbols$2,t)||_has$3(e,HIDDEN$2)&&e[HIDDEN$2][t]||(r.enumerable=!0),r}},$getOwnPropertyNames$2=function(e){for(var t,r=gOPN$4(_toIobject$3(e)),n=[],i=0;r.length>i;)_has$3(AllSymbols$2,t=r[i++])||t==HIDDEN$2||t==META$2||n.push(t);return n},$getOwnPropertySymbols$2=function(e){for(var t,r=e===ObjectProto$3,n=gOPN$4(r?OPSymbols$2:_toIobject$3(e)),i=[],o=0;n.length>o;)!_has$3(AllSymbols$2,t=n[o++])||r&&!_has$3(ObjectProto$3,t)||i.push(AllSymbols$2[t]);return i};USE_NATIVE$3||($Symbol$2=function(){if(this instanceof $Symbol$2)throw TypeError("Symbol is not a constructor!");var e=_uid$3(arguments.length>0?arguments[0]:undefined),t=function(r){this===ObjectProto$3&&t.call(OPSymbols$2,r),_has$3(this,HIDDEN$2)&&_has$3(this[HIDDEN$2],e)&&(this[HIDDEN$2][e]=!1),setSymbolDesc$2(this,e,_propertyDesc$3(1,r))};return _descriptors$3&&setter$2&&setSymbolDesc$2(ObjectProto$3,e,{configurable:!0,set:t}),wrap$2(e)},_redefine$3($Symbol$2[PROTOTYPE$4],"toString",function(){return this._k}),_objectGopd$3.f=$getOwnPropertyDescriptor$3,_objectDp$3.f=$defineProperty$1$1,_objectGopn$3.f=_objectGopnExt$3.f=$getOwnPropertyNames$2,_objectPie$3.f=$propertyIsEnumerable$2,_objectGops$3.f=$getOwnPropertySymbols$2,_descriptors$3&&!_library$3&&_redefine$3(ObjectProto$3,"propertyIsEnumerable",$propertyIsEnumerable$2,!0),_wksExt$3.f=function(e){return wrap$2(_wks$3(e))}),_export$3(_export$3.G+_export$3.W+_export$3.F*!USE_NATIVE$3,{Symbol:$Symbol$2});for(var es6Symbols$2="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),j$2=0;es6Symbols$2.length>j$2;)_wks$3(es6Symbols$2[j$2++]);for(var wellKnownSymbols$2=_objectKeys$3(_wks$3.store),k$2=0;wellKnownSymbols$2.length>k$2;)_wksDefine$3(wellKnownSymbols$2[k$2++]);_export$3(_export$3.S+_export$3.F*!USE_NATIVE$3,"Symbol",{"for":function(e){return _has$3(SymbolRegistry$2,e+="")?SymbolRegistry$2[e]:SymbolRegistry$2[e]=$Symbol$2(e)},keyFor:function(e){if(!isSymbol$2(e))throw TypeError(e+" is not a symbol!");for(var t in SymbolRegistry$2)if(SymbolRegistry$2[t]===e)return t},useSetter:function(){setter$2=!0},useSimple:function(){setter$2=!1}}),_export$3(_export$3.S+_export$3.F*!USE_NATIVE$3,"Object",{create:$create$2,defineProperty:$defineProperty$1$1,defineProperties:$defineProperties$2,getOwnPropertyDescriptor:$getOwnPropertyDescriptor$3,getOwnPropertyNames:$getOwnPropertyNames$2,getOwnPropertySymbols:$getOwnPropertySymbols$2}),$JSON$3&&_export$3(_export$3.S+_export$3.F*(!USE_NATIVE$3||_fails$3(function(){var e=$Symbol$2();return"[null]"!=_stringify$2([e])||"{}"!=_stringify$2({a:e})||"{}"!=_stringify$2(Object(e))})),"JSON",{stringify:function(e){if(e!==undefined&&!isSymbol$2(e)){for(var t,r,n=[e],i=1;arguments.length>i;)n.push(arguments[i++]);return t=n[1],"function"==typeof t&&(r=t),!r&&_isArray$3(t)||(t=function(e,t){if(r&&(t=r.call(this,e,t)),!isSymbol$2(t))return t}),n[1]=t,_stringify$2.apply($JSON$3,n)}}}),$Symbol$2[PROTOTYPE$4][TO_PRIMITIVE$2]||_hide$3($Symbol$2[PROTOTYPE$4],TO_PRIMITIVE$2,$Symbol$2[PROTOTYPE$4].valueOf),_setToStringTag$3($Symbol$2,"Symbol"),_setToStringTag$3(Math,"Math",!0),_setToStringTag$3(_global$3.JSON,"JSON",!0),_export$3(_export$3.S,"Object",{create:_objectCreate$3}),_export$3(_export$3.S+_export$3.F*!_descriptors$3,"Object",{defineProperty:_objectDp$3.f}),_export$3(_export$3.S+_export$3.F*!_descriptors$3,"Object",{defineProperties:_objectDps$3});var _objectSap$3=function(e,t){var r=(_core$3.Object||{})[e]||Object[e],n={};n[e]=t(r),_export$3(_export$3.S+_export$3.F*_fails$3(function(){r(1)}),"Object",n)},$getOwnPropertyDescriptor$4=_objectGopd$3.f;_objectSap$3("getOwnPropertyDescriptor",function(){return function(e,t){return $getOwnPropertyDescriptor$4(_toIobject$3(e),t)}});var _toObject$3=function(e){return Object(_defined$3(e))},IE_PROTO$6=_sharedKey$3("IE_PROTO"),ObjectProto$4=Object.prototype,_objectGpo$3=Object.getPrototypeOf||function(e){return e=_toObject$3(e),_has$3(e,IE_PROTO$6)?e[IE_PROTO$6]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?ObjectProto$4:null};_objectSap$3("getPrototypeOf",function(){return function(e){return _objectGpo$3(_toObject$3(e))}}),_objectSap$3("keys",function(){return function(e){return _objectKeys$3(_toObject$3(e))}}),_objectSap$3("getOwnPropertyNames",function(){return _objectGopnExt$3.f});var meta$1=_meta$3.onFreeze;_objectSap$3("freeze",function(e){return function(t){return e&&_isObject$3(t)?e(meta$1(t)):t}});var meta$2=_meta$3.onFreeze;_objectSap$3("seal",function(e){return function(t){return e&&_isObject$3(t)?e(meta$2(t)):t}});var meta$3=_meta$3.onFreeze;_objectSap$3("preventExtensions",function(e){return function(t){return e&&_isObject$3(t)?e(meta$3(t)):t}}),_objectSap$3("isFrozen",function(e){return function(t){return!_isObject$3(t)||!!e&&e(t)}}),_objectSap$3("isSealed",function(e){return function(t){return!_isObject$3(t)||!!e&&e(t)}}),_objectSap$3("isExtensible",function(e){return function(t){return!!_isObject$3(t)&&(!e||e(t))}});var $assign$1=Object.assign,_objectAssign$2=!$assign$1||_fails$3(function(){var e={},t={},r=Symbol(),n="abcdefghijklmnopqrst";return e[r]=7,n.split("").forEach(function(e){t[e]=e}),7!=$assign$1({},e)[r]||Object.keys($assign$1({},t)).join("")!=n})?function(e,t){for(var r=_toObject$3(e),n=arguments.length,i=1,o=_objectGops$3.f,a=_objectPie$3.f;n>i;)for(var s,u=_iobject$3(arguments[i++]),c=o?_objectKeys$3(u).concat(o(u)):_objectKeys$3(u),l=c.length,f=0;l>f;)a.call(u,s=c[f++])&&(r[s]=u[s]);return r}:$assign$1;_export$3(_export$3.S+_export$3.F,"Object",{assign:_objectAssign$2});var _sameValue=Object.is||function(e,t){return e===t?0!==e||1/e==1/t:e!=e&&t!=t};_export$3(_export$3.S,"Object",{is:_sameValue});var check$2=function(e,t){if(_anObject$3(e),!_isObject$3(t)&&null!==t)throw TypeError(t+": can't set as prototype!")},_setProto$3={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=_ctx$3(Function.call,_objectGopd$3.f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(e){t=!0}return function(e,n){return check$2(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):undefined),check:check$2};_export$3(_export$3.S,"Object",{setPrototypeOf:_setProto$3.set});var TAG$4=_wks$3("toStringTag"),ARG$2="Arguments"==_cof$3(function(){return arguments}()),tryGet$2=function(e,t){try{return e[t]}catch(e){}},_classof$3=function(e){var t,r,n;return e===undefined?"Undefined":null===e?"Null":"string"==typeof(r=tryGet$2(t=Object(e),TAG$4))?r:ARG$2?_cof$3(t):"Object"==(n=_cof$3(t))&&"function"==typeof t.callee?"Arguments":n},test={};test[_wks$3("toStringTag")]="z",test+""!="[object z]"&&_redefine$3(Object.prototype,"toString",function(){return"[object "+_classof$3(this)+"]"},!0);var _invoke$2=function(e,t,r){var n=r===undefined;switch(t.length){case 0:return n?e():e.call(r);case 1:return n?e(t[0]):e.call(r,t[0]);case 2:return n?e(t[0],t[1]):e.call(r,t[0],t[1]);case 3:return n?e(t[0],t[1],t[2]):e.call(r,t[0],t[1],t[2]);case 4:return n?e(t[0],t[1],t[2],t[3]):e.call(r,t[0],t[1],t[2],t[3])}return e.apply(r,t)},arraySlice=[].slice,factories={},construct=function(e,t,r){if(!(t in factories)){for(var n=[],i=0;i<t;i++)n[i]="a["+i+"]";factories[t]=Function("F,a","return new F("+n.join(",")+")")}return factories[t](e,r)},_bind=Function.bind||function(e){var t=_aFunction$3(this),r=arraySlice.call(arguments,1),n=function(){var i=r.concat(arraySlice.call(arguments));return this instanceof n?construct(t,i.length,i):_invoke$2(t,i,e)};return _isObject$3(t.prototype)&&(n.prototype=t.prototype),n};_export$3(_export$3.P,"Function",{bind:_bind});var dP$7=_objectDp$3.f,FProto=Function.prototype,nameRE=/^\s*function ([^ (]*)/,NAME$2="name";NAME$2 in FProto||_descriptors$3&&dP$7(FProto,NAME$2,{configurable:!0,get:function(){try{return(""+this).match(nameRE)[1]}catch(e){return""}}});var HAS_INSTANCE=_wks$3("hasInstance"),FunctionProto=Function.prototype;HAS_INSTANCE in FunctionProto||_objectDp$3.f(FunctionProto,HAS_INSTANCE,{value:function(e){if("function"!=typeof this||!_isObject$3(e))return!1;if(!_isObject$3(this.prototype))return e instanceof this;for(;e=_objectGpo$3(e);)if(this.prototype===e)return!0;return!1}});var _stringWs$3="\t\n\x0B\f\r \xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff",space$2="["+_stringWs$3+"]",non$2="\u200b\x85",ltrim$2=RegExp("^"+space$2+space$2+"*"),rtrim$2=RegExp(space$2+space$2+"*$"),exporter$2=function(e,t,r){var n={},i=_fails$3(function(){return!!_stringWs$3[e]()||non$2[e]()!=non$2}),o=n[e]=i?t(trim$2):_stringWs$3[e];r&&(n[r]=o),_export$3(_export$3.P+_export$3.F*i,"String",n)},trim$2=exporter$2.trim=function(e,t){return e=String(_defined$3(e)),1&t&&(e=e.replace(ltrim$2,"")),2&t&&(e=e.replace(rtrim$2,"")),e},_stringTrim$3=exporter$2,$parseInt=_global$3.parseInt,$trim$2=_stringTrim$3.trim,hex=/^[-+]?0[xX]/,_parseInt=8!==$parseInt(_stringWs$3+"08")||22!==$parseInt(_stringWs$3+"0x16")?function(e,t){var r=$trim$2(String(e),3);return $parseInt(r,t>>>0||(hex.test(r)?16:10))}:$parseInt;_export$3(_export$3.G+_export$3.F*(parseInt!=_parseInt),{parseInt:_parseInt});var $parseFloat$3=_global$3.parseFloat,$trim$3=_stringTrim$3.trim,_parseFloat$6=1/$parseFloat$3(_stringWs$3+"-0")!=-Infinity?function(e){var t=$trim$3(String(e),3),r=$parseFloat$3(t);return 0===r&&"-"==t.charAt(0)?-0:r}:$parseFloat$3;_export$3(_export$3.G+_export$3.F*(parseFloat!=_parseFloat$6),{parseFloat:_parseFloat$6});var setPrototypeOf$5=_setProto$3.set,_inheritIfRequired=function(e,t,r){var n,i=t.constructor;return i!==r&&"function"==typeof i&&(n=i.prototype)!==r.prototype&&_isObject$3(n)&&setPrototypeOf$5&&setPrototypeOf$5(e,n),e},gOPN$7=_objectGopn$3.f,gOPD$6=_objectGopd$3.f,dP$8=_objectDp$3.f,$trim$4=_stringTrim$3.trim,NUMBER="Number",$Number=_global$3[NUMBER],Base$1=$Number,proto$2=$Number.prototype,BROKEN_COF=_cof$3(_objectCreate$3(proto$2))==NUMBER,TRIM="trim"in String.prototype,toNumber=function(e){var t=_toPrimitive$3(e,!1);if("string"==typeof t&&t.length>2){t=TRIM?t.trim():$trim$4(t,3);var r,n,i,o=t.charCodeAt(0);if(43===o||45===o){if(88===(r=t.charCodeAt(2))||120===r)return NaN}else if(48===o){switch(t.charCodeAt(1)){case 66:case 98:n=2,i=49;break;case 79:case 111:n=8,i=55;break;default:return+t}for(var a,s=t.slice(2),u=0,c=s.length;u<c;u++)if((a=s.charCodeAt(u))<48||a>i)return NaN;return parseInt(s,n)}}return+t};if(!$Number(" 0o1")||!$Number("0b1")||$Number("+0x1")){$Number=function(e){var t=arguments.length<1?0:e,r=this
;return r instanceof $Number&&(BROKEN_COF?_fails$3(function(){proto$2.valueOf.call(r)}):_cof$3(r)!=NUMBER)?_inheritIfRequired(new Base$1(toNumber(t)),r,$Number):toNumber(t)};for(var keys$4=_descriptors$3?gOPN$7(Base$1):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),j$3=0,key;keys$4.length>j$3;j$3++)_has$3(Base$1,key=keys$4[j$3])&&!_has$3($Number,key)&&dP$8($Number,key,gOPD$6(Base$1,key));$Number.prototype=proto$2,proto$2.constructor=$Number,_redefine$3(_global$3,NUMBER,$Number)}var _aNumberValue=function(e,t){if("number"!=typeof e&&"Number"!=_cof$3(e))throw TypeError(t);return+e},_stringRepeat=function(e){var t=String(_defined$3(this)),r="",n=_toInteger$3(e);if(n<0||n==Infinity)throw RangeError("Count can't be negative");for(;n>0;(n>>>=1)&&(t+=t))1&n&&(r+=t);return r},$toFixed=1..toFixed,floor$4=Math.floor,data=[0,0,0,0,0,0],ERROR="Number.toFixed: incorrect invocation!",ZERO="0",multiply=function(e,t){for(var r=-1,n=t;++r<6;)n+=e*data[r],data[r]=n%1e7,n=floor$4(n/1e7)},divide=function(e){for(var t=6,r=0;--t>=0;)r+=data[t],data[t]=floor$4(r/e),r=r%e*1e7},numToString=function(){for(var e=6,t="";--e>=0;)if(""!==t||0===e||0!==data[e]){var r=String(data[e]);t=""===t?r:t+_stringRepeat.call(ZERO,7-r.length)+r}return t},pow=function(e,t,r){return 0===t?r:t%2==1?pow(e,t-1,r*e):pow(e*e,t/2,r)},log=function(e){for(var t=0,r=e;r>=4096;)t+=12,r/=4096;for(;r>=2;)t+=1,r/=2;return t};_export$3(_export$3.P+_export$3.F*(!!$toFixed&&("0.000"!==8e-5.toFixed(3)||"1"!==.9.toFixed(0)||"1.25"!==1.255.toFixed(2)||"1000000000000000128"!==(0xde0b6b3a7640080).toFixed(0))||!_fails$3(function(){$toFixed.call({})})),"Number",{toFixed:function(e){var t,r,n,i,o=_aNumberValue(this,ERROR),a=_toInteger$3(e),s="",u=ZERO;if(a<0||a>20)throw RangeError(ERROR);if(o!=o)return"NaN";if(o<=-1e21||o>=1e21)return String(o);if(o<0&&(s="-",o=-o),o>1e-21)if(t=log(o*pow(2,69,1))-69,r=t<0?o*pow(2,-t,1):o/pow(2,t,1),r*=4503599627370496,(t=52-t)>0){for(multiply(0,r),n=a;n>=7;)multiply(1e7,0),n-=7;for(multiply(pow(10,n,1),0),n=t-1;n>=23;)divide(1<<23),n-=23;divide(1<<n),multiply(1,1),divide(2),u=numToString()}else multiply(0,r),multiply(1<<-t,0),u=numToString()+_stringRepeat.call(ZERO,a);return a>0?(i=u.length,u=s+(i<=a?"0."+_stringRepeat.call(ZERO,a-i)+u:u.slice(0,i-a)+"."+u.slice(i-a))):u=s+u,u}});var $toPrecision=1..toPrecision;_export$3(_export$3.P+_export$3.F*(_fails$3(function(){return"1"!==$toPrecision.call(1,undefined)})||!_fails$3(function(){$toPrecision.call({})})),"Number",{toPrecision:function(e){var t=_aNumberValue(this,"Number#toPrecision: incorrect invocation!");return e===undefined?$toPrecision.call(t):$toPrecision.call(t,e)}}),_export$3(_export$3.S,"Number",{EPSILON:Math.pow(2,-52)});var _isFinite=_global$3.isFinite;_export$3(_export$3.S,"Number",{isFinite:function(e){return"number"==typeof e&&_isFinite(e)}});var floor$5=Math.floor,_isInteger$3=function(e){return!_isObject$3(e)&&isFinite(e)&&floor$5(e)===e};_export$3(_export$3.S,"Number",{isInteger:_isInteger$3}),_export$3(_export$3.S,"Number",{isNaN:function(e){return e!=e}});var abs=Math.abs;_export$3(_export$3.S,"Number",{isSafeInteger:function(e){return _isInteger$3(e)&&abs(e)<=9007199254740991}}),_export$3(_export$3.S,"Number",{MAX_SAFE_INTEGER:9007199254740991}),_export$3(_export$3.S,"Number",{MIN_SAFE_INTEGER:-9007199254740991}),_export$3(_export$3.S+_export$3.F*(Number.parseFloat!=_parseFloat$6),"Number",{parseFloat:_parseFloat$6}),_export$3(_export$3.S+_export$3.F*(Number.parseInt!=_parseInt),"Number",{parseInt:_parseInt});var _mathLog1p=Math.log1p||function(e){return(e=+e)>-1e-8&&e<1e-8?e-e*e/2:Math.log(1+e)},sqrt=Math.sqrt,$acosh=Math.acosh;_export$3(_export$3.S+_export$3.F*!($acosh&&710==Math.floor($acosh(Number.MAX_VALUE))&&$acosh(Infinity)==Infinity),"Math",{acosh:function(e){return(e=+e)<1?NaN:e>94906265.62425156?Math.log(e)+Math.LN2:_mathLog1p(e-1+sqrt(e-1)*sqrt(e+1))}});var $asinh=Math.asinh;_export$3(_export$3.S+_export$3.F*!($asinh&&1/$asinh(0)>0),"Math",{asinh:asinh});var $atanh=Math.atanh;_export$3(_export$3.S+_export$3.F*!($atanh&&1/$atanh(-0)<0),"Math",{atanh:function(e){return 0==(e=+e)?e:Math.log((1+e)/(1-e))/2}});var _mathSign=Math.sign||function(e){return 0==(e=+e)||e!=e?e:e<0?-1:1};_export$3(_export$3.S,"Math",{cbrt:function(e){return _mathSign(e=+e)*Math.pow(Math.abs(e),1/3)}}),_export$3(_export$3.S,"Math",{clz32:function(e){return(e>>>=0)?31-Math.floor(Math.log(e+.5)*Math.LOG2E):32}});var exp=Math.exp;_export$3(_export$3.S,"Math",{cosh:function(e){return(exp(e=+e)+exp(-e))/2}});var $expm1=Math.expm1,_mathExpm1=!$expm1||$expm1(10)>22025.465794806718||$expm1(10)<22025.465794806718||-2e-17!=$expm1(-2e-17)?function(e){return 0==(e=+e)?e:e>-1e-6&&e<1e-6?e+e*e/2:Math.exp(e)-1}:$expm1;_export$3(_export$3.S+_export$3.F*(_mathExpm1!=Math.expm1),"Math",{expm1:_mathExpm1});var pow$1=Math.pow,EPSILON=pow$1(2,-52),EPSILON32=pow$1(2,-23),MAX32=pow$1(2,127)*(2-EPSILON32),MIN32=pow$1(2,-126),roundTiesToEven=function(e){return e+1/EPSILON-1/EPSILON},_mathFround=Math.fround||function(e){var t,r,n=Math.abs(e),i=_mathSign(e);return n<MIN32?i*roundTiesToEven(n/MIN32/EPSILON32)*MIN32*EPSILON32:(t=(1+EPSILON32/EPSILON)*n,r=t-(t-n),r>MAX32||r!=r?i*Infinity:i*r)};_export$3(_export$3.S,"Math",{fround:_mathFround});var abs$1=Math.abs;_export$3(_export$3.S,"Math",{hypot:function(e,t){for(var r,n,i=0,o=0,a=arguments.length,s=0;o<a;)r=abs$1(arguments[o++]),s<r?(n=s/r,i=i*n*n+1,s=r):r>0?(n=r/s,i+=n*n):i+=r;return s===Infinity?Infinity:s*Math.sqrt(i)}});var $imul=Math.imul;_export$3(_export$3.S+_export$3.F*_fails$3(function(){return-5!=$imul(4294967295,5)||2!=$imul.length}),"Math",{imul:function(e,t){var r=+e,n=+t,i=65535&r,o=65535&n;return 0|i*o+((65535&r>>>16)*o+i*(65535&n>>>16)<<16>>>0)}}),_export$3(_export$3.S,"Math",{log10:function(e){return Math.log(e)*Math.LOG10E}}),_export$3(_export$3.S,"Math",{log1p:_mathLog1p}),_export$3(_export$3.S,"Math",{log2:function(e){return Math.log(e)/Math.LN2}}),_export$3(_export$3.S,"Math",{sign:_mathSign});var exp$1=Math.exp;_export$3(_export$3.S+_export$3.F*_fails$3(function(){return-2e-17!=!Math.sinh(-2e-17)}),"Math",{sinh:function(e){return Math.abs(e=+e)<1?(_mathExpm1(e)-_mathExpm1(-e))/2:(exp$1(e-1)-exp$1(-e-1))*(Math.E/2)}});var exp$2=Math.exp;_export$3(_export$3.S,"Math",{tanh:function(e){var t=_mathExpm1(e=+e),r=_mathExpm1(-e);return t==Infinity?1:r==Infinity?-1:(t-r)/(exp$2(e)+exp$2(-e))}}),_export$3(_export$3.S,"Math",{trunc:function(e){return(e>0?Math.floor:Math.ceil)(e)}});var fromCharCode=String.fromCharCode,$fromCodePoint=String.fromCodePoint;_export$3(_export$3.S+_export$3.F*(!!$fromCodePoint&&1!=$fromCodePoint.length),"String",{fromCodePoint:function(e){for(var t,r=[],n=arguments.length,i=0;n>i;){if(t=+arguments[i++],_toAbsoluteIndex$3(t,1114111)!==t)throw RangeError(t+" is not a valid code point");r.push(t<65536?fromCharCode(t):fromCharCode(55296+((t-=65536)>>10),t%1024+56320))}return r.join("")}}),_export$3(_export$3.S,"String",{raw:function(e){for(var t=_toIobject$3(e.raw),r=_toLength$3(t.length),n=arguments.length,i=[],o=0;r>o;)i.push(String(t[o++])),o<n&&i.push(String(arguments[o]));return i.join("")}}),_stringTrim$3("trim",function(e){return function(){return e(this,3)}});var _stringAt$3=function(e){return function(t,r){var n,i,o=String(_defined$3(t)),a=_toInteger$3(r),s=o.length;return a<0||a>=s?e?"":undefined:(n=o.charCodeAt(a),n<55296||n>56319||a+1===s||(i=o.charCodeAt(a+1))<56320||i>57343?e?o.charAt(a):n:e?o.slice(a,a+2):i-56320+(n-55296<<10)+65536)}},_iterators$3={},IteratorPrototype$2={};_hide$3(IteratorPrototype$2,_wks$3("iterator"),function(){return this});var _iterCreate$3=function(e,t,r){e.prototype=_objectCreate$3(IteratorPrototype$2,{next:_propertyDesc$3(1,r)}),_setToStringTag$3(e,t+" Iterator")},ITERATOR$6=_wks$3("iterator"),BUGGY$2=!([].keys&&"next"in[].keys()),FF_ITERATOR$2="@@iterator",KEYS$2="keys",VALUES$2="values",returnThis$2=function(){return this},_iterDefine$3=function(e,t,r,n,i,o,a){_iterCreate$3(r,t,n);var s,u,c,l=function(e){if(!BUGGY$2&&e in p)return p[e];switch(e){case KEYS$2:case VALUES$2:return function(){return new r(this,e)}}return function(){return new r(this,e)}},f=t+" Iterator",d=i==VALUES$2,h=!1,p=e.prototype,y=p[ITERATOR$6]||p[FF_ITERATOR$2]||i&&p[i],g=y||l(i),m=i?d?l("entries"):g:undefined,_="Array"==t?p.entries||y:y;if(_&&(c=_objectGpo$3(_.call(new e)))!==Object.prototype&&c.next&&(_setToStringTag$3(c,f,!0),_library$3||_has$3(c,ITERATOR$6)||_hide$3(c,ITERATOR$6,returnThis$2)),d&&y&&y.name!==VALUES$2&&(h=!0,g=function(){return y.call(this)}),_library$3&&!a||!BUGGY$2&&!h&&p[ITERATOR$6]||_hide$3(p,ITERATOR$6,g),_iterators$3[t]=g,_iterators$3[f]=returnThis$2,i)if(s={values:d?g:l(VALUES$2),keys:o?g:l(KEYS$2),entries:m},a)for(u in s)u in p||_redefine$3(p,u,s[u]);else _export$3(_export$3.P+_export$3.F*(BUGGY$2||h),t,s);return s},$at$2=_stringAt$3(!0);_iterDefine$3(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:undefined,done:!0}:(e=$at$2(t,r),this._i+=e.length,{value:e,done:!1})});var $at$3=_stringAt$3(!1);_export$3(_export$3.P,"String",{codePointAt:function(e){return $at$3(this,e)}});var MATCH=_wks$3("match"),_isRegexp=function(e){var t;return _isObject$3(e)&&((t=e[MATCH])!==undefined?!!t:"RegExp"==_cof$3(e))},_stringContext=function(e,t,r){if(_isRegexp(t))throw TypeError("String#"+r+" doesn't accept regex!");return String(_defined$3(e))},MATCH$1=_wks$3("match"),_failsIsRegexp=function(e){var t=/./;try{"/./"[e](t)}catch(e){try{return t[MATCH$1]=!1,!"/./"[e](t)}catch(f){}}return!0},ENDS_WITH="endsWith",$endsWith=""[ENDS_WITH];_export$3(_export$3.P+_export$3.F*_failsIsRegexp(ENDS_WITH),"String",{endsWith:function(e){var t=_stringContext(this,e,ENDS_WITH),r=arguments.length>1?arguments[1]:undefined,n=_toLength$3(t.length),i=r===undefined?n:Math.min(_toLength$3(r),n),o=String(e);return $endsWith?$endsWith.call(t,o,i):t.slice(i-o.length,i)===o}});var INCLUDES="includes";_export$3(_export$3.P+_export$3.F*_failsIsRegexp(INCLUDES),"String",{includes:function(e){return!!~_stringContext(this,e,INCLUDES).indexOf(e,arguments.length>1?arguments[1]:undefined)}}),_export$3(_export$3.P,"String",{repeat:_stringRepeat});var STARTS_WITH="startsWith",$startsWith=""[STARTS_WITH];_export$3(_export$3.P+_export$3.F*_failsIsRegexp(STARTS_WITH),"String",{startsWith:function(e){var t=_stringContext(this,e,STARTS_WITH),r=_toLength$3(Math.min(arguments.length>1?arguments[1]:undefined,t.length)),n=String(e);return $startsWith?$startsWith.call(t,n,r):t.slice(r,r+n.length)===n}});var quot=/"/g,createHTML=function(e,t,r,n){var i=String(_defined$3(e)),o="<"+t;return""!==r&&(o+=" "+r+'="'+String(n).replace(quot,"&quot;")+'"'),o+">"+i+"</"+t+">"},_stringHtml=function(e,t){var r={};r[e]=t(createHTML),_export$3(_export$3.P+_export$3.F*_fails$3(function(){var t=""[e]('"');return t!==t.toLowerCase()||t.split('"').length>3}),"String",r)};_stringHtml("anchor",function(e){return function(t){return e(this,"a","name",t)}}),_stringHtml("big",function(e){return function(){return e(this,"big","","")}}),_stringHtml("blink",function(e){return function(){return e(this,"blink","","")}}),_stringHtml("bold",function(e){return function(){return e(this,"b","","")}}),_stringHtml("fixed",function(e){return function(){return e(this,"tt","","")}}),_stringHtml("fontcolor",function(e){return function(t){return e(this,"font","color",t)}}),_stringHtml("fontsize",function(e){return function(t){return e(this,"font","size",t)}}),_stringHtml("italics",function(e){return function(){return e(this,"i","","")}}),_stringHtml("link",function(e){return function(t){return e(this,"a","href",t)}}),_stringHtml("small",function(e){return function(){return e(this,"small","","")}}),_stringHtml("strike",function(e){return function(){return e(this,"strike","","")}}),_stringHtml("sub",function(e){return function(){return e(this,"sub","","")}}),_stringHtml("sup",function(e){return function(){return e(this,"sup","","")}}),_export$3(_export$3.S,"Date",{now:function(){return(new Date).getTime()}}),_export$3(_export$3.P+_export$3.F*_fails$3(function(){return null!==new Date(NaN).toJSON()||1!==Date.prototype.toJSON.call({toISOString:function(){return 1}})}),"Date",{toJSON:function(e){var t=_toObject$3(this),r=_toPrimitive$3(t);return"number"!=typeof r||isFinite(r)?t.toISOString():null}});var getTime=Date.prototype.getTime,$toISOString=Date.prototype.toISOString,lz=function(e){return e>9?e:"0"+e},_dateToIsoString=_fails$3(function(){return"0385-07-25T07:06:39.999Z"!=$toISOString.call(new Date(-5e13-1))})||!_fails$3(function(){$toISOString.call(new Date(NaN))})?function(){if(!isFinite(getTime.call(this)))throw RangeError("Invalid time value");var e=this,t=e.getUTCFullYear(),r=e.getUTCMilliseconds(),n=t<0?"-":t>9999?"+":"";return n+("00000"+Math.abs(t)).slice(n?-6:-4)+"-"+lz(e.getUTCMonth()+1)+"-"+lz(e.getUTCDate())+"T"+lz(e.getUTCHours())+":"+lz(e.getUTCMinutes())+":"+lz(e.getUTCSeconds())+"."+(r>99?r:"0"+lz(r))+"Z"}:$toISOString;_export$3(_export$3.P+_export$3.F*(Date.prototype.toISOString!==_dateToIsoString),"Date",{toISOString:_dateToIsoString});var DateProto=Date.prototype,INVALID_DATE="Invalid Date",TO_STRING="toString",$toString=DateProto[TO_STRING],getTime$1=DateProto.getTime;new Date(NaN)+""!=INVALID_DATE&&_redefine$3(DateProto,TO_STRING,function(){var e=getTime$1.call(this);return e===e?$toString.call(this):INVALID_DATE});var NUMBER$1="number",_dateToPrimitive=function(e){if("string"!==e&&e!==NUMBER$1&&"default"!==e)throw TypeError("Incorrect hint");return _toPrimitive$3(_anObject$3(this),e!=NUMBER$1)},TO_PRIMITIVE$3=_wks$3("toPrimitive"),proto$3=Date.prototype;TO_PRIMITIVE$3 in proto$3||_hide$3(proto$3,TO_PRIMITIVE$3,_dateToPrimitive),_export$3(_export$3.S,"Array",{isArray:_isArray$3});var _iterCall$3=function(t,r,n,i){try{return i?r(_anObject$3(n)[0],n[1]):r(n)}catch(e){var o=t["return"];throw o!==undefined&&_anObject$3(o.call(t)),e}},ITERATOR$7=_wks$3("iterator"),ArrayProto$2=Array.prototype,_isArrayIter$3=function(e){return e!==undefined&&(_iterators$3.Array===e||ArrayProto$2[ITERATOR$7]===e)},_createProperty$3=function(e,t,r){t in e?_objectDp$3.f(e,t,_propertyDesc$3(0,r)):e[t]=r},ITERATOR$8=_wks$3("iterator"),core_getIteratorMethod$3=_core$3.getIteratorMethod=function(e){if(e!=undefined)return e[ITERATOR$8]||e["@@iterator"]||_iterators$3[_classof$3(e)]},ITERATOR$9=_wks$3("iterator"),SAFE_CLOSING$2=!1;try{var riter$2=[7][ITERATOR$9]();riter$2["return"]=function(){SAFE_CLOSING$2=!0}}catch(e){}var _iterDetect$3=function(e,t){if(!t&&!SAFE_CLOSING$2)return!1;var r=!1;try{var n=[7],i=n[ITERATOR$9]();i.next=function(){return{done:r=!0}},n[ITERATOR$9]=function(){return i},e(n)}catch(e){}return r};_export$3(_export$3.S+_export$3.F*!_iterDetect$3(function(e){}),"Array",{from:function(e){var t,r,n,i,o=_toObject$3(e),a="function"==typeof this?this:Array,s=arguments.length,u=s>1?arguments[1]:undefined,c=u!==undefined,l=0,f=core_getIteratorMethod$3(o);if(c&&(u=_ctx$3(u,s>2?arguments[2]:undefined,2)),f==undefined||a==Array&&_isArrayIter$3(f))for(t=_toLength$3(o.length),r=new a(t);t>l;l++)_createProperty$3(r,l,c?u(o[l],l):o[l]);else for(i=f.call(o),r=new a;!(n=i.next()).done;l++)_createProperty$3(r,l,c?_iterCall$3(i,u,[n.value,l],!0):n.value);return r.length=l,r}}),_export$3(_export$3.S+_export$3.F*_fails$3(function(){function e(){}return!(Array.of.call(e)instanceof e)}),"Array",{of:function(){for(var e=0,t=arguments.length,r=new("function"==typeof this?this:Array)(t);t>e;)_createProperty$3(r,e,arguments[e++]);return r.length=t,r}});var _strictMethod=function(e,t){return!!e&&_fails$3(function(){t?e.call(null,function(){},1):e.call(null)})},arrayJoin=[].join;_export$3(_export$3.P+_export$3.F*(_iobject$3!=Object||!_strictMethod(arrayJoin)),"Array",{join:function(e){return arrayJoin.call(_toIobject$3(this),e===undefined?",":e)}});var arraySlice$1=[].slice;_export$3(_export$3.P+_export$3.F*_fails$3(function(){_html$3&&arraySlice$1.call(_html$3)}),"Array",{slice:function(e,t){var r=_toLength$3(this.length),n=_cof$3(this);if(t=t===undefined?r:t,"Array"==n)return arraySlice$1.call(this,e,t);for(var i=_toAbsoluteIndex$3(e,r),o=_toAbsoluteIndex$3(t,r),a=_toLength$3(o-i),s=Array(a),u=0;u<a;u++)s[u]="String"==n?this.charAt(i+u):this[i+u];return s}});var $sort=[].sort,test$1=[1,2,3];_export$3(_export$3.P+_export$3.F*(_fails$3(function(){test$1.sort(undefined)})||!_fails$3(function(){test$1.sort(null)})||!_strictMethod($sort)),"Array",{sort:function(e){return e===undefined?$sort.call(_toObject$3(this)):$sort.call(_toObject$3(this),_aFunction$3(e))}});var SPECIES$3=_wks$3("species"),_arraySpeciesConstructor$2=function(e){var t;return _isArray$3(e)&&(t=e.constructor,"function"!=typeof t||t!==Array&&!_isArray$3(t.prototype)||(t=undefined),_isObject$3(t)&&null===(t=t[SPECIES$3])&&(t=undefined)),t===undefined?Array:t},_arraySpeciesCreate$2=function(e,t){return new(_arraySpeciesConstructor$2(e))(t)},_arrayMethods$2=function(e,t){var r=1==e,n=2==e,i=3==e,o=4==e,a=6==e,s=5==e||a,u=t||_arraySpeciesCreate$2;return function(t,c,l){for(var f,d,h=_toObject$3(t),p=_iobject$3(h),y=_ctx$3(c,l,3),g=_toLength$3(p.length),m=0,_=r?u(t,g):n?u(t,0):undefined;g>m;m++)if((s||m in p)&&(f=p[m],d=y(f,m,h),e))if(r)_[m]=d;else if(d)switch(e){case 3:return!0;case 5:return f;case 6:return m;case 2:_.push(f)}else if(o)return!1;return a?-1:i||o?o:_}},$forEach=_arrayMethods$2(0),STRICT=_strictMethod([].forEach,!0);_export$3(_export$3.P+_export$3.F*!STRICT,"Array",{forEach:function(e){return $forEach(this,e,arguments[1])}});var $map=_arrayMethods$2(1);_export$3(_export$3.P+_export$3.F*!_strictMethod([].map,!0),"Array",{map:function(e){return $map(this,e,arguments[1])}});var $filter=_arrayMethods$2(2);_export$3(_export$3.P+_export$3.F*!_strictMethod([].filter,!0),"Array",{filter:function(e){return $filter(this,e,arguments[1])}});var $some=_arrayMethods$2(3);_export$3(_export$3.P+_export$3.F*!_strictMethod([].some,!0),"Array",{some:function(e){return $some(this,e,arguments[1])}});var $every=_arrayMethods$2(4);_export$3(_export$3.P+_export$3.F*!_strictMethod([].every,!0),"Array",{every:function(e){return $every(this,e,arguments[1])}});var _arrayReduce=function(e,t,r,n,i){_aFunction$3(t);var o=_toObject$3(e),a=_iobject$3(o),s=_toLength$3(o.length),u=i?s-1:0,c=i?-1:1;if(r<2)for(;;){if(u in a){n=a[u],u+=c;break}if(u+=c,i?u<0:s<=u)throw TypeError("Reduce of empty array with no initial value")}for(;i?u>=0:s>u;u+=c)u in a&&(n=t(n,a[u],u,o));return n};_export$3(_export$3.P+_export$3.F*!_strictMethod([].reduce,!0),"Array",{reduce:function(e){return _arrayReduce(this,e,arguments.length,arguments[1],!1)}}),_export$3(_export$3.P+_export$3.F*!_strictMethod([].reduceRight,!0),"Array",{reduceRight:function(e){return _arrayReduce(this,e,arguments.length,arguments[1],!0)}});var $indexOf=_arrayIncludes$3(!1),$native=[].indexOf,NEGATIVE_ZERO=!!$native&&1/[1].indexOf(1,-0)<0;_export$3(_export$3.P+_export$3.F*(NEGATIVE_ZERO||!_strictMethod($native)),"Array",{indexOf:function(e){return NEGATIVE_ZERO?$native.apply(this,arguments)||0:$indexOf(this,e,arguments[1])}});var $native$1=[].lastIndexOf,NEGATIVE_ZERO$1=!!$native$1&&1/[1].lastIndexOf(1,-0)<0;_export$3(_export$3.P+_export$3.F*(NEGATIVE_ZERO$1||!_strictMethod($native$1)),"Array",{lastIndexOf:function(e){if(NEGATIVE_ZERO$1)return $native$1.apply(this,arguments)||0;var t=_toIobject$3(this),r=_toLength$3(t.length),n=r-1;for(arguments.length>1&&(n=Math.min(n,_toInteger$3(arguments[1]))),n<0&&(n=r+n);n>=0;n--)if(n in t&&t[n]===e)return n||0;return-1}});var _arrayCopyWithin=[].copyWithin||function(e,t){var r=_toObject$3(this),n=_toLength$3(r.length),i=_toAbsoluteIndex$3(e,n),o=_toAbsoluteIndex$3(t,n),a=arguments.length>2?arguments[2]:undefined,s=Math.min((a===undefined?n:_toAbsoluteIndex$3(a,n))-o,n-i),u=1;for(o<i&&i<o+s&&(u=-1,o+=s-1,i+=s-1);s-- >0;)o in r?r[i]=r[o]:delete r[i],i+=u,o+=u;return r},UNSCOPABLES=_wks$3("unscopables"),ArrayProto$3=Array.prototype;ArrayProto$3[UNSCOPABLES]==undefined&&_hide$3(ArrayProto$3,UNSCOPABLES,{});var _addToUnscopables$2=function(e){ArrayProto$3[UNSCOPABLES][e]=!0};_export$3(_export$3.P,"Array",{copyWithin:_arrayCopyWithin}),_addToUnscopables$2("copyWithin");var _arrayFill=function(e){for(var t=_toObject$3(this),r=_toLength$3(t.length),n=arguments.length,i=_toAbsoluteIndex$3(n>1?arguments[1]:undefined,r),o=n>2?arguments[2]:undefined,a=o===undefined?r:_toAbsoluteIndex$3(o,r);a>i;)t[i++]=e;return t};_export$3(_export$3.P,"Array",{fill:_arrayFill}),_addToUnscopables$2("fill");var $find=_arrayMethods$2(5),KEY="find",forced=!0;KEY in[]&&Array(1)[KEY](function(){forced=!1}),_export$3(_export$3.P+_export$3.F*forced,"Array",{find:function(e){return $find(this,e,arguments.length>1?arguments[1]:undefined)}}),_addToUnscopables$2(KEY);var $find$1=_arrayMethods$2(6),KEY$1="findIndex",forced$1=!0;KEY$1 in[]&&Array(1)[KEY$1](function(){forced$1=!1}),_export$3(_export$3.P+_export$3.F*forced$1,"Array",{findIndex:function(e){return $find$1(this,e,arguments.length>1?arguments[1]:undefined)}}),_addToUnscopables$2(KEY$1);var SPECIES$4=_wks$3("species"),_setSpecies$2=function(e){var t=_global$3[e];_descriptors$3&&t&&!t[SPECIES$4]&&_objectDp$3.f(t,SPECIES$4,{configurable:!0,get:function(){return this}})};_setSpecies$2("Array");var _iterStep$3=function(e,t){return{value:t,done:!!e}},es6_array_iterator$3=_iterDefine$3(Array,"Array",function(e,t){this._t=_toIobject$3(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,r=this._i++;return!e||r>=e.length?(this._t=undefined,_iterStep$3(1)):"keys"==t?_iterStep$3(0,r):"values"==t?_iterStep$3(0,e[r]):_iterStep$3(0,[r,e[r]])},"values");_iterators$3.Arguments=_iterators$3.Array,_addToUnscopables$2("keys"),_addToUnscopables$2("values"),_addToUnscopables$2("entries");var _flags=function(){var e=_anObject$3(this),t="";return e.global&&(t+="g"),e.ignoreCase&&(t+="i"),e.multiline&&(t+="m"),e.unicode&&(t+="u"),e.sticky&&(t+="y"),t},dP$9=_objectDp$3.f,gOPN$8=_objectGopn$3.f,$RegExp=_global$3.RegExp,Base$2=$RegExp,proto$4=$RegExp.prototype,re1=/a/g,re2=/a/g,CORRECT_NEW=new $RegExp(re1)!==re1;if(_descriptors$3&&(!CORRECT_NEW||_fails$3(function(){return re2[_wks$3("match")]=!1,$RegExp(re1)!=re1||$RegExp(re2)==re2||"/a/i"!=$RegExp(re1,"i")}))){$RegExp=function(e,t){var r=this instanceof $RegExp,n=_isRegexp(e),i=t===undefined;return!r&&n&&e.constructor===$RegExp&&i?e:_inheritIfRequired(CORRECT_NEW?new Base$2(n&&!i?e.source:e,t):Base$2((n=e instanceof $RegExp)?e.source:e,n&&i?_flags.call(e):t),r?this:proto$4,$RegExp)};for(var proxy=(function(e){e in $RegExp||dP$9($RegExp,e,{configurable:!0,get:function(){return Base$2[e]},set:function(t){Base$2[e]=t}})}),keys$5=gOPN$8(Base$2),i$2=0;keys$5.length>i$2;)proxy(keys$5[i$2++]);proto$4.constructor=$RegExp,$RegExp.prototype=proto$4,_redefine$3(_global$3,"RegExp",$RegExp)}_setSpecies$2("RegExp"),_descriptors$3&&"g"!=/./g.flags&&_objectDp$3.f(RegExp.prototype,"flags",{configurable:!0,get:_flags});var TO_STRING$1="toString",$toString$1=/./[TO_STRING$1],define$1=function(e){_redefine$3(RegExp.prototype,TO_STRING$1,e,!0)};_fails$3(function(){return"/a/b"!=$toString$1.call({source:"a",flags:"b"})})?define$1(function(){var e=_anObject$3(this);return"/".concat(e.source,"/","flags"in e?e.flags:!_descriptors$3&&e instanceof RegExp?_flags.call(e):undefined)}):$toString$1.name!=TO_STRING$1&&define$1(function(){return $toString$1.call(this)});var _fixReWks=function(e,t,r){var n=_wks$3(e),i=r(_defined$3,n,""[e]),o=i[0],a=i[1];_fails$3(function(){var t={};return t[n]=function(){return 7},7!=""[e](t)})&&(_redefine$3(String.prototype,e,o),_hide$3(RegExp.prototype,n,2==t?function(e,t){return a.call(e,this,t)}:function(e){return a.call(e,this)}))};_fixReWks("match",1,function(e,t,r){return[function(r){var n=e(this),i=r==undefined?undefined:r[t];return i!==undefined?i.call(r,n):new RegExp(r)[t](String(n))},r]}),_fixReWks("replace",2,function(e,t,r){return[function(n,i){var o=e(this),a=n==undefined?undefined:n[t];return a!==undefined?a.call(n,o,i):r.call(String(o),n,i)},r]}),_fixReWks("search",1,function(e,t,r){return[function(r){var n=e(this),i=r==undefined?undefined:r[t];return i!==undefined?i.call(r,n):new RegExp(r)[t](String(n))},r]}),_fixReWks("split",2,function(e,t,r){var n=_isRegexp,i=r,o=[].push,a="length";if("c"=="abbc".split(/(b)*/)[1]||4!="test".split(/(?:)/,-1)[a]||2!="ab".split(/(?:ab)*/)[a]||4!=".".split(/(.?)(.?)/)[a]||".".split(/()()/)[a]>1||"".split(/.?/)[a]){var s=/()??/.exec("")[1]===undefined;r=function(e,t){var r=String(this);if(e===undefined&&0===t)return[];if(!n(e))return i.call(r,e,t);var u,c,l,f,d,h=[],p=(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.unicode?"u":"")+(e.sticky?"y":""),y=0,g=t===undefined?4294967295:t>>>0,m=new RegExp(e.source,p+"g");for(s||(u=new RegExp("^"+m.source+"$(?!\\s)",p));(c=m.exec(r))&&!((l=c.index+c[0][a])>y&&(h.push(r.slice(y,c.index)),!s&&c[a]>1&&c[0].replace(u,function(){for(d=1;d<arguments[a]-2;d++)arguments[d]===undefined&&(c[d]=undefined)}),c[a]>1&&c.index<r[a]&&o.apply(h,c.slice(1)),f=c[0][a],y=l,h[a]>=g));)m.lastIndex===c.index&&m.lastIndex++;return y===r[a]?!f&&m.test("")||h.push(""):h.push(r.slice(y)),h[a]>g?h.slice(0,g):h}}else"0".split(undefined,0)[a]&&(r=function(e,t){return e===undefined&&0===t?[]:i.call(this,e,t)});return[function(n,i){var o=e(this),a=n==undefined?undefined:n[t];return a!==undefined?a.call(n,o,i):r.call(String(o),n,i)},r]});var _anInstance$2=function(e,t,r,n){if(!(e instanceof t)||n!==undefined&&n in e)throw TypeError(r+": incorrect invocation!");return e},_forOf$2=createCommonjsModule(function(e){var t={},r={},n=e.exports=function(e,n,i,o,a){var s,u,c,l,f=a?function(){return e}:core_getIteratorMethod$3(e),d=_ctx$3(i,o,n?2:1),h=0;if("function"!=typeof f)throw TypeError(e+" is not iterable!");if(_isArrayIter$3(f)){for(s=_toLength$3(e.length);s>h;h++)if((l=n?d(_anObject$3(u=e[h])[0],u[1]):d(e[h]))===t||l===r)return l}else for(c=f.call(e);!(u=c.next()).done;)if((l=_iterCall$3(c,d,u.value,n))===t||l===r)return l};n.BREAK=t,n.RETURN=r}),SPECIES$5=_wks$3("species"),_speciesConstructor$2=function(e,t){var r,n=_anObject$3(e).constructor;return n===undefined||(r=_anObject$3(n)[SPECIES$5])==undefined?t:_aFunction$3(r)},process$4=_global$3.process,setTask$1=_global$3.setImmediate,clearTask$1=_global$3.clearImmediate,MessageChannel$1=_global$3.MessageChannel,Dispatch$1=_global$3.Dispatch,counter$1=0,queue$1={},ONREADYSTATECHANGE$1="onreadystatechange",defer$1,channel$1,port$1,run$1=function(){var e=+this;if(queue$1.hasOwnProperty(e)){var t=queue$1[e];delete queue$1[e],t()}},listener$1=function(e){run$1.call(e.data)};setTask$1&&clearTask$1||(setTask$1=function(e){for(var t=[],r=1;arguments.length>r;)t.push(arguments[r++]);return queue$1[++counter$1]=function(){_invoke$2("function"==typeof e?e:Function(e),t)},defer$1(counter$1),counter$1},clearTask$1=function(e){delete queue$1[e]},"process"==_cof$3(process$4)?defer$1=function(e){process$4.nextTick(_ctx$3(run$1,e,1))}:Dispatch$1&&Dispatch$1.now?defer$1=function(e){Dispatch$1.now(_ctx$3(run$1,e,1))}:MessageChannel$1?(channel$1=new MessageChannel$1,port$1=channel$1.port2,channel$1.port1.onmessage=listener$1,defer$1=_ctx$3(port$1.postMessage,port$1,1)):_global$3.addEventListener&&"function"==typeof postMessage&&!_global$3.importScripts?(defer$1=function(e){_global$3.postMessage(e+"","*")},_global$3.addEventListener("message",listener$1,!1)):defer$1=ONREADYSTATECHANGE$1 in _domCreate$3("script")?function(e){_html$3.appendChild(_domCreate$3("script"))[ONREADYSTATECHANGE$1]=function(){_html$3.removeChild(this),run$1.call(e)}}:function(e){setTimeout(_ctx$3(run$1,e,1),0)});var _task$2={set:setTask$1,clear:clearTask$1},macrotask$1=_task$2.set,Observer$1=_global$3.MutationObserver||_global$3.WebKitMutationObserver,process$5=_global$3.process,Promise$2=_global$3.Promise,isNode$4="process"==_cof$3(process$5),_microtask$2=function(){var t,r,n,i=function(){var i,o;for(isNode$4&&(i=process$5.domain)&&i.exit();t;){o=t.fn,t=t.next;try{o()}catch(e){throw t?n():r=undefined,e}}r=undefined,i&&i.enter()};if(isNode$4)n=function(){process$5.nextTick(i)};else if(Observer$1){var o=!0,a=document.createTextNode("");new Observer$1(i).observe(a,{characterData:!0}),n=function(){a.data=o=!o}}else if(Promise$2&&Promise$2.resolve){var s=Promise$2.resolve();n=function(){s.then(i)}}else n=function(){macrotask$1.call(_global$3,i)};return function(e){var i={fn:e,next:undefined};r&&(r.next=i),t||(t=i,n()),r=i}},f$16=function(e){return new PromiseCapability$1(e)},_newPromiseCapability$2={f:f$16},_perform$2=function(t){try{return{e:!1,v:t()}}catch(e){return{e:!0,v:e}}},_promiseResolve$2=function(e,t){if(_anObject$3(e),_isObject$3(t)&&t.constructor===e)return t;var r=_newPromiseCapability$2.f(e);return(0,r.resolve)(t),r.promise},_redefineAll$2=function(e,t,r){for(var n in t)_redefine$3(e,n,t[n],r);return e},task$1=_task$2.set,microtask$1=_microtask$2(),PROMISE$1="Promise",TypeError$2=_global$3.TypeError,process$3=_global$3.process,$Promise$1=_global$3[PROMISE$1],isNode$3="process"==_classof$3(process$3),empty$1=function(){},Internal$1,newGenericPromiseCapability$1,OwnPromiseCapability$1,Wrapper$1,newPromiseCapability$2=newGenericPromiseCapability$1=_newPromiseCapability$2.f,USE_NATIVE$4=!!function(){try{var e=$Promise$1.resolve(1),t=(e.constructor={})[_wks$3("species")]=function(e){e(empty$1,empty$1)};return(isNode$3||"function"==typeof PromiseRejectionEvent)&&e.then(empty$1)instanceof t}catch(e){}}(),isThenable$1=function(e){var t;return!(!_isObject$3(e)||"function"!=typeof(t=e.then))&&t},notify$1=function(t,r){if(!t._n){t._n=!0;var n=t._c;microtask$1(function(){for(var i=t._v,o=1==t._s,a=0;n.length>a;)!function(r){var n,a,s=o?r.ok:r.fail,u=r.resolve,c=r.reject,l=r.domain;try{s?(o||(2==t._h&&onHandleUnhandled$1(t),t._h=1),!0===s?n=i:(l&&l.enter(),n=s(i),l&&l.exit()),n===r.promise?c(TypeError$2("Promise-chain cycle")):(a=isThenable$1(n))?a.call(n,u,c):u(n)):c(i)}catch(e){c(e)}}(n[a++]);t._c=[],t._n=!1,r&&!t._h&&onUnhandled$1(t)})}},onUnhandled$1=function(e){task$1.call(_global$3,function(){var t,r,n,i=e._v,o=isUnhandled$1(e);if(o&&(t=_perform$2(function(){isNode$3?process$3.emit("unhandledRejection",i,e):(r=_global$3.onunhandledrejection)?r({promise:e,reason:i}):(n=_global$3.console)&&n.error&&n.error("Unhandled promise rejection",i)}),e._h=isNode$3||isUnhandled$1(e)?2:1),e._a=undefined,o&&t.e)throw t.v})},isUnhandled$1=function(e){if(1==e._h)return!1;for(var t,r=e._a||e._c,n=0;r.length>n;)if(t=r[n++],t.fail||!isUnhandled$1(t.promise))return!1;return!0},onHandleUnhandled$1=function(e){task$1.call(_global$3,function(){var t;isNode$3?process$3.emit("rejectionHandled",e):(t=_global$3.onrejectionhandled)&&t({promise:e,reason:e._v})})},$reject$1=function(e){var t=this;t._d||(t._d=!0,t=t._w||t,t._v=e,t._s=2,t._a||(t._a=t._c.slice()),notify$1(t,!0))},$resolve$1=function(t){var r,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw TypeError$2("Promise can't be resolved itself");(r=isThenable$1(t))?microtask$1(function(){var i={_w:n,_d:!1};try{r.call(t,_ctx$3($resolve$1,i,1),_ctx$3($reject$1,i,1))}catch(e){$reject$1.call(i,e)}}):(n._v=t,n._s=1,notify$1(n,!1))}catch(e){$reject$1.call({_w:n,_d:!1},e)}}};USE_NATIVE$4||($Promise$1=function(e){_anInstance$2(this,$Promise$1,PROMISE$1,"_h"),_aFunction$3(e),Internal$1.call(this);try{e(_ctx$3($resolve$1,this,1),_ctx$3($reject$1,this,1))}catch(t){$reject$1.call(this,t)}},Internal$1=function(e){this._c=[],this._a=undefined,this._s=0,this._d=!1,this._v=undefined,this._h=0,this._n=!1},Internal$1.prototype=_redefineAll$2($Promise$1.prototype,{then:function(e,t){var r=newPromiseCapability$2(_speciesConstructor$2(this,$Promise$1));return r.ok="function"!=typeof e||e,r.fail="function"==typeof t&&t,r.domain=isNode$3?process$3.domain:undefined,this._c.push(r),this._a&&this._a.push(r),this._s&&notify$1(this,!1),r.promise},"catch":function(e){return this.then(undefined,e)}}),OwnPromiseCapability$1=function(){
var e=new Internal$1;this.promise=e,this.resolve=_ctx$3($resolve$1,e,1),this.reject=_ctx$3($reject$1,e,1)},_newPromiseCapability$2.f=newPromiseCapability$2=function(e){return e===$Promise$1||e===Wrapper$1?new OwnPromiseCapability$1(e):newGenericPromiseCapability$1(e)}),_export$3(_export$3.G+_export$3.W+_export$3.F*!USE_NATIVE$4,{Promise:$Promise$1}),_setToStringTag$3($Promise$1,PROMISE$1),_setSpecies$2(PROMISE$1),Wrapper$1=_core$3[PROMISE$1],_export$3(_export$3.S+_export$3.F*!USE_NATIVE$4,PROMISE$1,{reject:function(e){var t=newPromiseCapability$2(this);return(0,t.reject)(e),t.promise}}),_export$3(_export$3.S+_export$3.F*(_library$3||!USE_NATIVE$4),PROMISE$1,{resolve:function(e){return _promiseResolve$2(_library$3&&this===Wrapper$1?$Promise$1:this,e)}}),_export$3(_export$3.S+_export$3.F*!(USE_NATIVE$4&&_iterDetect$3(function(e){$Promise$1.all(e)["catch"](empty$1)})),PROMISE$1,{all:function(e){var t=this,r=newPromiseCapability$2(t),n=r.resolve,i=r.reject,o=_perform$2(function(){var r=[],o=0,a=1;_forOf$2(e,!1,function(e){var s=o++,u=!1;r.push(undefined),a++,t.resolve(e).then(function(e){u||(u=!0,r[s]=e,--a||n(r))},i)}),--a||n(r)});return o.e&&i(o.v),r.promise},race:function(e){var t=this,r=newPromiseCapability$2(t),n=r.reject,i=_perform$2(function(){_forOf$2(e,!1,function(e){t.resolve(e).then(r.resolve,n)})});return i.e&&n(i.v),r.promise}});var _validateCollection$2=function(e,t){if(!_isObject$3(e)||e._t!==t)throw TypeError("Incompatible receiver, "+t+" required!");return e},dP$10=_objectDp$3.f,fastKey$1=_meta$3.fastKey,SIZE$1=_descriptors$3?"_s":"size",getEntry$1=function(e,t){var r,n=fastKey$1(t);if("F"!==n)return e._i[n];for(r=e._f;r;r=r.n)if(r.k==t)return r},_collectionStrong$2={getConstructor:function(e,t,r,n){var i=e(function(e,o){_anInstance$2(e,i,t,"_i"),e._t=t,e._i=_objectCreate$3(null),e._f=undefined,e._l=undefined,e[SIZE$1]=0,o!=undefined&&_forOf$2(o,r,e[n],e)});return _redefineAll$2(i.prototype,{clear:function(){for(var e=_validateCollection$2(this,t),r=e._i,n=e._f;n;n=n.n)n.r=!0,n.p&&(n.p=n.p.n=undefined),delete r[n.i];e._f=e._l=undefined,e[SIZE$1]=0},"delete":function(e){var r=_validateCollection$2(this,t),n=getEntry$1(r,e);if(n){var i=n.n,o=n.p;delete r._i[n.i],n.r=!0,o&&(o.n=i),i&&(i.p=o),r._f==n&&(r._f=i),r._l==n&&(r._l=o),r[SIZE$1]--}return!!n},forEach:function(e){_validateCollection$2(this,t);for(var r,n=_ctx$3(e,arguments.length>1?arguments[1]:undefined,3);r=r?r.n:this._f;)for(n(r.v,r.k,this);r&&r.r;)r=r.p},has:function(e){return!!getEntry$1(_validateCollection$2(this,t),e)}}),_descriptors$3&&dP$10(i.prototype,"size",{get:function(){return _validateCollection$2(this,t)[SIZE$1]}}),i},def:function(e,t,r){var n,i,o=getEntry$1(e,t);return o?o.v=r:(e._l=o={i:i=fastKey$1(t,!0),k:t,v:r,p:n=e._l,n:undefined,r:!1},e._f||(e._f=o),n&&(n.n=o),e[SIZE$1]++,"F"!==i&&(e._i[i]=o)),e},getEntry:getEntry$1,setStrong:function(e,t,r){_iterDefine$3(e,t,function(e,r){this._t=_validateCollection$2(e,t),this._k=r,this._l=undefined},function(){for(var e=this,t=e._k,r=e._l;r&&r.r;)r=r.p;return e._t&&(e._l=r=r?r.n:e._t._f)?"keys"==t?_iterStep$3(0,r.k):"values"==t?_iterStep$3(0,r.v):_iterStep$3(0,[r.k,r.v]):(e._t=undefined,_iterStep$3(1))},r?"entries":"values",!r,!0),_setSpecies$2(t)}},_collection$2=function(e,t,r,n,i,o){var a=_global$3[e],s=a,u=i?"set":"add",c=s&&s.prototype,l={},f=function(e){var t=c[e];_redefine$3(c,e,"delete"==e?function(e){return!(o&&!_isObject$3(e))&&t.call(this,0===e?0:e)}:"has"==e?function(e){return!(o&&!_isObject$3(e))&&t.call(this,0===e?0:e)}:"get"==e?function(e){return o&&!_isObject$3(e)?undefined:t.call(this,0===e?0:e)}:"add"==e?function(e){return t.call(this,0===e?0:e),this}:function(e,r){return t.call(this,0===e?0:e,r),this})};if("function"==typeof s&&(o||c.forEach&&!_fails$3(function(){(new s).entries().next()}))){var d=new s,h=d[u](o?{}:-0,1)!=d,p=_fails$3(function(){d.has(1)}),y=_iterDetect$3(function(e){new s(e)}),g=!o&&_fails$3(function(){for(var e=new s,t=5;t--;)e[u](t,t);return!e.has(-0)});y||(s=t(function(t,r){_anInstance$2(t,s,e);var n=_inheritIfRequired(new a,t,s);return r!=undefined&&_forOf$2(r,i,n[u],n),n}),s.prototype=c,c.constructor=s),(p||g)&&(f("delete"),f("has"),i&&f("get")),(g||h)&&f(u),o&&c.clear&&delete c.clear}else s=n.getConstructor(t,e,i,u),_redefineAll$2(s.prototype,r),_meta$3.NEED=!0;return _setToStringTag$3(s,e),l[e]=s,_export$3(_export$3.G+_export$3.W+_export$3.F*(s!=a),l),o||n.setStrong(s,e,i),s},MAP$1="Map",es6_map$2=_collection$2(MAP$1,function(e){return function(){return e(this,arguments.length>0?arguments[0]:undefined)}},{get:function(e){var t=_collectionStrong$2.getEntry(_validateCollection$2(this,MAP$1),e);return t&&t.v},set:function(e,t){return _collectionStrong$2.def(_validateCollection$2(this,MAP$1),0===e?0:e,t)}},_collectionStrong$2,!0),SET="Set",es6_set=_collection$2(SET,function(e){return function(){return e(this,arguments.length>0?arguments[0]:undefined)}},{add:function(e){return _collectionStrong$2.def(_validateCollection$2(this,SET),e=0===e?0:e,e)}},_collectionStrong$2),getWeak$1=_meta$3.getWeak,arrayFind$1=_arrayMethods$2(5),arrayFindIndex$1=_arrayMethods$2(6),id$4=0,uncaughtFrozenStore$1=function(e){return e._l||(e._l=new UncaughtFrozenStore$1)},UncaughtFrozenStore$1=function(){this.a=[]},findUncaughtFrozen$1=function(e,t){return arrayFind$1(e.a,function(e){return e[0]===t})};UncaughtFrozenStore$1.prototype={get:function(e){var t=findUncaughtFrozen$1(this,e);if(t)return t[1]},has:function(e){return!!findUncaughtFrozen$1(this,e)},set:function(e,t){var r=findUncaughtFrozen$1(this,e);r?r[1]=t:this.a.push([e,t])},"delete":function(e){var t=arrayFindIndex$1(this.a,function(t){return t[0]===e});return~t&&this.a.splice(t,1),!!~t}};var _collectionWeak$2={getConstructor:function(e,t,r,n){var i=e(function(e,o){_anInstance$2(e,i,t,"_i"),e._t=t,e._i=id$4++,e._l=undefined,o!=undefined&&_forOf$2(o,r,e[n],e)});return _redefineAll$2(i.prototype,{"delete":function(e){if(!_isObject$3(e))return!1;var r=getWeak$1(e);return!0===r?uncaughtFrozenStore$1(_validateCollection$2(this,t))["delete"](e):r&&_has$3(r,this._i)&&delete r[this._i]},has:function(e){if(!_isObject$3(e))return!1;var r=getWeak$1(e);return!0===r?uncaughtFrozenStore$1(_validateCollection$2(this,t)).has(e):r&&_has$3(r,this._i)}}),i},def:function(e,t,r){var n=getWeak$1(_anObject$3(t),!0);return!0===n?uncaughtFrozenStore$1(e).set(t,r):n[e._i]=r,e},ufstore:uncaughtFrozenStore$1},es6_weakMap$2=createCommonjsModule(function(e){var t,r=_arrayMethods$2(0),n=_meta$3.getWeak,i=Object.isExtensible,o=_collectionWeak$2.ufstore,a={},s=function(e){return function(){return e(this,arguments.length>0?arguments[0]:undefined)}},u={get:function(e){if(_isObject$3(e)){var t=n(e);return!0===t?o(_validateCollection$2(this,"WeakMap")).get(e):t?t[this._i]:undefined}},set:function(e,t){return _collectionWeak$2.def(_validateCollection$2(this,"WeakMap"),e,t)}},c=e.exports=_collection$2("WeakMap",s,u,_collectionWeak$2,!0,!0);_fails$3(function(){return 7!=(new c).set((Object.freeze||Object)(a),7).get(a)})&&(t=_collectionWeak$2.getConstructor(s,"WeakMap"),_objectAssign$2(t.prototype,u),_meta$3.NEED=!0,r(["delete","has","get","set"],function(e){var r=c.prototype,n=r[e];_redefine$3(r,e,function(r,o){if(_isObject$3(r)&&!i(r)){this._f||(this._f=new t);var a=this._f[e](r,o);return"set"==e?this:a}return n.call(this,r,o)})}))}),WEAK_SET="WeakSet";_collection$2(WEAK_SET,function(e){return function(){return e(this,arguments.length>0?arguments[0]:undefined)}},{add:function(e){return _collectionWeak$2.def(_validateCollection$2(this,WEAK_SET),e,!0)}},_collectionWeak$2,!1,!0);for(var TYPED=_uid$3("typed_array"),VIEW$1=_uid$3("view"),ABV=!(!_global$3.ArrayBuffer||!_global$3.DataView),CONSTR=ABV,i$3=0,l=9,Typed,TypedArrayConstructors="Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");i$3<l;)(Typed=_global$3[TypedArrayConstructors[i$3++]])?(_hide$3(Typed.prototype,TYPED,!0),_hide$3(Typed.prototype,VIEW$1,!0)):CONSTR=!1;var _typed={ABV:ABV,CONSTR:CONSTR,TYPED:TYPED,VIEW:VIEW$1},_toIndex=function(e){if(e===undefined)return 0;var t=_toInteger$3(e),r=_toLength$3(t);if(t!==r)throw RangeError("Wrong length!");return r},_typedBuffer=createCommonjsModule(function(e,t){function r(e,t,r){var n,i,o,a=Array(r),s=8*r-t-1,u=(1<<s)-1,c=u>>1,l=23===t?S(2,-24)-S(2,-77):0,f=0,d=e<0||0===e&&1/e<0?1:0;for(e=E(e),e!=e||e===$?(i=e!=e?1:0,n=u):(n=O(T(e)/A),e*(o=S(2,-n))<1&&(n--,o*=2),e+=n+c>=1?l/o:l*S(2,1-c),e*o>=2&&(n++,o/=2),n+c>=u?(i=0,n=u):n+c>=1?(i=(e*o-1)*S(2,t),n+=c):(i=e*S(2,c-1)*S(2,t),n=0));t>=8;a[f++]=255&i,i/=256,t-=8);for(n=n<<t|i,s+=t;s>0;a[f++]=255&n,n/=256,s-=8);return a[--f]|=128*d,a}function n(e,t,r){var n,i=8*r-t-1,o=(1<<i)-1,a=o>>1,s=i-7,u=r-1,c=e[u--],l=127&c;for(c>>=7;s>0;l=256*l+e[u],u--,s-=8);for(n=l&(1<<-s)-1,l>>=-s,s+=t;s>0;n=256*n+e[u],u--,s-=8);if(0===l)l=1-a;else{if(l===o)return n?NaN:c?-$:$;n+=S(2,t),l-=a}return(c?-1:1)*n*S(2,l-t)}function i(e){return e[3]<<24|e[2]<<16|e[1]<<8|e[0]}function o(e){return[255&e]}function a(e){return[255&e,e>>8&255]}function s(e){return[255&e,e>>8&255,e>>16&255,e>>24&255]}function u(e){return r(e,52,8)}function c(e){return r(e,23,4)}function l(e,t,r){p(e[y],t,{get:function(){return this[r]}})}function f(e,t,r,n){var i=+r,o=_toIndex(i);if(o+t>e[k])throw b(g);var a=e[x]._b,s=o+e[D],u=a.slice(s,s+t);return n?u:u.reverse()}function d(e,t,r,n,i,o){var a=+r,s=_toIndex(a);if(s+t>e[k])throw b(g);for(var u=e[x]._b,c=s+e[D],l=n(+i),f=0;f<t;f++)u[c+f]=l[o?f:t-f-1]}var h=_objectGopn$3.f,p=_objectDp$3.f,y="prototype",g="Wrong index!",m=_global$3.ArrayBuffer,_=_global$3.DataView,v=_global$3.Math,b=_global$3.RangeError,$=_global$3.Infinity,w=m,E=v.abs,S=v.pow,O=v.floor,T=v.log,A=v.LN2,x=_descriptors$3?"_b":"buffer",k=_descriptors$3?"_l":"byteLength",D=_descriptors$3?"_o":"byteOffset";if(_typed.ABV){if(!_fails$3(function(){m(1)})||!_fails$3(function(){new m(-1)})||_fails$3(function(){return new m,new m(1.5),new m(NaN),"ArrayBuffer"!=m.name})){m=function(e){return _anInstance$2(this,m),new w(_toIndex(e))};for(var I,P=m[y]=w[y],M=h(w),R=0;M.length>R;)(I=M[R++])in m||_hide$3(m,I,w[I]);_library$3||(P.constructor=m)}var C=new _(new m(2)),j=_[y].setInt8;C.setInt8(0,2147483648),C.setInt8(1,2147483649),!C.getInt8(0)&&C.getInt8(1)||_redefineAll$2(_[y],{setInt8:function(e,t){j.call(this,e,t<<24>>24)},setUint8:function(e,t){j.call(this,e,t<<24>>24)}},!0)}else m=function(e){_anInstance$2(this,m,"ArrayBuffer");var t=_toIndex(e);this._b=_arrayFill.call(Array(t),0),this[k]=t},_=function(e,t,r){_anInstance$2(this,_,"DataView"),_anInstance$2(e,m,"DataView");var n=e[k],i=_toInteger$3(t);if(i<0||i>n)throw b("Wrong offset!");if(r=r===undefined?n-i:_toLength$3(r),i+r>n)throw b("Wrong length!");this[x]=e,this[D]=i,this[k]=r},_descriptors$3&&(l(m,"byteLength","_l"),l(_,"buffer","_b"),l(_,"byteLength","_l"),l(_,"byteOffset","_o")),_redefineAll$2(_[y],{getInt8:function(e){return f(this,1,e)[0]<<24>>24},getUint8:function(e){return f(this,1,e)[0]},getInt16:function(e){var t=f(this,2,e,arguments[1]);return(t[1]<<8|t[0])<<16>>16},getUint16:function(e){var t=f(this,2,e,arguments[1]);return t[1]<<8|t[0]},getInt32:function(e){return i(f(this,4,e,arguments[1]))},getUint32:function(e){return i(f(this,4,e,arguments[1]))>>>0},getFloat32:function(e){return n(f(this,4,e,arguments[1]),23,4)},getFloat64:function(e){return n(f(this,8,e,arguments[1]),52,8)},setInt8:function(e,t){d(this,1,e,o,t)},setUint8:function(e,t){d(this,1,e,o,t)},setInt16:function(e,t){d(this,2,e,a,t,arguments[2])},setUint16:function(e,t){d(this,2,e,a,t,arguments[2])},setInt32:function(e,t){d(this,4,e,s,t,arguments[2])},setUint32:function(e,t){d(this,4,e,s,t,arguments[2])},setFloat32:function(e,t){d(this,4,e,c,t,arguments[2])},setFloat64:function(e,t){d(this,8,e,u,t,arguments[2])}});_setToStringTag$3(m,"ArrayBuffer"),_setToStringTag$3(_,"DataView"),_hide$3(_[y],_typed.VIEW,!0),t.ArrayBuffer=m,t.DataView=_}),ArrayBuffer$1=_global$3.ArrayBuffer,$ArrayBuffer=_typedBuffer.ArrayBuffer,$DataView=_typedBuffer.DataView,$isView=_typed.ABV&&ArrayBuffer$1.isView,$slice=$ArrayBuffer.prototype.slice,VIEW=_typed.VIEW,ARRAY_BUFFER="ArrayBuffer";_export$3(_export$3.G+_export$3.W+_export$3.F*(ArrayBuffer$1!==$ArrayBuffer),{ArrayBuffer:$ArrayBuffer}),_export$3(_export$3.S+_export$3.F*!_typed.CONSTR,ARRAY_BUFFER,{isView:function(e){return $isView&&$isView(e)||_isObject$3(e)&&VIEW in e}}),_export$3(_export$3.P+_export$3.U+_export$3.F*_fails$3(function(){return!new $ArrayBuffer(2).slice(1,undefined).byteLength}),ARRAY_BUFFER,{slice:function(e,t){if($slice!==undefined&&t===undefined)return $slice.call(_anObject$3(this),e);for(var r=_anObject$3(this).byteLength,n=_toAbsoluteIndex$3(e,r),i=_toAbsoluteIndex$3(t===undefined?r:t,r),o=new(_speciesConstructor$2(this,$ArrayBuffer))(_toLength$3(i-n)),a=new $DataView(this),s=new $DataView(o),u=0;n<i;)s.setUint8(u++,a.getUint8(n++));return o}}),_setSpecies$2(ARRAY_BUFFER),_export$3(_export$3.G+_export$3.W+_export$3.F*!_typed.ABV,{DataView:_typedBuffer.DataView});var _typedArray=createCommonjsModule(function(e){if(_descriptors$3){var t=_library$3,r=_global$3,n=_fails$3,i=_export$3,o=_typed,a=_typedBuffer,s=_ctx$3,u=_anInstance$2,c=_propertyDesc$3,l=_hide$3,f=_redefineAll$2,d=_toInteger$3,h=_toLength$3,p=_toIndex,y=_toAbsoluteIndex$3,g=_toPrimitive$3,m=_has$3,_=_classof$3,v=_isObject$3,b=_toObject$3,$=_isArrayIter$3,w=_objectCreate$3,E=_objectGpo$3,S=_objectGopn$3.f,O=core_getIteratorMethod$3,T=_uid$3,A=_wks$3,x=_arrayMethods$2,k=_arrayIncludes$3,D=_speciesConstructor$2,I=es6_array_iterator$3,P=_iterators$3,M=_iterDetect$3,R=_setSpecies$2,C=_arrayFill,j=_arrayCopyWithin,L=_objectDp$3,N=_objectGopd$3,F=L.f,B=N.f,U=r.RangeError,z=r.TypeError,G=r.Uint8Array,W=Array.prototype,H=a.ArrayBuffer,V=a.DataView,Y=x(0),K=x(2),Z=x(3),J=x(4),Q=x(5),X=x(6),q=k(!0),ee=k(!1),te=I.values,re=I.keys,ne=I.entries,ie=W.lastIndexOf,oe=W.reduce,ae=W.reduceRight,se=W.join,ue=W.sort,ce=W.slice,le=W.toString,fe=W.toLocaleString,de=A("iterator"),he=A("toStringTag"),pe=T("typed_constructor"),ye=T("def_constructor"),ge=o.CONSTR,me=o.TYPED,_e=o.VIEW,ve=x(1,function(e,t){return Se(D(e,e[ye]),t)}),be=n(function(){return 1===new G(new Uint16Array([1]).buffer)[0]}),$e=!!G&&!!G.prototype.set&&n(function(){new G(1).set({})}),we=function(e,t){var r=d(e);if(r<0||r%t)throw U("Wrong offset!");return r},Ee=function(e){if(v(e)&&me in e)return e;throw z(e+" is not a typed array!")},Se=function(e,t){if(!(v(e)&&pe in e))throw z("It is not a typed array constructor!");return new e(t)},Oe=function(e,t){return Te(D(e,e[ye]),t)},Te=function(e,t){for(var r=0,n=t.length,i=Se(e,n);n>r;)i[r]=t[r++];return i},Ae=function(e,t,r){F(e,t,{get:function(){return this._d[r]}})},xe=function(e){var t,r,n,i,o,a,u=b(e),c=arguments.length,l=c>1?arguments[1]:undefined,f=l!==undefined,d=O(u);if(d!=undefined&&!$(d)){for(a=d.call(u),n=[],t=0;!(o=a.next()).done;t++)n.push(o.value);u=n}for(f&&c>2&&(l=s(l,arguments[2],2)),t=0,r=h(u.length),i=Se(this,r);r>t;t++)i[t]=f?l(u[t],t):u[t];return i},ke=function(){for(var e=0,t=arguments.length,r=Se(this,t);t>e;)r[e]=arguments[e++];return r},De=!!G&&n(function(){fe.call(new G(1))}),Ie=function(){return fe.apply(De?ce.call(Ee(this)):Ee(this),arguments)},Pe={copyWithin:function(e,t){return j.call(Ee(this),e,t,arguments.length>2?arguments[2]:undefined)},every:function(e){return J(Ee(this),e,arguments.length>1?arguments[1]:undefined)},fill:function(e){return C.apply(Ee(this),arguments)},filter:function(e){return Oe(this,K(Ee(this),e,arguments.length>1?arguments[1]:undefined))},find:function(e){return Q(Ee(this),e,arguments.length>1?arguments[1]:undefined)},findIndex:function(e){return X(Ee(this),e,arguments.length>1?arguments[1]:undefined)},forEach:function(e){Y(Ee(this),e,arguments.length>1?arguments[1]:undefined)},indexOf:function(e){return ee(Ee(this),e,arguments.length>1?arguments[1]:undefined)},includes:function(e){return q(Ee(this),e,arguments.length>1?arguments[1]:undefined)},join:function(e){return se.apply(Ee(this),arguments)},lastIndexOf:function(e){return ie.apply(Ee(this),arguments)},map:function(e){return ve(Ee(this),e,arguments.length>1?arguments[1]:undefined)},reduce:function(e){return oe.apply(Ee(this),arguments)},reduceRight:function(e){return ae.apply(Ee(this),arguments)},reverse:function(){for(var e,t=this,r=Ee(t).length,n=Math.floor(r/2),i=0;i<n;)e=t[i],t[i++]=t[--r],t[r]=e;return t},some:function(e){return Z(Ee(this),e,arguments.length>1?arguments[1]:undefined)},sort:function(e){return ue.call(Ee(this),e)},subarray:function(e,t){var r=Ee(this),n=r.length,i=y(e,n);return new(D(r,r[ye]))(r.buffer,r.byteOffset+i*r.BYTES_PER_ELEMENT,h((t===undefined?n:y(t,n))-i))}},Me=function(e,t){return Oe(this,ce.call(Ee(this),e,t))},Re=function(e){Ee(this);var t=we(arguments[1],1),r=this.length,n=b(e),i=h(n.length),o=0;if(i+t>r)throw U("Wrong length!");for(;o<i;)this[t+o]=n[o++]},Ce={entries:function(){return ne.call(Ee(this))},keys:function(){return re.call(Ee(this))},values:function(){return te.call(Ee(this))}},je=function(e,t){return v(e)&&e[me]&&"symbol"!=typeof t&&t in e&&String(+t)==String(t)},Le=function(e,t){return je(e,t=g(t,!0))?c(2,e[t]):B(e,t)},Ne=function(e,t,r){return!(je(e,t=g(t,!0))&&v(r)&&m(r,"value"))||m(r,"get")||m(r,"set")||r.configurable||m(r,"writable")&&!r.writable||m(r,"enumerable")&&!r.enumerable?F(e,t,r):(e[t]=r.value,e)};ge||(N.f=Le,L.f=Ne),i(i.S+i.F*!ge,"Object",{getOwnPropertyDescriptor:Le,defineProperty:Ne}),n(function(){le.call({})})&&(le=fe=function(){return se.call(this)});var Fe=f({},Pe);f(Fe,Ce),l(Fe,de,Ce.values),f(Fe,{slice:Me,set:Re,constructor:function(){},toString:le,toLocaleString:Ie}),Ae(Fe,"buffer","b"),Ae(Fe,"byteOffset","o"),Ae(Fe,"byteLength","l"),Ae(Fe,"length","e"),F(Fe,he,{get:function(){return this[me]}}),e.exports=function(e,a,s,c){c=!!c;var f=e+(c?"Clamped":"")+"Array",d="get"+e,y="set"+e,g=r[f],m=g||{},b=g&&E(g),$=!g||!o.ABV,O={},T=g&&g.prototype,A=function(e,t){var r=e._d;return r.v[d](t*a+r.o,be)},x=function(e,t,r){var n=e._d;c&&(r=(r=Math.round(r))<0?0:r>255?255:255&r),n.v[y](t*a+n.o,r,be)},k=function(e,t){F(e,t,{get:function(){return A(this,t)},set:function(e){return x(this,t,e)},enumerable:!0})};$?(g=s(function(e,t,r,n){u(e,g,f,"_d");var i,o,s,c,d=0,y=0;if(v(t)){if(!(t instanceof H||"ArrayBuffer"==(c=_(t))||"SharedArrayBuffer"==c))return me in t?Te(g,t):xe.call(g,t);i=t,y=we(r,a);var m=t.byteLength;if(n===undefined){if(m%a)throw U("Wrong length!");if((o=m-y)<0)throw U("Wrong length!")}else if((o=h(n)*a)+y>m)throw U("Wrong length!");s=o/a}else s=p(t),o=s*a,i=new H(o);for(l(e,"_d",{b:i,o:y,l:o,e:s,v:new V(i)});d<s;)k(e,d++)}),T=g.prototype=w(Fe),l(T,"constructor",g)):n(function(){g(1)})&&n(function(){new g(-1)})&&M(function(e){new g,new g(null),new g(1.5),new g(e)},!0)||(g=s(function(e,t,r,n){u(e,g,f);var i;return v(t)?t instanceof H||"ArrayBuffer"==(i=_(t))||"SharedArrayBuffer"==i?n!==undefined?new m(t,we(r,a),n):r!==undefined?new m(t,we(r,a)):new m(t):me in t?Te(g,t):xe.call(g,t):new m(p(t))}),Y(b!==Function.prototype?S(m).concat(S(b)):S(m),function(e){e in g||l(g,e,m[e])}),g.prototype=T,t||(T.constructor=g));var D=T[de],I=!!D&&("values"==D.name||D.name==undefined),C=Ce.values;l(g,pe,!0),l(T,me,f),l(T,_e,!0),l(T,ye,g),(c?new g(1)[he]==f:he in T)||F(T,he,{get:function(){return f}}),O[f]=g,i(i.G+i.W+i.F*(g!=m),O),i(i.S,f,{BYTES_PER_ELEMENT:a}),i(i.S+i.F*n(function(){m.of.call(g,1)}),f,{from:xe,of:ke}),"BYTES_PER_ELEMENT"in T||l(T,"BYTES_PER_ELEMENT",a),i(i.P,f,Pe),R(f),i(i.P+i.F*$e,f,{set:Re}),i(i.P+i.F*!I,f,Ce),t||T.toString==le||(T.toString=le),i(i.P+i.F*n(function(){new g(1).slice()}),f,{slice:Me}),i(i.P+i.F*(n(function(){return[1,2].toLocaleString()!=new g([1,2]).toLocaleString()})||!n(function(){T.toLocaleString.call([1,2])})),f,{toLocaleString:Ie}),P[f]=I?D:C,t||I||l(T,de,C)}}else e.exports=function(){}});_typedArray("Int8",1,function(e){return function(t,r,n){return e(this,t,r,n)}}),_typedArray("Uint8",1,function(e){return function(t,r,n){return e(this,t,r,n)}}),_typedArray("Uint8",1,function(e){return function(t,r,n){return e(this,t,r,n)}},!0),_typedArray("Int16",2,function(e){return function(t,r,n){return e(this,t,r,n)}}),_typedArray("Uint16",2,function(e){return function(t,r,n){return e(this,t,r,n)}}),_typedArray("Int32",4,function(e){return function(t,r,n){return e(this,t,r,n)}}),_typedArray("Uint32",4,function(e){return function(t,r,n){return e(this,t,r,n)}}),_typedArray("Float32",4,function(e){return function(t,r,n){return e(this,t,r,n)}}),_typedArray("Float64",8,function(e){return function(t,r,n){return e(this,t,r,n)}});var rApply=(_global$3.Reflect||{}).apply,fApply=Function.apply;_export$3(_export$3.S+_export$3.F*!_fails$3(function(){rApply(function(){})}),"Reflect",{apply:function(e,t,r){var n=_aFunction$3(e),i=_anObject$3(r);return rApply?rApply(n,t,i):fApply.call(n,t,i)}});var rConstruct=(_global$3.Reflect||{}).construct,NEW_TARGET_BUG=_fails$3(function(){function e(){}return!(rConstruct(function(){},[],e)instanceof e)}),ARGS_BUG=!_fails$3(function(){rConstruct(function(){})});_export$3(_export$3.S+_export$3.F*(NEW_TARGET_BUG||ARGS_BUG),"Reflect",{construct:function(e,t){_aFunction$3(e),_anObject$3(t);var r=arguments.length<3?e:_aFunction$3(arguments[2]);if(ARGS_BUG&&!NEW_TARGET_BUG)return rConstruct(e,t,r);if(e==r){switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3])}var n=[null];return n.push.apply(n,t),new(_bind.apply(e,n))}var i=r.prototype,o=_objectCreate$3(_isObject$3(i)?i:Object.prototype),a=Function.apply.call(e,o,t);return _isObject$3(a)?a:o}}),_export$3(_export$3.S+_export$3.F*_fails$3(function(){Reflect.defineProperty(_objectDp$3.f({},1,{value:1}),1,{value:2})}),"Reflect",{defineProperty:function(e,t,r){_anObject$3(e),t=_toPrimitive$3(t,!0),_anObject$3(r);try{return _objectDp$3.f(e,t,r),!0}catch(e){return!1}}});var gOPD$7=_objectGopd$3.f;_export$3(_export$3.S,"Reflect",{deleteProperty:function(e,t){var r=gOPD$7(_anObject$3(e),t);return!(r&&!r.configurable)&&delete e[t]}});var Enumerate=function(e){this._t=_anObject$3(e),this._i=0;var t,r=this._k=[];for(t in e)r.push(t)};_iterCreate$3(Enumerate,"Object",function(){var e,t=this,r=t._k;do{if(t._i>=r.length)return{value:undefined,done:!0}}while(!((e=r[t._i++])in t._t));return{value:e,done:!1}}),_export$3(_export$3.S,"Reflect",{enumerate:function(e){return new Enumerate(e)}}),_export$3(_export$3.S,"Reflect",{get:get$2}),_export$3(_export$3.S,"Reflect",{getOwnPropertyDescriptor:function(e,t){return _objectGopd$3.f(_anObject$3(e),t)}}),_export$3(_export$3.S,"Reflect",{getPrototypeOf:function(e){return _objectGpo$3(_anObject$3(e))}}),_export$3(_export$3.S,"Reflect",{has:function(e,t){return t in e}});var $isExtensible=Object.isExtensible;_export$3(_export$3.S,"Reflect",{isExtensible:function(e){return _anObject$3(e),!$isExtensible||$isExtensible(e)}});var Reflect$2=_global$3.Reflect,_ownKeys$2=Reflect$2&&Reflect$2.ownKeys||function(e){var t=_objectGopn$3.f(_anObject$3(e)),r=_objectGops$3.f;return r?t.concat(r(e)):t};_export$3(_export$3.S,"Reflect",{ownKeys:_ownKeys$2});var $preventExtensions=Object.preventExtensions;_export$3(_export$3.S,"Reflect",{preventExtensions:function(e){_anObject$3(e);try{return $preventExtensions&&$preventExtensions(e),!0}catch(e){return!1}}}),_export$3(_export$3.S,"Reflect",{set:set}),_setProto$3&&_export$3(_export$3.S,"Reflect",{setPrototypeOf:function(e,t){_setProto$3.check(e,t);try{return _setProto$3.set(e,t),!0}catch(e){return!1}}});var $includes=_arrayIncludes$3(!0);_export$3(_export$3.P,"Array",{includes:function(e){return $includes(this,e,arguments.length>1?arguments[1]:undefined)}}),_addToUnscopables$2("includes");var IS_CONCAT_SPREADABLE=_wks$3("isConcatSpreadable"),_flattenIntoArray=flattenIntoArray;_export$3(_export$3.P,"Array",{flatMap:function(e){var t,r,n=_toObject$3(this);return _aFunction$3(e),t=_toLength$3(n.length),r=_arraySpeciesCreate$2(n,0),_flattenIntoArray(r,n,n,t,0,1,e,arguments[1]),r}}),_addToUnscopables$2("flatMap"),_export$3(_export$3.P,"Array",{flatten:function(){var e=arguments[0],t=_toObject$3(this),r=_toLength$3(t.length),n=_arraySpeciesCreate$2(t,0);return _flattenIntoArray(n,t,t,r,0,e===undefined?1:_toInteger$3(e)),n}}),_addToUnscopables$2("flatten");var $at$4=_stringAt$3(!0);_export$3(_export$3.P,"String",{at:function(e){return $at$4(this,e)}});var _stringPad=function(e,t,r,n){var i=String(_defined$3(e)),o=i.length,a=r===undefined?" ":String(r),s=_toLength$3(t);if(s<=o||""==a)return i;var u=s-o,c=_stringRepeat.call(a,Math.ceil(u/a.length));return c.length>u&&(c=c.slice(0,u)),n?c+i:i+c};_export$3(_export$3.P,"String",{padStart:function(e){return _stringPad(this,e,arguments.length>1?arguments[1]:undefined,!0)}}),_export$3(_export$3.P,"String",{padEnd:function(e){return _stringPad(this,e,arguments.length>1?arguments[1]:undefined,!1)}}),_stringTrim$3("trimLeft",function(e){return function(){return e(this,1)}},"trimStart"),_stringTrim$3("trimRight",function(e){return function(){return e(this,2)}},"trimEnd");var RegExpProto=RegExp.prototype,$RegExpStringIterator=function(e,t){this._r=e,this._s=t};_iterCreate$3($RegExpStringIterator,"RegExp String",function(){var e=this._r.exec(this._s);return{value:e,done:null===e}}),_export$3(_export$3.P,"String",{matchAll:function(e){if(_defined$3(this),!_isRegexp(e))throw TypeError(e+" is not a regexp!");var t=String(this),r="flags"in RegExpProto?String(e.flags):_flags.call(e),n=new RegExp(e.source,~r.indexOf("g")?r:"g"+r);return n.lastIndex=_toLength$3(e.lastIndex),new $RegExpStringIterator(n,t)}}),_wksDefine$3("asyncIterator"),_wksDefine$3("observable"),_export$3(_export$3.S,"Object",{getOwnPropertyDescriptors:function(e){for(var t,r,n=_toIobject$3(e),i=_objectGopd$3.f,o=_ownKeys$2(n),a={},s=0;o.length>s;)(r=i(n,t=o[s++]))!==undefined&&_createProperty$3(a,t,r);return a}});var isEnum$4=_objectPie$3.f,_objectToArray$2=function(e){return function(t){for(var r,n=_toIobject$3(t),i=_objectKeys$3(n),o=i.length,a=0,s=[];o>a;)isEnum$4.call(n,r=i[a++])&&s.push(e?[r,n[r]]:n[r]);return s}},$values=_objectToArray$2(!1);_export$3(_export$3.S,"Object",{values:function(e){return $values(e)}});var $entries$1=_objectToArray$2(!0);_export$3(_export$3.S,"Object",{entries:function(e){return $entries$1(e)}});var _objectForcedPam=_library$3||!_fails$3(function(){var e=Math.random();__defineSetter__.call(null,e,function(){}),delete _global$3[e]});_descriptors$3&&_export$3(_export$3.P+_objectForcedPam,"Object",{__defineGetter__:function(e,t){_objectDp$3.f(_toObject$3(this),e,{get:_aFunction$3(t),enumerable:!0,configurable:!0})}}),_descriptors$3&&_export$3(_export$3.P+_objectForcedPam,"Object",{__defineSetter__:function(e,t){_objectDp$3.f(_toObject$3(this),e,{set:_aFunction$3(t),enumerable:!0,configurable:!0})}});var getOwnPropertyDescriptor$5=_objectGopd$3.f;_descriptors$3&&_export$3(_export$3.P+_objectForcedPam,"Object",{__lookupGetter__:function(e){var t,r=_toObject$3(this),n=_toPrimitive$3(e,!0);do{if(t=getOwnPropertyDescriptor$5(r,n))return t.get}while(r=_objectGpo$3(r))}});var getOwnPropertyDescriptor$6=_objectGopd$3.f;_descriptors$3&&_export$3(_export$3.P+_objectForcedPam,"Object",{__lookupSetter__:function(e){var t,r=_toObject$3(this),n=_toPrimitive$3(e,!0);do{if(t=getOwnPropertyDescriptor$6(r,n))return t.set}while(r=_objectGpo$3(r))}});var _arrayFromIterable$2=function(e,t){var r=[];return _forOf$2(e,!1,r.push,r,t),r},_collectionToJson$2=function(e){return function(){if(_classof$3(this)!=e)throw TypeError(e+"#toJSON isn't generic");return _arrayFromIterable$2(this)}};_export$3(_export$3.P+_export$3.R,"Map",{toJSON:_collectionToJson$2("Map")}),_export$3(_export$3.P+_export$3.R,"Set",{toJSON:_collectionToJson$2("Set")});var _setCollectionOf$2=function(e){_export$3(_export$3.S,e,{of:function(){for(var e=arguments.length,t=Array(e);e--;)t[e]=arguments[e];return new this(t)}})};_setCollectionOf$2("Map"),_setCollectionOf$2("Set"),_setCollectionOf$2("WeakMap"),_setCollectionOf$2("WeakSet");var _setCollectionFrom$2=function(e){_export$3(_export$3.S,e,{from:function(e){var t,r,n,i,o=arguments[1];return _aFunction$3(this),t=o!==undefined,t&&_aFunction$3(o),e==undefined?new this:(r=[],t?(n=0,i=_ctx$3(o,arguments[2],2),_forOf$2(e,!1,function(e){r.push(i(e,n++))})):_forOf$2(e,!1,r.push,r),new this(r))}})};_setCollectionFrom$2("Map"),_setCollectionFrom$2("Set"),_setCollectionFrom$2("WeakMap"),_setCollectionFrom$2("WeakSet"),_export$3(_export$3.G,{global:_global$3}),_export$3(_export$3.S,"System",{global:_global$3}),_export$3(_export$3.S,"Error",{isError:function(e){return"Error"===_cof$3(e)}}),_export$3(_export$3.S,"Math",{clamp:function(e,t,r){return Math.min(r,Math.max(t,e))}}),_export$3(_export$3.S,"Math",{DEG_PER_RAD:Math.PI/180});var RAD_PER_DEG=180/Math.PI;_export$3(_export$3.S,"Math",{degrees:function(e){return e*RAD_PER_DEG}});var _mathScale=Math.scale||function(e,t,r,n,i){return 0===arguments.length||e!=e||t!=t||r!=r||n!=n||i!=i?NaN:e===Infinity||e===-Infinity?e:(e-t)*(i-n)/(r-t)+n};_export$3(_export$3.S,"Math",{fscale:function(e,t,r,n,i){return _mathFround(_mathScale(e,t,r,n,i))}}),_export$3(_export$3.S,"Math",{iaddh:function(e,t,r,n){var i=e>>>0,o=t>>>0,a=r>>>0;return o+(n>>>0)+((i&a|(i|a)&~(i+a>>>0))>>>31)|0}}),_export$3(_export$3.S,"Math",{isubh:function(e,t,r,n){var i=e>>>0,o=t>>>0,a=r>>>0;return o-(n>>>0)-((~i&a|~(i^a)&i-a>>>0)>>>31)|0}}),_export$3(_export$3.S,"Math",{imulh:function(e,t){var r=+e,n=+t,i=65535&r,o=65535&n,a=r>>16,s=n>>16,u=(a*o>>>0)+(i*o>>>16);return a*s+(u>>16)+((i*s>>>0)+(65535&u)>>16)}}),_export$3(_export$3.S,"Math",{RAD_PER_DEG:180/Math.PI});var DEG_PER_RAD=Math.PI/180;_export$3(_export$3.S,"Math",{radians:function(e){return e*DEG_PER_RAD}}),_export$3(_export$3.S,"Math",{scale:_mathScale}),_export$3(_export$3.S,"Math",{umulh:function(e,t){var r=+e,n=+t,i=65535&r,o=65535&n,a=r>>>16,s=n>>>16,u=(a*o>>>0)+(i*o>>>16);return a*s+(u>>>16)+((i*s>>>0)+(65535&u)>>>16)}}),_export$3(_export$3.S,"Math",{signbit:function(e){return(e=+e)!=e?e:0==e?1/e==Infinity:e>0}}),_export$3(_export$3.P+_export$3.R,"Promise",{"finally":function(e){var t=_speciesConstructor$2(this,_core$3.Promise||_global$3.Promise),r="function"==typeof e;return this.then(r?function(r){return _promiseResolve$2(t,e()).then(function(){return r})}:e,r?function(r){return _promiseResolve$2(t,e()).then(function(){throw r})}:e)}}),_export$3(_export$3.S,"Promise",{"try":function(e){var t=_newPromiseCapability$2.f(this),r=_perform$2(e);return(r.e?t.reject:t.resolve)(r.v),t.promise}});var shared$4=_shared$3("metadata"),store$3=shared$4.store||(shared$4.store=new es6_weakMap$2),getOrCreateMetadataMap=function(e,t,r){var n=store$3.get(e);if(!n){if(!r)return undefined;store$3.set(e,n=new es6_map$2)}var i=n.get(t);if(!i){if(!r)return undefined;n.set(t,i=new es6_map$2)}return i},ordinaryHasOwnMetadata=function(e,t,r){var n=getOrCreateMetadataMap(t,r,!1);return n!==undefined&&n.has(e)},ordinaryGetOwnMetadata=function(e,t,r){var n=getOrCreateMetadataMap(t,r,!1);return n===undefined?undefined:n.get(e)},ordinaryDefineOwnMetadata$1=function(e,t,r,n){getOrCreateMetadataMap(r,n,!0).set(e,t)},ordinaryOwnMetadataKeys=function(e,t){var r=getOrCreateMetadataMap(e,t,!1),n=[];return r&&r.forEach(function(e,t){n.push(t)}),n},toMetaKey$1=function(e){return e===undefined||"symbol"==typeof e?e:String(e)},exp$3=function(e){_export$3(_export$3.S,"Reflect",e)},_metadata={store:store$3,map:getOrCreateMetadataMap,has:ordinaryHasOwnMetadata,get:ordinaryGetOwnMetadata,set:ordinaryDefineOwnMetadata$1,keys:ordinaryOwnMetadataKeys,key:toMetaKey$1,exp:exp$3},toMetaKey=_metadata.key,ordinaryDefineOwnMetadata=_metadata.set;_metadata.exp({defineMetadata:function(e,t,r,n){ordinaryDefineOwnMetadata(e,t,_anObject$3(r),toMetaKey(n))}});var toMetaKey$2=_metadata.key,getOrCreateMetadataMap$1=_metadata.map,store$4=_metadata.store;_metadata.exp({deleteMetadata:function(e,t){
var r=arguments.length<3?undefined:toMetaKey$2(arguments[2]),n=getOrCreateMetadataMap$1(_anObject$3(t),r,!1);if(n===undefined||!n["delete"](e))return!1;if(n.size)return!0;var i=store$4.get(t);return i["delete"](r),!!i.size||store$4["delete"](t)}});var ordinaryHasOwnMetadata$1=_metadata.has,ordinaryGetOwnMetadata$1=_metadata.get,toMetaKey$3=_metadata.key,ordinaryGetMetadata=function(e,t,r){if(ordinaryHasOwnMetadata$1(e,t,r))return ordinaryGetOwnMetadata$1(e,t,r);var n=_objectGpo$3(t);return null!==n?ordinaryGetMetadata(e,n,r):undefined};_metadata.exp({getMetadata:function(e,t){return ordinaryGetMetadata(e,_anObject$3(t),arguments.length<3?undefined:toMetaKey$3(arguments[2]))}});var ordinaryOwnMetadataKeys$1=_metadata.keys,toMetaKey$4=_metadata.key,ordinaryMetadataKeys=function(e,t){var r=ordinaryOwnMetadataKeys$1(e,t),n=_objectGpo$3(e);if(null===n)return r;var i=ordinaryMetadataKeys(n,t);return i.length?r.length?_arrayFromIterable$2(new es6_set(r.concat(i))):i:r};_metadata.exp({getMetadataKeys:function(e){return ordinaryMetadataKeys(_anObject$3(e),arguments.length<2?undefined:toMetaKey$4(arguments[1]))}});var ordinaryGetOwnMetadata$2=_metadata.get,toMetaKey$5=_metadata.key;_metadata.exp({getOwnMetadata:function(e,t){return ordinaryGetOwnMetadata$2(e,_anObject$3(t),arguments.length<3?undefined:toMetaKey$5(arguments[2]))}});var ordinaryOwnMetadataKeys$2=_metadata.keys,toMetaKey$6=_metadata.key;_metadata.exp({getOwnMetadataKeys:function(e){return ordinaryOwnMetadataKeys$2(_anObject$3(e),arguments.length<2?undefined:toMetaKey$6(arguments[1]))}});var ordinaryHasOwnMetadata$2=_metadata.has,toMetaKey$7=_metadata.key,ordinaryHasMetadata=function(e,t,r){if(ordinaryHasOwnMetadata$2(e,t,r))return!0;var n=_objectGpo$3(t);return null!==n&&ordinaryHasMetadata(e,n,r)};_metadata.exp({hasMetadata:function(e,t){return ordinaryHasMetadata(e,_anObject$3(t),arguments.length<3?undefined:toMetaKey$7(arguments[2]))}});var ordinaryHasOwnMetadata$3=_metadata.has,toMetaKey$8=_metadata.key;_metadata.exp({hasOwnMetadata:function(e,t){return ordinaryHasOwnMetadata$3(e,_anObject$3(t),arguments.length<3?undefined:toMetaKey$8(arguments[2]))}});var toMetaKey$9=_metadata.key,ordinaryDefineOwnMetadata$2=_metadata.set;_metadata.exp({metadata:function(e,t){return function(r,n){ordinaryDefineOwnMetadata$2(e,t,(n!==undefined?_anObject$3:_aFunction$3)(r),toMetaKey$9(n))}}});var microtask$2=_microtask$2(),process$6=_global$3.process,isNode$5="process"==_cof$3(process$6);_export$3(_export$3.G,{asap:function(e){var t=isNode$5&&process$6.domain;microtask$2(t?t.bind(e):e)}});var microtask$3=_microtask$2(),OBSERVABLE=_wks$3("observable"),RETURN=_forOf$2.RETURN,getMethod=function(e){return null==e?undefined:_aFunction$3(e)},cleanupSubscription=function(e){var t=e._c;t&&(e._c=undefined,t())},subscriptionClosed=function(e){return e._o===undefined},closeSubscription=function(e){subscriptionClosed(e)||(e._o=undefined,cleanupSubscription(e))},Subscription=function(t,r){_anObject$3(t),this._c=undefined,this._o=t,t=new SubscriptionObserver(this);try{var n=r(t),i=n;null!=n&&("function"==typeof n.unsubscribe?n=function(){i.unsubscribe()}:_aFunction$3(n),this._c=n)}catch(e){return void t.error(e)}subscriptionClosed(this)&&cleanupSubscription(this)};Subscription.prototype=_redefineAll$2({},{unsubscribe:function(){closeSubscription(this)}});var SubscriptionObserver=function(e){this._s=e};SubscriptionObserver.prototype=_redefineAll$2({},{next:function(t){var r=this._s;if(!subscriptionClosed(r)){var n=r._o;try{var i=getMethod(n.next);if(i)return i.call(n,t)}catch(e){try{closeSubscription(r)}finally{throw e}}}},error:function(t){var r=this._s;if(subscriptionClosed(r))throw t;var n=r._o;r._o=undefined;try{var i=getMethod(n.error);if(!i)throw t;t=i.call(n,t)}catch(e){try{cleanupSubscription(r)}finally{throw e}}return cleanupSubscription(r),t},complete:function(t){var r=this._s;if(!subscriptionClosed(r)){var n=r._o;r._o=undefined;try{var i=getMethod(n.complete);t=i?i.call(n,t):undefined}catch(e){try{cleanupSubscription(r)}finally{throw e}}return cleanupSubscription(r),t}}});var $Observable=function(e){_anInstance$2(this,$Observable,"Observable","_f")._f=_aFunction$3(e)};_redefineAll$2($Observable.prototype,{subscribe:function(e){return new Subscription(e,this._f)},forEach:function(t){var r=this;return new(_core$3.Promise||_global$3.Promise)(function(n,i){_aFunction$3(t);var o=r.subscribe({next:function(r){try{return t(r)}catch(e){i(e),o.unsubscribe()}},error:i,complete:n})})}}),_redefineAll$2($Observable,{from:function(t){var r="function"==typeof this?this:$Observable,n=getMethod(_anObject$3(t)[OBSERVABLE]);if(n){var i=_anObject$3(n.call(t));return i.constructor===r?i:new r(function(e){return i.subscribe(e)})}return new r(function(r){var n=!1;return microtask$3(function(){if(!n){try{if(_forOf$2(t,!1,function(e){if(r.next(e),n)return RETURN})===RETURN)return}catch(e){if(n)throw e;return void r.error(e)}r.complete()}}),function(){n=!0}})},of:function(){for(var e=0,t=arguments.length,r=Array(t);e<t;)r[e]=arguments[e++];return new("function"==typeof this?this:$Observable)(function(e){var t=!1;return microtask$3(function(){if(!t){for(var n=0;n<r.length;++n)if(e.next(r[n]),t)return;e.complete()}}),function(){t=!0}})}}),_hide$3($Observable.prototype,OBSERVABLE,function(){return this}),_export$3(_export$3.G,{Observable:$Observable}),_setSpecies$2("Observable");var navigator$1=_global$3.navigator,slice=[].slice,MSIE=!!navigator$1&&/MSIE .\./.test(navigator$1.userAgent),wrap$3=function(e){return function(t,r){var n=arguments.length>2,i=!!n&&slice.call(arguments,2);return e(n?function(){("function"==typeof t?t:Function(t)).apply(this,i)}:t,r)}};_export$3(_export$3.G+_export$3.B+_export$3.F*MSIE,{setTimeout:wrap$3(_global$3.setTimeout),setInterval:wrap$3(_global$3.setInterval)}),_export$3(_export$3.G+_export$3.B,{setImmediate:_task$2.set,clearImmediate:_task$2.clear});for(var ITERATOR$10=_wks$3("iterator"),TO_STRING_TAG$2=_wks$3("toStringTag"),ArrayValues=_iterators$3.Array,DOMIterables$2={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},collections=_objectKeys$3(DOMIterables$2),i$4=0;i$4<collections.length;i$4++){var NAME$3=collections[i$4],explicit=DOMIterables$2[NAME$3],Collection$2=_global$3[NAME$3],proto$5=Collection$2&&Collection$2.prototype,key$1;if(proto$5&&(proto$5[ITERATOR$10]||_hide$3(proto$5,ITERATOR$10,ArrayValues),proto$5[TO_STRING_TAG$2]||_hide$3(proto$5,TO_STRING_TAG$2,NAME$3),_iterators$3[NAME$3]=ArrayValues,explicit))for(key$1 in es6_array_iterator$3)proto$5[key$1]||_redefine$3(proto$5,key$1,es6_array_iterator$3[key$1],!0)}var runtime=createCommonjsModule(function(e){!function(t){function r(e,t,r,n){var o=t&&t.prototype instanceof i?t:i,a=Object.create(o.prototype),s=new h(n||[]);return a._invoke=c(e,r,s),a}function n(e,t,r){try{return{type:"normal",arg:e.call(t,r)}}catch(n){return{type:"throw",arg:n}}}function i(){}function o(){}function a(){}function s(e){["next","throw","return"].forEach(function(t){e[t]=function(e){return this._invoke(t,e)}})}function u(e){function r(t,i,o,a){var s=n(e[t],e,i);if("throw"!==s.type){var u=s.arg,c=u.value;return c&&"object"==typeof c&&_.call(c,"__await")?Promise.resolve(c.__await).then(function(e){r("next",e,o,a)},function(e){r("throw",e,o,a)}):Promise.resolve(c).then(function(e){u.value=e,o(u)},a)}a(s.arg)}function i(e,t){function n(){return new Promise(function(n,i){r(e,t,n,i)})}return o=o?o.then(n,n):n()}"object"==typeof t.process&&t.process.domain&&(r=t.process.domain.bind(r));var o;this._invoke=i}function c(e,t,r){var i=S;return function(o,a){if(i===T)throw new Error("Generator is already running");if(i===A){if("throw"===o)throw a;return y()}for(r.method=o,r.arg=a;;){var s=r.delegate;if(s){var u=l(s,r);if(u){if(u===x)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(i===S)throw i=A,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);i=T;var c=n(e,t,r);if("normal"===c.type){if(i=r.done?A:O,c.arg===x)continue;return{value:c.arg,done:r.done}}"throw"===c.type&&(i=A,r.method="throw",r.arg=c.arg)}}}function l(e,t){var r=e.iterator[t.method];if(r===g){if(t.delegate=null,"throw"===t.method){if(e.iterator["return"]&&(t.method="return",t.arg=g,l(e,t),"throw"===t.method))return x;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return x}var i=n(r,e.iterator,t.arg);if("throw"===i.type)return t.method="throw",t.arg=i.arg,t.delegate=null,x;var o=i.arg;return o?o.done?(t[e.resultName]=o.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=g),t.delegate=null,x):o:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,x)}function f(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function d(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function h(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(f,this),this.reset(!0)}function p(e){if(e){var t=e[b];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var r=-1,n=function i(){for(;++r<e.length;)if(_.call(e,r))return i.value=e[r],i.done=!1,i;return i.value=g,i.done=!0,i};return n.next=n}}return{next:y}}function y(){return{value:g,done:!0}}var g,m=Object.prototype,_=m.hasOwnProperty,v="function"==typeof Symbol?Symbol:{},b=v.iterator||"@@iterator",$=v.asyncIterator||"@@asyncIterator",w=v.toStringTag||"@@toStringTag",E=t.regeneratorRuntime;if(E)return void(e.exports=E);E=t.regeneratorRuntime=e.exports,E.wrap=r;var S="suspendedStart",O="suspendedYield",T="executing",A="completed",x={},k={};k[b]=function(){return this};var D=Object.getPrototypeOf,I=D&&D(D(p([])));I&&I!==m&&_.call(I,b)&&(k=I);var P=a.prototype=i.prototype=Object.create(k);o.prototype=P.constructor=a,a.constructor=o,a[w]=o.displayName="GeneratorFunction",E.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===o||"GeneratorFunction"===(t.displayName||t.name))},E.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,a):(e.__proto__=a,w in e||(e[w]="GeneratorFunction")),e.prototype=Object.create(P),e},E.awrap=function(e){return{__await:e}},s(u.prototype),u.prototype[$]=function(){return this},E.AsyncIterator=u,E.async=function(e,t,n,i){var o=new u(r(e,t,n,i));return E.isGeneratorFunction(t)?o:o.next().then(function(e){return e.done?e.value:o.next()})},s(P),P[w]="Generator",P[b]=function(){return this},P.toString=function(){return"[object Generator]"},E.keys=function(e){var t=[];for(var r in e)t.push(r);return t.reverse(),function n(){for(;t.length;){var r=t.pop();if(r in e)return n.value=r,n.done=!1,n}return n.done=!0,n}},E.values=p,h.prototype={constructor:h,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=g,this.done=!1,this.delegate=null,this.method="next",this.arg=g,this.tryEntries.forEach(d),!e)for(var t in this)"t"===t.charAt(0)&&_.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=g)},stop:function(){this.done=!0;var e=this.tryEntries[0],t=e.completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){function t(t,n){return o.type="throw",o.arg=e,r.next=t,n&&(r.method="next",r.arg=g),!!n}if(this.done)throw e;for(var r=this,n=this.tryEntries.length-1;n>=0;--n){var i=this.tryEntries[n],o=i.completion;if("root"===i.tryLoc)return t("end");if(i.tryLoc<=this.prev){var a=_.call(i,"catchLoc"),s=_.call(i,"finallyLoc");if(a&&s){if(this.prev<i.catchLoc)return t(i.catchLoc,!0);if(this.prev<i.finallyLoc)return t(i.finallyLoc)}else if(a){if(this.prev<i.catchLoc)return t(i.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return t(i.finallyLoc)}}}},abrupt:function(e,t){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&_.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var i=n;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var o=i?i.completion:{};return o.type=e,o.arg=t,i?(this.method="next",this.next=i.finallyLoc,x):this.complete(o)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),x},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.finallyLoc===e)return this.complete(r.completion,r.afterLoc),d(r),x}},"catch":function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.tryLoc===e){var n=r.completion;if("throw"===n.type){var i=n.arg;d(r)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,r){return this.delegate={iterator:p(e),resultName:t,nextLoc:r},"next"===this.method&&(this.arg=g),x}}}("object"==typeof commonjsGlobal?commonjsGlobal:"object"==typeof window?window:"object"==typeof self?self:commonjsGlobal)}),_replacer=function(e,t){var r=t===Object(t)?function(e){return t[e]}:t;return function(t){return String(t).replace(e,r)}},$re=_replacer(/[\\^$*+?.()|[\]{}]/g,"\\$&");_export$3(_export$3.S,"RegExp",{escape:function(e){return $re(e)}});var _escape=_core$3.RegExp.escape;if(commonjsGlobal._babelPolyfill)throw new Error("only one instance of babel-polyfill is allowed");commonjsGlobal._babelPolyfill=!0;var DEFINE_PROPERTY="defineProperty";define(String.prototype,"padLeft","".padStart),define(String.prototype,"padRight","".padEnd),"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function(e){[][e]&&define(Array,e,Function.call.bind([][e]))}),Chimee.install(chimeeControl),Chimee.install(chimeeCenterState),Chimee.install(contextmenuConf),Chimee.install(index$1);var ChimeePlayer=function(e){function t(e){if(_classCallCheck(this,t),!isObject$1(e))throw new TypeError("You must pass an Object as config when you new ChimeePlayer");e.plugin=e.plugin||e.plugins,isArray$1(e.plugin)||(e.plugin=[]);var r=[chimeeControl.name,chimeeCenterState.name,contextmenuConf.name,index$1.name],n=e.plugin.map(function(e){return isObject$1(e)?e.name:e});r.forEach(function(t){n.indexOf(t)>-1||e.plugin.push(t)}),isObject$1(e.preset)||(e.preset={hls:Hls,flv:chimeeKernelFlv});var i=_possibleConstructorReturn(this,(t.__proto__||_Object$getPrototypeOf(t)).call(this,e));return i.on("play",function(){return i.chimeeContextmenu.updatemenu([{text:"\u6682\u505c",action:"pause"}])}),i.on("pause",function(){return i.chimeeContextmenu.updatemenu([{text:"\u64ad\u653e",action:"play"}])}),i}return _inherits(t,e),t}(Chimee);return ChimeePlayer.popupFactory=popupFactory,ChimeePlayer});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject},[_c('video',{attrs:{"tabindex":"-1"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h2',{staticClass:"mb-none"},[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.item.description))]),_vm._v(" "),_c('hr',{staticClass:"tall"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('h4',[_vm._v(_vm._s(_vm.item.stepsLabel))]),_vm._v(" "),_c('Collapse',{attrs:{"items":_vm.item.steps,"hkey":_vm.nkey}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('aside',{staticClass:"sidebar"},[(_vm.item.video)?[_c('h4',[_vm._v("Watch Video")]),_vm._v(" "),(_vm.isArray(_vm.item.video))?_vm._l((_vm.item.video),function(v,index){return _c('Video',{key:v,attrs:{"idx":index,"item":v}})}):[_c('Video',{attrs:{"item":_vm.item.video}})],_vm._v(" "),_c('hr')]:_vm._e(),_vm._v(" "),_c('section',{staticClass:"call-to-action call-to-action-quaternary button-centered mb-xl"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"call-to-action-btn"},[_c('a',{staticClass:"btn btn-lg btn-primary",attrs:{"href":_vm.item.pdf,"target":"_blank"}},[_vm._v("Download")])])])],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"call-to-action-content"},[_c('h3',[_vm._v("How to")]),_vm._v(" "),_c('p',[_vm._v("Download all 10 Steps of this Quick Start Guide to a PDF file.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_steps__ = __webpack_require__(55);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        steps: __WEBPACK_IMPORTED_MODULE_2__modules_steps__["a" /* default */]
    }
});
/* harmony default export */ __webpack_exports__["a"] = (store);


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    installation: {
        name: 'Installation of Application',
        pdf: ['static/pdf/All.pdf'],
        video: ['static/video/ISO_INSTALL.mp4', 'static/video/PKG_INSTALL.mp4'],
        steps: [{
                name: '1. Prepare the Server',
                content: [{
                        type: 'dot',
                        value: 'Operating System: CentOS or Red Hat Enterprise Linux 7.3 (When using the ISO version of the application installer, the CentOS 7.3 OS will be installed automatically)'
                    }, {
                        type: 'dot',
                        value: 'CPU: 4 Cores Intel® Xeon®  E5-2407 V2 with Passmark 4575 or above'
                    }, { type: 'dot', value: 'Physical Memory: 16GB' }, { type: 'dot', value: 'Hard Drive: 100GB free disk space or above' }, { type: 'dot', value: 'I/O Throughput: 125MB/second or above' }]
            }, {
                name: '2.	Select the desired installation package',
                content: [{
                        type: 'span',
                        value: 'Either an OS-included ISO application installer or an application-only installer can be used to install the application to a server.'
                    }, {
                        type: 'p',
                        value: ' '
                    }, {
                        type: 'span',
                        value: '<strong>If the OS-included ISO application installer is selected, mount the ISO image file onto the CD/DVD drive, which is accessible by the server. Then, boot the server up using the ISO image.</strong>', color: '#0088cc'
                    }, {
                        children: [{
                                type: 'image',
                                value: 'static/img/products/A.png'
                            }, {
                                type: 'abc',
                                value: 'The installer will prompt the following 4 questions before starting the OS installation:',
                                children: [{ type: '123)', value: 'The time zone' }, { type: '123)', value: 'The current clock time' }, { type: '123)', value: 'The URL which will be used to access the application' }, { type: '123)', value: 'The IP address for the server running the application' }]
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'After the OS installation is completed, login to the server as the root user to activate the network interface. Please ensure the IP address of the network interface matches the IP address specified during the OS installation.'
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'When the network interface is working, run the command “install_vpm” as the root user to start the application installation.  No user input is required for this part of the installation of Visual Power Manager.'
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'To obtain a license activation key, wait until the application is fully installed, run the command “/opt/VDC/bin/vdckeyreq> /tmp/my.req” as the root user and email the /tmp/my.req file to the application support team to obtain a license activation key.'
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'When the license activation key is received, upload it onto the server under /opt/VDC/.vdc directory, run “/opt/VDC/bin/setperm” and “reboot”.'
                            }]
                    }, {
                        type: 'span',
                        value: '<br/><strong>If the application-only installer is selected, install an OS (RedHat or CentOS) which is supported by the application and configure the network interface properly.  Check the Installation Guides for a list of supported Operating Systems.</strong>', color: '#0088cc'
                    }, { type: 'br', height: '10px' }, {
                        children: [{
                                type: 'abc',
                                value: 'Transfer (e.g. SCP) the application-only installer onto the server under the /tmp directory.'
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'Login to the server as the root user and run the command:<br> mkdir/opt/INSTALL'
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'Extract the installation package by running command: <br> tar -C /opt/INSTALL-xvf/tmp/[INSTALLATION_PACKAGE_NAME]'
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'Invoke the installer by running command:<br> /opt/INSTALL//[INSTALLATION_PACKAGE_DIRECTORY]/install'
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'The installer will prompt the following questions before starting the application installation:',
                                children: [{ type: '123)', value: 'The time zone' }, { type: '123)', value: 'The current clock time' }, { type: '123)', value: 'The application component to install (Select all-in-one if you are not sure)' }, { type: '123)', value: 'The URL used to access the application' }, { type: '123)', value: 'The IP Address for the server running the application.<br>  Note, this IP address must exist on the current server or the installer will not continue.' }, { type: '123)', value: 'The Email notification Server IP Address or hostname (Hit the Enter key if you are not sure)' }, { type: '123)', value: 'The Email notification From address which populates the From field of system generated emails (Hit the Enter key if you are not sure)' }, { type: '123)', value: 'The Email To address for system generated notifications (Hit the Enter key if you are not sure)' }, { type: '123)', value: 'Email server authentication requirements (Hit the Enter “no” if you are not sure)' }, { type: '123)', value: 'Preference to use Metric Unit or Imperial Units as a default in the application.' }]
                            }, { type: 'br', height: '10px' }, {
                                type: 'abc',
                                value: 'To obtain a license activation key, wait until the application is fully installed, run the command “/opt/VDC/bin/vdckeyreq> /tmp/my.req” as the root user and email the /tmp/my.req file to the application support team to obtain a license activation key.<br><br>When the license activation key is received, upload it onto the server under /opt/VDC/.vdc directory, run “/opt/VDC/bin/setperm” and “reboot”.'
                            }]
                    }]
            }]
    },
    navigation: {
        name: 'Define Navigation Tree',
        description: 'The Location feature is designed to allow users to create and modify locations in the navigation tree. The Navigation tree defines the various nodes of navigation from World to Floor and Area of the various sites managed in the application.',
        pdf: ['static/pdf/All.pdf'],
        video: ['static/video/B-Define Navigation Tree.mp4'],
        steps: [{
                name: '1. Select the Locations tab',
                content: [{ type: 'span', value: 'Select the Locations link from the top of the Home Page of the application.' }],
                image: 'static/img/products/2-1.png'
            }, {
                name: '2. Create Country',
                content: ['Select the World node on the left navigation tree.', 'Select a name of the country to be created from the dropdown list.', 'Click the Save button.'],
                image: 'static/img/products/2-2.png'
            }, {
                name: '3. Create State',
                content: ['Select a Country node on the navigation tree.', 'Select a State from the dropdown list. If there are no states defined for the country, the only option for State is All areas.', 'Click the Save button.'],
                image: 'static/img/products/2-3.png'
            }, {
                name: '4. Create City',
                content: ['Select the State node on the navigation tree.', 'Input the city name.', 'Fill in the Latitude and Longitude of the city.  This will position the Alarm LED for this location on the World map.', 'Click the Save button.'],
                image: 'static/img/products/2-4.png'
            }, {
                name: '5. Create Building',
                content: ['Select the City node on the navigation tree.', 'Input the building name.', 'Fill in the Electricity Price and Number of Floors in Attributes for this building.', 'Click the Save button.'],
                image: 'static/img/products/2-5.png'
            }, {
                name: '6. Create Floor',
                content: ['Select the Building node on the navigation tree.', 'Input the floor name.', 'Select the ﬂoor index from the dropdown box. The options of the ﬂoor index are based on the Number of Floors of its building.  Each Floor Index can only be assigned to one floor in the building.', 'Click the Save button.'],
                image: 'static/img/products/2-6.png'
            }, {
                name: '7. Create Area',
                content: ['Select the Floor node on the navigation tree.', 'Input the area name.', 'If multiple areas will be created then fill in Quantity.  Use the options provided to name multiple floors with specific prefix or suffix.  Use the Preview button to confirm naming prior to saving.', 'Click the Save button.'],
                image: 'static/img/products/2-7.png'
            }]
    },
    floorplan: {
        name: 'Build Floorplan',
        description: 'The Floors feature of the application allows users to manage the graphical ﬂoorplan details such as walls, raised floor tiles, grid name references etc and allows users to mount devices onto the ﬂoor. Prior to using this feature, the ﬂoor which needs to be configured must be defined in the navigation tree.',
        pdf: ['static/pdf/All.pdf'],
        video: ['static/video/C-Build Floor.mp4'],
        steps: [{
                name: '1. Select the Locations tab',
                content: [{ type: 'span', value: 'Select the Floors link from the top of the Home Page.' }],
                image: 'static/img/products/3-1.png'
            }, {
                name: '2. Select a Floor in the Navigation Tree',
                image: 'static/img/products/3-2.png'
            }, {
                name: '3. Upload Floor Image',
                content: [{ type: 'span', value: 'Standard Windows picture file types such as PNG, BMP, GIF, etc are supported to upload to the application.' }],
                image: 'static/img/products/3-3.png'
            }, {
                name: '4. Create Anchor Points',
                content: [{ type: 'span', value: 'Create anchor points for wall segments where two walls are connected on the floorplan image.  Turn on the Anchor Point tool by selecting the icon and then left mouse click anchor points onto the image.  The crosshair tool allows users to align anchor points.  For a free-form anchor placement, turn off the crosshair tool by toggling this icon to the off position.  The Escape key toggles out of the Anchor Point mode.' }],
                image: 'static/img/products/3-4.png'
            }, {
                name: '5. Draw Wall Segments',
                content: [{ type: 'span', value: 'Draw wall segments by joining anchor points.  Turn on the Wall Draw tool by selecting the icon and then connect anchor points with walls by clicking them in order.  Note, the Escape key will toggle the user out of the Wall Draw mode if the user needs to define more walls in a new area of the floor.' }, { type: 'image', value: 'static/img/products/3-5-1.png' }, { type: 'span', value: 'Right click a wall to change the wall type from Solid, Cage or Glass.  The color of the wall on the floorplan will indicate the wall type.' }, { type: 'image', value: 'static/img/products/3-5-2.png' }]
            }, {
                name: '6. Draw Floor Shape',
                content: ['Turn on the Floor Shape tool by selecting the icon from the ribbon menu on the left of the ﬂoor image. This allows the user to define the full area of the entire floor where devices may be placed in the application.  The cursor changes to indicate that the session is in the Edit mode.  The Escape key will toggle the user out of Floor Shape mode.', 'Define the entire ﬂoor area by clicking the first anchor point which is part of the full floor perimeter area.  Select the other anchor points in sequence to draw the full area of the floor.  The graphics on the screen will update with the selection of each anchor point.  Complete the floor definition by selecting the first anchor point once again which will close the full perimeter of the floor.', { type: 'image', value: 'static/img/products/3-6-1.png' }, 'When completed, the Floor configuration window will appear which allows the user to define raised floor and grid naming conventions for the floor. Note, if there are multiple areas on the floor which have combinations of raised floor and/or grid names then define these settings at the Area and not at the Floor level.', { type: 'image', value: 'static/img/products/3-6-2.png' }]
            }, {
                name: '7. Draw Area Shape',
                content: ['Turn on the Area Shape tool by selecting the icon from the toolbar. This allows the user to define each area within the floor where devices may be placed in the application.  The cursor changes to indicate that the session is in the Edit mode.  The Escape key will toggle the user out of Area Shape mode.', 'Define the area shape by clicking the first anchor point which is part of the area.  Select the other anchor points in sequence to draw the area.  The graphics on the screen will update with the selection of each anchor point.  Complete the area definition by selecting the first anchor point once again which will close the perimeter of the area.', { type: 'image', value: 'static/img/products/3-7-1.png' }, {
                        type: 'abc',
                        value: 'The Area configuration window will provide area settings to be defined.',
                        children: [{ type: '123)', value: 'Select the desired color for the area.' }, { type: '123)', value: 'If the area is a raised floor then turn on the Raised Floor checkbox.' }, { type: '123)', value: 'Set tile Tile size to standard or custom measurement.' }, { type: '123)', value: 'Adjust the Starting Corner settings if a partial tile is needed in the corner of the raised floor area.' }, { type: '123)', value: 'Enable the Coordinates checkbox if the area uses Row/Column grid naming conventions.' }, { type: '123)', value: 'Choose the Starting point for the grid definitions.' }, { type: '123)', value: 'Define the grid labels.  Default settings are applied, but users may override the default values by editing the list.' }, { type: 'image', value: 'static/img/products/3-7-2.png' }]
                    }]
            }, {
                name: '8. Publish the ﬂoorplan',
                image: 'static/img/products/gif3-8.gif'
            }]
    },
    devices: {
        name: 'Add Devices',
        description: 'The application contains a list of over 20,000 models with which users can create devices to manage their properties, attributes, locations, connections, etc. Devices can be created manually, cloned from other devices, imported using bulk import (refer to User Guide for detailed instructions) or via auto discovery (see Step 6 of this Quick Start Guide).',
        pdf: ['static/pdf/All.pdf'],
        video: ['static/video/D-Add Devices.mp4'],
        steps: [{
                name: '1. Select the Admin tab',
                content: [{ type: 'span', value: 'Select the Admin link on the top of the Home Page.  By default, the Admin page shows the list of Devices in the application and allows users to easily manage the devices by selecting them in the device list.' }],
                image: 'static/img/products/4-1.png'
            }, {
                name: '2. Create a New Device',
                content: [{ type: 'span', value: 'Complete the required fields in the device properties list and hit the Create New Device button.  This will add the device to the device list.  For example:' }, { type: 'br', height: '16px' }, { type: 'span', value: '•	Name= Rack001<br>•	Type = Rack<br>•	Manufacturer=HP<br>•	Product Line=Rack System<br>•	Model=7142<br>•	Device Group=Public' }],
                image: 'static/img/products/4-2.png'
            }, {
                name: ' 3. Find Devices in the List',
                content: ['Type a few characters from the beginning of the device name in the progressive search field.  The list will be filtered using “starts with” logic of the text entered to the search area.', { type: 'image', value: 'static/img/products/4-3-1.png' }, 'Use % or * as a wild card to match characters.  For example, *001* will filter the list using “contains” logic for the filtered device list.', { type: 'image', value: 'static/img/products/4-3-2.png' }, {
                        type: 'abc',
                        value: 'Use the filter icon when name is unknown or additional filtering is needed.',
                        children: [{ type: '123)', value: 'Click on the filter icon next to the magnifying glass.' }, { type: '123)', value: 'From the drop-down menus indicate Type, Manufacturer, Product Line, Model, Device Group or Status to identify the desired devices.' }, { type: '123)', value: 'Click Set to activate the filter.' }, { type: '123)', value: 'To clear the filter, click the filter icon to reopen and Click Reset.' }]
                    }, { type: 'image', value: 'static/img/products/4-3-3.png' }]
            }, {
                name: '4. Use Clone to Create Additional Devices',
                content: ['In the device list select the device you want to replicate.', 'Click the Clone button underneath the device list.', 'In the popup window enter the desired quantity of cloned devices to create.', { type: 'image', value: 'static/img/products/4-4-1.png' }, 'Cloned devices maintain the same name as the original device, but are appended with(#).', { type: 'image', value: 'static/img/products/4-4-2.png' }]
            }, {
                name: '5. Rename a device',
                content: ['	Select the device from the device list.', '	In the Name field change the text as desired.', 'Click on the Modify button.'],
                image: 'static/img/products/4-5.png'
            }]
    },
    place: {
        name: 'Place Floormount Devices',
        description: 'When floor configurations are completed and Rack/Facility devices have been created, users can place these devices on the floorplans.  The Floor tools provide easy ways to place, rotate, align, raise devices on the floors.',
        video: ['static/video/E-Floor Mount.mp4'],
        pdf: ['static/pdf/All.pdf'],
        steps: [{
                name: '1. Select the Floors Page',
                content: [{ type: 'span', value: 'Select the Floors link at the top of the Home Page.' }],
                image: 'static/img/products/5-1.png'
            }, {
                name: '2. Select the Floor Node in the Navigation Tree',
                image: 'static/img/products/5-2.png'
            }, {
                name: '3. Mount Devices to the Floor',
                content: ['Click the Floor View menu.', 'Search for the device name on the device list which will be placed on the floor.', 'Click the desired device(s), hold the mouse key down and drag devices onto the ﬂoor. Release the mouse key to place devices on the floor.  Multiple devices can be selected using the Ctrl or Shift keys.', 'Click the Save button.'],
                image: 'static/img/products/5-3.png'
            }, {
                name: '4. Edit Device Positions',
                content: [{
                        type: 'span', value: 'There are four primary functions performed on the floormount devices once they are placed on the floor.  In all cases, multiple devices can be selected by holding the Shift key and selecting multiple devices on the floorplan.  For the Align and Join features, the first device selected in the series will act as the reference for the join and align functions.',
                        children: [{ type: 'br', height: '16px' }, { type: '123)', value: 'Move – Click and drag devices to move them on the floor.' }, { type: '123)', value: 'Rotate – Click devices and then choose the Rotate icon to rotate in 90 degree increments.' }, { type: '123)', value: 'Join – Select multiple devices and join devices to the left, right, top or bottom of the first device selected in the series.' }, { type: '123)', value: 'Align – Select multiple devices and join devices to the left, right, top and bottom of the first device selected in the series' }]
                    }],
                image: 'static/img/products/5-4.png'
            }]
    },
    discovery: {
        name: 'Auto Discovery',
        description: 'The Discovery feature allows users to define discovery settings for polling networks to automatically find and activate monitoring for devices to be managed in the application.',
        video: ['static/video/F-AutoDiscovery.mp4'],
        pdf: ['static/pdf/All.pdf'],
        steps: [{
                name: '1. Select the Discovery Page',
                content: [{ type: 'span', value: 'Select the Admin link from the top of the Home Page and then select the Discovery link from the top of the Admin Page.' }],
                image: 'static/img/products/gif-6-1-1.gif'
            }, {
                name: '2. View Defined Discovery Jobs',
                content: [{ type: 'span', value: 'Click the Edit button from the discovery status page.' }],
                image: 'static/img/products/6-2.png'
            }, {
                name: '3. Add a Discovery Job',
                content: ['Click the Add button on the discovery job window.', 'Enter the job name and Start/End ranges for the IP addresses to be polled for devices.', { type: 'image', value: 'static/img/products/6-3-1.png' }, 'Select the discovery protocol check box. In most cases, this will be SNMP discovery only.', 'Fill the SNMP version, Port and community to be used with the SNMP discovery settings.  These should match the configuration of the devices which will be discovered and added to the application.', 'Select the Active check box to activate the new discovery job.', 'Click the Save button on the top left corner of the page.', { type: 'image', value: 'static/img/products/6-3-2.png' }]
            }, {
                name: '4.	Manage Discovered Devices',
                content: ['Return to the Discovery Status page by hitting the back button from the Discovery Job definition page.', 'When the jobs Current Status is Completed, click the Manage button to view a list of devices found by the discovery job.', { type: 'image', value: 'static/img/products/6-4-1.png' }, 'Select the checkbox next to the discovered device or Select All devices by clicking the checkbox in the column heading.', 'Select the “Move to Monitor” or “Move to Manage” buttons, choose the Device Group for the selected devices and click the OK button.  Note, Move to Monitor will add the device to the application and enable Monitoring data collection, but Move to Manage will simply add the device to the device list with no active data collection.', { type: 'image', value: 'static/img/products/6-4-2.png' }]
            }]
    },
    rack: {
        name: 'Rack Building',
        description: 'The Racks feature allows users to manage devices within the rack and to view rack detail and capacity information.',
        video: ['static/video/G-Rack Buidling.mp4'],
        pdf: ['static/pdf/All.pdf'],
        steps: [{
                name: '1. Select the Racks Page',
                content: [{ type: 'span', value: 'Select the Racks link from the top of the Home Page.' }],
                image: 'static/img/products/7-1.png'
            }, {
                name: '2.	Choose a Rack to Manage',
                content: [{ type: 'span', value: 'Find the rack in the list and single click to highlight the rack.  Use the search and filter options to limit the racks listed if there are many racks in the list.  This will display the rack detail image and rack dashboard.  Use the mouse scroll wheel to zoom in/out or click and drag the rack image to pan the view to the desired view settings.' }],
                image: 'static/img/products/7-2.png'
            }, {
                name: '3.	Find Devices to Place in Rack',
                content: [{ type: 'span', value: 'Use the search and filter options on the Device list to find the device that needs to be placed into the rack.  Note, the rack has available mount positions on the front, rear right and left of the rack.  Left and right are typically reserved for 0U Rackmount PDU devices.  For devices which mount to the outside of the rack, such as sensors or door locks, use the Show Enclosure checkbox to toggle the view with the rack enclosure.' }],
                image: 'static/img/products/7-3.png'
            }, {
                name: '4. Assign Device to U Position',
                content: [{ type: 'span', value: 'Click, hold and drag the device to into the Rack.  The position the device is when the mouse is released defines where the device will be mounted.  A green highlight will indicate the positions to be occupied by the device if the user releases the mouse. Note, blades can be mounted directly into Enclosures in this view with the same user function.' }],
                image: 'static/img/products/7-4.png'
            }, {
                name: '5.	Save the Rack',
                image: 'static/img/products/7-5.png'
            }]
    },
    port: {
        name: 'Port Mapping',
        description: 'The Ports feature allows users to create mappings between devices for power ports. This helps define the hierarchy of power delivery from facility to end IT devices.',
        video: ['static/video/H Port Mapping.mp4'],
        pdf: ['static/pdf/All.pdf'],
        steps: [{
                name: '1.	Select the Ports Page',
                content: [{ type: 'span', value: 'Select the Ports link from the top of the Home Page.' }],
                image: 'static/img/products/8-1.png'
            }, {
                name: '2.	Select Devices to Connect',
                content: [{ type: 'span', value: 'Use the search and filter options to find devices that need to be connected.  Double click the device name in the device list to add them to the Connected Devices area of the Port page.  The table under the Connected Devices will list the defined connections for those devices.' }],
                image: 'static/img/products/8-2.png'
            }, {
                name: '3.	Confirm Ports are listed',
                content: [{ type: 'span', value: 'The model library contains 20,000+ models with a predefined list of ports which can be used to define connections.  If the ports on the device are missing then users can manage the list of available ports for the device on the Admin page.  Select the device in the Device list and choose the Ports sub tab.  On this page, users can create any number of ports with a specific port type from the list.' }],
                image: 'static/img/products/8-3.png'
            }, {
                name: '4. Create Port Connections',
                content: [{ type: 'span', value: 'Connect ports from different devices by clicking the first port from a device in Candidate Devices, continue to hold down the mouse button, drag the mouse to the second port on the next device and release the mouse button.  Complete the information in the Connection properties window including the Name, Serial Number, Length and Color.' }],
                image: 'static/img/products/8-4.png'
            }, {
                name: '5.	View Power Path',
                content: [{ type: 'span', value: 'Select the “Power Path” icon within the Candidate Device to view the hierarchy of power devices for that device. Note, not all downstream devices will be expanded.  Click the Expand icon on the device in the power path view to further expand the connection topology.' }],
                image: 'static/img/products/8-5.png'
            }, {
                name: '6.	Create Panels and Breakers on PDU/RPP Devices',
                content: [{ type: 'span', value: 'The application supports the creation and management of Breakers on PDU and RPP devices.  The Breakers are created on PDU and RPP devices in the Candidate Devices part of the Ports page.' }, { type: 'br', height: '16px' }, { type: 'abc', value: 'Search and add PDU or RPP devices as a Candidate Device.' }, { type: 'abc', value: 'Select the PDU name in the Candidate Device port table and click the Add Panel button. This will reveal the Add Panel properties window.' }, { type: 'image', value: 'static/img/products/8-6-1.png' }, {
                        type: 'abc', value: 'Complete the fields in the Panel properties window.',
                        children: [{ type: '123)', value: 'View Mode:<br>•  Double Table – Panel is composed of two columns with 21 circuits in each column.<br>•  Single Table – Panel is composed of a single column with all 42 circuits.' }, { type: '123)', value: 'Numbering Scheme<br>•  1, 3, 5… – Odd breakers on the left and even breakers on the right. This option is only available for the Double Table view mode.<br>•	1, 2, 3… –All circuits are listed in sequential order.  This option is available for both Single and Double Table views. If this option is selected for a Double Table, then circuits 1-21 are in the left column and circuits 22-42 are in the right column' }, { type: '123)', value: '•	Department:<br>•  Describes the department associated to all breakers within the panel. This setting is used to calculate the Customer Power Report.' }]
                    }, { type: 'image', value: 'static/img/products/8-6-2.png' }, { type: 'abc', value: 'Add a breaker to the panel. Select the panel name in the table list and click the Add button.' }, { type: 'image', value: 'static/img/products/8-6-3.png' }, { type: 'abc', value: 'The Breaker properties window will appear. Complete the Breaker information and click OK to save the breaker for the panel.' }, { type: 'image', value: 'static/img/products/8-6-4.png' }]
            }, {
                name: '7. Create Port Connections to PDU/RPP Breakers',
                content: [{ type: 'span', value: 'Similar to the standard device port connections, users can connect the PDU and RPP breakers to ports of Rack PDU and Rack UPS devices.  In some cases, these connections are created directly to end IT devices such as switch or server enclosures. Click the port from a device in Candidate Devices, continue to hold down the mouse button, drag the mouse to the Rack PDU and release the mouse button.  Complete the information in the Connection properties window including the Name, Serial Number, Length and Color.' }],
                image: 'static/img/products/8-7.png'
            }]
    },
    device: {
        name: 'Device Settings',
        description: 'Many of the capacity tools and dashboards require the devices being monitored to be configured properly for A|B power settings and derated values.  These settings enable detailed tracking of capacity and failover capabilities for these devices.',
        video: ['static/video/I Device settings.mp4'],
        pdf: ['static/pdf/All.pdf'],
        steps: [{
                name: '1. Select the Admin Page',
                content: [{ type: 'span', value: 'Select the Admin link from the top of the Home Page.' }],
                image: 'static/img/products/9-1.png'
            }, {
                name: '2.	Configure Rack PDU or Rack UPS Attributes.',
                content: ['Select the Device menu', 'Use search and filter to find the device in the device list.', 'Select the Attributes tab for the selected device.', 'Configure the A-B Side Power, Power-Derated and Power-Rated attributes.  Note, Power Rated is typically defined at the model level and Power Derated is set to equal Power Rated.  Users can override these settings on each device or set these values at the Model to have them propagate to all devices based on that model.', 'Click the Modify button to save these configurations.', { type: 'image', value: 'static/img/products/9-2.png' }]
            }, {
                name: '3.	View the Rack Dashboard',
                content: [{ type: 'span', value: 'Power and Current data will now be displayed at the Rack dashboard where properly configured Rack PDU and Rack UPS devices are mounted.' }],
                image: 'static/img/products/9-3.png'
            }, {
                name: '4.	View the rack PDU and Rack UPS Dashboards',
                content: [{ type: 'span', value: 'Rack PDU and Rack UPS dashboards will not correctly show the A|B Power setting and properly report phase level data for these devices.  Power ratings will also be populated in the Power and Current gauges and tables.' }],
                image: 'static/img/products/9-4.png'
            }, {
                name: '5.	Configure Rack Attributes',
                content: [{ type: 'span', value: 'Configuring the Rack attributes will enable the failover calculations which provide advanced notice to users about issues with phase level failover capabilities for power providing devices in the racks. ' }, { type: 'br', height: '16px' }, 'Select the Rack device in the device list on the Admin page', 'Configure the A Current Derated and B Current Derated attributes for the Rack.', 'Click the Modify button to save changes.'],
                image: 'static/img/products/9-5.png'
            }, {
                name: '6.	View the Rack Dashboard',
                content: [{ type: 'span', value: 'The rack dashboard will now list the A|B Derated Current values.  In the phase level current dashboard gauge, the red “hashed” bars indicate there is an issue with A to B or B to A failover for those phases of power.' }],
                image: 'static/img/products/9-6.png'
            }]
    },
    alarm: {
        name: 'Alarm Settings',
        description: 'Alarm settings allow users to define thresholds for monitored data and capacity information along with notification rules to deliver Email and SMS alarms to defined recipients.',
        video: ['static/video/J-Alarm Settings.mp4'],
        pdf: ['static/pdf/All.pdf'],
        steps: [{
                name: '1.	Select the Admin Page',
                content: [{ type: 'span', value: 'Select the Admin link from the top of the Home Page.' }],
                image: 'static/img/products/10-1.png'
            }, {
                name: '2. Open the Monitor Attributes Configuration Page',
                content: [{ type: 'span', value: 'Monitor Attributes are the normalized data points in the application which are used to map raw data from various device sources to a common application reference scheme.  By defining the alarm configuration at the application attribute level, profiles can be created to help reduce the administration of the settings.' }, { type: 'br', height: '16px' }, { type: 'abc', value: 'Open the Monitor Tab.' }, { type: 'abc', value: 'Access the Monitor Attributes section on the left menu.' }],
                image: 'static/img/products/10-2.png'
            }, {
                name: '3.	Configure Thresholds',
                content: [{
                        type: 'span',
                        value: 'Thresholds can be defined for multiple levels of the device hierarchy.  The most common method is to define a threshold for either the Model or the individual Device.  The example below uses a definition of a threshold for an individual Sensor devices using the Temperature data point.'
                    }, { type: 'br', height: '16px' }, 'Select Device from the level dropdown to define a threshold for an individual device.  Search the device name and select it in the list.', 'Select the Alarm Thresholds tab.', { type: 'image', value: 'static/img/products/10-3-1.png' }, 'Select the Layer-Temperature Monitor Attribute (MA).  This is the product reference for Temperature.', 'Select the Add Threshold button', { type: 'image', value: 'static/img/products/10-3-2.png' }, {
                        type: 'abc',
                        value: "Configure the threshold page and click the Add button. Note, multiple rules can be defined for the same data point, but number ranges can't overlap for different alarm ranges.",
                        children: [{ type: '123)', value: 'Label – Name of the alarm which will be included in the alarm information and notifications.' }, { type: '123)', value: 'Type –If the data point is a number there is no option for this setting; an interval will be defined for the value of the data.  If the data point is a string then the user can define “starts with” or “contains” rules.' }, { type: '123)', value: 'Alarm Level – Defines the Warning or Critical alarm status if the value matches the rule definition.' }, { type: '123)', value: 'Inc | Not Inc – For Numeric values Inc is short for Inclusive and Not Inc is short for Not Inclusive.  If the value box is null then it is infinite.' }]
                    }, { type: 'image', value: 'static/img/products/10-3-3.png' }, { type: 'p', value: ' ' }, 'Select the Save Table button to save this threshold.  Alarms will  appear in the Alarms page and other areas of the application where alarm status is presented when the values of the device cross into the defined ranges for the alarm rule. ', { type: 'image', value: 'static/img/products/10-3-4.png' }]
            }, {
                name: '4. Notification Configuration',
                content: [{
                        type: 'span',
                        value: 'The alarm engine lets you define Notification Rules so that you can be notified of certain alarms generated by devices managed within the application.'
                    }, { type: 'br', height: '16px' }, 'Ensure the alarm recipient user account has a correct email address for SMTP notifications or mobile phone for SMS notifications.', { type: 'image', value: 'static/img/products/10-4-1.png' }, 'On the Admin page access the Monitor page and the Notification Rules menu in the left menu tree.', {
                        type: 'abc', value: 'Define the notification rule settings',
                        children: [{ type: '123)', value: 'Rule Name – Name of the notification rule.' }, { type: '123)', value: 'Maximum Messages – Used to throttle alarm storms and limits the number of messages which can be generated by the rule.' }, { type: '123)', value: 'Alarm Level – Defines which alarm levels are included in the rule.' }, { type: '123)', value: 'Recipients – Defines the users, notification method and escalation rules for recipients of the notification.' }, { type: '123)', value: 'Devices – Defines which devices apply to the notification rule' }]
                    }, 'Click the Create button to save the rule.  Email and SMS notifications will be delivered when alarms match the rule settings.', { type: 'image', value: 'static/img/products/10-4-2.png' }]
            }]
    }
};
var mutations = {};
var getters = {
    steps: function steps(state) {
        return state;
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: {},
    getters: getters
});


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__ = __webpack_require__(57);
 

/**
 * Check why can't use () => {}
 */
__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */].install = function (Vue, options) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */])
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__BackToTop_vue__["a" /* default */]);


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_58972b86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__ = __webpack_require__(59);
function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_58972b86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-to-top-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"vue-back-to-top",style:(("bottom:" + (this.bottom) + ";right:" + (this.right) + ";")),on:{"click":_vm.backToTop}},[_vm._t("default",[_c('div',{staticClass:"default"},[_c('span',[_vm._v("\n          "+_vm._s(_vm.text)+"\n        ")])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Magnific Popup - v1.0.1 - 2015-12-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isIE7=-1!==c.indexOf("MSIE 7."),b.isIE8=-1!==c.indexOf("MSIE 8."),b.isLowIE=b.isIE7||b.isIE8,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(a,c){if(void 0===c||c===!1)return!0;if(e=a.split("_"),e.length>1){var d=b.find(p+"-"+e[0]);if(d.length>0){var f=e[1];"replaceWith"===f?d[0]!==c[0]&&d.replaceWith(c):"img"===f?d.is("img")?d.attr("src",c):d.replaceWith('<img src="'+c+'" class="'+d.attr("class")+'" />'):d.attr(e[1],c)}}else b.find(p+"-"+a).html(c)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery",g=Boolean(a.fn.mfpFastClick);return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s),h=g?"mfpFastClick":"click";e[h](function(){b.prev()}),f[h](function(){b.next()}),b.isIE7&&(x("b",e[0],!1,!0),x("a",e[0],!1,!0),x("b",f[0],!1,!0),x("a",f[0],!1,!0)),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowLeft&&g&&b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),function(){var b=1e3,c="ontouchstart"in window,d=function(){v.off("touchmove"+f+" touchend"+f)},e="mfpFastClick",f="."+e;a.fn.mfpFastClick=function(e){return a(this).each(function(){var g,h=a(this);if(c){var i,j,k,l,m,n;h.on("touchstart"+f,function(a){l=!1,n=1,m=a.originalEvent?a.originalEvent.touches[0]:a.touches[0],j=m.clientX,k=m.clientY,v.on("touchmove"+f,function(a){m=a.originalEvent?a.originalEvent.touches:a.touches,n=m.length,m=m[0],(Math.abs(m.clientX-j)>10||Math.abs(m.clientY-k)>10)&&(l=!0,d())}).on("touchend"+f,function(a){d(),l||n>1||(g=!0,a.preventDefault(),clearTimeout(i),i=setTimeout(function(){g=!1},b),e())})})}h.on("click"+f,function(){g||e()})})},a.fn.destroyMfpFastClick=function(){a(this).off("touchstart"+f+" click"+f),c&&v.off("touchmove"+f+" touchend"+f)}}(),A()});

/***/ })
],[20]);


// WEBPACK FOOTER //
// static/js/app.4baee95684d55860995f.js